import { defineComponent as J, ref as me, computed as Q, provide as Bn, createElementBlock as C, openBlock as m, normalizeClass as le, renderSlot as oe, createElementVNode as g, Fragment as ge, useAttrs as F1, unref as j, createBlock as he, withCtx as ue, inject as In, withDirectives as Ne, createVNode as ye, vShow as L1, mergeProps as Re, createCommentVNode as ae, toDisplayString as _e, useSlots as _t, useId as ro, withModifiers as $e, watch as Ue, normalizeStyle as w1, shallowRef as kn, resolveDynamicComponent as S1, withKeys as Ae, createTextVNode as qe, useTemplateRef as _r, mergeModels as Ye, useModel as e1, onMounted as h1, renderList as De, nextTick as p1, vModelText as _a, reactive as so, toRef as Qa, onUnmounted as oa, isRef as y0, createSlots as f1, normalizeProps as v1, guardReactiveProps as V1, Teleport as Pi, Transition as Va, h as Pl, render as b0, toValue as zl, getCurrentScope as Tl, onScopeDispose as Ol, onBeforeUpdate as Fl, vModelDynamic as Bl, vModelCheckbox as Il, useCssVars as Zl, TransitionGroup as Rl, watchEffect as Nl, onBeforeUnmount as ql, markRaw as Oa } from "vue";
import { cn as g1, formatters as Fr, dayjs as J1, sorters as Ul } from "@myparcel-frontend/utils";
import { vOnClickOutside as Ft, vOnLongPress as k0 } from "@vueuse/components";
import { useToggle as ht, useClipboard as Yl, templateRef as Wl, useCounter as na, useIntervalFn as C0, useFocusWithin as Kl, useDebounceFn as Gl, watchPausable as Xl } from "@vueuse/core";
import { useI18n as Sa } from "vue-i18n";
import { useFloating as Aa, offset as Br, flip as Ea, shift as Cn, size as wn, autoUpdate as Da, arrow as Ql } from "@floating-ui/vue";
import { useResize as zi, useNotification as Ti, useSortControl as Jl } from "@myparcel-frontend/composables";
const VH = /* @__PURE__ */ J({
  __name: "AccordionGroup",
  props: {
    multiple: { type: Boolean },
    border: { type: Boolean },
    background: { type: Boolean }
  },
  setup(t) {
    const e = t, a = me([]), o = Q(() => e.border);
    Q(() => e.background);
    const n = (i, l) => {
      if (l) {
        a.value = a.value.filter((f) => f !== i);
        return;
      }
      a.value = [...a.value, i];
    }, r = (i, l) => {
      if (l) {
        a.value = [];
        return;
      }
      a.value = [i];
    }, s = (i) => {
      const l = a.value.includes(i);
      e.multiple ? n(i, l) : r(i, l);
    };
    return Bn("openItems", a), Bn("border", o), Bn("setOpenItem", s), (i, l) => (m(), C("div", {
      class: le(["group overflow-hidden", {
        border: o.value,
        "rounded-xl": o.value
      }])
    }, [
      oe(i.$slots, "default")
    ], 2));
  }
}), eu = {
  d: "M14.5982 5.85714H10.4464C10.0011 5.85714 9.64286 5.49888 9.64286 5.05357V0.901786C9.64286 0.680804 9.82366 0.5 10.0446 0.5H11.3839C11.6049 0.5 11.7857 0.680804 11.7857 0.901786V3.71429H14.5982C14.8192 3.71429 15 3.89509 15 4.11607V5.45536C15 5.67634 14.8192 5.85714 14.5982 5.85714ZM5.35714 5.05357V0.901786C5.35714 0.680804 5.17634 0.5 4.95536 0.5H3.61607C3.39509 0.5 3.21429 0.680804 3.21429 0.901786V3.71429H0.401786C0.180804 3.71429 0 3.89509 0 4.11607V5.45536C0 5.67634 0.180804 5.85714 0.401786 5.85714H4.55357C4.99888 5.85714 5.35714 5.49888 5.35714 5.05357ZM5.35714 15.0982V10.9464C5.35714 10.5011 4.99888 10.1429 4.55357 10.1429H0.401786C0.180804 10.1429 0 10.3237 0 10.5446V11.8839C0 12.1049 0.180804 12.2857 0.401786 12.2857H3.21429V15.0982C3.21429 15.3192 3.39509 15.5 3.61607 15.5H4.95536C5.17634 15.5 5.35714 15.3192 5.35714 15.0982ZM11.7857 15.0982V12.2857H14.5982C14.8192 12.2857 15 12.1049 15 11.8839V10.5446C15 10.3237 14.8192 10.1429 14.5982 10.1429H10.4464C10.0011 10.1429 9.64286 10.5011 9.64286 10.9464V15.0982C9.64286 15.3192 9.82366 15.5 10.0446 15.5H11.3839C11.6049 15.5 11.7857 15.3192 11.7857 15.0982Z",
  fill: "currentColor"
}, SH = /* @__PURE__ */ J({
  __name: "compress",
  setup(t) {
    return (e, a) => (m(), C("path", eu));
  }
}), tu = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, AH = /* @__PURE__ */ J({
  __name: "reminder",
  setup(t) {
    return (e, a) => (m(), C("svg", tu, a[0] || (a[0] = [
      g("path", {
        stroke: "#0F5C47",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "m4.5 6.5-2 2-2-2"
      }, null, -1),
      g("path", {
        stroke: "#0F5C47",
        "stroke-linecap": "round",
        d: "M2.5 7.5A6 6 0 1 1 4.531 12"
      }, null, -1),
      g("path", {
        stroke: "#0F5C47",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M8.5 3.5v4h3"
      }, null, -1)
    ])));
  }
}), au = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 11C3 7.23771 6.91282 4 12 4C17.0872 4 21 7.23771 21 11C21 14.7623 17.0872 18 12 18C11.2331 18 10.4892 17.9252 9.77957 17.7848C9.54086 17.7375 9.30823 17.8687 9.21965 18.0859C9.14229 18.1381 9.07867 18.2126 9.03955 18.305C8.8997 18.6351 8.60951 18.9389 8.19648 19.2113C7.7866 19.4815 7.29127 19.6973 6.79969 19.8649C6.50173 19.9664 6.21121 20.0482 5.95098 20.1129C6.01845 19.9797 6.08886 19.8366 6.15986 19.6863C6.4887 18.9902 6.85809 18.0826 6.97182 17.2817C6.99746 17.209 7.00527 17.133 6.99683 17.0594C6.99743 17.052 6.99801 17.0445 6.99856 17.0371C7.01906 16.7617 6.81243 16.5219 6.53705 16.5014C6.5052 16.499 6.47383 16.4997 6.44322 16.5031C4.31462 15.2001 3 13.1975 3 11ZM5.94199 17.3687C3.57838 15.9285 2 13.6336 2 11C2 6.47802 6.59377 3 12 3C17.4062 3 22 6.47802 22 11C22 15.522 17.4062 19 12 19C11.2805 19 10.5783 18.9393 9.90108 18.8239C9.64449 19.3403 9.21199 19.7395 8.74699 20.0461C8.24088 20.3798 7.65937 20.6283 7.12228 20.8114C6.58265 20.9953 6.07112 21.1187 5.69574 21.1962C5.5075 21.235 5.35213 21.2626 5.24288 21.2805C5.18822 21.2895 5.14502 21.2961 5.11492 21.3006L5.07976 21.3056L5.06992 21.307L5.067 21.3074L5.06605 21.3075L5.0657 21.3076C5.06557 21.3076 5.06544 21.3076 4.99994 20.8119L5.06544 21.3076C4.87495 21.3328 4.68689 21.2465 4.58163 21.0858C4.4764 20.9251 4.47256 20.7183 4.57175 20.5537L4.57179 20.5537L4.57228 20.5528L4.57473 20.5488L4.58526 20.531C4.59471 20.5151 4.60889 20.491 4.62717 20.4594C4.66372 20.3963 4.71657 20.3037 4.78057 20.1876C4.90877 19.9549 5.0807 19.6296 5.25567 19.2592C5.54486 18.647 5.82026 17.9568 5.94199 17.3687Z",
  fill: "#FF8C00"
}, EH = /* @__PURE__ */ J({
  __name: "chat-24",
  setup(t) {
    return (e, a) => (m(), C("path", au));
  }
}), ou = { fill: "none" }, DH = /* @__PURE__ */ J({
  __name: "settings",
  setup(t) {
    return (e, a) => (m(), C("g", ou, a[0] || (a[0] = [
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22.0491 2.25C20.7492 2.25 19.6398 3.18976 19.4261 4.47194L18.8059 8.19359L16.9228 8.9736L13.8526 6.7806C12.7949 6.02507 11.346 6.14499 10.4268 7.06413L7.31421 10.1767C6.39507 11.0959 6.27515 12.5448 7.03068 13.6026L9.22367 16.6727L8.44359 18.5559L4.72194 19.1761C3.43976 19.3898 2.5 20.4992 2.5 21.7991V26.2009C2.5 27.5008 3.43976 28.6102 4.72194 28.8239L8.44363 29.4441L9.22386 31.3273L7.03089 34.3974C6.27536 35.4552 6.39528 36.9041 7.31442 37.8232L10.427 40.9358C11.3462 41.855 12.7951 41.9749 13.8528 41.2194L16.923 39.0264L18.8059 39.8064L19.4261 43.5281C19.6398 44.8102 20.7492 45.75 22.0491 45.75H26.4509C27.7508 45.75 28.8602 44.8102 29.0739 43.5281L29.6941 39.8064L31.577 39.0264L34.6472 41.2194C35.7049 41.9749 37.1538 41.855 38.073 40.9358L41.1856 37.8232C42.1047 36.9041 42.2246 35.4552 41.4691 34.3974L39.2761 31.3273L40.0564 29.4441L43.7781 28.8239C45.0602 28.6102 46 27.5008 46 26.2009V21.7991C46 20.4992 45.0602 19.3898 43.7781 19.1761L40.0564 18.5559L39.2763 16.6727L41.4693 13.6026C42.2249 12.5448 42.1049 11.0959 41.1858 10.1767L38.0732 7.06413C37.154 6.14499 35.7051 6.02507 34.6474 6.7806L31.5772 8.9736L29.6941 8.19359L29.0739 4.47194C28.8602 3.18976 27.7508 2.25 26.4509 2.25H22.0491ZM20.9057 4.71854C20.9989 4.15964 21.4825 3.75 22.0491 3.75H26.4509C27.0175 3.75 27.5011 4.15964 27.5943 4.71854L28.2829 8.85057C28.3255 9.10584 28.4966 9.32114 28.7357 9.42018L31.3875 10.5186C31.6266 10.6177 31.8999 10.5864 32.1105 10.436L35.5192 8.0012C35.9803 7.67187 36.6119 7.72414 37.0125 8.12479L40.1251 11.2374C40.5258 11.638 40.5781 12.2696 40.2487 12.7307L37.8139 16.1395C37.6635 16.35 37.6322 16.6233 37.7313 16.8624L38.8298 19.5143C38.9289 19.7534 39.1442 19.9245 39.3994 19.9671L43.5315 20.6557C44.0904 20.7489 44.5 21.2325 44.5 21.7991V26.2009C44.5 26.7675 44.0904 27.2511 43.5315 27.3443L39.3994 28.0329C39.1442 28.0755 38.9289 28.2466 38.8298 28.4856L37.7311 31.1375C37.632 31.3766 37.6632 31.6499 37.8137 31.8605L40.2485 35.2693C40.5778 35.7303 40.5256 36.3619 40.1249 36.7626L37.0123 39.8752C36.6117 40.2758 35.9801 40.3281 35.519 39.9988L32.1103 37.564C31.8997 37.4135 31.6264 37.3823 31.3873 37.4814L28.7357 38.5798C28.4966 38.6789 28.3255 38.8942 28.2829 39.1494L27.5943 43.2815C27.5011 43.8404 27.0175 44.25 26.4509 44.25H22.0491C21.4825 44.25 20.9989 43.8404 20.9057 43.2815L20.2171 39.1494C20.1745 38.8942 20.0034 38.6789 19.7643 38.5798L17.1127 37.4814C16.8736 37.3823 16.6003 37.4135 16.3897 37.564L12.981 39.9988C12.5199 40.3281 11.8883 40.2758 11.4877 39.8752L8.37508 36.7626C7.97443 36.3619 7.92216 35.7303 8.25149 35.2693L10.6863 31.8605C10.8368 31.6499 10.868 31.3766 10.7689 31.1375L9.67015 28.4856C9.57111 28.2466 9.35582 28.0755 9.10057 28.0329L4.96854 27.3443C4.40964 27.2511 4 26.7675 4 26.2009L4 21.7991C4 21.2325 4.40964 20.7489 4.96854 20.6557L9.10057 19.9671C9.35584 19.9245 9.57114 19.7534 9.67017 19.5143L10.7687 16.8624C10.8678 16.6233 10.8365 16.35 10.6861 16.1395L8.25128 12.7307C7.92195 12.2696 7.97422 11.638 8.37487 11.2374L11.4875 8.12479C11.8881 7.72414 12.5197 7.67187 12.9808 8.0012L16.3895 10.436C16.6001 10.5864 16.8734 10.6177 17.1125 10.5186L19.7643 9.42018C20.0034 9.32114 20.1745 9.10584 20.2171 8.85057L20.9057 4.71854ZM18 24C18 20.5482 20.7982 17.75 24.25 17.75C27.7018 17.75 30.5 20.5482 30.5 24C30.5 27.4518 27.7018 30.25 24.25 30.25C20.7982 30.25 18 27.4518 18 24ZM24.25 16.25C19.9698 16.25 16.5 19.7198 16.5 24C16.5 28.2802 19.9698 31.75 24.25 31.75C28.5302 31.75 32 28.2802 32 24C32 19.7198 28.5302 16.25 24.25 16.25Z",
        fill: "#FF8C00"
      }, null, -1),
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22.0491 2.25C20.7492 2.25 19.6398 3.18976 19.4261 4.47194L18.8059 8.19359L16.9228 8.9736L13.8526 6.7806C12.7949 6.02507 11.346 6.14499 10.4268 7.06413L7.31421 10.1767C6.39507 11.0959 6.27515 12.5448 7.03068 13.6026L9.22367 16.6727L8.44359 18.5559L4.72194 19.1761C3.43976 19.3898 2.5 20.4992 2.5 21.7991V26.2009C2.5 27.5008 3.43976 28.6102 4.72194 28.8239L8.44363 29.4441L9.22386 31.3273L7.03089 34.3974C6.27536 35.4552 6.39528 36.9041 7.31442 37.8232L10.427 40.9358C11.3462 41.855 12.7951 41.9749 13.8528 41.2194L16.923 39.0264L18.8059 39.8064L19.4261 43.5281C19.6398 44.8102 20.7492 45.75 22.0491 45.75H26.4509C27.7508 45.75 28.8602 44.8102 29.0739 43.5281L29.6941 39.8064L31.577 39.0264L34.6472 41.2194C35.7049 41.9749 37.1538 41.855 38.073 40.9358L41.1856 37.8232C42.1047 36.9041 42.2246 35.4552 41.4691 34.3974L39.2761 31.3273L40.0564 29.4441L43.7781 28.8239C45.0602 28.6102 46 27.5008 46 26.2009V21.7991C46 20.4992 45.0602 19.3898 43.7781 19.1761L40.0564 18.5559L39.2763 16.6727L41.4693 13.6026C42.2249 12.5448 42.1049 11.0959 41.1858 10.1767L38.0732 7.06413C37.154 6.14499 35.7051 6.02507 34.6474 6.7806L31.5772 8.9736L29.6941 8.19359L29.0739 4.47194C28.8602 3.18976 27.7508 2.25 26.4509 2.25H22.0491ZM20.9057 4.71854C20.9989 4.15964 21.4825 3.75 22.0491 3.75H26.4509C27.0175 3.75 27.5011 4.15964 27.5943 4.71854L28.2829 8.85057C28.3255 9.10584 28.4966 9.32114 28.7357 9.42018L31.3875 10.5186C31.6266 10.6177 31.8999 10.5864 32.1105 10.436L35.5192 8.0012C35.9803 7.67187 36.6119 7.72414 37.0125 8.12479L40.1251 11.2374C40.5258 11.638 40.5781 12.2696 40.2487 12.7307L37.8139 16.1395C37.6635 16.35 37.6322 16.6233 37.7313 16.8624L38.8298 19.5143C38.9289 19.7534 39.1442 19.9245 39.3994 19.9671L43.5315 20.6557C44.0904 20.7489 44.5 21.2325 44.5 21.7991V26.2009C44.5 26.7675 44.0904 27.2511 43.5315 27.3443L39.3994 28.0329C39.1442 28.0755 38.9289 28.2466 38.8298 28.4856L37.7311 31.1375C37.632 31.3766 37.6632 31.6499 37.8137 31.8605L40.2485 35.2693C40.5778 35.7303 40.5256 36.3619 40.1249 36.7626L37.0123 39.8752C36.6117 40.2758 35.9801 40.3281 35.519 39.9988L32.1103 37.564C31.8997 37.4135 31.6264 37.3823 31.3873 37.4814L28.7357 38.5798C28.4966 38.6789 28.3255 38.8942 28.2829 39.1494L27.5943 43.2815C27.5011 43.8404 27.0175 44.25 26.4509 44.25H22.0491C21.4825 44.25 20.9989 43.8404 20.9057 43.2815L20.2171 39.1494C20.1745 38.8942 20.0034 38.6789 19.7643 38.5798L17.1127 37.4814C16.8736 37.3823 16.6003 37.4135 16.3897 37.564L12.981 39.9988C12.5199 40.3281 11.8883 40.2758 11.4877 39.8752L8.37508 36.7626C7.97443 36.3619 7.92216 35.7303 8.25149 35.2693L10.6863 31.8605C10.8368 31.6499 10.868 31.3766 10.7689 31.1375L9.67015 28.4856C9.57111 28.2466 9.35582 28.0755 9.10057 28.0329L4.96854 27.3443C4.40964 27.2511 4 26.7675 4 26.2009L4 21.7991C4 21.2325 4.40964 20.7489 4.96854 20.6557L9.10057 19.9671C9.35584 19.9245 9.57114 19.7534 9.67017 19.5143L10.7687 16.8624C10.8678 16.6233 10.8365 16.35 10.6861 16.1395L8.25128 12.7307C7.92195 12.2696 7.97422 11.638 8.37487 11.2374L11.4875 8.12479C11.8881 7.72414 12.5197 7.67187 12.9808 8.0012L16.3895 10.436C16.6001 10.5864 16.8734 10.6177 17.1125 10.5186L19.7643 9.42018C20.0034 9.32114 20.1745 9.10584 20.2171 8.85057L20.9057 4.71854ZM18 24C18 20.5482 20.7982 17.75 24.25 17.75C27.7018 17.75 30.5 20.5482 30.5 24C30.5 27.4518 27.7018 30.25 24.25 30.25C20.7982 30.25 18 27.4518 18 24ZM24.25 16.25C19.9698 16.25 16.5 19.7198 16.5 24C16.5 28.2802 19.9698 31.75 24.25 31.75C28.5302 31.75 32 28.2802 32 24C32 19.7198 28.5302 16.25 24.25 16.25Z",
        fill: "#FF8C00"
      }, null, -1)
    ])));
  }
}), PH = /* @__PURE__ */ J({
  __name: "flag-finish-24",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M2.5 21.5V4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H4.5V21.5C4.5 22.0523 4.05228 22.5 3.5 22.5C2.94772 22.5 2.5 22.0523 2.5 21.5Z",
        fill: "none",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M21.5 15.5V4.5C21.5 3.94772 21.0523 3.5 20.5 3.5H9.6H4.5V16.5H9.6H20.5C21.0523 16.5 21.5 16.0523 21.5 15.5Z",
        fill: "none",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M9 4H7V6H5V8H7V10H5V12H7V14H5V16H7V14H9V16H11V14H13V16H15V14H17V16H19V14H21V12H19V10H21V8H19V6H21V4H19V6H17V4H15V6H13V4H11V6H9V4ZM9 8H7V6H9V8ZM11 8V6H13V8H11ZM11 10V8H9V10H7V12H9V14H11V12H13V14H15V12H17V14H19V12H17V10H19V8H17V6H15V8H13V10H11ZM15 10V8H17V10H15ZM15 10H13V12H15V10ZM11 10V12H9V10H11Z",
        fill: "currentColor",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd"
      }, null, -1))
    ], 64));
  }
}), nu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 3C3.11929 3 2 4.11929 2 5.5V14.5C2 15.8807 3.11929 17 4.5 17H9V18.2984C9 18.639 8.88408 18.9695 8.6713 19.2355L7.10957 21.1877C6.9895 21.3377 6.96609 21.5434 7.04935 21.7166C7.13261 21.8898 7.3078 22 7.5 22H16.5C16.6922 22 16.8674 21.8898 16.9507 21.7166C17.0339 21.5434 17.0105 21.3377 16.8904 21.1877L15.3287 19.2355C15.1159 18.9695 15 18.639 15 18.2984V17H19.5C20.8807 17 22 15.8807 22 14.5V5.5C22 4.11929 20.8807 3 19.5 3H4.5ZM14 17H10V18.2984C10 18.8661 9.8068 19.4169 9.45217 19.8602L8.54031 21H15.4597L14.5478 19.8602C14.1932 19.4169 14 18.8661 14 18.2984V17ZM14.5 16H19.5C20.3284 16 21 15.3284 21 14.5V5.5C21 4.67157 20.3284 4 19.5 4H4.5C3.67157 4 3 4.67157 3 5.5V14.5C3 15.3284 3.67157 16 4.5 16H9.5H14.5Z",
  fill: "currentColor"
}, zH = /* @__PURE__ */ J({
  __name: "desktop",
  setup(t) {
    return (e, a) => (m(), C("path", nu));
  }
}), ru = {
  fill: "#0F5C47",
  "fill-rule": "evenodd",
  d: "M4.5 1.5a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 5v9a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 15 14V3a1.5 1.5 0 0 0-1.5-1.5h-9Zm.5 1h8.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 2 14V5.5h2.5A.5.5 0 0 0 5 5V2.5Zm-1 2H2.707L4 3.207V4.5Zm.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0-2h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm0 4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
  "clip-rule": "evenodd"
}, TH = /* @__PURE__ */ J({
  __name: "note",
  setup(t) {
    return (e, a) => (m(), C("path", ru));
  }
}), su = {
  d: "M0 5.45536V1.30357C0 0.858259 0.358259 0.5 0.803571 0.5H4.95536C5.17634 0.5 5.35714 0.680804 5.35714 0.901786V2.24107C5.35714 2.46205 5.17634 2.64286 4.95536 2.64286H2.14286V5.45536C2.14286 5.67634 1.96205 5.85714 1.74107 5.85714H0.401786C0.180804 5.85714 0 5.67634 0 5.45536ZM9.64286 0.901786V2.24107C9.64286 2.46205 9.82366 2.64286 10.0446 2.64286H12.8571V5.45536C12.8571 5.67634 13.0379 5.85714 13.2589 5.85714H14.5982C14.8192 5.85714 15 5.67634 15 5.45536V1.30357C15 0.858259 14.6417 0.5 14.1964 0.5H10.0446C9.82366 0.5 9.64286 0.680804 9.64286 0.901786ZM14.5982 10.1429H13.2589C13.0379 10.1429 12.8571 10.3237 12.8571 10.5446V13.3571H10.0446C9.82366 13.3571 9.64286 13.5379 9.64286 13.7589V15.0982C9.64286 15.3192 9.82366 15.5 10.0446 15.5H14.1964C14.6417 15.5 15 15.1417 15 14.6964V10.5446C15 10.3237 14.8192 10.1429 14.5982 10.1429ZM5.35714 15.0982V13.7589C5.35714 13.5379 5.17634 13.3571 4.95536 13.3571H2.14286V10.5446C2.14286 10.3237 1.96205 10.1429 1.74107 10.1429H0.401786C0.180804 10.1429 0 10.3237 0 10.5446V14.6964C0 15.1417 0.358259 15.5 0.803571 15.5H4.95536C5.17634 15.5 5.35714 15.3192 5.35714 15.0982Z",
  fill: "currentColor"
}, OH = /* @__PURE__ */ J({
  __name: "expand",
  setup(t) {
    return (e, a) => (m(), C("path", su));
  }
}), iu = {
  fill: "currentColor",
  d: "M10 1a.5.5 0 0 0-.493.582l.117.702a10.015 10.015 0 0 0-7.34 7.34l-.702-.117A.5.5 0 0 0 1 10v4a.5.5 0 0 0 .582.493l.702-.117a10.015 10.015 0 0 0 7.34 7.34l-.117.702A.5.5 0 0 0 10 23h4a.5.5 0 0 0 .493-.582l-.117-.702a10.015 10.015 0 0 0 7.34-7.34l.702.117A.5.5 0 0 0 23 14v-4a.5.5 0 0 0-.582-.493l-.702.117a10.015 10.015 0 0 0-7.34-7.34l.117-.702A.5.5 0 0 0 14 1h-4ZM3.274 9.789a9.016 9.016 0 0 1 6.515-6.515l.33 1.982a7.013 7.013 0 0 0-4.863 4.863l-1.982-.33Zm2.975.495a6.014 6.014 0 0 1 4.036-4.035l.222 1.333A.5.5 0 0 0 11 8h2a.5.5 0 0 0 .493-.418l.223-1.333a6.014 6.014 0 0 1 4.035 4.035l-1.333.223A.5.5 0 0 0 16 11v2a.5.5 0 0 0 .418.493l1.333.223a6.014 6.014 0 0 1-4.036 4.035l-.222-1.333A.5.5 0 0 0 13 16h-2a.5.5 0 0 0-.493.418l-.223 1.333a6.014 6.014 0 0 1-4.035-4.036l1.333-.222A.5.5 0 0 0 8 13v-2a.5.5 0 0 0-.418-.493l-1.333-.223Zm7.632-5.028.33-1.982a9.016 9.016 0 0 1 6.516 6.515l-1.983.33a7.013 7.013 0 0 0-4.863-4.863Zm4.863 8.625 1.983.33a9.017 9.017 0 0 1-6.516 6.516l-.33-1.983a7.013 7.013 0 0 0 4.863-4.863Zm-8.625 4.863-.33 1.982a9.016 9.016 0 0 1-6.515-6.515l1.982-.33a7.013 7.013 0 0 0 4.863 4.863ZM11.424 7l-.834-5h2.82l-.834 5h-1.152ZM7 12.576l-5 .834v-2.82l5 .834v1.152ZM13.41 22h-2.82l.834-5h1.152l.834 5ZM17 11.424l5-.834v2.82l-5-.834v-1.152Z"
}, FH = /* @__PURE__ */ J({
  __name: "crosshairs-24",
  setup(t) {
    return (e, a) => (m(), C("path", iu));
  }
}), lu = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6Zm0 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm4-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm6-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2Zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
  "clip-rule": "evenodd"
}, BH = /* @__PURE__ */ J({
  __name: "th-solid",
  setup(t) {
    return (e, a) => (m(), C("path", lu));
  }
}), uu = {
  fill: "currentColor",
  d: "M 0 1.8 C 0 0.805 0.805 0 1.8 0 L 19.795 0 C 20.79 0 21.595 0.805 21.595 1.8 L 21.595 2.999 C 21.595 3.783 21.094 4.449 20.395 4.696 L 20.395 11.397 C 20.395 11.728 20.126 11.997 19.795 11.997 C 19.464 11.997 19.195 11.728 19.195 11.397 L 19.195 4.799 L 2.399 4.799 L 2.399 16.196 C 2.399 16.527 2.667 16.796 2.999 16.796 L 5.399 16.796 C 5.73 16.796 5.999 17.065 5.999 17.396 C 5.999 17.728 5.731 17.997 5.399 17.997 L 2.999 17.997 C 2.005 17.997 1.199 17.191 1.199 16.197 L 1.199 4.698 C 0.5 4.45 0 3.785 0 3.001 L 0 1.801 L 0 1.8 Z M 1.8 1.199 C 1.468 1.199 1.199 1.468 1.199 1.8 L 1.199 2.999 C 1.199 3.33 1.468 3.599 1.8 3.599 L 19.795 3.599 C 20.126 3.599 20.395 3.331 20.395 2.999 L 20.395 1.8 C 20.395 1.468 20.126 1.199 19.795 1.199 L 1.8 1.199 Z M 8.998 8.398 C 8.667 8.398 8.398 8.666 8.398 8.998 C 8.398 9.33 8.666 9.598 8.998 9.598 L 12.597 9.598 C 12.928 9.598 13.197 9.33 13.197 8.998 C 13.197 8.666 12.928 8.398 12.597 8.398 L 8.998 8.398 Z M 7.198 8.998 C 7.198 8.004 8.004 7.198 8.998 7.198 L 12.597 7.198 C 13.591 7.198 14.397 8.004 14.397 8.998 C 14.397 9.992 13.591 10.797 12.597 10.797 L 8.998 10.797 C 8.004 10.797 7.198 9.992 7.198 8.998 Z M 8.398 14.996 C 8.398 14.002 9.203 13.196 10.197 13.196 L 22.194 13.196 C 23.188 13.196 23.994 14.002 23.994 14.996 L 23.994 22.194 C 23.994 23.188 23.188 23.994 22.194 23.994 L 10.197 23.994 C 9.203 23.994 8.398 23.188 8.398 22.194 L 8.398 14.996 Z M 10.545 14.397 L 15.816 18.709 C 16.037 18.89 16.355 18.89 16.575 18.709 L 21.846 14.397 L 10.544 14.397 L 10.545 14.397 Z M 22.794 15.171 L 17.335 19.638 C 16.672 20.18 15.719 20.18 15.056 19.638 L 9.597 15.171 L 9.597 22.194 C 9.597 22.525 9.866 22.794 10.197 22.794 L 22.194 22.794 C 22.525 22.794 22.794 22.525 22.794 22.194 L 22.794 15.171 Z",
  style: { "transform-origin": "11.997px 11.997px" }
}, IH = /* @__PURE__ */ J({
  __name: "packaging-24",
  setup(t) {
    return (e, a) => (m(), C("path", uu));
  }
}), cu = {
  fill: "currentColor",
  d: "M49.285 7.462c-1.186.343-2.46 1.306-3.615 3.306-.841 1.457-1.1 3.54-1.05 5.662.05 2.034.38 3.956.614 5.092 1.102-.364 2.931-1.04 4.718-2.015 1.862-1.016 3.537-2.282 4.378-3.74 1.155-2 1.352-3.584 1.056-4.783C55.09 9.788 54.259 8.799 53 8.072c-1.259-.727-2.53-.952-3.715-.61ZM48.73 5.54c1.826-.527 3.66-.13 5.27.8 1.61.93 2.87 2.32 3.327 4.164.456 1.841.066 3.96-1.265 6.264-1.122 1.943-3.197 3.428-5.153 4.495-.49.267-.98.513-1.46.737H82a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-1v41a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V38H6a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3h29.86c-.646-.314-1.252-.713-1.76-1.22-1.4-1.4-2.157-2.946-2.255-4.472-.099-1.537.48-2.946 1.548-4.014 1.069-1.068 2.478-1.647 4.014-1.548 1.526.098 3.072.856 4.471 2.255.315.315.588.667.824 1.043.15-1.511.51-3.018 1.236-4.276 1.33-2.305 2.97-3.701 4.792-4.228ZM9 38v41a1 1 0 0 0 1 1h68a1 1 0 0 0 1-1V38H52a1 1 0 1 1 0-2h30a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H45v45a1 1 0 1 1-2 0V38H9Zm-1-2h35V24H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2Zm27.514-16.635c.764.763 2 1.25 3.377 1.532 1.296.264 2.586.32 3.427.322-.001-.841-.058-2.131-.322-3.427-.282-1.377-.769-2.614-1.532-3.377-1.139-1.138-2.25-1.613-3.185-1.673-.926-.06-1.783.277-2.472.966-.689.69-1.026 1.546-.966 2.472.06.935.535 2.046 1.673 3.185Z"
}, ZH = /* @__PURE__ */ J({
  __name: "droppedoff-88",
  setup(t) {
    return (e, a) => (m(), C("path", cu));
  }
}), RH = /* @__PURE__ */ J({
  __name: "map-marker-alt",
  setup(t) {
    return (e, a) => (m(), C("g", null, a[0] || (a[0] = [
      g("path", {
        fill: "currentColor",
        d: "M23.37 3.52c-9.07.01-16.41 7.36-16.41 16.42 0 8.82 15.14 25.9 15.78 26.62.31.35.85.38 1.19.07.02-.02.05-.04.07-.07.64-.73 15.78-17.8 15.78-26.62-.02-9.06-7.35-16.41-16.41-16.42zm0 41.19C20.48 41.33 8.65 27.15 8.65 19.93c0-8.13 6.59-14.72 14.72-14.72s14.72 6.59 14.72 14.72c0 7.22-11.83 21.42-14.72 24.78z"
      }, null, -1),
      g("path", {
        fill: "currentColor",
        d: "M23.35 10.45c-4.91 0-8.89 3.99-8.89 8.9s3.99 8.89 8.9 8.89 8.89-3.99 8.89-8.89c0-4.92-3.98-8.9-8.9-8.9zm0 16.1c-3.98 0-7.2-3.23-7.2-7.2s3.23-7.2 7.2-7.2 7.2 3.23 7.2 7.2c0 3.98-3.22 7.2-7.2 7.2z"
      }, null, -1)
    ])));
  }
}), du = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.847.5a1.5 1.5 0 0 0-1.48 1.253l-.315 1.891-.876.363-1.56-1.114a1.5 1.5 0 0 0-1.932.16l-1.63 1.63a1.5 1.5 0 0 0-.16 1.933l1.113 1.56-.363.876-1.89.316.082.493-.083-.493A1.5 1.5 0 0 0 .5 10.848v2.305a1.5 1.5 0 0 0 1.253 1.48l1.891.315.363.876-1.114 1.56a1.5 1.5 0 0 0 .16 1.933l1.63 1.63a1.5 1.5 0 0 0 1.933.16l1.56-1.114.876.363.316 1.89a1.5 1.5 0 0 0 1.48 1.254h2.305a1.5 1.5 0 0 0 1.48-1.253l.315-1.891.876-.363 1.56 1.114a1.5 1.5 0 0 0 1.932-.16l1.63-1.63a1.5 1.5 0 0 0 .16-1.933l-1.113-1.56.363-.876 1.89-.316a1.5 1.5 0 0 0 1.254-1.48v-2.305a1.5 1.5 0 0 0-1.253-1.48l-1.891-.315-.363-.876 1.114-1.56a1.5 1.5 0 0 0-.16-1.933l-1.63-1.63a1.5 1.5 0 0 0-1.933-.16l-1.56 1.114-.876-.363-.316-1.89A1.5 1.5 0 0 0 13.152.5h-2.305Zm-.493 1.418a.5.5 0 0 1 .493-.418h2.306a.5.5 0 0 1 .493.418l.36 2.164a.5.5 0 0 0 .303.38l1.389.575a.5.5 0 0 0 .482-.055l1.785-1.275a.5.5 0 0 1 .644.053l1.63 1.63a.5.5 0 0 1 .054.645L19.018 7.82a.5.5 0 0 0-.055.482l.575 1.39a.5.5 0 0 0 .38.301l2.164.36a.5.5 0 0 1 .418.494v2.306a.5.5 0 0 1-.418.493l-2.164.36a.5.5 0 0 0-.38.303l-.576 1.389a.5.5 0 0 0 .056.482l1.275 1.785a.5.5 0 0 1-.053.644l-1.63 1.63a.5.5 0 0 1-.645.054l-1.785-1.275a.5.5 0 0 0-.482-.055l-1.39.575a.5.5 0 0 0-.301.38l-.36 2.164a.5.5 0 0 1-.494.418h-2.306a.5.5 0 0 1-.493-.418l-.36-2.164a.5.5 0 0 0-.303-.38l-1.389-.575a.5.5 0 0 0-.482.055l-1.785 1.275a.5.5 0 0 1-.644-.053l-1.63-1.63a.5.5 0 0 1-.054-.645l1.275-1.785a.5.5 0 0 0 .055-.482l-.575-1.39a.5.5 0 0 0-.38-.301l-2.164-.36a.5.5 0 0 1-.418-.494v-2.306a.5.5 0 0 1 .418-.493l2.164-.36a.5.5 0 0 0 .38-.303l.575-1.389a.5.5 0 0 0-.055-.482L3.707 6.035a.5.5 0 0 1 .053-.644l1.63-1.63a.5.5 0 0 1 .645-.054L7.82 4.982a.5.5 0 0 0 .482.055l1.39-.575a.5.5 0 0 0 .301-.38l.36-2.164ZM9.5 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
  "clip-rule": "evenodd"
}, NH = /* @__PURE__ */ J({
  __name: "cog-24",
  setup(t) {
    return (e, a) => (m(), C("path", du));
  }
}), mu = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM6 6.79v-.71h2.441v4.07H10v.707H6v-.706h1.625V6.79H6Zm1.638-1.633a.477.477 0 0 1-.12-.33c0-.071.011-.138.032-.2a.42.42 0 0 1 .25-.247.58.58 0 0 1 .208-.035c.076 0 .144.012.203.035a.38.38 0 0 1 .146.089.382.382 0 0 1 .106.154.58.58 0 0 1 .035.203.467.467 0 0 1-.124.331c-.082.089-.204.133-.366.133-.165 0-.289-.044-.371-.133Z",
  "clip-rule": "evenodd"
}, pu = /* @__PURE__ */ J({
  __name: "info",
  setup(t) {
    return (e, a) => (m(), C("path", mu));
  }
}), fu = /* @__PURE__ */ J({
  __name: "hand-giving-package",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M16.2347 18.7383C16.2347 18.7383 21.2379 17.4919 22 18C22.7621 18.5081 23.254 18.9919 23 19.5C22.746 20.0081 15.5405 23.5 13 23.5C10.4595 23.5 7.52428 22.5 6 22.5C5.09633 22.5 3.85827 22.5 2.99991 22.5C2.44763 22.5 2 22.0523 2 21.5V17.3015C2 16.8331 2.32352 16.428 2.78153 16.3298C4.11303 16.0443 6.75027 15.5 7.5 15.5C8.51619 15.5 11.4919 17.5 12 17.5C12.5081 17.5 13.9838 17.5 15 17.5C16.0162 17.5 16.2347 18.7383 16.2347 18.7383ZM16.2347 18.7383C16.2347 18.7383 14.0162 20.5 13 20.5C11.9838 20.5 10 19.5 10 19.5",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.1286 0.23944C15.7297 0.0553592 15.2703 0.055359 14.8714 0.23944L9.37141 2.7779C8.84019 3.02308 8.5 3.55476 8.5 4.13984V11.8602C8.5 12.4453 8.84019 12.9769 9.37141 13.2221L14.8714 15.7606C15.2703 15.9447 15.7297 15.9447 16.1286 15.7606L21.6286 13.2221C22.1598 12.9769 22.5 12.4453 22.5 11.8602V4.13984C22.5 3.55476 22.1598 3.02308 21.6286 2.7779L16.1286 0.23944ZM15.2905 1.1474C15.4234 1.08604 15.5766 1.08604 15.7095 1.1474L20.8069 3.50003L18.8493 4.40352C18.7802 4.35602 18.7064 4.31394 18.6286 4.27801L13.568 1.94237L15.2905 1.1474ZM12.3749 2.49306L10.1931 3.50003L15.2905 5.85267C15.4234 5.91403 15.5766 5.91403 15.7095 5.85267L17.6818 4.9424L12.3749 2.49306ZM18.5 5.66613L16.1286 6.76063C16.0864 6.78012 16.0434 6.79755 16 6.81291V14.7186L21.2095 12.3142C21.3866 12.2324 21.5 12.0552 21.5 11.8602V4.28151L19.4432 5.23081C19.4804 5.36196 19.5 5.49942 19.5 5.63995V7.50012C19.5 7.77626 19.2761 8.00012 19 8.00012C18.7239 8.00012 18.5 7.77626 18.5 7.50012V5.66613ZM9.5 4.28151V11.8602C9.5 12.0552 9.6134 12.2324 9.79047 12.3142L15 14.7186V6.81291C14.9566 6.79755 14.9136 6.78012 14.8714 6.76063L9.5 4.28151Z",
        fill: "currentColor"
      }, null, -1))
    ], 64));
  }
}), hu = {
  d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
  fill: "currentColor"
}, qH = /* @__PURE__ */ J({
  __name: "shipment",
  setup(t) {
    return (e, a) => (m(), C("path", hu));
  }
}), vu = {
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM6.15273 10.0586C5.25963 12.3211 5.54262 14.8354 6.85364 16.1465C7.09708 16.3899 7.26628 16.5356 7.38752 16.6184C7.4315 16.6484 7.46298 16.6658 7.48369 16.6758L7.48841 16.6721C7.53868 16.6319 7.58804 16.5818 7.66807 16.5007C7.69775 16.4706 7.73166 16.4362 7.7714 16.3965C8.04498 16.1229 8.44174 15.7616 9.11841 15.4767C9.24686 15.4226 9.38427 15.3717 9.53165 15.3248C9.53778 15.3085 9.54482 15.2923 9.5528 15.2764L12.5531 9.27632C12.65 9.08262 12.8605 8.97329 13.0747 9.00551C13.2888 9.03772 13.4579 9.20415 13.4935 9.41777L14.4782 15.328C14.6219 15.374 14.756 15.4238 14.8816 15.4767C15.5583 15.7616 15.955 16.1229 16.2286 16.3965C16.2681 16.4359 16.3018 16.4701 16.3314 16.5001L16.3316 16.5003L16.3319 16.5006L16.3319 16.5007C16.412 16.5818 16.4613 16.6319 16.5116 16.6721L16.5164 16.6758C16.5371 16.6658 16.5686 16.6484 16.6126 16.6183C16.7339 16.5355 16.9031 16.3899 17.1465 16.1464C18.4576 14.8354 18.7406 12.3211 17.8474 10.0586C16.97 7.83596 15.0061 6 12 6C8.99394 6 7.03008 7.83596 6.15273 10.0586ZM13.4252 15.0925L12.7598 11.0988L10.7758 15.0665C11.1409 15.0237 11.547 15 12 15C12.5379 15 13.0096 15.0334 13.4252 15.0925ZM5.22257 9.69142C6.22022 7.16405 8.50628 5 12 5C15.4937 5 17.7799 7.16404 18.7776 9.69141C19.7596 12.1789 19.5427 15.1646 17.8536 16.8536C17.5971 17.1101 17.3756 17.3082 17.1766 17.4442C16.9804 17.5781 16.755 17.6875 16.5 17.6875C16.2307 17.6875 16.0285 17.5662 15.8869 17.4529C15.786 17.3722 15.6791 17.2635 15.5876 17.1704L15.5869 17.1697L15.5869 17.1697C15.564 17.1464 15.5421 17.1241 15.5215 17.1035C15.2951 16.8771 15.0044 16.6134 14.4935 16.3983C13.9754 16.1802 13.2008 16 12 16C10.7992 16 10.0246 16.1802 9.50647 16.3983C8.99564 16.6134 8.70491 16.8771 8.47853 17.1035C8.45773 17.1243 8.43559 17.1469 8.41246 17.1704C8.32096 17.2634 8.21402 17.3722 8.11314 17.4529C7.97159 17.5662 7.76938 17.6875 7.50003 17.6875C7.2451 17.6875 7.01969 17.5781 6.82353 17.4441C6.62448 17.3082 6.40307 17.1101 6.14652 16.8535C4.45762 15.1646 4.24068 12.1789 5.22257 9.69142Z",
  fill: "currentColor"
}, UH = /* @__PURE__ */ J({
  __name: "dashboard",
  setup(t) {
    return (e, a) => (m(), C("path", vu));
  }
}), YH = /* @__PURE__ */ J({
  __name: "support",
  setup(t) {
    return (e, a) => (m(), C("g", null, a[0] || (a[0] = [
      g("path", {
        fill: "currentColor",
        d: "M5.333 14c-1.473 0-2.667 1.194-2.667 2.667v1.333c0 1.473 1.194 2.667 2.667 2.667h0.667c0.368 0 0.667-0.299 0.667-0.667v-5.333c0-0.368-0.298-0.667-0.667-0.667h-0.667zM5.35 12.667c0.3-5.898 4.563-10.667 10.65-10.667s10.35 4.769 10.65 10.667h0.017c2.209 0 4 1.791 4 4v1.333c0 2.209-1.791 4-4 4 0 3.314-2.686 6-6 6h-1.4c-0.309 1.521-1.654 2.667-3.267 2.667-1.841 0-3.333-1.492-3.333-3.333s1.492-3.333 3.333-3.333c1.613 0 2.958 1.145 3.267 2.667h1.4c2.577 0 4.667-2.089 4.667-4.667v-0.114c-0.777-0.275-1.333-1.015-1.333-1.886v-5.333c0-0.866 0.551-1.604 1.321-1.882-0.244-5.319-4.034-9.452-9.321-9.452s-9.077 4.132-9.321 9.452c0.77 0.278 1.321 1.016 1.321 1.882v5.333c0 1.105-0.895 2-2 2h-0.667c-2.209 0-4-1.791-4-4v-1.333c0-2.209 1.791-4 4-4h0.017zM18 27.333c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2s2-0.895 2-2zM26.667 20.667c1.473 0 2.667-1.194 2.667-2.667v-1.333c0-1.473-1.194-2.667-2.667-2.667h-0.667c-0.368 0-0.667 0.299-0.667 0.667v5.333c0 0.368 0.299 0.667 0.667 0.667h0.667z"
      }, null, -1)
    ])));
  }
}), WH = /* @__PURE__ */ J({
  __name: "shirt-24",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        fill: "none",
        d: "M6.49994 10.4997L6.5 20.4998C6.5 20.8145 6.64793 21.1099 6.92158 21.2654C7.68014 21.6963 9.43829 22.5 12 22.5C14.5617 22.5 16.3199 21.6963 17.0784 21.2654C17.3521 21.1099 17.5 20.8145 17.5 20.4998L17.4999 10.4997C17.4999 9.94744 17.9476 9.49972 18.4999 9.49972H21.7192C22.1781 9.49972 22.5781 9.18743 22.6894 8.74227L23.2934 6.32622C23.4125 5.85005 23.1684 5.35787 22.7172 5.16452L16.6998 2.58562C16.5922 2.53953 16.4665 2.59428 16.4191 2.70126C16.1213 3.37365 14.9466 5.5 12 5.5C9.05337 5.5 7.87871 3.37364 7.58092 2.70126C7.53354 2.59428 7.40776 2.53953 7.30021 2.58562L1.28279 5.16452C0.831651 5.35786 0.587522 5.85005 0.706577 6.32622L1.31065 8.74228C1.42196 9.18743 1.82193 9.49972 2.28079 9.49972H5.49994C6.05222 9.49972 6.49993 9.94743 6.49994 10.4997Z",
        stroke: "#FF8C00"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M16.5 2.5C16.5 2.5 14.5 3 12 3C9.5 3 7.5 2.5 7.5 2.5",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), gu = {
  fill: "currentColor",
  d: "M6.854 2.146a.5.5 0 0 1 0 .708L2.707 7H9.5a5.5 5.5 0 0 1 5.5 5.5v1a.5.5 0 0 1-1 0v-1A4.5 4.5 0 0 0 9.5 8H2.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0Z"
}, KH = /* @__PURE__ */ J({
  __name: "reply",
  setup(t) {
    return (e, a) => (m(), C("path", gu));
  }
}), GH = /* @__PURE__ */ J({
  __name: "assign-to-person",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("g", {
        "clip-path": "url(#clip0_27568_7500)",
        fill: "none"
      }, [
        g("path", {
          d: "M11.5 4.5C11.5 6.433 9.933 8 8 8C6.067 8 4.5 6.433 4.5 4.5C4.5 2.567 6.067 1 8 1C9.933 1 11.5 2.567 11.5 4.5Z",
          stroke: "#0F5C47",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M14.5 15C14.5 12 13.5 9 10.5 7",
          stroke: "#0F5C47",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M5.5 7C4.61716 7.58856 3.90752 8.26372 3.3456 9",
          stroke: "#0F5C47",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M5 11L7.5 13.5M7.5 13.5L5 16M7.5 13.5H1.5",
          stroke: "#0F5C47",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      a[1] || (a[1] = g("defs", null, [
        g("clipPath", { id: "clip0_27568_7500" }, [
          g("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(0 0.5)"
          })
        ])
      ], -1))
    ], 64));
  }
}), yu = {
  d: "M3.5 19.5V9.01816C3.5 8.69323 3.65787 8.38857 3.92332 8.20119L11.4233 2.90707C11.769 2.66303 12.231 2.66303 12.5767 2.90707L20.0767 8.20119C20.3421 8.38857 20.5 8.69323 20.5 9.01816V19.5C20.5 20.0523 20.0523 20.5 19.5 20.5H15.5C14.9477 20.5 14.5 20.0523 14.5 19.5V14.5C14.5 13.9477 14.0523 13.5 13.5 13.5H10.5C9.94772 13.5 9.5 13.9477 9.5 14.5V19.5C9.5 20.0523 9.05228 20.5 8.5 20.5H4.5C3.94772 20.5 3.5 20.0523 3.5 19.5Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "none"
}, XH = /* @__PURE__ */ J({
  __name: "home",
  setup(t) {
    return (e, a) => (m(), C("path", yu));
  }
}), QH = /* @__PURE__ */ J({
  __name: "unassign-from-person",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M11.5 4C11.5 5.933 9.933 7.5 8 7.5C6.067 7.5 4.5 5.933 4.5 4C4.5 2.067 6.067 0.5 8 0.5C9.933 0.5 11.5 2.067 11.5 4Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M1.5 14.5C1.5 11.5 2.5 8.5 5.5 6.5",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M10.5 6.5C11.3828 7.08856 12.0925 7.76372 12.6544 8.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        d: "M10.5 10.5L12.5 12.5M12.5 12.5L10.5 14.5M12.5 12.5L14.5 10.5M12.5 12.5L14.5 14.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), bu = {
  fill: "currentColor",
  d: "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm5-6a6 6 0 1 0 3.874 10.582l4.272 4.272a.5.5 0 0 0 .708-.708l-4.272-4.272A6 6 0 0 0 6 0Z"
}, ku = /* @__PURE__ */ J({
  __name: "search-24",
  setup(t) {
    return (e, a) => (m(), C("path", bu));
  }
}), JH = /* @__PURE__ */ J({
  __name: "fulfilment-48",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M25.2572 2.47882C24.4595 2.11066 23.5405 2.11066 22.7429 2.47882L11.7429 7.55574C10.6804 8.0461 10 9.10947 10 10.2796V25.7203C10 26.8904 10.6804 27.9538 11.7429 28.4442L22.7429 33.5211C23.5405 33.8893 24.4595 33.8893 25.2572 33.5211L36.2572 28.4442C37.3197 27.9538 38 26.8904 38 25.7203V10.2796C38 9.10947 37.3197 8.0461 36.2572 7.55574L25.2572 2.47882ZM23.581 4.29474C23.8469 4.17202 24.1532 4.17202 24.4191 4.29474L34.6139 9.00002L30.6987 10.807C30.5604 10.712 30.4129 10.6278 30.2572 10.556L20.1361 5.88469L23.581 4.29474ZM17.7498 6.98606L13.3862 9.00002L23.581 13.7053C23.8469 13.828 24.1532 13.828 24.4191 13.7053L28.3636 11.8848L17.7498 6.98606ZM30 13.3322L25.2572 15.5212C25.1727 15.5602 25.0869 15.5951 25 15.6258V31.437L35.4191 26.6283C35.7732 26.4648 36 26.1103 36 25.7203V10.563L31.8864 12.4616C31.9608 12.7239 32 12.9988 32 13.2799V17.0002C32 17.5525 31.5523 18.0002 31 18.0002C30.4477 18.0002 30 17.5525 30 17.0002V13.3322ZM12 10.563V25.7203C12 26.1103 12.2268 26.4648 12.581 26.6283L23 31.437V15.6258C22.9131 15.5951 22.8273 15.5602 22.7429 15.5212L12 10.563Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18V16ZM9 18H10V16H9V18ZM1 18H9V16H1V18Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M39 16H38V18H39V16ZM45 18C45.5523 18 46 17.5523 46 17C46 16.4477 45.5523 16 45 16V18ZM39 18H45V16H39V18Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        fill: "none",
        d: "M1 37H45",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        fill: "none",
        d: "M5 43C5 44.1046 4.10457 45 3 45C1.89543 45 1 44.1046 1 43C1 41.8954 1.89543 41 3 41C4.10457 41 5 41.8954 5 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[5] || (a[5] = g("path", {
        fill: "none",
        d: "M13 43C13 44.1046 12.1046 45 11 45C9.89543 45 9 44.1046 9 43C9 41.8954 9.89543 41 11 41C12.1046 41 13 41.8954 13 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[6] || (a[6] = g("path", {
        fill: "none",
        d: "M21 43C21 44.1046 20.1046 45 19 45C17.8954 45 17 44.1046 17 43C17 41.8954 17.8954 41 19 41C20.1046 41 21 41.8954 21 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[7] || (a[7] = g("path", {
        fill: "none",
        d: "M29 43C29 44.1046 28.1046 45 27 45C25.8954 45 25 44.1046 25 43C25 41.8954 25.8954 41 27 41C28.1046 41 29 41.8954 29 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[8] || (a[8] = g("path", {
        fill: "none",
        d: "M37 43C37 44.1046 36.1046 45 35 45C33.8954 45 33 44.1046 33 43C33 41.8954 33.8954 41 35 41C36.1046 41 37 41.8954 37 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[9] || (a[9] = g("path", {
        fill: "none",
        d: "M45 43C45 44.1046 44.1046 45 43 45C41.8954 45 41 44.1046 41 43C41 41.8954 41.8954 41 43 41C44.1046 41 45 41.8954 45 43Z",
        stroke: "#FF8C00",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), Cu = {
  d: "M10.5 6.5V16C10.5 16.8284 11.1716 17.5 12 17.5V17.5C12.8284 17.5 13.5 16.8284 13.5 16V6.5C13.5 4.84315 12.1569 3.5 10.5 3.5V3.5C8.84315 3.5 7.5 4.84315 7.5 6.5V16C7.5 18.4853 9.51472 20.5 12 20.5V20.5C14.4853 20.5 16.5 18.4853 16.5 16V6.5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "none"
}, ej = /* @__PURE__ */ J({
  __name: "attachment-24",
  setup(t) {
    return (e, a) => (m(), C("path", Cu));
  }
}), wu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.169434 5.54443C0.169434 4.78504 0.785042 4.16943 1.54443 4.16943H12.6339C13.3491 4.16943 13.9368 4.71543 14.0028 5.41333C14.1918 5.3155 14.4064 5.26024 14.6339 5.26024H17.4309C17.9139 5.26024 18.3614 5.51365 18.6099 5.92781L21.4412 10.6466C21.5023 10.7485 21.5913 10.8309 21.6976 10.884L23.0659 11.5682C23.5318 11.8011 23.826 12.2772 23.826 12.798V16.634C23.826 17.3933 23.2104 18.009 22.451 18.009H21.6172C21.4358 19.2431 20.3725 20.1905 19.088 20.1905C17.7854 20.1905 16.7104 19.2164 16.5516 17.9569C16.4957 17.99 16.4305 18.009 16.3609 18.009H13.6339L13.6302 18.0089H8.52778C8.34637 19.2431 7.28308 20.1905 5.99851 20.1905C4.71395 20.1905 3.65065 19.2431 3.46924 18.0089L1.54443 18.0089C0.785042 18.0089 0.169434 17.3933 0.169434 16.6339V5.54443ZM16.5516 17.311C16.7103 16.0515 17.7854 15.0773 19.088 15.0773C20.3726 15.0773 21.4359 16.0248 21.6173 17.259H22.451C22.7962 17.259 23.076 16.9791 23.076 16.634V12.798C23.076 12.5613 22.9423 12.3449 22.7305 12.239L21.3622 11.5548C21.3083 11.5279 21.2565 11.4976 21.207 11.4641H16.8156C16.0562 11.4641 15.4406 10.8485 15.4406 10.0891V8.81673C15.4406 8.05734 16.0562 7.44173 16.8156 7.44173H18.6436L17.9668 6.31368C17.8539 6.12543 17.6504 6.01024 17.4309 6.01024H14.6339C14.2913 6.01024 14.013 6.28594 14.0089 6.6276V17.259H16.3609C16.4305 17.259 16.4957 17.2779 16.5516 17.311ZM20.8945 17.6254C20.89 16.6316 20.0829 15.8273 19.088 15.8273C18.0902 15.8273 17.2814 16.6362 17.2814 17.6339C17.2814 18.6317 18.0902 19.4405 19.088 19.4405C20.0829 19.4405 20.8899 18.6363 20.8945 17.6425C20.8945 17.6396 20.8944 17.6368 20.8944 17.634C20.8944 17.6311 20.8945 17.6283 20.8945 17.6254ZM7.80498 17.6339L7.80507 17.6254C7.80047 16.6316 6.99341 15.8273 5.99851 15.8273C5.00076 15.8273 4.19193 16.6362 4.19193 17.6339C4.19193 18.6317 5.00076 19.4405 5.99851 19.4405C6.9934 19.4405 7.80045 18.6363 7.80507 17.6425L7.80498 17.6339ZM13.2589 17.2589H8.52779C8.34639 16.0247 7.28309 15.0773 5.99851 15.0773C4.71393 15.0773 3.65063 16.0247 3.46923 17.2589L1.54443 17.2589C1.19926 17.2589 0.919434 16.9791 0.919434 16.6339V5.54443C0.919434 5.19926 1.19926 4.91943 1.54443 4.91943H12.6339C12.9791 4.91943 13.2589 5.19926 13.2589 5.54443V6.6239L13.2589 6.63524V17.2589ZM19.0936 8.19169L19.088 8.19173H16.8156C16.4705 8.19173 16.1906 8.47156 16.1906 8.81673V10.0891C16.1906 10.4343 16.4705 10.7141 16.8156 10.7141H20.6071L19.0936 8.19169Z",
  fill: "currentColor"
}, _u = /* @__PURE__ */ J({
  __name: "carrier-truck",
  setup(t) {
    return (e, a) => (m(), C("path", wu));
  }
}), Hu = {
  fill: "currentColor",
  d: "M21.782 7.447a3 3 0 0 1 2.436 0l16 7.111A3 3 0 0 1 42 17.3v11.383l11.782-5.236a3 3 0 0 1 2.436 0l25 11.111A3 3 0 0 1 83 37.3v30.443a3 3 0 0 1-1.698 2.703l-8.442 4.065a1 1 0 0 1-.997.48L56.3 82.483a3 3 0 0 1-2.602 0l-17.133-8.249a1 1 0 1 1 .868-1.802L54 80.41V49.64a2.984 2.984 0 0 1-.235-.094L29 38.54v29.204a1 1 0 0 0 .566.901l1.868.9a1 1 0 1 1-.868 1.802l-1.867-.9A3 3 0 0 1 27 67.743V46.118l-1.553.776-1.105.553a3 3 0 0 1-2.684 0l-16-8A3 3 0 0 1 4 36.764V17.3a3 3 0 0 1 1.782-2.742l16-7.11ZM56 49.627v30.782l15-7.223V42.695l-14.757 6.831c-.08.037-.16.07-.243.1Zm24.434 19.017a1 1 0 0 0 .566-.9v-29.68l-8.032 3.718c.021.117.032.236.032.356v30.084l7.434-3.579Zm-.303-32.38-24.725-10.99a1 1 0 0 0-.812 0l-7.786 3.461L71.6 40.213l8.53-3.95Zm-50.537.122a1 1 0 0 0-.217.132l25.2 11.2a1 1 0 0 0 .826-.007l13.817-6.396-24.64-11.407a1.006 1.006 0 0 1-.176-.104l-14.81 6.582ZM40 18.539l-15.782 7.014c-.072.032-.144.06-.218.087v19.742l.553-.276 2-1A.994.994 0 0 1 27 44v-6.7a3 3 0 0 1 1.782-2.742L40 29.572V18.54ZM22 45.382V25.64a3.063 3.063 0 0 1-.218-.087L6 18.539v18.225a1 1 0 0 0 .553.894L22 45.382Zm17.406-28.996-16-7.111a1 1 0 0 0-.812 0l-16 7.111a.99.99 0 0 0-.217.132l16.217 7.207a1 1 0 0 0 .812 0l16.217-7.207a1 1 0 0 0-.217-.132Z"
}, tj = /* @__PURE__ */ J({
  __name: "sorted",
  setup(t) {
    return (e, a) => (m(), C("path", Hu));
  }
}), ju = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 6.25A1.75 1.75 0 0 0 6.25 8v19.878l-2.962 8.885A.75.75 0 0 0 3.25 37v3c0 .967.784 1.75 1.75 1.75h38A1.75 1.75 0 0 0 44.75 40v-3a.75.75 0 0 0-.038-.237l-2.962-8.885V8A1.75 1.75 0 0 0 40 6.25H8Zm-2.96 30 2.5-7.5h32.92l2.5 7.5H5.04ZM40.25 8v19.25H7.75V8A.25.25 0 0 1 8 7.75h32a.25.25 0 0 1 .25.25ZM4.75 37.75h38.5V40a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25v-2.25ZM12 12.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm13.25.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM12 15.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Zm13.25.75a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM12 18.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm13.25.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM12 21.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm13.25.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM20 33.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8ZM10.25 31a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM12 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm3.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM31 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM15.25 31a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm5.75-.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm4.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm5.75-.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm4.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM35 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Z",
  "clip-rule": "evenodd"
}, aj = /* @__PURE__ */ J({
  __name: "laptop-48",
  setup(t) {
    return (e, a) => (m(), C("path", ju));
  }
}), Lu = /* @__PURE__ */ J({
  __name: "barcode-24",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M2.5 8.5V18.5C2.5 19.0523 2.94771 19.5 3.5 19.5H20.5C21.0523 19.5 21.5 19.0523 21.5 18.5V4.5C21.5 3.94772 21.0523 3.5 20.5 3.5H7.5M2.5 8.5L7.5 3.5M2.5 8.5H7.5V3.5",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M5.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M7.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        d: "M9.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        d: "M11.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[5] || (a[5] = g("path", {
        d: "M13.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[6] || (a[6] = g("path", {
        d: "M15.5 12.5V16.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[7] || (a[7] = g("path", {
        d: "M17.5 16.5V12.5H18.5V16.5H17.5Z",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), xu = {
  fill: "currentColor",
  d: "M21 4.75c10.098 0 18.006 6.338 18.245 13.9-2.022-.896-4.325-1.4-6.745-1.4-7.72 0-14.25 5.124-14.25 11.75 0 1.482.327 2.888.92 4.18a22.769 22.769 0 0 1-3.013-.438.747.747 0 0 0-.505.069.75.75 0 0 0-.525.439c-.314.742-.946 1.441-1.79 2.083-.84.636-1.839 1.178-2.815 1.619-.707.32-1.39.582-1.975.786a38.2 38.2 0 0 0 .54-1.097c.721-1.535 1.523-3.55 1.646-5.21a.75.75 0 0 0 .002-.051.75.75 0 0 0-.368-.802C5.7 27.957 2.75 23.711 2.75 19c0-7.714 7.996-14.25 18.25-14.25Zm19.743 14.665c.005-.138.007-.276.007-.415 0-8.854-9.017-15.75-19.75-15.75S1.25 10.146 1.25 19c0 5.23 3.177 9.8 7.954 12.638-.173 1.317-.813 2.958-1.474 4.364a34.358 34.358 0 0 1-1.345 2.565l-.022.036-.005.009-.001.002a.75.75 0 0 0 .825 1.113L7 39l.182.727h.002l.006-.002.018-.004.066-.017.245-.068a26.467 26.467 0 0 0 3.621-1.318c1.035-.467 2.144-1.063 3.103-1.79.813-.617 1.555-1.357 2.039-2.23 1.215.238 2.475.385 3.766.434 2.461 3.627 7.18 6.018 12.452 6.018.623 0 1.237-.033 1.84-.097.262.75.815 1.353 1.414 1.826.662.523 1.454.944 2.193 1.27a18.25 18.25 0 0 0 2.812.964l.05.012.014.004h.004l.001.001L41 44l-.171.73a.75.75 0 0 0 .803-1.134v-.001l-.004-.006-.015-.023a18.094 18.094 0 0 1-.277-.46 20.44 20.44 0 0 1-.663-1.234 12.92 12.92 0 0 1-.65-1.54c-.157-.466-.25-.88-.27-1.213C43.885 37.102 46.75 33.367 46.75 29c0-4.015-2.399-7.48-6.007-9.585ZM21.21 33.75a.752.752 0 0 0-.18-.289c-.822-1.36-1.279-2.878-1.279-4.462 0-5.525 5.558-10.25 12.75-10.25 7.193 0 12.75 4.725 12.75 10.25 0 3.788-2.582 7.176-6.557 8.959a.75.75 0 0 0-.422.863.75.75 0 0 0-.021.178c0 .587.153 1.222.352 1.812a14.394 14.394 0 0 0 .822 1.916c-.279-.103-.574-.22-.871-.352-.678-.299-1.344-.66-1.87-1.074-.533-.421-.85-.842-.958-1.245a.75.75 0 0 0-.115-.244.75.75 0 0 0-.856-.723c-.732.105-1.485.16-2.254.16-4.983 0-9.181-2.268-11.29-5.499Z"
}, oj = /* @__PURE__ */ J({
  __name: "comments-48",
  setup(t) {
    return (e, a) => (m(), C("path", xu));
  }
}), $u = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.85355 4.85355C10.0488 4.65829 10.0488 4.34171 9.85355 4.14645C9.65829 3.95118 9.34171 3.95118 9.14645 4.14645L7 6.29289L4.85355 4.14645C4.65829 3.95118 4.34171 3.95118 4.14645 4.14645C3.95118 4.34171 3.95118 4.65829 4.14645 4.85355L6.29289 7L4.14645 9.14645C3.95118 9.34171 3.95118 9.65829 4.14645 9.85355C4.34171 10.0488 4.65829 10.0488 4.85355 9.85355L7 7.70711L9.14645 9.85355C9.34171 10.0488 9.65829 10.0488 9.85355 9.85355C10.0488 9.65829 10.0488 9.34171 9.85355 9.14645L7.70711 7L9.85355 4.85355Z"
}, nj = /* @__PURE__ */ J({
  __name: "clear",
  setup(t) {
    return (e, a) => (m(), C("path", $u));
  }
}), Mu = { fill: "none" }, rj = /* @__PURE__ */ J({
  __name: "image-empty",
  setup(t) {
    return (e, a) => (m(), C("g", Mu, a[0] || (a[0] = [
      g("path", {
        d: "M25 38.5H3.5C2.94772 38.5 2.5 38.0523 2.5 37.5V6.5C2.5 5.94771 2.94772 5.5 3.5 5.5H40.5C41.0523 5.5 41.5 5.94772 41.5 6.5V22",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      g("path", {
        d: "M7.5 38L16.2842 27.5426C17.142 26.5214 18.74 26.61 19.4797 27.7196L22.3359 32.0038C23.1275 33.1913 24.8725 33.1913 25.6641 32.0038L32.4828 21.7758C33.2337 20.6495 34.863 20.5788 35.7086 21.6358L36 22",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      g("path", {
        d: "M16.5 15.5C16.5 17.7091 14.7091 19.5 12.5 19.5C10.2909 19.5 8.5 17.7091 8.5 15.5C8.5 13.2909 10.2909 11.5 12.5 11.5C14.7091 11.5 16.5 13.2909 16.5 15.5Z",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1),
      g("path", {
        d: "M34 41L45 30",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linejoin": "round"
      }, null, -1),
      g("path", {
        d: "M47 35.5C47 39.9183 43.4183 43.5 39 43.5C34.5817 43.5 31 39.9183 31 35.5C31 31.0817 34.5817 27.5 39 27.5C43.4183 27.5 47 31.0817 47 35.5Z",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)
    ])));
  }
}), Vu = /* @__PURE__ */ J({
  __name: "shipment-sorting",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.1286 1.23944C12.7297 1.05536 12.2703 1.05536 11.8714 1.23944L6.37141 3.7779C5.84019 4.02308 5.5 4.55476 5.5 5.13984V12.8602C5.5 13.4453 5.84019 13.9769 6.37141 14.2221L11.8714 16.7606C12.2703 16.9447 12.7297 16.9447 13.1286 16.7606L18.6286 14.2221C19.1598 13.9769 19.5 13.4453 19.5 12.8602V5.13984C19.5 4.55476 19.1598 4.02308 18.6286 3.7779L13.1286 1.23944ZM12.2905 2.1474C12.4234 2.08604 12.5766 2.08604 12.7095 2.1474L17.8069 4.50003L15.8493 5.40352C15.7802 5.35602 15.7064 5.31394 15.6286 5.27801L10.568 2.94237L12.2905 2.1474ZM9.37488 3.49306L7.1931 4.50003L12.2905 6.85267C12.4234 6.91403 12.5766 6.91403 12.7095 6.85267L14.6818 5.9424L9.37488 3.49306ZM15.5 6.66613L13.1286 7.76063C13.0864 7.78012 13.0434 7.79755 13 7.81291V15.7186L18.2095 13.3142C18.3866 13.2324 18.5 13.0552 18.5 12.8602V5.28151L16.4432 6.23081C16.4804 6.36196 16.5 6.49942 16.5 6.63995V8.50012C16.5 8.77626 16.2761 9.00012 16 9.00012C15.7239 9.00012 15.5 8.77626 15.5 8.50012V6.66613ZM6.5 5.28151V12.8602C6.5 13.0552 6.6134 13.2324 6.79047 13.3142L12 15.7186V7.81291C11.9566 7.79755 11.9136 7.78012 11.8714 7.76063L6.5 5.28151Z",
        fill: "currentColor"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M1 8C0.723858 8 0.5 8.22386 0.5 8.5C0.5 8.77614 0.723858 9 1 9V8ZM5 9H5.5V8H5V9ZM1 9H5V8H1V9Z",
        fill: "currentColor"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M20 8H19.5V9H20V8ZM23 9C23.2761 9 23.5 8.77614 23.5 8.5C23.5 8.22386 23.2761 8 23 8V9ZM20 9H23V8H20V9Z",
        fill: "currentColor"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        d: "M1 18.5H23",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        d: "M3 21.5C3 22.0523 2.55228 22.5 2 22.5C1.44772 22.5 1 22.0523 1 21.5C1 20.9477 1.44772 20.5 2 20.5C2.55228 20.5 3 20.9477 3 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[5] || (a[5] = g("path", {
        d: "M7 21.5C7 22.0523 6.55228 22.5 6 22.5C5.44772 22.5 5 22.0523 5 21.5C5 20.9477 5.44772 20.5 6 20.5C6.55228 20.5 7 20.9477 7 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[6] || (a[6] = g("path", {
        d: "M11 21.5C11 22.0523 10.5523 22.5 10 22.5C9.44772 22.5 9 22.0523 9 21.5C9 20.9477 9.44772 20.5 10 20.5C10.5523 20.5 11 20.9477 11 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[7] || (a[7] = g("path", {
        d: "M15 21.5C15 22.0523 14.5523 22.5 14 22.5C13.4477 22.5 13 22.0523 13 21.5C13 20.9477 13.4477 20.5 14 20.5C14.5523 20.5 15 20.9477 15 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[8] || (a[8] = g("path", {
        d: "M19 21.5C19 22.0523 18.5523 22.5 18 22.5C17.4477 22.5 17 22.0523 17 21.5C17 20.9477 17.4477 20.5 18 20.5C18.5523 20.5 19 20.9477 19 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[9] || (a[9] = g("path", {
        d: "M23 21.5C23 22.0523 22.5523 22.5 22 22.5C21.4477 22.5 21 22.0523 21 21.5C21 20.9477 21.4477 20.5 22 20.5C22.5523 20.5 23 20.9477 23 21.5Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), sj = /* @__PURE__ */ J({
  __name: "unstamped",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M19.5 19h-15c-.8 0-1.5-.7-1.5-1.5v-11C3 5.7 3.7 5 4.5 5h15c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5zM4.5 6c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-11c0-.3-.2-.5-.5-.5h-15z",
        fill: "currentColor"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M17.5 9h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm-1 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm1 2h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5z",
        fill: "currentColor"
      }, null, -1))
    ], 64));
  }
}), ij = /* @__PURE__ */ J({
  __name: "shipment-unknown",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M 11.853 1.527 C 11.948 1.491 12.054 1.491 12.15 1.527 L 13.377 1.992 C 13.587 2.072 13.692 2.303 13.61 2.508 C 13.528 2.714 13.291 2.815 13.08 2.736 L 12.001 2.327 L 10.922 2.736 C 10.712 2.815 10.475 2.714 10.393 2.508 C 10.311 2.303 10.415 2.072 10.626 1.992 L 11.853 1.527 Z M 15.302 3.15 C 15.384 2.945 15.621 2.843 15.831 2.923 L 18.286 3.853 C 18.496 3.933 18.601 4.164 18.519 4.369 C 18.437 4.574 18.2 4.676 17.989 4.596 L 15.535 3.666 C 15.324 3.586 15.22 3.355 15.302 3.15 Z M 8.701 3.15 C 8.783 3.355 8.678 3.586 8.468 3.666 L 6.013 4.596 C 5.803 4.676 5.566 4.574 5.484 4.369 C 5.402 4.164 5.506 3.933 5.717 3.853 L 8.171 2.923 C 8.382 2.843 8.619 2.945 8.701 3.15 Z M 20.211 5.011 C 20.293 4.805 20.53 4.704 20.74 4.783 L 21.968 5.249 C 22.125 5.308 22.228 5.456 22.228 5.62 L 22.228 6.949 C 22.228 7.17 22.045 7.348 21.819 7.348 C 21.593 7.348 21.41 7.17 21.41 6.949 L 21.41 5.893 L 20.444 5.527 C 20.233 5.447 20.129 5.216 20.211 5.011 Z M 3.792 5.011 C 3.874 5.216 3.769 5.447 3.559 5.527 L 2.592 5.893 L 2.592 6.639 C 2.592 6.86 2.409 7.038 2.183 7.038 C 1.957 7.038 1.774 6.86 1.774 6.639 L 1.774 5.62 C 1.774 5.456 1.878 5.308 2.035 5.249 L 3.262 4.783 C 3.473 4.704 3.71 4.805 3.792 5.011 Z M 2.183 8.279 C 2.409 8.279 2.592 8.457 2.592 8.677 L 2.592 10.715 C 2.592 10.935 2.409 11.114 2.183 11.114 C 1.957 11.114 1.774 10.935 1.774 10.715 L 1.774 8.677 C 1.774 8.457 1.957 8.279 2.183 8.279 Z M 21.819 9.209 C 22.045 9.209 22.228 9.387 22.228 9.607 L 22.228 10.937 C 22.228 11.157 22.045 11.335 21.819 11.335 C 21.593 11.335 21.41 11.157 21.41 10.937 L 21.41 9.607 C 21.41 9.387 21.593 9.209 21.819 9.209 Z M 2.183 12.354 C 2.409 12.354 2.592 12.533 2.592 12.753 L 2.592 14.791 C 2.592 15.011 2.409 15.19 2.183 15.19 C 1.957 15.19 1.774 15.011 1.774 14.791 L 1.774 12.753 C 1.774 12.533 1.957 12.354 2.183 12.354 Z M 2.183 16.43 C 2.409 16.43 2.592 16.609 2.592 16.829 L 2.592 17.589 L 3.577 18.015 C 3.783 18.105 3.876 18.34 3.784 18.542 C 3.692 18.743 3.451 18.834 3.244 18.744 L 2.017 18.213 C 1.869 18.149 1.774 18.006 1.774 17.848 L 1.774 16.829 C 1.774 16.609 1.957 16.43 2.183 16.43 Z M 5.491 19.281 C 5.583 19.08 5.825 18.989 6.031 19.079 L 8.486 20.142 C 8.692 20.231 8.785 20.467 8.693 20.668 C 8.602 20.869 8.36 20.96 8.153 20.871 L 5.699 19.807 C 5.492 19.718 5.399 19.482 5.491 19.281 Z M 17.146 19.809 C 17.24 20.009 17.15 20.246 16.944 20.337 L 15.751 20.869 C 15.545 20.96 15.303 20.872 15.209 20.672 C 15.115 20.472 15.205 20.235 15.411 20.144 L 16.604 19.612 C 16.809 19.52 17.052 19.609 17.146 19.809 Z M 13.567 21.404 C 13.66 21.604 13.57 21.841 13.365 21.932 L 12.171 22.464 C 12.065 22.511 11.942 22.512 11.835 22.466 L 10.608 21.934 C 10.401 21.845 10.308 21.609 10.4 21.408 C 10.492 21.206 10.734 21.116 10.94 21.205 L 11.999 21.664 L 13.024 21.207 C 13.23 21.115 13.473 21.204 13.567 21.404 Z",
        fill: "currentColor",
        transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M 1.808 5.458 C 1.9 5.257 2.142 5.166 2.348 5.256 L 3.576 5.787 C 3.782 5.877 3.875 6.112 3.783 6.314 C 3.691 6.515 3.45 6.606 3.243 6.516 L 2.016 5.984 C 1.809 5.895 1.717 5.659 1.808 5.458 Z M 22.192 5.458 C 22.284 5.659 22.191 5.895 21.985 5.984 L 20.757 6.516 C 20.551 6.606 20.309 6.515 20.217 6.314 C 20.126 6.112 20.219 5.877 20.425 5.787 L 21.652 5.256 C 21.859 5.166 22.1 5.257 22.192 5.458 Z M 18.51 7.053 C 18.602 7.254 18.509 7.49 18.303 7.579 L 15.848 8.643 C 15.642 8.732 15.4 8.642 15.308 8.44 C 15.216 8.239 15.309 8.003 15.516 7.914 L 17.97 6.851 C 18.177 6.761 18.419 6.852 18.51 7.053 Z M 5.49 7.053 C 5.582 6.852 5.824 6.761 6.03 6.851 L 8.485 7.914 C 8.691 8.003 8.784 8.239 8.692 8.44 C 8.6 8.642 8.359 8.732 8.152 8.643 L 5.698 7.579 C 5.491 7.49 5.398 7.254 5.49 7.053 Z M 10.399 9.18 C 10.491 8.979 10.733 8.888 10.939 8.977 L 12 9.437 L 13.061 8.977 C 13.268 8.888 13.51 8.979 13.601 9.18 C 13.693 9.381 13.6 9.617 13.394 9.706 L 12.166 10.238 C 12.061 10.284 11.94 10.284 11.834 10.238 L 10.607 9.706 C 10.4 9.617 10.307 9.381 10.399 9.18 Z",
        fill: "currentColor",
        transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M 12.001 11.07 C 12.227 11.07 12.41 11.248 12.41 11.468 L 12.41 12.532 C 12.41 12.752 12.227 12.93 12.001 12.93 C 11.775 12.93 11.592 12.752 11.592 12.532 L 11.592 11.468 C 11.592 11.248 11.775 11.07 12.001 11.07 Z M 12.001 14.259 C 12.227 14.259 12.41 14.438 12.41 14.658 L 12.41 16.785 C 12.41 17.005 12.227 17.183 12.001 17.183 C 11.775 17.183 11.592 17.005 11.592 16.785 L 11.592 14.658 C 11.592 14.438 11.775 14.259 12.001 14.259 Z M 12.001 18.513 C 12.227 18.513 12.41 18.691 12.41 18.911 L 12.41 19.975 C 12.41 20.195 12.227 20.373 12.001 20.373 C 11.775 20.373 11.592 20.195 11.592 19.975 L 11.592 18.911 C 11.592 18.691 11.775 18.513 12.001 18.513 Z",
        fill: "currentColor",
        transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M 20.183 15.057 C 19.806 15.057 19.501 15.354 19.501 15.721 L 19.501 16.253 C 19.501 16.473 19.318 16.652 19.092 16.652 C 18.866 16.652 18.683 16.473 18.683 16.253 L 18.683 15.721 C 18.683 14.914 19.355 14.259 20.183 14.259 L 21.274 14.259 C 22.102 14.259 22.774 14.914 22.774 15.721 L 22.774 16.216 C 22.774 16.705 22.523 17.161 22.106 17.432 L 21.441 17.864 C 21.252 17.987 21.138 18.195 21.138 18.417 L 21.138 18.911 C 21.138 19.132 20.954 19.31 20.729 19.31 C 20.503 19.31 20.319 19.132 20.319 18.911 L 20.319 18.417 C 20.319 17.928 20.57 17.472 20.987 17.201 L 21.652 16.769 C 21.842 16.645 21.956 16.438 21.956 16.216 L 21.956 15.721 C 21.956 15.354 21.651 15.057 21.274 15.057 L 20.183 15.057 Z",
        fill: "currentColor",
        transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        d: "M 20.183 20.506 C 20.183 20.213 20.427 19.975 20.729 19.975 C 21.03 19.975 21.274 20.213 21.274 20.506 C 21.274 20.8 21.03 21.038 20.729 21.038 C 20.427 21.038 20.183 20.8 20.183 20.506 Z",
        fill: "currentColor",
        transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
      }, null, -1))
    ], 64));
  }
}), Su = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9C18 9.78139 17.636 10.9262 17.0292 12.2606C16.4314 13.5754 15.6301 15.0068 14.8226 16.3367C14.0162 17.6649 13.2089 18.883 12.6029 19.7695C12.3673 20.1141 12.1624 20.4082 12 20.6389C11.8376 20.4082 11.6327 20.1141 11.3971 19.7695C10.7911 18.883 9.98385 17.6649 9.17739 16.3367C8.3699 15.0068 7.56861 13.5754 6.97078 12.2606C6.36402 10.9262 6 9.78139 6 9ZM11.5959 21.7945C11.596 21.7946 11.5961 21.7947 12 21.5L11.5961 21.7947C11.6902 21.9237 11.8403 22 12 22C12.1597 22 12.3098 21.9237 12.4039 21.7947L12 21.5C12.4039 21.7947 12.404 21.7946 12.4041 21.7945L12.4043 21.7941L12.4053 21.7927L12.4091 21.7876L12.4235 21.7678L12.4788 21.6912C12.5271 21.6241 12.5976 21.5257 12.6872 21.3993C12.8663 21.1467 13.1219 20.7822 13.4284 20.3339C14.0411 19.4376 14.8588 18.2038 15.6774 16.8557C16.4949 15.5093 17.3186 14.0401 17.9395 12.6746C18.5515 11.3287 19 10.0135 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 10.0135 5.44848 11.3287 6.06047 12.6746C6.68139 14.0401 7.5051 15.5093 8.32261 16.8557C9.14115 18.2038 9.9589 19.4376 10.5716 20.3339C10.8781 20.7822 11.1337 21.1467 11.3128 21.3993C11.4024 21.5257 11.4729 21.6241 11.5212 21.6912L11.5765 21.7678L11.5909 21.7876L11.5947 21.7927L11.5957 21.7941L11.5959 21.7945ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9ZM12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6Z",
  fill: "currentColor"
}, lj = /* @__PURE__ */ J({
  __name: "location-pin",
  setup(t) {
    return (e, a) => (m(), C("path", Su));
  }
}), uj = /* @__PURE__ */ J({
  __name: "cancel",
  setup(t) {
    return (e, a) => (m(), C("g", null, a[0] || (a[0] = [
      g("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "m13.354 3.354-10 10-.708-.708 10-10 .708.708Z",
        "clip-rule": "evenodd"
      }, null, -1),
      g("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8 7A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])));
  }
}), cj = /* @__PURE__ */ J({
  __name: "filter",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        stroke: "currentColor",
        fill: "none",
        d: "M9.75 5.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM18.75 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        d: "M3.75 11.5h11M3.75 17.5h4M11.75 17.5h9M9.75 5.5h11M3.75 5.5h2M18.75 11.5h2"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        stroke: "currentColor",
        fill: "none",
        d: "M11.75 17.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      }, null, -1))
    ], 64));
  }
}), Au = {
  fill: "none",
  d: "M8 2L4 6L2 4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "square"
}, Eu = /* @__PURE__ */ J({
  __name: "checkbox-check",
  setup(t) {
    return (e, a) => (m(), C("path", Au));
  }
}), Du = {
  d: "M3.66663 3.66663L12.3333 12.3333M12.3334 3.66661L3.66665 12.3332",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Oi = /* @__PURE__ */ J({
  __name: "cross",
  setup(t) {
    return (e, a) => (m(), C("path", Du));
  }
}), Pu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.8995 1C10.1885 1 9.58167 1.51406 9.46478 2.21542L9.16604 4.00785L8.35264 4.34478L6.87397 3.28858C6.29538 2.8753 5.5028 2.9409 5.00002 3.44368L3.44372 4.99998C2.94094 5.50276 2.87534 6.29534 3.28862 6.87393L4.34481 8.3526L4.00785 9.16604L2.21542 9.46478C1.51406 9.58167 1 10.1885 1 10.8995V13.1005C1 13.8115 1.51406 14.4183 2.21542 14.5352L4.00787 14.834L4.34491 15.6474L3.28873 17.1261C2.87545 17.7047 2.94104 18.4972 3.44382 19L5.00012 20.5563C5.5029 21.0591 6.29548 21.1247 6.87408 20.7114L8.35274 19.6552L9.16604 19.9921L9.46478 21.7846C9.58167 22.4859 10.1885 23 10.8995 23H13.1005C13.8115 23 14.4183 22.4859 14.5352 21.7846L14.834 19.9921L15.6473 19.6552L17.1259 20.7114C17.7045 21.1247 18.4971 21.0591 18.9999 20.5563L20.5562 19C21.059 18.4972 21.1246 17.7047 20.7113 17.1261L19.6551 15.6474L19.9921 14.834L21.7846 14.5352C22.4859 14.4183 23 13.8115 23 13.1005V10.8995C23 10.1885 22.4859 9.58167 21.7846 9.46478L19.9922 9.16604L19.6552 8.3526L20.7114 6.87393C21.1247 6.29534 21.0591 5.50276 20.5563 4.99998L19 3.44368C18.4972 2.9409 17.7046 2.8753 17.126 3.28858L15.6474 4.34478L14.834 4.00785L14.5352 2.21542L14.042 2.29762L14.5352 2.21542C14.4183 1.51406 13.8115 1 13.1005 1H10.8995ZM10.4512 2.37982C10.4877 2.16064 10.6773 2 10.8995 2H13.1005C13.3227 2 13.5123 2.16064 13.5488 2.37982L13.8932 4.44584C13.9215 4.61601 14.0356 4.75955 14.195 4.82557L15.5209 5.3748C15.6803 5.44083 15.8625 5.42001 16.0029 5.31973L17.7073 4.10232C17.8881 3.97317 18.1358 3.99366 18.2929 4.15078L19.8492 5.70708C20.0063 5.8642 20.0268 6.11188 19.8976 6.29269L18.6802 7.99707C18.5799 8.13747 18.5591 8.31965 18.6252 8.47904L19.1744 9.80499C19.2405 9.96438 19.384 10.0785 19.5542 10.1068L21.6202 10.4512C21.8394 10.4877 22 10.6773 22 10.8995V13.1005C22 13.3227 21.8394 13.5123 21.6202 13.5488L19.5542 13.8932C19.384 13.9215 19.2405 14.0356 19.1744 14.195L18.6251 15.5209C18.559 15.6803 18.5798 15.8625 18.6801 16.0029L19.8975 17.7073C20.0267 17.8881 20.0062 18.1358 19.8491 18.2929L18.2928 19.8492C18.1357 20.0063 17.888 20.0268 17.7072 19.8977L16.0028 18.6803C15.8624 18.58 15.6802 18.5592 15.5208 18.6252L14.195 19.1744C14.0356 19.2405 13.9215 19.384 13.8932 19.5542L13.5488 21.6202C13.5123 21.8394 13.3227 22 13.1005 22H10.8995C10.6773 22 10.4877 21.8394 10.4512 21.6202L10.1068 19.5542C10.0785 19.384 9.96438 19.2405 9.805 19.1744L8.4792 18.6252C8.3198 18.5592 8.13762 18.58 7.99722 18.6803L6.29284 19.8977C6.11203 20.0268 5.86435 20.0063 5.70723 19.8492L4.15093 18.2929C3.99381 18.1358 3.97331 17.8881 4.10246 17.7073L5.31987 16.0029C5.42017 15.8625 5.44098 15.6803 5.37493 15.5209L4.82556 14.195C4.75952 14.0356 4.616 13.9215 4.44584 13.8932L2.37982 13.5488C2.16064 13.5123 2 13.3227 2 13.1005L2 10.8995C2 10.6773 2.16064 10.4877 2.37982 10.4512L4.44584 10.1068C4.61601 10.0785 4.75954 9.96438 4.82557 9.80499L5.37484 8.47904C5.44087 8.31965 5.42005 8.13747 5.31977 7.99707L4.10236 6.29269C3.97321 6.11188 3.99371 5.8642 4.15082 5.70708L5.70712 4.15078C5.86424 3.99366 6.11192 3.97317 6.29273 4.10232L7.99711 5.31973C8.13751 5.42001 8.31968 5.44083 8.47908 5.3748L9.80498 4.82557C9.96438 4.75955 10.0785 4.61601 10.1068 4.44584L10.4512 2.37982ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z",
  fill: "currentColor"
}, dj = /* @__PURE__ */ J({
  __name: "settings-24",
  setup(t) {
    return (e, a) => (m(), C("path", Pu));
  }
}), zu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 4.5C6 3.11929 7.11929 2 8.5 2H15.5C16.8807 2 18 3.11929 18 4.5V19.5C18 20.8807 16.8807 22 15.5 22H8.5C7.11929 22 6 20.8807 6 19.5V4.5ZM8.5 3C7.67157 3 7 3.67157 7 4.5V19.5C7 20.3284 7.67157 21 8.5 21H15.5C16.3284 21 17 20.3284 17 19.5V4.5C17 3.67157 16.3284 3 15.5 3H15L14.2929 3.70711C14.1054 3.89464 13.851 4 13.5858 4H10.4142C10.149 4 9.89464 3.89464 9.70711 3.70711L9 3H8.5ZM10.5 19C10.2239 19 10 19.2239 10 19.5C10 19.7761 10.2239 20 10.5 20H13.5C13.7761 20 14 19.7761 14 19.5C14 19.2239 13.7761 19 13.5 19H10.5Z",
  fill: "currentColor"
}, mj = /* @__PURE__ */ J({
  __name: "mobile-phone",
  setup(t) {
    return (e, a) => (m(), C("path", zu));
  }
}), Tu = /* @__PURE__ */ J({
  __name: "myparcel-24",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V1.5C17.799 1.5 22.5 6.20101 22.5 12V12C22.5 17.799 17.799 22.5 12 22.5V22.5C6.20101 22.5 1.5 17.799 1.5 12V12Z",
        stroke: "currentColor",
        fill: "none"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.72074 10.8902C7.92181 11.0442 8.16795 11.1271 8.42085 11.1261C8.62301 11.1262 8.82153 11.0722 8.99593 10.9695L12.5648 8.88667C12.8167 8.72807 12.9974 8.47743 13.0687 8.18764C13.1401 7.89785 13.0965 7.59156 12.9472 7.33341C12.7979 7.07525 12.5545 6.88542 12.2685 6.80395C11.9824 6.72249 11.676 6.75576 11.4139 6.89676L7.84368 8.97754C7.62456 9.1043 7.45333 9.30024 7.35664 9.53484C7.25995 9.76945 7.24323 10.0296 7.30908 10.2747C7.37493 10.5198 7.51966 10.7362 7.72074 10.8902ZM8.43264 15.2682C8.18063 15.2682 7.93565 15.1848 7.73558 15.0309C7.53551 14.8771 7.39149 14.6614 7.3258 14.4171C7.2601 14.1729 7.27638 13.9137 7.37212 13.6797C7.46786 13.4456 7.63774 13.2498 7.85547 13.1224L14.996 8.95667C15.1261 8.88076 15.2699 8.83133 15.4191 8.8112C15.5682 8.79107 15.7199 8.80064 15.8654 8.83935C16.0109 8.87807 16.1474 8.94518 16.267 9.03684C16.3867 9.12851 16.4872 9.24293 16.5628 9.37359C16.6384 9.50425 16.6877 9.64858 16.7077 9.79835C16.7278 9.94811 16.7182 10.1004 16.6797 10.2464C16.6411 10.3925 16.5743 10.5295 16.4829 10.6496C16.3916 10.7698 16.2777 10.8707 16.1475 10.9466L9.00772 15.1151C8.83286 15.2162 8.63444 15.2691 8.43264 15.2682ZM12.0147 17.3337C11.7627 17.3336 11.5178 17.2502 11.3177 17.0964C11.1176 16.9426 10.9736 16.7268 10.9079 16.4826C10.8422 16.2383 10.8585 15.9792 10.9542 15.7451C11.05 15.5111 11.2198 15.3153 11.4376 15.1879L15.0078 13.1015C15.138 13.0256 15.2817 12.9762 15.4309 12.956C15.5801 12.9359 15.7318 12.9455 15.8772 12.9842C16.0227 13.0229 16.1592 13.09 16.2789 13.1817C16.3985 13.2733 16.4991 13.3878 16.5747 13.5184C16.6503 13.6491 16.6995 13.7934 16.7196 13.9432C16.7396 14.0929 16.7301 14.2452 16.6915 14.3913C16.653 14.5373 16.5861 14.6744 16.4948 14.7945C16.4035 14.9146 16.2895 15.0155 16.1594 15.0914L12.5898 17.1778C12.4152 17.2799 12.2168 17.3337 12.0147 17.3337Z",
        fill: "currentColor"
      }, null, -1))
    ], 64));
  }
}), pj = /* @__PURE__ */ J({
  __name: "insurance",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M3.5 5.5C3.5 5.5 10 3.5 12 1.5C14 3.5 20.5 5.5 20.5 5.5C20.5 20 12 21.5 12 21.5C12 21.5 3.5 20 3.5 5.5Z",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M8.5 12.5L10.5 14.5L15.5 8.5",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), fj = /* @__PURE__ */ J({
  __name: "basket",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("g", {
        "clip-path": "url(#clip0_16539_613)",
        fill: "none"
      }, [
        g("rect", {
          x: "2.5",
          y: "11",
          width: "44",
          height: "8",
          rx: "2",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("circle", {
          cx: "22",
          cy: "2.5",
          r: "1.5",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M21 4L12.5 15",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M29 4L36.5 15",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("circle", {
          cx: "28",
          cy: "2.5",
          r: "1.5",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M32.5 42H9.25607C8.2515 42 7.4028 41.2548 7.27287 40.2587L4.5 19H44.5L42.7265 32.5968",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M34.5208 45.3333L28.1569 27.6556L45.8345 34.0196L40.8848 37.5551L47.2487 43.9191L44.4203 46.7475L38.0563 40.3836L34.5208 45.3333Z",
          stroke: "#FF8C00",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      a[1] || (a[1] = g("defs", null, [
        g("clipPath", { id: "clip0_16539_613" }, [
          g("rect", {
            width: "48",
            height: "48",
            fill: "white",
            transform: "translate(0.5)"
          })
        ])
      ], -1))
    ], 64));
  }
}), hj = /* @__PURE__ */ J({
  __name: "directDebitAuthorization",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("rect", {
        width: "38",
        height: "38",
        fill: "url(#pattern0_26730_316821)"
      }, null, -1)),
      a[1] || (a[1] = g("defs", null, [
        g("pattern", {
          id: "pattern0_26730_316821",
          patternContentUnits: "objectBoundingBox",
          width: "1",
          height: "1"
        }, [
          g("use", {
            "xlink:href": "#image0_26730_316821",
            transform: "scale(0.00666667)"
          })
        ]),
        g("image", {
          id: "image0_26730_316821",
          width: "150",
          height: "150",
          "xlink:href": "data:image/png;base64,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"
        })
      ], -1))
    ], 64));
  }
}), Ou = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 1C3.36739 1 3.24021 1.05268 3.14645 1.14645L0.146447 4.14645C0.0526784 4.24021 0 4.36739 0 4.5V12.5C0 13.3284 0.671573 14 1.5 14H14.5C15.3284 14 16 13.3284 16 12.5V2.5C16 1.67157 15.3284 1 14.5 1H3.5ZM4 2H14.5C14.7761 2 15 2.22386 15 2.5V12.5C15 12.7761 14.7761 13 14.5 13H1.5C1.22386 13 1 12.7761 1 12.5V5H3.5C3.77614 5 4 4.77614 4 4.5V2ZM3 4H1.70711L3 2.70711V4ZM4.5 5C4.22386 5 4 5.22386 4 5.5V8V10.5C4 10.7761 4.22386 11 4.5 11H8.5H12.5C12.7761 11 13 10.7761 13 10.5V8V5.5C13 5.22386 12.7761 5 12.5 5H8.5H4.5ZM5 7.5V6H8V7.5H5ZM9 7.5V6H12V7.5H9ZM9 8.5H12V10H9V8.5ZM8 8.5V10H5V8.5H8Z",
  fill: "currentColor"
}, vj = /* @__PURE__ */ J({
  __name: "file-sheet",
  setup(t) {
    return (e, a) => (m(), C("path", Ou));
  }
}), Fu = {
  fill: "currentColor",
  d: "M0 12a1 1 0 0 1 1-1h55a2 2 0 0 1 2 2v15h11.757a5 5 0 0 1 4.266 2.393l9.243 15.125A5 5 0 0 1 84 48.126V56h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4a.97.97 0 0 1-.062-.002 8.001 8.001 0 0 1-15.876 0A.97.97 0 0 1 65 70H27a.97.97 0 0 1-.062-.002 8.001 8.001 0 0 1-15.876 0A.97.97 0 0 1 11 70H3a2 2 0 0 1-2-2V58a2 2 0 0 1 2-2V42a1 1 0 1 1 2 0v14h51V13H1a1 1 0 0 1-1-1Zm65.062 56.002a8.001 8.001 0 0 1 15.876 0A.97.97 0 0 1 81 68h4V58H3v10h8c.02 0 .041 0 .062.002a8.001 8.001 0 0 1 15.876 0l.017-.001A.767.767 0 0 1 27 68h38c.02 0 .041 0 .062.002ZM82 48.126a3 3 0 0 0-.44-1.565l-9.243-15.125A3 3 0 0 0 69.757 30H58v26h24v-7.874ZM0 17a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm13-1a1 1 0 1 0 0 2h30a1 1 0 1 0 0-2H13ZM0 22a1 1 0 0 1 1-1h34a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2H1Zm-1 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H1Zm62-3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-2.629a2 2 0 0 0-.33-1.1l-4.192-6.37a2 2 0 0 0-1.67-.901H63Zm0 2h4.807L72 41.371V44h-9v-9ZM19 63a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm56-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-8 0a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
}, gj = /* @__PURE__ */ J({
  __name: "distributed-88",
  setup(t) {
    return (e, a) => (m(), C("path", Fu));
  }
}), Bu = {
  fill: "currentColor",
  d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM7.071 3.997a.931.931 0 1 1 1.858 0l-.393 5.504a.537.537 0 0 1-1.072 0l-.393-5.504ZM8 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
}, w0 = /* @__PURE__ */ J({
  __name: "error",
  setup(t) {
    return (e, a) => (m(), C("path", Bu));
  }
}), Iu = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M47.28 11.42H2.72c-.4 0-.72-.35-.72-.78s.32-.78.72-.78h44.57c.4 0 .72.35.72.78s-.33.78-.73.78zM48 25c0-.43-.32-.78-.72-.78H2.72c-.4 0-.72.35-.72.78s.32.78.72.78h44.57c.39 0 .71-.35.71-.78zm0 14.36c0-.43-.32-.78-.72-.78H2.72c-.4 0-.72.35-.72.78s.32.78.72.78h44.57c.39-.01.71-.35.71-.78z"
}, yj = /* @__PURE__ */ J({
  __name: "bars",
  setup(t) {
    return (e, a) => (m(), C("path", Iu));
  }
}), bj = /* @__PURE__ */ J({
  __name: "packing-slip",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("g", {
        "clip-path": "url(#clip0_27568_7480)",
        fill: "none"
      }, [
        g("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M0.686646 8.22045L3.22888 6.57983L3.77112 7.42006L1.48563 8.89499L8 12.3693L14.5144 8.89499L12.2289 7.42006L12.7711 6.57983L15.3134 8.22045C15.7414 8.4967 16 8.97133 16 9.48079V16.4999H15V14.809L12.3242 16.1468C11.7793 16.4193 11.1238 16.3351 10.6654 15.9338L8.5 14.0382V17.436H7.5V14.0382L5.33461 15.9338C4.87622 16.3351 4.22066 16.4193 3.67577 16.1468L1 14.809V16.4999H0V9.48079C0 8.97133 0.258586 8.4967 0.686646 8.22045ZM1 13.6909V9.76932L7.12604 13.0365L4.67593 15.1814C4.52313 15.3152 4.30461 15.3432 4.12298 15.2524L1 13.6909ZM8.87396 13.0365L15 9.76932V13.6909L11.877 15.2524C11.6954 15.3432 11.4769 15.3152 11.3241 15.1814L8.87396 13.0365Z",
          fill: "#0F5C47"
        }),
        g("path", {
          d: "M5.5 2L3.5 4H5.5V2Z",
          fill: "#0F5C47"
        }),
        g("path", {
          d: "M5.5 2H12.5V10.5M5.5 2L3.5 4M5.5 2V4H3.5M3.5 10.5V4",
          stroke: "#0F5C47",
          "stroke-linejoin": "round"
        }),
        g("path", {
          d: "M5.5 8L7.5 9.5L10.5 5",
          stroke: "#0F5C47",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      a[1] || (a[1] = g("defs", null, [
        g("clipPath", { id: "clip0_27568_7480" }, [
          g("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(0 0.5)"
          })
        ])
      ], -1))
    ], 64));
  }
}), Zu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 6.50003C1 4.37953 3.14017 2.49927 6 2.49927C8.26307 2.49927 10.107 3.68203 10.7516 5.50497C8.21628 5.60656 6 7.25425 6 9.5C6 9.73784 6.02486 9.96898 6.07232 10.1923C6.02717 10.2184 5.96296 10.2512 5.87692 10.2856C5.62991 10.3844 5.19386 10.4996 4.50024 10.4993C4.3546 10.4992 4.22347 10.5614 4.13203 10.6607C3.7137 11.072 3.06756 11.4064 2.47538 11.6462C2.58324 11.4054 2.69209 11.1451 2.78214 10.8939C2.88205 10.6152 2.97066 10.3157 2.99692 10.0558C3.01856 9.86477 2.92835 9.67006 2.75151 9.56713C2.11598 9.19724 1.68593 8.76191 1.4113 8.26855C1.13598 7.77393 1 7.19057 1 6.50003ZM6 1.49927C8.74769 1.49927 11.1402 3.0409 11.8134 5.55363C14.1041 5.85745 16 7.42292 16 9.5C16 10.9886 14.8697 12.1318 13.5547 12.7932C13.5561 12.7981 13.5575 12.803 13.5589 12.808C13.5994 12.9499 13.6554 13.1047 13.7142 13.2518C13.7727 13.3979 13.8315 13.5303 13.8759 13.6264C13.8979 13.6743 13.9162 13.7127 13.9288 13.7387L13.9431 13.768L13.9465 13.7749L13.9472 13.7764L13.9472 13.7764L13.9473 13.7765L13.9473 13.7765L13.9473 13.7765L13.9473 13.7765C14.0247 13.9315 14.0164 14.1155 13.9253 14.2629C13.8342 14.4103 13.6733 14.5 13.5 14.5V14C13.5 14.5 13.4999 14.5 13.4997 14.5H13.4994L13.4987 14.5L13.4966 14.5L13.4902 14.5L13.4692 14.4997C13.4515 14.4994 13.4267 14.4988 13.3956 14.4977C13.3334 14.4956 13.2458 14.4913 13.1398 14.4828C12.929 14.4659 12.6393 14.432 12.329 14.3631C12.0214 14.2947 11.6755 14.188 11.3621 14.0171C11.1322 13.8916 10.9031 13.7223 10.7242 13.4939C8.86844 13.4113 7.18767 12.5007 6.4278 11.1349C6.37357 11.1613 6.31376 11.1879 6.24808 11.2142C5.90247 11.3523 5.40141 11.4765 4.70173 11.4965C4.14014 11.9953 3.3974 12.3546 2.8107 12.5892C2.48272 12.7204 2.18814 12.8186 1.97517 12.8841C1.86847 12.917 1.78172 12.9418 1.72086 12.9586C1.69041 12.967 1.6664 12.9734 1.64956 12.9778L1.62977 12.9829L1.62407 12.9844L1.6223 12.9848L1.62169 12.985L1.62146 12.985C1.62136 12.985 1.62127 12.9851 1.5 12.5L1.62127 12.9851C1.429 13.0331 1.22649 12.9631 1.10498 12.8065C0.983482 12.65 0.965928 12.4364 1.06023 12.2621L1.06025 12.2621L1.0606 12.2614L1.06227 12.2583L1.06938 12.245L1.09744 12.1921C1.1219 12.1457 1.15719 12.078 1.1999 11.9941C1.28548 11.826 1.40005 11.5943 1.51657 11.3395C1.63352 11.0837 1.74993 10.8099 1.84079 10.5565C1.88255 10.44 1.91657 10.334 1.94262 10.2405C1.32892 9.82965 0.860796 9.33563 0.537546 8.75491C0.163251 8.08249 0 7.3241 0 6.50003C0 3.64912 2.7847 1.49927 6 1.49927ZM11.0612 12.5037C11.0375 12.5008 11.0136 12.4995 10.9896 12.5C8.66171 12.4957 7 11.0449 7 9.5C7 7.95281 8.66664 6.5 11 6.5C13.3334 6.5 15 7.95281 15 9.5C15 10.5193 14.1287 11.47 12.8134 12.036C12.7872 12.0465 12.762 12.0593 12.7382 12.074C12.6745 12.113 12.622 12.1649 12.5826 12.2246C12.5264 12.31 12.497 12.4115 12.5001 12.515C12.5024 12.7055 12.5476 12.9087 12.5974 13.0827C12.6297 13.1959 12.668 13.3102 12.7078 13.4196C12.6547 13.4099 12.6006 13.399 12.546 13.3869C12.2911 13.3303 12.0433 13.2495 11.841 13.1392C11.6417 13.0305 11.5162 12.9096 11.4508 12.7834C11.4407 12.7625 11.4293 12.7425 11.4165 12.7233C11.3376 12.6048 11.2094 12.5218 11.0612 12.5037Z",
  fill: "currentColor"
}, kj = /* @__PURE__ */ J({
  __name: "DoubleChatBubble",
  setup(t) {
    return (e, a) => (m(), C("path", Zu));
  }
}), Ru = {
  d: "M0 2.5C0 2.22386 0.223858 2 0.5 2H3.5C3.77614 2 4 2.22386 4 2.5V3H20.5C20.6412 3 20.7759 3.05976 20.8707 3.1645C20.9655 3.26924 21.0115 3.40919 20.9975 3.54975L19.9975 13.5498C19.9719 13.8054 19.7568 14 19.5 14H5.21486L5.44563 16H18.5C18.7761 16 19 16.2239 19 16.5C19 16.7761 18.7761 17 18.5 17H5C4.74603 17 4.53241 16.8096 4.5033 16.5573L3.00415 3.56472C3.00141 3.54353 3 3.52193 3 3.5V3H0.5C0.223858 3 0 2.77614 0 2.5ZM5.09947 13H19.0475L19.9475 4H4.06101L5.09947 13ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19ZM14 20C14 18.8954 14.8954 18 16 18C17.1046 18 18 18.8954 18 20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20ZM6 20C6 19.4477 6.44772 19 7 19C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20ZM7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18ZM14.9 6.8C15.0657 6.57909 15.0209 6.26569 14.8 6.1C14.5791 5.93431 14.2657 5.97909 14.1 6.2L11.4459 9.7388L9.85355 8.14645C9.65829 7.95118 9.34171 7.95118 9.14645 8.14645C8.95118 8.34171 8.95118 8.65829 9.14645 8.85355L11.1464 10.8536C11.2489 10.956 11.3909 11.009 11.5354 10.9987C11.68 10.9885 11.813 10.916 11.9 10.8L14.9 6.8Z",
  fill: "currentColor"
}, Cj = /* @__PURE__ */ J({
  __name: "shopping-cart",
  setup(t) {
    return (e, a) => (m(), C("path", Ru));
  }
}), Nu = { fill: "none" }, wj = /* @__PURE__ */ J({
  __name: "chrome",
  setup(t) {
    return (e, a) => (m(), C("g", Nu, a[0] || (a[0] = [
      g("circle", {
        cx: "24",
        cy: "24",
        r: "21",
        stroke: "#FF8C00",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      g("circle", {
        cx: "24",
        cy: "24",
        r: "7",
        stroke: "#FF8C00",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      g("path", {
        d: "M30.0625 27.5L20.3125 44.3875",
        stroke: "#FF8C00",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      g("path", {
        d: "M17.9375 27.5L8.18762 10.6127",
        stroke: "#FF8C00",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1),
      g("path", {
        d: "M24 17L43 17",
        stroke: "#FF8C00",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])));
  }
}), qu = { fill: "currentColor" }, _j = /* @__PURE__ */ J({
  __name: "paper-plane",
  setup(t) {
    return (e, a) => (m(), C("g", qu, a[0] || (a[0] = [
      g("path", { d: "M48.54 3.95c-.42-.41-1.04-.54-1.59-.35L3.58 19.04c-.81.31-1.39 1.04-1.49 1.9-.1.86.3 1.72 1.01 2.2l10.43 6.64 3.58 13.11c.21.67.83 1.1 1.52 1.09.53 0 1.01-.28 1.28-.73.04-.01.06-.02.1-.05l5.2-6.94 9.02 5.69c.37.23.8.36 1.23.36.26 0 .53-.05.77-.14.68-.25 1.2-.79 1.41-1.48L48.91 5.53c.21-.55.06-1.17-.37-1.58zM3.97 21.83a.735.735 0 0 1-.39-.73c.04-.3.23-.54.51-.64l40.5-14.37-30.6 22.13-10.02-6.39zm14.65 20.58L15.05 29.3 42.2 9.71 21.14 32.64c-.05.05-.07.11-.1.17-.02.04-.04.07-.05.11l-2.37 9.49zm2.32-3.09 1.25-4.99 1.72 1.14-2.97 3.85zm15.27.94a.778.778 0 0 1-1.15.42L22.9 33.01 46.87 6.94 36.21 40.26zm-24.32-3.61L.32 45.08a.781.781 0 0 0 .92 1.26l11.58-8.44c.35-.25.42-.73.17-1.09a.774.774 0 0 0-1.1-.16zm-9.56 2.92c.16 0 .32-.05.46-.15l3.86-2.81a.77.77 0 0 0 .17-1.09.764.764 0 0 0-1.09-.17l-3.85 2.81c-.27.2-.38.54-.28.86.1.33.41.55.73.55zm7.1-5 1.93-1.42c.35-.25.42-.73.17-1.09a.782.782 0 0 0-1.09-.17L8.51 33.3c-.35.25-.42.73-.17 1.09.26.35.74.42 1.09.17v.01z" }, null, -1),
      g("path", { d: "M.77 46.61c-.28 0-.56-.13-.73-.37-.29-.41-.2-.96.2-1.26l11.58-8.43c.2-.15.44-.21.67-.17.24.04.45.16.59.36.29.42.2.97-.2 1.26L1.3 46.44c-.16.11-.34.17-.53.17zm11.59-10c-.14 0-.28.05-.39.13L.39 45.18c-.29.22-.35.62-.14.91.2.29.62.35.91.14l11.58-8.44a.652.652 0 0 0-.28-1.17c-.04-.01-.07-.01-.1-.01zm-.47.04zm6.7 7.44c-.74 0-1.38-.47-1.61-1.17l-3.57-13.06-10.38-6.62a2.502 2.502 0 0 1-1.07-2.32c.1-.91.71-1.68 1.57-2L46.9 3.49c.6-.21 1.27-.07 1.72.37.47.44.63 1.11.4 1.71L37.75 40.72c-.22.73-.76 1.3-1.48 1.56a2.404 2.404 0 0 1-2.11-.24l-8.92-5.63-5.13 6.84-.03.03c-.03.02-.06.03-.08.05-.3.47-.81.75-1.37.75-.02.01-.03.01-.04.01zM47.46 3.65c-.16 0-.32.03-.47.08L3.62 19.15c-.78.29-1.32.98-1.41 1.8-.09.81.28 1.63.96 2.08l10.43 6.64c.03.02.04.04.05.07l3.58 13.11c.19.6.74.99 1.37.99h.03c.48 0 .92-.25 1.18-.67.01-.02.04-.04.07-.05.02-.01.04-.01.05-.02l5.18-6.92c.04-.05.11-.06.17-.03l9.02 5.69c.35.22.75.34 1.17.34a2.156 2.156 0 0 0 2.05-1.53L48.79 5.5c.19-.51.06-1.08-.34-1.45-.27-.26-.63-.4-.99-.4zM18.62 42.54c-.06 0-.11-.04-.12-.09l-3.57-13.11a.13.13 0 0 1 .05-.13L42.13 9.6c.05-.04.12-.03.17.02.04.05.04.12 0 .17L21.23 32.72a.4.4 0 0 0-.07.13c-.03.05-.04.07-.05.1l-2.37 9.48c-.01.07-.06.1-.12.11zM15.2 29.35l3.42 12.56 2.25-9.03c.02-.05.03-.1.07-.15.01-.04.05-.12.11-.19l20.23-22.02L15.2 29.35zm20.28 11.58c-.17 0-.34-.05-.49-.14l-12.16-7.68a.146.146 0 0 1-.06-.09c0-.04.01-.07.03-.1L46.78 6.86c.04-.04.1-.05.15-.02.05.03.07.09.06.15L36.33 40.3a.95.95 0 0 1-.54.57c-.1.04-.21.06-.31.06zM23.1 32.98l12.03 7.6c.17.11.39.13.57.06a.72.72 0 0 0 .4-.42L46.58 7.44 23.1 32.98zm13.11 7.28zM2.33 39.7c-.38 0-.74-.27-.85-.63-.12-.37.02-.77.33-1l3.85-2.81c.42-.3.96-.22 1.26.2.14.2.2.44.16.68-.04.24-.17.44-.36.58l-3.86 2.81c-.15.11-.34.17-.53.17zm3.87-4.38c-.13 0-.27.04-.39.13l-3.85 2.81a.66.66 0 0 0-.24.73c.08.26.34.45.61.45.14 0 .27-.04.38-.12l3.86-2.81c.14-.1.24-.25.26-.42a.62.62 0 0 0-.12-.49.611.611 0 0 0-.51-.28zm14.74 4.13c-.02 0-.04 0-.05-.01-.05-.03-.08-.08-.07-.14l1.25-4.99c.01-.04.04-.07.08-.09.04-.01.08-.01.11.01l1.72 1.14c.03.02.05.05.05.08s0 .07-.02.1l-2.96 3.85a.16.16 0 0 1-.11.05zm1.32-4.91-1.06 4.23 2.51-3.27-1.45-.96zm-13.29.29a.91.91 0 0 1-.73-.37c-.29-.42-.2-.98.2-1.26l1.92-1.41c.41-.29.96-.2 1.26.2.29.42.2.98-.2 1.26L9.5 34.67c-.02.01-.03.02-.05.02-.15.1-.32.14-.48.14zm1.92-2.96c-.13 0-.27.04-.38.12L8.59 33.4a.652.652 0 0 0 .77 1.05c.01-.01.03-.02.04-.02l1.88-1.39c.29-.21.35-.61.14-.91a.698.698 0 0 0-.53-.26zm3.1-3.53c-.02 0-.05-.01-.07-.02L3.91 21.93a.87.87 0 0 1-.46-.85c.04-.35.27-.63.59-.75l40.5-14.37c.06-.02.12.01.15.06.03.06.01.12-.04.16L14.07 28.32c-.03.01-.05.02-.08.02zM43.81 6.5 4.12 20.57c-.23.08-.39.29-.42.54-.02.25.11.49.33.6 0 0 .01 0 .01.01l9.95 6.35L43.81 6.5z" }, null, -1)
    ])));
  }
}), Uu = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.2071 3.75714C20.1834 2.78082 21.7663 2.78082 22.7426 3.75714C23.7189 4.73345 23.7189 6.31636 22.7426 7.29267L18.1464 11.8889C18.0661 11.9691 17.9609 12.0197 17.8481 12.0323L14.6661 12.3858C14.5151 12.4026 14.3647 12.3498 14.2573 12.2424C14.1499 12.135 14.0972 11.9846 14.114 11.8336L14.4675 8.65167C14.48 8.53883 14.5306 8.43361 14.6109 8.35333L19.2071 3.75714ZM22.0355 4.46424C21.4497 3.87846 20.5 3.87846 19.9142 4.46424L15.442 8.93642L15.1769 11.3229L17.5633 11.0577L22.0355 6.58556C22.6213 5.99978 22.6213 5.05003 22.0355 4.46424ZM6 10.5002C6 10.224 6.22386 10.0002 6.5 10.0002H12.5C12.7761 10.0002 13 10.224 13 10.5002C13 10.7763 12.7761 11.0002 12.5 11.0002H6.5C6.22386 11.0002 6 10.7763 6 10.5002ZM6.5 12.0002C6.22386 12.0002 6 12.224 6 12.5002C6 12.7763 6.22386 13.0002 6.5 13.0002H10.5C10.7761 13.0002 11 12.7763 11 12.5002C11 12.224 10.7761 12.0002 10.5 12.0002H6.5ZM6 14.5002C6 14.224 6.22386 14.0002 6.5 14.0002H14.5C14.7761 14.0002 15 14.224 15 14.5002C15 14.7763 14.7761 15.0002 14.5 15.0002H6.5C6.22386 15.0002 6 14.7763 6 14.5002ZM12 5C6.91282 5 3 8.23771 3 12C3 14.1975 4.31462 16.2001 6.44322 17.5031C6.47383 17.4997 6.5052 17.499 6.53705 17.5014C6.81243 17.5219 7.01906 17.7617 6.99856 18.0371L6.99683 18.0594C7.00527 18.133 6.99746 18.209 6.97182 18.2817C6.85809 19.0826 6.4887 19.9902 6.15986 20.6863C6.08886 20.8366 6.01845 20.9797 5.95098 21.1129C6.21121 21.0482 6.50173 20.9664 6.79969 20.8649C7.29127 20.6973 7.7866 20.4815 8.19648 20.2113C8.60951 19.9389 8.8997 19.6351 9.03955 19.305C9.07867 19.2126 9.14229 19.1381 9.21965 19.0859C9.30823 18.8687 9.54086 18.7375 9.77957 18.7848C10.4892 18.9252 11.2331 19 12 19C17.0872 19 21 15.7623 21 12C21 11.689 20.9739 11.3831 20.9233 11.0832C20.8773 10.8109 21.0608 10.5529 21.3331 10.507C21.6054 10.461 21.8634 10.6445 21.9093 10.9168C21.9691 11.2712 22 11.6328 22 12C22 16.522 17.4062 20 12 20C11.2806 20 10.5783 19.9393 9.90108 19.8239C9.64449 20.3403 9.21199 20.7395 8.74699 21.0461C8.24088 21.3798 7.65937 21.6283 7.12228 21.8114C6.58265 21.9953 6.07112 22.1187 5.69574 22.1962C5.5075 22.235 5.35213 22.2626 5.24288 22.2805C5.18822 22.2895 5.14502 22.2961 5.11492 22.3006L5.07976 22.3056L5.06992 22.307L5.067 22.3074L5.06605 22.3075L5.0657 22.3076C5.06557 22.3076 5.06544 22.3076 4.99994 21.8119L5.06544 22.3076C4.87495 22.3328 4.68689 22.2465 4.58163 22.0858C4.4764 21.9251 4.47256 21.7183 4.57175 21.5537L4.57179 21.5537L4.57228 21.5528L4.57473 21.5488L4.58526 21.531C4.59471 21.5151 4.60889 21.491 4.62717 21.4594C4.66372 21.3963 4.71657 21.3037 4.78057 21.1876C4.90877 20.9549 5.0807 20.6296 5.25567 20.2592C5.54486 19.647 5.82026 18.9568 5.94199 18.3687C3.57838 16.9285 2 14.6336 2 12C2 7.47802 6.59377 4 12 4C12.714 4 13.411 4.05975 14.0834 4.1735C14.4384 4.23356 14.7867 4.30868 15.127 4.39803C15.3941 4.46815 15.5537 4.74152 15.4836 5.00861C15.4135 5.2757 15.1401 5.43537 14.873 5.36525C14.5616 5.28349 14.2425 5.21462 13.9166 5.15949C13.2994 5.05508 12.6582 5 12 5Z",
  fill: "currentColor"
}, Hj = /* @__PURE__ */ J({
  __name: "feedback",
  setup(t) {
    return (e, a) => (m(), C("path", Uu));
  }
}), Yu = {
  fill: "currentColor",
  d: "M4.146 2.146A.5.5 0 0 1 4.5 2h9A1.5 1.5 0 0 1 15 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5v-7a.5.5 0 0 1 .146-.354l3-3ZM13.5 3H5v2.5a.5.5 0 0 1-.5.5H2v6.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5ZM2.707 5H4V3.707L2.707 5ZM3.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4ZM7.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4Zm-1 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z"
}, jj = /* @__PURE__ */ J({
  __name: "barcode",
  setup(t) {
    return (e, a) => (m(), C("path", Yu));
  }
}), Wu = {
  fill: "currentColor",
  d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v8A1.5 1.5 0 0 0 2.5 13H5v1.5A1.5 1.5 0 0 0 6.5 16h7a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 3H11V1.5A1.5 1.5 0 0 0 9.5 0h-5ZM10 3H8.5a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 5 6.5V12H2.5a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1h4.5a.5.5 0 0 1 .5.5V3Zm-4 9.5V7h2.5a.5.5 0 0 0 .5-.5V4h4.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2ZM4 3H2.707L4 1.707V3Zm4 3H6.707L8 4.707V6Z"
}, Ku = /* @__PURE__ */ J({
  __name: "copy",
  setup(t) {
    return (e, a) => (m(), C("path", Wu));
  }
}), Gu = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, Lj = /* @__PURE__ */ J({
  __name: "close",
  setup(t) {
    return (e, a) => (m(), C("path", Gu));
  }
}), Xu = { transform: "matrix(0.81815, 0, 0, 0.81815, -1.091412, -1.6363)" }, xj = /* @__PURE__ */ J({
  __name: "support-24",
  setup(t) {
    return (e, a) => (m(), C("g", Xu, a[0] || (a[0] = [
      g("path", {
        fill: "currentColor",
        d: "M5.333 14c-1.473 0-2.667 1.194-2.667 2.667v1.333c0 1.473 1.194 2.667 2.667 2.667h0.667c0.368 0 0.667-0.299 0.667-0.667v-5.333c0-0.368-0.298-0.667-0.667-0.667h-0.667zM5.35 12.667c0.3-5.898 4.563-10.667 10.65-10.667s10.35 4.769 10.65 10.667h0.017c2.209 0 4 1.791 4 4v1.333c0 2.209-1.791 4-4 4 0 3.314-2.686 6-6 6h-1.4c-0.309 1.521-1.654 2.667-3.267 2.667-1.841 0-3.333-1.492-3.333-3.333s1.492-3.333 3.333-3.333c1.613 0 2.958 1.145 3.267 2.667h1.4c2.577 0 4.667-2.089 4.667-4.667v-0.114c-0.777-0.275-1.333-1.015-1.333-1.886v-5.333c0-0.866 0.551-1.604 1.321-1.882-0.244-5.319-4.034-9.452-9.321-9.452s-9.077 4.132-9.321 9.452c0.77 0.278 1.321 1.016 1.321 1.882v5.333c0 1.105-0.895 2-2 2h-0.667c-2.209 0-4-1.791-4-4v-1.333c0-2.209 1.791-4 4-4h0.017zM18 27.333c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2s2-0.895 2-2zM26.667 20.667c1.473 0 2.667-1.194 2.667-2.667v-1.333c0-1.473-1.194-2.667-2.667-2.667h-0.667c-0.368 0-0.667 0.299-0.667 0.667v5.333c0 0.368 0.299 0.667 0.667 0.667h0.667z"
      }, null, -1)
    ])));
  }
}), Qu = {
  fill: "currentColor",
  d: "M2.5 5A1.5 1.5 0 0 0 1 6.5V19a1.5 1.5 0 0 0 1.5 1.5h19A1.5 1.5 0 0 0 23 19V6.5A1.5 1.5 0 0 0 21.5 5h-19ZM2 6.625l9.1 6.825a1.5 1.5 0 0 0 1.8 0L22 6.625V18.76l-5.131-5.598a.5.5 0 0 0-.738.676l5.19 5.662H2.679l5.19-5.662a.5.5 0 0 0-.737-.676L2 18.76V6.625ZM21.167 6 12.3 12.65a.5.5 0 0 1-.6 0L2.833 6h18.334Z"
}, $j = /* @__PURE__ */ J({
  __name: "envelope-24",
  setup(t) {
    return (e, a) => (m(), C("path", Qu));
  }
}), Mj = /* @__PURE__ */ J({
  __name: "refresh",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("mask", {
        id: "mask0_36639_33301",
        style: { "mask-type": "alpha" },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }, [
        g("rect", {
          width: "24",
          height: "24",
          fill: "#D9D9D9"
        })
      ], -1)),
      a[1] || (a[1] = g("g", { mask: "url(#mask0_36639_33301)" }, [
        g("path", {
          d: "M12.0499 19.5C9.95755 19.5 8.17614 18.7698 6.70564 17.3095C5.23514 15.8493 4.49989 14.0795 4.49989 12V10.6135L2.39989 12.7135L1.69214 12.0058L4.99989 8.698L8.30764 12.0058L7.59989 12.7135L5.49989 10.6135V12C5.49989 13.8077 6.13547 15.3429 7.40664 16.6058C8.67781 17.8686 10.2256 18.5 12.0499 18.5C12.4447 18.5 12.8473 18.4596 13.2576 18.3788C13.6678 18.2981 14.0665 18.177 14.4536 18.0155L15.2036 18.7655C14.7115 19.0038 14.1993 19.1858 13.6671 19.3115C13.1351 19.4372 12.5961 19.5 12.0499 19.5ZM18.9999 15.302L15.6921 11.9942L16.3999 11.2865L18.4999 13.3865V12C18.4999 10.1923 17.8643 8.65708 16.5931 7.39425C15.322 6.13142 13.7742 5.5 11.9499 5.5C11.5551 5.5 11.1525 5.54042 10.7421 5.62125C10.332 5.70192 9.93331 5.823 9.54614 5.9845L8.79614 5.2345C9.28831 4.99617 9.80047 4.81417 10.3326 4.6885C10.8646 4.56283 11.4037 4.5 11.9499 4.5C14.0422 4.5 15.8236 5.23017 17.2941 6.6905C18.7646 8.15067 19.4999 9.9205 19.4999 12V13.3865L21.5999 11.2865L22.3076 11.9942L18.9999 15.302Z",
          fill: "#1C1B1F"
        })
      ], -1))
    ], 64));
  }
}), Vj = /* @__PURE__ */ J({
  __name: "carrier-truck-48",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("circle", {
        fill: "none",
        cx: "10",
        cy: "35",
        r: "4",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[1] || (a[1] = g("circle", {
        fill: "none",
        cx: "37",
        cy: "35",
        r: "4",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        fill: "none",
        d: "M6 35H3C1.89543 35 1 34.1046 1 33V11C1 9.89543 1.89543 9 3 9H28C29.1046 9 30 9.89543 30 11V35H14",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        fill: "none",
        d: "M33 35H30V15C30 13.8954 30.8954 13 32 13H36.7639C37.5215 13 38.214 13.428 38.5528 14.1056L44 25L45.6325 25.5442C46.4491 25.8164 47 26.5807 47 27.4415V33C47 34.1046 46.1046 35 45 35H41",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        fill: "none",
        d: "M40 18H35C34.4477 18 34 18.4477 34 19V24C34 24.5523 34.4477 25 35 25H44",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[5] || (a[5] = g("path", {
        fill: "none",
        d: "M9.58094 26.2681L15.0809 28.8066C15.3468 28.9293 15.6532 28.9293 15.9191 28.8066L21.4191 26.2681C21.7732 26.1047 22 25.7502 22 25.3602V17.6398C22 17.2498 21.7732 16.8953 21.4191 16.7319L15.9191 14.1934C15.6532 14.0707 15.3468 14.0707 15.0809 14.1934L9.58094 16.7319C9.22679 16.8953 9 17.2498 9 17.6398V25.3602C9 25.7502 9.22679 26.1047 9.58094 26.2681Z",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[6] || (a[6] = g("path", {
        fill: "none",
        d: "M9 17L15.0809 19.8066C15.3468 19.9293 15.6532 19.9293 15.9191 19.8066L22 17",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[7] || (a[7] = g("path", {
        fill: "none",
        d: "M15.5 20V29",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }, null, -1)),
      a[8] || (a[8] = g("path", {
        fill: "none",
        d: "M12.5 15.5L18.4191 18.2319C18.7732 18.3953 19 18.7498 19 19.1398V21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1))
    ], 64));
  }
}), Ju = {
  fill: "currentColor",
  d: "M14.217 1.282a3 3 0 0 0-4.242 0l-.06.06a1.5 1.5 0 0 0-1.708.294l-.707.707a1.5 1.5 0 0 0-.293 1.708L1.843 9.414a.5.5 0 0 0-.133.241L.649 14.252a.5.5 0 0 0 .6.6l4.596-1.062a.5.5 0 0 0 .24-.133l5.365-5.364A1.5 1.5 0 0 0 13.157 8l.707-.707a1.5 1.5 0 0 0 .293-1.708l.06-.06a3 3 0 0 0 0-4.243Zm-.707 3.536L10.682 1.99a2 2 0 0 1 2.828 2.828Zm-2.828 2.828-4.95 4.95-2.828-2.828 4.95-4.95 2.828 2.828Zm-8.879 6.05.678-2.937 2.26 2.26-2.938.678ZM8.914 2.344a.5.5 0 0 1 .707 0l3.536 3.536a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L8.207 3.757a.5.5 0 0 1 0-.707l.707-.707Z"
}, e5 = /* @__PURE__ */ J({
  __name: "edit",
  setup(t) {
    return (e, a) => (m(), C("path", Ju));
  }
}), t5 = {
  d: "M2.667 4.667c0-1.105 0.895-2 2-2h20c1.105 0 2 0.895 2 2v1.333c0 0.871-0.557 1.612-1.333 1.886v7.447c0 0.368-0.299 0.667-0.667 0.667s-0.667-0.299-0.667-0.667v-7.333h-18.667v12.667c0 0.368 0.298 0.667 0.667 0.667h2.667c0.368 0 0.667 0.299 0.667 0.667s-0.298 0.667-0.667 0.667h-2.667c-1.105 0-2-0.895-2-2v-12.78c-0.777-0.275-1.333-1.015-1.333-1.886v-1.333zM4.667 4c-0.368 0-0.667 0.298-0.667 0.667v1.333c0 0.368 0.298 0.667 0.667 0.667h20c0.368 0 0.667-0.298 0.667-0.667v-1.333c0-0.368-0.299-0.667-0.667-0.667h-20zM12.667 12c-0.368 0-0.667 0.298-0.667 0.667s0.298 0.667 0.667 0.667h4c0.368 0 0.667-0.298 0.667-0.667s-0.299-0.667-0.667-0.667h-4zM10.667 12.667c0-1.105 0.895-2 2-2h4c1.105 0 2 0.895 2 2s-0.895 2-2 2h-4c-1.105 0-2-0.895-2-2zM12 19.333c0-1.105 0.895-2 2-2h13.333c1.105 0 2 0.895 2 2v8c0 1.105-0.895 2-2 2h-13.333c-1.105 0-2-0.895-2-2v-8zM14.386 18.667l5.858 4.793c0.246 0.201 0.599 0.201 0.844 0l5.858-4.793h-12.561zM28 19.528l-6.067 4.964c-0.737 0.603-1.796 0.603-2.533 0l-6.067-4.964v7.805c0 0.368 0.299 0.667 0.667 0.667h13.333c0.368 0 0.667-0.299 0.667-0.667v-7.805z",
  fill: "currentColor"
}, Sj = /* @__PURE__ */ J({
  __name: "packaging",
  setup(t) {
    return (e, a) => (m(), C("path", t5));
  }
}), Aj = /* @__PURE__ */ J({
  __name: "refresh-plus",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        d: "M11.875 9.86356L13.5 8.5L14.8636 10.125",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M4.12503 7.13644L2.5 8.5L1.13644 6.87497",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M2.5 8.5C2.5 5.46243 4.96243 3 8 3C9.93078 3 11.6292 3.9949 12.6105 5.5",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        d: "M13.4999 8.5C13.4999 11.5376 11.0375 14 7.99994 14C6.06916 14 4.37075 13.0051 3.3894 11.5",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        d: "M5.5 8.5H10.5M8 6V11",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), a5 = {
  fill: "currentColor",
  d: "M16.121 9.293 10.414 15H43.25V9H16.828a1 1 0 0 0-.707.293ZM44.75 15H64a1 1 0 1 1 0 2H9v24h70V17h-7a1 1 0 1 1 0-2h5.586l-5.707-5.707A1 1 0 0 0 71.172 9H44.75v6ZM34 43a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm-2.83 0H9v31a1 1 0 0 0 1 1h68a1 1 0 0 0 1-1V43H40.83c.11.313.17.65.17 1v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4c0-.35.06-.687.17-1ZM4 41h3V16a1 1 0 0 1 .293-.707l7.414-7.414A3 3 0 0 1 16.828 7h54.344a3 3 0 0 1 2.12.879l7.415 7.414A1 1 0 0 1 81 16v25h3a1 1 0 1 1 0 2h-3v31a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V43H4a1 1 0 1 1 0-2Zm29-13a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H36a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H36ZM5 71a1 1 0 1 0-2 0v7a3 3 0 0 0 3 3h7a1 1 0 1 0 0-2H6a1 1 0 0 1-1-1v-7Zm78 0a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3h-7a1 1 0 1 1 0-2h7a1 1 0 0 0 1-1v-7ZM31 60a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm13 1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm-5-14a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm5 2a1 1 0 0 0-1 1v4h-5a1 1 0 0 0-1 1v9a1 1 0 1 0 2 0v-8h5a1 1 0 0 0 1-1v-4h4v2a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1h-6Zm-17 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
}, Ej = /* @__PURE__ */ J({
  __name: "signin",
  setup(t) {
    return (e, a) => (m(), C("path", a5));
  }
}), Dj = /* @__PURE__ */ J({
  __name: "fulfilment-24",
  setup(t) {
    return (e, a) => (m(), C(ge, null, [
      a[0] || (a[0] = g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.6286 1.23962C12.2297 1.05554 11.7703 1.05554 11.3714 1.23962L5.87141 3.77808C5.34019 4.02327 5 4.55495 5 5.14002V12.8604C5 13.4454 5.34019 13.9771 5.87141 14.2223L11.3714 16.7608C11.7703 16.9448 12.2297 16.9448 12.6286 16.7608L18.1286 14.2223C18.6598 13.9771 19 13.4454 19 12.8604V5.14002C19 4.55495 18.6598 4.02327 18.1286 3.77808L12.6286 1.23962ZM11.7905 2.14758C11.9234 2.08622 12.0766 2.08622 12.2095 2.14758L17.3069 4.50022L15.3493 5.40371C15.2802 5.35621 15.2064 5.31413 15.1286 5.2782L10.068 2.94256L11.7905 2.14758ZM8.87488 3.49324L6.6931 4.50022L11.7905 6.85285C11.9234 6.91421 12.0766 6.91421 12.2095 6.85285L14.1818 5.94258L8.87488 3.49324ZM15 6.66631L12.6286 7.76081C12.5864 7.7803 12.5434 7.79773 12.5 7.81309V15.7187L17.7095 13.3143C17.8866 13.2326 18 13.0554 18 12.8604V5.2817L15.9432 6.231C15.9804 6.36214 16 6.4996 16 6.64014V8.5003C16 8.77645 15.7761 9.0003 15.5 9.0003C15.2239 9.0003 15 8.77645 15 8.5003V6.66631ZM6 5.2817V12.8604C6 13.0554 6.1134 13.2326 6.29047 13.3143L11.5 15.7187V7.81309C11.4566 7.79773 11.4136 7.7803 11.3714 7.76081L6 5.2817Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[1] || (a[1] = g("path", {
        d: "M0.5 8C0.223858 8 0 8.22386 0 8.5C0 8.77614 0.223858 9 0.5 9V8ZM4.5 9H5V8H4.5V9ZM0.5 9H4.5V8H0.5V9Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[2] || (a[2] = g("path", {
        d: "M19.5 8H19V9H19.5V8ZM22.5 9C22.7761 9 23 8.77614 23 8.5C23 8.22386 22.7761 8 22.5 8V9ZM19.5 9H22.5V8H19.5V9Z",
        fill: "#FF8C00"
      }, null, -1)),
      a[3] || (a[3] = g("path", {
        fill: "none",
        d: "M0.5 18.5H22.5",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[4] || (a[4] = g("path", {
        fill: "none",
        d: "M2.5 21.5C2.5 22.0523 2.05228 22.5 1.5 22.5C0.947715 22.5 0.5 22.0523 0.5 21.5C0.5 20.9477 0.947715 20.5 1.5 20.5C2.05228 20.5 2.5 20.9477 2.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[5] || (a[5] = g("path", {
        fill: "none",
        d: "M6.5 21.5C6.5 22.0523 6.05228 22.5 5.5 22.5C4.94772 22.5 4.5 22.0523 4.5 21.5C4.5 20.9477 4.94772 20.5 5.5 20.5C6.05228 20.5 6.5 20.9477 6.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[6] || (a[6] = g("path", {
        fill: "none",
        d: "M10.5 21.5C10.5 22.0523 10.0523 22.5 9.5 22.5C8.94772 22.5 8.5 22.0523 8.5 21.5C8.5 20.9477 8.94772 20.5 9.5 20.5C10.0523 20.5 10.5 20.9477 10.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[7] || (a[7] = g("path", {
        fill: "none",
        d: "M14.5 21.5C14.5 22.0523 14.0523 22.5 13.5 22.5C12.9477 22.5 12.5 22.0523 12.5 21.5C12.5 20.9477 12.9477 20.5 13.5 20.5C14.0523 20.5 14.5 20.9477 14.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[8] || (a[8] = g("path", {
        fill: "none",
        d: "M18.5 21.5C18.5 22.0523 18.0523 22.5 17.5 22.5C16.9477 22.5 16.5 22.0523 16.5 21.5C16.5 20.9477 16.9477 20.5 17.5 20.5C18.0523 20.5 18.5 20.9477 18.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)),
      a[9] || (a[9] = g("path", {
        fill: "none",
        d: "M22.5 21.5C22.5 22.0523 22.0523 22.5 21.5 22.5C20.9477 22.5 20.5 22.0523 20.5 21.5C20.5 20.9477 20.9477 20.5 21.5 20.5C22.0523 20.5 22.5 20.9477 22.5 21.5Z",
        stroke: "#FF8C00",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1))
    ], 64));
  }
}), o5 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pj = /* @__PURE__ */ J({
  __name: "picklist",
  setup(t) {
    return (e, a) => (m(), C("svg", o5, a[0] || (a[0] = [
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.14645 0.146447C4.24021 0.0526784 4.36739 0 4.5 0H12.5C13.3284 0 14 0.671573 14 1.5V14.5C14 15.3284 13.3284 16 12.5 16H2.5C1.67157 16 1 15.3284 1 14.5V3.5C1 3.36739 1.05268 3.24021 1.14645 3.14645L4.14645 0.146447ZM12.5 1H5V3.5C5 3.77614 4.77614 4 4.5 4H2V14.5C2 14.7761 2.22386 15 2.5 15H12.5C12.7761 15 13 14.7761 13 14.5V1.5C13 1.22386 12.7761 1 12.5 1ZM2.70711 3H4V1.70711L2.70711 3ZM6.85355 6.14645C7.04882 6.34171 7.04882 6.65829 6.85355 6.85355L4.85355 8.85355C4.65829 9.04882 4.34171 9.04882 4.14645 8.85355L3.14645 7.85355C2.95118 7.65829 2.95118 7.34171 3.14645 7.14645C3.34171 6.95118 3.65829 6.95118 3.85355 7.14645L4.5 7.79289L6.14645 6.14645C6.34171 5.95118 6.65829 5.95118 6.85355 6.14645ZM8 7.5C8 7.22386 8.22386 7 8.5 7H8.50686H8.51371H8.52054H8.52737H8.53418H8.54098H8.54777H8.55454H8.56131H8.56807H8.57481H8.58154H8.58826H8.59497H8.60167H8.60836H8.61504H8.6217H8.62836H8.635H8.64163H8.64825H8.65486H8.66147H8.66806H8.67463H8.6812H8.68776H8.69431H8.70085H8.70737H8.71389H8.7204H8.72689H8.73338H8.73985H8.74632H8.75277H8.75922H8.76565H8.77208H8.77849H8.7849H8.7913H8.79768H8.80406H8.81042H8.81678H8.82313H8.82947H8.8358H8.84211H8.84842H8.85472H8.86101H8.8673H8.87357H8.87983H8.88609H8.89233H8.89857H8.9048H8.91101H8.91722H8.92342H8.92962H8.9358H8.94197H8.94814H8.9543H8.96044H8.96658H8.97272H8.97884H8.98495H8.99106H8.99716H9.00325H9.00933H9.0154H9.02147H9.02753H9.03358H9.03962H9.04565H9.05168H9.05769H9.0637H9.06971H9.0757H9.08169H9.08767H9.09364H9.0996H9.10556H9.11151H9.11745H9.12339H9.12931H9.13523H9.14115H9.14705H9.15295H9.15884H9.16473H9.17061H9.17648H9.18234H9.1882H9.19405H9.19989H9.20573H9.21156H9.21738H9.2232H9.22901H9.23482H9.24062H9.24641H9.25219H9.25797H9.26375H9.26951H9.27527H9.28103H9.28678H9.29252H9.29825H9.30399H9.30971H9.31543H9.32114H9.32685H9.33255H9.33825H9.34394H9.34963H9.3553H9.36098H9.36665H9.37231H9.37797H9.38362H9.38927H9.39491H9.40055H9.40619H9.41181H9.41743H9.42305H9.42867H9.43427H9.43988H9.44548H9.45107H9.45666H9.46224H9.46782H9.4734H9.47897H9.48454H9.4901H9.49566H9.50121H9.50676H9.5123H9.51785H9.52338H9.52891H9.53444H9.53997H9.54549H9.55101H9.55652H9.56203H9.56754H9.57304H9.57854H9.58403H9.58952H9.59501H9.60049H9.60598H9.61145H9.61693H9.6224H9.62787H9.63333H9.63879H9.64425H9.64971H9.65516H9.66061H9.66606H9.6715H9.67694H9.68238H9.68781H9.69325H9.69868H9.7041H9.70953H9.71495H9.72037H9.72579H9.7312H9.73662H9.74203H9.74744H9.75284H9.75825H9.76365H9.76905H9.77445H9.77985H9.78524H9.79063H9.79602H9.80141H9.8068H9.81219H9.81757H9.82295H9.82833H9.83371H9.83909H9.84447H9.84984H9.85522H9.86059H9.86596H9.87133H9.8767H9.88207H9.88744H9.8928H9.89817H9.90353H9.9089H9.91426H9.91962H9.92498H9.93035H9.93571H9.94107H9.94643H9.95178H9.95714H9.9625H9.96786H9.97322H9.97857H9.98393H9.98929H9.99464H10H10.0054H10.0107H10.0161H10.0214H10.0268H10.0321H10.0375H10.0429H10.0482H10.0536H10.0589H10.0643H10.0697H10.075H10.0804H10.0857H10.0911H10.0965H10.1018H10.1072H10.1126H10.1179H10.1233H10.1287H10.134H10.1394H10.1448H10.1502H10.1555H10.1609H10.1663H10.1717H10.177H10.1824H10.1878H10.1932H10.1986H10.204H10.2094H10.2148H10.2202H10.2256H10.2309H10.2363H10.2418H10.2472H10.2526H10.258H10.2634H10.2688H10.2742H10.2796H10.285H10.2905H10.2959H10.3013H10.3068H10.3122H10.3176H10.3231H10.3285H10.3339H10.3394H10.3448H10.3503H10.3557H10.3612H10.3667H10.3721H10.3776H10.3831H10.3885H10.394H10.3995H10.405H10.4105H10.416H10.4215H10.427H10.4325H10.438H10.4435H10.449H10.4545H10.46H10.4656H10.4711H10.4766H10.4822H10.4877H10.4932H10.4988H10.5043H10.5099H10.5155H10.521H10.5266H10.5322H10.5378H10.5433H10.5489H10.5545H10.5601H10.5657H10.5713H10.5769H10.5826H10.5882H10.5938H10.5994H10.6051H10.6107H10.6164H10.622H10.6277H10.6334H10.639H10.6447H10.6504H10.6561H10.6618H10.6674H10.6731H10.6789H10.6846H10.6903H10.696H10.7017H10.7075H10.7132H10.719H10.7247H10.7305H10.7363H10.742H10.7478H10.7536H10.7594H10.7652H10.771H10.7768H10.7826H10.7884H10.7943H10.8001H10.806H10.8118H10.8177H10.8235H10.8294H10.8353H10.8412H10.847H10.8529H10.8589H10.8648H10.8707H10.8766H10.8825H10.8885H10.8944H10.9004H10.9064H10.9123H10.9183H10.9243H10.9303H10.9363H10.9423H10.9483H10.9544H10.9604H10.9664H10.9725H10.9785H10.9846H10.9907H10.9968H11.0028H11.0089H11.015H11.0212H11.0273H11.0334H11.0396H11.0457H11.0519H11.058H11.0642H11.0704H11.0766H11.0828H11.089H11.0952H11.1014H11.1077H11.1139H11.1202H11.1264H11.1327H11.139H11.1453H11.1516H11.1579H11.1642H11.1705H11.1769H11.1832H11.1896H11.1959H11.2023H11.2087H11.2151H11.2215H11.2279H11.2343H11.2408H11.2472H11.2537H11.2601H11.2666H11.2731H11.2796H11.2861H11.2926H11.2992H11.3057H11.3122H11.3188H11.3254H11.3319H11.3385H11.3451H11.3517H11.3584H11.365H11.3716H11.3783H11.385H11.3916H11.3983H11.405H11.4117H11.4185H11.4252H11.4319H11.4387H11.4455H11.4522H11.459H11.4658H11.4726H11.4795H11.4863H11.4931H11.5C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8H11.4931H11.4863H11.4795H11.4726H11.4658H11.459H11.4522H11.4455H11.4387H11.4319H11.4252H11.4185H11.4117H11.405H11.3983H11.3916H11.385H11.3783H11.3716H11.365H11.3584H11.3517H11.3451H11.3385H11.3319H11.3254H11.3188H11.3122H11.3057H11.2992H11.2926H11.2861H11.2796H11.2731H11.2666H11.2601H11.2537H11.2472H11.2408H11.2343H11.2279H11.2215H11.2151H11.2087H11.2023H11.1959H11.1896H11.1832H11.1769H11.1705H11.1642H11.1579H11.1516H11.1453H11.139H11.1327H11.1264H11.1202H11.1139H11.1077H11.1014H11.0952H11.089H11.0828H11.0766H11.0704H11.0642H11.058H11.0519H11.0457H11.0396H11.0334H11.0273H11.0212H11.015H11.0089H11.0028H10.9968H10.9907H10.9846H10.9785H10.9725H10.9664H10.9604H10.9544H10.9483H10.9423H10.9363H10.9303H10.9243H10.9183H10.9123H10.9064H10.9004H10.8944H10.8885H10.8825H10.8766H10.8707H10.8648H10.8589H10.8529H10.847H10.8412H10.8353H10.8294H10.8235H10.8177H10.8118H10.806H10.8001H10.7943H10.7884H10.7826H10.7768H10.771H10.7652H10.7594H10.7536H10.7478H10.742H10.7363H10.7305H10.7247H10.719H10.7132H10.7075H10.7017H10.696H10.6903H10.6846H10.6789H10.6731H10.6674H10.6618H10.6561H10.6504H10.6447H10.639H10.6334H10.6277H10.622H10.6164H10.6107H10.6051H10.5994H10.5938H10.5882H10.5826H10.5769H10.5713H10.5657H10.5601H10.5545H10.5489H10.5433H10.5378H10.5322H10.5266H10.521H10.5155H10.5099H10.5043H10.4988H10.4932H10.4877H10.4822H10.4766H10.4711H10.4656H10.46H10.4545H10.449H10.4435H10.438H10.4325H10.427H10.4215H10.416H10.4105H10.405H10.3995H10.394H10.3885H10.3831H10.3776H10.3721H10.3667H10.3612H10.3557H10.3503H10.3448H10.3394H10.3339H10.3285H10.3231H10.3176H10.3122H10.3068H10.3013H10.2959H10.2905H10.285H10.2796H10.2742H10.2688H10.2634H10.258H10.2526H10.2472H10.2418H10.2363H10.2309H10.2256H10.2202H10.2148H10.2094H10.204H10.1986H10.1932H10.1878H10.1824H10.177H10.1717H10.1663H10.1609H10.1555H10.1502H10.1448H10.1394H10.134H10.1287H10.1233H10.1179H10.1126H10.1072H10.1018H10.0965H10.0911H10.0857H10.0804H10.075H10.0697H10.0643H10.0589H10.0536H10.0482H10.0429H10.0375H10.0321H10.0268H10.0214H10.0161H10.0107H10.0054H10H9.99464H9.98929H9.98393H9.97857H9.97322H9.96786H9.9625H9.95714H9.95178H9.94643H9.94107H9.93571H9.93035H9.92498H9.91962H9.91426H9.9089H9.90353H9.89817H9.8928H9.88744H9.88207H9.8767H9.87133H9.86596H9.86059H9.85522H9.84984H9.84447H9.83909H9.83371H9.82833H9.82295H9.81757H9.81219H9.8068H9.80141H9.79602H9.79063H9.78524H9.77985H9.77445H9.76905H9.76365H9.75825H9.75284H9.74744H9.74203H9.73662H9.7312H9.72579H9.72037H9.71495H9.70953H9.7041H9.69868H9.69325H9.68781H9.68238H9.67694H9.6715H9.66606H9.66061H9.65516H9.64971H9.64425H9.63879H9.63333H9.62787H9.6224H9.61693H9.61145H9.60598H9.60049H9.59501H9.58952H9.58403H9.57854H9.57304H9.56754H9.56203H9.55652H9.55101H9.54549H9.53997H9.53444H9.52891H9.52338H9.51785H9.5123H9.50676H9.50121H9.49566H9.4901H9.48454H9.47897H9.4734H9.46782H9.46224H9.45666H9.45107H9.44548H9.43988H9.43427H9.42867H9.42305H9.41743H9.41181H9.40619H9.40055H9.39491H9.38927H9.38362H9.37797H9.37231H9.36665H9.36098H9.3553H9.34963H9.34394H9.33825H9.33255H9.32685H9.32114H9.31543H9.30971H9.30399H9.29825H9.29252H9.28678H9.28103H9.27527H9.26951H9.26375H9.25797H9.25219H9.24641H9.24062H9.23482H9.22901H9.2232H9.21738H9.21156H9.20573H9.19989H9.19405H9.1882H9.18234H9.17648H9.17061H9.16473H9.15884H9.15295H9.14705H9.14115H9.13523H9.12931H9.12339H9.11745H9.11151H9.10556H9.0996H9.09364H9.08767H9.08169H9.0757H9.06971H9.0637H9.05769H9.05168H9.04565H9.03962H9.03358H9.02753H9.02147H9.0154H9.00933H9.00325H8.99716H8.99106H8.98495H8.97884H8.97272H8.96658H8.96044H8.9543H8.94814H8.94197H8.9358H8.92962H8.92342H8.91722H8.91101H8.9048H8.89857H8.89233H8.88609H8.87983H8.87357H8.8673H8.86101H8.85472H8.84842H8.84211H8.8358H8.82947H8.82313H8.81678H8.81042H8.80406H8.79768H8.7913H8.7849H8.77849H8.77208H8.76565H8.75922H8.75277H8.74632H8.73985H8.73338H8.72689H8.7204H8.71389H8.70737H8.70085H8.69431H8.68776H8.6812H8.67463H8.66806H8.66147H8.65486H8.64825H8.64163H8.635H8.62836H8.6217H8.61504H8.60836H8.60167H8.59497H8.58826H8.58154H8.57481H8.56807H8.56131H8.55454H8.54777H8.54098H8.53418H8.52737H8.52054H8.51371H8.50686H8.5C8.22386 8 8 7.77614 8 7.5ZM8.50686 11H8.5C8.22386 11 8 11.2239 8 11.5C8 11.7761 8.22386 12 8.5 12H8.50686H8.51371H8.52054H8.52737H8.53418H8.54098H8.54777H8.55454H8.56131H8.56807H8.57481H8.58154H8.58826H8.59497H8.60167H8.60836H8.61504H8.6217H8.62836H8.635H8.64163H8.64825H8.65486H8.66147H8.66806H8.67463H8.6812H8.68776H8.69431H8.70085H8.70737H8.71389H8.7204H8.72689H8.73338H8.73985H8.74632H8.75277H8.75922H8.76565H8.77208H8.77849H8.7849H8.7913H8.79768H8.80406H8.81042H8.81678H8.82313H8.82947H8.8358H8.84211H8.84842H8.85472H8.86101H8.8673H8.87357H8.87983H8.88609H8.89233H8.89857H8.9048H8.91101H8.91722H8.92342H8.92962H8.9358H8.94197H8.94814H8.9543H8.96044H8.96658H8.97272H8.97884H8.98495H8.99106H8.99716H9.00325H9.00933H9.0154H9.02147H9.02753H9.03358H9.03962H9.04565H9.05168H9.05769H9.0637H9.06971H9.0757H9.08169H9.08767H9.09364H9.0996H9.10556H9.11151H9.11745H9.12339H9.12931H9.13523H9.14115H9.14705H9.15295H9.15884H9.16473H9.17061H9.17648H9.18234H9.1882H9.19405H9.19989H9.20573H9.21156H9.21738H9.2232H9.22901H9.23482H9.24062H9.24641H9.25219H9.25797H9.26375H9.26951H9.27527H9.28103H9.28678H9.29252H9.29825H9.30399H9.30971H9.31543H9.32114H9.32685H9.33255H9.33825H9.34394H9.34963H9.3553H9.36098H9.36665H9.37231H9.37797H9.38362H9.38927H9.39491H9.40055H9.40619H9.41181H9.41743H9.42305H9.42867H9.43427H9.43988H9.44548H9.45107H9.45666H9.46224H9.46782H9.4734H9.47897H9.48454H9.4901H9.49566H9.50121H9.50676H9.5123H9.51785H9.52338H9.52891H9.53444H9.53997H9.54549H9.55101H9.55652H9.56203H9.56754H9.57304H9.57854H9.58403H9.58952H9.59501H9.60049H9.60598H9.61145H9.61693H9.6224H9.62787H9.63333H9.63879H9.64425H9.64971H9.65516H9.66061H9.66606H9.6715H9.67694H9.68238H9.68781H9.69325H9.69868H9.7041H9.70953H9.71495H9.72037H9.72579H9.7312H9.73662H9.74203H9.74744H9.75284H9.75825H9.76365H9.76905H9.77445H9.77985H9.78524H9.79063H9.79602H9.80141H9.8068H9.81219H9.81757H9.82295H9.82833H9.83371H9.83909H9.84447H9.84984H9.85522H9.86059H9.86596H9.87133H9.8767H9.88207H9.88744H9.8928H9.89817H9.90353H9.9089H9.91426H9.91962H9.92498H9.93035H9.93571H9.94107H9.94643H9.95178H9.95714H9.9625H9.96786H9.97322H9.97857H9.98393H9.98929H9.99464H10H10.0054H10.0107H10.0161H10.0214H10.0268H10.0321H10.0375H10.0429H10.0482H10.0536H10.0589H10.0643H10.0697H10.075H10.0804H10.0857H10.0911H10.0965H10.1018H10.1072H10.1126H10.1179H10.1233H10.1287H10.134H10.1394H10.1448H10.1502H10.1555H10.1609H10.1663H10.1717H10.177H10.1824H10.1878H10.1932H10.1986H10.204H10.2094H10.2148H10.2202H10.2256H10.2309H10.2363H10.2418H10.2472H10.2526H10.258H10.2634H10.2688H10.2742H10.2796H10.285H10.2905H10.2959H10.3013H10.3068H10.3122H10.3176H10.3231H10.3285H10.3339H10.3394H10.3448H10.3503H10.3557H10.3612H10.3667H10.3721H10.3776H10.3831H10.3885H10.394H10.3995H10.405H10.4105H10.416H10.4215H10.427H10.4325H10.438H10.4435H10.449H10.4545H10.46H10.4656H10.4711H10.4766H10.4822H10.4877H10.4932H10.4988H10.5043H10.5099H10.5155H10.521H10.5266H10.5322H10.5378H10.5433H10.5489H10.5545H10.5601H10.5657H10.5713H10.5769H10.5826H10.5882H10.5938H10.5994H10.6051H10.6107H10.6164H10.622H10.6277H10.6334H10.639H10.6447H10.6504H10.6561H10.6618H10.6674H10.6731H10.6789H10.6846H10.6903H10.696H10.7017H10.7075H10.7132H10.719H10.7247H10.7305H10.7363H10.742H10.7478H10.7536H10.7594H10.7652H10.771H10.7768H10.7826H10.7884H10.7943H10.8001H10.806H10.8118H10.8177H10.8235H10.8294H10.8353H10.8412H10.847H10.8529H10.8589H10.8648H10.8707H10.8766H10.8825H10.8885H10.8944H10.9004H10.9064H10.9123H10.9183H10.9243H10.9303H10.9363H10.9423H10.9483H10.9544H10.9604H10.9664H10.9725H10.9785H10.9846H10.9907H10.9968H11.0028H11.0089H11.015H11.0212H11.0273H11.0334H11.0396H11.0457H11.0519H11.058H11.0642H11.0704H11.0766H11.0828H11.089H11.0952H11.1014H11.1077H11.1139H11.1202H11.1264H11.1327H11.139H11.1453H11.1516H11.1579H11.1642H11.1705H11.1769H11.1832H11.1896H11.1959H11.2023H11.2087H11.2151H11.2215H11.2279H11.2343H11.2408H11.2472H11.2537H11.2601H11.2666H11.2731H11.2796H11.2861H11.2926H11.2992H11.3057H11.3122H11.3188H11.3254H11.3319H11.3385H11.3451H11.3517H11.3584H11.365H11.3716H11.3783H11.385H11.3916H11.3983H11.405H11.4117H11.4185H11.4252H11.4319H11.4387H11.4455H11.4522H11.459H11.4658H11.4726H11.4795H11.4863H11.4931H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H11.4931H11.4863H11.4795H11.4726H11.4658H11.459H11.4522H11.4455H11.4387H11.4319H11.4252H11.4185H11.4117H11.405H11.3983H11.3916H11.385H11.3783H11.3716H11.365H11.3584H11.3517H11.3451H11.3385H11.3319H11.3254H11.3188H11.3122H11.3057H11.2992H11.2926H11.2861H11.2796H11.2731H11.2666H11.2601H11.2537H11.2472H11.2408H11.2343H11.2279H11.2215H11.2151H11.2087H11.2023H11.1959H11.1896H11.1832H11.1769H11.1705H11.1642H11.1579H11.1516H11.1453H11.139H11.1327H11.1264H11.1202H11.1139H11.1077H11.1014H11.0952H11.089H11.0828H11.0766H11.0704H11.0642H11.058H11.0519H11.0457H11.0396H11.0334H11.0273H11.0212H11.015H11.0089H11.0028H10.9968H10.9907H10.9846H10.9785H10.9725H10.9664H10.9604H10.9544H10.9483H10.9423H10.9363H10.9303H10.9243H10.9183H10.9123H10.9064H10.9004H10.8944H10.8885H10.8825H10.8766H10.8707H10.8648H10.8589H10.8529H10.847H10.8412H10.8353H10.8294H10.8235H10.8177H10.8118H10.806H10.8001H10.7943H10.7884H10.7826H10.7768H10.771H10.7652H10.7594H10.7536H10.7478H10.742H10.7363H10.7305H10.7247H10.719H10.7132H10.7075H10.7017H10.696H10.6903H10.6846H10.6789H10.6731H10.6674H10.6618H10.6561H10.6504H10.6447H10.639H10.6334H10.6277H10.622H10.6164H10.6107H10.6051H10.5994H10.5938H10.5882H10.5826H10.5769H10.5713H10.5657H10.5601H10.5545H10.5489H10.5433H10.5378H10.5322H10.5266H10.521H10.5155H10.5099H10.5043H10.4988H10.4932H10.4877H10.4822H10.4766H10.4711H10.4656H10.46H10.4545H10.449H10.4435H10.438H10.4325H10.427H10.4215H10.416H10.4105H10.405H10.3995H10.394H10.3885H10.3831H10.3776H10.3721H10.3667H10.3612H10.3557H10.3503H10.3448H10.3394H10.3339H10.3285H10.3231H10.3176H10.3122H10.3068H10.3013H10.2959H10.2905H10.285H10.2796H10.2742H10.2688H10.2634H10.258H10.2526H10.2472H10.2418H10.2363H10.2309H10.2256H10.2202H10.2148H10.2094H10.204H10.1986H10.1932H10.1878H10.1824H10.177H10.1717H10.1663H10.1609H10.1555H10.1502H10.1448H10.1394H10.134H10.1287H10.1233H10.1179H10.1126H10.1072H10.1018H10.0965H10.0911H10.0857H10.0804H10.075H10.0697H10.0643H10.0589H10.0536H10.0482H10.0429H10.0375H10.0321H10.0268H10.0214H10.0161H10.0107H10.0054H10H9.99464H9.98929H9.98393H9.97857H9.97322H9.96786H9.9625H9.95714H9.95178H9.94643H9.94107H9.93571H9.93035H9.92498H9.91962H9.91426H9.9089H9.90353H9.89817H9.8928H9.88744H9.88207H9.8767H9.87133H9.86596H9.86059H9.85522H9.84984H9.84447H9.83909H9.83371H9.82833H9.82295H9.81757H9.81219H9.8068H9.80141H9.79602H9.79063H9.78524H9.77985H9.77445H9.76905H9.76365H9.75825H9.75284H9.74744H9.74203H9.73662H9.7312H9.72579H9.72037H9.71495H9.70953H9.7041H9.69868H9.69325H9.68781H9.68238H9.67694H9.6715H9.66606H9.66061H9.65516H9.64971H9.64425H9.63879H9.63333H9.62787H9.6224H9.61693H9.61145H9.60598H9.60049H9.59501H9.58952H9.58403H9.57854H9.57304H9.56754H9.56203H9.55652H9.55101H9.54549H9.53997H9.53444H9.52891H9.52338H9.51785H9.5123H9.50676H9.50121H9.49566H9.4901H9.48454H9.47897H9.4734H9.46782H9.46224H9.45666H9.45107H9.44548H9.43988H9.43427H9.42867H9.42305H9.41743H9.41181H9.40619H9.40055H9.39491H9.38927H9.38362H9.37797H9.37231H9.36665H9.36098H9.3553H9.34963H9.34394H9.33825H9.33255H9.32685H9.32114H9.31543H9.30971H9.30399H9.29825H9.29252H9.28678H9.28103H9.27527H9.26951H9.26375H9.25797H9.25219H9.24641H9.24062H9.23482H9.22901H9.2232H9.21738H9.21156H9.20573H9.19989H9.19405H9.1882H9.18234H9.17648H9.17061H9.16473H9.15884H9.15295H9.14705H9.14115H9.13523H9.12931H9.12339H9.11745H9.11151H9.10556H9.0996H9.09364H9.08767H9.08169H9.0757H9.06971H9.0637H9.05769H9.05168H9.04565H9.03962H9.03358H9.02753H9.02147H9.0154H9.00933H9.00325H8.99716H8.99106H8.98495H8.97884H8.97272H8.96658H8.96044H8.9543H8.94814H8.94197H8.9358H8.92962H8.92342H8.91722H8.91101H8.9048H8.89857H8.89233H8.88609H8.87983H8.87357H8.8673H8.86101H8.85472H8.84842H8.84211H8.8358H8.82947H8.82313H8.81678H8.81042H8.80406H8.79768H8.7913H8.7849H8.77849H8.77208H8.76565H8.75922H8.75277H8.74632H8.73985H8.73338H8.72689H8.7204H8.71389H8.70737H8.70085H8.69431H8.68776H8.6812H8.67463H8.66806H8.66147H8.65486H8.64825H8.64163H8.635H8.62836H8.6217H8.61504H8.60836H8.60167H8.59497H8.58826H8.58154H8.57481H8.56807H8.56131H8.55454H8.54777H8.54098H8.53418H8.52737H8.52054H8.51371H8.50686ZM6.85355 10.8536C7.04882 10.6583 7.04882 10.3417 6.85355 10.1464C6.65829 9.95118 6.34171 9.95118 6.14645 10.1464L4.5 11.7929L3.85355 11.1464C3.65829 10.9512 3.34171 10.9512 3.14645 11.1464C2.95118 11.3417 2.95118 11.6583 3.14645 11.8536L4.14645 12.8536C4.34171 13.0488 4.65829 13.0488 4.85355 12.8536L6.85355 10.8536Z",
        fill: "#0F5C47"
      }, null, -1)
    ])));
  }
}), se = (t, e) => {
  const a = t.__vccOpts || t;
  for (const [o, n] of e)
    a[o] = n;
  return a;
}, n5 = {}, r5 = {
  fill: "currentColor",
  d: "M24.65 2.24C12.1 2.24 1.89 12.45 1.89 25S12.1 47.76 24.65 47.76 47.41 37.55 47.41 25c.01-12.55-10.2-22.76-22.76-22.76zm-5.16 36.11c-3.26 0-6.43-.93-9.17-2.69a.765.765 0 0 1-.31-.9c.12-.33.45-.55.81-.5.41.05.84.07 1.27.07 1.8 0 3.53-.44 5.08-1.27a6.488 6.488 0 0 1-4.05-4.15.766.766 0 0 1 .36-.9 6.508 6.508 0 0 1-2.4-5.03v-.1c.01-.26.16-.5.39-.63.17-.1.37-.12.56-.08-.58-.98-.9-2.12-.9-3.3 0-1.15.3-2.28.88-3.26.13-.22.35-.36.6-.38.25-.03.49.09.65.28a15.55 15.55 0 0 0 10.29 5.62c-.01-.15-.02-.31-.02-.46 0-3.57 2.91-6.48 6.48-6.48 1.63 0 3.22.63 4.42 1.73 1.05-.25 2.06-.65 3-1.21.27-.16.62-.14.87.06s.35.53.25.83c-.17.54-.42 1.04-.71 1.51.15-.06.29-.12.44-.18.31-.14.68-.06.9.21.22.26.24.63.05.92-.74 1.12-1.65 2.09-2.71 2.91v.37c-.01 8.35-6.38 17.01-17.03 17.01zm-5.67-2.61c1.79.71 3.71 1.07 5.67 1.07 9.7 0 15.49-7.88 15.49-15.49 0-.24-.01-.47-.02-.71-.01-.26.11-.5.32-.65.35-.25.68-.52 1-.81-.3.06-.6.1-.9.14-.38.04-.7-.17-.81-.51-.12-.34.02-.72.33-.9.37-.22.7-.49 1-.79-.51.17-1.04.31-1.58.42a.763.763 0 0 1-.7-.23 4.902 4.902 0 0 0-3.61-1.56 4.955 4.955 0 0 0-4.82 6.08c.05.23 0 .48-.16.67-.15.19-.38.3-.63.27a17.08 17.08 0 0 1-11.53-5.33c-.15.47-.22.97-.22 1.47 0 1.66.82 3.2 2.2 4.12.28.19.41.54.3.87-.1.32-.41.51-.75.53-.56-.02-1.12-.11-1.66-.27.44 1.86 1.92 3.34 3.83 3.72.35.07.6.37.61.72.01.35-.22.67-.56.76-.5.14-1.02.21-1.55.22a4.96 4.96 0 0 0 4.12 2.34c.32.01.61.21.71.52.1.31 0 .65-.25.85-1.71 1.34-3.7 2.19-5.83 2.48z"
};
function s5(t, e) {
  return m(), C("path", r5);
}
const zj = /* @__PURE__ */ se(n5, [["render", s5]]), i5 = {}, l5 = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M25 1.46C12.02 1.46 1.46 12.02 1.46 25c0 12.98 10.56 23.54 23.54 23.54S48.54 37.98 48.54 25C48.54 12.02 37.98 1.46 25 1.46zm0 45.53C12.88 46.99 3.01 37.12 3.01 25S12.88 3.01 25 3.01 46.99 12.88 46.99 25 37.12 46.99 25 46.99zm13.61-30.06c-.15.07-.29.13-.44.18.3-.47.54-.98.71-1.51.1-.3 0-.63-.25-.83a.77.77 0 0 0-.87-.06c-.94.56-1.94.96-3 1.21a6.489 6.489 0 0 0-4.41-1.73c-3.57 0-6.48 2.91-6.48 6.48 0 .16.01.31.02.46-4.01-.45-7.72-2.46-10.29-5.62-.16-.19-.4-.3-.65-.28-.25.02-.47.16-.6.38-.57.98-.88 2.11-.88 3.26 0 1.18.32 2.31.9 3.3a.709.709 0 0 0-.55.08c-.23.13-.38.37-.39.63v.1c0 2 .92 3.83 2.4 5.03-.08.04-.14.1-.2.16-.18.2-.24.48-.16.74a6.488 6.488 0 0 0 4.05 4.15c-1.55.83-3.28 1.27-5.08 1.27-.43 0-.86-.03-1.27-.07-.35-.04-.69.17-.81.5s.01.71.31.9c2.74 1.76 5.91 2.69 9.17 2.69 10.66 0 17.02-8.65 17.02-17.02v-.37c1.05-.81 1.96-1.79 2.71-2.9.19-.28.17-.66-.05-.92a.801.801 0 0 0-.91-.21zm-2.98 3.03a.77.77 0 0 0-.32.65c.01.24.02.47.02.71 0 7.61-5.8 15.49-15.49 15.49-1.96 0-3.87-.37-5.67-1.07 2.13-.3 4.12-1.14 5.84-2.49.25-.2.36-.54.25-.85a.75.75 0 0 0-.71-.52 4.937 4.937 0 0 1-4.12-2.34c.53-.01 1.05-.09 1.55-.22.34-.09.58-.41.56-.76s-.27-.65-.61-.72c-1.91-.38-3.39-1.86-3.83-3.72.54.16 1.1.25 1.66.27.37 0 .65-.21.75-.53s-.02-.68-.3-.87a4.937 4.937 0 0 1-2.2-4.12c0-.5.08-1 .22-1.47 3 3.18 7.14 5.11 11.52 5.33.25.01.47-.09.63-.27.15-.18.21-.43.16-.67a4.955 4.955 0 0 1 4.82-6.08c1.38 0 2.67.56 3.61 1.56.18.19.44.28.7.23.54-.11 1.06-.25 1.57-.42-.3.3-.63.57-1 .79-.31.19-.45.56-.33.9.12.34.46.56.81.51.3-.04.6-.08.9-.14-.31.3-.64.57-.99.82z"
};
function u5(t, e) {
  return m(), C("path", l5);
}
const Tj = /* @__PURE__ */ se(i5, [["render", u5]]), c5 = {}, d5 = {
  d: "M9.48891 6.77146L15.3142 3.05176e-05H13.9338L8.87569 5.87957L4.8358 3.05176e-05H0.17627L6.28537 8.89093L0.17627 15.9918H1.55676L6.89824 9.78283L11.1647 15.9918H15.8242L9.48857 6.77146H9.48891ZM7.59814 8.96926L6.97916 8.08393L2.05416 1.03924H4.17451L8.14904 6.72453L8.76802 7.60986L13.9344 14.9999H11.8141L7.59814 8.9696V8.96926Z",
  fill: "currentColor"
};
function m5(t, e) {
  return m(), C("path", d5);
}
const Oj = /* @__PURE__ */ se(c5, [["render", m5]]), p5 = {}, f5 = {
  stroke: "currentColor",
  fill: "none",
  d: "m6 3 5 5-5 5"
};
function h5(t, e) {
  return m(), C("path", f5);
}
const _0 = /* @__PURE__ */ se(p5, [["render", h5]]), v5 = {}, g5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.354 11.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708L15.293 12 8.646 5.354a.5.5 0 1 1 .708-.708l7 7Z",
  "clip-rule": "evenodd"
};
function y5(t, e) {
  return m(), C("path", g5);
}
const Fj = /* @__PURE__ */ se(v5, [["render", y5]]), b5 = {}, k5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.354 5.646a.5.5 0 0 0-.708 0l-5 5a.5.5 0 1 0 .708.707L8 6.707l4.646 4.646a.5.5 0 0 0 .708-.707l-5-5Z",
  "clip-rule": "evenodd"
};
function C5(t, e) {
  return m(), C("path", k5);
}
const w5 = /* @__PURE__ */ se(b5, [["render", C5]]), _5 = {}, H5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.354 11.354a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.707L8 10.293l4.646-4.646a.5.5 0 0 1 .708.707l-5 5Z",
  "clip-rule": "evenodd"
};
function j5(t, e) {
  return m(), C("path", H5);
}
const L5 = /* @__PURE__ */ se(_5, [["render", j5]]), x5 = {}, $5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.354 16.354a.5.5 0 0 1-.708 0l-7-7a.5.5 0 1 1 .708-.708L12 15.293l6.646-6.647a.5.5 0 0 1 .708.708l-7 7Z",
  "clip-rule": "evenodd"
};
function M5(t, e) {
  return m(), C("path", $5);
}
const V5 = /* @__PURE__ */ se(x5, [["render", M5]]), S5 = {}, A5 = { fill: "currentColor" };
function E5(t, e) {
  return m(), C("g", A5, e[0] || (e[0] = [
    g("path", { d: "M35.03 47.54c-.21 0-.42-.09-.58-.25L14.39 25.54a.786.786 0 0 1 0-1.07L34.45 2.71c.3-.32.8-.34 1.12-.04.32.3.34.8.05 1.12L16.04 25l19.57 21.22a.783.783 0 0 1-.58 1.32z" }, null, -1),
    g("path", { d: "M35.03 47.67c-.25 0-.5-.11-.67-.29L14.3 25.62a.92.92 0 0 1 0-1.24L34.36 2.62a.93.93 0 0 1 1.3-.05c.18.17.28.39.29.64.01.24-.08.48-.24.66L16.21 25 35.7 46.13c.17.18.25.41.24.66a.93.93 0 0 1-.29.64c-.17.15-.39.24-.62.24zm0-45.09H35a.66.66 0 0 0-.46.21L14.48 24.55c-.23.25-.23.65 0 .9L34.54 47.2c.24.26.68.28.94.04.13-.12.21-.28.21-.46a.655.655 0 0 0-.18-.48L15.95 25.08a.135.135 0 0 1 0-.17L35.52 3.7c.12-.13.18-.3.18-.48a.667.667 0 0 0-.67-.64z" }, null, -1)
  ]));
}
const Bj = /* @__PURE__ */ se(S5, [["render", E5]]), D5 = {}, P5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.354 8.646a.5.5 0 0 0-.708 0l-7 7a.5.5 0 0 0 .708.708L12 9.707l6.646 6.647a.5.5 0 0 0 .708-.708l-7-7Z",
  "clip-rule": "evenodd"
};
function z5(t, e) {
  return m(), C("path", P5);
}
const T5 = /* @__PURE__ */ se(D5, [["render", z5]]), O5 = {}, F5 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.4937 12.7497C3.3093 12.4561 3.17264 12.2126 3.08285 12.0441C3.06788 12.0161 3.05423 11.9901 3.04187 11.9663C3.04936 11.9465 3.05752 11.9252 3.0664 11.9024C3.13083 11.7373 3.23215 11.4975 3.3769 11.208C3.66686 10.6281 4.12832 9.85414 4.812 9.08129C6.17106 7.54496 8.41634 6 12 6C15.5837 6 17.8289 7.54496 19.188 9.08129C19.8717 9.85414 20.3331 10.6281 20.6231 11.208C20.7679 11.4975 20.8692 11.7373 20.9336 11.9024C20.9425 11.9252 20.9506 11.9465 20.9581 11.9663C20.9458 11.9901 20.9321 12.0161 20.9172 12.0441C20.8274 12.2126 20.6907 12.4561 20.5063 12.7497C20.1369 13.3376 19.5792 14.1213 18.8271 14.9034C17.3214 16.4693 15.0681 18 12 18C8.93189 18 6.67856 16.4693 5.17292 14.9034C4.42081 14.1213 3.86306 13.3376 3.4937 12.7497ZM21.9538 12.21C21.9539 12.2097 21.954 12.2095 21.5 12L21.954 12.2095C22.0056 12.0977 22.0141 11.9707 21.9779 11.853L21.5 12C21.9779 11.853 21.9778 11.8527 21.9777 11.8524L21.9775 11.8517L21.9769 11.8498L21.9752 11.8443L21.9694 11.8263C21.9645 11.8112 21.9574 11.7901 21.9482 11.7634C21.9297 11.7101 21.9024 11.6342 21.8652 11.539C21.791 11.3487 21.6775 11.0806 21.5175 10.7608C21.1981 10.1219 20.6908 9.27086 19.937 8.41871C18.4211 6.70504 15.9163 5 12 5C8.08366 5 5.57894 6.70504 4.063 8.41871C3.30918 9.27086 2.80189 10.1219 2.48247 10.7608C2.32254 11.0806 2.20902 11.3487 2.13478 11.539C2.09764 11.6342 2.07027 11.7101 2.0518 11.7634C2.04256 11.7901 2.03554 11.8112 2.03063 11.8263L2.02483 11.8443L2.02309 11.8498L2.02251 11.8517L2.02229 11.8524C2.02219 11.8527 2.02211 11.853 2.5 12L2.02211 11.853C1.98588 11.9707 1.9944 12.0977 2.04602 12.2095L2.5 12C2.04602 12.2095 2.04612 12.2097 2.04622 12.21L2.0465 12.2106L2.04725 12.2122L2.0496 12.2172L2.05763 12.2342C2.06448 12.2485 2.07431 12.2688 2.08715 12.2948C2.11282 12.3466 2.15051 12.4209 2.20036 12.5145C2.30002 12.7015 2.44851 12.9658 2.64692 13.2816C3.04319 13.9124 3.64169 14.7537 4.45208 15.5966C6.07144 17.2807 8.56811 19 12 19C15.4319 19 17.9286 17.2807 19.5479 15.5966C20.3583 14.7537 20.9568 13.9124 21.3531 13.2816C21.5515 12.9658 21.7 12.7015 21.7996 12.5145C21.8495 12.4209 21.8872 12.3466 21.9129 12.2948C21.9257 12.2688 21.9355 12.2485 21.9424 12.2342L21.9504 12.2172L21.9527 12.2122L21.9535 12.2106L21.9538 12.21ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z",
  fill: "currentColor"
};
function B5(t, e) {
  return m(), C("path", F5);
}
const Ij = /* @__PURE__ */ se(O5, [["render", B5]]), I5 = {}, Z5 = {
  fill: "currentColor",
  d: "M14.854 1.146a.5.5 0 0 1 0 .708l-13 13a.5.5 0 0 1-.708-.708l1.985-1.984C2.19 11.388 1.468 10.5.964 9.77a12.752 12.752 0 0 1-.857-1.435 5.73 5.73 0 0 1-.045-.092L.05 8.218l-.003-.007-.002-.003L.5 8a42.876 42.876 0 0 1-.482-.132v-.002L.02 7.86l.004-.016a3.3 3.3 0 0 1 .08-.247 9.191 9.191 0 0 1 1.509-2.665C2.813 3.466 4.822 2 8 2c1.729 0 3.117.434 4.22 1.073l1.926-1.927a.5.5 0 0 1 .708 0ZM.5 8l-.455.207a.5.5 0 0 1-.027-.339L.5 8Zm5.055 1.738a3 3 0 0 1 4.184-4.184l1.745-1.745C10.567 3.326 9.424 3 8 3 5.178 3 3.436 4.284 2.387 5.567a8.192 8.192 0 0 0-1.339 2.362l-.01.031a11.752 11.752 0 0 0 .75 1.243c.483.702 1.17 1.539 2.054 2.248l1.713-1.713Zm.722-.722 2.74-2.74a2 2 0 0 0-2.74 2.74Zm7.998-3.435a.5.5 0 0 1 .691.147c.372.573.624 1.101.783 1.488a7.307 7.307 0 0 1 .229.636l.003.01v.004l.001.001v.001L15.5 8l.455.207v.002l-.003.005-.007.014a11.484 11.484 0 0 1-.486.89 12.883 12.883 0 0 1-1.464 1.968C12.697 12.514 10.698 14 8 14c-.37 0-.73-.028-1.075-.08a.5.5 0 0 1 .15-.99c.297.046.605.07.925.07 2.302 0 4.053-1.264 5.255-2.586a11.89 11.89 0 0 0 1.684-2.408l.024-.046a6.503 6.503 0 0 0-.138-.363 8.22 8.22 0 0 0-.698-1.325.5.5 0 0 1 .148-.691ZM15.5 8l.482-.132a.5.5 0 0 1-.027.339L15.5 8Z"
};
function R5(t, e) {
  return m(), C("path", Z5);
}
const Zj = /* @__PURE__ */ se(I5, [["render", R5]]), N5 = {}, q5 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.934 8.486a13.149 13.149 0 0 1-.367-.527 9.368 9.368 0 0 1 1.43-2.124C4.06 4.651 5.686 3.5 8 3.5s3.939 1.152 5.003 2.334a9.368 9.368 0 0 1 1.43 2.125 14.539 14.539 0 0 1-1.787 2.188C11.424 11.368 9.796 12.5 8 12.5c-1.796 0-3.424-1.131-4.646-2.354a14.538 14.538 0 0 1-1.42-1.66Zm13.494-.228L15 8l.429.257.127-.212-.092-.23L15 8l.464-.186v-.002l-.003-.004-.005-.014-.021-.049a9.048 9.048 0 0 0-.39-.773 10.364 10.364 0 0 0-1.298-1.806C12.56 3.848 10.686 2.5 8 2.5S3.439 3.848 2.253 5.166a10.368 10.368 0 0 0-1.61 2.406 6.066 6.066 0 0 0-.099.222l-.006.014-.001.004v.001H.535L1 8l-.464-.186-.092.23.127.213L1 8l-.429.258.001.001.003.004.007.013a5.364 5.364 0 0 0 .137.213 15.54 15.54 0 0 0 1.928 2.364C3.923 12.132 5.796 13.5 8 13.5c2.204 0 4.076-1.369 5.354-2.646a15.54 15.54 0 0 0 2.035-2.532l.029-.046.007-.013.003-.004v-.001ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
  "clip-rule": "evenodd"
};
function U5(t, e) {
  return m(), C("path", q5);
}
const Rj = /* @__PURE__ */ se(N5, [["render", U5]]), Y5 = {}, W5 = {
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M30.47 26.56H19.53c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h10.94c1.73 0 3.12-1.4 3.12-3.12s-1.39-3.12-3.12-3.12zm0 4.69H19.53c-.86 0-1.56-.7-1.56-1.56s.7-1.56 1.56-1.56h10.94c.86 0 1.56.7 1.56 1.56s-.7 1.56-1.56 1.56zm15.39-14.61-6.24-6.24a.677.677 0 0 0-.26-.18c-.1-.04-.2-.06-.3-.06h-3.58l-6.8-6.8c-.3-.31-.8-.31-1.1 0l-3.36 3.36-1.79-1.79c-.3-.31-.8-.31-1.1 0l-5.24 5.24h-5.14a.765.765 0 0 0-.56.24l-6.24 6.24c-.23.23-.29.56-.18.84-.03.16-.06.33-.06.5v26.56c0 1.29 1.05 2.34 2.34 2.34h37.5c1.29 0 2.34-1.05 2.34-2.34V17.97c0-.17-.02-.34-.06-.5a.74.74 0 0 0-.17-.83zm-32.35-2.81c.3.31.8.31 1.1 0l2.34-2.34.01-.01 4.91-4.91 7.26 7.26c.15.15.35.23.55.23.2 0 .4-.08.55-.23.31-.3.31-.8 0-1.1l-4.92-4.92 2.8-2.8 6.47 6.47.01.01 2.34 2.34c.15.15.35.23.55.23s.4-.08.55-.23c.31-.3.31-.8 0-1.1l-1.01-1.01h1.7l3.91 3.91H7.35l3.91-3.91h3.27l-1.01 1.01c-.32.31-.32.8-.01 1.1zm31.02 30.7c0 .43-.35.78-.78.78H6.25c-.43 0-.78-.35-.78-.78V17.97c0-.43.35-.78.78-.78h37.5c.43 0 .78.35.78.78v26.56z"
};
function K5(t, e) {
  return m(), C("path", W5);
}
const Nj = /* @__PURE__ */ se(Y5, [["render", K5]]), G5 = {}, X5 = {
  fill: "currentColor",
  d: "M8.629.24a1.5 1.5 0 0 0-1.258 0l-5.5 2.538A1.5 1.5 0 0 0 1 4.14v7.72a1.5 1.5 0 0 0 .871 1.362l5.5 2.539a1.5 1.5 0 0 0 1.258 0l5.5-2.539A1.5 1.5 0 0 0 15 11.86V4.14a1.5 1.5 0 0 0-.871-1.362L8.629.239Zm-.839.907a.5.5 0 0 1 .42 0L13.307 3.5l-1.958.904a1.5 1.5 0 0 0-.22-.126L6.068 1.942l1.722-.795ZM4.875 2.493l5.307 2.45-1.972.91a.5.5 0 0 1-.42 0L2.693 3.5l2.182-1.007ZM11 5.666V7.5a.5.5 0 0 0 1 0V5.64c0-.14-.02-.278-.057-.41L14 4.282v7.58a.5.5 0 0 1-.29.453L8.5 14.72V6.813a1.5 1.5 0 0 0 .129-.052L11 5.666ZM2 4.281l5.371 2.48a1.5 1.5 0 0 0 .129.052v7.906l-5.21-2.405A.5.5 0 0 1 2 11.86V4.281Z"
};
function Q5(t, e) {
  return m(), C("path", X5);
}
const qj = /* @__PURE__ */ se(G5, [["render", Q5]]), J5 = {}, e3 = {
  d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
  fill: "currentColor"
};
function t3(t, e) {
  return m(), C("path", e3);
}
const Uj = /* @__PURE__ */ se(J5, [["render", t3]]), a3 = {};
function o3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      fill: "#012169",
      d: "M 2.519 4.89 L 21.48 4.89 L 21.48 19.11 L 2.519 19.11 L 2.519 4.89 Z"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      fill: "#FFF",
      d: "M 4.741 4.89 L 11.97 10.253 L 19.169 4.89 L 21.48 4.89 L 21.48 6.727 L 14.37 12.029 L 21.48 17.303 L 21.48 19.11 L 19.109 19.11 L 11.999 13.809 L 4.918 19.11 L 2.519 19.11 L 2.519 17.333 L 9.598 12.061 L 2.519 6.787 L 2.519 4.89 L 4.741 4.89 Z"
    }, null, -1)),
    e[2] || (e[2] = g("path", {
      fill: "#C8102E",
      d: "M 15.08 13.215 L 21.48 17.927 L 21.48 19.11 L 13.451 13.215 L 15.08 13.215 Z M 9.629 13.809 L 9.806 14.845 L 4.118 19.11 L 2.519 19.11 L 9.629 13.809 Z M 21.48 4.89 L 21.48 4.98 L 14.103 10.548 L 14.163 9.246 L 19.998 4.89 L 21.48 4.89 Z M 2.519 4.89 L 9.598 10.104 L 7.822 10.104 L 2.519 6.135 L 2.519 4.89 Z"
    }, null, -1)),
    e[3] || (e[3] = g("path", {
      fill: "#FFF",
      d: "M 9.658 4.89 L 9.658 19.11 L 14.398 19.11 L 14.398 4.89 L 9.658 4.89 Z M 2.519 9.631 L 2.519 14.371 L 21.48 14.371 L 21.48 9.631 L 2.519 9.631 Z"
    }, null, -1)),
    e[4] || (e[4] = g("path", {
      fill: "#C8102E",
      d: "M 2.519 10.607 L 2.519 13.453 L 21.48 13.453 L 21.48 10.607 L 2.519 10.607 Z M 10.607 4.89 L 10.607 19.11 L 13.451 19.11 L 13.451 4.89 L 10.607 4.89 Z"
    }, null, -1))
  ], 64);
}
const ho = /* @__PURE__ */ se(a3, [["render", o3]]), n3 = {};
function r3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_2900_4456)" }, [
      g("rect", {
        x: "3",
        y: "6",
        width: "6",
        height: "12",
        fill: "#002654"
      }),
      g("rect", {
        x: "9",
        y: "6",
        width: "6",
        height: "12",
        fill: "white"
      }),
      g("rect", {
        x: "15",
        y: "6",
        width: "6",
        height: "12",
        fill: "#ED2939"
      })
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_2900_4456" }, [
        g("rect", {
          width: "18",
          height: "12",
          fill: "white",
          transform: "translate(3 6)"
        })
      ])
    ], -1))
  ], 64);
}
const Zn = /* @__PURE__ */ se(n3, [["render", r3]]), s3 = {};
function i3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      x: "3",
      y: "6",
      width: "18",
      height: "4",
      fill: "#C8102E"
    }, null, -1)),
    e[1] || (e[1] = g("rect", {
      x: "3",
      y: "10",
      width: "18",
      height: "4",
      fill: "white"
    }, null, -1)),
    e[2] || (e[2] = g("rect", {
      x: "3",
      y: "14",
      width: "18",
      height: "4",
      fill: "#003DA5"
    }, null, -1))
  ], 64);
}
const Rn = /* @__PURE__ */ se(s3, [["render", i3]]), l3 = {};
function u3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_2900_4456)" }, [
      g("rect", {
        x: "3",
        y: "6",
        width: "6",
        height: "12",
        fill: "black"
      }),
      g("rect", {
        x: "9",
        y: "6",
        width: "6",
        height: "12",
        fill: "#F8D952"
      }),
      g("rect", {
        x: "15",
        y: "6",
        width: "6",
        height: "12",
        fill: "#DD4547"
      })
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_2900_4456" }, [
        g("rect", {
          width: "18",
          height: "12",
          fill: "white",
          transform: "translate(3 6)"
        })
      ])
    ], -1))
  ], 64);
}
const Fa = /* @__PURE__ */ se(l3, [["render", u3]]), c3 = {};
function d3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      width: "18",
      height: "12",
      fill: "#c60b1e",
      x: "3",
      y: "6",
      style: {}
    }, null, -1)),
    e[1] || (e[1] = g("rect", {
      width: "18",
      height: "6",
      y: "9.001",
      fill: "#ffc400",
      x: "3",
      style: {}
    }, null, -1))
  ], 64);
}
const Nn = /* @__PURE__ */ se(c3, [["render", d3]]), m3 = {};
function p3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      x: "3",
      y: "6",
      width: "6",
      height: "12",
      fill: "#139149"
    }, null, -1)),
    e[1] || (e[1] = g("rect", {
      x: "9",
      y: "6",
      width: "6",
      height: "12",
      fill: "white"
    }, null, -1)),
    e[2] || (e[2] = g("rect", {
      x: "15",
      y: "6",
      width: "6",
      height: "12",
      fill: "#CC2E3B"
    }, null, -1))
  ], 64);
}
const qn = /* @__PURE__ */ se(m3, [["render", p3]]), f3 = {};
function h3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      x: "3",
      y: "6",
      width: "18",
      height: "4",
      fill: "black"
    }, null, -1)),
    e[1] || (e[1] = g("rect", {
      x: "3",
      y: "10",
      width: "18",
      height: "4",
      fill: "#DD4547"
    }, null, -1)),
    e[2] || (e[2] = g("rect", {
      x: "3",
      y: "14",
      width: "18",
      height: "4",
      fill: "#F8D952"
    }, null, -1))
  ], 64);
}
const Un = /* @__PURE__ */ se(f3, [["render", h3]]), v3 = {}, g3 = {
  fill: "currentColor",
  d: "M5 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 5 12Z"
};
function y3(t, e) {
  return m(), C("path", g3);
}
const Yj = /* @__PURE__ */ se(v3, [["render", y3]]), b3 = {}, k3 = {
  fill: "currentColor",
  d: "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
};
function C3(t, e) {
  return m(), C("path", k3);
}
const w3 = /* @__PURE__ */ se(b3, [["render", C3]]), _3 = {}, H3 = {
  "clip-path": "url(#a)",
  filter: "url(#b)"
};
function j3(t, e) {
  return m(), C("g", H3, e[0] || (e[0] = [
    g("rect", {
      width: "72",
      height: "72",
      x: "6",
      y: "2",
      fill: "#341B14",
      rx: "36"
    }, null, -1),
    g("path", {
      fill: "#341B14",
      d: "M42 55.516c.305-.152 8.224-3.579 10.737-5.635 2.588-2.132 3.959-5.177 3.959-8.832V23.917l-.228-.076c-6.32-3.427-14.163-3.198-14.544-3.198-.304 0-8.147-.229-14.466 3.198l-.153.076v17.208c0 3.655 1.37 6.7 3.96 8.833C33.777 52.013 41.696 55.44 42 55.516Z"
    }, null, -1),
    g("path", {
      fill: "#FFB406",
      d: "M42 55.897s-8.376-3.655-10.965-5.711C28.295 47.902 27 44.78 27 41.2V23.384c6.624-3.579 15-3.274 15-3.274s8.376-.305 15 3.274v17.74c0 3.58-1.294 6.701-4.035 8.986C50.374 52.242 42 55.897 42 55.897ZM28.218 41.2c0 3.35 1.218 6.091 3.579 7.995 2.132 1.751 8.452 4.569 10.203 5.33 1.751-.762 8.147-3.655 10.203-5.33 2.36-1.904 3.579-4.72 3.579-7.995V23.688c-8.833-.837-19.34-.38-27.564 7.234v10.28Z"
    }, null, -1),
    g("path", {
      fill: "#FFB406",
      d: "M50.452 38.688c1.142.686 1.6 1.142 1.675 1.98 0 .914-.609 1.447-1.599 1.447-.837 0-1.827-.457-2.512-1.066v2.436c.837.457 1.827.838 2.893.838 2.589 0 3.807-1.828 3.807-3.503.076-1.523-.38-2.74-2.589-4.035-.99-.61-1.751-.99-1.751-1.904 0-.913.838-1.294 1.523-1.294.914 0 1.827.533 2.36 1.066v-2.284c-.457-.381-1.446-.914-2.893-.838-1.751.076-3.579 1.294-3.579 3.426.076 1.447.533 2.513 2.665 3.731Zm-8.985 5.483c.229.076.61.152 1.219.152 2.97 0 4.644-2.665 4.644-6.472 0-3.883-1.75-6.244-4.873-6.244-1.447 0-2.589.305-3.578.914v17.208h2.588v-5.558Zm0-10.356c.229-.076.61-.228.914-.228 1.523 0 2.132 1.218 2.132 4.188 0 2.893-.761 4.264-2.284 4.264-.38 0-.685-.077-.838-.153v-8.07h.076Zm-7.995 10.508c1.6 0 2.97-.38 3.96-1.066V31.759h-2.665v9.975c-.305.228-.685.305-1.218.305-1.219 0-1.371-1.142-1.371-1.828V31.76h-2.665v8.3c0 2.817 1.37 4.264 3.96 4.264Z"
    }, null, -1),
    g("rect", {
      width: "12",
      height: "12",
      x: "36",
      y: "78",
      fill: "#341B14",
      rx: "6"
    }, null, -1)
  ]));
}
const Wj = /* @__PURE__ */ se(_3, [["render", j3]]), L3 = {}, x3 = { "clip-path": "url(#a)" };
function $3(t, e) {
  return m(), C("g", x3, e[0] || (e[0] = [
    g("rect", {
      width: "44",
      height: "44",
      fill: "#D90B37",
      rx: "22"
    }, null, -1),
    g("g", { "clip-path": "url(#b)" }, [
      g("path", {
        fill: "#fff",
        d: "M22.063 11.715h-.065a.832.832 0 0 0-.184.026l-.004-.005a.41.41 0 0 1-.024.011l-.04.01.005.005a.252.252 0 0 0-.067.037l-.072.036-.012-.015-.232.127-.19.105v.002l-.19.104h.001l-.191.105-.136.075-.01-.012-.182.115-.01-.01-.231.127.001.001-.19.104v.001l-.19.105v.002l-.189.103-.137.076-.011-.013-.253.127.006.007-.196.098.006.007-.196.098.006.008-.195.098.006.007-.197.098.006.007-.125.063-.006-.007-.253.127.006.007-.196.098.006.007-.154.078h-.002l-.04.02v.002l-.19.104.001.002-.19.103.001.002-.137.074-.01-.012-.233.126h.001l-.191.106v.001l-.19.104h.001l-.191.105v.002l-.189.103.001.002-.137.075-.011-.013-.232.126v.001l-.19.104v.002l-.19.104v.002l-.19.103.001.002-.19.104.001.002-.138.075-.012-.014-.232.126.002.002-.19.104h.001l-.192.105.002.002-.19.104-.19.105v.001l-.137.075-.01-.013-.254.126.009.01-.094.054.25.138.025.03.664.363.43.247.001.002.675.4-.022-.026.429.242.014.016.538.303.012.013.556.313.664.383.4.229.001.003.042.022.107.062-.005-.006.377.206.027.032.534.3.014.016.674.379-.016-.02.564.336-.016-.019.565.336-.021-.025.39.219.032.037.517.282.03.035.586.32.152.101c.073.036.146.12.165.21l-.019-.02c0 .01.006.02.011.031.005.01.01.021.01.032v.358l.002.002v.884h-.001v1.369l.001.002v.253l-.001-.002v.4l.001.003v.253l-.001-.003v.634-.001V26.828v-.002.738l.001.001v.232-.001.337h-.001v.4l.001.001V29.356a.16.16 0 0 1-.017.067l-.005-.004a.28.28 0 0 1-.008.025.119.119 0 0 1-.013.017l.005.005a.291.291 0 0 1-.103.129l-.007-.008v.012a.132.132 0 0 1-.021.01l-.145.086-.003-.002-.186.108-.003-.003-.148.084c-.042.021-.084.021-.127.021l.012.014a.123.123 0 0 1-.033.007H22a.304.304 0 0 1-.148-.042l-.039-.017-.003-.004-.464-.253a.293.293 0 0 1-.148-.253v-2.382h.001v-.97.001-.737l-.001-.001v-.233.002-.991h.001v-.4l-.001-.002v-.232l.002.002v-.4l-.002-.003v-.252l.002.002v-.232c0-.042-.043-.106-.085-.127l-.314-.185-.003-.005-.13-.074-.016-.01-.398-.229-.003-.002-.051-.029-.098-.056.005.006-.38-.207-.026-.03-.674-.38.015.017-.562-.333.017.02-.565-.336.02.024-.387-.218-.033-.038-.696-.38.001.001-.4-.23-.002-.002-.674-.4.02.023-.43-.242-.012-.014-.674-.379.016.019-.564-.335.015.018-.41-.244-.005-.006-.058-.031-.09-.053.008.008-.38-.207-.028-.033-.169-.085V26.826c0 .127.054.27.133.386l-.006-.006.006.006a.65.65 0 0 0 .183.183l.492.267.413.238.001.001.513.295.035.042.52.284.028.033.696.4-.016-.019.564.335-.02-.022.44.253h.001l.548.316.547.315.001.002.547.315.001.001.553.318.016.02.675.4-.016-.018.564.334-.02-.023.44.253.001.002.547.314.001.002.295.169a.449.449 0 0 0 .187.06l.003.003h.064-.001.063c.047 0 .094 0 .14-.009l.008.009.19-.063.063-.043h-.001l.19-.105v-.001l.19-.104-.008-.01.177-.096-.001-.001.19-.104-.003-.004.142-.09.009.01.181-.116.009.01.18-.115.01.01.231-.148-.008-.009.177-.096-.001-.001.19-.104v-.002l.19-.104v-.001l.19-.104-.001-.001.191-.105-.008-.01.176-.095-.001-.001.19-.104-.002-.004.142-.09.008.01.18-.116.01.01.168-.107.001.001.232-.147-.001-.002.19-.103v-.002l.19-.104h-.001l.191-.105-.001-.002.19-.103-.008-.009.178-.097-.002-.002.19-.103-.003-.003.143-.09.008.009.181-.116.009.01.167-.106.233-.147-.002-.001.192-.104-.001-.001.191-.104-.001-.002.19-.104v-.001l.19-.104-.008-.01.176-.096H28.7l.192-.105-.002-.002.19-.103-.002-.004.142-.09.009.01.167-.107h.001l.18-.114.01.01.23-.148v-.001l.19-.105.19-.105v-.001l.191-.104-.008-.01.163-.089.14-.07.02-.021h.001c.042-.028.084-.075.127-.122.02-.023.042-.047.063-.068l-.007-.008a.67.67 0 0 0 .09-.202l-.004-.006a.481.481 0 0 0 .026-.142v-.718.002V24.402l-.002-.002v-.252l.002.001v-.97.001-1.054h-.001v-.233l.002.002v-.4l-.001-.002v-1.621l-.001-.002v-.253l.001.002v-.634.001-.738l-.001-.001v-.232.002-.253l-.081.046-.004-.005-.18.116-.008-.01-.232.147.001.002-.19.104-.191.105.002.002-.19.104-.192.105.007.008-.195.098.008.009-.177.096.001.001-.191.105-.189.104.001.002-.191.104.001.002-.19.104-.191.105.008.01-.176.095.003.004-.142.09-.008-.01-.182.116-.008-.01-.181.115-.008-.01-.182.116-.009-.01-.168.107-.002-.002-.232.148.002.002-.19.103h.002l-.192.105.002.002-.191.104h.001l-.191.105.001.002-.19.104.008.008-.178.097.002.001-.19.104v.002l-.19.104.003.003-.13.081a.046.046 0 0 0-.017.004l-.004-.004a.365.365 0 0 1-.263.013l-.011-.013h-.02l-.106-.085.037.044-.417-.254c-.027-.014-.046-.036-.067-.062l-.038-.044c-.027-.04-.037-.07-.046-.1-.005-.016-.01-.031-.018-.047v-.149l.001.001v-.422c0-.051.027-.116.06-.172l.003.004a.164.164 0 0 1 .085-.084l.076-.051.008.009.167-.106.183-.116.009.011.18-.114.008.009.182-.116.008.01.232-.147-.001-.002.19-.104.191-.105-.009-.01.175-.095v-.001l.191-.105.19-.105v-.002l.19-.103-.001-.001.191-.105-.001-.001.19-.104-.006-.008.196-.098-.008-.01.176-.095.191-.105-.002-.002.19-.104-.002-.003.142-.09.008.01.168-.108.002.002.186-.11.003.004.18-.114.008.009.232-.148.191-.105-.001-.002.19-.104.19-.105-.006-.008.196-.097-.008-.01.176-.096h-.001l.191-.105.19-.105v-.002l.19-.104-.002-.001.148-.083-.396-.207-.004-.004-.497-.265-.007-.009-.525-.27-.003-.004-.5-.267-.007-.007-.497-.265-.008-.009-.523-.27-.003-.004-.5-.267-.007-.007-.498-.266-.007-.007-.526-.272-.002-.003-.497-.264-.007-.01-.486-.25-.02-.024-.526-.271-.002-.002-.497-.265-.008-.01-.653-.358.006.007-.513-.281.027.03-.401-.213-.006-.007-.108-.054-.017-.009.001.001h-.002a.583.583 0 0 0-.271-.083l-.002-.002Z"
      })
    ], -1)
  ]));
}
const Kj = /* @__PURE__ */ se(L3, [["render", $3]]), M3 = {}, V3 = {
  "clip-path": "url(#a)",
  filter: "url(#b)"
};
function S3(t, e) {
  return m(), C("g", V3, e[0] || (e[0] = [
    g("rect", {
      width: "72",
      height: "72",
      x: "6",
      y: "2",
      fill: "#D90B37",
      rx: "36"
    }, null, -1),
    g("g", { "clip-path": "url(#c)" }, [
      g("path", {
        fill: "#fff",
        d: "M42.105 20.858h-.107c-.103 0-.206.02-.308.043l-.007-.007a1.081 1.081 0 0 1-.04.018l-.065.016.007.01a.422.422 0 0 0-.112.06l-.12.06-.02-.024-.387.21.002.002-.32.174.003.003-.317.173.001.001-.319.174.002.002-.228.124-.018-.02-.303.192-.014-.017-.387.211.002.002-.317.174.001.002-.319.173.003.004-.316.172v.001l-.23.126-.017-.022-.422.211.01.013-.326.163.01.012-.327.164.01.012-.325.163.01.012-.328.163.01.012-.21.105-.009-.011-.421.21.01.013-.328.163.01.012-.256.129-.003.001-.067.034.002.002-.319.174.003.002-.318.174.002.002-.228.124-.018-.021-.386.21v.002l-.319.174.003.003-.318.173.002.002-.32.174.002.002-.316.173.002.002-.23.126-.018-.022-.386.21.001.002-.319.174.002.002-.318.173.002.003-.317.173.002.002-.319.174.003.003-.23.125-.02-.023-.386.21.003.004-.316.172v.002l-.32.174.004.003-.317.173.001.002-.319.174.002.002-.228.124-.019-.022-.421.211.014.017-.157.09.417.229.042.05 1.107.604.716.412.003.004 1.124.667-.037-.043.715.402.023.027.898.505.019.022.927.522 1.107.637.665.383.004.004.07.038.177.102-.008-.01.629.343.045.054.89.5.022.026 1.124.633-.027-.032.941.559-.027-.032.942.559-.036-.042.65.366.053.062.863.47.048.057.978.534.254.169c.121.06.243.2.273.35l-.03-.034c0 .017.01.035.018.053a.124.124 0 0 1 .018.052v.597l.002.003v.385-.001V39.582l-.002-.002v1.23l.001.001v1.053l.002.002v.422l-.003-.003v.668l.003.003v.422l-.003-.004v.668l.002.002v.386l-.001-.002V46.047l-.001-.003v1.229l.002.002v.386l-.001-.002v1.23l.001.002v.386l-.001-.002v.983c0 .04-.012.081-.028.115l-.007-.009a.493.493 0 0 1-.013.043.203.203 0 0 1-.022.027l.008.01a.484.484 0 0 1-.173.214l-.011-.013v.02a.21.21 0 0 1-.035.015l-.242.145-.004-.004-.311.181-.005-.005-.246.14c-.07.035-.14.035-.21.035l.019.023a.205.205 0 0 1-.055.013H42c-.105 0-.176-.035-.246-.07l-.064-.03-.006-.006-.773-.422a.487.487 0 0 1-.246-.421v-3.971l.002.002v-.668l-.002-.002v-.948l.002.001v-.702l-.002-.002v-.524l-.001-.002v-.388l.002.003v-1.23h-.001v-.422l.001.001v-.667l-.002-.002v-.388l.003.003v-.667l-.003-.003v-.422l.003.003v-.386c0-.07-.07-.176-.14-.21l-.524-.31-.006-.007-.217-.125-.026-.015-.663-.382-.005-.005-.086-.047-.162-.093.008.009-.633-.345-.043-.05-1.124-.633.025.03-.936-.557.028.033-.943-.56.035.042-.646-.364-.055-.065-1.16-.632.002.002-.667-.384-.003-.004-1.124-.667.034.04-.716-.403-.02-.024-1.124-.632.027.031-.94-.558.025.03-.685-.407-.008-.01-.095-.051-.15-.089.012.014-.633-.346-.047-.054-.281-.14V46.043c0 .212.09.449.222.642l-.01-.01.01.011c.088.128.194.236.305.305l.82.444.688.397.002.002.854.492.06.07.866.473.047.054 1.16.668-.027-.032.94.559-.032-.038.733.422v.002l.913.525.001.001.911.525.002.003.912.525.002.001.92.53.028.032 1.124.668-.026-.03.94.557-.033-.038.733.422.002.002.91.525.003.002.492.281a.745.745 0 0 0 .311.1l.005.005H42c.078 0 .156 0 .233-.014l.013.015.316-.106.105-.07-.001-.002.318-.173-.003-.003.319-.174-.013-.015.294-.16-.002-.002.318-.174-.005-.006.236-.15.015.016.302-.192.014.016.302-.192.014.017.386-.246-.013-.016.294-.16-.002-.002.319-.174-.003-.002.319-.173-.002-.003.318-.173-.002-.002.32-.173-.015-.017.293-.16-.001-.001.318-.174-.005-.006.237-.15.014.016.3-.192.015.017.28-.18.003.003.386-.246-.002-.002.318-.173-.002-.002.317-.173-.001-.002.319-.174-.003-.003.317-.173-.012-.014.296-.162-.003-.003.316-.172-.004-.005.237-.151.014.015.302-.192.014.017.279-.178.001.002.387-.246-.002-.002.318-.174v-.001l.318-.174-.002-.002.317-.173-.002-.003.319-.174-.013-.015.292-.16-.001-.001.32-.174-.003-.003.317-.173-.005-.006.238-.15.014.015.279-.177.002.002.3-.192.014.016.387-.246-.002-.002.318-.174-.001-.002.318-.173-.002-.002.32-.174-.015-.017.271-.148.233-.116.036-.036c.071-.046.141-.124.212-.202.035-.04.07-.078.105-.113l-.012-.014c.073-.113.123-.225.151-.337l-.008-.01a.803.803 0 0 0 .045-.236v-.808l-.002-.002v-.388l.003.004v-.703l-.003-.003v-.385l.001.001v-1.09l.001.001v-.667L56.995 42v-.42l.003.003v-.528.001-1.09.001-1.756l-.002-.002v-.388l.003.004v-.668l-.001-.001v-1.088l-.001-.002v-.386l.002.002v-1.229l-.003-.003v-.422l.003.003v-.667l-.002-.002v-.387l.002.002v-.668h-.001v-.562l-.002-.002v-.386l.002.002v-.422l-.137.078-.005-.008-.302.192-.013-.016-.386.246.002.003-.317.173v.001l-.318.174.003.003-.318.174h.001l-.32.175.012.013-.325.163.013.015-.294.16.001.002-.319.174.002.002-.316.173.001.002-.318.174.002.003-.317.173-.319.175.014.016-.293.16.005.006-.236.15-.014-.016-.303.193-.015-.017-.301.192-.014-.016-.302.192-.015-.017-.28.178-.003-.002-.387.246.003.003-.315.172.001.002-.319.174.003.002-.318.173.001.002-.319.174.003.004-.316.172.012.014-.296.162.002.002-.317.173.002.002-.317.174.004.005-.216.135a.078.078 0 0 0-.029.007l-.005-.007a.608.608 0 0 1-.44.022l-.018-.022h-.034l-.176-.14.062.071-.695-.423c-.046-.023-.076-.06-.111-.102-.02-.024-.04-.048-.065-.073-.044-.067-.06-.119-.075-.166-.009-.028-.017-.054-.03-.08v-.248l.001.002v-.703l-.001-.001c0-.085.046-.193.1-.286l.006.007a.274.274 0 0 1 .141-.14l.127-.086.013.015.278-.177.002.001.304-.193.015.018.3-.191.013.015.303-.193.014.017.387-.246-.002-.002.318-.173-.002-.002.319-.174-.014-.017.291-.159-.001-.001.32-.174-.002-.002.319-.174-.002-.002.317-.173-.002-.002.32-.174-.003-.002.318-.173-.01-.013.326-.163-.014-.016.293-.16.319-.175-.003-.003.318-.173-.006-.006.237-.15.014.016.28-.179.002.003.311-.182.006.007.3-.192.013.016.387-.246-.001-.001.32-.175-.004-.003.318-.173-.001-.001.319-.174-.011-.013.326-.163-.014-.016.293-.16v-.001l.318-.174-.001-.002.319-.174-.003-.003.316-.172-.002-.003.248-.138-.66-.344-.007-.007-.828-.442-.013-.015-.875-.451-.004-.006-.835-.445-.01-.012-.83-.442-.011-.014-.872-.45-.006-.006-.834-.445-.01-.012-.83-.443-.012-.013-.877-.453-.003-.004-.828-.442-.013-.015-.81-.417-.033-.04-.877-.452-.003-.004-.828-.442-.013-.015-1.09-.598.011.013-.854-.469.044.051-.668-.356-.01-.011-.18-.09-.028-.015.002.002-.004-.002a.973.973 0 0 0-.452-.137l-.003-.004Z"
      })
    ], -1),
    g("rect", {
      width: "12",
      height: "12",
      x: "36",
      y: "78",
      fill: "#D90B37",
      rx: "6"
    }, null, -1)
  ]));
}
const Gj = /* @__PURE__ */ se(M3, [["render", S3]]), A3 = {}, E3 = { "clip-path": "url(#a)" };
function D3(t, e) {
  return m(), C("g", E3, e[0] || (e[0] = [
    g("rect", {
      width: "44",
      height: "44",
      fill: "#3544B3",
      rx: "22"
    }, null, -1),
    g("g", { "clip-path": "url(#b)" }, [
      g("path", {
        fill: "#fff",
        d: "M17.754 20.605c-1.035 0-1.867.574-1.867 1.866 0 1.264.832 1.867 1.867 1.867 1.032 0 1.866-.603 1.866-1.867 0-1.292-.834-1.866-1.866-1.866Zm0 2.845c-.462 0-.809-.351-.809-.979 0-.682.347-.98.81-.98.46 0 .806.298.806.98 0 .628-.347.979-.807.979Zm6.726-2.813c0 .02.015.035.034.035h.785c.063 0 .113.051.113.112v.68c0 .02-.015.035-.034.035h-.864a.034.034 0 0 0-.034.034v1.32c0 .506.191.656.511.656.15 0 .386-.092.42-.092.02 0 .036.015.036.034v.65a.11.11 0 0 1-.06.1c-.142.077-.381.13-.736.13-.619 0-1.194-.313-1.194-1.308V20.73a.8.8 0 0 1 .206-.534c.167-.185.704-.53.774-.53.03 0 .043.009.043.037v.935Zm-12.487.15c0-.064.051-.114.115-.114h1.361c1.337 0 2.03.802 2.03 1.84 0 1.04-.775 1.76-2.051 1.76h-.398a.035.035 0 0 0-.035.035v1.683c0 .029-.012.038-.043.038-.07 0-.607-.346-.774-.53a.804.804 0 0 1-.205-.534v-4.177Zm2.496 1.674c0-.442-.286-.856-1.04-.856h-.4a.034.034 0 0 0-.035.036v1.66c0 .02.015.036.034.036h.42c.9 0 1.021-.625 1.021-.876Zm8.442.702c0 .758-.545 1.175-1.608 1.175-.608 0-1.25-.214-1.256-.216a.12.12 0 0 1-.08-.11v-.707c0-.024.02-.042.045-.042l.014.003c.227.073.963.256 1.354.256.232 0 .353-.035.43-.113a.24.24 0 0 0 .078-.179c0-.23-.29-.295-.571-.357-.035-.007-.02-.003-.115-.026-.615-.145-1.264-.295-1.264-1.088 0-.352.147-.643.423-.846.275-.202.671-.308 1.147-.308.427 0 .934.14 1.104.195a.119.119 0 0 1 .084.112v.705c-.002.033-.036.048-.06.039a3.677 3.677 0 0 0-1.252-.247c-.254 0-.419.11-.419.281 0 .197.24.25.546.32.037.007.203.045.246.054.25.056.507.112.719.25.293.192.435.469.435.849Zm5.51 1.097a.022.022 0 0 1-.02-.022v-2.145c0-.476-.163-.68-.542-.68-.136 0-.3.051-.462.144-.162.094-.288.171-.334.198a.065.065 0 0 0-.026.047v2.437c0 .012-.01.022-.021.022h-.957c-.011 0-.022-.01-.022-.022v-3.45c0-.057.046-.103.103-.103h.876c.012 0 .023.01.023.022v.271c0 .016.014.03.03.03a.038.038 0 0 0 .017-.006l.029-.021c.107-.082.271-.176.381-.218.24-.091.498-.145.708-.145.782 0 1.195.45 1.195 1.298v2.32c0 .013-.01.022-.023.022h-.954Zm1.767 0a.022.022 0 0 1-.022-.022v-5.284c0-.02.004-.025.03-.025.06 0 .593.336.765.525a.789.789 0 0 1 .202.526v4.258c0 .012-.01.022-.022.022h-.953Zm-12.454-9.186a.104.104 0 0 0-.057.019 2.28 2.28 0 0 0-.425.418c-.036.04-.036.088.002.137.116.15.25.285.396.4a.13.13 0 0 0 .083.032.13.13 0 0 0 .082-.033c.146-.115.28-.25.397-.4.038-.048.038-.095 0-.139a2.219 2.219 0 0 0-.42-.414.103.103 0 0 0-.059-.02Zm0 1.296c-.077 0-.159.002-.243.005-.03 0-.057.01-.078.033a.165.165 0 0 0-.041.109l.02 1.594.007.47c0 .04.029.122.119.122h.432c.065 0 .109-.045.118-.117v-.006l.026-2.036v-.025a.161.161 0 0 0-.04-.11.105.105 0 0 0-.08-.032 4.392 4.392 0 0 0-.24-.007Zm1.098.118c-.1 0-.181.055-.224.15a5.68 5.68 0 0 0-.302.845c-.01.037-.007.068.01.09.012.016.036.034.083.034h.338c.076 0 .104-.04.115-.074.055-.188.095-.298.166-.453 0-.002.006-.012.027-.012.008 0 .016.001.024.004l.172.057c.02.007.033.024.039.038a.123.123 0 0 1 .005.087c-.002.006-.347.971-.45 1.293-.015.05-.013.088.007.117.02.027.052.04.097.04h.419c.068 0 .113-.027.133-.082l.063-.174.01-.027c.125-.35.316-.882.357-1.033.068-.256.087-.536-.288-.675a5.894 5.894 0 0 0-.336-.114c-.132-.04-.26-.07-.371-.096l-.014-.004a.305.305 0 0 0-.08-.01Zm-2.197 0a.297.297 0 0 0-.074.01l-.017.003a5.48 5.48 0 0 0-.707.21c-.376.14-.356.42-.287.675.039.146.216.644.366 1.06l.062.174c.02.055.065.082.134.082h.418c.057 0 .084-.021.097-.04.021-.027.023-.066.008-.116a71.587 71.587 0 0 0-.452-1.292.123.123 0 0 1 .006-.088.07.07 0 0 1 .04-.038l.172-.057a.086.086 0 0 1 .023-.003c.017 0 .025.008.027.012.071.16.112.27.165.453.01.034.038.074.115.074h.34c.036 0 .064-.01.081-.034.017-.022.021-.052.01-.089a5.786 5.786 0 0 0-.302-.846.243.243 0 0 0-.225-.15Zm2.638 2.536h-3.074a.201.201 0 0 0-.199.198v.387c0 .121.052.18.159.18h3.154c.107 0 .159-.059.159-.18v-.387a.201.201 0 0 0-.2-.198Zm14.802 2.99c-.003-2.157-4.058-5.896-8.378-8.277-4.984-2.749-10.655-4.368-12.523-3.339-2.13 1.175-3.296 7.04-3.297 11.617 0 4.614 1.1 10.404 3.297 11.615 1.99 1.098 7.415-.522 12.523-3.337 4.388-2.42 8.375-6.015 8.378-8.278ZM14.69 9.038c3.145 0 8.184 1.988 11.534 3.836 1.917 1.056 4.092 2.598 5.775 4.167 1.615 1.505 3.14 3.379 3.142 4.975-.003 1.503-1.223 3.266-3.187 5.066-1.668 1.528-3.833 3.03-5.73 4.076-3.236 1.784-8.169 3.868-11.42 3.868-.884 0-1.61-.153-2.157-.455-1.44-.793-2.363-2.931-2.908-5.026-.585-2.248-.886-4.951-.887-7.528 0-2.522.325-5.231.892-7.435.69-2.683 1.695-4.454 2.903-5.12.507-.282 1.195-.424 2.043-.424Z"
      })
    ], -1)
  ]));
}
const Xj = /* @__PURE__ */ se(A3, [["render", D3]]), P3 = {}, z3 = { "clip-path": "url(#a)" };
function T3(t, e) {
  return m(), C("g", z3, e[0] || (e[0] = [
    g("rect", {
      width: "44",
      height: "44",
      fill: "#F36920",
      rx: "22"
    }, null, -1),
    g("path", {
      fill: "#F36920",
      d: "M6 6h32v32H6z"
    }, null, -1),
    g("g", { "clip-path": "url(#b)" }, [
      g("path", {
        fill: "#fff",
        d: "M17.754 20.605c-1.035 0-1.867.574-1.867 1.866 0 1.264.832 1.867 1.867 1.867 1.032 0 1.866-.603 1.866-1.867 0-1.292-.834-1.866-1.866-1.866Zm0 2.845c-.462 0-.809-.351-.809-.979 0-.682.347-.98.81-.98.46 0 .806.298.806.98 0 .628-.347.979-.807.979Zm6.726-2.813c0 .02.015.035.034.035h.785c.063 0 .113.051.113.112v.68c0 .02-.015.035-.034.035h-.864a.034.034 0 0 0-.034.034v1.32c0 .506.191.656.511.656.15 0 .386-.092.42-.092.02 0 .036.015.036.034v.65a.11.11 0 0 1-.06.1c-.142.077-.381.13-.736.13-.619 0-1.194-.313-1.194-1.308V20.73a.8.8 0 0 1 .206-.534c.167-.185.704-.53.774-.53.03 0 .043.009.043.037v.935Zm-12.487.15c0-.064.051-.114.115-.114h1.361c1.337 0 2.03.802 2.03 1.84 0 1.04-.775 1.76-2.051 1.76h-.398a.035.035 0 0 0-.035.035v1.683c0 .029-.012.038-.043.038-.07 0-.607-.346-.774-.53a.804.804 0 0 1-.205-.534v-4.177Zm2.496 1.674c0-.442-.286-.856-1.04-.856h-.4a.034.034 0 0 0-.035.036v1.66c0 .02.015.036.034.036h.42c.9 0 1.021-.625 1.021-.876Zm8.442.702c0 .758-.545 1.175-1.608 1.175-.608 0-1.25-.214-1.256-.216a.12.12 0 0 1-.08-.11v-.707c0-.024.02-.042.045-.042l.014.003c.227.073.963.256 1.354.256.232 0 .353-.035.43-.113a.24.24 0 0 0 .078-.179c0-.23-.29-.295-.571-.357-.035-.007-.02-.003-.115-.026-.615-.145-1.264-.295-1.264-1.088 0-.352.147-.643.423-.846.275-.202.671-.308 1.147-.308.427 0 .934.14 1.104.195a.119.119 0 0 1 .084.112v.705c-.002.033-.036.048-.06.039a3.677 3.677 0 0 0-1.252-.247c-.254 0-.419.11-.419.281 0 .197.24.25.546.32.037.007.203.045.246.054.25.056.507.112.719.25.293.192.435.469.435.849Zm5.51 1.097a.022.022 0 0 1-.02-.022v-2.145c0-.476-.163-.68-.542-.68-.136 0-.3.051-.462.144-.162.094-.288.171-.334.198a.065.065 0 0 0-.026.047v2.437c0 .012-.01.022-.021.022h-.957c-.011 0-.022-.01-.022-.022v-3.45c0-.057.046-.103.103-.103h.876c.012 0 .023.01.023.022v.271c0 .016.014.03.03.03a.038.038 0 0 0 .017-.006l.029-.021c.107-.082.271-.176.381-.218.24-.091.498-.145.708-.145.782 0 1.195.45 1.195 1.298v2.32c0 .013-.01.022-.023.022h-.954Zm1.767 0a.022.022 0 0 1-.022-.022v-5.284c0-.02.004-.025.03-.025.06 0 .593.336.765.525a.789.789 0 0 1 .202.526v4.258c0 .012-.01.022-.022.022h-.953Zm-12.454-9.186a.104.104 0 0 0-.057.019 2.28 2.28 0 0 0-.425.418c-.036.04-.036.088.002.137.116.15.25.285.396.4a.13.13 0 0 0 .083.032.13.13 0 0 0 .082-.033c.146-.115.28-.25.397-.4.038-.048.038-.095 0-.139a2.219 2.219 0 0 0-.42-.414.103.103 0 0 0-.059-.02Zm0 1.296c-.077 0-.159.002-.243.005-.03 0-.057.01-.078.033a.165.165 0 0 0-.041.109l.02 1.594.007.47c0 .04.029.122.119.122h.432c.065 0 .109-.045.118-.117v-.006l.026-2.036v-.025a.161.161 0 0 0-.04-.11.105.105 0 0 0-.08-.032 4.392 4.392 0 0 0-.24-.007Zm1.098.118c-.1 0-.181.055-.224.15a5.68 5.68 0 0 0-.302.845c-.01.037-.007.068.01.09.012.016.036.034.083.034h.338c.076 0 .104-.04.115-.074.055-.188.095-.298.166-.453 0-.002.006-.012.027-.012.008 0 .016.001.024.004l.172.057c.02.007.033.024.039.038a.123.123 0 0 1 .005.087c-.002.006-.347.971-.45 1.293-.015.05-.013.088.007.117.02.027.052.04.097.04h.419c.068 0 .113-.027.133-.082l.063-.174.01-.027c.125-.35.316-.882.357-1.033.068-.256.087-.536-.288-.675a5.894 5.894 0 0 0-.336-.114c-.132-.04-.26-.07-.371-.096l-.014-.004a.305.305 0 0 0-.08-.01Zm-2.197 0a.297.297 0 0 0-.074.01l-.017.003a5.48 5.48 0 0 0-.707.21c-.376.14-.356.42-.287.675.039.146.216.644.366 1.06l.062.174c.02.055.065.082.134.082h.418c.057 0 .084-.021.097-.04.021-.027.023-.066.008-.116a71.587 71.587 0 0 0-.452-1.292.123.123 0 0 1 .006-.088.07.07 0 0 1 .04-.038l.172-.057a.086.086 0 0 1 .023-.003c.017 0 .025.008.027.012.071.16.112.27.165.453.01.034.038.074.115.074h.34c.036 0 .064-.01.081-.034.017-.022.021-.052.01-.089a5.786 5.786 0 0 0-.302-.846.243.243 0 0 0-.225-.15Zm2.638 2.536h-3.074a.201.201 0 0 0-.199.198v.387c0 .121.052.18.159.18h3.154c.107 0 .159-.059.159-.18v-.387a.201.201 0 0 0-.2-.198Zm14.802 2.99c-.003-2.157-4.058-5.896-8.378-8.277-4.984-2.749-10.655-4.368-12.523-3.339-2.13 1.175-3.296 7.04-3.297 11.617 0 4.614 1.1 10.404 3.297 11.615 1.99 1.098 7.415-.522 12.523-3.337 4.388-2.42 8.375-6.015 8.378-8.278ZM14.69 9.038c3.145 0 8.184 1.988 11.534 3.836 1.917 1.056 4.092 2.598 5.775 4.167 1.615 1.505 3.14 3.379 3.142 4.975-.003 1.503-1.223 3.266-3.187 5.066-1.668 1.528-3.833 3.03-5.73 4.076-3.236 1.784-8.169 3.868-11.42 3.868-.884 0-1.61-.153-2.157-.455-1.44-.793-2.363-2.931-2.908-5.026-.585-2.248-.886-4.951-.887-7.528 0-2.522.325-5.231.892-7.435.69-2.683 1.695-4.454 2.903-5.12.507-.282 1.195-.424 2.043-.424Z"
      })
    ], -1)
  ]));
}
const Qj = /* @__PURE__ */ se(P3, [["render", T3]]), O3 = {}, F3 = { "clip-path": "url(#a)" };
function B3(t, e) {
  return m(), C("g", F3, e[0] || (e[0] = [
    g("rect", {
      width: "44",
      height: "44",
      fill: "#341B14",
      rx: "22"
    }, null, -1),
    g("path", {
      fill: "#341B14",
      d: "M21.535 33.736c.204-.102 5.501-2.394 7.182-3.77 1.732-1.426 2.65-3.463 2.65-5.909v-11.46l-.154-.052c-4.228-2.292-9.474-2.14-9.729-2.14-.204 0-5.45-.152-9.679 2.14l-.101.051v11.512c0 2.445.916 4.483 2.648 5.91 1.681 1.375 6.98 3.667 7.183 3.718Z"
    }, null, -1),
    g("path", {
      fill: "#FFB406",
      d: "M21.535 33.99s-5.603-2.445-7.335-3.82c-1.834-1.528-2.7-3.617-2.7-6.01V12.24c4.432-2.395 10.035-2.191 10.035-2.191s5.603-.204 10.035 2.19v11.87c0 2.393-.866 4.482-2.7 6.01-1.732 1.427-7.335 3.872-7.335 3.872Zm-9.22-9.83c0 2.24.815 4.074 2.394 5.348 1.427 1.172 5.654 3.056 6.826 3.566 1.172-.51 5.45-2.445 6.826-3.566 1.58-1.274 2.394-3.158 2.394-5.349V12.443c-5.909-.56-12.938-.255-18.44 4.84v6.876Z"
    }, null, -1),
    g("path", {
      fill: "#FFB406",
      d: "M27.19 22.478c.763.459 1.069.764 1.12 1.325 0 .611-.408.968-1.07.968-.56 0-1.222-.306-1.68-.714v1.63c.56.306 1.222.56 1.935.56 1.732 0 2.547-1.222 2.547-2.342.05-1.02-.255-1.834-1.732-2.7-.662-.408-1.172-.662-1.172-1.274 0-.611.56-.866 1.02-.866.61 0 1.222.357 1.578.713V18.25c-.305-.254-.968-.611-1.935-.56-1.172.05-2.395.866-2.395 2.292.051.968.357 1.681 1.783 2.496Zm-6.012 3.668c.153.05.408.102.815.102 1.987 0 3.108-1.783 3.108-4.33 0-2.598-1.172-4.177-3.26-4.177-.968 0-1.732.204-2.395.611v11.512h1.732v-3.718Zm0-6.928c.153-.05.408-.153.612-.153 1.018 0 1.426.815 1.426 2.802 0 1.936-.51 2.853-1.528 2.853-.255 0-.459-.051-.56-.102v-5.4h.05Zm-5.348 7.03c1.07 0 1.986-.255 2.649-.713v-7.692h-1.783v6.673c-.204.153-.459.204-.815.204-.815 0-.917-.764-.917-1.223v-5.654H13.18v5.552c0 1.885.917 2.853 2.649 2.853Z"
    }, null, -1)
  ]));
}
const Jj = /* @__PURE__ */ se(O3, [["render", B3]]), I3 = {};
function Z3(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      width: "44",
      height: "44",
      fill: "#FECC00",
      rx: "22"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      fill: "#D50029",
      d: "M13.93 20.816c-.19.256-.505.7-.697.96-.098.132-.274.372.31.372h3.076l.912-1.239c.565-.767.049-2.364-1.973-2.364h-7.96l-1.38 1.875h7.522c.38 0 .375.145.19.396Zm-2.26 1.794c-.585 0-.409-.24-.311-.372.192-.26.513-.7.702-.955.186-.252.19-.396-.19-.396h-3.44L5.66 24.654h6.76c2.233 0 3.476-1.518 3.86-2.044h-4.61Zm4.397 2.044h3.965l1.504-2.044H17.57c-.002 0-1.504 2.044-1.504 2.044Zm10.232-6.11-1.521 2.067h-1.77l1.52-2.066h-3.964l-2.653 3.603h9.7l2.651-3.603H26.3Zm-4.497 6.11h3.964l1.504-2.044h-3.964l-1.504 2.044ZM.001 23.416v.435h5.523l.319-.434H0Zm6.435-.806H.001v.434h6.115l.32-.434ZM.001 24.654h4.93l.319-.431H0v.431Zm37.38-.804h5.82v-.434h-5.5l-.32.434Zm-.591.804h6.41v-.431h-6.093l-.317.431Zm1.503-2.044-.319.434h5.227v-.434h-4.908Zm-5.192-.462 2.652-3.603h-4.199L28.9 22.148h4.2Zm-4.54.462-.431.587c-.498.672-.058 1.457 1.567 1.457h6.366l1.505-2.044H28.56Z"
    }, null, -1))
  ], 64);
}
const eL = /* @__PURE__ */ se(I3, [["render", Z3]]), R3 = {}, N3 = { filter: "url(#a)" };
function q3(t, e) {
  return m(), C("g", N3, e[0] || (e[0] = [
    g("rect", {
      width: "72",
      height: "72",
      x: "8",
      y: "2",
      fill: "#F36920",
      rx: "36"
    }, null, -1),
    g("g", { "clip-path": "url(#b)" }, [
      g("path", {
        fill: "#fff",
        d: "M38.693 36.256c-1.294 0-2.334.718-2.334 2.333 0 1.58 1.04 2.333 2.334 2.333 1.289 0 2.332-.754 2.332-2.333 0-1.615-1.043-2.333-2.332-2.333Zm0 3.556c-.579 0-1.011-.439-1.011-1.223 0-.853.432-1.226 1.01-1.226.576 0 1.01.373 1.01 1.226 0 .784-.434 1.224-1.01 1.224Zm8.406-3.515c0 .024.02.043.043.043h.982c.078 0 .141.064.141.14v.85c0 .024-.019.043-.043.043h-1.08a.043.043 0 0 0-.043.043v1.65c0 .632.24.82.64.82.187 0 .482-.115.525-.115.024 0 .044.019.044.043v.813a.139.139 0 0 1-.073.124c-.179.096-.478.162-.921.162-.774 0-1.492-.39-1.492-1.634v-2.868a1 1 0 0 1 .256-.668c.21-.23.881-.662.968-.662.038 0 .053.011.053.046v1.17Zm-15.608.187c0-.08.064-.143.144-.143h1.702c1.67 0 2.536 1.003 2.536 2.301 0 1.3-.968 2.199-2.563 2.199h-.498a.044.044 0 0 0-.044.044v2.104c0 .035-.014.047-.053.047-.087 0-.759-.432-.968-.662a1.005 1.005 0 0 1-.256-.668v-5.222Zm3.12 2.093c0-.553-.357-1.07-1.3-1.07h-.5a.043.043 0 0 0-.044.044v2.076c0 .024.02.044.043.044h.526c1.124 0 1.275-.78 1.275-1.094Zm10.553.876c0 .948-.681 1.469-2.01 1.469-.76 0-1.563-.267-1.57-.269a.15.15 0 0 1-.1-.139v-.883c0-.03.025-.052.056-.052l.018.003c.284.092 1.203.32 1.692.32.29 0 .44-.043.538-.14a.3.3 0 0 0 .097-.224c0-.29-.362-.37-.714-.446l-.143-.033c-.77-.182-1.58-.37-1.58-1.36 0-.44.183-.805.528-1.058.343-.253.84-.385 1.434-.385.534 0 1.168.176 1.38.244.067.022.105.08.105.14v.881c-.002.041-.045.06-.074.049a4.598 4.598 0 0 0-1.566-.308c-.318 0-.523.137-.523.35 0 .247.3.314.681.4l.308.069c.312.069.634.139.899.311.366.24.544.587.544 1.061Zm6.888 1.372a.027.027 0 0 1-.027-.027v-2.681c0-.596-.202-.85-.677-.85-.17 0-.374.063-.577.179-.202.117-.36.214-.417.248a.081.081 0 0 0-.033.059v3.046a.027.027 0 0 1-.027.027H49.1c-.015 0-.028-.013-.028-.027v-4.314c0-.07.057-.127.129-.127h1.095c.015 0 .029.012.029.027v.339c0 .02.017.037.037.037a.047.047 0 0 0 .021-.007l.037-.027a2.22 2.22 0 0 1 .476-.272c.3-.114.623-.18.885-.18.977 0 1.493.56 1.493 1.622v2.9c0 .015-.012.027-.028.027h-1.193Zm2.208 0a.027.027 0 0 1-.027-.027v-6.606c0-.024.004-.03.037-.03.074 0 .741.419.957.656.16.176.252.416.252.657v5.323a.027.027 0 0 1-.027.027H54.26ZM38.692 29.343a.13.13 0 0 0-.07.023 2.847 2.847 0 0 0-.532.523c-.046.05-.046.11.002.17.146.19.313.357.496.5.034.028.068.04.103.04a.163.163 0 0 0 .102-.04c.183-.144.35-.312.496-.5.048-.06.048-.12 0-.174a2.774 2.774 0 0 0-.524-.517.13.13 0 0 0-.073-.025Zm0 1.62a6.95 6.95 0 0 0-.303.006.131.131 0 0 0-.097.04.206.206 0 0 0-.052.137l.026 1.993.008.586c0 .05.036.154.148.154h.54c.081 0 .136-.056.148-.147v-.007l.032-2.545v-.032a.202.202 0 0 0-.05-.137.132.132 0 0 0-.1-.04 5.519 5.519 0 0 0-.3-.009Zm1.372.147a.299.299 0 0 0-.279.188 7.097 7.097 0 0 0-.378 1.056c-.012.046-.008.085.014.113.014.02.044.042.102.042h.423c.096 0 .13-.051.144-.093.07-.235.119-.372.207-.566.001-.002.008-.015.034-.015.01 0 .02.002.03.005l.215.071a.09.09 0 0 1 .049.047.154.154 0 0 1 .007.11c-.003.007-.434 1.213-.563 1.616-.02.062-.017.11.009.147.024.032.064.05.12.05h.524c.086 0 .142-.035.167-.104.02-.052.046-.127.078-.217l.013-.033c.157-.439.395-1.103.446-1.292.086-.32.11-.67-.36-.844a6.858 6.858 0 0 0-.885-.263l-.016-.004a.38.38 0 0 0-.1-.014Zm-2.745 0a.367.367 0 0 0-.093.011l-.021.005a6.721 6.721 0 0 0-.883.263c-.47.174-.446.524-.36.844.049.182.27.804.458 1.325l.078.217c.025.069.081.103.167.103h.523c.07 0 .104-.027.12-.05.027-.035.03-.083.01-.146a89.133 89.133 0 0 0-.564-1.615.154.154 0 0 1 .007-.11.086.086 0 0 1 .05-.047l.215-.071a.11.11 0 0 1 .029-.004c.021 0 .031.01.034.015.089.199.14.337.206.566.013.043.048.093.144.093h.423c.047 0 .082-.014.103-.042.022-.028.026-.066.013-.112a7.24 7.24 0 0 0-.379-1.057.304.304 0 0 0-.28-.188Zm3.297 3.17h-3.843a.251.251 0 0 0-.248.248v.483c0 .151.064.225.199.225h3.943c.133 0 .197-.073.197-.225v-.483a.251.251 0 0 0-.248-.248Zm18.503 3.739c-.005-2.698-5.073-7.371-10.473-10.348-6.23-3.436-13.319-5.46-15.654-4.173-2.661 1.468-4.12 8.8-4.121 14.52 0 5.768 1.375 13.005 4.121 14.52 2.489 1.372 9.27-.653 15.654-4.172 5.485-3.024 10.468-7.519 10.473-10.347ZM34.862 21.796c3.931 0 10.23 2.486 14.418 4.795 2.396 1.32 5.115 3.248 7.219 5.21 2.019 1.88 3.923 4.222 3.927 6.218-.004 1.878-1.529 4.082-3.984 6.333-2.084 1.91-4.79 3.787-7.161 5.094-4.046 2.23-10.212 4.835-14.277 4.835-1.105 0-2.01-.19-2.695-.568-1.8-.992-2.953-3.665-3.635-6.284-.732-2.81-1.108-6.188-1.11-9.41 0-3.151.407-6.538 1.116-9.293.863-3.354 2.118-5.567 3.629-6.4.633-.352 1.493-.53 2.553-.53Z"
      })
    ], -1),
    g("rect", {
      width: "12",
      height: "12",
      x: "38",
      y: "78",
      fill: "#F36920",
      rx: "6"
    }, null, -1)
  ]));
}
const tL = /* @__PURE__ */ se(R3, [["render", q3]]), U3 = {}, Y3 = {
  "clip-path": "url(#a)",
  filter: "url(#b)"
};
function W3(t, e) {
  return m(), C("g", Y3, e[0] || (e[0] = [
    g("rect", {
      width: "72",
      height: "72",
      x: "6",
      y: "2",
      fill: "#3544B3",
      rx: "36"
    }, null, -1),
    g("g", { "clip-path": "url(#c)" }, [
      g("path", {
        fill: "#fff",
        d: "M36.693 36.256c-1.294 0-2.334.718-2.334 2.333 0 1.58 1.04 2.333 2.334 2.333 1.289 0 2.332-.754 2.332-2.333 0-1.615-1.043-2.333-2.332-2.333Zm0 3.556c-.579 0-1.011-.439-1.011-1.223 0-.853.432-1.226 1.01-1.226.576 0 1.01.373 1.01 1.226 0 .784-.434 1.224-1.01 1.224Zm8.406-3.515c0 .024.02.043.043.043h.982c.078 0 .141.064.141.14v.85c0 .024-.019.043-.043.043h-1.08a.043.043 0 0 0-.043.043v1.65c0 .632.24.82.64.82.187 0 .482-.115.525-.115.024 0 .044.019.044.043v.813a.139.139 0 0 1-.073.124c-.179.096-.478.162-.921.162-.774 0-1.492-.39-1.492-1.634v-2.868a1 1 0 0 1 .256-.668c.21-.23.881-.662.968-.662.038 0 .053.011.053.046v1.17Zm-15.608.187c0-.08.064-.143.144-.143h1.702c1.67 0 2.536 1.003 2.536 2.301 0 1.3-.968 2.199-2.563 2.199h-.497a.044.044 0 0 0-.045.044v2.104c0 .035-.014.047-.053.047-.087 0-.759-.432-.968-.662a1.005 1.005 0 0 1-.256-.668v-5.222Zm3.12 2.093c0-.553-.357-1.07-1.3-1.07h-.5a.043.043 0 0 0-.044.044v2.076c0 .024.02.044.043.044h.526c1.124 0 1.275-.78 1.275-1.094Zm10.553.876c0 .948-.681 1.469-2.01 1.469-.76 0-1.563-.267-1.57-.269a.15.15 0 0 1-.1-.139v-.883c0-.03.025-.052.056-.052l.018.003c.284.092 1.203.32 1.692.32.29 0 .44-.043.538-.14a.3.3 0 0 0 .097-.224c0-.29-.362-.37-.714-.446l-.143-.033c-.77-.182-1.58-.37-1.58-1.36 0-.44.183-.805.528-1.058.343-.253.84-.385 1.434-.385.534 0 1.168.176 1.38.244.067.022.105.08.105.14v.881c-.002.041-.045.06-.074.049a4.598 4.598 0 0 0-1.566-.308c-.318 0-.523.137-.523.35 0 .247.3.314.681.4l.308.069c.312.069.634.139.899.311.366.24.544.587.544 1.061Zm6.888 1.372a.027.027 0 0 1-.027-.027v-2.681c0-.596-.202-.85-.677-.85-.17 0-.374.063-.577.179-.202.117-.36.214-.417.248a.081.081 0 0 0-.033.059v3.046a.027.027 0 0 1-.027.027H47.1c-.015 0-.028-.013-.028-.027v-4.314c0-.07.057-.127.129-.127h1.095c.015 0 .029.012.029.027v.339c0 .02.017.037.037.037a.047.047 0 0 0 .021-.007l.037-.027a2.22 2.22 0 0 1 .476-.272c.3-.114.623-.18.885-.18.977 0 1.493.56 1.493 1.622v2.9c0 .015-.012.027-.028.027h-1.193Zm2.208 0a.027.027 0 0 1-.027-.027v-6.606c0-.024.004-.03.037-.03.074 0 .741.419.957.656.16.176.252.416.252.657v5.323a.027.027 0 0 1-.027.027H52.26ZM36.692 29.343a.13.13 0 0 0-.07.023 2.847 2.847 0 0 0-.532.523c-.046.05-.046.11.002.17.146.19.313.357.496.5.034.028.068.04.103.04a.163.163 0 0 0 .102-.04c.183-.144.35-.312.496-.5.048-.06.048-.12 0-.174a2.774 2.774 0 0 0-.524-.517.13.13 0 0 0-.073-.025Zm0 1.62a6.95 6.95 0 0 0-.303.006.131.131 0 0 0-.097.04.206.206 0 0 0-.052.137l.026 1.993.008.586c0 .05.036.154.148.154h.54c.081 0 .136-.056.148-.147v-.007l.032-2.545v-.032a.202.202 0 0 0-.05-.137.132.132 0 0 0-.1-.04 5.519 5.519 0 0 0-.3-.009Zm1.372.147a.299.299 0 0 0-.279.188 7.097 7.097 0 0 0-.378 1.056c-.012.046-.008.085.014.113.014.02.044.042.102.042h.423c.096 0 .13-.051.144-.093.07-.235.119-.372.207-.566.001-.002.008-.015.034-.015.01 0 .02.002.03.005l.215.071a.09.09 0 0 1 .049.047.154.154 0 0 1 .007.11c-.003.007-.434 1.213-.563 1.616-.02.062-.017.11.009.147.024.032.064.05.12.05h.524c.086 0 .142-.035.167-.104.02-.052.046-.127.078-.217l.013-.033c.157-.439.395-1.103.446-1.292.086-.32.11-.67-.36-.844a6.858 6.858 0 0 0-.885-.263l-.016-.004a.38.38 0 0 0-.1-.014Zm-2.745 0a.367.367 0 0 0-.093.011l-.021.005a6.721 6.721 0 0 0-.883.263c-.47.174-.446.524-.36.844.049.182.27.804.458 1.325l.078.217c.025.069.081.103.167.103h.523c.07 0 .104-.027.12-.05.027-.035.03-.083.01-.146a89.133 89.133 0 0 0-.564-1.615.154.154 0 0 1 .007-.11.086.086 0 0 1 .05-.047l.215-.071a.11.11 0 0 1 .029-.004c.021 0 .031.01.034.015.089.199.14.337.206.566.013.043.048.093.144.093h.423c.047 0 .082-.014.103-.042.022-.028.026-.066.013-.112a7.24 7.24 0 0 0-.379-1.057.304.304 0 0 0-.28-.188Zm3.297 3.17h-3.843a.251.251 0 0 0-.248.248v.483c0 .151.064.225.199.225h3.943c.133 0 .197-.073.197-.225v-.483a.251.251 0 0 0-.248-.248Zm18.503 3.739c-.005-2.698-5.073-7.371-10.473-10.348-6.23-3.436-13.319-5.46-15.654-4.173-2.662 1.468-4.12 8.8-4.121 14.52 0 5.768 1.375 13.005 4.121 14.52 2.489 1.372 9.27-.653 15.654-4.172 5.485-3.024 10.468-7.519 10.473-10.347ZM32.862 21.796c3.931 0 10.23 2.486 14.418 4.795 2.396 1.32 5.115 3.248 7.219 5.21 2.019 1.88 3.923 4.222 3.927 6.218-.004 1.878-1.529 4.082-3.984 6.333-2.084 1.91-4.79 3.787-7.161 5.094-4.046 2.23-10.212 4.835-14.277 4.835-1.105 0-2.01-.19-2.695-.568-1.8-.992-2.954-3.665-3.635-6.284-.732-2.81-1.108-6.188-1.11-9.41 0-3.151.407-6.538 1.116-9.293.863-3.354 2.118-5.567 3.629-6.4.633-.352 1.493-.53 2.553-.53Z"
      })
    ], -1),
    g("rect", {
      width: "12",
      height: "12",
      x: "36",
      y: "78",
      fill: "#3544B3",
      rx: "6"
    }, null, -1)
  ]));
}
const aL = /* @__PURE__ */ se(U3, [["render", W3]]), K3 = {}, G3 = {
  "clip-path": "url(#a)",
  filter: "url(#b)"
};
function X3(t, e) {
  return m(), C("g", G3, e[0] || (e[0] = [
    g("rect", {
      width: "72",
      height: "72",
      x: "6",
      y: "2",
      fill: "#FECC00",
      rx: "36"
    }, null, -1),
    g("path", {
      fill: "#D50029",
      d: "M30.413 37.217c-.285.386-.762 1.057-1.053 1.449-.147.2-.413.561.47.561h4.646l1.376-1.87c.854-1.16.074-3.571-2.979-3.571H20.85l-2.085 2.832h11.362c.574 0 .566.218.286.599ZM27 39.926c-.883 0-.617-.363-.47-.562.29-.392.776-1.056 1.06-1.442.282-.38.289-.599-.285-.599h-5.197l-4.186 5.69h10.21c3.372 0 5.25-2.294 5.828-3.087H27Zm6.641 3.087h5.99l2.27-3.087h-5.988c-.002 0-2.272 3.087-2.272 3.087Zm15.455-9.227-2.298 3.12h-2.673l2.296-3.12h-5.988l-4.006 5.441h14.65l4.006-5.441h-5.987Zm-6.792 9.227h5.988l2.271-3.087h-5.987c-.002 0-2.272 3.087-2.272 3.087Zm-32.929-1.87v.657h8.342l.482-.656H9.375Zm9.72-1.217h-9.72v.655h9.237l.483-.655Zm-9.72 3.087h7.448l.48-.652H9.375v.652Zm56.46-1.214h8.79v-.656h-8.308l-.482.656Zm-.893 1.214h9.683v-.652H65.42l-.48.652Zm2.27-3.087-.481.656h7.894v-.656h-7.413Zm-7.842-.699 4.005-5.441h-6.341c-.003 0-4.009 5.441-4.009 5.441h6.345Zm-6.858.699s-.438.598-.651.886c-.752 1.016-.087 2.201 2.367 2.201h9.616l2.272-3.087H52.511Z"
    }, null, -1),
    g("rect", {
      width: "12",
      height: "12",
      x: "36",
      y: "78",
      fill: "#FECC00",
      rx: "6"
    }, null, -1)
  ]));
}
const oL = /* @__PURE__ */ se(K3, [["render", X3]]), Q3 = {}, J3 = { "data-test": "icon-sort-desc" };
function e4(t, e) {
  return m(), C("g", J3, e[0] || (e[0] = [
    g("path", {
      d: "M3.64645 11.6464L0.853553 8.85355C0.538571 8.53857 0.761654 8 1.20711 8L6.79289 8C7.23835 8 7.46143 8.53857 7.14645 8.85355L4.35355 11.6464C4.15829 11.8417 3.84171 11.8417 3.64645 11.6464Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const t4 = /* @__PURE__ */ se(Q3, [["render", e4]]), a4 = {}, o4 = { "data-test": "icon-sort-asc" };
function n4(t, e) {
  return m(), C("g", o4, e[0] || (e[0] = [
    g("path", {
      d: "M3.64645 0.353553L0.853553 3.14645C0.538571 3.46143 0.761654 4 1.20711 4L6.79289 4C7.23835 4 7.46143 3.46143 7.14645 3.14645L4.35355 0.353553C4.15829 0.158291 3.84171 0.158291 3.64645 0.353553Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const r4 = /* @__PURE__ */ se(a4, [["render", n4]]), s4 = {}, i4 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.5 4a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 0 0 1h4a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 21 2.5H3A1.5 1.5 0 0 0 1.5 4v13A1.5 1.5 0 0 0 3 18.5h4a.5.5 0 0 0 0-1H3a.5.5 0 0 1-.5-.5V4Zm10 7a.5.5 0 1 0-1 0v10.793l-2.146-2.146a.5.5 0 1 0-.708.707l3 3a.5.5 0 0 0 .707 0l3-3a.5.5 0 0 0-.707-.708L12.5 21.793V11Z",
  "clip-rule": "evenodd"
};
function l4(t, e) {
  return m(), C("path", i4);
}
const nL = /* @__PURE__ */ se(s4, [["render", l4]]), u4 = {}, c4 = {
  fill: "currentColor",
  d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM12.5 1H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5ZM2.707 3H4V1.707L2.707 3Z"
};
function d4(t, e) {
  return m(), C("path", c4);
}
const rL = /* @__PURE__ */ se(u4, [["render", d4]]), m4 = {}, p4 = {
  d: "M7 10.577L3.4615 7.0385L4.16925 6.31925L6.5 8.65V0H7.5V8.65L9.83075 6.31925L10.5385 7.0385L7 10.577ZM1.6155 14C1.15517 14 0.770833 13.8458 0.4625 13.5375C0.154167 13.2292 0 12.8448 0 12.3845V9.9615H1V12.3845C1 12.5385 1.06408 12.6796 1.19225 12.8077C1.32042 12.9359 1.4615 13 1.6155 13H12.3845C12.5385 13 12.6796 12.9359 12.8077 12.8077C12.9359 12.6796 13 12.5385 13 12.3845V9.9615H14V12.3845C14 12.8448 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8448 14 12.3845 14H1.6155Z",
  fill: "currentColor"
};
function f4(t, e) {
  return m(), C("path", p4);
}
const sL = /* @__PURE__ */ se(m4, [["render", f4]]), h4 = {}, v4 = {
  fill: "currentColor",
  d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5V6h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v1.5a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM13 1.5a.5.5 0 0 0-.5-.5H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V13H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8V1.5ZM2.707 3H4V1.707L2.707 3ZM6 12h9V7H5v5h1Zm5.778-3.999a.25.25 0 0 0-.267.32l.75 2.5a.25.25 0 0 0 .479 0l.75-2.5a.25.25 0 0 0-.479-.142l-.51 1.701-.511-1.701A.25.25 0 0 0 11.777 8Zm-5.278.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75.25.25 0 0 1-.25.25.25.25 0 0 1-.25-.25.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25v1.5c0 .137.112.25.25.25h.5a.25.25 0 0 0 .25-.25.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25c0 .412-.337.75-.75.75h-.5a.752.752 0 0 1-.75-.75v-1.5Zm2.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75.25.25 0 0 1-.25.25.25.25 0 0 1-.25-.25.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25V9c0 .137.112.25.25.25h.5A.75.75 0 0 1 11 10v.25c0 .412-.337.75-.75.75h-.5a.752.752 0 0 1-.75-.75.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25c0 .137.112.25.25.25h.5a.25.25 0 0 0 .25-.25V10a.25.25 0 0 0-.25-.25h-.5A.751.751 0 0 1 9 9v-.25Z"
};
function g4(t, e) {
  return m(), C("path", v4);
}
const iL = /* @__PURE__ */ se(h4, [["render", g4]]), y4 = {}, b4 = {
  fill: "currentColor",
  d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5V6h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v1.5a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM13 1.5a.5.5 0 0 0-.5-.5H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V13H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8V1.5ZM5 12h10V7H5v5ZM2.707 3H4V1.707L2.707 3Zm9.793 7.75a.25.25 0 1 1-.5 0v-2.5a.25.25 0 0 1 .25-.25h1.25a.25.25 0 1 1 0 .5h-1v1h.75a.25.25 0 1 1 0 .5h-.75v.75Zm-5 0a.25.25 0 1 1-.5 0v-2.5A.25.25 0 0 1 7.25 8h1a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H7.5v.75Zm.75-2.25H7.5v1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25ZM10.5 11h-.75a.25.25 0 0 1-.25-.25v-2.5A.25.25 0 0 1 9.75 8h.75a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm0-2.5H10v2h.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5Z"
};
function k4(t, e) {
  return m(), C("path", b4);
}
const lL = /* @__PURE__ */ se(y4, [["render", k4]]), C4 = {}, w4 = {
  fill: "currentColor",
  d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v11A1.5 1.5 0 0 0 2.5 16h10a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0h-8ZM5 1h7.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1ZM4 3H2.707L4 1.707V3Zm1 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H5Zm-.5 2.5A.5.5 0 0 1 5 9h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM5 11a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H5Z"
};
function _4(t, e) {
  return m(), C("path", w4);
}
const uL = /* @__PURE__ */ se(C4, [["render", _4]]), H4 = {};
function j4(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      d: "M8 45V12.4142C8 12.149 8.10536 11.8946 8.29289 11.7071L17.7071 2.29289C17.8946 2.10536 18.149 2 18.4142 2H38C38.5523 2 39 2.44771 39 3V45C39 45.5523 38.5523 46 38 46H9C8.44772 46 8 45.5523 8 45Z",
      stroke: "currentColor",
      fill: "none",
      "stroke-width": "1.5"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M28 24L31 24C31.5523 24 32 24.4477 32 25L32 34C32 34.5523 31.5523 35 31 35L16 35C15.4477 35 15 34.5523 15 34L15 25C15 24.4477 15.4477 24 16 24L19 24",
      stroke: "currentColor",
      fill: "none",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)),
    e[2] || (e[2] = g("path", {
      d: "M23.5003 29L23.5001 18M23.5001 18L27 21M23.5001 18L20.0002 21",
      stroke: "currentColor",
      fill: "none",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)),
    e[3] || (e[3] = g("path", {
      d: "M8 12H17C17.5523 12 18 11.5523 18 11V2",
      stroke: "currentColor",
      fill: "none",
      "stroke-width": "1.5"
    }, null, -1))
  ], 64);
}
const L4 = /* @__PURE__ */ se(H4, [["render", j4]]), x4 = {}, $4 = {
  fill: "currentColor",
  d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v11A1.5 1.5 0 0 0 2.5 16h10a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0h-8ZM5 1h7.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1ZM4 3H2.707L4 1.707V3Zm2.307 2.105A.5.5 0 0 0 5.5 5.5v7a.5.5 0 0 0 .807.395l4.5-3.5a.5.5 0 0 0 0-.79l-4.5-3.5ZM9.686 9 6.5 11.478V6.522L9.686 9Z"
};
function M4(t, e) {
  return m(), C("path", $4);
}
const cL = /* @__PURE__ */ se(x4, [["render", M4]]), V4 = {}, S4 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.5 2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h2a.5.5 0 1 0 0-1H2a.5.5 0 0 1-.5-.5V2Zm7 5a.5.5 0 0 0-1 0v6.793l-1.146-1.146a.5.5 0 1 0-.708.707l2 2a.5.5 0 0 0 .707 0l2-2a.5.5 0 1 0-.707-.707L8.5 13.793V7Z",
  "clip-rule": "evenodd"
};
function A4(t, e) {
  return m(), C("path", S4);
}
const dL = /* @__PURE__ */ se(V4, [["render", A4]]), E4 = {}, D4 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 33H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2h-6M24 23v21m0 0-8-8m8 8 8-8"
};
function P4(t, e) {
  return m(), C("path", D4);
}
const z4 = /* @__PURE__ */ se(E4, [["render", P4]]), T4 = {}, O4 = {
  d: "M15 4.5L22 12M22 12L15 19.5M22 12L3 12",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function F4(t, e) {
  return m(), C("path", O4);
}
const mL = /* @__PURE__ */ se(T4, [["render", F4]]), B4 = {}, I4 = {
  d: "M3 9.5L8 14.5M8 14.5L13 9.5M8 14.5L8 1.5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Z4(t, e) {
  return m(), C("path", I4);
}
const pL = /* @__PURE__ */ se(B4, [["render", Z4]]), R4 = {}, N4 = {
  d: "M3 6.33317L8 1.6665M8 1.6665L13 6.33317M8 1.6665L8 14.3332",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function q4(t, e) {
  return m(), C("path", N4);
}
const fL = /* @__PURE__ */ se(R4, [["render", q4]]), U4 = {}, Y4 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.53 12a7.47 7.47 0 1 1 14.46 2.643l-1.505-2.606a.53.53 0 1 0-.917.53l2.121 3.674a.53.53 0 0 0 .724.194l3.674-2.121a.53.53 0 0 0-.53-.917l-2.515 1.452c.316-.892.487-1.85.487-2.849A8.53 8.53 0 1 0 11 20.53a.53.53 0 1 0 0-1.06A7.47 7.47 0 0 1 3.53 12Z",
  "clip-rule": "evenodd"
};
function W4(t, e) {
  return m(), C("path", Y4);
}
const hL = /* @__PURE__ */ se(U4, [["render", W4]]), K4 = {}, G4 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.5 7.5a5 5 0 1 1 9.853 1.208l-.802-1.39a.5.5 0 1 0-.866.5l1.414 2.45a.5.5 0 0 0 .683.183l2.45-1.415a.5.5 0 1 0-.5-.866l-1.418.819A6 6 0 1 0 7.5 13.5a.5.5 0 0 0 0-1 5 5 0 0 1-5-5Z",
  "clip-rule": "evenodd"
};
function X4(t, e) {
  return m(), C("path", G4);
}
const vL = /* @__PURE__ */ se(K4, [["render", X4]]), Q4 = {}, J4 = {
  fill: "currentColor",
  d: "M18.854 5.147a.5.5 0 0 1 0 .707L12.707 12l6.147 6.146a.5.5 0 0 1-.708.708L12 12.707l-6.146 6.147a.5.5 0 1 1-.708-.707L11.293 12 5.146 5.854a.5.5 0 1 1 .707-.707L12 11.293l6.146-6.146a.5.5 0 0 1 .708 0Z"
};
function e7(t, e) {
  return m(), C("path", J4);
}
const Fi = /* @__PURE__ */ se(Q4, [["render", e7]]), t7 = {}, a7 = {
  fill: "currentColor",
  d: "M12.687 3.313a.5.5 0 0 1 0 .707L8.707 8l3.98 3.98a.5.5 0 0 1-.707.707L8 8.707l-3.98 3.98a.5.5 0 0 1-.707-.707L7.293 8l-3.98-3.98a.5.5 0 0 1 .707-.707L8 7.293l3.98-3.98a.5.5 0 0 1 .707 0Z"
};
function o7(t, e) {
  return m(), C("path", a7);
}
const n7 = /* @__PURE__ */ se(t7, [["render", o7]]), r7 = {}, s7 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.49939 7.5C6.49939 4.46243 8.96182 2 11.9994 2C15.037 2 17.4994 4.46243 17.4994 7.5C17.4994 10.5376 15.037 13 11.9994 13C8.96182 13 6.49939 10.5376 6.49939 7.5ZM11.9994 1C8.40954 1 5.49939 3.91015 5.49939 7.5C5.49939 9.28187 6.21638 10.8963 7.37759 12.0705C3.89823 13.7966 1.99951 17.4025 1.99951 21.5C1.99951 21.7761 2.22337 22 2.49951 22C2.77565 22 2.99951 21.7761 2.99951 21.5C2.99951 17.5588 4.88346 14.2392 8.1997 12.7902L8.21324 12.7841C9.27945 13.5494 10.5868 14 11.9994 14C13.412 14 14.7194 13.5494 15.7856 12.784L15.7993 12.7902C16.2161 12.9723 16.6092 13.1833 16.9782 13.4206C17.2104 13.5699 17.5198 13.5027 17.6691 13.2705C17.8185 13.0382 17.7513 12.7288 17.519 12.5795C17.2322 12.395 16.9328 12.225 16.6212 12.0704C17.7824 10.8962 18.4994 9.28184 18.4994 7.5C18.4994 3.91015 15.5892 1 11.9994 1ZM16.0535 15.351C16.2981 14.6795 16.9422 14.2 17.6983 14.2C18.4543 14.2 19.0984 14.6795 19.343 15.351C20.0469 15.2271 20.7841 15.5451 21.1622 16.1999C21.5402 16.8547 21.447 17.6523 20.9877 18.1999C21.447 18.7475 21.5402 19.5451 21.1622 20.1999C20.7842 20.8547 20.0469 21.1727 19.3431 21.0489C19.0986 21.7205 18.4544 22.2 17.6983 22.2C16.9421 22.2 16.2979 21.7204 16.0534 21.0488C15.3495 21.1728 14.6121 20.8548 14.234 20.1999C13.8559 19.5451 13.9491 18.7475 14.4084 18.1999C13.9491 17.6523 13.8559 16.8547 14.234 16.1999C14.6121 15.545 15.3495 15.227 16.0535 15.351ZM16.1245 19.9744C16.1913 19.9359 16.2747 19.9442 16.336 19.9909C16.4865 20.1056 16.6519 20.2017 16.8288 20.2759C16.8996 20.3056 16.9483 20.3733 16.9483 20.45C16.9483 20.8643 17.284 21.2 17.6983 21.2C18.1125 21.2 18.4483 20.8643 18.4483 20.45C18.4483 20.3733 18.4969 20.3056 18.5677 20.2759C18.7446 20.2017 18.91 20.1056 19.0606 19.9909C19.1218 19.9443 19.205 19.936 19.2716 19.9744C19.6303 20.1815 20.089 20.0586 20.2961 19.6999C20.5033 19.3412 20.3803 18.8825 20.0216 18.6754C19.9552 18.637 19.9208 18.561 19.9304 18.4849C19.9422 18.3916 19.9483 18.2965 19.9483 18.2C19.9483 18.1035 19.9422 18.0084 19.9304 17.915C19.9208 17.8388 19.9551 17.7628 20.0216 17.7244C20.3803 17.5173 20.5033 17.0586 20.2961 16.6999C20.089 16.3412 19.6303 16.2183 19.2716 16.4254C19.2049 16.4639 19.1215 16.4556 19.0602 16.4089C18.9098 16.2943 18.7445 16.1983 18.5677 16.1242C18.4969 16.0945 18.4483 16.0268 18.4483 15.95C18.4483 15.5358 18.1125 15.2 17.6983 15.2C17.284 15.2 16.9483 15.5358 16.9483 15.95C16.9483 16.0268 16.8996 16.0945 16.8288 16.1242C16.6521 16.1983 16.4868 16.2943 16.3364 16.4089C16.2749 16.4557 16.1914 16.464 16.1245 16.4254C15.7658 16.2183 15.3071 16.3412 15.1 16.6999C14.8929 17.0586 15.0158 17.5173 15.3745 17.7244C15.4412 17.7629 15.4757 17.8392 15.4661 17.9156C15.4543 18.0088 15.4483 18.1037 15.4483 18.2C15.4483 18.2963 15.4543 18.3912 15.466 18.4843C15.4757 18.5607 15.4412 18.6369 15.3745 18.6754C15.0158 18.8825 14.8929 19.3412 15.1 19.6999C15.3071 20.0586 15.7658 20.1815 16.1245 19.9744ZM18.45 18.2C18.45 18.6142 18.1142 18.95 17.7 18.95C17.2857 18.95 16.95 18.6142 16.95 18.2C16.95 17.7858 17.2857 17.45 17.7 17.45C18.1142 17.45 18.45 17.7858 18.45 18.2ZM19.2 18.2C19.2 19.0284 18.5284 19.7 17.7 19.7C16.8715 19.7 16.2 19.0284 16.2 18.2C16.2 17.3716 16.8715 16.7 17.7 16.7C18.5284 16.7 19.2 17.3716 19.2 18.2Z",
  fill: "currentColor"
};
function i7(t, e) {
  return m(), C("path", s7);
}
const gL = /* @__PURE__ */ se(r7, [["render", i7]]), l7 = {}, u7 = { fill: "currentColor" };
function c7(t, e) {
  return m(), C("g", u7, e[0] || (e[0] = [
    g("path", { d: "M32.91 7.59a.764.764 0 0 1-.06-1.09c.28-.32.77-.35 1.09-.06.86.76 1.61 1.64 2.25 2.59.24.36.14.84-.22 1.07-.13.09-.28.13-.43.13-.25 0-.5-.12-.65-.35-.55-.84-1.22-1.61-1.98-2.29zm2.06 17.83a13.33 13.33 0 0 0 3.46-8.97c0-1.44-.23-2.86-.68-4.22a.764.764 0 0 0-.98-.49c-.41.13-.63.57-.49.98.4 1.2.6 2.45.6 3.73 0 6.55-5.33 11.88-11.88 11.88S13.13 23 13.13 16.45 18.46 4.58 25 4.58c1.79 0 3.51.39 5.11 1.15l.28.14c.38.19.85.04 1.04-.34s.04-.85-.34-1.04l-.32-.16c-1.8-.86-3.74-1.3-5.77-1.3-7.4 0-13.43 6.02-13.43 13.43 0 3.48 1.34 6.64 3.52 9.03C7.23 29.3 2.17 37.32 2.17 46.09c0 .43.35.77.77.77s.77-.35.77-.77c0-8.37 4.92-16 12.55-19.46 2.35 2.02 5.4 3.25 8.73 3.25 3.37 0 6.44-1.25 8.8-3.31.01 0 .01.01.02.02 7.67 3.44 12.63 11.1 12.63 19.5 0 .43.35.77.77.77s.77-.35.77-.77c.03-8.82-5.08-16.87-13.01-20.67z" }, null, -1),
    g("path", { d: "M47.23 46.99c-.5 0-.9-.4-.9-.9 0-8.34-4.91-15.94-12.51-19.37A13.503 13.503 0 0 1 25.01 30c-3.2 0-6.3-1.15-8.76-3.23-7.54 3.46-12.4 11.03-12.4 19.32 0 .5-.4.9-.9.9s-.9-.4-.9-.9c0-8.7 5.04-16.79 12.84-20.65a13.495 13.495 0 0 1-3.44-8.99C11.45 8.98 17.53 2.9 25 2.9c2.04 0 4.01.44 5.83 1.32l.32.16c.44.23.62.77.39 1.21-.11.21-.3.37-.52.45-.23.08-.47.06-.69-.05l-.28-.14A11.5 11.5 0 0 0 25 4.7c-6.48 0-11.75 5.27-11.75 11.75S18.53 28.21 25 28.21c6.48 0 11.75-5.27 11.75-11.75 0-1.26-.2-2.5-.59-3.69-.16-.47.1-.98.57-1.14a.85.85 0 0 1 .68.05c.22.11.38.29.45.52.45 1.37.68 2.8.68 4.26 0 3.28-1.2 6.45-3.39 8.93 7.88 3.84 12.96 11.95 12.96 20.71.02.49-.38.89-.88.89zM33.8 26.45c.02 0 .04 0 .06.01.01 0 .03.02.04.03 7.7 3.45 12.68 11.15 12.68 19.61 0 .36.29.65.65.65s.65-.29.65-.65c0-8.72-5.09-16.79-12.97-20.56-.04-.02-.06-.05-.07-.09s0-.08.03-.11c2.21-2.46 3.43-5.61 3.43-8.89 0-1.43-.23-2.83-.67-4.18a.62.62 0 0 0-.33-.38.641.641 0 0 0-.9.78c.4 1.21.6 2.48.6 3.77 0 6.62-5.38 12-12 12s-12-5.38-12-12 5.38-12 12-12c1.81 0 3.55.39 5.17 1.17l.28.14c.16.08.33.09.5.04a.645.645 0 0 0 .1-1.19l-.32-.16c-1.79-.85-3.72-1.29-5.73-1.29-7.33 0-13.3 5.97-13.3 13.3 0 3.3 1.24 6.48 3.48 8.94.03.03.04.07.03.11-.01.04-.03.07-.07.09-7.8 3.8-12.84 11.84-12.84 20.5 0 .36.29.65.65.65s.65-.29.65-.65c0-8.41 4.95-16.1 12.62-19.58.04-.02.1-.01.13.02 2.42 2.08 5.49 3.22 8.65 3.22 3.19 0 6.29-1.16 8.72-3.28.02-.01.05-.02.08-.02zm1.74-16.1c-.3 0-.58-.15-.75-.4-.56-.83-1.22-1.6-1.97-2.27a.877.877 0 0 1-.3-.62c-.01-.24.07-.47.23-.65.16-.18.38-.29.62-.3.23-.01.47.07.65.23.87.77 1.63 1.65 2.27 2.61.13.2.18.44.13.68a.89.89 0 0 1-.88.72zm-2.12-3.99h-.04c-.17.01-.33.09-.45.22s-.17.3-.16.47.09.33.22.45c.77.68 1.44 1.46 2.01 2.32.19.29.61.37.9.18.14-.1.24-.24.28-.41a.66.66 0 0 0-.1-.49 13.33 13.33 0 0 0-2.23-2.57.613.613 0 0 0-.43-.17z" }, null, -1)
  ]));
}
const yL = /* @__PURE__ */ se(l7, [["render", c7]]), d7 = {}, m7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM12 1.5a6.5 6.5 0 0 0-4.623 11.07A10.5 10.5 0 0 0 1.5 22a.5.5 0 1 0 1 0 9.502 9.502 0 0 1 5.714-8.716A6.47 6.47 0 0 0 12 14.5a6.47 6.47 0 0 0 3.786-1.216l.014.006A9.502 9.502 0 0 1 21.5 22a.5.5 0 1 0 1 0 10.5 10.5 0 0 0-5.878-9.43A6.5 6.5 0 0 0 12 1.5Z",
  "clip-rule": "evenodd"
};
function p7(t, e) {
  return m(), C("path", m7);
}
const bL = /* @__PURE__ */ se(d7, [["render", p7]]), f7 = {}, h7 = {
  fill: "none",
  d: "M6 8.5L7.3905 19.624C7.45306 20.1245 7.87846 20.5 8.38278 20.5H15.6172C16.1215 20.5 16.5469 20.1245 16.6095 19.624L18 8.5M6 8.5H5.5C4.94772 8.5 4.5 8.05228 4.5 7.5V5.5C4.5 4.94772 4.94772 4.5 5.5 4.5H8.5M6 8.5H18M18 8.5H18.5C19.0523 8.5 19.5 8.05228 19.5 7.5V5.5C19.5 4.94772 19.0523 4.5 18.5 4.5H15.5M8.5 4.5L9.7 2.9C9.88885 2.64819 10.1852 2.5 10.5 2.5H13.5C13.8148 2.5 14.1111 2.64819 14.3 2.9L15.5 4.5M8.5 4.5H15.5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function v7(t, e) {
  return m(), C("path", h7);
}
const Bi = /* @__PURE__ */ se(f7, [["render", v7]]), g7 = {}, y7 = {
  fill: "currentColor",
  d: "M10.618 3H13.5a.5.5 0 0 1 .4.2l.6.8H9.809l.362-.724A.5.5 0 0 1 10.618 3Zm5.132 1L14.7 2.6a1.5 1.5 0 0 0-1.2-.6h-2.882a1.5 1.5 0 0 0-1.342.83L8.691 4H5.5A1.5 1.5 0 0 0 4 5.5v2A1.5 1.5 0 0 0 5.5 9h.059l1.335 10.686A1.5 1.5 0 0 0 8.383 21h7.234a1.5 1.5 0 0 0 1.489-1.314L18.44 9h.059A1.5 1.5 0 0 0 20 7.5v-2A1.5 1.5 0 0 0 18.5 4h-2.75Zm1.684 5-1.32 10.562a.5.5 0 0 1-.497.438H8.383a.5.5 0 0 1-.496-.438L6.567 9h10.867ZM5.5 5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5Z"
};
function b7(t, e) {
  return m(), C("path", y7);
}
const kL = /* @__PURE__ */ se(g7, [["render", b7]]), k7 = {}, C7 = {
  fill: "currentColor",
  d: "M6.618 2h2.764a.5.5 0 0 1 .447.276l.362.724H5.809l.362-.724A.5.5 0 0 1 6.618 2Zm4.691 1-.585-1.17A1.5 1.5 0 0 0 9.382 1H6.618a1.5 1.5 0 0 0-1.342.83L4.691 3H3a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.05 1.431l.844 6.755A1.5 1.5 0 0 0 4.883 15h6.234a1.5 1.5 0 0 0 1.489-1.314l.844-6.755A1.5 1.5 0 0 0 14.5 5.5v-1A1.5 1.5 0 0 0 13 3h-1.691Zm1.125 4-.82 6.562a.5.5 0 0 1-.497.438H4.883a.5.5 0 0 1-.496-.438L3.567 7h8.867ZM3 4h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 3 4Z"
};
function w7(t, e) {
  return m(), C("path", C7);
}
const _7 = /* @__PURE__ */ se(k7, [["render", w7]]), H7 = {}, j7 = {
  d: "M 14.234 2.731 C 14.922 2.916 15.466 3.461 15.651 4.149 C 15.99 5.402 16 8 16 8 C 16 8 16 10.608 15.661 11.851 C 15.476 12.539 14.932 13.083 14.244 13.268 C 13.001 13.607 8 13.607 8 13.607 C 8 13.607 2.999 13.607 1.756 13.268 C 1.068 13.083 0.524 12.539 0.339 11.851 C 0 10.598 0 8 0 8 C 0 8 0 5.402 0.329 4.159 C 0.513 3.471 1.058 2.927 1.746 2.742 C 2.988 2.403 7.99 2.393 7.99 2.393 C 7.99 2.393 12.991 2.393 14.234 2.731 Z M 10.547 8 L 6.398 5.597 L 6.398 10.403 L 10.547 8 Z",
  fill: "currentColor"
};
function L7(t, e) {
  return m(), C("path", j7);
}
const CL = /* @__PURE__ */ se(H7, [["render", L7]]), x7 = {}, $7 = {
  fill: "currentColor",
  d: "M20 2.62037V7.26328C20.0444 7.30152 20.095 7.34618 20.1504 7.39695C20.352 7.58178 20.6208 7.85047 20.8904 8.18756C21.4216 8.85152 22 9.83589 22 10.9999C22 12.1639 21.4216 13.1483 20.8904 13.8123C20.6208 14.1493 20.352 14.418 20.1504 14.6029C20.095 14.6536 20.0444 14.6983 20 14.7365V18.3794C20 19.1222 19.4909 19.64 18.9248 19.8397C18.3612 20.0386 17.6431 19.9594 17.1571 19.4199C16.2568 18.4206 15.1309 17.3024 13.9435 16.4378C12.7424 15.5631 11.5484 14.9999 10.5 14.9999H8.6099L9.63842 20.1425C9.88234 21.3621 8.94954 22.4999 7.70583 22.4999C6.76635 22.4999 5.95747 21.8368 5.77323 20.9156L4.58439 14.9713C3.12423 14.769 2 13.5157 2 11.9999V9.4999C2 7.56702 3.56635 5.9999 5.49946 5.9999H10.5C11.5484 5.9999 12.7424 5.4367 13.9435 4.56203C15.1309 3.69739 16.2568 2.57917 17.1571 1.57989C17.6431 1.04042 18.3612 0.961191 18.9248 1.1601C19.4909 1.35984 20 1.87757 20 2.62037ZM20 8.67943V13.3204C20.0364 13.2776 20.073 13.2333 20.1096 13.1876C20.5784 12.6015 21 11.8359 21 10.9999C21 10.1639 20.5784 9.39829 20.1096 8.81225C20.073 8.76653 20.0364 8.72224 20 8.67943ZM19 6.4999V2.62037C19 2.39033 18.849 2.19376 18.5921 2.10311C18.3328 2.01162 18.0652 2.06591 17.9 2.24922C16.9769 3.27391 15.7984 4.44837 14.5322 5.37041C13.4316 6.17185 12.2104 6.82308 11 6.9692V14.0306C12.2104 14.1767 13.4316 14.828 14.5322 15.6294C15.7984 16.5514 16.9769 17.7259 17.9 18.7506C18.0652 18.9339 18.3328 18.9882 18.5921 18.8967C18.849 18.8061 19 18.6095 19 18.3794V15.4999V6.4999ZM6.75381 20.7194C6.84457 21.1732 7.24303 21.4999 7.70583 21.4999C8.31849 21.4999 8.778 20.9394 8.65784 20.3386L7.5901 14.9999H5.6099L6.75381 20.7194ZM10 13.9999V6.9999H5.49946C4.11887 6.9999 3 8.11907 3 9.4999V11.9999C3 13.1045 3.89543 13.9999 5 13.9999H8.00003H10Z"
};
function M7(t, e) {
  return m(), C("path", $7);
}
const wL = /* @__PURE__ */ se(x7, [["render", M7]]), V7 = {};
function S7(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      fill: "currentColor",
      d: "M48.76,22.73h-2.64c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h2.64c0.5,0,0.9-0.4,0.9-0.9S49.26,22.73,48.76,22.73z"
    }, null, -1),
    g("path", {
      fill: "currentColor",
      d: "M44.44,17.91c0.23,0,0.44-0.08,0.61-0.24l2.5-2.29c0.18-0.16,0.28-0.38,0.29-0.62c0.01-0.24-0.07-0.47-0.24-0.65 c-0.34-0.37-0.91-0.39-1.27-0.05l-2.5,2.29c-0.37,0.33-0.39,0.91-0.06,1.27C43.94,17.8,44.19,17.91,44.44,17.91z"
    }, null, -1),
    g("path", {
      fill: "currentColor",
      d: "M45.16,29.63c-0.19-0.15-0.42-0.22-0.66-0.2c-0.24,0.02-0.45,0.14-0.61,0.32c-0.15,0.18-0.22,0.42-0.2,0.66 c0.02,0.24,0.14,0.46,0.32,0.61l2.62,2.16c0.16,0.13,0.36,0.21,0.57,0.21c0.27,0,0.52-0.12,0.69-0.33 c0.32-0.38,0.26-0.95-0.12-1.27L45.16,29.63z"
    }, null, -1)
  ]));
}
const _L = /* @__PURE__ */ se(V7, [["render", S7]]), A7 = {}, E7 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 8C5 9.10457 4.10457 10 3 10C1.89543 10 1 9.10457 1 8C1 6.89543 1.89543 6 3 6C4.10457 6 5 6.89543 5 8ZM3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8ZM8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM13 10C14.1046 10 15 9.10457 15 8C15 6.89543 14.1046 6 13 6C11.8954 6 11 6.89543 11 8C11 9.10457 11.8954 10 13 10ZM14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z",
  fill: "black",
  "fill-opacity": "0.6"
};
function D7(t, e) {
  return m(), C("path", E7);
}
const P7 = /* @__PURE__ */ se(A7, [["render", D7]]), z7 = {}, T7 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12ZM7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14ZM18 12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12Z",
  fill: "currentColor"
};
function O7(t, e) {
  return m(), C("path", T7);
}
const HL = /* @__PURE__ */ se(z7, [["render", O7]]), F7 = {}, B7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.5321 1.70114C13.2721 1.77623 12.958 1.99634 12.6559 2.5195C12.5114 2.76986 12.4293 3.11722 12.4021 3.52334C12.3753 3.92342 12.4041 4.34214 12.4507 4.70676C12.4792 4.9289 12.6851 5.04779 12.8917 4.96135C13.2308 4.81947 13.6078 4.63504 13.9409 4.4118C14.279 4.18518 14.5388 3.9404 14.6834 3.69005C14.9854 3.16689 15.0189 2.78476 14.954 2.52206C14.8894 2.26081 14.7057 2.02982 14.3941 1.84993C14.0825 1.67004 13.7907 1.62647 13.5321 1.70114ZM13.2546 0.740411C13.8339 0.573095 14.4067 0.702488 14.8941 0.983906C15.3815 1.26532 15.78 1.69664 15.9247 2.282C16.0691 2.86591 15.9393 3.5147 15.5494 4.19005C15.2971 4.62707 14.8978 4.97429 14.4977 5.24247C14.4615 5.26674 14.425 5.29054 14.3883 5.31388H21.187C22.5396 5.31388 23.636 6.41032 23.636 7.76285C23.636 8.62276 23.1928 9.37915 22.5224 9.81607V19.9621C22.5224 21.3428 21.4031 22.4621 20.0224 22.4621H3.97582C2.59511 22.4621 1.47582 21.3428 1.47582 19.9621V9.81615C0.805317 9.37925 0.362061 8.62281 0.362061 7.76285C0.362061 6.41032 1.4585 5.31388 2.81103 5.31388H9.04803C8.65286 4.90466 8.42429 4.4405 8.39372 3.96522C8.36186 3.46972 8.54972 3.01624 8.88922 2.67675C9.22872 2.33725 9.68219 2.14939 10.1777 2.18125C10.6408 2.21103 11.0933 2.42881 11.4948 2.80552C11.5557 2.53192 11.6493 2.26294 11.7899 2.0195C12.1798 1.34415 12.6767 0.907314 13.2546 0.740411ZM2.47582 10.1891V19.9621C2.47582 20.7905 3.14739 21.4621 3.97582 21.4621H20.0224C20.8508 21.4621 21.5224 20.7905 21.5224 19.9621V10.189C21.4127 10.2041 21.3008 10.2118 21.187 10.2118H14.2264C13.9503 10.2118 13.7264 9.98796 13.7264 9.71181C13.7264 9.43567 13.9503 9.21181 14.2264 9.21181H21.187C21.9873 9.21181 22.636 8.56309 22.636 7.76285C22.636 6.9626 21.9873 6.31388 21.187 6.31388H12.4992V18.6214C12.4992 18.8975 12.2753 19.1214 11.9992 19.1214C11.723 19.1214 11.4992 18.8975 11.4992 18.6214V10.2118H2.81103C2.69732 10.2118 2.58542 10.2041 2.47582 10.1891ZM2.81103 6.31388H11.4992V9.21181H2.81103C2.01079 9.21181 1.36206 8.56309 1.36206 7.76285C1.36206 6.9626 2.01079 6.31388 2.81103 6.31388ZM9.7932 4.6455C9.50499 4.35729 9.4042 4.09606 9.39166 3.90104C9.37945 3.71117 9.44653 3.53365 9.59632 3.38385C9.74612 3.23406 9.92364 3.16698 10.1135 3.17919C10.3085 3.19173 10.5698 3.29252 10.858 3.58073C11.092 3.81477 11.2263 4.27694 11.2803 4.7761C11.2996 4.95419 11.1667 5.08709 10.9886 5.06783C10.4894 5.01383 10.0272 4.87955 9.7932 4.6455Z"
};
function I7(t, e) {
  return m(), C("path", B7);
}
const Z7 = /* @__PURE__ */ se(F7, [["render", I7]]), R7 = {}, N7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.5 7.5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1.469a2.5 2.5 0 0 1-1.572 2.321l-1.228.491a3.5 3.5 0 0 0-2.2 3.25V17a.5.5 0 0 0 1 0v-1.969a2.5 2.5 0 0 1 1.572-2.321l1.228-.491a3.5 3.5 0 0 0 2.2-3.25V7.5a4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4V9a.5.5 0 0 0 1 0V7.5ZM12 19a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
  "clip-rule": "evenodd"
};
function q7(t, e) {
  return m(), C("path", N7);
}
const jL = /* @__PURE__ */ se(R7, [["render", q7]]), U7 = {}, Y7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm1 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7.5 4.5a1 1 0 0 0-1 1v.071a.5.5 0 0 1-1 0V5.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v.84a2.15 2.15 0 0 1-1.303 1.977A1.15 1.15 0 0 0 8.5 9.374V10a.5.5 0 0 1-1 0v-.626c0-.86.513-1.638 1.303-1.976A1.15 1.15 0 0 0 9.5 6.34V5.5a1 1 0 0 0-1-1h-1Zm-.25 7.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z",
  "clip-rule": "evenodd"
};
function W7(t, e) {
  return m(), C("path", Y7);
}
const LL = /* @__PURE__ */ se(U7, [["render", W7]]), K7 = {}, G7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.5 4A1.5 1.5 0 0 1 7 2.5h2A1.5 1.5 0 0 1 10.5 4v.93c0 .501-.25.97-.668 1.248l-1.219.812A2.5 2.5 0 0 0 7.5 9.07V10a.5.5 0 0 0 1 0v-.93c0-.501.25-.97.668-1.248l1.219-.812A2.5 2.5 0 0 0 11.5 4.93V4A2.5 2.5 0 0 0 9 1.5H7A2.5 2.5 0 0 0 4.5 4v1a.5.5 0 0 0 1 0V4ZM8 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
  "clip-rule": "evenodd"
};
function X7(t, e) {
  return m(), C("path", G7);
}
const xL = /* @__PURE__ */ se(K7, [["render", X7]]), Q7 = {}, J7 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm1 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM11 6.5A1.5 1.5 0 0 0 9.5 8v1a.5.5 0 0 1-1 0V8A2.5 2.5 0 0 1 11 5.5h2A2.5 2.5 0 0 1 15.5 8v.93a2.5 2.5 0 0 1-1.113 2.08l-1.22.812a1.5 1.5 0 0 0-.667 1.248V14a.5.5 0 0 1-1 0v-.93a2.5 2.5 0 0 1 1.113-2.08l1.22-.812A1.5 1.5 0 0 0 14.5 8.93V8A1.5 1.5 0 0 0 13 6.5h-2ZM11 17a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  "clip-rule": "evenodd"
};
function ec(t, e) {
  return m(), C("path", J7);
}
const $L = /* @__PURE__ */ se(Q7, [["render", ec]]), tc = {}, ac = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M47 24C47 36.4264 36.9264 46.5 24.5 46.5C12.0736 46.5 2 36.4264 2 24C2 11.5736 12.0736 1.5 24.5 1.5C36.9264 1.5 47 11.5736 47 24ZM48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0C37.7548 0 48.5 10.7452 48.5 24ZM22.5 12.75C20.7051 12.75 19.25 14.2051 19.25 16V18C19.25 18.4142 18.9142 18.75 18.5 18.75C18.0858 18.75 17.75 18.4142 17.75 18V16C17.75 13.3766 19.8766 11.25 22.5 11.25H26.5C29.1234 11.25 31.25 13.3766 31.25 16V18.8593C31.25 20.4474 30.4563 21.9305 29.1348 22.8115L26.6972 24.4366C25.7931 25.0393 25.25 26.0541 25.25 27.1407V30C25.25 30.4142 24.9142 30.75 24.5 30.75C24.0858 30.75 23.75 30.4142 23.75 30V27.1407C23.75 25.5526 24.5437 24.0695 25.8652 23.1885L28.3028 21.5634C29.2069 20.9607 29.75 19.9459 29.75 18.8593V16C29.75 14.2051 28.2949 12.75 26.5 12.75H22.5ZM23 35.5C23 34.6716 23.6716 34 24.5 34C25.3284 34 26 34.6716 26 35.5C26 36.3284 25.3284 37 24.5 37C23.6716 37 23 36.3284 23 35.5Z"
};
function oc(t, e) {
  return m(), C("path", ac);
}
const ML = /* @__PURE__ */ se(tc, [["render", oc]]), nc = {};
function rc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      fill: "currentColor",
      d: "M8.53 7.47a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM7.47 8.53l6 6 1.06-1.06-6-6-1.06 1.06Z"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m5 37.5 7.571-5.5M24 41v-3M39 34l-3-2M39 9l-5 5"
    }, null, -1)),
    e[2] || (e[2] = g("circle", {
      cx: "24",
      cy: "24",
      r: "14",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1)),
    e[3] || (e[3] = g("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.849 22.337a1.644 1.644 0 0 0 1.833.114l5.13-2.994a1.655 1.655 0 0 0 .55-2.233 1.65 1.65 0 0 0-2.204-.628l-5.133 2.991a1.653 1.653 0 0 0-.768 1.865c.095.353.302.664.592.885Zm1.023 6.294a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .762-1.861l10.265-5.989a1.643 1.643 0 0 1 2.252.6 1.658 1.658 0 0 1-.597 2.261l-10.264 5.993a1.637 1.637 0 0 1-.827.22Zm5.15 2.969a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .76-1.86l5.134-3a1.643 1.643 0 0 1 2.252.6 1.66 1.66 0 0 1-.597 2.26l-5.132 3a1.637 1.637 0 0 1-.826.224Z",
      "clip-rule": "evenodd"
    }, null, -1)),
    e[4] || (e[4] = g("circle", {
      cx: "43",
      cy: "37",
      r: "4",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1)),
    e[5] || (e[5] = g("circle", {
      cx: "24",
      cy: "44",
      r: "3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1)),
    e[6] || (e[6] = g("circle", {
      cx: "6",
      cy: "6",
      r: "3",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1)),
    e[7] || (e[7] = g("circle", {
      cx: "3",
      cy: "39",
      r: "2",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1)),
    e[8] || (e[8] = g("circle", {
      cx: "42",
      cy: "6",
      r: "4",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "transparent"
    }, null, -1))
  ], 64);
}
const VL = /* @__PURE__ */ se(nc, [["render", rc]]), sc = {};
function ic(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      fill: "#7D57A4",
      "fill-rule": "evenodd",
      d: "M4.454 10h38.923a4.454 4.454 0 0 1 4.454 4.456v14.85a4.451 4.451 0 0 1-4.454 4.451h-13.96l1.911 4.697-8.433-4.697H4.448A4.453 4.453 0 0 1 0 29.305v-14.85A4.455 4.455 0 0 1 4.454 10Z",
      "clip-rule": "evenodd"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      fill: "#fff",
      d: "M2.408 14.034a1.611 1.611 0 0 1 1.223-.604c.993-.07 1.562.399 1.71 1.404.612 4.077 1.267 7.538 1.966 10.383l4.285-8.147c.387-.735.877-1.124 1.47-1.167.858-.06 1.395.486 1.61 1.64a36.454 36.454 0 0 0 1.85 6.68c.514-4.962 1.373-8.55 2.576-10.761a1.506 1.506 0 0 1 1.292-.866c.445-.037.887.101 1.233.386a1.505 1.505 0 0 1 .596 1.129c.032.325-.034.653-.188.941-.763 1.416-1.39 3.77-1.882 7.06-.486 3.178-.665 5.664-.539 7.457.045.44-.034.883-.227 1.28a1.23 1.23 0 0 1-1.041.706c-.516.037-1.03-.206-1.548-.725-1.817-1.864-3.26-4.636-4.329-8.318-1.255 2.51-2.196 4.387-2.824 5.632-1.148 2.209-2.132 3.341-2.951 3.398-.532.037-.985-.41-1.36-1.34-1.003-2.557-2.08-7.503-3.23-14.837a1.672 1.672 0 0 1 .308-1.331ZM44.424 17.106a4.535 4.535 0 0 0-3.125-2.259 5.225 5.225 0 0 0-1.061-.113c-1.873 0-3.402.975-4.59 2.924a10.386 10.386 0 0 0-1.519 5.505c0 1.506.314 2.797.942 3.872a4.527 4.527 0 0 0 3.126 2.26 5.07 5.07 0 0 0 1.06.114c1.891 0 3.42-.974 4.587-2.923a10.52 10.52 0 0 0 1.521-5.538c0-1.506-.314-2.787-.941-3.842Zm-2.466 5.423c-.267 1.28-.763 2.245-1.487 2.893-.573.516-1.1.726-1.577.631-.478-.095-.862-.517-1.15-1.265a5.047 5.047 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.449 6.449 0 0 1 1.032-2.323c.65-.955 1.329-1.356 2.036-1.203.478.097.861.517 1.148 1.261.22.567.337 1.17.343 1.777.003.485-.045.968-.143 1.442ZM32.173 17.106a4.537 4.537 0 0 0-3.125-2.259 5.226 5.226 0 0 0-1.061-.113c-1.874 0-3.403.975-4.588 2.924a10.371 10.371 0 0 0-1.52 5.505c0 1.506.313 2.797.94 3.872a4.516 4.516 0 0 0 3.127 2.26c.348.075.704.113 1.06.114 1.892 0 3.422-.974 4.59-2.923a10.54 10.54 0 0 0 1.533-5.538c0-1.506-.313-2.787-.941-3.842h-.015Zm-2.466 5.423c-.267 1.283-.764 2.248-1.49 2.897-.575.516-1.101.726-1.578.63-.477-.095-.86-.518-1.146-1.268a5.051 5.051 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.514 6.514 0 0 1 1.032-2.323c.647-.953 1.326-1.352 2.036-1.199.478.097.86.517 1.147 1.261.22.567.337 1.169.344 1.777.002.482-.046.962-.143 1.434v.004Z"
    }, null, -1))
  ], 64);
}
const SL = /* @__PURE__ */ se(sc, [["render", ic]]), lc = {};
function uc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.6634 4.51915C19.7503 4.52646 19.8554 4.59288 19.8719 4.71287C19.8882 4.83287 22.4784 22.3444 22.4784 22.3444L15.1 23.9406L1.48267 21.3892C1.48267 21.3892 3.23023 7.87446 3.29623 7.398C3.38393 6.76866 3.40505 6.74761 4.07294 6.53811C4.18152 6.504 5.03154 6.24041 6.22809 5.86964C6.68935 3.91348 8.1605 0.0640259 11.2398 0.0640259C11.6421 0.0640259 12.1078 0.280026 12.4837 0.777204C12.5213 0.775067 12.5588 0.773587 12.5953 0.773587C13.9172 0.773587 14.6686 1.89945 15.0944 3.1246C15.5292 2.99005 15.792 2.90893 15.8076 2.90433C15.9137 2.87309 16.1871 2.83052 16.3271 2.97049C16.467 3.11055 17.7415 4.37589 17.7415 4.37589C17.7415 4.37589 19.5767 4.51192 19.6634 4.51915ZM13.1895 3.714L14.3417 3.35737C14.0498 2.46551 13.5962 1.69052 12.9151 1.60504C13.0846 2.09104 13.1903 2.70411 13.1903 3.46553C13.1903 3.55127 13.1899 3.62981 13.1895 3.70945L13.1895 3.714ZM12.3826 3.83038C12.3826 2.91148 12.2595 2.23052 12.0701 1.75603C11.3192 2.07822 10.4603 2.93235 10.0021 4.70079L12.3818 3.96386L12.3818 3.96225C12.3822 3.91932 12.3826 3.87682 12.3826 3.83038ZM11.5502 1.02329C11.422 0.935094 11.2881 0.889971 11.1552 0.889971C8.94346 0.889971 7.70097 3.79397 7.17774 5.57548L9.05878 4.9929C9.50549 2.65726 10.5633 1.48767 11.5502 1.02329ZM11.6855 11.3023L12.5953 8.59602C12.5953 8.59602 11.9803 8.23947 10.7355 8.23947C7.50488 8.23947 5.90444 10.3973 5.90444 12.627C5.90444 14.1153 6.73861 14.7902 7.46973 15.3818C8.04008 15.8432 8.54773 16.254 8.54773 16.9605C8.54773 17.3503 8.27214 17.8837 7.59463 17.8837C6.55778 17.8837 5.32902 16.8288 5.32902 16.8288L4.70312 18.8967C4.70312 18.8967 5.89852 20.3515 8.23606 20.3515C10.184 20.3515 11.6287 18.8848 11.6287 16.607C11.6287 14.856 10.4501 13.9908 9.51859 13.3069C8.90994 12.8601 8.40677 12.4907 8.40677 12.0023C8.40677 11.7758 8.47885 10.8768 9.91129 10.8768C10.8884 10.8768 11.6855 11.3023 11.6855 11.3023Z",
      fill: "#95BF46"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M19.6633 4.51914C19.5766 4.51191 17.7414 4.37588 17.7414 4.37588C17.7414 4.37588 16.4669 3.11054 16.327 2.97049C16.2746 2.91838 16.204 2.89166 16.1302 2.88016L15.1006 23.9404L22.4783 22.3444C22.4783 22.3444 19.8881 4.83287 19.8718 4.71287C19.8553 4.59287 19.7502 4.52646 19.6633 4.51914Z",
      fill: "#5E8E3E"
    }, null, -1))
  ], 64);
}
const AL = /* @__PURE__ */ se(lc, [["render", uc]]), cc = {};
function dc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      width: "48",
      height: "48",
      fill: "#00149D",
      rx: "8"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      fill: "#fff",
      d: "M4 16h4.607v3.867a7.752 7.752 0 0 1 2.812-.51c3.618 0 6.241 2.686 6.241 6.368 0 2.779-1.877 6.067-6.151 6.067H4V16Zm4.607 11.736c.575.104 1.158.158 1.742.162 1.651 0 2.737-.903 2.737-2.316 0-1.388-1.063-2.338-2.602-2.338a6.121 6.121 0 0 0-1.877.278v4.214Zm16.797-8.382c5.088 0 7.033 3.358 7.033 6.322 0 3.241-2.24 6.32-6.99 6.32-5.088 0-7.079-3.334-7.079-6.32.005-3.15 2.108-6.322 7.039-6.322h-.003Zm0 8.683c1.438 0 2.428-.973 2.428-2.361 0-1.389-.987-2.363-2.425-2.363-1.439 0-2.428.973-2.428 2.363 0 1.39.99 2.361 2.428 2.361h-.003ZM33.373 16h4.6v15.789h-4.6V16ZM44 29.151C44 30.726 42.797 32 41.283 32s-2.74-1.274-2.74-2.849a2.826 2.826 0 0 1 .79-1.99 2.75 2.75 0 0 1 1.95-.834C42.797 26.323 44 27.573 44 29.148v.003Z"
    }, null, -1))
  ], 64);
}
const EL = /* @__PURE__ */ se(cc, [["render", dc]]), mc = {};
function pc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M39.3266 9.0383C39.5003 9.05293 39.7106 9.18575 39.7436 9.42575C39.7762 9.66575 44.9565 44.6888 44.9565 44.6888L30.1998 47.8811L2.96509 42.7784C2.96509 42.7784 6.46021 15.7489 6.59221 14.796C6.76761 13.5373 6.80986 13.4952 8.14564 13.0762C8.36279 13.008 10.0628 12.4808 12.4559 11.7393C13.3785 7.82696 16.3208 0.128052 22.4794 0.128052C23.2839 0.128052 24.2153 0.560052 24.9672 1.55441C25.0423 1.55013 25.1174 1.54717 25.1904 1.54717C27.8342 1.54717 29.337 3.7989 30.1885 6.2492C31.0581 5.98011 31.5838 5.81786 31.615 5.80865C31.8272 5.74619 32.374 5.66104 32.6539 5.94098C32.9337 6.22109 35.4828 8.75178 35.4828 8.75178C35.4828 8.75178 39.1531 9.02383 39.3266 9.0383ZM26.3787 7.428L28.6832 6.71474C28.0993 4.93101 27.1921 3.38104 25.8299 3.21008C26.169 4.18208 26.3804 5.40822 26.3804 6.93107C26.3804 7.1029 26.3796 7.26026 26.3788 7.41989L26.3787 7.428ZM24.765 7.66076C24.765 5.82296 24.5187 4.46104 24.14 3.51205C22.6382 4.15644 20.9204 5.86471 20.0039 9.40159C20.903 9.12305 21.801 8.84502 22.6768 8.57385C23.3909 8.35276 24.0902 8.13623 24.7633 7.92772L24.7634 7.92451C24.7642 7.83864 24.765 7.75363 24.765 7.66076ZM23.1001 2.04657C22.8438 1.87019 22.576 1.77994 22.3102 1.77994C17.8867 1.77994 15.4017 7.58794 14.3552 11.151L18.1173 9.98581C19.0107 5.31452 21.1264 2.97534 23.1001 2.04657ZM23.371 22.6045L25.1905 17.192C25.1905 17.192 23.9606 16.4789 21.471 16.4789C15.0098 16.4789 11.8089 20.7945 11.8089 25.2541C11.8089 28.2306 13.4772 29.5804 14.9395 30.7635C16.0802 31.6865 17.0955 32.5079 17.0955 33.921C17.0955 34.7005 16.5443 35.7674 15.1893 35.7674C13.1156 35.7674 10.658 33.6575 10.658 33.6575L9.40625 37.7934C9.40625 37.7934 11.797 40.703 16.4721 40.703C20.368 40.703 23.2574 37.7696 23.2574 33.214C23.2574 29.712 20.9002 27.9816 19.0372 26.6139C17.8199 25.7202 16.8135 24.9815 16.8135 24.0046C16.8135 23.5515 16.9577 21.7537 19.8226 21.7537C21.7768 21.7537 23.371 22.6045 23.371 22.6045Z",
      fill: "#95BF46"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M39.3266 9.03829C39.1532 9.02382 35.4828 8.75177 35.4828 8.75177C35.4828 8.75177 32.9337 6.22108 32.6539 5.94097C32.5492 5.83675 32.408 5.78333 32.2604 5.76031L30.2012 47.8808L44.9566 44.6888C44.9566 44.6888 39.7762 9.66574 39.7436 9.42574C39.7106 9.18574 39.5004 9.05292 39.3266 9.03829Z",
      fill: "#5E8E3E"
    }, null, -1))
  ], 64);
}
const DL = /* @__PURE__ */ se(mc, [["render", pc]]), fc = {};
function hc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("rect", {
      width: "24",
      height: "24",
      fill: "#00149D"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M2 8H4.30357V9.9333C4.75282 9.76191 5.22928 9.67554 5.70928 9.6785C7.51854 9.6785 8.83012 11.0216 8.83012 12.8624C8.83012 14.2518 7.89167 15.896 5.75437 15.896H2V8ZM4.30357 13.8679C4.59105 13.9199 4.88237 13.9471 5.17439 13.949C6.00011 13.949 6.54289 13.4977 6.54289 12.791C6.54289 12.0968 6.01139 11.6221 5.24202 11.6221C4.92403 11.6193 4.60751 11.6661 4.30357 11.7609V13.8679ZM12.7017 9.67678C15.246 9.67678 16.2182 11.3559 16.2182 12.8378C16.2182 14.4586 15.0989 15.9983 12.7237 15.9983C10.1795 15.9983 9.18408 14.3312 9.18408 12.8378C9.18634 11.2627 10.2381 9.67678 12.7034 9.67678H12.7017ZM12.7017 14.0187C13.4209 14.0187 13.9158 13.532 13.9158 12.8378C13.9158 12.1437 13.4226 11.6564 12.7034 11.6564C11.9842 11.6564 11.4893 12.1431 11.4893 12.8378C11.4893 13.5325 11.9842 14.0187 12.7034 14.0187H12.7017ZM16.6872 8H18.9874V15.8943H16.6872V8ZM22 14.5757C22 15.363 21.3986 16 20.6416 16C19.8847 16 19.2714 15.363 19.2714 14.5757C19.2693 14.3916 19.3031 14.2089 19.3709 14.0381C19.4387 13.8673 19.5392 13.7118 19.6665 13.5805C19.7939 13.4493 19.9456 13.3448 20.113 13.2732C20.2803 13.2017 20.46 13.1644 20.6416 13.1635C21.3986 13.1618 22 13.7868 22 14.574V14.5757Z",
      fill: "white"
    }, null, -1))
  ], 64);
}
const PL = /* @__PURE__ */ se(fc, [["render", hc]]), vc = {};
function gc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      fill: "#7D57A4",
      "fill-rule": "evenodd",
      d: "M2.227 5h19.462a2.227 2.227 0 0 1 2.226 2.228v7.425a2.226 2.226 0 0 1-2.226 2.226h-6.98l.955 2.348-4.216-2.348H2.223A2.227 2.227 0 0 1 0 14.653V7.228A2.228 2.228 0 0 1 2.227 5Z",
      "clip-rule": "evenodd"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      fill: "#fff",
      d: "M1.204 7.017a.806.806 0 0 1 .612-.302c.496-.035.78.2.854.702.306 2.038.634 3.769.984 5.191l2.142-4.073c.194-.368.439-.562.735-.584.429-.03.697.244.805.82.201 1.14.51 2.259.925 3.34.257-2.48.686-4.274 1.288-5.38a.753.753 0 0 1 .646-.433.86.86 0 0 1 .616.193.752.752 0 0 1 .299.564.829.829 0 0 1-.094.471c-.382.708-.696 1.885-.942 3.53-.242 1.59-.332 2.832-.269 3.728.022.22-.017.442-.114.64a.615.615 0 0 1-.52.353c-.258.02-.515-.102-.774-.362-.908-.932-1.63-2.318-2.165-4.16-.627 1.256-1.098 2.194-1.411 2.817-.574 1.104-1.066 1.67-1.476 1.699-.266.019-.493-.205-.68-.67-.502-1.279-1.04-3.751-1.615-7.419a.836.836 0 0 1 .154-.665ZM22.212 8.553a2.268 2.268 0 0 0-1.562-1.13 2.612 2.612 0 0 0-.531-.056c-.936 0-1.701.487-2.295 1.462a5.193 5.193 0 0 0-.76 2.753c0 .753.157 1.398.471 1.936a2.264 2.264 0 0 0 1.564 1.13c.174.037.351.056.53.057.945 0 1.71-.488 2.293-1.462a5.259 5.259 0 0 0 .76-2.769c0-.753-.156-1.393-.47-1.92Zm-1.233 2.712c-.134.64-.381 1.122-.744 1.446-.286.258-.55.363-.788.316-.24-.048-.431-.259-.575-.633a2.526 2.526 0 0 1-.172-.89c-.001-.24.023-.48.071-.717.093-.417.268-.812.516-1.161.325-.477.664-.678 1.018-.601.24.048.43.258.574.63.11.284.168.585.172.889 0 .242-.023.483-.072.72ZM16.087 8.553a2.269 2.269 0 0 0-1.563-1.13 2.612 2.612 0 0 0-.53-.056c-.938 0-1.702.487-2.294 1.462a5.185 5.185 0 0 0-.76 2.753c0 .753.156 1.398.47 1.936a2.259 2.259 0 0 0 1.563 1.13c.174.037.352.056.53.057.946 0 1.711-.488 2.294-1.462a5.27 5.27 0 0 0 .768-2.769c0-.753-.157-1.393-.471-1.92h-.008Zm-1.233 2.712c-.134.64-.383 1.124-.746 1.448-.287.258-.55.363-.789.315-.238-.047-.43-.259-.573-.634a2.524 2.524 0 0 1-.172-.89c0-.24.023-.48.072-.717.093-.417.269-.811.515-1.161.324-.476.664-.676 1.019-.6.239.049.43.259.573.631.11.283.169.584.172.889.001.24-.023.48-.072.717v.002Z"
    }, null, -1))
  ], 64);
}
const zL = /* @__PURE__ */ se(vc, [["render", gc]]), yc = {}, bc = {
  d: "M12 4C16.1686 4 19.5924 7.18828 19.9662 11.2593L18.8536 10.1465C18.6584 9.9512 18.3418 9.95117 18.1465 10.1464C17.9512 10.3416 17.9512 10.6582 18.1464 10.8535L20.1464 12.854C20.2402 12.9478 20.3674 13.0005 20.5 13.0005C20.6326 13.0005 20.7598 12.9478 20.8536 12.854L22.8536 10.8535C23.0488 10.6582 23.0488 10.3416 22.8535 10.1464C22.6582 9.95117 22.3416 9.9512 22.1464 10.1465L20.9746 11.3186C20.6263 6.66634 16.7413 3 12 3C8.56143 3 5.57406 4.92853 4.05911 7.76061C3.92886 8.0041 4.02067 8.30708 4.26416 8.43733C4.50765 8.56758 4.81063 8.47578 4.94088 8.23229C6.28879 5.71248 8.9448 4 12 4ZM3.02546 12.6814L1.8536 13.8535C1.65836 14.0488 1.34178 14.0488 1.14649 13.8536C0.951204 13.6584 0.951164 13.3418 1.1464 13.1465L3.1464 11.146C3.24018 11.0522 3.36737 10.9995 3.5 10.9995C3.63263 10.9995 3.75982 11.0522 3.8536 11.146L5.8536 13.1465C6.04884 13.3418 6.0488 13.6584 5.85351 13.8536C5.65822 14.0488 5.34164 14.0488 5.1464 13.8535L4.03389 12.7407C4.40765 16.8118 7.83152 20 12.0001 20C15.0566 20 17.7136 18.286 19.061 15.7644C19.1911 15.5208 19.494 15.4289 19.7376 15.559C19.9811 15.6891 20.0731 15.9921 19.943 16.2356C18.4286 19.0698 15.4401 21 12.0001 21C7.25871 21 3.3737 17.3336 3.02546 12.6814ZM11.5 8.5C11.5 8.22386 11.7239 8 12 8C12.2761 8 12.5 8.22386 12.5 8.5V11.5H15.5C15.7761 11.5 16 11.7239 16 12C16 12.2761 15.7761 12.5 15.5 12.5H12.5V15.5C12.5 15.7761 12.2761 16 12 16C11.7239 16 11.5 15.7761 11.5 15.5V12.5H8.5C8.22386 12.5 8 12.2761 8 12C8 11.7239 8.22386 11.5 8.5 11.5H11.5V8.5Z",
  fill: "currentColor"
};
function kc(t, e) {
  return m(), C("path", bc);
}
const TL = /* @__PURE__ */ se(yc, [["render", kc]]), Cc = {}, wc = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M40.7316 23.2077L43.4697 20.4697C43.7626 20.1768 44.2374 20.1768 44.5303 20.4697C44.8232 20.7626 44.8232 21.2374 44.5303 21.5303L40.5303 25.5303C40.2374 25.8232 39.7626 25.8232 39.4697 25.5303L35.4697 21.5303C35.1768 21.2374 35.1768 20.7626 35.4697 20.4697C35.7626 20.1768 36.2374 20.1768 36.5303 20.4697L39.2276 23.167C38.7951 15.132 32.1428 8.75 24 8.75C18.1847 8.75 13.1284 12.0048 10.5555 16.7955C10.3596 17.1604 9.90487 17.2974 9.53995 17.1014C9.17504 16.9054 9.03808 16.4507 9.23406 16.0858C12.0579 10.8278 17.6105 7.25 24 7.25C32.9852 7.25 40.318 14.3248 40.7316 23.2077ZM7.26841 24.7923L4.53033 27.5303C4.23744 27.8232 3.76256 27.8232 3.46967 27.5303C3.17678 27.2374 3.17678 26.7626 3.46967 26.4697L7.46967 22.4697C7.76256 22.1768 8.23744 22.1768 8.53033 22.4697L12.5303 26.4697C12.8232 26.7626 12.8232 27.2374 12.5303 27.5303C12.2374 27.8232 11.7626 27.8232 11.4697 27.5303L8.77237 24.833C9.20491 32.868 15.8572 39.25 24 39.25C29.861 39.25 34.9509 35.9439 37.5046 31.0914C37.6975 30.7248 38.151 30.5841 38.5176 30.777C38.8841 30.9699 39.0249 31.4234 38.832 31.7899C36.0293 37.1158 30.4396 40.75 24 40.75C15.0148 40.75 7.68202 33.6752 7.26841 24.7923ZM24 16.25C23.5858 16.25 23.25 16.5858 23.25 17V23.25H17C16.5858 23.25 16.25 23.5858 16.25 24C16.25 24.4142 16.5858 24.75 17 24.75H23.25V31C23.25 31.4142 23.5858 31.75 24 31.75C24.4142 31.75 24.75 31.4142 24.75 31V24.75H31C31.4142 24.75 31.75 24.4142 31.75 24C31.75 23.5858 31.4142 23.25 31 23.25H24.75V17C24.75 16.5858 24.4142 16.25 24 16.25Z",
  fill: "#FF8C00"
};
function _c(t, e) {
  return m(), C("path", wc);
}
const OL = /* @__PURE__ */ se(Cc, [["render", _c]]), Hc = {}, jc = {
  d: "M16.5622 16.3942H12.2951C10.258 16.3942 9.31148 15.6732 9.04964 13.8598H15.3481V13.8622H17.5601V13.2197C17.5616 13.1984 17.5629 13.1769 17.5629 13.1547V10.9577C17.5629 10.9356 17.5616 10.9141 17.5601 10.8927V10.2567H16.9384C16.9119 10.2544 16.8853 10.2532 16.8587 10.2532H9.03513C9.27563 8.37454 10.2196 7.60545 12.2951 7.60545H18.7177V4H16.7866L11.901 4.00032C6.9146 4.00032 5 6.47872 5 11.9998C5 17.5205 6.9146 20 11.901 20H18.0702L18.0771 19.9997H18.7744V16.3942H16.5622Z",
  fill: "#E1141D"
};
function Lc(t, e) {
  return m(), C("path", jc);
}
const FL = /* @__PURE__ */ se(Hc, [["render", Lc]]), xc = {}, $c = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22.0002 8.27983L19.4002 12.1454L22.0002 16.0011C22.0002 16.0011 20.869 16.1454 20.3248 15.6503C20.0656 15.3951 19.8307 15.1163 19.6231 14.8175L18.6658 13.4405C18.6479 13.3998 18.6197 13.3646 18.5841 13.3381C18.5485 13.3117 18.5066 13.295 18.4625 13.2896C18.3641 13.2896 18.3051 13.3683 18.2559 13.4405L17.3018 14.8175C17.1011 15.1167 16.8716 15.3956 16.6166 15.6503C16.0723 16.1454 14.9314 16.0011 14.9314 16.0011L17.5248 12.1323L14.9248 8.2536C14.9248 8.2536 16.0199 8.06671 16.5641 8.55851C16.8381 8.83856 17.085 9.14372 17.3018 9.46999L18.2559 10.8536C18.3051 10.9257 18.3641 11.0044 18.4625 11.0044C18.5064 10.9985 18.548 10.9815 18.5835 10.9551C18.6191 10.9288 18.6474 10.8938 18.6658 10.8536L19.6264 9.44376C19.8429 9.12628 20.0888 8.82989 20.3608 8.55851C20.9018 8.09294 22.0002 8.27983 22.0002 8.27983ZM10.6754 9.35584C10.7403 9.07501 10.8849 8.81887 11.0918 8.61814V8.59519C11.4665 8.31096 11.9357 8.18076 12.4032 8.23126L10.3672 16.0017C10.0235 16.0274 9.67811 15.985 9.35079 15.8771C8.90817 15.6509 8.69506 15.4771 8.4262 14.4214C8.28267 13.8846 8.00349 12.7627 7.77845 11.8584L7.77844 11.8584L7.77843 11.8584L7.77831 11.8579C7.60759 11.1719 7.46806 10.6112 7.4426 10.5263C7.43785 10.5125 7.43295 10.4959 7.42754 10.4774C7.39564 10.3686 7.34575 10.1985 7.19998 10.1985C7.0494 10.1985 7.00112 10.3775 6.97157 10.4871C6.96766 10.5016 6.96408 10.5148 6.96064 10.5263C6.92271 10.6441 6.6588 11.712 6.40409 12.7426L6.40406 12.7427L6.40388 12.7435C6.24026 13.4056 6.08047 14.0521 5.98687 14.4214C5.71802 15.4771 5.50818 15.6509 5.06228 15.8771C4.73623 15.9856 4.3918 16.028 4.04917 16.0017L2 8.23126C2.4707 8.18621 2.94059 8.32483 3.31147 8.61814C3.51834 8.81887 3.66291 9.07501 3.72786 9.35584L4.79671 13.4771L5.69507 10.1067C5.77748 9.7068 5.94401 9.32904 6.18359 8.99847C6.46037 8.73772 6.82628 8.59251 7.20654 8.59251C7.5868 8.59251 7.9527 8.73772 8.22948 8.99847C8.46808 9.32922 8.63349 9.707 8.71473 10.1067L9.60325 13.4771L10.6754 9.35584ZM12.8978 9.91598C12.8978 8.94877 13.0454 8.59796 13.4421 8.38812C13.7126 8.28344 14.0014 8.23438 14.2913 8.24386C14.2913 8.77501 14.2322 9.09304 13.9044 9.33566C13.7485 9.4513 13.5775 9.54506 13.3962 9.61435C13.2119 9.68124 13.0426 9.78373 12.8978 9.91598ZM14.2917 9.51926C14.1788 9.6651 14.0356 9.78478 13.872 9.87007C13.7483 9.93835 13.6287 9.99273 13.5079 10.0477L13.5078 10.0477C13.443 10.0772 13.3778 10.1069 13.3114 10.1389C13.1858 10.177 13.0768 10.2563 13.0018 10.364C12.9269 10.4716 12.8904 10.6014 12.8983 10.7324V15.9782C13.1881 16.0131 13.482 15.976 13.754 15.87C14.1901 15.6471 14.2884 15.434 14.2917 14.4701V9.79794V9.51926Z",
  fill: "black"
};
function Mc(t, e) {
  return m(), C("path", $c);
}
const BL = /* @__PURE__ */ se(xc, [["render", Mc]]), Vc = {}, Sc = {
  d: "M2.57294 7.87305V11.1009C2.57294 11.1009 3.71033 11.1009 4.31904 11.0547C4.79774 10.9709 4.88585 10.9247 4.97396 10.446L5.15019 9.74487H5.67079L5.58268 11.2771L5.62889 12.847H5.10398L4.97396 12.234C4.84395 11.7977 4.66773 11.7091 4.31904 11.6672C3.88279 11.621 2.57294 11.621 2.57294 11.621V14.3282C2.57294 14.8489 2.83728 15.0713 3.44599 15.0713H5.2802C5.84701 15.0713 6.41329 15.0251 6.76627 14.1982L7.24067 13.149H7.68122C7.63502 13.3671 7.41689 15.2894 7.37499 15.7219C7.37499 15.7219 5.717 15.68 5.02017 15.68H1.87612L0 15.7219V15.2475L0.608717 15.1132C1.04927 15.0251 1.17929 14.8951 1.17929 14.5464C1.17929 14.5464 1.22549 13.3671 1.22549 11.4023C1.22549 9.44239 1.17929 8.26256 1.17929 8.26256C1.17929 7.87198 1.04927 7.78386 0.608717 7.69575L0 7.56681V7.08811L1.83421 7.12572H5.32641C6.02324 7.12572 7.19823 7 7.19823 7C7.19823 7 7.15632 7.73873 7.11012 9.48483H6.63142L6.45519 8.87182C6.28327 8.08688 6.0227 7.69629 5.54024 7.69629H2.79537C2.57294 7.69683 2.57294 7.73873 2.57294 7.87305ZM9.64115 8.21743H10.1661V10.0516L11.9584 9.96353L11.8703 10.7947L10.1242 10.6604V13.8925C10.1242 14.8075 10.4304 15.1599 10.9553 15.1599C11.4297 15.1599 11.7821 14.8956 11.9122 14.6775L12.1722 14.9837C11.9122 15.5924 11.1734 15.8987 10.4723 15.8987C9.60355 15.8987 8.89812 15.3781 8.89812 14.375V10.706H7.85691V10.2698C8.7305 10.1817 9.38112 9.65676 9.64115 8.21743ZM13.3977 13.8458L13.7458 14.6769C13.8758 15.0251 14.1821 15.3781 14.8789 15.3781C15.6219 15.3781 15.9282 14.9837 15.9282 14.505C15.9282 13.0189 13.0028 13.4557 13.0028 11.4491C13.0028 10.316 13.9178 9.78677 15.097 9.78677C15.6219 9.78677 16.4069 9.87489 16.8012 10.0511C16.7131 10.4874 16.6669 11.0542 16.6669 11.491L16.2344 11.5329L15.9282 10.6598C15.8401 10.446 15.4876 10.2692 15.0551 10.2692C14.5302 10.2692 14.0059 10.4874 14.0059 11.0542C14.0059 12.4059 17.0194 12.1034 17.0194 14.1101C17.0194 15.2475 16.0163 15.8562 14.7908 15.8562C13.8758 15.8562 12.9566 15.5038 12.9566 15.5038C13.0447 14.9832 13.0028 14.4169 12.9566 13.8458H13.3977ZM16.8018 18.0348C16.9318 17.5561 17.0199 16.9479 17.108 16.3768L17.5867 16.3349L17.7629 17.2499C17.8048 17.468 17.9349 17.6442 18.2835 17.6442C18.8504 17.6442 19.5934 17.2961 20.294 16.0743C19.9834 15.3313 19.0685 12.9346 18.2373 11.1004C18.0192 10.6179 17.9773 10.5755 17.6748 10.4874L17.4524 10.4036V9.963L18.766 10.0092L20.3778 9.92109V10.3579L19.9834 10.446C19.6772 10.4879 19.5509 10.6598 19.5509 10.8366C19.5509 10.8828 19.5509 10.9247 19.5928 11.0128C19.6767 11.2771 20.3778 13.2376 20.9027 14.5469C21.3352 13.632 22.1663 11.5796 22.2963 11.2309C22.3425 11.0547 22.3845 11.0128 22.3845 10.8828C22.3845 10.6604 22.2544 10.5303 21.952 10.4465L21.6414 10.3579V9.92163L22.8669 9.96353L24 9.92163V10.3579L23.7819 10.5298C23.3456 10.706 23.2994 10.7479 23.127 11.1004L21.2089 15.5913C20.0715 18.1686 18.8923 18.3867 18.0649 18.3867C17.5405 18.3873 17.1462 18.2529 16.8018 18.0348Z",
  fill: "#F1641E"
};
function Ac(t, e) {
  return m(), C("path", Sc);
}
const IL = /* @__PURE__ */ se(Vc, [["render", Ac]]), Ec = {};
function Dc(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      d: "M18.3208 17.8187C10.8914 21.3544 6.28063 18.3962 3.32914 16.5994C3.1465 16.4861 2.83608 16.6258 3.10541 16.9352C4.0887 18.1275 7.31115 21.0012 11.5174 21.0012C15.7265 21.0012 18.2305 18.7045 18.5438 18.3038C18.8549 17.9066 18.6351 17.6874 18.3207 17.8187H18.3208ZM20.4073 16.6664C20.2078 16.4066 19.1941 16.3581 18.5562 16.4365C17.9173 16.5126 16.9583 16.9031 17.0417 17.1375C17.0845 17.2254 17.1718 17.186 17.6107 17.1465C18.0508 17.1026 19.2837 16.947 19.5406 17.2828C19.7987 17.621 19.1474 19.2319 19.0284 19.4917C18.9135 19.7515 19.0724 19.8185 19.2882 19.6455C19.5012 19.4725 19.8866 19.0245 20.1453 18.3906C20.4022 17.7533 20.5589 16.8642 20.4072 16.6664H20.4073Z",
      fill: "#FF9900"
    }, null, -1),
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.3253 10.6028C13.3253 11.5306 13.3488 12.3043 12.8799 13.1281C12.5014 13.798 11.9019 14.21 11.232 14.21C10.3176 14.21 9.78512 13.5133 9.78512 12.4851C9.78512 10.4554 11.6037 10.0871 13.3253 10.0871V10.6028ZM15.7267 16.4071C15.5693 16.5478 15.3415 16.5579 15.1641 16.464C14.3736 15.8076 14.2329 15.5028 13.7976 14.8765C12.4914 16.2095 11.5669 16.6081 9.87224 16.6081C7.86938 16.6081 6.30859 15.3722 6.30859 12.8971C6.30859 10.9646 7.35697 9.64829 8.8473 9.00528C10.1402 8.43584 11.9454 8.33538 13.3253 8.17801V7.86985C13.3253 7.3038 13.3688 6.63396 13.0373 6.145C12.7459 5.70623 12.1899 5.52536 11.7009 5.52536C10.7933 5.52536 9.98273 5.99089 9.78512 6.95547C9.74488 7.16987 9.58752 7.38089 9.37318 7.39092L7.06216 7.14312C6.86794 7.09949 6.65361 6.94212 6.70719 6.64399C7.23971 3.84407 9.76832 3 12.0324 3C13.1913 3 14.7051 3.30816 15.6195 4.18569C16.7784 5.26747 16.6678 6.71099 16.6678 8.28179V11.9928C16.6678 13.1081 17.13 13.597 17.5654 14.2C17.7194 14.4143 17.753 14.6723 17.5587 14.8329C17.073 15.2382 16.2089 15.9918 15.7334 16.4138L15.7267 16.4071",
      fill: "black"
    }, null, -1)
  ]));
}
const ZL = /* @__PURE__ */ se(Ec, [["render", Dc]]), Pc = {};
function zc(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.5205 5L10.9009 5.00004C5.9146 5.00004 4 7.47844 4 12.9996C4 18.5203 5.9146 20.9997 10.9009 20.9997H17.0702L17.0771 20.9994H17.7744V17.3939H15.5622H11.2951C9.258 17.3939 8.31148 16.6729 8.04964 14.8595H14.3481V14.8619H16.5601V14.2194C16.5616 14.1981 16.5629 14.1767 16.5629 14.1545V11.9574C16.5629 11.9353 16.5616 11.9138 16.5601 11.8925V11.4265C16.2978 11.3853 16.0411 11.327 15.7913 11.2529H8.03513C8.27563 9.37426 9.21959 8.60518 11.2951 8.60518H12.3651C11.8161 7.69925 11.5 6.6364 11.5 5.49972C11.5 5.33144 11.5069 5.16478 11.5205 5Z",
      fill: "#E1141D"
    }, null, -1)),
    e[1] || (e[1] = g("g", { "clip-path": "url(#clip_exact_de)" }, [
      g("path", {
        d: "M13 1H22V4H13V1Z",
        fill: "black"
      }),
      g("path", {
        d: "M13 4H22V7H13V4Z",
        fill: "#DD4547"
      }),
      g("path", {
        d: "M13 7H22V10H13V7Z",
        fill: "#F8D952"
      })
    ], -1)),
    e[2] || (e[2] = g("defs", null, [
      g("clipPath", { id: "clip_exact_de" }, [
        g("rect", {
          x: "13",
          y: "1",
          width: "9",
          height: "9",
          rx: "4.5",
          fill: "white"
        })
      ])
    ], -1))
  ], 64);
}
const RL = /* @__PURE__ */ se(Pc, [["render", zc]]), Tc = {}, Oc = {
  d: "M10.25 9.5L12.75 2.5L15.25 9.5L21.75 10L16.75 14.5L19.25 21L12.75 17.5L6.25 21L8.75 14.5L3.75 10L10.25 9.5Z",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none"
};
function Fc(t, e) {
  return m(), C("path", Oc);
}
const NL = /* @__PURE__ */ se(Tc, [["render", Fc]]), Bc = {}, Ic = {
  fill: "currentColor",
  d: "M49.24 19.48c-.1-.3-.36-.51-.67-.54l-16.7-1.52-6.15-15.06c-.11-.3-.4-.49-.72-.49s-.6.19-.72.48l-6.15 15.07-16.7 1.52a.786.786 0 0 0-.44 1.37l12.6 11.02-3.87 15.83c-.07.31.05.63.3.82.26.18.6.2.87.03L25 39.28l14.11 8.73c.12.08.27.12.41.12.16 0 .32-.05.46-.15.26-.19.38-.51.3-.82l-3.87-15.83 12.6-11.02c.24-.2.33-.53.23-.83z"
};
function Zc(t, e) {
  return m(), C("path", Ic);
}
const qL = /* @__PURE__ */ se(Bc, [["render", Zc]]), Rc = {};
function Nc(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      fill: "currentColor",
      d: "M49.24 19.48c-.1-.3-.36-.51-.67-.54l-16.7-1.52-6.15-15.06c-.11-.3-.4-.49-.72-.49s-.6.19-.72.48l-6.15 15.07-16.7 1.52a.786.786 0 0 0-.44 1.37l12.6 11.02-3.87 15.83c-.07.31.05.63.3.82.26.18.6.2.87.03L25 39.28l14.11 8.73c.12.08.27.12.41.12.16 0 .32-.05.46-.15.26-.19.38-.51.3-.82l-3.87-15.83 12.6-11.02c.24-.2.33-.53.23-.83zM35.02 30.47c-.22.2-.31.49-.25.77l3.53 14.44-12.9-7.98a.754.754 0 0 0-.82 0l-12.9 7.98 3.53-14.44a.756.756 0 0 0-.25-.77L3.39 20.34l15.35-1.4c.29-.02.54-.21.65-.48L25 4.72l5.61 13.74c.11.27.36.46.65.48l15.35 1.4-11.59 10.13z"
    }, null, -1),
    g("path", {
      fill: "currentColor",
      d: "M10.48 48.25a.902.902 0 0 1-.88-1.12l3.85-15.76L.91 20.41a.895.895 0 0 1-.26-.96c.11-.35.42-.59.78-.62l16.62-1.51 6.12-15c.13-.35.46-.57.83-.57.37 0 .7.23.84.56l6.12 15 16.62 1.51c.36.03.67.27.78.62.11.34.01.72-.26.96L36.55 31.37l3.85 15.76c.09.36-.05.73-.35.95-.3.21-.7.22-1.01.04L25 39.42l-14.04 8.69a.84.84 0 0 1-.48.14zM25 2c-.27 0-.5.16-.61.41l-6.15 15.07c-.02.04-.06.07-.1.08l-16.7 1.52c-.26.02-.48.2-.56.45-.08.25-.01.52.19.7l12.6 11.02c.04.03.05.08.04.12L9.84 47.19c-.06.26.04.53.25.69.22.16.5.17.73.03l14.11-8.73c.04-.03.09-.03.13 0l14.11 8.73c.22.14.51.13.73-.03.21-.16.31-.43.25-.69l-3.87-15.83c-.01-.04 0-.09.04-.12l12.6-11.02c.2-.17.27-.45.19-.7a.644.644 0 0 0-.56-.45l-16.7-1.52c-.05 0-.09-.03-.1-.08L25.61 2.4c-.1-.24-.34-.4-.61-.4zm13.31 43.8c-.02 0-.05-.01-.07-.02l-12.9-7.98a.66.66 0 0 0-.69 0l-12.9 7.98c-.04.03-.1.02-.14 0a.13.13 0 0 1-.05-.13l3.53-14.44a.642.642 0 0 0-.21-.65L3.31 20.43c-.04-.03-.05-.08-.04-.13.02-.05.06-.08.11-.08l15.35-1.4c.25-.02.46-.17.55-.4l5.61-13.74c.04-.1.19-.1.23 0l5.61 13.74c.09.23.3.38.55.4l15.35 1.4c.05 0 .09.04.11.08.02.05 0 .1-.04.13L35.11 30.56c-.18.16-.26.41-.21.65l3.53 14.44c.01.05-.01.1-.05.13-.02.02-.05.02-.07.02zM3.69 20.44l11.37 9.94c.26.23.37.57.29.9l-3.46 14.14 12.64-7.82c.28-.18.67-.18.95 0l12.64 7.82-3.46-14.14c-.08-.33.03-.67.28-.9l11.37-9.94-15.06-1.37a.897.897 0 0 1-.76-.56L25 5.05 19.51 18.5c-.13.32-.42.53-.76.56L3.69 20.44z"
    }, null, -1)
  ]));
}
const UL = /* @__PURE__ */ se(Rc, [["render", Nc]]), qc = {}, Uc = {
  transform: "translate(0,700) scale(0.1,-0.1)",
  fill: "#0866ff",
  stroke: "none"
};
function Yc(t, e) {
  return m(), C("g", Uc, e[0] || (e[0] = [
    g("path", { d: `M3245 5994 c-585 -62 -1145 -334 -1545 -751 -356 -370 -580 -812
      -670 -1324 -28 -155 -39 -530 -21 -690 66 -578 312 -1091 721 -1499 289 -290
      629 -498 1010 -618 52 -16 107 -32 123 -36 l27 -6 0 830 0 830 -255 0 -255 0
      0 385 0 385 254 0 254 0 5 283 c3 191 10 315 22 385 90 562 403 845 999 903
      185 18 496 -1 694 -42 l52 -10 0 -352 0 -352 -209 3 c-156 2 -227 -1 -281 -12
      -180 -38 -278 -123 -333 -289 -17 -53 -21 -95 -25 -289 l-4 -228 406 0 406 0
      -1 -22 c0 -13 -30 -185 -67 -383 l-67 -360 -338 -3 -337 -2 0 -859 0 -858 88
      14 c518 82 995 326 1373 703 407 406 654 921 720 1499 18 160 7 535 -21 690
      -95 537 -348 1018 -727 1381 -370 356 -811 579 -1324 670 -102 19 -169 23
      -379 25 -140 2 -273 1 -295 -1z` }, null, -1)
  ]));
}
const YL = /* @__PURE__ */ se(qc, [["render", Yc]]), Wc = {}, Kc = {
  fill: "currentColor",
  d: "M 9.632812 15.890625 C 9.554688 15.894531 9.507812 15.898438 9.457031 15.898438 C 8.386719 15.898438 7.320312 15.898438 6.253906 15.902344 C 6.101562 15.902344 6.0625 15.863281 6.0625 15.710938 C 6.066406 13.226562 6.066406 10.734375 6.066406 8.246094 C 6.066406 8.179688 6.066406 8.117188 6.066406 8.03125 C 5.484375 8.03125 4.917969 8.03125 4.34375 8.03125 C 4.34375 7.144531 4.34375 6.273438 4.34375 5.375 C 4.402344 5.375 4.460938 5.375 4.511719 5.375 C 4.980469 5.375 5.449219 5.371094 5.917969 5.378906 C 6.039062 5.378906 6.070312 5.34375 6.070312 5.226562 C 6.0625 4.53125 6.0625 3.832031 6.070312 3.132812 C 6.070312 2.648438 6.148438 2.171875 6.375 1.730469 C 6.695312 1.109375 7.207031 0.707031 7.851562 0.457031 C 8.375 0.25 8.929688 0.175781 9.484375 0.164062 C 10.390625 0.152344 11.296875 0.160156 12.203125 0.15625 C 12.289062 0.15625 12.355469 0.152344 12.355469 0.273438 C 12.351562 1.132812 12.351562 1.992188 12.351562 2.851562 C 12.351562 2.859375 12.351562 2.867188 12.335938 2.910156 C 12.285156 2.910156 12.226562 2.910156 12.164062 2.910156 C 11.601562 2.910156 11.039062 2.90625 10.476562 2.910156 C 10.152344 2.910156 9.890625 3.039062 9.726562 3.324219 C 9.675781 3.410156 9.644531 3.519531 9.644531 3.617188 C 9.632812 4.148438 9.644531 4.679688 9.636719 5.210938 C 9.636719 5.335938 9.675781 5.371094 9.796875 5.371094 C 10.578125 5.367188 11.359375 5.367188 12.140625 5.367188 C 12.203125 5.367188 12.261719 5.367188 12.367188 5.367188 C 12.257812 6.261719 12.152344 7.136719 12.042969 8.023438 C 11.230469 8.023438 10.441406 8.023438 9.632812 8.023438 C 9.632812 10.648438 9.632812 13.261719 9.632812 15.890625 Z M 9.632812 15.890625 "
};
function Gc(t, e) {
  return m(), C("path", Kc);
}
const WL = /* @__PURE__ */ se(Wc, [["render", Gc]]), Xc = {}, Qc = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46 48.54 12.02 48.54 25 37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01zm1.96 35.98h-5.49c-.43 0-.77-.35-.77-.78V25.79h-1.83c-.43 0-.77-.35-.77-.78v-4.67c0-.43.35-.78.77-.78h1.83v-2.24c0-2.91 1.65-6.31 6.31-6.31l4.07.02c.43 0 .77.35.77.78v4.53c0 .43-.35.78-.77.78h-2.95c-.25 0-.39.08-.39.5v1.97h3.41c.22 0 .43.09.58.26.15.16.22.38.2.6l-.48 4.67c-.04.4-.37.7-.77.7h-2.93v12.42c-.02.4-.37.75-.79.75zm-4.72-1.55h3.94V25.01c0-.43.35-.78.77-.78h3l.32-3.11h-3.32c-.43 0-.77-.35-.77-.78V17.6c0-1.41.97-2.05 1.94-2.05h2.18v-2.98l-3.3-.01c-4.3 0-4.76 3.33-4.76 4.76v3.02c0 .43-.35.78-.77.78h-1.83v3.12h1.83c.43 0 .77.35.77.78v12.42z"
};
function Jc(t, e) {
  return m(), C("path", Qc);
}
const KL = /* @__PURE__ */ se(Xc, [["render", Jc]]), e8 = {};
function t8(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_32686_39903)" }, [
      g("path", {
        d: "M28.6923 7.96066C27.7113 6.29863 25.541 5.73258 23.8489 6.70812L1.80244 19.2937C0.11033 20.2572 -0.465969 22.389 0.514964 24.051C1.17709 25.159 2.35421 25.7853 3.58038 25.7853C4.1812 25.7853 4.79429 25.6287 5.35832 25.3156L27.4048 12.7299C29.0969 11.7665 29.6732 9.63473 28.68 7.9727L28.6923 7.96066ZM23.8857 19.2215L12.8625 25.5203C11.1704 26.4838 10.5941 28.6155 11.575 30.2776C12.2371 31.3856 13.4142 32.0118 14.6404 32.0118C15.2412 32.0118 15.8543 31.8553 16.4183 31.5421L27.4416 25.2433C29.1337 24.2798 29.71 22.1481 28.7291 20.4861C27.7481 18.824 25.5778 18.258 23.8857 19.2215ZM3.5436 13.2478C4.14442 13.2478 4.7575 13.0913 5.32154 12.7781L16.3448 6.47929C18.0369 5.51579 18.6132 3.38407 17.6322 1.72204C16.6391 0.0720608 14.481 -0.493991 12.7889 0.469502L1.76565 6.76833C0.0735446 7.73183 -0.502754 9.86356 0.478179 11.5135C1.14031 12.6216 2.31743 13.2478 3.5436 13.2478ZM131.347 8.38218C130.525 7.57526 128.404 6.93695 127.031 6.93695C125.658 6.93695 124.664 7.16578 123.512 7.61139C122.359 8.05701 121.378 8.69532 120.569 9.50224C119.76 10.3092 119.122 11.2847 118.668 12.3927C118.215 13.5007 117.982 14.7292 117.982 16.066C117.982 17.3306 118.215 18.5109 118.693 19.6069C119.159 20.7028 119.809 21.6663 120.63 22.4974C121.452 23.3163 122.224 23.9667 123.377 24.4364C124.517 24.9061 125.363 25.147 127.129 25.147C129.557 25.147 131.359 23.6295 131.359 23.6295V24.7495H136.73V7.33439H131.359V8.38218H131.347ZM131.433 16.1142C131.433 18.812 129.618 20.5945 127.423 20.5945C125.228 20.5945 123.389 18.812 123.389 16.1142V16.054C123.389 13.3321 125.241 11.5738 127.423 11.5738C129.606 11.5738 131.433 13.3683 131.433 16.054V16.1142ZM183.054 6.91286C177.77 6.91286 173.821 10.7427 173.821 15.8372V15.8974C173.821 21.3652 177.855 25.1229 183.312 25.1229C186.598 25.1229 189.038 23.8583 190.742 21.7868L187.542 19.0047C186.439 20.3656 185.114 21.0642 183.385 21.0642C181.08 21.0642 179.449 19.8598 178.947 17.5715H191.601C191.638 17.1018 191.674 16.6441 191.674 16.2347C191.674 10.8511 188.106 6.91286 183.067 6.91286H183.054ZM178.873 14.404C179.204 12.3566 180.676 10.8511 182.809 10.8511C184.943 10.8511 186.328 12.2964 186.635 14.404H178.873ZM194.556 -0.000200971V24.7495H199.988V-0.000200971H194.556ZM63.3437 6.93695C62.2157 6.93695 61.1244 7.14169 60.0821 7.56322C59.0399 7.98474 58.1448 8.57488 57.4214 9.34568C57.2129 9.06867 56.9554 8.79167 56.6489 8.51467C56.3301 8.22562 55.9622 7.9727 55.5576 7.73183C55.1407 7.49095 54.6625 7.3103 54.0984 7.15373C53.5467 7.00921 52.9213 6.93695 52.2101 6.93695C51.0453 6.93695 50.0398 7.15373 49.1815 7.59935C48.3232 8.04496 47.6243 8.59897 47.0725 9.27342V7.34643H41.6774V24.7495H47.1093V15.4036C47.1093 14.2956 47.4281 13.3803 48.078 12.6577C48.7156 11.9471 49.5616 11.5858 50.5916 11.5858C51.5235 11.5858 52.2224 11.8748 52.6884 12.4409C53.1543 13.007 53.3873 13.8139 53.3873 14.8496V24.7495H58.6353V15.4036C58.6353 14.2956 58.9541 13.3803 59.5794 12.6577C60.2048 11.9471 61.0508 11.5858 62.1053 11.5858C63.0372 11.5858 63.7361 11.8748 64.2021 12.4409C64.668 13.007 64.901 13.8139 64.901 14.8496V24.7495H70.3451V13.9945C70.3451 11.8146 69.7443 10.1044 68.5549 8.83984C67.3656 7.5873 65.6244 6.94899 63.356 6.94899L63.3437 6.93695ZM151.517 7.0333C150.254 7.0333 149.224 7.3103 148.44 7.85226C147.643 8.39423 147.03 8.96028 146.576 9.56246V7.33439H141.181V24.7736H146.625V16.1624C146.625 14.7774 147.017 13.7055 147.814 12.9467C148.611 12.188 149.641 11.8146 150.929 11.8146C151.689 11.8146 152.339 11.8989 152.891 12.0796L153.761 7.37052C153.43 7.25008 153.099 7.15373 152.768 7.10556C152.425 7.05738 152.02 7.0333 151.542 7.0333H151.517ZM161.78 12.8383C162.136 12.4289 162.565 12.0916 163.08 11.8387C163.583 11.5858 164.159 11.4533 164.809 11.4533C165.741 11.4533 166.501 11.6219 167.065 11.9592C167.629 12.2964 168.107 12.6818 168.5 13.1274L171.725 9.70699C170.94 8.86393 169.959 8.17744 168.794 7.67161C167.641 7.16578 166.268 6.91286 164.686 6.91286C163.325 6.91286 162.075 7.15373 160.934 7.62343C159.782 8.09314 158.801 8.74349 157.967 9.56246C157.145 10.3935 156.496 11.357 156.03 12.4529C155.564 13.561 155.318 14.7412 155.318 15.9938C155.318 17.3306 155.551 18.547 156.005 19.6671C156.459 20.7872 157.096 21.7506 157.906 22.5576C158.715 23.3765 159.696 24.0028 160.848 24.4484C161.989 24.894 163.276 25.1229 164.674 25.1229C166.28 25.1229 167.666 24.8459 168.843 24.2798C170.008 23.7258 170.952 23.0514 171.676 22.2806L168.561 18.8602C168.193 19.2697 167.69 19.6551 167.077 20.0043C166.452 20.3536 165.692 20.5342 164.784 20.5342C164.135 20.5342 163.571 20.4018 163.056 20.1368C162.553 19.8718 162.111 19.5226 161.756 19.101C161.4 18.6795 161.131 18.1978 160.947 17.6438C160.763 17.1018 160.665 16.5478 160.665 15.9938C160.665 15.3916 160.75 14.8135 160.947 14.2715C161.131 13.7296 161.4 13.2478 161.756 12.8383H161.78ZM112.243 9.58655C111.422 8.76758 110.649 8.11722 109.497 7.64752C108.356 7.17782 107.51 6.93695 105.745 6.93695C103.317 6.93695 101.514 8.45445 101.514 8.45445V7.33439H96.1437V31.9998H101.514C101.514 31.9998 101.514 23.7138 101.514 23.7258C102.336 24.5327 104.457 25.171 105.83 25.171C107.204 25.171 108.197 24.9422 109.35 24.4966C110.502 24.051 111.483 23.4127 112.292 22.6057C113.102 21.7988 113.739 20.8353 114.193 19.7153C114.647 18.6073 114.88 17.3788 114.88 16.042C114.88 14.7774 114.647 13.5971 114.168 12.5011C113.702 11.4051 113.053 10.4296 112.231 9.61064L112.243 9.58655ZM109.497 16.042C109.497 18.7638 107.645 20.5222 105.463 20.5222C103.28 20.5222 101.453 18.7277 101.453 16.042V15.9817C101.453 13.284 103.268 11.5015 105.463 11.5015C107.657 11.5015 109.497 13.284 109.497 15.9817V16.042ZM82.7294 18.9806L78.0087 7.34643H72.1599L79.7008 24.7495L76.5496 31.9998H82.3371L93.3112 7.35847H87.7812L82.7294 18.9926V18.9806Z",
        fill: "#0F5C47"
      })
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_32686_39903" }, [
        g("rect", {
          width: "200",
          height: "32",
          fill: "white"
        })
      ])
    ], -1))
  ], 64);
}
const GL = /* @__PURE__ */ se(e8, [["render", t8]]), a8 = {}, o8 = { transform: "translate(-135.827 -151.567)" };
function n8(t, e) {
  return m(), C("g", o8, e[0] || (e[0] = [
    g("g", { transform: "translate(135.827 151.567)" }, [
      g("g", { transform: "translate(0.032 5.52)" }, [
        g("path", {
          fill: "#FFFFFF",
          d: "M139.081,198.386a3.08,3.08,0,0,1-1.551-5.743l19.183-11.149a3.08,3.08,0,1,1,3.1,5.326l-19.183,11.149A3.07,3.07,0,0,1,139.081,198.386Z",
          transform: "translate(-135.997 -181.077)"
        })
      ]),
      g("g", { transform: "translate(9.656 16.614)" }, [
        g("path", {
          fill: "#FFFFFF",
          d: "M190.531,252.122a3.08,3.08,0,0,1-1.551-5.743l9.592-5.574a3.08,3.08,0,0,1,3.1,5.326l-9.592,5.574A3.075,3.075,0,0,1,190.531,252.122Z",
          transform: "translate(-187.447 -240.387)"
        })
      ]),
      g("g", { transform: "translate(0 0)" }, [
        g("path", {
          fill: "#FFFFFF",
          d: "M138.911,163.3a3.08,3.08,0,0,1-1.551-5.743l9.592-5.574a3.08,3.08,0,0,1,3.1,5.326l-9.592,5.574A3.07,3.07,0,0,1,138.911,163.3Z",
          transform: "translate(-135.827 -151.567)"
        })
      ])
    ], -1),
    g("g", { transform: "translate(172.082 151.577)" }, [
      g("path", {
        fill: "#FFFFFF",
        d: "M959.768,192.552c0-4.764-3.105-8.262-7.484-8.262a7.782,7.782,0,0,0-8.034,7.909v.056a8.352,8.352,0,0,0,14.721,5.223l-2.785-2.467a4.375,4.375,0,0,1-3.62,1.82,3.671,3.671,0,0,1-3.865-3.1h11C959.738,193.319,959.768,192.908,959.768,192.552Zm-11.124-1.624a3.45,3.45,0,0,1,3.423-3.144,3.3,3.3,0,0,1,3.333,3.144Z",
        transform: "translate(-829.282 -178.179)"
      }),
      g("rect", {
        fill: "#FFFFFF",
        width: "4.731",
        height: "21.919",
        transform: "translate(133.015)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M353.013,186.1a6.445,6.445,0,0,1,1.562,4.568V200.2h-4.733V191.43a3.35,3.35,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.754,2.754,0,0,0-2.2.952,3.59,3.59,0,0,0-.823,2.43V200.2h-4.568V191.43a3.338,3.338,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.776,2.776,0,0,0-2.185.952,3.545,3.545,0,0,0-.84,2.43V200.2H329.64v-15.41h4.7l0,1.71a5.909,5.909,0,0,1,1.839-1.48,5.52,5.52,0,0,1,2.632-.591,6.361,6.361,0,0,1,1.642.195,5.522,5.522,0,0,1,1.265.511,5.335,5.335,0,0,1,.954.69,5.168,5.168,0,0,1,.673.737,6.5,6.5,0,0,1,2.316-1.575,7.389,7.389,0,0,1,2.84-.559A5.877,5.877,0,0,1,353.013,186.1Z",
        transform: "translate(-329.64 -178.293)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M802.459,184.929a3.956,3.956,0,0,1,.87.23l-.754,4.173a5.587,5.587,0,0,0-1.708-.232,3.733,3.733,0,0,0-2.709,1,3.771,3.771,0,0,0-1.038,2.841v7.623H792.39V185.118h4.7V187.1a7.108,7.108,0,0,1,1.625-1.511,4.587,4.587,0,0,1,2.679-.724A7.763,7.763,0,0,1,802.459,184.929Z",
        transform: "translate(-705.829 -178.642)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M863.13,190.815a4.755,4.755,0,0,0-.241,1.528,4.545,4.545,0,0,0,.241,1.465,4.043,4.043,0,0,0,.707,1.291,3.72,3.72,0,0,0,1.128.917,3.123,3.123,0,0,0,1.5.354,3.937,3.937,0,0,0,2-.466,5.307,5.307,0,0,0,1.289-1.014l2.7,3.027a7.977,7.977,0,0,1-2.464,1.771,8.246,8.246,0,0,1-3.627.743,8.9,8.9,0,0,1-3.33-.6,7.3,7.3,0,0,1-2.563-1.674,7.668,7.668,0,0,1-1.657-2.561,8.605,8.605,0,0,1-.6-3.253,8.077,8.077,0,0,1,.614-3.141,7.99,7.99,0,0,1,1.689-2.561,7.841,7.841,0,0,1,2.579-1.723,8.352,8.352,0,0,1,3.266-.629,8.7,8.7,0,0,1,3.575.677,7.588,7.588,0,0,1,2.548,1.8l-2.806,3.03a5.389,5.389,0,0,0-1.253-1.033,3.786,3.786,0,0,0-1.966-.451,3.234,3.234,0,0,0-1.5.339,3.675,3.675,0,0,0-1.128.887A3.855,3.855,0,0,0,863.13,190.815Z",
        transform: "translate(-759.345 -178.179)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M598.738,189.34a7.99,7.99,0,0,0-1.689-2.561,7.014,7.014,0,0,0-2.385-1.721,7.211,7.211,0,0,0-3.264-.629,6.227,6.227,0,0,0-3.683,1.343v-1H583.05v21.846h4.667s0-7.335.006-7.335a6.429,6.429,0,0,0,3.754,1.278,7.514,7.514,0,0,0,3.057-.6A7.325,7.325,0,0,0,597.1,198.3a7.668,7.668,0,0,0,1.657-2.561,8.607,8.607,0,0,0,.6-3.253A8.08,8.08,0,0,0,598.738,189.34Zm-4.085,3.148a3.651,3.651,0,0,1-3.513,3.969c-1.9,0-3.487-1.584-3.487-3.969v-.056c0-2.389,1.583-3.969,3.487-3.969a3.665,3.665,0,0,1,3.513,3.969Z",
        transform: "translate(-535.648 -178.293)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M696.215,184.75s-.006.939-.006.937a6.429,6.429,0,0,0-3.754-1.278,7.552,7.552,0,0,0-3.057.6,7.325,7.325,0,0,0-2.565,1.674,7.668,7.668,0,0,0-1.657,2.561,8.605,8.605,0,0,0-.6,3.253,8.092,8.092,0,0,0,2.3,5.7,7.053,7.053,0,0,0,2.387,1.723,7.211,7.211,0,0,0,3.264.629,6.246,6.246,0,0,0,3.683-1.341v.993h4.667V184.76Zm.062,7.793c0,2.389-1.583,3.969-3.487,3.969a3.665,3.665,0,0,1-3.513-3.969v-.056a3.65,3.65,0,0,1,3.513-3.969c1.9,0,3.487,1.582,3.487,3.969Z",
        transform: "translate(-618.186 -178.276)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M485.035,186.36h4.807L480.3,208.192h-5.037L478,201.77l-6.564-15.41h5.092l4.106,10.307Z",
        transform: "translate(-444.915 -179.862)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M959.768,192.552c0-4.764-3.105-8.262-7.484-8.262a7.782,7.782,0,0,0-8.034,7.909v.056a8.352,8.352,0,0,0,14.721,5.223l-2.785-2.467a4.375,4.375,0,0,1-3.62,1.82,3.671,3.671,0,0,1-3.865-3.1h11C959.738,193.319,959.768,192.908,959.768,192.552Zm-11.124-1.624a3.45,3.45,0,0,1,3.423-3.144,3.3,3.3,0,0,1,3.333,3.144Z",
        transform: "translate(-829.282 -178.179)"
      }),
      g("rect", {
        fill: "#FFFFFF",
        width: "4.731",
        height: "21.919",
        transform: "translate(133.015)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M353.013,186.1a6.445,6.445,0,0,1,1.562,4.568V200.2h-4.733V191.43a3.35,3.35,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.754,2.754,0,0,0-2.2.952,3.59,3.59,0,0,0-.823,2.43V200.2h-4.568V191.43a3.338,3.338,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.776,2.776,0,0,0-2.185.952,3.545,3.545,0,0,0-.84,2.43V200.2H329.64v-15.41h4.7l0,1.71a5.909,5.909,0,0,1,1.839-1.48,5.52,5.52,0,0,1,2.632-.591,6.361,6.361,0,0,1,1.642.195,5.522,5.522,0,0,1,1.265.511,5.335,5.335,0,0,1,.954.69,5.168,5.168,0,0,1,.673.737,6.5,6.5,0,0,1,2.316-1.575,7.389,7.389,0,0,1,2.84-.559A5.877,5.877,0,0,1,353.013,186.1Z",
        transform: "translate(-329.64 -178.293)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M802.459,184.929a3.956,3.956,0,0,1,.87.23l-.754,4.173a5.587,5.587,0,0,0-1.708-.232,3.733,3.733,0,0,0-2.709,1,3.771,3.771,0,0,0-1.038,2.841v7.623H792.39V185.118h4.7V187.1a7.108,7.108,0,0,1,1.625-1.511,4.587,4.587,0,0,1,2.679-.724A7.763,7.763,0,0,1,802.459,184.929Z",
        transform: "translate(-705.829 -178.642)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M863.13,190.815a4.755,4.755,0,0,0-.241,1.528,4.545,4.545,0,0,0,.241,1.465,4.043,4.043,0,0,0,.707,1.291,3.72,3.72,0,0,0,1.128.917,3.123,3.123,0,0,0,1.5.354,3.937,3.937,0,0,0,2-.466,5.307,5.307,0,0,0,1.289-1.014l2.7,3.027a7.977,7.977,0,0,1-2.464,1.771,8.246,8.246,0,0,1-3.627.743,8.9,8.9,0,0,1-3.33-.6,7.3,7.3,0,0,1-2.563-1.674,7.668,7.668,0,0,1-1.657-2.561,8.605,8.605,0,0,1-.6-3.253,8.077,8.077,0,0,1,.614-3.141,7.99,7.99,0,0,1,1.689-2.561,7.841,7.841,0,0,1,2.579-1.723,8.352,8.352,0,0,1,3.266-.629,8.7,8.7,0,0,1,3.575.677,7.588,7.588,0,0,1,2.548,1.8l-2.806,3.03a5.389,5.389,0,0,0-1.253-1.033,3.786,3.786,0,0,0-1.966-.451,3.234,3.234,0,0,0-1.5.339,3.675,3.675,0,0,0-1.128.887A3.855,3.855,0,0,0,863.13,190.815Z",
        transform: "translate(-759.345 -178.179)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M598.738,189.34a7.99,7.99,0,0,0-1.689-2.561,7.014,7.014,0,0,0-2.385-1.721,7.211,7.211,0,0,0-3.264-.629,6.227,6.227,0,0,0-3.683,1.343v-1H583.05v21.846h4.667s0-7.335.006-7.335a6.429,6.429,0,0,0,3.754,1.278,7.514,7.514,0,0,0,3.057-.6A7.325,7.325,0,0,0,597.1,198.3a7.668,7.668,0,0,0,1.657-2.561,8.607,8.607,0,0,0,.6-3.253A8.08,8.08,0,0,0,598.738,189.34Zm-4.085,3.148a3.651,3.651,0,0,1-3.513,3.969c-1.9,0-3.487-1.584-3.487-3.969v-.056c0-2.389,1.583-3.969,3.487-3.969a3.665,3.665,0,0,1,3.513,3.969Z",
        transform: "translate(-535.648 -178.293)"
      }),
      g("path", {
        fill: "#FFFFFF",
        d: "M485.035,186.36h4.807L480.3,208.192h-5.037L478,201.77l-6.564-15.41h5.092l4.106,10.307Z",
        transform: "translate(-444.915 -179.862)"
      })
    ], -1)
  ]));
}
const XL = /* @__PURE__ */ se(a8, [["render", n8]]), r8 = {};
function s8(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      d: "M3.17621 23.4525C2.09698 23.4525 1.04186 22.8875 0.45703 21.879C-0.417207 20.3663 0.0952765 18.4344 1.59655 17.5535L21.1553 6.09548C22.6566 5.21457 24.5799 5.73097 25.4481 7.24371C26.3224 8.75645 25.8099 10.6884 24.3086 11.5693L4.74983 23.0273C4.25544 23.3128 3.71281 23.4525 3.17621 23.4525Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M12.9916 29.1269C11.9124 29.1269 10.8573 28.5619 10.2725 27.5534C9.39822 26.0407 9.91071 24.1088 11.412 23.2278L21.1914 17.4988C22.6927 16.624 24.616 17.1343 25.4842 18.6471C26.3584 20.1598 25.8459 22.0918 24.3447 22.9727L14.5653 28.7017C14.0709 28.9872 13.5282 29.1269 12.9916 29.1269Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[2] || (e[2] = g("path", {
      d: "M3.14594 12.0554C2.0667 12.0554 1.01159 11.4904 0.426756 10.4819C-0.447481 8.96915 0.0650039 7.03114 1.56628 6.1563L11.3457 0.427316C12.847 -0.447523 14.7703 0.0628004 15.6385 1.57554C16.5127 3.08829 16.0002 5.0263 14.499 5.90114L4.71956 11.624C4.22517 11.9157 3.68254 12.0554 3.14594 12.0554Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[3] || (e[3] = g("path", {
      d: "M116.532 6.66056L116.525 7.62653C115.802 6.89142 113.915 6.31427 112.697 6.31427C111.455 6.31427 110.599 6.52083 109.58 6.92787C108.561 7.33492 107.687 7.90599 106.963 8.64718C106.24 9.38836 105.673 10.2632 105.275 11.2778C104.871 12.2923 104.666 13.4041 104.666 14.6192C104.666 15.7674 104.877 16.8427 105.293 17.8451C105.703 18.8476 106.282 19.7224 107.011 20.4757C107.747 21.223 108.422 21.8123 109.447 22.2436C110.46 22.675 111.214 22.8876 112.775 22.8876C114.934 22.8876 116.525 21.5085 116.532 21.5085V22.5292H121.289V6.66664L116.532 6.66056ZM116.598 14.6678C116.598 17.1222 114.982 18.7443 113.041 18.7443C111.099 18.7443 109.459 17.1222 109.459 14.6678V14.6131C109.459 12.1344 111.099 10.5366 113.041 10.5366C114.982 10.5366 116.598 12.1648 116.598 14.6131V14.6678Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[4] || (e[4] = g("path", {
      d: "M170.016 14.7771C170.016 9.8804 166.851 6.28992 162.383 6.28992C157.692 6.28992 154.189 9.77713 154.189 14.4186V14.4794C154.189 19.449 157.771 22.8754 162.612 22.8754C165.53 22.8754 167.695 21.7272 169.202 19.8439L166.362 17.3105C165.386 18.5559 164.204 19.1816 162.673 19.1816C160.629 19.1816 159.188 18.0881 158.735 15.9982H169.956C169.986 15.5669 170.016 15.1416 170.016 14.7771ZM158.675 13.1064C158.965 11.2413 160.273 9.87433 162.166 9.87433C164.089 9.87433 165.289 11.1866 165.567 13.1064H158.675Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[5] || (e[5] = g("path", {
      d: "M200 8.10036C200 5.48192 198.306 3.56213 195.924 3.56213C193.416 3.56213 191.547 5.42724 191.547 7.90595V7.93633C191.547 10.5912 193.458 12.426 196.045 12.426C197.606 12.426 198.758 11.8124 199.566 10.8039L198.046 9.44907C197.528 10.1113 196.895 10.4454 196.075 10.4454C194.984 10.4454 194.212 9.86219 193.971 8.74434H199.964C199.988 8.52563 200 8.29477 200 8.10036ZM193.94 7.2073C194.097 6.21095 194.791 5.48192 195.804 5.48192C196.835 5.48192 197.474 6.18665 197.618 7.2073H193.94Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[6] || (e[6] = g("path", {
      d: "M177.42 0.00817871H172.597V22.5292H177.42V0.00817871Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[7] || (e[7] = g("path", {
      d: "M60.7964 8.03357C61.8575 9.1818 62.3881 10.7492 62.3881 12.7237V22.517H57.5647V13.5013C57.5647 12.5536 57.3597 11.8245 56.9437 11.3081C56.5337 10.7917 55.9127 10.5305 55.0807 10.5305C54.1462 10.5305 53.3925 10.8586 52.8378 11.5086C52.2771 12.1648 51.9998 12.9971 51.9998 14.0056V22.517H47.3452V13.5013C47.3452 12.5536 47.1402 11.8245 46.7242 11.3081C46.3142 10.7917 45.6932 10.5305 44.8672 10.5305C43.9508 10.5305 43.2092 10.8586 42.6424 11.5086C42.0757 12.1648 41.7863 12.9971 41.7863 14.0056V22.517H36.9629V6.68486H41.7501V8.44062C42.2385 7.83309 42.8655 7.32277 43.6252 6.9218C44.3849 6.51475 45.2772 6.31427 46.3082 6.31427C46.9352 6.31427 47.4899 6.3811 47.9843 6.51476C48.4727 6.65449 48.9068 6.82459 49.2746 7.03723C49.6423 7.24986 49.9679 7.4868 50.2453 7.74804C50.5226 8.0032 50.7517 8.25836 50.9326 8.50744C51.5777 7.81486 52.3675 7.26809 53.296 6.89142C54.2245 6.50868 55.1892 6.31427 56.1901 6.31427C58.2038 6.31427 59.7413 6.88535 60.7964 8.03357Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[8] || (e[8] = g("path", {
      d: "M135.499 6.46609C135.801 6.50862 136.096 6.5876 136.386 6.70303L135.614 10.9922C135.125 10.8342 134.541 10.7552 133.871 10.7552C132.732 10.7552 131.815 11.1015 131.11 11.788C130.405 12.4745 130.055 13.4466 130.055 14.7102V22.5413H125.231V6.6605H130.025V8.69572C130.429 8.15502 130.977 7.63862 131.683 7.14045C132.388 6.64835 133.299 6.39319 134.414 6.39319C134.836 6.39926 135.198 6.42356 135.499 6.46609Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[9] || (e[9] = g("path", {
      d: "M142.794 12.9909C142.632 13.4891 142.547 14.0116 142.547 14.5584C142.547 15.0687 142.625 15.5669 142.794 16.065C142.957 16.5632 143.198 17.0067 143.518 17.3894C143.831 17.7722 144.217 18.0881 144.669 18.3311C145.116 18.5741 145.628 18.6956 146.201 18.6956C147.009 18.6956 147.684 18.5377 148.239 18.2157C148.781 17.8937 149.221 17.5474 149.553 17.1707L152.314 20.2813C151.681 20.986 150.837 21.5935 149.8 22.1039C148.757 22.6081 147.527 22.8633 146.098 22.8633C144.85 22.8633 143.717 22.6567 142.704 22.2497C141.685 21.8426 140.811 21.2715 140.087 20.5304C139.364 19.7953 138.797 18.9143 138.399 17.8998C137.995 16.8852 137.79 15.7734 137.79 14.5584C137.79 13.4101 138.001 12.3348 138.417 11.3324C138.827 10.33 139.406 9.45514 140.141 8.7018C140.871 7.95454 141.751 7.36524 142.77 6.9339C143.783 6.50255 144.898 6.28992 146.098 6.28992C147.497 6.28992 148.715 6.52078 149.746 6.9825C150.777 7.44422 151.645 8.0639 152.345 8.83546L149.487 11.9521C149.137 11.5511 148.709 11.1987 148.209 10.8889C147.702 10.5791 147.033 10.4272 146.207 10.4272C145.634 10.4272 145.128 10.5426 144.675 10.7735C144.229 11.0043 143.843 11.3081 143.524 11.6848C143.198 12.0614 142.957 12.4928 142.794 12.9909Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[10] || (e[10] = g("path", {
      d: "M101.301 11.3567C100.891 10.3543 100.312 9.47949 99.5768 8.72615C98.8473 7.9789 98.166 7.38959 97.1471 6.95825C96.1341 6.52691 95.3805 6.31427 93.8189 6.31427C91.6605 6.31427 90.0687 7.68728 90.0627 7.69336V6.67271H85.3057V29.1148H90.0627C90.0627 29.1148 90.0687 21.5754 90.0687 21.5814C90.7923 22.3165 92.6794 22.8937 93.8973 22.8937C95.1454 22.8937 96.0015 22.6871 97.0144 22.2801C98.0333 21.873 98.9076 21.302 99.6311 20.5608C100.355 19.8196 100.921 18.9448 101.319 17.9302C101.723 16.9156 101.928 15.8038 101.928 14.5888C101.922 13.4345 101.717 12.3652 101.301 11.3567ZM97.135 14.5949C97.135 17.0736 95.495 18.6714 93.5536 18.6714C91.6122 18.6714 89.9964 17.0432 89.9964 14.5949V14.5341C89.9964 12.0797 91.6122 10.4576 93.5536 10.4576C95.495 10.4576 97.135 12.0797 97.135 14.5341V14.5949Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[11] || (e[11] = g("path", {
      d: "M190.244 7.98496C190.244 7.33491 190.135 6.73953 189.918 6.19883C189.701 5.65814 189.399 5.18426 189.014 4.79545C188.628 4.40055 188.163 4.09071 187.615 3.87808C187.072 3.65937 186.614 3.55001 185.951 3.55001C185.3 3.55001 184.293 3.85985 183.907 4.24867L183.901 0.220764H181.356V12.2134H183.901V11.6666C183.907 11.6666 184.757 12.4017 185.908 12.4017C186.741 12.4017 187.144 12.2863 187.687 12.0554C188.23 11.8245 188.598 11.5086 188.989 11.1077C189.381 10.7067 189.689 10.2389 189.912 9.70427C190.129 9.16964 190.244 8.59857 190.244 7.98496ZM187.681 8.00927C187.681 9.32153 186.807 10.1903 185.77 10.1903C184.733 10.1903 183.871 9.32153 183.871 8.00927V7.97889C183.871 6.66663 184.733 5.79787 185.77 5.79787C186.807 5.79787 187.681 6.65448 187.681 7.97889V8.00927Z",
      fill: "#0F5C47"
    }, null, -1)),
    e[12] || (e[12] = g("path", {
      d: "M77.8778 6.68488H82.7795L73.0423 29.1148H67.9054L70.709 22.517L64.0166 6.68488H69.2017L73.392 17.2741L77.8778 6.68488Z",
      fill: "#0F5C47"
    }, null, -1))
  ], 64);
}
const QL = /* @__PURE__ */ se(r8, [["render", s8]]), i8 = {}, l8 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M3.357 10.43c-1.182-2.408-1.304-5.483.593-7.38v0c.42-.42 1.063-.619 1.686-.705 1.126-.155 2.076.68 2.436 1.757l.698 2.095a3 3 0 0 1-.405 2.693l-.32.447c-.353.495-.464 1.127-.226 1.688.38.897 1.11 2.309 2.318 3.516 1.086 1.085 2.336 1.785 3.23 2.192.7.318 1.494.053 1.955-.562v0a2.782 2.782 0 0 1 3.403-.852l1.525.712c1.056.493 1.786 1.58 1.42 2.686-.158.474-.394.949-.75 1.304v0c-1.911 1.911-4.996 1.929-7.44.774a20.177 20.177 0 0 1-5.641-3.956c-2.075-2.075-3.526-4.461-4.482-6.41Z"
};
function u8(t, e) {
  return m(), C("path", l8);
}
const JL = /* @__PURE__ */ se(i8, [["render", u8]]), c8 = {}, d8 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.43 6.63c-.507.508-1.036 1.218-1.546 2.013-1.803 2.81-1.96 6.35-.615 9.461 1.793 4.148 4.957 10.061 9.94 15.044 5.038 5.039 10.549 7.737 14.281 9.113 2.684.989 5.646.695 8.112-.773 1.059-.63 2.05-1.318 2.709-1.976.602-.603 1.02-1.43 1.307-2.29l-10.862-5.111-1.217 1.623c-.68.906-1.882 1.331-2.998.89-1.778-.703-5.037-2.252-7.797-5.012-2.98-2.98-4.549-6.542-5.166-8.197-.309-.827-.141-1.715.343-2.393l.503-.704-4.283-12.85a9.764 9.764 0 0 0-.59.117c-.872.206-1.618.543-2.121 1.046Zm24.264 24.265 10.301 4.847c.018-.096.035-.19.05-.284.123-.76-.322-1.53-1.131-1.908l-6.669-3.112a2.25 2.25 0 0 0-2.551.457ZM18.229 16.972l-1.14 1.596.007.023-.032.01-.922 1.293c-.225.314-.276.683-.159.997.584 1.563 2.06 4.898 4.821 7.66 2.557 2.557 5.606 4.012 7.288 4.678.426.169.932.025 1.247-.395l1.955-2.607a3.75 3.75 0 0 1 4.586-1.149l6.668 3.112c1.303.608 2.228 1.968 1.977 3.509-.233 1.436-.785 3.504-2.154 4.873-.791.792-1.91 1.554-3.002 2.204-2.846 1.695-6.28 2.04-9.398.892-3.871-1.427-9.589-4.225-14.823-9.46C9.982 29.043 6.726 22.943 4.892 18.7c-1.523-3.523-1.37-7.595.73-10.867.535-.834 1.13-1.645 1.747-2.262.778-.778 1.828-1.206 2.838-1.444 1.02-.24 2.068-.304 2.917-.303 1.51.003 2.7 1.053 3.144 2.385l2.467 7.399a3.75 3.75 0 0 1-.506 3.365ZM12.676 5.329l3.826 11.48.506-.709a2.25 2.25 0 0 0 .304-2.02l-2.467-7.397c-.274-.824-.961-1.358-1.724-1.36-.144 0-.293.002-.445.006Z",
  "clip-rule": "evenodd"
};
function m8(t, e) {
  return m(), C("path", d8);
}
const ex = /* @__PURE__ */ se(c8, [["render", m8]]), p8 = {}, f8 = { fill: "none" };
function h8(t, e) {
  return m(), C("g", f8, e[0] || (e[0] = [
    g("path", {
      d: "M9.5 6.5H21.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M9.5 11.5H21.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M9.5 16.5H21.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M6.5 7.5L2.5 11.5L6.5 15.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const v8 = /* @__PURE__ */ se(p8, [["render", h8]]), g8 = {}, y8 = { fill: "none" };
function b8(t, e) {
  return m(), C("g", y8, e[0] || (e[0] = [
    g("path", {
      d: "M2.5 6.5H14.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M2.5 11.5H14.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M2.5 16.5H14.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    g("path", {
      d: "M17.5 7.5L21.5 11.5L17.5 15.5",
      stroke: "black",
      "stroke-opacity": "0.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const k8 = /* @__PURE__ */ se(g8, [["render", b8]]), C8 = {}, w8 = {
  fill: "currentColor",
  d: "M7.102 1.56a5.149 5.149 0 0 1 1.817.045 1 1 0 0 0-1.817-.046Zm2.897.396a2 2 0 0 0-3.994-.1 5.13 5.13 0 0 0-3.172 3.882l-.628 3.556a5.644 5.644 0 0 1-.718 1.923l-.219.364A1.267 1.267 0 0 0 2.355 13.5H5.04a3 3 0 0 0 5.917 0h2.768c.933 0 1.451-1.079.869-1.807l-.236-.294A4.918 4.918 0 0 1 13.315 8.9l-.338-2.871A5.129 5.129 0 0 0 10 1.956ZM8 15a2 2 0 0 1-1.936-1.5h3.874A2 2 0 0 1 8 15ZM7.885 2.5a4.13 4.13 0 0 1 4.1 3.647l.338 2.871c.13 1.1.565 2.14 1.256 3.005l.236.295a.112.112 0 0 1-.088.182H2.355a.267.267 0 0 1-.23-.405l.22-.364a6.643 6.643 0 0 0 .845-2.263l.627-3.557A4.129 4.129 0 0 1 7.884 2.5Z"
};
function _8(t, e) {
  return m(), C("path", w8);
}
const tx = /* @__PURE__ */ se(C8, [["render", _8]]), H8 = {}, j8 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.2859 2.64435C10.8067 2.5497 11.3764 2.5 11.9998 2.5C12.6231 2.5 13.1928 2.5497 13.7136 2.64435C13.5493 1.84838 12.8444 1.25 11.9998 1.25C11.1551 1.25 10.4502 1.84838 10.2859 2.64435ZM14.7484 2.91147C14.7016 1.43366 13.4889 0.25 11.9998 0.25C10.5106 0.25 9.29789 1.43366 9.25115 2.91148C8.59844 3.13578 8.04013 3.44611 7.56236 3.82831C6.52269 4.66002 5.91768 5.78975 5.52528 6.96688C5.16376 8.05138 4.9711 9.21518 4.7974 10.2644L4.7564 10.5116C4.56579 11.6554 4.38738 12.6065 4.05252 13.2764C3.20296 14.976 2.35315 16.6755 1.77605 17.8296C1.27708 18.8274 2.00334 20 3.11797 20H7.77886C8.02632 22.1116 9.8217 23.75 11.9998 23.75C14.1778 23.75 15.9732 22.1116 16.2207 20H20.8819C21.9964 20 22.7227 18.8277 22.2239 17.8299L19.9473 13.2764C19.6124 12.6065 19.4339 11.6553 19.2433 10.5115L19.2022 10.2641C19.0285 9.21492 18.8358 8.05125 18.4743 6.96687C18.0819 5.78975 17.4768 4.66002 16.4372 3.82831C15.9594 3.44611 15.4011 3.13578 14.7484 2.91147ZM5.7428 10.6759C5.55845 11.7821 5.36195 12.8935 4.94699 13.7236C4.0974 15.4232 3.24757 17.1228 2.67046 18.2769C2.50443 18.6089 2.74574 19 3.11797 19H20.8819C21.2541 19 21.4954 18.609 21.3294 18.277L19.0529 13.7236C18.6379 12.8935 18.4413 11.7822 18.2569 10.676L18.2181 10.4424C18.0415 9.37754 17.8609 8.28904 17.5256 7.28313C17.1679 6.21025 16.6479 5.27748 15.8125 4.60919C14.9827 3.94536 13.7883 3.5 11.9998 3.5C10.2112 3.5 9.01686 3.94536 8.18705 4.60919C7.35166 5.27748 6.8316 6.21025 6.47396 7.28312C6.1386 8.28912 5.95811 9.37773 5.78154 10.4427L5.7428 10.6759ZM11.9998 22.75C10.3749 22.75 9.02848 21.5575 8.78798 20H15.2115C14.971 21.5575 13.6246 22.75 11.9998 22.75Z",
  "clip-rule": "evenodd"
};
function L8(t, e) {
  return m(), C("path", j8);
}
const ax = /* @__PURE__ */ se(H8, [["render", L8]]), x8 = {}, $8 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7624 2C15.8988 2.00005 16.9119 2.27211 17.8029 2.81393L14.1968 6.43425L11.0594 3.28458C12.0994 2.42868 13.3334 2 14.7624 2ZM17.7171 11.8052L17.5156 12.0001L17.5193 12.0038L9.91443 19.6385L6.52249 16.3649L19.0312 3.80693C19.936 4.73588 20.389 5.85632 20.389 7.16849C20.389 8.30138 20.0515 9.29149 19.377 10.1387L17.7171 11.8052ZM18.8567 20.3654C17.7388 21.4547 16.3739 22 14.7623 22C13.3334 22 12.0994 21.5708 11.0594 20.7154L18.6282 13.1168L18.8567 13.3462C19.8781 14.3077 20.3891 15.4773 20.3891 16.8558C20.3891 18.2335 19.8781 19.4039 18.8567 20.3654ZM9.91449 4.36151L2.00018 11.9997L2 11.9999L5.39192 15.2735L13.0878 7.54731L9.91449 4.36151Z",
  fill: "#FF3E3E"
};
function M8(t, e) {
  return m(), C("path", $8);
}
const H0 = /* @__PURE__ */ se(x8, [["render", M8]]), V8 = {};
function S8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0627 1.71491H11.9995H11.9985C11.937 1.71503 11.8754 1.72634 11.8139 1.74064L11.81 1.73615C11.8027 1.73984 11.7947 1.74352 11.7863 1.74721L11.7466 1.75706L11.7466 1.75706L11.7512 1.76241C11.7226 1.77473 11.6959 1.78706 11.6836 1.79938L11.6122 1.8351L11.5995 1.82036L11.3677 1.94681L11.3686 1.94788L11.1772 2.05225L11.1786 2.05385L10.9883 2.15768L10.989 2.15849L10.7979 2.26274L10.7986 2.26364L10.6618 2.33825L10.6513 2.32592L10.4696 2.44154L10.4608 2.43136L10.229 2.55781L10.2302 2.55924L10.0396 2.66324L10.0405 2.66431L9.84912 2.76868L9.85081 2.77066L9.66113 2.87412L9.66174 2.87483L9.52369 2.95013L9.51268 2.93731L9.25977 3.06376L9.26621 3.07126L9.07031 3.16921L9.07644 3.17633L8.87988 3.27461L8.88624 3.28201L8.69092 3.37968L8.69704 3.38682L8.50049 3.48511L8.50649 3.4921L8.38071 3.55499L8.37498 3.5483L8.12207 3.67476L8.12822 3.68192L7.93164 3.7802L7.93791 3.7875L7.78363 3.86464L7.78359 3.86459L7.78226 3.86532L7.7417 3.8856L7.74278 3.88686L7.55176 3.99105L7.55315 3.99267L7.36279 4.0965L7.36402 4.09793L7.22725 4.17252L7.21621 4.15967L6.98438 4.28612L6.98513 4.287L6.79346 4.39155L6.79486 4.39319L6.60449 4.49702L6.60524 4.49789L6.41357 4.60243L6.41489 4.60397L6.2251 4.7075L6.22638 4.709L6.0887 4.78409L6.07754 4.77106L5.8457 4.89751L5.84639 4.89832L5.65527 5.00257L5.65634 5.00381L5.46533 5.108L5.46672 5.10962L5.27637 5.21345L5.27743 5.21469L5.08643 5.31888L5.08796 5.32067L4.95017 5.39583L4.93838 5.38205L4.70654 5.50851L4.70822 5.51048L4.51855 5.61394L4.51917 5.61466L4.32715 5.7194L4.32868 5.72119L4.13867 5.82484L4.13957 5.82588L3.94824 5.93024L3.94927 5.93144L3.81242 6.00609L3.80125 5.99306L3.54834 6.11951L3.55662 6.12963L3.46289 6.18319L3.71297 6.32073L3.73802 6.35135L4.40235 6.71371L4.83164 6.96088L4.83343 6.96297L5.50785 7.36341L5.48559 7.33726L5.9149 7.57874L5.9289 7.59513L6.46736 7.89802L6.4786 7.91119L7.03506 8.2242L7.69932 8.60665L7.69891 8.60617L8.09812 8.83602L8.10028 8.83854L8.14238 8.86151L8.24902 8.9229L8.24378 8.91682L8.62118 9.12268L8.64851 9.15463L9.18216 9.45482L9.19574 9.4707L9.87017 9.85007L9.85372 9.83087L10.4184 10.1662L10.4021 10.1471L10.9671 10.4826L10.9458 10.4576L11.3359 10.6771L11.3676 10.7141L11.8851 10.9964L11.9144 11.0306L12.5012 11.3506L12.6532 11.452C12.7263 11.4885 12.7993 11.5725 12.8175 11.6627L12.7995 11.6418C12.7995 11.6523 12.8048 11.6628 12.8101 11.6734C12.8153 11.6839 12.8206 11.6944 12.8206 11.705V12.0633L12.8218 12.0647V12.2955L12.8216 12.2952V12.7167L12.8218 12.717V12.949L12.821 12.9482V13.2647L12.8208 13.2643V13.6859L12.8215 13.6867V13.9181L12.8212 13.9178V14.3183L12.8224 14.3197V14.5731L12.8207 14.5711V14.9716L12.8224 14.9735V15.2266L12.8207 15.2246V15.625L12.8219 15.6264V15.8578L12.8212 15.8569V16.2574L12.8214 16.2577V16.5943L12.8217 16.5947V16.8278L12.8205 16.8265V17.248L12.8211 17.2487V17.5641L12.8222 17.5653V17.7967L12.8214 17.7957V18.1332L12.821 18.1328V18.5332L12.8221 18.5345V18.7663L12.8212 18.7653V19.1868L12.8213 19.1869V19.3552C12.8213 19.3793 12.8144 19.4034 12.8046 19.4236L12.8002 19.4185C12.7981 19.4272 12.7955 19.4358 12.7925 19.4444C12.7882 19.4506 12.7837 19.4561 12.7792 19.4606L12.784 19.4661C12.7604 19.5205 12.7218 19.5696 12.6805 19.595L12.6738 19.5871C12.6738 19.5922 12.6738 19.5961 12.6735 19.5991C12.6666 19.6028 12.6598 19.6059 12.6529 19.6082H12.6527L12.5075 19.6953L12.5052 19.6926L12.3186 19.8015L12.3155 19.798L12.168 19.8823C12.1258 19.9034 12.0837 19.9034 12.0415 19.9034L12.0534 19.9171C12.0408 19.9212 12.0289 19.9246 12.0205 19.9246H11.9994C11.9362 19.9246 11.894 19.9035 11.8519 19.8825L11.8519 19.8825L11.8133 19.8653L11.8097 19.8612L11.346 19.6082C11.2617 19.5661 11.1985 19.4607 11.1985 19.3553L11.1985 19.2291L11.1985 19.1446L11.1985 18.9128V18.8286V18.5756V18.5124L11.1985 18.2593V17.8589L11.1985 17.6059L11.1985 17.5428L11.1985 17.2055L11.1984 17.2054V16.9728L11.1993 16.9738V16.5734L11.1982 16.5721V16.32L11.1985 16.3204V16.0031L11.1994 16.0041V15.5825L11.1983 15.5813V15.2668L11.1977 15.2661V15.0332L11.1989 15.0346V14.6131L11.1986 14.6127V14.2971L11.1983 14.2968V14.0435L11.1991 14.0444V13.644L11.1979 13.6426V13.41L11.1996 13.412V13.0115L11.1979 13.0096V12.7567L11.1996 12.7587V12.5269C11.1996 12.4847 11.1575 12.4215 11.1153 12.4004L10.8009 12.2146L10.7975 12.2106L10.6673 12.1357L10.6517 12.1264L10.6521 12.1269L10.2538 11.8976L10.2512 11.8945L10.1996 11.8664L10.1019 11.8102L10.1068 11.8158L9.72749 11.6089L9.70148 11.5785L9.02705 11.1991L9.04199 11.2165L8.4803 10.883L8.49734 10.9029L7.93158 10.5669L7.95266 10.5915L7.56488 10.3734L7.53168 10.3347L6.83617 9.95531L6.83697 9.95624L6.43695 9.72593L6.43517 9.72385L5.76074 9.32341L5.78091 9.34693L5.35144 9.10536L5.33946 9.0914L4.66504 8.71203L4.68129 8.73095L4.1167 8.39572L4.1321 8.41364L3.72134 8.16975L3.7165 8.1641L3.6591 8.1328L3.56982 8.07979L3.57678 8.08789L3.19676 7.88061L3.16861 7.8478L3 7.7635V7.97436V8.05856V8.31152V8.39588V8.62782V8.71197V8.965V9.02826V9.28131V9.36544V9.59723V9.68175V9.93442V10.0187V10.2507V10.3349V10.5666V10.6512V10.9042V10.9882V11.2201V11.3046V11.5361V11.6206V11.8736V11.9576V12.1895V12.2741V12.5267V12.59V12.843V12.9271V13.159V13.2435V13.4961V13.5594V13.8124V13.8966V14.1284V14.2129V14.4659V14.5288V14.7822V14.8664V15.0981V15.1826V15.4353V15.5197V15.7512V15.8357V16.0676V16.1517V16.4047V16.4891V16.721V16.8052V16.8264C3 16.9534 3.05357 17.0957 3.13304 17.2118L3.12697 17.2057C3.12917 17.2079 3.13132 17.2102 3.13341 17.2124C3.18575 17.2887 3.24929 17.3537 3.31614 17.3954L3.80767 17.6617L4.22122 17.8998L4.2224 17.9012L4.73465 18.1961L4.77037 18.2382L5.29051 18.5219L5.31834 18.5545L6.01384 18.955L5.99788 18.9363L6.56181 19.2712L6.5428 19.2489L6.9825 19.5021L6.98333 19.503L7.5308 19.8182L7.53131 19.8188L8.07782 20.1335L8.07928 20.1352L8.62651 20.4503L8.62726 20.4511L9.17997 20.7694L9.19628 20.7884L9.87071 21.1888L9.85505 21.1705L10.4187 21.5052L10.399 21.4822L10.839 21.7355L10.8402 21.7369L11.3867 22.0516L11.3882 22.0533L11.6832 22.2219C11.7306 22.2535 11.8017 22.2732 11.8698 22.2811L11.8729 22.2848H11.9174C11.9237 22.285 11.93 22.2851 11.9362 22.2851L11.9359 22.2848H11.9994C12.0461 22.2848 12.0928 22.2848 12.1395 22.2763L12.1469 22.285L12.3366 22.2217L12.3998 22.1796L12.3988 22.1784L12.5895 22.0744L12.5882 22.0728L12.7792 21.9687L12.7715 21.9597L12.9478 21.8635L12.9466 21.8621L13.1375 21.758L13.1343 21.7543L13.2763 21.6639L13.285 21.6739L13.4662 21.5586L13.4747 21.5684L13.6558 21.4531L13.6644 21.463L13.8962 21.3155L13.8883 21.3062L14.0648 21.2099L14.0637 21.2087L14.2545 21.1046L14.2533 21.1032L14.4442 20.9991L14.4431 20.9979L14.6338 20.8939L14.6329 20.8929L14.8243 20.7885L14.816 20.7788L14.9918 20.6829L14.9909 20.6819L15.1819 20.5777L15.1789 20.5742L15.3209 20.4839L15.3292 20.4936L15.5099 20.3786L15.5183 20.3883L15.6868 20.281L15.688 20.2825L15.9199 20.1349L15.9187 20.1336L16.1092 20.0297L16.1082 20.0285L16.2987 19.9246L16.2978 19.9235L16.4891 19.8192L16.4876 19.8174L16.6776 19.7137L16.6702 19.7052L16.8479 19.6083L16.8462 19.6063L17.0359 19.5028L17.0334 19.4999L17.1759 19.4092L17.1839 19.4186L17.3653 19.3032L17.3739 19.3132L17.541 19.2068L17.5418 19.2077L17.7736 19.0602L17.7725 19.0589L17.9636 18.9548L17.9629 18.954L18.154 18.8497L18.1529 18.8484L18.3434 18.7444L18.3422 18.7429L18.5334 18.6386L18.5253 18.6293L18.7008 18.5336L18.7 18.5327L18.8917 18.4282L18.8903 18.4265L19.0807 18.3227L19.0779 18.3194L19.2204 18.2288L19.2287 18.2384L19.3961 18.1319L19.3971 18.133L19.5779 18.018L19.5861 18.0276L19.8179 17.88L19.8168 17.8788L20.0078 17.7746L20.0068 17.7734L20.1977 17.6692L20.1968 17.6681L20.3882 17.5637L20.3797 17.5539L20.5425 17.4651L20.6823 17.3952L20.7038 17.3737L20.7041 17.374C20.7463 17.3459 20.7884 17.2991 20.8306 17.2523L20.8306 17.2522C20.8517 17.2288 20.8727 17.2054 20.8938 17.1844L20.8866 17.1759C20.9303 17.1086 20.9606 17.0412 20.9774 16.9739L20.9726 16.9683C20.9874 16.921 20.9992 16.8737 20.9992 16.8263V16.6577L20.999 16.6575V16.3415L20.9982 16.3406V16.1077L20.9999 16.1097V15.6882L20.9982 15.6862V15.4554L20.999 15.4563V15.0558L20.9987 15.0555V14.802L20.9995 14.8028V14.4024L20.9973 14.3998V14.1481L20.9985 14.1495V13.8328L20.9993 13.8337V13.4332L20.9986 13.4324V13.1794L20.9993 13.1802V12.7798L20.9991 12.7795V12.4637L20.9989 12.4635V12.1264L20.9979 12.1252V11.8929L20.9995 11.8948V11.4944L20.9986 11.4933V11.2404L20.9992 11.241V10.8406L20.9981 10.8394V10.6078L20.9991 10.6089V10.2719L20.9992 10.272V9.87153L20.9977 9.86975V9.61695L20.9992 9.61869V9.21824L20.9982 9.2171V8.98489L20.9992 8.98608V8.58564L20.9987 8.5851V8.24829L20.9977 8.24704V8.01537L20.9987 8.01652V7.76361L20.9167 7.81048L20.9134 7.80554L20.7325 7.92065L20.7248 7.91108L20.4929 8.05861L20.4943 8.06017L20.3037 8.16412L20.3044 8.16491L20.113 8.26929L20.1147 8.27133L19.9243 8.3752L19.9248 8.37578L19.7331 8.48034L19.74 8.48837L19.545 8.58589L19.5527 8.59484L19.3763 8.69104L19.3772 8.69208L19.1856 8.79658L19.1868 8.79801L18.997 8.90158L18.998 8.90279L18.8068 9.00711L18.8083 9.00897L18.618 9.1128L18.6184 9.11331L18.4267 9.21791L18.4348 9.22739L18.259 9.32329L18.2623 9.32722L18.1204 9.41754L18.1119 9.40766L17.9302 9.5233L17.9215 9.5131L17.7408 9.62811L17.7325 9.61852L17.5511 9.73401L17.5421 9.72358L17.3737 9.83074L17.3723 9.82905L17.1404 9.97658L17.1422 9.97861L16.9529 10.0818L16.9538 10.0829L16.7625 10.1873L16.7637 10.1887L16.573 10.2927L16.574 10.2938L16.3826 10.3981L16.3843 10.4001L16.1947 10.5036L16.202 10.5121L16.0243 10.609L16.0256 10.6106L15.8354 10.7143L15.8367 10.7157L15.646 10.8197L15.6487 10.8229L15.5188 10.9041C15.5131 10.9041 15.5075 10.9056 15.5019 10.9078L15.4984 10.9038C15.4241 10.9409 15.3171 10.9453 15.235 10.917L15.2237 10.9038H15.2034L15.2033 10.9038L15.098 10.8195L15.1348 10.8626L14.7178 10.6088C14.6906 10.5951 14.6722 10.5727 14.6512 10.5472C14.6397 10.5332 14.6274 10.5183 14.6125 10.5034C14.586 10.4637 14.5762 10.4323 14.5673 10.404L14.5673 10.404C14.562 10.3872 14.5571 10.3715 14.5492 10.3558V10.2074L14.55 10.2083V9.78674L14.5493 9.78594C14.5497 9.73492 14.5772 9.67044 14.6098 9.6144L14.6133 9.61841C14.6343 9.57626 14.6554 9.55519 14.6976 9.53411L14.7741 9.4831L14.7816 9.49189L14.9486 9.38564L14.9495 9.38662L15.1318 9.27058L15.1409 9.28117L15.321 9.16654L15.3288 9.17573L15.5106 9.0601L15.5193 9.07029L15.7511 8.92276L15.7499 8.92134L15.9406 8.81733L15.9396 8.81626L16.131 8.71189L16.1225 8.70203L16.2974 8.60664L16.2966 8.60574L16.4883 8.50118L16.4876 8.50036L16.6787 8.39611L16.6774 8.39451L16.8677 8.29069L16.8668 8.28962L17.0581 8.18525L17.057 8.18392L17.2476 8.07997L17.2411 8.07239L17.437 7.97442L17.4289 7.96493L17.6047 7.86904L17.6043 7.86854L17.796 7.76394L17.7944 7.76208L17.9848 7.65824L17.9817 7.65464L18.1235 7.56444L18.1318 7.57417L18.3001 7.46708L18.3015 7.46863L18.488 7.35983L18.4912 7.36351L18.6715 7.24877L18.6793 7.25796L18.9112 7.11043L18.9107 7.10985L19.1024 7.00529L19.1006 7.00326L19.2911 6.89938L19.2904 6.89859L19.4818 6.79421L19.4752 6.7866L19.671 6.6887L19.6627 6.67909L19.8386 6.58317L19.8379 6.58238L20.0293 6.47801L20.0286 6.47722L20.2199 6.37283L20.2183 6.37085L20.4081 6.2673L20.4067 6.26564L20.5553 6.18307L20.5557 6.18287L20.1589 5.97652L20.1552 5.97223L19.6584 5.70725L19.6509 5.6984L19.1257 5.4273L19.123 5.42421L18.6223 5.15714L18.6162 5.15L18.1187 4.88468L18.1114 4.87616L17.5883 4.60618L17.5849 4.60231L17.0843 4.33529L17.0781 4.32812L16.5799 4.06243L16.5732 4.05467L16.0472 3.78316L16.0449 3.78044L15.5482 3.51556L15.5406 3.50662L15.055 3.25604L15.0347 3.2324L14.5089 2.96102L14.5068 2.95858L14.0102 2.69372L14.002 2.68421L13.3486 2.32592L13.3549 2.33317L12.8423 2.05209L12.8686 2.08281L12.4679 1.86909L12.4622 1.86244L12.3539 1.80827L12.3374 1.79949L12.3382 1.80045L12.3358 1.79922C12.2492 1.74731 12.1627 1.72381 12.0646 1.71706L12.0627 1.71491Z",
      fill: "url(#paint0_linear_529_7521)"
    }, null, -1),
    g("defs", null, [
      g("linearGradient", {
        id: "paint0_linear_529_7521",
        x1: "21",
        y1: "2",
        x2: "3",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      }, [
        g("stop", { "stop-color": "#DC0032" }),
        g("stop", {
          offset: "1",
          "stop-color": "#C00033"
        })
      ])
    ], -1)
  ]));
}
const Yn = /* @__PURE__ */ se(V8, [["render", S8]]), A8 = {};
function E8(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_38757_17517)" }, [
      g("mask", {
        id: "mask0_38757_17517",
        style: { "mask-type": "luminance" },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "6",
        width: "24",
        height: "11"
      }, [
        g("path", {
          d: "M0 6H24V17H0V6Z",
          fill: "white"
        })
      ]),
      g("g", { mask: "url(#mask0_38757_17517)" }, [
        g("path", {
          d: "M20.7168 12.6136C21.3207 12.6136 21.8103 13.1027 21.8103 13.7061C21.8103 14.3094 21.3207 14.7986 20.7168 14.7986C20.1128 14.7986 19.6233 14.3094 19.6233 13.7061C19.6233 13.1027 20.1128 12.6136 20.7168 12.6136Z",
          fill: "#FFD100"
        }),
        g("path", {
          d: "M5.37905 11.2792V12.7086H6.56943C6.39556 12.9813 6.00347 13.1265 5.73747 13.1265C4.84144 13.1265 4.39339 12.6162 4.39339 11.5867C4.39339 10.4498 4.9848 9.86792 6.15861 9.86792C6.62458 9.86792 7.2339 9.98428 7.888 10.1902V8.48035C7.69984 8.3998 7.4131 8.33713 7.04572 8.27445C6.66935 8.21178 6.33784 8.18494 6.0511 8.18494C4.88622 8.18494 3.96329 8.49827 3.27333 9.1249C2.58336 9.75154 2.23389 10.593 2.23389 11.6583C2.23389 12.6341 2.50271 13.404 3.04034 13.968C3.57797 14.5409 4.30379 14.8274 5.21776 14.8274C6.13554 14.8274 6.97879 14.3515 7.25051 13.7474L7.24464 14.7199H8.57212V11.2792H5.37905Z",
          fill: "#061AB1"
        }),
        g("path", {
          d: "M9.22705 14.7199V8.29236H11.288V13.0459H13.537V14.7199H9.22705Z",
          fill: "#061AB1"
        }),
        g("path", {
          d: "M14.1914 14.5588V12.8042C14.4961 12.9027 14.8545 12.9833 15.2577 13.0549C15.6609 13.1265 16.0104 13.1623 16.3061 13.1623C16.8079 13.1623 17.0678 13.037 17.0678 12.8132C17.0678 12.6699 16.9871 12.5983 16.6197 12.5177L15.9029 12.3566C14.6753 12.0791 14.1018 11.4614 14.1018 10.414C14.1018 9.7247 14.3437 9.17861 14.8187 8.77578C15.2936 8.38189 15.9567 8.18494 16.79 8.18494C17.3635 8.18494 18.2416 8.30134 18.7792 8.43559V10.1096C18.5015 10.038 18.1699 9.96641 17.7667 9.90373C17.3635 9.84108 17.0499 9.81422 16.8168 9.81422C16.3778 9.81422 16.1269 9.93954 16.1269 10.1634C16.1269 10.2976 16.2434 10.3871 16.4853 10.4498L17.3187 10.6468C18.5373 10.9332 19.1018 11.5599 19.1018 12.6252C19.1018 13.3055 18.8509 13.8426 18.3581 14.2365C17.8653 14.6304 17.1842 14.8274 16.3151 14.8274C15.4907 14.8274 14.6574 14.711 14.1914 14.5588Z",
          fill: "#061AB1"
        })
      ])
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_38757_17517" }, [
        g("rect", {
          width: "24",
          height: "11",
          fill: "white",
          transform: "translate(0 6)"
        })
      ])
    ], -1))
  ], 64);
}
const Wn = /* @__PURE__ */ se(A8, [["render", E8]]), D8 = {};
function P8(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_42355_61447)" }, [
      g("path", {
        d: "M13.0997 4.83683L7.8926 9.89285C7.74049 10.0409 7.53343 10.1241 7.31807 10.1244H0.405434C0.182482 10.123 0 9.94444 0 9.72796C0 9.62444 0.0419165 9.52479 0.116355 9.45077L4.97652 4.74561C5.12829 4.59298 5.33605 4.50456 5.55468 4.5H12.9587C13.0693 4.50035 13.1604 4.58912 13.1604 4.69649C13.1604 4.74912 13.1383 4.79999 13.0997 4.83683Z",
        fill: "#2CE27E"
      }),
      g("path", {
        d: "M23.5442 4.50035H15.2114C14.9949 4.50105 14.7872 4.58421 14.6332 4.73192L9.31778 9.89321C9.166 10.0416 9.08037 10.242 9.07928 10.4511V13.4791C9.07531 13.6938 8.89247 13.8686 8.67097 13.8686C8.66842 13.8686 8.66625 13.8686 8.66372 13.8686H5.55613C5.34076 13.8689 5.13371 13.9521 4.98157 14.1001L0.121414 18.8263C0.0437233 18.9004 0 19.0014 0 19.107C0 19.3225 0.182482 19.5 0.404712 19.5H0.406881H8.74322C8.95858 19.4996 9.16564 19.4165 9.31778 19.2684L14.6332 14.1071C14.7868 13.9601 14.8728 13.7587 14.8717 13.5493V10.5213C14.8717 10.3037 15.056 10.1248 15.2801 10.1248H18.3985C18.6139 10.1244 18.8209 10.0413 18.973 9.89321L23.8405 5.17402C23.9182 5.09999 23.9622 4.99894 23.9622 4.89297C23.9622 4.67754 23.7793 4.5 23.5576 4.5C23.5531 4.5 23.5485 4.50035 23.5442 4.50035Z",
        fill: "#220C4A"
      })
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_42355_61447" }, [
        g("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ], -1))
  ], 64);
}
const Kn = /* @__PURE__ */ se(D8, [["render", P8]]), z8 = {};
function T8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("rect", {
      y: "0.5",
      width: "24",
      height: "24",
      fill: "#FECC00"
    }, null, -1),
    g("path", {
      d: "M7.73844 12.0647C7.63356 12.2067 7.45808 12.4536 7.3513 12.5978C7.29708 12.6711 7.19917 12.8043 7.52377 12.8043C7.86721 12.8043 9.2328 12.8043 9.2328 12.8043C9.2328 12.8043 9.50823 12.4296 9.73915 12.1162C10.0532 11.6898 9.76633 10.8027 8.64341 10.8027C7.63834 10.8027 4.22111 10.8027 4.22111 10.8027L3.45433 11.8445C3.45433 11.8445 7.42941 11.8445 7.63343 11.8445C7.84441 11.8445 7.84154 11.9248 7.73844 12.0647ZM6.48292 13.0613C6.15832 13.0613 6.25624 12.9279 6.31045 12.8545C6.41724 12.7103 6.59558 12.466 6.70046 12.324C6.8037 12.1842 6.80643 12.1039 6.59517 12.1039C6.39129 12.1039 4.6839 12.1039 4.6839 12.1039L3.14394 14.1968C3.14394 14.1968 5.89436 14.1968 6.89942 14.1968C8.13978 14.1968 8.83036 13.3531 9.04325 13.0614C9.04325 13.0613 6.82623 13.0613 6.48292 13.0613ZM8.92595 14.1968H11.129L11.9642 13.0611L9.76141 13.0614C9.76073 13.0613 8.92595 14.1968 8.92595 14.1968ZM14.6102 10.8027L13.7652 11.9505H12.7819L13.6266 10.8027H11.4241L9.95068 12.8043H15.3393L16.8123 10.8027H14.6102ZM12.1123 14.1968H14.3145L15.1501 13.0614H12.9479C12.947 13.0613 12.1123 14.1968 12.1123 14.1968ZM0.000366211 13.5092V13.7503H3.06856L3.24581 13.5092H0.000366211ZM3.5756 13.0613H0.000366211V13.3022H3.39793L3.5756 13.0613ZM0.000366211 14.1968H2.73986L2.91629 13.957H0.000366211V14.1968ZM20.7671 13.7502H24.0002V13.509H20.9446L20.7671 13.7502ZM20.4386 14.1968H24.0002V13.957H20.6149L20.4386 14.1968ZM21.2738 13.0613L21.0967 13.3024H24.0002V13.0613H21.2738ZM18.3892 12.8043L19.8625 10.8027H17.5299C17.5291 10.8027 16.0555 12.8043 16.0555 12.8043H18.3892ZM15.8667 13.0613C15.8667 13.0613 15.7057 13.2813 15.6274 13.3872C15.3509 13.7609 15.5955 14.1968 16.4981 14.1968C17.5409 14.1968 20.0351 14.1968 20.0351 14.1968L20.8707 13.0614H15.8667V13.0613Z",
      fill: "#D50029"
    }, null, -1)
  ]));
}
const Y1 = /* @__PURE__ */ se(z8, [["render", T8]]), O8 = {};
function F8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      d: "M17.3502 6.34624C15.5409 10.2957 11.3191 14.3229 7.93385 15.354C4.52918 16.3852 3.24514 14.0116 5.07393 10.0622L3.26459 10.6069C2.42802 12.4357 2 14.0505 2 15.3735V15.4902C2.01946 18.4085 4.06226 19.7704 7.62257 18.6809C12.8171 17.1245 19.2568 10.9571 22 4.94547L17.3502 6.34624Z",
      fill: "url(#paint0_linear_529_7711)"
    }, null, -1),
    g("path", {
      d: "M5.89052 9.80931C4.95667 11.8327 5.61814 13.0389 7.34966 12.5136C9.08118 11.9883 11.2407 9.92604 12.1551 7.92215L5.89052 9.80931Z",
      fill: "url(#paint1_linear_529_7711)"
    }, null, -1),
    g("defs", null, [
      g("linearGradient", {
        id: "paint0_linear_529_7711",
        x1: "2",
        y1: "12",
        x2: "22",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
      }, [
        g("stop", { "stop-color": "#A21007" }),
        g("stop", {
          offset: "0.244",
          "stop-color": "#B90D11"
        }),
        g("stop", {
          offset: "0.5555",
          "stop-color": "#D0091B"
        }),
        g("stop", {
          offset: "0.75",
          "stop-color": "#D9081F"
        }),
        g("stop", {
          offset: "1",
          "stop-color": "#D9081F"
        })
      ]),
      g("linearGradient", {
        id: "paint1_linear_529_7711",
        x1: "5.46632",
        y1: "10.2793",
        x2: "12.1551",
        y2: "10.2793",
        gradientUnits: "userSpaceOnUse"
      }, [
        g("stop", { "stop-color": "#A21007" }),
        g("stop", {
          offset: "0.244",
          "stop-color": "#B90D11"
        }),
        g("stop", {
          offset: "0.5555",
          "stop-color": "#D0091B"
        }),
        g("stop", {
          offset: "0.75",
          "stop-color": "#D9081F"
        }),
        g("stop", {
          offset: "1",
          "stop-color": "#D9081F"
        })
      ])
    ], -1)
  ]));
}
const Gn = /* @__PURE__ */ se(O8, [["render", F8]]), B8 = {};
function I8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      d: "M9.00037 22.0097C9.18311 21.9184 13.9344 19.8625 15.442 18.629C16.9953 17.3498 17.8176 15.5224 17.8176 13.3295V3.05035L17.6806 3.00466C13.8887 0.948826 9.18311 1.08588 8.95468 1.08588C8.77194 1.08588 4.06635 0.948826 0.274476 3.00466L0.183105 3.05035V13.3752C0.183105 15.5681 1.00544 17.3955 2.55874 18.6747C4.06635 19.9082 8.81763 21.9641 9.00037 22.0097Z",
      fill: "#341B14"
    }, null, -1),
    g("path", {
      d: "M9 22.2382C9 22.2382 3.97462 20.0453 2.42132 18.8118C0.77665 17.4412 0 15.5681 0 13.4209V2.73054C3.97462 0.583332 9 0.766073 9 0.766073C9 0.766073 14.0254 0.583332 18 2.73054V13.3752C18 15.5224 17.2233 17.3955 15.5787 18.7661C14.0254 20.0453 9 22.2382 9 22.2382ZM0.730964 13.4209C0.730964 15.431 1.46193 17.0757 2.87817 18.2178C4.15736 19.2686 7.94924 20.959 9 21.4158C10.0508 20.959 13.8883 19.2229 15.1218 18.2178C16.5381 17.0757 17.269 15.3854 17.269 13.4209V2.91328C11.9695 2.41074 5.66497 2.68485 0.730964 7.25338V13.4209Z",
      fill: "#FFB406"
    }, null, -1),
    g("path", {
      d: "M14.0713 11.9131C14.7565 12.3242 15.0307 12.5984 15.0763 13.1009C15.0763 13.6491 14.7109 13.9689 14.1169 13.9689C13.6144 13.9689 13.0205 13.6948 12.6093 13.3293V14.7912C13.1119 15.0654 13.7058 15.2938 14.3454 15.2938C15.8987 15.2938 16.6296 14.1973 16.6296 13.1923C16.6753 12.2786 16.4012 11.5476 15.0763 10.7709C14.4824 10.4055 14.0256 10.177 14.0256 9.62881C14.0256 9.08059 14.5281 8.85216 14.9393 8.85216C15.4875 8.85216 16.0357 9.17196 16.3555 9.49176V8.1212C16.0814 7.89277 15.4875 7.57297 14.6195 7.61866C13.5687 7.66434 12.4723 8.39531 12.4723 9.6745C12.518 10.5425 12.7921 11.1821 14.0713 11.9131ZM8.6804 15.2024C8.81746 15.2481 9.04588 15.2938 9.41137 15.2938C11.1931 15.2938 12.1982 13.6948 12.1982 11.4105C12.1982 9.08059 11.1474 7.66434 9.27431 7.66434C8.40629 7.66434 7.72101 7.84709 7.1271 8.21257V18.5374H8.6804V15.2024ZM8.6804 8.98922C8.81746 8.94353 9.04588 8.85216 9.22863 8.85216C10.1423 8.85216 10.5078 9.58313 10.5078 11.3649C10.5078 13.1009 10.051 13.9232 9.13725 13.9232C8.90883 13.9232 8.72609 13.8775 8.63472 13.8319V8.98922H8.6804ZM3.88345 15.2938C4.84284 15.2938 5.66517 15.0654 6.25908 14.6542V7.75572H4.6601V13.7405C4.47736 13.8775 4.24893 13.9232 3.92913 13.9232C3.19817 13.9232 3.1068 13.2379 3.1068 12.8268V7.75572H1.50781V12.7354C1.50781 14.4258 2.33015 15.2938 3.88345 15.2938Z",
      fill: "#FFB406"
    }, null, -1)
  ]));
}
const jt = /* @__PURE__ */ se(B8, [["render", I8]]), Z8 = {};
function R8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("path", {
      d: "M12.0858 24.2476C11.9829 24.2329 11.8965 24.2044 11.8205 24.1601C11.5274 23.9896 2.20552 18.4894 2.17743 18.4704C2.04288 18.3795 1.91937 18.1936 1.8666 18.0026L1.8484 17.9368L1.84667 12.5746C1.84572 9.62538 1.84623 7.2124 1.84784 7.2124C1.86004 7.2124 11.1854 12.6478 11.2044 12.666C11.2179 12.6789 11.2363 12.7038 11.2453 12.7214L11.2616 12.7534L11.265 16.8095L11.2684 20.8656L11.286 20.9107C11.3119 20.9773 11.3377 21.0179 11.3803 21.059C11.4113 21.0889 11.476 21.1275 11.7316 21.2686C11.9039 21.3637 12.0569 21.4447 12.0715 21.4487C12.1556 21.4714 12.2493 21.472 12.3229 21.4501C12.3423 21.4444 12.4973 21.3626 12.6674 21.2684C13.0004 21.084 13.0316 21.0626 13.0767 20.9876C13.0898 20.9659 13.1073 20.928 13.1157 20.9035L13.1309 20.8588L13.1311 16.3169L13.1313 11.775L13.1142 11.7238C13.0939 11.6634 13.0605 11.6088 13.0196 11.5695C12.9992 11.5497 11.3581 10.5911 7.68325 8.45205C4.7645 6.75315 2.3764 5.36138 2.37637 5.35923C2.37632 5.35625 11.3369 0.468989 11.7759 0.232537C11.9304 0.149309 12.0271 0.125217 12.205 0.125615C12.3307 0.125911 12.4028 0.136906 12.492 0.169475C12.5411 0.187399 22.0272 5.35129 22.0265 5.35973C22.0264 5.36161 20.5072 6.24741 18.6506 7.32819C14.894 9.51499 15.2213 9.31758 15.1683 9.42855C15.1264 9.51633 15.1261 9.52112 15.1336 9.86446C15.1426 10.2702 15.1432 10.2787 15.1629 10.3331C15.1846 10.3926 15.2337 10.4704 15.2747 10.5102C15.3117 10.5459 15.8793 10.8869 15.9437 10.912C15.9713 10.9227 16.0016 10.9276 16.0535 10.9298C16.1157 10.9324 16.1314 10.9306 16.1727 10.9167C16.2064 10.9053 17.1409 10.3642 19.3853 9.05652C21.126 8.04225 22.5521 7.2124 22.5542 7.2124C22.5617 7.2124 22.5586 17.8254 22.5511 17.8988C22.5381 18.0248 22.4901 18.1527 22.4103 18.2732C22.3602 18.3489 22.2563 18.4528 22.1903 18.4932C22.0971 18.5503 12.6387 24.1269 12.5728 24.1637C12.4626 24.2251 12.3796 24.2459 12.2254 24.2505C12.1711 24.2521 12.1082 24.2509 12.0858 24.2476Z",
      fill: "#DB0036"
    }, null, -1)
  ]));
}
const Xn = /* @__PURE__ */ se(Z8, [["render", R8]]), N8 = {};
function q8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("g", { "clip-path": "url(#clip0_10761_174090)" }, [
      g("rect", {
        width: "24",
        height: "24",
        fill: "#333399"
      }),
      g("rect", {
        x: "5.75",
        y: "4.75",
        width: "12.5",
        height: "12.5",
        rx: "2.25",
        stroke: "#FDC801",
        "stroke-width": "1.5"
      }),
      g("path", {
        d: "M6.71602 19.926L8 18H12L7.67404 20.884C7.56056 20.9596 7.42722 21 7.29083 21C6.73907 21 6.40996 20.3851 6.71602 19.926Z",
        fill: "#FDC801"
      }),
      g("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 8.25C8 8.11193 8.11193 8 8.25 8H12.75C12.8881 8 13 8.11193 13 8.25V12.75C13 12.8881 12.8881 13 12.75 13H12.5C12.5 12.4477 12.0523 12 11.5 12H9.5C8.94772 12 8.5 12.4477 8.5 13H8.25C8.11193 13 8 12.8881 8 12.75V8.25ZM10.5 13C10.5 13.4142 10.1642 13.75 9.75 13.75C9.33579 13.75 9 13.4142 9 13C9 12.5858 9.33579 12.25 9.75 12.25C10.1642 12.25 10.5 12.5858 10.5 13ZM10.5 13C10.5 12.5858 10.8358 12.25 11.25 12.25C11.6642 12.25 12 12.5858 12 13C12 13.4142 11.6642 13.75 11.25 13.75C10.8358 13.75 10.5 13.4142 10.5 13ZM15.5 13C15.5 13.4142 15.1642 13.75 14.75 13.75C14.3358 13.75 14 13.4142 14 13C14 12.5858 14.3358 12.25 14.75 12.25C15.1642 12.25 15.5 12.5858 15.5 13ZM13.25 9.75C13.25 9.61193 13.3619 9.5 13.5 9.5H14.8455C14.9402 9.5 15.0268 9.5535 15.0691 9.6382L15.75 11H16C16.1381 11 16.25 11.1119 16.25 11.25V12.75C16.25 12.8881 16.1381 13 16 13H15.75L15.6819 12.7276C15.575 12.3 15.1908 12 14.75 12C14.3092 12 13.925 12.3 13.8181 12.7276L13.75 13H13.5C13.3619 13 13.25 12.8881 13.25 12.75V9.75ZM13.75 10H14.75L15.25 11H13.75V10Z",
        fill: "white"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", { id: "clip0_10761_174090" }, [
        g("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ], -1)
  ]));
}
const Qn = /* @__PURE__ */ se(N8, [["render", q8]]), U8 = {};
function Y8(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("g", { "clip-path": "url(#clip0_20324_27)" }, [
      g("path", {
        d: "M8.81575 10.9536C8.03961 10.9536 7.41532 11.384 7.41532 12.3533C7.41532 13.301 8.03961 13.7531 8.81575 13.7531C9.58918 13.7531 10.2148 13.301 10.2148 12.3533C10.2148 11.384 9.58918 10.9536 8.81575 10.9536ZM8.81575 13.0875C8.46868 13.0875 8.20907 12.8238 8.20907 12.3533C8.20907 11.8416 8.46868 11.6179 8.81575 11.6179C9.16077 11.6179 9.42107 11.8416 9.42107 12.3533C9.42107 12.8238 9.16077 13.0875 8.81575 13.0875ZM13.8596 10.978C13.8596 10.9922 13.8712 11.0038 13.8854 11.0038H14.4745C14.5212 11.0038 14.5592 11.0424 14.5592 11.0878V11.5975C14.5592 11.6125 14.5477 11.624 14.5334 11.624H13.8854C13.8712 11.624 13.8596 11.6355 13.8596 11.6498V12.6394C13.8596 13.019 14.0033 13.1315 14.2433 13.1315C14.3558 13.1315 14.5328 13.0624 14.5585 13.0624C14.5728 13.0624 14.585 13.0739 14.585 13.0881V13.5762C14.585 13.6128 14.5639 13.6386 14.5409 13.6508C14.4338 13.7084 14.2542 13.7477 13.9884 13.7477C13.5241 13.7477 13.093 13.5138 13.093 12.7675V11.0465C13.093 10.8939 13.1526 10.7489 13.2469 10.6458C13.3723 10.5076 13.7756 10.2486 13.8278 10.2486C13.8502 10.2486 13.8596 10.2554 13.8596 10.2764V10.978ZM4.49446 11.0905C4.49446 11.0424 4.53309 11.0044 4.5812 11.0044H5.60207C6.60459 11.0044 7.12384 11.6064 7.12384 12.3852C7.12384 13.1648 6.54291 13.7043 5.5858 13.7043H5.28755C5.2733 13.7043 5.26109 13.7158 5.26109 13.7308V14.9936C5.26109 15.0146 5.2523 15.0214 5.22925 15.0214C5.17705 15.0214 4.77373 14.7624 4.64832 14.6242C4.55409 14.5204 4.49446 14.3754 4.49446 14.2235V11.0905ZM6.36668 12.3459C6.36668 12.0144 6.15248 11.704 5.58648 11.704H5.28618C5.27196 11.704 5.26043 11.7155 5.26043 11.7304V12.9763C5.26043 12.9905 5.27196 13.0027 5.28618 13.0027H5.60139C6.27584 13.0027 6.36668 12.5343 6.36668 12.3459ZM12.6985 12.8719C12.6985 13.4406 12.2898 13.7531 11.4926 13.7531C11.0364 13.7531 10.5544 13.5931 10.5504 13.5918C10.5145 13.5782 10.4907 13.5457 10.4907 13.5084V12.9783C10.4907 12.9607 10.5056 12.9472 10.5239 12.9472C10.5267 12.9472 10.5341 12.9485 10.5348 12.9492C10.7049 13.0041 11.2567 13.141 11.5502 13.141C11.7237 13.141 11.8146 13.1153 11.8729 13.057C11.9129 13.017 11.9312 12.9743 11.9312 12.9228C11.9312 12.7492 11.7136 12.7011 11.5027 12.655C11.4763 12.6496 11.4878 12.6523 11.4167 12.6353C10.955 12.5262 10.4684 12.4137 10.4684 11.8192C10.4684 11.5555 10.5788 11.3366 10.7856 11.1847C10.9917 11.0329 11.2892 10.9536 11.6458 10.9536C11.9664 10.9536 12.3467 11.0593 12.4741 11.1C12.5141 11.1129 12.5372 11.1481 12.5372 11.1841V11.7128C12.5358 11.7372 12.51 11.7487 12.4924 11.7419C12.1271 11.605 11.7929 11.5569 11.5529 11.5569C11.3624 11.5569 11.2391 11.6396 11.2391 11.7677C11.2391 11.9155 11.4194 11.9555 11.6478 12.007C11.6756 12.0131 11.8003 12.0415 11.8329 12.0483C12.02 12.0897 12.2131 12.1317 12.3718 12.2354C12.5914 12.3791 12.6985 12.5872 12.6985 12.8719ZM16.8313 13.6948C16.8225 13.6948 16.8151 13.6874 16.8151 13.6785V12.07C16.8151 11.7128 16.6937 11.5603 16.409 11.5603C16.3074 11.5603 16.1847 11.5982 16.0627 11.6674C15.9413 11.7379 15.8464 11.7962 15.8125 11.8165C15.803 11.8226 15.7929 11.8389 15.7929 11.8518V13.6792C15.7929 13.688 15.7854 13.6955 15.7766 13.6955H15.0595C15.0506 13.6955 15.0425 13.688 15.0425 13.6792V11.0912C15.0425 11.0492 15.0771 11.0146 15.1198 11.0146H15.7773C15.7861 11.0146 15.7942 11.022 15.7942 11.0309V11.2342C15.7942 11.2464 15.8044 11.2566 15.8166 11.2566C15.8213 11.2566 15.8275 11.2539 15.8295 11.2525L15.8512 11.2363C15.9312 11.1746 16.0545 11.1048 16.1372 11.0729C16.3169 11.0044 16.5107 10.9644 16.668 10.9644C17.2543 10.9644 17.5641 11.3013 17.5641 11.9378V13.6779C17.5641 13.6874 17.5567 13.6941 17.5472 13.6941H16.8313V13.6948ZM18.1559 13.6948C18.147 13.6948 18.1396 13.6874 18.1396 13.6785V9.71516C18.1396 9.70091 18.1423 9.69685 18.162 9.69685C18.2067 9.69685 18.6066 9.94835 18.7361 10.0907C18.8324 10.1964 18.8873 10.3401 18.8873 10.4852V13.6785C18.8873 13.6874 18.8798 13.6948 18.871 13.6948H18.1559ZM8.81507 6.80582C8.80152 6.80582 8.78864 6.80989 8.77305 6.81937C8.65239 6.91021 8.54598 7.01528 8.45377 7.13323C8.42666 7.16373 8.42666 7.19898 8.45514 7.23557C8.54257 7.34878 8.64291 7.44978 8.7527 7.53587C8.77305 7.55214 8.79339 7.5596 8.81439 7.5596C8.83541 7.5596 8.85575 7.55146 8.87609 7.53519C8.98589 7.4491 9.0862 7.3481 9.17366 7.23557C9.20214 7.19898 9.20214 7.16373 9.17366 7.13119C9.0835 7.0146 8.97709 6.90953 8.85914 6.82073C8.84218 6.80989 8.82932 6.80582 8.81507 6.80582ZM8.81507 7.77719C8.75745 7.77719 8.69645 7.77853 8.63341 7.78125C8.61105 7.78125 8.5907 7.78939 8.57511 7.80564C8.55275 7.82803 8.54393 7.86394 8.54393 7.88766C8.54598 8.01171 8.55411 8.66653 8.55952 9.08339C8.56223 9.28473 8.56359 9.43046 8.56427 9.43521C8.56427 9.46503 8.58595 9.52739 8.65307 9.52739H8.97775C9.02589 9.52739 9.05909 9.4935 9.06589 9.43928C9.06589 9.43791 9.06589 9.43655 9.06589 9.43521C9.06589 9.42503 9.07266 8.86853 9.08555 7.908V7.88903C9.08621 7.87073 9.08011 7.83141 9.05505 7.80632C9.03945 7.79005 9.01911 7.7826 8.99539 7.7826C8.93439 7.77921 8.87336 7.77719 8.81507 7.77719ZM9.63866 7.86598C9.56409 7.86598 9.50309 7.90732 9.47123 7.97851C9.37768 8.1866 9.30991 8.37639 9.24416 8.6123C9.2367 8.6401 9.23941 8.66314 9.2523 8.68007C9.26109 8.6916 9.27873 8.70516 9.31398 8.70516H9.5675C9.62511 8.70516 9.64611 8.67466 9.65425 8.64957C9.69561 8.50857 9.72543 8.42655 9.7783 8.30998C9.77898 8.30862 9.78305 8.30116 9.79864 8.30116C9.80473 8.30116 9.81084 8.30185 9.81693 8.30387L9.94573 8.34657C9.96064 8.35201 9.97014 8.36487 9.97489 8.37505C9.98436 8.39471 9.98573 8.42114 9.97895 8.4408C9.97759 8.44487 9.71866 9.1688 9.64139 9.41012C9.62986 9.44741 9.6312 9.47655 9.6468 9.49825C9.66102 9.51791 9.68543 9.52807 9.71932 9.52807H10.0332C10.0847 9.52807 10.1186 9.50773 10.1335 9.46639C10.145 9.43521 10.1613 9.38978 10.1803 9.33623L10.1877 9.31591C10.282 9.05289 10.425 8.65432 10.4555 8.54112C10.507 8.34928 10.5212 8.13914 10.2399 8.03475C10.1504 8.00155 10.0657 7.97307 9.98775 7.94935C9.8888 7.91885 9.7932 7.89648 9.70916 7.87682L9.699 7.87412C9.67596 7.868 9.65698 7.86598 9.63866 7.86598ZM7.99148 7.86598C7.97318 7.86598 7.9542 7.868 7.93591 7.87275L7.92302 7.87546C7.83898 7.89512 7.74407 7.9175 7.64511 7.948C7.56782 7.97173 7.48309 8.00019 7.39293 8.03341C7.11095 8.1378 7.12586 8.34794 7.17739 8.53975C7.20652 8.64889 7.33939 9.02239 7.45191 9.33489C7.47157 9.38844 7.48716 9.43385 7.49868 9.46503C7.51359 9.50637 7.5475 9.52671 7.599 9.52671H7.91286C7.95489 9.52671 7.97523 9.51044 7.98539 9.49689C8.00098 9.47587 8.00234 9.44673 7.99082 9.40944C7.9142 9.17153 7.65527 8.44689 7.65257 8.44012C7.64577 8.42046 7.64714 8.39471 7.65664 8.37437C7.66136 8.36421 7.67018 8.35132 7.68645 8.34589L7.81593 8.30319C7.82066 8.30185 7.82677 8.30116 7.83286 8.30116C7.84575 8.30116 7.85184 8.30657 7.8532 8.30998C7.90675 8.42928 7.93725 8.51198 7.97725 8.64957C7.9847 8.67532 8.00573 8.70516 8.06334 8.70516H8.31752C8.34532 8.70516 8.36634 8.69703 8.37923 8.68007C8.39209 8.66314 8.39482 8.64075 8.38668 8.61296C8.32025 8.37573 8.25246 8.18591 8.15959 7.97851C8.144 7.94462 8.09723 7.86598 7.99148 7.86598ZM9.96945 9.76803H7.66409C7.58341 9.76803 7.51496 9.83582 7.51496 9.91648V10.2066C7.51496 10.2974 7.55359 10.3415 7.63425 10.3415H9.99996C10.08 10.3415 10.1186 10.2974 10.1186 10.2066V9.91648C10.1186 9.83582 10.0501 9.76803 9.96945 9.76803ZM21.0713 12.011C21.0686 10.3923 18.0278 7.58873 14.7876 5.8026C11.05 3.74125 6.79643 2.52654 5.39532 3.29861C3.7983 4.17982 2.92319 8.57839 2.92251 12.011C2.92319 15.4715 3.74746 19.8138 5.39532 20.7228C6.88861 21.5457 10.9571 20.331 14.7876 18.2195C18.0786 16.4049 21.0686 13.7084 21.0713 12.011ZM6.51716 2.27777C8.87609 2.27777 12.6551 3.76904 15.1679 5.15457C16.6056 5.94698 18.2372 7.10339 19.4994 8.28014C20.7107 9.40878 21.8535 10.814 21.8556 12.011C21.8535 13.1383 20.9385 14.4608 19.4655 15.8111C18.2148 16.9566 16.5907 18.0832 15.1686 18.8675C12.7412 20.2056 9.04148 21.7687 6.60257 21.7687C5.93964 21.7687 5.396 21.6542 4.9852 21.4278C3.9054 20.8326 3.21331 19.2288 2.80457 17.6576C2.36532 15.9717 2.13959 13.9443 2.13892 12.0117C2.13892 10.1205 2.38294 8.08832 2.80796 6.43571C3.32583 4.42316 4.07893 3.09526 4.9852 2.59501C5.36548 2.38419 5.88134 2.27777 6.51716 2.27777Z",
        fill: "#F56900"
      })
    ], -1)),
    e[1] || (e[1] = g("defs", null, [
      g("clipPath", { id: "clip0_20324_27" }, [
        g("rect", {
          width: "20",
          height: "20",
          fill: "white",
          transform: "translate(2 2)"
        })
      ])
    ], -1))
  ], 64);
}
const Jn = /* @__PURE__ */ se(U8, [["render", Y8]]), W8 = {};
function K8(t, e) {
  return m(), C("g", null, e[0] || (e[0] = [
    g("g", { "clip-path": "url(#clip0_4638_78157)" }, [
      g("rect", {
        width: "24",
        height: "24",
        fill: "#00149D"
      }),
      g("path", {
        d: "M3 8.21057H5.56604V10.3352C6.06647 10.1469 6.59721 10.052 7.13191 10.0552C9.14732 10.0552 10.6083 11.5313 10.6083 13.5542C10.6083 15.0812 9.56296 16.8881 7.18213 16.8881H3V8.21057ZM5.56604 14.6593C5.88626 14.7165 6.21078 14.7463 6.53607 14.7484C7.45588 14.7484 8.0605 14.2524 8.0605 13.4758C8.0605 12.7129 7.46844 12.1912 6.61142 12.1912C6.25719 12.1881 5.90461 12.2396 5.56604 12.3437V14.6593ZM14.9211 10.0533C17.7552 10.0533 18.8382 11.8986 18.8382 13.5272C18.8382 15.3085 17.5913 17.0005 14.9455 17.0005C12.1114 17.0005 11.0026 15.1684 11.0026 13.5272C11.0051 11.7962 12.1767 10.0533 14.9229 10.0533H14.9211ZM14.9211 14.825C15.7222 14.825 16.2735 14.2901 16.2735 13.5272C16.2735 12.7644 15.7241 12.2288 14.9229 12.2288C14.1218 12.2288 13.5705 12.7638 13.5705 13.5272C13.5705 14.2907 14.1218 14.825 14.9229 14.825H14.9211ZM19.3606 8.21057H21.9229V16.8863H19.3606V8.21057ZM25.2788 15.4372C25.2788 16.3024 24.6088 17.0024 23.7656 17.0024C22.9224 17.0024 22.2393 16.3024 22.2393 15.4372C22.2369 15.2348 22.2746 15.034 22.3501 14.8463C22.4256 14.6586 22.5376 14.4877 22.6794 14.3435C22.8213 14.1992 22.9903 14.0844 23.1767 14.0058C23.3632 13.9271 23.5633 13.8861 23.7656 13.8851C24.6088 13.8832 25.2788 14.5701 25.2788 15.4353V15.4372Z",
        fill: "white"
      })
    ], -1),
    g("defs", null, [
      g("clipPath", { id: "clip0_4638_78157" }, [
        g("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ], -1)
  ]));
}
const vo = /* @__PURE__ */ se(W8, [["render", K8]]), G8 = {}, X8 = {
  d: "M0 7C0 6.44772 0.447715 6 1 6H17.0858C17.4836 6 17.8651 6.15804 18.1464 6.43934L24 12.2929V16C24 16.5523 23.5523 17 23 17L19.2929 17.0001L15.2929 13H11V16C11 16.5523 10.5523 17 9.99999 17L6.29289 17L0.43934 11.1464C0.158035 10.8651 0 10.4836 0 10.0858V7ZM10.7071 12H13.7929L8.79289 7H5.7071L10.7071 12ZM15.2071 12H18.2929L13.2929 7H10.2071L15.2071 12ZM14.7071 7L19.7071 12H22.2929L17.4393 7.14645C17.3456 7.05268 17.2184 7 17.0858 7H14.7071ZM23 13H20V16L23 16V13ZM19 15.2929V13H16.7071L19 15.2929ZM4.29289 7H1.7071L6.70711 12H9.2929L4.29289 7ZM6 12.7072L1 7.70711V10.0858C1 10.2184 1.05268 10.3456 1.14645 10.4393L6 15.2929V12.7072ZM7 16L10 16V13H7V16Z",
  fill: "currentColor"
};
function Q8(t, e) {
  return m(), C("path", X8);
}
const ox = /* @__PURE__ */ se(G8, [["render", Q8]]), J8 = {}, e6 = {
  d: "M12.5821 4.20251C12.2099 4.04578 11.7901 4.04578 11.4179 4.20251L2.91791 7.78147C2.36169 8.01567 2 8.56041 2 9.16392V14.8359C2 15.4394 2.36169 15.9842 2.91792 16.2184L11.4179 19.7973C11.7901 19.954 12.2099 19.954 12.5821 19.7973L21.0821 16.2183C21.6383 15.9842 22 15.4394 22 14.8359V9.16391C22 8.56039 21.6383 8.01565 21.0821 7.78146L12.5821 4.20251ZM11.806 5.12414C11.93 5.0719 12.07 5.0719 12.194 5.12414L19.984 8.40415L16.4999 9.95264L8.63751 6.45824L11.806 5.12414ZM7.37313 6.99061L15.2688 10.4998L12.6092 11.6819C12.2214 11.8542 11.7786 11.8542 11.3908 11.6819L4.01598 8.40415L7.37313 6.99061ZM16 11.2692V13.9998C16 14.276 16.2239 14.4998 16.5 14.4998C16.7761 14.4998 17 14.276 17 13.9998V10.8247L20.9875 9.0525C20.9957 9.08856 21 9.12588 21 9.16391V14.8359C21 15.0371 20.8794 15.2186 20.694 15.2967L12.5 18.7468V12.7606C12.6758 12.7248 12.8486 12.6698 13.0153 12.5957L16 11.2692ZM3.01255 9.0525L10.9847 12.5957C11.1514 12.6698 11.3242 12.7248 11.5 12.7606V18.7468L3.30597 15.2967C3.12056 15.2187 3 15.0371 3 14.8359V9.16392C3 9.12589 3.00431 9.08857 3.01255 9.0525Z",
  fill: "currentColor"
};
function t6(t, e) {
  return m(), C("path", e6);
}
const nx = /* @__PURE__ */ se(J8, [["render", t6]]), a6 = {};
function o6(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      d: "M21 22h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H8v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H3v-4h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3v-3h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V8h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v4h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v4zm-2.1-1H20v-2.1c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9v-1.2c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V8.9c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V3h-1.1c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1h-1.2c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1H8.9c-.2.5-.8 1-1.9 1s-1.7-.5-1.9-1H4v2.1c.5.2 1 .8 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9V21h1.1c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1z",
      fill: "currentColor"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M9.3 14.5c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l5.5-3.2c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2l-5.5 3.2c0 .2-.2.2-.3.2zm2.7 1.6c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l2.7-1.6c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2L12.5 16c-.2.1-.3.1-.5.1zm-2.8-4.7c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.1.2-.3.4-.4l2.7-1.6c.3-.1.5-.1.7-.1.2.1.4.2.5.4.1.2.1.4.1.7-.1.2-.2.4-.4.5l-2.7 1.6c-.1.1-.3.2-.5.2z",
      fill: "currentColor"
    }, null, -1))
  ], 64);
}
const rx = /* @__PURE__ */ se(a6, [["render", o6]]), n6 = {}, r6 = {
  d: "M10.4116 5.20544C10.7894 5.04636 11.2158 5.04884 11.5918 5.21229L22.0981 9.78026C22.6458 10.0184 23 10.5587 23 11.1559V12.8362C23 13.4397 22.6383 13.9844 22.0821 14.2186L13.5884 17.7949C13.2106 17.954 12.7842 17.9515 12.4082 17.7881L1.90191 13.2201C1.35424 12.982 1 12.4417 1 11.8445V10.1642C1 9.56067 1.36169 9.01593 1.91792 8.78173L10.4116 5.20544ZM11.1931 6.12936C11.0677 6.07487 10.9256 6.07405 10.7997 6.12707L7.64807 7.45406L17.745 11.844L21.0046 10.3953L11.1931 6.12936ZM18.5 12.6028V13.5001C18.5 13.7763 18.2761 14.0001 18 14.0001C17.7239 14.0001 17.5 13.7763 17.5 13.5001V13.0472L14.0065 14.5999C13.8426 14.6727 13.6727 14.7271 13.5 14.763V16.7471L21.694 13.297C21.8794 13.2189 22 13.0374 22 12.8362V11.1559C22 11.1205 21.9963 11.0857 21.9891 11.052L18.5 12.6028ZM16.5048 12.3952L6.37396 7.99052L2.77115 9.5075L12.3931 13.6909C12.7784 13.8585 13.2164 13.8567 13.6004 13.6861L16.5048 12.3952ZM2.30064 12.303L12.5 16.7375V14.7666C12.3277 14.7321 12.1582 14.6792 11.9943 14.608L2 10.2626V11.8445C2 12.0436 2.11808 12.2237 2.30064 12.303Z",
  fill: "currentColor"
};
function s6(t, e) {
  return m(), C("path", r6);
}
const sx = /* @__PURE__ */ se(n6, [["render", s6]]), i6 = {}, l6 = {
  fill: "currentColor",
  d: "M13 3h5.5a.5.5 0 0 1 0 1H13a4.5 4.5 0 0 0-4.5 4.5V10h9a.5.5 0 0 1 0 1h-9v2h7a.5.5 0 0 1 0 1h-7v1.5A4.5 4.5 0 0 0 13 20h5.5a.5.5 0 0 1 0 1H13a5.5 5.5 0 0 1-5.5-5.5V14h-4a.5.5 0 1 1 0-1h4v-2h-3a.5.5 0 1 1 0-1h3V8.5A5.5 5.5 0 0 1 13 3Z"
};
function u6(t, e) {
  return m(), C("path", l6);
}
const ix = /* @__PURE__ */ se(i6, [["render", u6]]), c6 = {}, d6 = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.5 4.833A3.833 3.833 0 0 1 8.333 1H12.5a.5.5 0 1 1 0 1H8.333A2.833 2.833 0 0 0 5.5 4.833V6h5a.5.5 0 0 1 0 1h-5v2h4a.5.5 0 0 1 0 1h-4v1.167A2.833 2.833 0 0 0 8.333 14H12.5a.5.5 0 0 1 0 1H8.333A3.833 3.833 0 0 1 4.5 11.167V10h-3a.5.5 0 1 1 0-1h3V7h-2a.5.5 0 1 1 0-1h2V4.833Z",
  "clip-rule": "evenodd"
};
function m6(t, e) {
  return m(), C("path", d6);
}
const p6 = /* @__PURE__ */ se(c6, [["render", m6]]), f6 = {}, h6 = {
  d: "M2.667 7.333c0-0.368 0.298-0.667 0.667-0.667h25.333c0.368 0 0.667 0.298 0.667 0.667s-0.299 0.667-0.667 0.667h-25.333c-0.368 0-0.667-0.298-0.667-0.667zM2.667 15.333c0-0.368 0.298-0.667 0.667-0.667h25.333c0.368 0 0.667 0.299 0.667 0.667s-0.299 0.667-0.667 0.667h-25.333c-0.368 0-0.667-0.299-0.667-0.667zM3.333 22.667c-0.368 0-0.667 0.299-0.667 0.667s0.298 0.667 0.667 0.667h25.333c0.368 0 0.667-0.299 0.667-0.667s-0.299-0.667-0.667-0.667h-25.333z",
  fill: "currentColor"
};
function v6(t, e) {
  return m(), C("path", h6);
}
const lx = /* @__PURE__ */ se(f6, [["render", v6]]), g6 = {}, y6 = {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "none",
  d: "M2.75 5.5h19M2.75 11.5h19M2.75 17.5h19"
};
function b6(t, e) {
  return m(), C("path", y6);
}
const ux = /* @__PURE__ */ se(g6, [["render", b6]]), k6 = {}, C6 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.5 6.5C5.5 5.67157 6.17157 5 7 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H7C5.61929 4 4.5 5.11929 4.5 6.5V17.5C4.5 18.8807 5.61929 20 7 20H18C19.3807 20 20.5 18.8807 20.5 17.5V14.5C20.5 14.2239 20.2761 14 20 14C19.7239 14 19.5 14.2239 19.5 14.5V17.5C19.5 18.3284 18.8284 19 18 19H7C6.17157 19 5.5 18.3284 5.5 17.5V6.5ZM15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H18.7929L11.6464 12.1464C11.4512 12.3417 11.4512 12.6583 11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536L19.5 5.70711V9.5C19.5 9.77614 19.7239 10 20 10C20.2761 10 20.5 9.77614 20.5 9.5V4.5C20.5 4.22386 20.2761 4 20 4H15Z",
  fill: "currentColor"
};
function w6(t, e) {
  return m(), C("path", C6);
}
const _6 = /* @__PURE__ */ se(k6, [["render", w6]]), H6 = {}, j6 = {
  d: "M10.5001 1C10.2239 1 10.0001 1.22386 10.0001 1.5C10.0001 1.77614 10.2239 2 10.5001 2H13.2929L7.14645 8.14645C6.95119 8.34171 6.95118 8.65829 7.14645 8.85356C7.34171 9.04882 7.65829 9.04882 7.85355 8.85356L14.0001 2.7071V5.5C14.0001 5.77614 14.2239 6 14.5001 6C14.7762 6 15.0001 5.77614 15.0001 5.5V1.5C15.0001 1.22386 14.7762 1 14.5001 1H10.5001ZM2 2.83334C2 2.3731 2.3731 2.00001 2.83333 2.00001H6.5C6.77614 2.00001 7 1.77615 7 1.50001C7 1.22387 6.77614 1.00001 6.5 1.00001H2.83333C1.82081 1.00001 1 1.82082 1 2.83334V13.1667C1 14.1792 1.82081 15 2.83333 15H13.1667C14.1792 15 15 14.1792 15 13.1667V9.5C15 9.22386 14.7761 9 14.5 9C14.2239 9 14 9.22386 14 9.5V13.1667C14 13.6269 13.6269 14 13.1667 14H2.83333C2.3731 14 2 13.6269 2 13.1667V2.83334Z",
  fill: "currentColor"
};
function L6(t, e) {
  return m(), C("path", j6);
}
const cx = /* @__PURE__ */ se(H6, [["render", L6]]), x6 = {}, $6 = {
  d: "M9.16129 0.698078H11.2219C11.4205 1.74609 12.057 2.64537 12.9388 3.20722C12.9391 3.20758 12.9394 3.20794 12.9397 3.2083C13.5536 3.59927 14.2855 3.82737 15.0712 3.82737V4.4397L15.0713 6.57766C13.6118 6.57766 12.2594 6.12136 11.1555 5.34698V10.937C11.1555 13.7288 8.8315 16 5.97486 16C4.87105 16 3.84742 15.6598 3.006 15.0824C3.00555 15.0819 3.0051 15.0814 3.00456 15.0809C1.66941 14.1642 0.794434 12.6488 0.794434 10.9365C0.794434 8.14478 3.11839 5.87346 5.97504 5.87346C6.21205 5.87346 6.44438 5.89254 6.67312 5.92286V6.57451L6.67302 8.73155C6.45203 8.66397 6.21844 8.62465 5.97486 8.62465C4.6703 8.62465 3.60897 9.66205 3.60897 10.937C3.60897 11.8249 4.12438 12.5963 4.87744 12.9835C5.20578 13.1524 5.57876 13.2493 5.97477 13.2493C7.24927 13.2493 8.28892 12.2585 8.33625 11.024L8.34075 0H11.1554C11.1554 0.238451 11.1789 0.471504 11.2219 0.698078H9.16129Z",
  fill: "currentColor"
};
function M6(t, e) {
  return m(), C("path", $6);
}
const dx = /* @__PURE__ */ se(x6, [["render", M6]]), V6 = {}, S6 = {
  fill: "currentColor",
  d: "M12.83 4.124a.5.5 0 0 1 .046.705l-7 8a.5.5 0 0 1-.73.025l-3-3a.5.5 0 1 1 .708-.708l2.622 2.622 6.648-7.597a.5.5 0 0 1 .705-.047Z"
};
function A6(t, e) {
  return m(), C("path", S6);
}
const Ir = /* @__PURE__ */ se(V6, [["render", A6]]), E6 = {}, D6 = {
  fill: "currentColor",
  d: "M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0Zm1 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.146-2.146a.5.5 0 0 0-.708-.708L6.5 9.793 4.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l5-5Z"
};
function P6(t, e) {
  return m(), C("path", D6);
}
const z6 = /* @__PURE__ */ se(E6, [["render", P6]]), T6 = {}, O6 = {
  fill: "currentColor",
  d: "M38.53 12.47a.75.75 0 0 0-1.06 0L18 31.94l-7.47-7.47a.75.75 0 1 0-1.06 1.06l8 8a.75.75 0 0 0 1.06 0l20-20a.75.75 0 0 0 0-1.06Z"
};
function F6(t, e) {
  return m(), C("path", O6);
}
const mx = /* @__PURE__ */ se(T6, [["render", F6]]), B6 = {}, I6 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Z6(t, e) {
  return m(), C("svg", I6, e[0] || (e[0] = [
    g("mask", {
      id: "a",
      style: { "mask-type": "alpha" },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24"
    }, [
      g("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    g("g", { mask: "url(#a)" }, [
      g("path", {
        d: "m10.562 15.908 6.396-6.396-.708-.708-5.688 5.688-2.85-2.85-.708.708 3.558 3.558ZM12.003 21a8.772 8.772 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z",
        fill: "#1C1B1F"
      })
    ], -1)
  ]));
}
const px = /* @__PURE__ */ se(B6, [["render", Z6]]), R6 = {}, N6 = {
  fill: "currentColor",
  d: "M19.354 6.146a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L9 15.793l9.646-9.647a.5.5 0 0 1 .708 0Z"
};
function q6(t, e) {
  return m(), C("path", N6);
}
const fx = /* @__PURE__ */ se(R6, [["render", q6]]), U6 = {}, Y6 = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46 48.54 12.02 48.54 25 37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01zm0 29.41c-4.09 0-7.42-3.33-7.42-7.42s3.33-7.42 7.42-7.42 7.42 3.33 7.42 7.42-3.33 7.42-7.42 7.42zm0-13.29c-3.24 0-5.87 2.63-5.87 5.87s2.64 5.87 5.87 5.87 5.87-2.63 5.87-5.87-2.63-5.87-5.87-5.87zm8.43-.43c-1.18 0-2.14-.96-2.14-2.14s.96-2.14 2.14-2.14 2.14.96 2.14 2.14-.96 2.14-2.14 2.14zm0-2.97c-.46 0-.84.38-.84.84s.38.84.84.84.84-.38.84-.84-.37-.84-.84-.84zM25 40.08c-3.86 0-4.37-.02-5.93-.09-1.47-.07-2.61-.29-3.72-.72a7.812 7.812 0 0 1-2.81-1.83 7.795 7.795 0 0 1-1.82-2.8c-.43-1.09-.65-2.24-.71-3.71-.08-1.53-.09-2.04-.09-5.93s.02-4.4.09-5.94c.07-1.47.29-2.61.72-3.72a7.812 7.812 0 0 1 1.83-2.81 7.93 7.93 0 0 1 2.8-1.82c1.1-.43 2.24-.65 3.71-.71 1.56-.07 2.08-.09 5.93-.09s4.37.02 5.93.09c1.47.07 2.61.29 3.72.72 1.05.39 2.02 1.03 2.81 1.83.79.78 1.43 1.75 1.82 2.8.43 1.09.65 2.24.71 3.71.07 1.53.09 2.04.09 5.93s-.02 4.4-.09 5.93h0c-.07 1.47-.29 2.61-.72 3.72a8.118 8.118 0 0 1-4.63 4.63c-1.1.43-2.25.65-3.72.72-1.55.08-2.06.09-5.92.09zm0-28.61c-3.82 0-4.33.02-5.86.09-1.29.06-2.29.25-3.23.61-.86.33-1.62.82-2.26 1.47a6.38 6.38 0 0 0-1.48 2.26c-.37.95-.56 1.94-.62 3.24-.07 1.5-.09 2.01-.09 5.86s.02 4.36.09 5.86c.06 1.29.25 2.29.61 3.23.32.85.83 1.63 1.47 2.26.65.66 1.41 1.16 2.26 1.48.95.37 1.94.56 3.24.62 1.53.07 2.04.09 5.86.09 3.82 0 4.33-.02 5.86-.09 1.29-.06 2.29-.25 3.23-.61a6.53 6.53 0 0 0 3.74-3.74c.37-.94.55-1.94.61-3.23h0c.07-1.51.09-2.01.09-5.86s-.02-4.36-.09-5.86c-.06-1.29-.25-2.29-.61-3.23-.32-.85-.83-1.63-1.47-2.26a6.38 6.38 0 0 0-2.26-1.48c-.95-.37-1.95-.56-3.24-.62-1.52-.08-2.03-.09-5.85-.09z"
};
function W6(t, e) {
  return m(), C("path", Y6);
}
const hx = /* @__PURE__ */ se(U6, [["render", W6]]), K6 = {}, G6 = {
  d: "M 7.978 4.437 C 5.99 4.437 4.387 6.04 4.387 8.027 C 4.387 10.015 5.99 11.618 7.978 11.618 C 9.965 11.618 11.568 10.015 11.568 8.027 C 11.568 6.04 9.965 4.437 7.978 4.437 Z M 7.978 10.362 C 6.693 10.362 5.643 9.315 5.643 8.027 C 5.643 6.74 6.69 5.693 7.978 5.693 C 9.265 5.693 10.312 6.74 10.312 8.027 C 10.312 9.315 9.262 10.362 7.978 10.362 Z M 12.553 4.29 C 12.553 4.755 12.178 5.127 11.715 5.127 C 11.249 5.127 10.878 4.752 10.878 4.29 C 10.878 3.827 11.253 3.452 11.715 3.452 C 12.178 3.452 12.553 3.827 12.553 4.29 Z M 14.931 5.14 C 14.878 4.018 14.621 3.024 13.799 2.205 C 12.981 1.387 11.987 1.13 10.865 1.074 C 9.709 1.008 6.243 1.008 5.087 1.074 C 3.968 1.127 2.974 1.383 2.153 2.202 C 1.331 3.021 1.078 4.015 1.021 5.137 C 0.956 6.293 0.956 9.758 1.021 10.915 C 1.074 12.037 1.331 13.03 2.153 13.849 C 2.974 14.668 3.965 14.924 5.087 14.98 C 6.243 15.046 9.709 15.046 10.865 14.98 C 11.987 14.927 12.981 14.671 13.799 13.849 C 14.618 13.03 14.874 12.037 14.931 10.915 C 14.996 9.758 14.996 6.296 14.931 5.14 Z M 13.437 12.155 C 13.193 12.768 12.721 13.24 12.106 13.487 C 11.184 13.852 8.996 13.768 7.978 13.768 C 6.959 13.768 4.768 13.849 3.849 13.487 C 3.237 13.243 2.765 12.771 2.518 12.155 C 2.153 11.233 2.237 9.046 2.237 8.027 C 2.237 7.008 2.156 4.818 2.518 3.899 C 2.762 3.287 3.234 2.815 3.849 2.568 C 4.771 2.202 6.959 2.287 7.978 2.287 C 8.996 2.287 11.187 2.205 12.106 2.568 C 12.718 2.812 13.19 3.283 13.437 3.899 C 13.803 4.821 13.718 7.008 13.718 8.027 C 13.718 9.046 13.803 11.237 13.437 12.155 Z",
  style: { fill: "currentColor" }
};
function X6(t, e) {
  return m(), C("path", G6);
}
const vx = /* @__PURE__ */ se(K6, [["render", X6]]), Q6 = {}, J6 = {
  fill: "currentColor",
  d: "M25 2.24C12.45 2.24 2.24 12.45 2.24 25S12.45 47.76 25 47.76 47.76 37.55 47.76 25 37.55 2.24 25 2.24zm0 30.18c-4.09 0-7.42-3.33-7.42-7.42s3.33-7.42 7.42-7.42 7.42 3.33 7.42 7.42-3.33 7.42-7.42 7.42zm0-13.29c-3.24 0-5.87 2.63-5.87 5.87s2.64 5.87 5.87 5.87 5.87-2.63 5.87-5.87-2.63-5.87-5.87-5.87zm8.43-.43c-1.18 0-2.14-.96-2.14-2.14 0-1.18.96-2.14 2.14-2.14s2.14.96 2.14 2.14c0 1.18-.96 2.14-2.14 2.14zm0-2.97c-.46 0-.84.38-.84.84 0 .46.38.84.84.84s.84-.38.84-.84c0-.47-.37-.84-.84-.84zM25 40.08c-3.88 0-4.39-.02-5.94-.09-1.47-.07-2.61-.29-3.72-.72a7.812 7.812 0 0 1-2.81-1.83 7.795 7.795 0 0 1-1.82-2.8c-.43-1.09-.65-2.24-.71-3.71-.07-1.53-.08-2.04-.08-5.93 0-3.89.02-4.4.09-5.93.07-1.47.29-2.61.72-3.72a7.899 7.899 0 0 1 1.83-2.81c.78-.79 1.75-1.43 2.8-1.82 1.1-.43 2.24-.65 3.71-.71 1.54-.07 2.06-.09 5.93-.09s4.39.02 5.93.09c1.47.07 2.61.29 3.72.72 1.05.39 2.02 1.03 2.81 1.83.79.78 1.43 1.75 1.82 2.8.43 1.09.65 2.24.71 3.71.07 1.53.09 2.04.09 5.93s-.02 4.4-.09 5.93c-.07 1.47-.29 2.61-.72 3.72a8.118 8.118 0 0 1-4.63 4.63c-1.1.43-2.25.65-3.72.72-1.53.07-2.04.08-5.92.08zm0-28.61c-3.84 0-4.35.02-5.86.08-1.29.06-2.29.25-3.23.61-.86.33-1.62.82-2.26 1.47-.66.65-1.16 1.41-1.48 2.26-.37.95-.56 1.94-.62 3.24-.07 1.5-.09 2-.09 5.86s.02 4.36.09 5.86c.06 1.29.25 2.29.61 3.23.32.85.83 1.63 1.47 2.26.65.66 1.41 1.16 2.26 1.48.95.37 1.94.56 3.24.62 1.51.07 2.02.09 5.86.09 3.85 0 4.35-.02 5.86-.09 1.29-.06 2.29-.25 3.23-.61a6.53 6.53 0 0 0 3.74-3.74c.37-.94.55-1.94.61-3.23.07-1.51.09-2.01.09-5.86s-.02-4.36-.09-5.86c-.06-1.29-.25-2.29-.61-3.23-.32-.85-.83-1.63-1.47-2.26a6.38 6.38 0 0 0-2.26-1.48c-.95-.37-1.95-.56-3.24-.62-1.5-.07-2.01-.08-5.85-.08z"
};
function e9(t, e) {
  return m(), C("path", J6);
}
const gx = /* @__PURE__ */ se(Q6, [["render", e9]]), t9 = {}, a9 = {
  fill: "currentColor",
  d: "M12 3a9 9 0 1 1 0 18 8.956 8.956 0 0 1-5.062-1.558.5.5 0 0 0-.68.112l-2.717.905.915-2.747a.5.5 0 0 0 .092-.663A8.956 8.956 0 0 1 3 12a9 9 0 0 1 9-9ZM2 12c0 1.955.562 3.78 1.533 5.323a.467.467 0 0 0-.007.019l-1.25 3.75a.5.5 0 0 0 .632.632l3.75-1.25a.422.422 0 0 0 .02-.007A9.955 9.955 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm5.59-3.42c.11-.171.216-.31.31-.402.065-.065.187-.13.383-.171.188-.04.399-.05.585-.045.046 0 .12.035.157.142l.67 1.907a.282.282 0 0 1-.035.256l-.498.707a.975.975 0 0 0-.117.918c.174.446.611 1.401 1.425 2.215.751.751 1.623 1.181 2.101 1.38a.975.975 0 0 0 1.157-.332l.449-.606a.282.282 0 0 1 .35-.086l1.716.828a.24.24 0 0 1 .102.09.115.115 0 0 1 .018.078c-.047.337-.153.672-.332.85-.126.127-.328.27-.57.413a2.13 2.13 0 0 1-1.865.151 10.433 10.433 0 0 1-3.568-2.324c-1.255-1.256-2.074-2.736-2.546-3.785-.329-.73-.301-1.55.108-2.184Zm-.398-1.11a3.49 3.49 0 0 0-.441.567c-.619.957-.63 2.142-.18 3.138.5 1.11 1.378 2.709 2.75 4.081a11.433 11.433 0 0 0 3.912 2.55c.9.35 1.906.27 2.739-.224a4 4 0 0 0 .766-.566c.422-.421.562-1.04.616-1.418.076-.546-.253-1.003-.676-1.207l-1.717-.829a1.283 1.283 0 0 0-1.588.392l-.443.598c-.421-.177-1.143-.542-1.753-1.152-.665-.665-1.038-1.462-1.194-1.855l.494-.702c.24-.34.3-.773.162-1.164l-.67-1.906c-.152-.433-.549-.798-1.076-.811a3.575 3.575 0 0 0-.82.067c-.287.061-.623.184-.88.442Z"
};
function o9(t, e) {
  return m(), C("path", a9);
}
const yx = /* @__PURE__ */ se(t9, [["render", o9]]), n9 = {}, r9 = {
  fill: "currentColor",
  d: "M25.21 2.24h-.01C12.65 2.24 2.44 12.45 2.44 25c0 4.98 1.6 9.59 4.33 13.34L3.94 46.8l8.75-2.8c3.6 2.38 7.89 3.76 12.52 3.76 12.55 0 22.76-10.21 22.76-22.76S37.76 2.24 25.21 2.24zm6.87 35.49c-1.28 0-3.15-.39-6.64-1.83-3.94-1.63-7.84-5.05-11-9.62l-.11-.16c-1.04-1.42-2.73-4.15-2.73-7.01 0-3.34 1.67-5.04 2.38-5.76.68-.7 1.69-1.07 2.83-1.07.26 0 .49.01.7.02 1.01.04 1.6.29 2.12 1.55l.66 1.59c.5 1.21 1.18 2.87 1.28 3.07.12.25.5 1.04.08 1.86-.22.48-.45.73-.75 1.09-.2.23-.34.38-.48.52-.17.18-.33.35-.5.56-.11.12-.24.28-.25.33 0 0 0 .04.06.14.55.93 1.73 2.73 3.36 4.18 2.12 1.89 3.84 2.58 4.67 2.92l.2.08c.26.11.54.09.67-.06.38-.41.87-1.09 1.38-1.81l.25-.35c.59-.84 1.5-1.11 2.46-.75.58.2 3.27 1.52 4.39 2.08l.36.18c.52.25.94.45 1.18.87.34.61.21 2.18-.31 3.65-.63 1.77-2.95 3.16-4.82 3.56-.45.1-.89.17-1.44.17zM16.8 13.82c-.7 0-1.33.21-1.66.54-.69.7-2 2.03-2 4.74 0 1.77.87 3.97 2.4 6.04.05.06.1.14.18.25 2.99 4.33 6.66 7.55 10.32 9.07 4.96 2.06 6.27 1.77 7.14 1.59 1.45-.31 3.28-1.42 3.69-2.56.4-1.14.44-2.05.41-2.36-.1-.07-.31-.17-.48-.25l-.38-.19c-1.82-.9-3.83-1.88-4.23-2.01-.33-.12-.48-.08-.67.19l-.25.35c-.54.76-1.06 1.49-1.51 1.97-.59.62-1.52.79-2.39.43l-.19-.08c-.83-.34-2.79-1.13-5.12-3.2-1.79-1.59-3.07-3.54-3.67-4.56-.64-1.1 0-1.86.31-2.23.2-.25.39-.45.59-.66l.38-.41c.33-.38.44-.51.59-.82.04-.08.06-.19-.09-.51-.11-.23-.59-1.39-1.31-3.15l-.65-1.58c-.24-.58-.24-.58-.69-.59-.29 0-.5-.01-.72-.01zm20.78 19.93z"
};
function s9(t, e) {
  return m(), C("path", r9);
}
const bx = /* @__PURE__ */ se(n9, [["render", s9]]), i9 = {}, l9 = {
  fill: "currentColor",
  d: "M24 4.75c10.632 0 19.25 8.618 19.25 19.25S34.632 43.25 24 43.25c-4.04 0-7.786-1.243-10.882-3.368l-.04-.028a.749.749 0 0 0-.64-.102.75.75 0 0 0-.175.036l-6.077 2.026 2.02-6.06a.75.75 0 0 0-.036-.798A19.158 19.158 0 0 1 4.75 24C4.75 13.368 13.368 4.75 24 4.75ZM3.25 24a20.66 20.66 0 0 0 3.465 11.484l-2.427 7.279a.75.75 0 0 0 .95.949l7.278-2.427A20.657 20.657 0 0 0 24 44.75c11.46 0 20.75-9.29 20.75-20.75S35.46 3.25 24 3.25 3.25 12.54 3.25 24Zm12.579-7.503c.225-.35.447-.642.651-.845.178-.179.477-.321.89-.41a5.418 5.418 0 0 1 1.23-.096c.212.006.44.156.545.452l1.34 3.814a.815.815 0 0 1-.103.74l-.995 1.413a1.7 1.7 0 0 0-.207 1.6c.343.877 1.202 2.753 2.795 4.345 1.47 1.47 3.18 2.315 4.121 2.705.757.314 1.57.022 2.017-.58l.897-1.212a.815.815 0 0 1 1.01-.249l3.433 1.657c.293.141.408.392.38.594-.097.685-.318 1.426-.736 1.844-.274.274-.7.574-1.19.864a4.51 4.51 0 0 1-3.948.32 21.118 21.118 0 0 1-7.221-4.705c-2.54-2.54-4.192-5.531-5.144-7.644-.688-1.527-.637-3.26.235-4.607Zm-.41-1.906c-.31.31-.597.7-.85 1.091-1.185 1.833-1.21 4.112-.342 6.038.993 2.206 2.735 5.373 5.45 8.089a22.617 22.617 0 0 0 7.738 5.042 6.01 6.01 0 0 0 5.259-.428c.525-.312 1.077-.687 1.484-1.094.782-.782 1.054-1.95 1.16-2.695.135-.964-.445-1.784-1.213-2.154l-3.434-1.657a2.315 2.315 0 0 0-2.866.707l-.898 1.211c-.078.106-.178.113-.236.089-.848-.352-2.36-1.104-3.636-2.38-1.384-1.385-2.15-3.045-2.459-3.832-.016-.042-.018-.112.037-.19l.995-1.413c.431-.612.54-1.395.292-2.1L20.56 15.1c-.276-.785-.988-1.431-1.922-1.454a6.889 6.889 0 0 0-1.58.129c-.552.118-1.171.348-1.639.815Z"
};
function u9(t, e) {
  return m(), C("path", l9);
}
const kx = /* @__PURE__ */ se(i9, [["render", u9]]), c9 = {}, d9 = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M25.01 48.54c-4.5 0-8.87-1.27-12.64-3.69l-8.4 2.68c-.28.09-.58.01-.79-.19-.2-.2-.27-.51-.18-.79l2.71-8.08A23.307 23.307 0 0 1 1.46 25c0-12.98 10.56-23.54 23.53-23.54H25c12.98 0 23.53 10.56 23.53 23.54.01 12.98-10.55 23.54-23.52 23.54zm-12.53-5.31c.15 0 .3.04.43.13 3.59 2.38 7.77 3.63 12.09 3.63 12.12 0 21.98-9.86 21.98-21.99 0-12.13-9.86-21.99-21.98-21.99h-.01C12.87 3.01 3.01 12.88 3.01 25c0 4.67 1.45 9.12 4.19 12.89.15.2.19.46.11.7L4.96 45.6l7.29-2.33c.07-.03.15-.04.23-.04zm19.39-5.5c-1.28 0-3.15-.39-6.64-1.83-3.94-1.63-7.85-5.05-11-9.62l-.11-.16c-1.04-1.42-2.73-4.15-2.73-7.01 0-3.34 1.67-5.04 2.38-5.76.68-.7 1.69-1.07 2.83-1.07.26 0 .49.01.7.02 1.01.04 1.6.29 2.12 1.55l.66 1.59c.5 1.21 1.18 2.87 1.28 3.07.12.25.5 1.04.08 1.86-.22.48-.45.73-.75 1.09-.2.23-.34.38-.48.52-.17.18-.33.35-.5.56-.11.12-.24.28-.25.33h0s0 .04.06.14c.55.93 1.73 2.73 3.36 4.18 2.12 1.89 3.84 2.58 4.67 2.92l.2.08c.26.11.53.09.67-.06.38-.41.87-1.09 1.38-1.81l.25-.35c.59-.84 1.5-1.11 2.46-.75.63.22 3.77 1.77 4.39 2.08l.36.18c.52.25.94.45 1.18.87.34.61.21 2.18-.31 3.65h0c-.63 1.77-2.95 3.16-4.82 3.56-.44.1-.89.17-1.44.17zM16.59 13.82c-.7 0-1.33.21-1.66.54-.69.7-2 2.03-2 4.74 0 1.77.87 3.97 2.4 6.04.05.06.1.14.17.25 2.99 4.33 6.65 7.55 10.32 9.07 4.96 2.06 6.27 1.77 7.14 1.59 1.45-.31 3.28-1.42 3.69-2.56.4-1.14.44-2.05.41-2.36-.1-.07-.31-.17-.48-.25l-.38-.19c-1.81-.9-3.84-1.88-4.23-2.01-.33-.12-.48-.08-.67.19l-.25.35c-.54.76-1.06 1.49-1.51 1.97-.59.62-1.52.79-2.39.43l-.19-.08c-.83-.34-2.79-1.13-5.12-3.2-1.79-1.59-3.07-3.54-3.67-4.56-.64-1.11.01-1.87.32-2.23.2-.25.39-.45.58-.66l.38-.41c.33-.38.44-.51.59-.82.04-.08.06-.19-.09-.51-.11-.23-.59-1.39-1.31-3.15l-.65-1.58c-.24-.58-.24-.58-.69-.59-.27 0-.48-.01-.71-.01zm20.79 19.93h0z"
};
function m9(t, e) {
  return m(), C("path", d9);
}
const Cx = /* @__PURE__ */ se(c9, [["render", m9]]), p9 = {}, f9 = {
  fill: "currentColor",
  d: "M21 19.5v-12a.5.5 0 0 0-.5-.5H17a.5.5 0 0 1 0-1h3.5A1.5 1.5 0 0 1 22 7.5v12a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 19.5v-12A1.5 1.5 0 0 1 3.5 6H7a.5.5 0 0 1 0 1H3.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5Zm-9.5-6a.5.5 0 1 0 1 0V2.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.707 0l-3 3a.5.5 0 1 0 .707.708L11.5 2.707V13.5Z"
};
function h9(t, e) {
  return m(), C("path", f9);
}
const wx = /* @__PURE__ */ se(p9, [["render", h9]]), v9 = {}, g9 = {
  fill: "currentColor",
  d: "M46.69 17.27v26.52c0 1.25-1.02 2.28-2.28 2.28H5.59c-1.25 0-2.28-1.02-2.28-2.28V17.27c0-1.25 1.02-2.28 2.28-2.28h6.49a.781.781 0 0 1 0 1.56H5.59c-.4 0-.72.33-.72.72v26.52c0 .4.33.72.72.72h38.82c.4 0 .72-.33.72-.72V17.27c0-.4-.33-.72-.72-.72h-6.34c-.43 0-.78-.35-.78-.78s.36-.77.78-.77h6.34c1.26 0 2.28 1.02 2.28 2.27zm-29.2-4.01c.19 0 .39-.07.54-.22l6.79-6.51v19.28a.781.781 0 0 0 1.56 0V6.58l6.45 6.45c.3.3.79.3 1.1 0s.3-.79 0-1.1l-7.77-7.77a.852.852 0 0 0-.25-.17.717.717 0 0 0-.29-.06h-.01c-.04 0-.07.02-.11.02-.06.01-.12.01-.18.04-.05.02-.1.06-.15.09-.03.02-.07.04-.1.07l-8.1 7.77c-.31.3-.32.79-.02 1.1a.7.7 0 0 0 .54.24z"
};
function y9(t, e) {
  return m(), C("path", g9);
}
const _x = /* @__PURE__ */ se(v9, [["render", y9]]), b9 = {}, k9 = {
  d: "M14.8 0H1.2C0.88174 0 0.576516 0.126428 0.351472 0.351472C0.126428 0.576516 0 0.88174 0 1.2V14.8C0 15.1183 0.126428 15.4235 0.351472 15.6485C0.576516 15.8736 0.88174 16 1.2 16H14.8C15.1183 16 15.4235 15.8736 15.6485 15.6485C15.8736 15.4235 16 15.1183 16 14.8V1.2C16 0.88174 15.8736 0.576516 15.6485 0.351472C15.4235 0.126428 15.1183 0 14.8 0ZM4.8 13.6H2.4V6.4H4.8V13.6ZM3.6 5C3.32495 4.99214 3.05831 4.9034 2.8334 4.74486C2.60849 4.58633 2.43529 4.36503 2.33544 4.10862C2.23558 3.85221 2.2135 3.57206 2.27195 3.30318C2.3304 3.03429 2.4668 2.78859 2.66409 2.59678C2.86138 2.40497 3.11083 2.27555 3.38125 2.22469C3.65168 2.17383 3.93109 2.2038 4.18459 2.31083C4.43808 2.41787 4.65441 2.59724 4.80655 2.82652C4.95869 3.0558 5.03989 3.32483 5.04 3.6C5.03368 3.97628 4.87867 4.33476 4.60884 4.59709C4.33901 4.85943 3.97631 5.00428 3.6 5ZM13.6 13.6H11.2V9.808C11.2 8.672 10.72 8.264 10.096 8.264C9.91305 8.27618 9.73431 8.32439 9.57004 8.40585C9.40577 8.48731 9.25921 8.60042 9.13879 8.73869C9.01836 8.87695 8.92644 9.03765 8.8683 9.21154C8.81016 9.38544 8.78695 9.56911 8.8 9.752C8.79603 9.78923 8.79603 9.82677 8.8 9.864V13.6H6.4V6.4H8.72V7.44C8.95402 7.084 9.27554 6.79406 9.65375 6.59795C10.032 6.40184 10.4542 6.30613 10.88 6.32C12.12 6.32 13.568 7.008 13.568 9.248L13.6 13.6Z",
  fill: "currentColor"
};
function C9(t, e) {
  return m(), C("path", k9);
}
const Hx = /* @__PURE__ */ se(b9, [["render", C9]]), w9 = {}, _9 = {
  fill: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "10",
  "stroke-width": ".25",
  d: "M19.55 36.99h-5.47c-.43 0-.77-.35-.77-.78V19.76c0-.43.35-.78.77-.78h5.47c.43 0 .77.35.77.78v16.45c0 .43-.35.78-.77.78zm-4.7-1.55h3.92v-14.9h-3.92v14.9zm1.96-17.15h-.04c-2.2 0-3.8-1.52-3.8-3.62s1.63-3.62 3.87-3.62c2.21 0 3.79 1.48 3.83 3.6.01 2.11-1.62 3.64-3.86 3.64zm.04-5.69c-1.39 0-2.32.83-2.32 2.07 0 1.22.92 2.07 2.25 2.07h.04c1.39 0 2.32-.83 2.32-2.07-.04-1.25-.93-2.07-2.29-2.07zm22.42 24.39H33.8c-.43 0-.77-.35-.77-.78v-8.8c0-2.95-1.45-2.95-2-2.95-1.33 0-1.9 1.06-2.09 1.51-.08.2-.12.55-.12 1.05v9.19c0 .43-.35.78-.77.78h-5.47c-.21 0-.4-.08-.55-.23a.764.764 0 0 1-.23-.55c0-.15.07-14.91 0-16.41-.01-.21.07-.42.21-.57.15-.15.35-.24.56-.24h5.47c.43 0 .77.35.77.78V20c.93-.78 2.24-1.4 4.15-1.4 4.36 0 7.07 3.14 7.07 8.18v9.43c.01.43-.34.78-.76.78zm-4.7-1.55h3.92v-8.66c0-4.21-2.01-6.63-5.52-6.63-2.44 0-3.57 1.26-4.28 2.36a.78.78 0 0 1-1.43-.42v-1.55h-3.9c.04 2.98 0 12.14-.01 14.9h3.92v-8.41c0-.73.07-1.23.24-1.63.62-1.55 1.94-2.48 3.52-2.48 1.07 0 3.55.44 3.55 4.5v8.02zM25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46c12.98 0 23.54 10.56 23.54 23.54S37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01z"
};
function H9(t, e) {
  return m(), C("path", _9);
}
const jx = /* @__PURE__ */ se(w9, [["render", H9]]), j9 = {}, L9 = {
  fill: "currentColor",
  d: "M25 2.24C12.45 2.24 2.24 12.45 2.24 25S12.45 47.76 25 47.76 47.76 37.55 47.76 25 37.55 2.24 25 2.24zm-6.96 34.71h-5.47c-.43 0-.77-.35-.77-.78V19.72c0-.43.35-.78.77-.78h5.47c.43 0 .77.35.77.78v16.45c0 .43-.35.78-.77.78zm-4.7-1.55h3.92V20.5h-3.92v14.9zm1.96-17.15h-.04c-2.2 0-3.8-1.52-3.8-3.62s1.63-3.62 3.87-3.62c2.21 0 3.79 1.48 3.83 3.6.01 2.12-1.62 3.64-3.86 3.64zm.04-5.69c-1.39 0-2.32.83-2.32 2.07 0 1.22.92 2.07 2.25 2.07h.04c1.39 0 2.32-.83 2.32-2.07-.04-1.25-.93-2.07-2.29-2.07zm22.42 24.39h-5.47c-.43 0-.77-.35-.77-.78v-8.8c0-2.95-1.45-2.95-2-2.95-1.33 0-1.9 1.06-2.09 1.51-.08.2-.12.55-.12 1.05v9.19c0 .43-.35.78-.77.78h-5.47c-.21 0-.4-.08-.55-.23a.764.764 0 0 1-.23-.55c0-.15.07-14.91 0-16.41-.01-.21.07-.42.21-.57.15-.15.35-.24.56-.24h5.47c.43 0 .77.35.77.78v.24c.93-.78 2.24-1.4 4.15-1.4 4.36 0 7.07 3.14 7.07 8.18v9.43c.01.42-.34.77-.76.77zm-4.7-1.55h3.92v-8.66c0-4.21-2.01-6.63-5.52-6.63-2.44 0-3.57 1.26-4.28 2.36a.78.78 0 0 1-1.43-.42V20.5h-3.9c.04 2.98 0 12.14-.01 14.9h3.92v-8.41c0-.73.07-1.23.24-1.63.62-1.55 1.94-2.48 3.52-2.48 1.07 0 3.55.44 3.55 4.5v8.02z"
};
function x9(t, e) {
  return m(), C("path", L9);
}
const Lx = /* @__PURE__ */ se(j9, [["render", x9]]), $9 = {}, M9 = {
  fill: "currentColor",
  d: "M8 .5a.5.5 0 0 1 .5.5v6.5H15a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1A.5.5 0 0 1 8 .5Z"
};
function V9(t, e) {
  return m(), C("path", M9);
}
const xx = /* @__PURE__ */ se($9, [["render", V9]]), S9 = {}, A9 = {
  fill: "currentColor",
  d: "M8 .5a.5.5 0 0 1 .5.5v6.5H15a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1A.5.5 0 0 1 8 .5Z"
};
function E9(t, e) {
  return m(), C("path", A9);
}
const Ii = /* @__PURE__ */ se(S9, [["render", E9]]), D9 = {
  Normal: "0 0 16 16",
  Medium: "0 0 24 24",
  MediumLarge: "0 0 32 32",
  Large: "0 0 48 48",
  Social: "0 0 50 50",
  XLarge: "0 0 88 88",
  XXLarge: "0 0 200 200"
}, et = {
  Normal: 16,
  Medium: 24,
  MediumLarge: 32,
  Large: 48,
  Social: 50,
  XLarge: 88,
  XXLarge: 200
}, $x = {
  Rounded: "rounded",
  Active: "active",
  Disabled: "disabled"
}, P9 = ["width", "height", "viewBox"], Oe = /* @__PURE__ */ J({
  __name: "IconBase",
  props: {
    width: { default: void 0 },
    height: { default: void 0 },
    viewbox: { default: void 0 },
    size: { default: et.Normal }
  },
  setup(t) {
    const e = F1(), a = t, n = Object.entries(et).find(([, l]) => l === a.size)[0], r = Q(() => String(a.height ?? et[n])), s = Q(() => String(a.width ?? et[n])), i = Q(() => String(a.viewbox ?? D9[n]));
    return (l, f) => (m(), C("svg", {
      class: le(j(g1)("align-baseline inline-block overflow-visible", j(e).class)),
      xmlns: "http://www.w3.org/2000/svg",
      width: s.value,
      height: r.value,
      viewBox: i.value,
      role: "presentation"
    }, [
      oe(l.$slots, "default")
    ], 10, P9));
  }
}), ra = /* @__PURE__ */ J({
  __name: "ChevronIcon",
  props: {
    isOpen: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), he(j(Oe), {
      size: j(et).Medium
    }, {
      default: ue(() => [
        e.isOpen ? (m(), he(j(T5), { key: 0 })) : (m(), he(j(V5), { key: 1 }))
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), z9 = ["id", "aria-controls", "aria-expanded"], T9 = ["id", "aria-labelledby"], Mx = /* @__PURE__ */ J({
  __name: "AccordionItem",
  props: {
    name: {},
    open: { type: Boolean }
  },
  setup(t) {
    const e = t, a = In("setOpenItem"), o = In("border"), n = In("openItems"), r = Q(() => `accordion-header-${e.name}`), s = Q(() => `accordion-content-${e.name}`), i = Q(() => !!n?.value.includes(e.name));
    return e.open && a && a(e.name), (l, f) => (m(), C("div", {
      class: le(["group/item w-full", {
        "first:rounded-t-xl first:border-0 border-t": j(o),
        "border-b last:border-b-0": !j(o)
      }])
    }, [
      g("div", {
        class: le({
          "bg-gray-100": j(o)
        })
      }, [
        g("button", {
          id: r.value,
          class: le(["flex py-4 text-left w-full", {
            "group-first/item:rounded-t-xl px-4": j(o),
            "group-last/item:rounded-b-xl": !i.value && j(o)
          }]),
          "aria-controls": s.value,
          "aria-expanded": i.value,
          type: "button",
          onClick: f[0] || (f[0] = () => j(a)?.(l.name))
        }, [
          oe(l.$slots, "header"),
          ye(j(ra), {
            "is-open": i.value,
            class: "ml-auto self-center"
          }, null, 8, ["is-open"])
        ], 10, z9)
      ], 2),
      Ne(g("div", {
        id: s.value,
        "aria-labelledby": r.value,
        role: "region",
        class: le(["border-t py-4", {
          "px-4": j(o)
        }])
      }, [
        oe(l.$slots, "default")
      ], 10, T9), [
        [L1, i.value]
      ])
    ], 2));
  }
}), Ka = {
  Small: "small",
  Medium: "medium",
  Large: "large",
  None: "none"
}, k1 = {
  Danger: "danger",
  DangerBasic: "danger-basic",
  DangerLight: "danger-light",
  DangerOutline: "danger-outline",
  GrayOutline: "gray",
  None: "none",
  Primary: "primary",
  PrimaryBasic: "primary-basic",
  PrimaryLight: "primary-light",
  PrimaryOutline: "primary-outline",
  Secondary: "secondary",
  SecondaryBasic: "secondary-basic",
  SecondaryLight: "secondary-light",
  SecondaryOutline: "secondary-outline"
}, O9 = {
  Button: "button",
  Submit: "submit"
}, F9 = (t) => {
  const e = {
    [k1.Primary]: {
      base: "bg-primary border-primary text-white",
      hover: "hover:bg-primary-200 hover:border-primary-200"
    },
    [k1.Secondary]: {
      base: "bg-secondary border-secondary text-white",
      hover: "hover:bg-secondary-200 hover:border-secondary-200"
    },
    [k1.Danger]: {
      base: "bg-red border-red text-white",
      hover: "hover:bg-red-900 hover:border-red-900"
    },
    [k1.PrimaryOutline]: {
      base: "border-primary text-primary",
      hover: "hover:border-primary-200 hover:bg-primary-200 hover:text-white"
    },
    [k1.SecondaryOutline]: {
      base: "border-secondary text-secondary",
      hover: "hover:border-secondary-200 hover:bg-secondary-200 hover:text-white"
    },
    [k1.DangerOutline]: {
      base: "border-red text-red",
      hover: "hover:border-red-900 hover:bg-red-900 hover:text-white"
    },
    [k1.PrimaryBasic]: {
      base: "border-transparent text-primary",
      hover: "hover:text-primary-200"
    },
    [k1.SecondaryBasic]: {
      base: "border-transparent text-secondary",
      hover: "hover:text-secondary-200"
    },
    [k1.DangerBasic]: {
      base: "border-transparent text-red",
      hover: "hover:text-red-900"
    },
    [k1.PrimaryLight]: {
      base: "border-primary bg-primary-light text-primary",
      hover: "hover:bg-primary hover:text-white"
    },
    [k1.SecondaryLight]: {
      base: "border-secondary bg-secondary-light text-secondary",
      hover: "hover:bg-secondary hover:text-white"
    },
    [k1.DangerLight]: {
      base: "border-red bg-red-100 text-red",
      hover: "hover:bg-red hover:text-white"
    },
    [k1.GrayOutline]: {
      base: "bg-white border-gray-400 text-gray-800",
      hover: "hover:bg-neutral-100"
    },
    [k1.None]: {
      base: "",
      hover: ""
    }
  };
  return e[t] ? [e[t].base, e[t].hover].join(" ") : "";
}, B9 = (t) => ({
  [Ka.Small]: "text-xs leading-0 px-[6px] py-[1px]",
  [Ka.Medium]: "text-md leading-6 py-[6px] px-[12px]",
  [Ka.Large]: "text-md leading-6 py-3 px-6",
  [Ka.None]: ""
})[t] ?? "", I9 = ["disabled", "type", "title", "data-test", "aria-label", "aria-controls", "aria-expanded", "aria-haspopup"], b1 = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    disabled: { type: Boolean },
    size: { default: Ka.Medium },
    type: { default: O9.Button },
    variant: { default: k1.Secondary },
    title: { default: void 0 },
    dataTest: { default: void 0 },
    ariaControls: { default: void 0 },
    ariaExpanded: { type: [Boolean, String], default: void 0 },
    ariaHaspopup: { type: [Boolean, String], default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["click", "keydown"],
  setup(t) {
    const e = F1(), a = Q(() => {
      const { class: r, ...s } = e;
      return s;
    }), o = t, n = Q(() => {
      const r = B9(o.size), s = F9(o.variant), l = o.disabled ? "cursor-not-allowed bg-gray-200 text-gray-800 border border-gray-200" : s, f = o.variant === k1.None ? "" : "duration-200 ease-in-out rounded-xl select-none whitespace-nowrap border border-solid";
      return g1(f, r, l, e.class);
    });
    return (r, s) => (m(), C("button", Re(a.value, {
      class: n.value,
      disabled: r.disabled,
      type: r.type,
      title: r.title,
      "data-test": r.dataTest,
      "aria-label": r.ariaLabel,
      "aria-controls": r.ariaControls,
      "aria-expanded": r.ariaExpanded,
      "aria-haspopup": r.ariaHaspopup,
      onClick: s[0] || (s[0] = (i) => r.$emit("click", i)),
      onKeydown: s[1] || (s[1] = (i) => r.$emit("keydown", i))
    }), [
      oe(r.$slots, "default")
    ], 16, I9));
  }
}), Z9 = {
  key: 0,
  role: "tooltip",
  class: /* @__PURE__ */ le([
    "bg-gray-900 px-2 py-1 rounded-full text-white text-xs pointer-events-none z-10 transition-all w-max",
    "group-hover:opacity-100 opacity-0 group-focus-visible:opacity-100",
    "absolute bottom-[-4px] translate-x-[-50%] left-[50%] translate-y-[50%] group-hover:translate-y-[calc(100%)] group-focus-visible:translate-y-[calc(100%)]"
  ])
}, Hr = /* @__PURE__ */ J({
  __name: "ActionButton",
  props: {
    title: { default: void 0 },
    withTooltip: { type: Boolean, default: !1 },
    withText: { type: Boolean, default: !1 },
    variant: { default: "none" }
  },
  setup(t) {
    const e = t, a = [
      "action-button",
      "flex justify-center items-center relative",
      "border-y border-r bg-white group first:rounded-s-full first:border last:rounded-r-full last:border-r",
      "disabled:bg-transparent disabled:text-gray-800 disabled:cursor-not-allowed",
      "hover:bg-gray-200",
      {
        "min-h-8 h-fit text-xs pl-2 first:pl-3 pr-2": e.withText,
        "only:w-8 h-8 min-w-8 w-8 first:w-9 last:w-9": !e.withText
      }
    ];
    return (o, n) => (m(), he(b1, {
      title: o.title,
      class: le(a),
      variant: o.variant
    }, {
      default: ue(() => [
        oe(o.$slots, "default"),
        o.withTooltip && !o.withText ? (m(), C("div", Z9, _e(o.title), 1)) : ae("", !0)
      ]),
      _: 3
    }, 8, ["title", "variant"]));
  }
}), R9 = {}, N9 = { class: "absolute bg-white border px-2 py-1 right-0 rounded-[10px] shadow-lg" };
function q9(t, e) {
  return m(), C("div", N9, [
    oe(t.$slots, "default")
  ]);
}
const Zi = /* @__PURE__ */ se(R9, [["render", q9]]), U9 = { class: "flex justify-self-end" }, Y9 = { class: "flex relative" }, W9 = ["id", "aria-labelledby"], Ri = /* @__PURE__ */ J({
  __name: "ActionButtonWrapper",
  props: {
    popupDirection: { default: "bottom" }
  },
  setup(t) {
    const e = _t(), a = ro(), [o, n] = ht(!1), r = () => n(!o.value), { t: s } = Sa({
      useScope: "local",
      inheritLocale: !0
    }), i = (f) => {
      if (Array.isArray(f.dirs)) {
        const u = f.dirs.find((d) => d.dir && d.dir.name === "show");
        if (u && u.value === !1)
          return !1;
      }
      return f.children !== "v-if" && f.component !== void 0 && f.type !== "v-if";
    }, l = Q(() => {
      if (!e.actionMenu)
        return !1;
      const f = e.actionMenu();
      return !Array.isArray(f) || f.length === 0 ? !1 : f.some(i);
    });
    return (f, u) => (m(), C("div", U9, [
      g("div", Y9, [
        oe(f.$slots, "default"),
        l.value ? Ne((m(), he(Hr, {
          key: 0,
          "with-tooltip": "",
          title: j(s)("actionMenu"),
          id: `action-button-${j(a)}`,
          "aria-expanded": j(o),
          "aria-haspopup": "menu",
          "aria-controls": `action-button-menu-${j(a)}`,
          class: le([{
            "bg-gray-200 !rounded-s-none": j(o)
          }, "rounded-r-full"]),
          onClick: $e(r, ["stop"])
        }, {
          default: ue(() => [
            ye(Oe, null, {
              default: ue(() => [
                ye(j(P7))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "id", "aria-expanded", "aria-controls", "class"])), [
          [j(Ft), () => j(n)(!1)]
        ]) : ae("", !0),
        l.value ? (m(), C("div", {
          key: 1,
          id: `action-button-menu-${j(a)}`,
          "aria-labelledby": `action-button-${j(a)}`
        }, [
          Ne(ye(Zi, {
            role: "menu",
            class: le(["!right-[30px] min-w-[180px] z-30 action-menu", {
              "-bottom-2": f.popupDirection === "top",
              "-top-2": f.popupDirection === "bottom"
            }])
          }, {
            default: ue(() => [
              oe(f.$slots, "actionMenu")
            ]),
            _: 3
          }, 8, ["class"]), [
            [L1, j(o)]
          ])
        ], 8, W9)) : ae("", !0)
      ])
    ]));
  }
});
function j0(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      "nl-NL": {
        actionMenu: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Actiemenu" } }
      },
      "nl-BE": {
        actionMenu: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Actiemenu" } }
      },
      "en-GB": {
        actionMenu: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Action menu" } }
      },
      "fr-BE": {
        actionMenu: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Menu d'action" } }
      }
    }
  });
}
typeof j0 == "function" && j0(Ri);
const D1 = {
  Clear: "clear",
  Danger: "danger",
  DangerLight: "danger-light",
  Info: "info",
  InfoLight: "info-light",
  Muted: "muted",
  MutedLight: "muted-light",
  Primary: "primary",
  PrimaryLight: "primary-light",
  Secondary: "secondary",
  SecondaryLight: "secondary-light",
  Success: "success",
  SuccessLight: "success-light",
  Warning: "warning",
  WarningLight: "warning-light"
}, Vx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Badge",
  props: {
    variant: {}
  },
  setup(t) {
    const e = t, { class: a, ...o } = F1(), n = {
      [D1.Clear]: "bg-white text-black border border-gray-400",
      [D1.Danger]: "bg-red text-white border-transparent",
      [D1.DangerLight]: "bg-red-100 text-danger-200 border border-transparent",
      [D1.Info]: "bg-blue text-white border-transparent",
      [D1.InfoLight]: "bg-blue-100 text-info-200 border border-transparent",
      [D1.Muted]: "bg-gray-200 text-black border-gray-400",
      [D1.MutedLight]: "bg-gray-200 text-gray-800 border border-gray-400",
      [D1.Primary]: "bg-primary text-white border-transparent",
      [D1.PrimaryLight]: "bg-primary-50 text-primary border-transparent",
      [D1.Secondary]: "bg-secondary text-black border-transparent",
      [D1.SecondaryLight]: "bg-secondary-50 text-secondary-200 border-transparent",
      [D1.Success]: "bg-green text-white border border-transparent",
      [D1.SuccessLight]: "bg-green-100 text-green border border-transparent",
      [D1.Warning]: "bg-yellow text-black border-transparent",
      [D1.WarningLight]: "bg-[#FEF5D9] text-[#A27900] border-transparent"
    }, r = Q(() => g1(n[e.variant], a));
    return (s, i) => (m(), C("div", Re({ class: "border px-[6px] py-[2px] rounded-regular text-xs w-max" }, o, { class: r.value }), [
      oe(s.$slots, "default")
    ], 16));
  }
}), K9 = ["src", "alt", "title"], Sx = /* @__PURE__ */ J({
  __name: "BaseImage",
  props: {
    src: {},
    alt: {},
    title: {},
    hideOnError: { type: Boolean }
  },
  emits: ["error"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = me(!1), r = Q(() => a.hideOnError ? !n.value : !0), s = () => {
      n.value = !0, a.hideOnError && o("error");
    };
    return a.src || a.hideOnError && (n.value = !0, o("error")), Ue(
      () => a.src,
      (i) => {
        i ? n.value = !1 : (n.value = !!a.hideOnError, a.hideOnError && o("error"));
      }
    ), (i, l) => r.value ? (m(), C("img", {
      key: 0,
      src: i.src,
      alt: i.alt,
      title: i.title,
      onError: s
    }, null, 40, K9)) : ae("", !0);
  }
}), G9 = {
  class: "animate-spin-fade opacity-0",
  "data-test": "spinner"
}, X9 = /* @__PURE__ */ J({
  __name: "Spinner",
  props: {
    size: { default: "medium" }
  },
  setup(t) {
    const e = t, a = Q(() => e.size === "small" ? "0.2rem" : "0.3rem"), o = Q(() => e.size === "small" ? "1.5rem" : "3rem"), n = Q(() => ({
      borderWidth: a.value,
      width: o.value
    }));
    return (r, s) => (m(), C("div", G9, [
      g("div", {
        class: "animate-spin-border aspect-square border-gray-400 rounded-full text-primary",
        style: w1([n.value, { "border-right-color": "currentColor" }]),
        "data-test": "spinner-border"
      }, null, 4)
    ]));
  }
}), Q9 = { class: "-translate-x-1/2 absolute left-1/2 mx-auto w-min" }, Ax = /* @__PURE__ */ J({
  __name: "ButtonWithSpinner",
  props: {
    disabled: { type: Boolean },
    size: {},
    type: {},
    variant: {},
    title: {},
    ariaControls: {},
    ariaExpanded: { type: [Boolean, String] },
    ariaHaspopup: { type: [Boolean, String] },
    ariaLabel: {},
    isLoading: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), he(b1, Re(e.$props, {
      class: ["box-content relative", {
        "text-transparent": e.isLoading
      }],
      disabled: e.disabled || e.isLoading
    }), {
      default: ue(() => [
        Ne(g("div", Q9, [
          ye(X9, { size: "small" })
        ], 512), [
          [L1, e.isLoading]
        ]),
        oe(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "disabled"]));
  }
}), J9 = {}, ed = { class: "border border-gray-400 card max-w-md rounded-regular" }, td = {
  key: 0,
  class: "p-4 border-b"
}, ad = { class: "py-4 px-6" }, od = {
  key: 1,
  class: "border-t divide-x grid auto-cols-[1fr] grid-flow-col"
};
function nd(t, e) {
  return m(), C("div", ed, [
    t.$slots.header ? (m(), C("div", td, [
      oe(t.$slots, "header")
    ])) : ae("", !0),
    g("div", ad, [
      oe(t.$slots, "default")
    ]),
    t.$slots.footer ? (m(), C("div", od, [
      oe(t.$slots, "footer")
    ])) : ae("", !0)
  ]);
}
const Ni = /* @__PURE__ */ se(J9, [["render", nd]]), rd = {}, sd = {
  role: "list",
  class: "font-normal text-xs grid grid-cols-2 gap-x-2 gap-y-3"
};
function id(t, e) {
  return m(), C("dl", sd, [
    oe(t.$slots, "default")
  ]);
}
const Ex = /* @__PURE__ */ se(rd, [["render", id]]), ld = { class: "flex flex-col w-full" }, ud = { class: "font-bold" }, cd = { class: "break-all" }, Dx = /* @__PURE__ */ J({
  __name: "CardRow",
  props: {
    label: {}
  },
  setup(t) {
    return (e, a) => (m(), C("div", ld, [
      g("dt", ud, _e(e.label), 1),
      g("dd", cd, [
        oe(e.$slots, "default")
      ])
    ]));
  }
});
var H1 = { PostNl: 1, Bpost: 2, CheapCargo: 3, Dpd: 4, Instabox: 5, Dhl: 6, Bol: 7, Ups: 8, DhlForYou: 9, DhlParcelConnect: 10, DhlEuroPlus: 11, UpsStandard: 12, UpsExpressSaver: 13, Gls: 14, Brt: 15, Trunkrs: 16 }, Ke = { PostNl: "postnl", POSTNL: "POSTNL", Bpost: "bpost", BPOST: "BPOST", CheapCargo: "cheapcargo", CHEAP_CARGO: "CHEAP_CARGO", Dpd: "dpd", DPD: "DPD", Instabox: "instabox", Dhl: "dhl", BolCom: "bol.com", Bol: "bol", BOL: "BOL", Ups: "ups", DhlForYou: "dhlforyou", DHL_FOR_YOU: "DHL_FOR_YOU", DhlParcelConnect: "dhlparcelconnect", DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT", DhlEuroPlus: "dhleuroplus", DHL_EUROPLUS: "DHL_EUROPLUS", UpsStandard: "upsstandard", UPS_STANDARD: "UPS_STANDARD", UpsExpressSaver: "upsexpresssaver", UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER", Gls: "gls", GLS: "GLS", Brt: "brt", BRT: "BRT", Trunkrs: "trunkrs", TRUNKRS: "TRUNKRS" }, ua = { Package: 1, Mailbox: 2, Letter: 3, DigitalStamp: 4, Pallet: 5, PackageSmall: 6 }, dd = (t) => Object.values(Ke).includes(t), md = (t) => Object.values(H1).includes(t), Ba = { Registered: 0, HandedToCarrier: 3, Sorting: 4, Distribution: 5, Delivered: 7 }, go = { Info: "info", Success: "success", Warning: "warning", Error: "alert" }, ln = { Full: "full", Half: "half" }, pd = { Toaster: "toaster" }, Kt = { Asc: "ASC", Desc: "DESC" };
const Px = /* @__PURE__ */ J({
  __name: "CarrierLogo",
  props: {
    carrier: {}
  },
  setup(t) {
    const e = t, a = kn(), o = {
      [H1.PostNl]: Jn,
      [H1.Dhl]: Y1,
      [H1.DhlForYou]: Y1,
      [H1.DhlParcelConnect]: Y1,
      [H1.DhlEuroPlus]: Y1,
      [H1.Ups]: jt,
      [H1.UpsStandard]: jt,
      [H1.UpsExpressSaver]: jt,
      [H1.CheapCargo]: Qn,
      [H1.Dpd]: Yn,
      [H1.Bpost]: Gn,
      [H1.Bol]: vo,
      [H1.Instabox]: H0,
      [H1.Gls]: Wn,
      [H1.Brt]: Xn,
      [H1.Trunkrs]: Kn
    }, n = {
      [Ke.PostNl]: Jn,
      [Ke.POSTNL]: Jn,
      [Ke.Dhl]: Y1,
      [Ke.DhlForYou]: Y1,
      [Ke.DHL_FOR_YOU]: Y1,
      [Ke.DhlParcelConnect]: Y1,
      [Ke.DHL_PARCEL_CONNECT]: Y1,
      [Ke.DhlEuroPlus]: Y1,
      [Ke.DHL_EUROPLUS]: Y1,
      [Ke.Ups]: jt,
      [Ke.UpsStandard]: jt,
      [Ke.UPS_STANDARD]: jt,
      [Ke.UpsExpressSaver]: jt,
      [Ke.UPS_EXPRESS_SAVER]: jt,
      [Ke.CheapCargo]: Qn,
      [Ke.CHEAP_CARGO]: Qn,
      [Ke.Dpd]: Yn,
      [Ke.DPD]: Yn,
      [Ke.Bpost]: Gn,
      [Ke.BPOST]: Gn,
      [Ke.BolCom]: vo,
      [Ke.Bol]: vo,
      [Ke.BOL]: vo,
      [Ke.Instabox]: H0,
      [Ke.Gls]: Wn,
      [Ke.GLS]: Wn,
      [Ke.Brt]: Xn,
      [Ke.BRT]: Xn,
      [Ke.Trunkrs]: Kn,
      [Ke.TRUNKRS]: Kn
    }, r = () => dd(e.carrier) ? n[e.carrier] : md(e.carrier) ? o[e.carrier] : null;
    return Ue(
      () => [e.carrier],
      () => {
        a.value = r();
      },
      {
        immediate: !0
      }
    ), (s, i) => (m(), he(Oe, {
      size: j(et).Medium
    }, {
      default: ue(() => [
        (m(), he(S1(a.value)))
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), zx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "ClipboardText",
  props: {
    ariaLabel: { default: void 0 },
    copyContent: {},
    copyConfirmation: {}
  },
  setup(t) {
    const e = t, { copy: a, copied: o } = Yl(), n = async () => {
      o.value || await a(e.copyContent);
    };
    return (r, s) => (m(), he(j(b1), Re({
      variant: j(k1).None,
      class: "flex gap-x-1 items-center relative text-center text-primary"
    }, r.$attrs, {
      "aria-label": r.ariaLabel,
      onKeydown: Ae(n, ["enter"]),
      onClick: n
    }), {
      default: ue(() => [
        Ne(ye(j(Zi), {
          role: "alert",
          class: "-top-8 -translate-x-1/2 absolute left-1/2 text-black text-sm transition-all w-fit whitespace-nowrap"
        }, {
          default: ue(() => [
            qe(_e(r.copyConfirmation), 1)
          ]),
          _: 1
        }, 512), [
          [L1, j(o)]
        ]),
        oe(r.$slots, "default"),
        ye(j(Oe), null, {
          default: ue(() => [
            ye(j(Ku))
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["variant", "aria-label"]));
  }
}), fd = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "CountBadge",
  props: {
    count: {}
  },
  setup(t) {
    return (e, a) => (m(), C("p", {
      class: le(j(g1)("bg-primary-10 font-bold px-2 py-1 rounded-full text-primary text-xs", e.$attrs.class))
    }, _e(e.count), 3));
  }
}), hd = { class: "relative" }, vd = ["id"], gd = 16, yd = 8, Tx = /* @__PURE__ */ J({
  __name: "Dropdown",
  props: {
    label: {},
    value: {},
    hasDeleteButton: { type: Boolean },
    deleteButtonText: {}
  },
  emits: ["reset"],
  setup(t, { emit: e }) {
    const a = t, o = e, [n, r] = ht(), s = ro(), i = Q(() => {
      const y = typeof a.value == "string" && a.value === "", b = Array.isArray(a.value) && a.value.length === 0, M = a.value === null, c = a.value === void 0;
      return y || b || M || c;
    }), l = Q(() => i.value ? a.label : Array.isArray(a.value) ? `${a.label}: ` : `${a.label}: ${a.value}`), f = () => {
      o("reset");
    }, u = _r("reference"), d = _r("floating"), { floatingStyles: k } = Aa(u, d, {
      placement: "bottom-start",
      whileElementsMounted: Da,
      middleware: [
        Br(yd),
        Ea(),
        Cn(),
        wn({
          padding: gd
        })
      ]
    });
    return (y, b) => Ne((m(), C("div", hd, [
      ye(b1, {
        variant: i.value ? "gray" : "primary-outline",
        class: "flex gap-2 justify-center",
        ref: "reference",
        "aria-haspopup": "listbox",
        "aria-controls": `listbox-${j(s)}`,
        onClick: b[0] || (b[0] = () => j(r)())
      }, {
        default: ue(() => [
          qe(_e(l.value) + " ", 1),
          Array.isArray(a.value) && !i.value ? (m(), he(fd, {
            key: 0,
            count: a.value.length
          }, null, 8, ["count"])) : ae("", !0),
          ye(ra, { "is-open": j(n) }, null, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["variant", "aria-controls"]),
      Ne(g("div", {
        id: `listbox-${j(s)}`,
        ref: "floating",
        style: w1([j(k)]),
        tabindex: "-1",
        class: "z-10 absolute bg-white min-w-max p-4 rounded-regular top-[calc(100%+8px)] shadow-[0px_4px_12px_rgba(0,0,0,0.15)] flex flex-col"
      }, [
        oe(y.$slots, "default"),
        y.hasDeleteButton ? (m(), he(b1, {
          key: 0,
          variant: "danger-basic",
          class: "bg-transparent! border-none! mt-2 self-end",
          size: "none",
          disabled: i.value,
          onClick: f
        }, {
          default: ue(() => [
            qe(_e(y.deleteButtonText), 1)
          ]),
          _: 1
        }, 8, ["disabled"])) : ae("", !0)
      ], 12, vd), [
        [L1, j(n)]
      ])
    ])), [
      [j(Ft), () => j(r)(!1)]
    ]);
  }
}), L0 = {
  Self: "_self",
  Blank: "_blank",
  Parent: "_parent",
  Top: "_top"
}, Rt = {
  Default: "default",
  Social: "social",
  Button: "button",
  FooterLegal: "footer legal",
  Outline: "outline",
  Clean: "clean"
}, bd = ["href", "target", "rel", "title", "data-test"], Ox = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "ExternalLink",
  props: {
    href: {},
    target: {},
    title: {},
    variant: {}
  },
  setup(t) {
    const e = t, a = F1(), o = Q(() => e.target === L0.Blank), n = {
      [Rt.Default]: ["text-secondary", "hover:text-secondary-dark"],
      [Rt.Social]: [
        "bg-primary",
        "hover:bg-primary-200",
        "text-onPrimary",
        "flex",
        "h-8",
        "items-center",
        "justify-center",
        "rounded-full",
        "w-8"
      ],
      [Rt.Button]: ["bg-primary", "hover:bg-primary-200", "rounded-xl", "px-4", "py-2", "text-white"],
      [Rt.FooterLegal]: [
        "opacity-40",
        "text-sm",
        "hover:underline",
        "whitespace-nowrap",
        "font-extralight"
      ],
      [Rt.Outline]: [
        "text-secondary",
        "border",
        "py-2",
        "px-3",
        "rounded-[20px]",
        "border-secondary",
        "hover:text-white",
        "hover:border-secondary-dark",
        "hover:bg-secondary"
      ],
      [Rt.Clean]: []
    }, r = Q(() => {
      const i = ["duration-300", "ease-in-out", "transition-colors"], l = e.variant ?? Rt.Default;
      return [...i, ...n[l]].join(" ");
    }), s = Q(() => g1(r.value, a.class));
    return (i, l) => (m(), C("a", {
      class: le(s.value),
      href: i.href,
      target: i.target ?? j(L0).Self,
      rel: o.value ? "noopener noreferrer" : void 0,
      title: i.title,
      role: "link",
      "data-test": j(a)["data-test"]
    }, [
      oe(i.$slots, "default")
    ], 10, bd));
  }
}), Nt = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
  H5: 5,
  H6: 6
}, kd = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Heading",
  props: {
    level: { default: Nt.H1 },
    border: { type: Boolean },
    align: { default: "left" }
  },
  setup(t) {
    const e = F1(), a = Q(() => {
      const { class: i, ...l } = e;
      return l;
    }), o = t, n = Q(() => (e.class ? e.class.split(" ") : []).filter((l) => l.startsWith("text-"))), s = Q(() => {
      let i;
      switch (o.level) {
        case Nt.H2:
        case Nt.H3:
        case Nt.H4:
        case Nt.H5:
        case Nt.H6:
          i = "text-base";
          break;
        case Nt.H1:
        default:
          i = "text-lg";
      }
      return i;
    });
    return (i, l) => (m(), C("div", Re(a.value, {
      class: j(g1)(
        "flex justify-between my-6",
        {
          "pb-4 border-b border-gray-400": i.border
        },
        i.$attrs.class ?? ""
      )
    }), [
      (m(), he(S1(`h${i.level}`), {
        class: le([
          "font-bold w-full",
          j(g1)([
            s.value,
            {
              "text-center": i.align === "center",
              "text-right": i.align === "right",
              "text-left": i.align === "left"
            },
            n.value
          ])
        ])
      }, {
        default: ue(() => [
          oe(i.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"])),
      oe(i.$slots, "right")
    ], 16));
  }
}), Cd = { class: "bg-gray-100 border-b border-grey-400 flex flex-row gap-x-4 items-center justify-between p-4" }, wd = ["title"], _d = { class: "flex flex-row gap-x-2 items-center shrink-0" }, Hd = { class: "text-black/60 text-sm uppercase" }, Fx = /* @__PURE__ */ J({
  __name: "FileBar",
  props: {
    file: {},
    deleteTitle: {},
    title: { default: void 0 }
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = Q(() => Fr.fileSize.toBytes(a.file.size));
    return (r, s) => (m(), C("div", Cd, [
      g("div", null, [
        r.title ? (m(), he(j(kd), {
          key: 0,
          level: 3,
          class: "m-0 pb-1 text-black"
        }, {
          default: ue(() => [
            qe(_e(r.title), 1)
          ]),
          _: 1
        })) : ae("", !0),
        g("p", {
          title: r.file.name,
          class: "first-letter:uppercase line-clamp-1 text-black text-sm"
        }, _e(r.file.name), 9, wd)
      ]),
      g("div", _d, [
        g("span", Hd, _e(n.value), 1),
        ye(j(Oe), {
          "aria-label": r.deleteTitle,
          viewbox: "0 0 24 24",
          width: "24",
          height: "24",
          title: r.deleteTitle,
          class: "cursor-pointer text-red",
          onClick: s[0] || (s[0] = (i) => o("remove"))
        }, {
          default: ue(() => [
            ye(j(Bi))
          ]),
          _: 1
        }, 8, ["aria-label", "title"])
      ])
    ]));
  }
}), lt = {
  Secondary: "secondary",
  Gray: "gray",
  Custom: "custom"
}, jd = (t) => ({
  [lt.Secondary]: {
    base: "bg-secondary-10 border-secondary max-w-md rounded-xl"
  },
  [lt.Gray]: {
    base: "bg-gray-100 border-gray-400 w-full"
  },
  [lt.Custom]: {
    base: ""
  }
})[t].base, Ld = {
  key: 1,
  class: "font-bold leading-snug"
}, xd = {
  key: 2,
  class: "text-black-light"
}, $d = { class: "flex flex-wrap gap-2 justify-center" }, Bx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "FileUpload",
  props: {
    variant: { default: lt.Secondary },
    title: { default: void 0 },
    hasDownload: { type: Boolean },
    orText: { default: void 0 },
    chooseFileText: { default: void 0 },
    downloadExampleText: { default: void 0 }
  },
  emits: ["click", "download"],
  setup(t) {
    const e = t, a = F1(), { class: o, ...n } = a, r = Q(() => {
      const s = jd(e.variant);
      return g1("border border-dashed flex flex-col gap-y-2 items-center p-8 text-center", s, o);
    });
    return (s, i) => (m(), C("div", Re({ class: r.value }, n), [
      s.variant !== j(lt).Custom ? (m(), he(j(Oe), {
        key: 0,
        size: j(et).Large,
        class: le({
          "text-secondary": s.variant === j(lt).Secondary,
          "rotate-180 text-primary": s.variant === j(lt).Gray
        })
      }, {
        default: ue(() => [
          s.variant === j(lt).Secondary ? (m(), he(j(L4), { key: 0 })) : ae("", !0),
          s.variant === j(lt).Gray ? (m(), he(j(z4), { key: 1 })) : ae("", !0)
        ]),
        _: 1
      }, 8, ["size", "class"])) : ae("", !0),
      s.title ? (m(), C("h3", Ld, _e(s.title), 1)) : ae("", !0),
      s.orText ? (m(), C("span", xd, _e(s.orText), 1)) : ae("", !0),
      g("div", $d, [
        s.chooseFileText ? (m(), he(b1, {
          key: 0,
          variant: s.variant === j(lt).Secondary ? "secondary-outline" : "secondary",
          onClick: i[0] || (i[0] = (l) => s.$emit("click"))
        }, {
          default: ue(() => [
            qe(_e(s.chooseFileText), 1)
          ]),
          _: 1
        }, 8, ["variant"])) : ae("", !0),
        s.hasDownload && s.downloadExampleText ? (m(), he(b1, {
          key: 1,
          variant: "secondary-outline",
          onClick: i[1] || (i[1] = (l) => s.$emit("download"))
        }, {
          default: ue(() => [
            qe(_e(s.downloadExampleText), 1)
          ]),
          _: 1
        })) : ae("", !0)
      ])
    ], 16));
  }
}), Md = { class: "flex flex-row gap-x-4 items-center justify-between" }, Vd = ["title"], Sd = { class: "flex flex-row gap-x-2 items-center shrink-0" }, Ad = { class: "text-black/60 text-sm uppercase" }, Ix = /* @__PURE__ */ J({
  __name: "FilledFileCard",
  props: {
    file: {},
    deleteTitle: {}
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = Q(() => Fr.fileSize.toBytes(a.file.size));
    return (r, s) => (m(), he(j(Ni), {
      "data-test": "filled-file-card",
      class: "p-3"
    }, {
      default: ue(() => [
        g("div", Md, [
          g("p", {
            title: r.file.name,
            class: "first-letter:uppercase line-clamp-1 text-black text-sm"
          }, _e(r.file.name), 9, Vd),
          g("div", Sd, [
            g("span", Ad, _e(n.value), 1),
            ye(j(Oe), {
              "aria-label": r.deleteTitle,
              viewbox: "0 0 24 24",
              width: "24",
              height: "24",
              title: r.deleteTitle,
              class: "cursor-pointer text-red",
              onClick: s[0] || (s[0] = (i) => o("remove", r.file))
            }, {
              default: ue(() => [
                ye(j(Bi))
              ]),
              _: 1
            }, 8, ["aria-label", "title"])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Zx = /* @__PURE__ */ J({
  __name: "Flag",
  props: {
    country: {}
  },
  setup(t) {
    const e = t, a = kn(), o = {
      nl: Rn,
      nl_nl: Rn,
      "nl-nl": Rn,
      be: Fa,
      nl_be: Fa,
      "nl-be": Fa,
      fr: Zn,
      fr_fr: Zn,
      "fr-fr": Zn,
      fr_be: Fa,
      "fr-be": Fa,
      de: Un,
      de_de: Un,
      "de-de": Un,
      it: qn,
      it_it: qn,
      "it-it": qn,
      en: ho,
      gb: ho,
      en_gb: ho,
      "en-gb": ho,
      es: Nn,
      es_es: Nn,
      "es-es": Nn
    }, n = () => {
      const r = e.country.toLowerCase();
      return o[r];
    };
    return Ue(
      () => e.country,
      () => {
        a.value = n();
      },
      {
        immediate: !0
      }
    ), (r, s) => a.value ? (m(), he(Oe, {
      key: 0,
      size: j(et).Medium
    }, {
      default: ue(() => [
        (m(), he(S1(a.value)))
      ]),
      _: 1
    }, 8, ["size"])) : ae("", !0);
  }
}), Ed = ["aria-checked", "aria-labelledby", "aria-disabled", "onKeydown"], Dd = { class: "flex flex-row items-center min-h-[24px]" }, Pd = /* @__PURE__ */ J({
  __name: "Checkbox",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    labelledBy: { default: void 0 }
  }, {
    modelValue: { type: Boolean, required: !1, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = e1(t, "modelValue"), o = () => {
      e.disabled || (a.value = !a.value);
    };
    return (n, r) => (m(), C("div", {
      role: "checkbox",
      "aria-checked": a.value,
      "aria-labelledby": n.labelledBy,
      "aria-disabled": n.disabled ? !0 : void 0,
      tabindex: "0",
      class: "cursor-pointer",
      onClick: o,
      onKeydown: Ae($e(o, ["exact"]), ["space"])
    }, [
      g("div", Dd, [
        g("div", {
          class: le(["aspect-square border h-4 inline-block mr-2 relative rounded-sm", {
            "bg-gray-300 border-gray-500": n.disabled,
            "bg-secondary-100 border-secondary-100": a.value && !n.disabled,
            "bg-white": !a.value && !n.disabled,
            "border-red": !n.isValid,
            "border-gray": n.isValid
          }])
        }, [
          a.value ? (m(), he(Oe, {
            key: 0,
            width: "10",
            height: "8",
            viewbox: "0 0 10 8",
            class: le(["absolute left-[2px] top-[3px]", {
              "text-gray-800": n.disabled,
              "text-white": !n.disabled
            }])
          }, {
            default: ue(() => [
              ye(Eu)
            ]),
            _: 1
          }, 8, ["class"])) : ae("", !0)
        ], 2),
        oe(n.$slots, "default")
      ])
    ], 40, Ed));
  }
}), Lt = {
  Vertical: "vertical",
  Horizontal: "horizontal"
}, zd = { class: "w-full" }, Td = ["id"], Od = ["aria-labelledby"], Fd = /* @__PURE__ */ J({
  __name: "CheckboxGroup",
  props: /* @__PURE__ */ Ye({
    name: {},
    options: {},
    disabled: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    label: { default: void 0 },
    labelledBy: { default: void 0 },
    alignment: { default: Lt.Vertical }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const { watchResize: e } = zi(), a = t, o = Q(() => i.value === Lt.Horizontal), n = Q(() => i.value === Lt.Vertical), r = e1(t, "modelValue"), s = Wl("checkboxGroup"), i = me(a.alignment), l = (y) => r.value?.includes(y), f = (y) => a.disabled || y.disabled, u = (y, b) => {
      const M = Array.isArray(r.value) ? r.value : [], c = b ? [...M, y] : M.filter((p) => p !== y);
      r.value = c;
    }, d = async () => {
      if (a.alignment === Lt.Vertical) {
        i.value = Lt.Vertical;
        return;
      }
      const y = s.value;
      if (k(y)) {
        i.value = Lt.Vertical;
        return;
      }
      i.value = Lt.Horizontal, await p1(), k(y) && (i.value = Lt.Vertical);
    }, k = (y) => y.scrollWidth > y.clientWidth;
    return Ue(
      [() => a.alignment, () => a.options, () => r.value],
      () => {
        d();
      },
      {
        deep: !0
      }
    ), h1(() => {
      e(() => {
        d();
      });
    }), (y, b) => (m(), C("div", zd, [
      y.label && !y.labelledBy ? (m(), C("label", {
        key: 0,
        id: `checkbox-group-${y.name}-aria-label`
      }, _e(y.label), 9, Td)) : ae("", !0),
      g("ul", {
        ref_key: "checkboxGroup",
        ref: s,
        role: "group",
        "aria-labelledby": y.labelledBy ? y.labelledBy : `checkbox-group-${y.name}-aria-label`,
        class: le(["flex border rounded-[10px] w-full", {
          "flex-row": o.value,
          "flex-col": n.value
        }])
      }, [
        (m(!0), C(ge, null, De(y.options, (M) => (m(), C("li", {
          key: M.value,
          class: le(["flex gap-2 px-4 py-2 last:border-none", {
            "border-r flex-1 whitespace-nowrap": o.value,
            "border-b": n.value
          }])
        }, [
          ye(Pd, {
            "model-value": l(M.value),
            "is-valid": y.isValid,
            disabled: f(M),
            "onUpdate:modelValue": (c) => u(M.value, c)
          }, {
            default: ue(() => [
              M?.icon ? oe(y.$slots, "icon", {
                key: 0,
                option: M
              }) : ae("", !0),
              qe(" " + _e(M.label) + " ", 1),
              oe(y.$slots, "default", { option: M })
            ]),
            _: 2
          }, 1032, ["model-value", "is-valid", "disabled", "onUpdate:modelValue"]),
          oe(y.$slots, "right", { option: M })
        ], 2))), 128))
      ], 10, Od)
    ]));
  }
}), Bd = ["id", "placeholder"], Id = { class: "border-l flex items-center px-4" }, Zd = ["id"], Rd = /* @__PURE__ */ J({
  __name: "ColorInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    placeholder: { default: "0f5c47" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = (i) => {
      let l = i;
      return l && !l.startsWith("#") && (l = `#${l}`), l.split("").splice(0, 7).join("");
    }, a = e1(t, "modelValue"), o = Q({
      get() {
        return e(a.value);
      },
      set(i) {
        a.value = e(i);
      }
    }), n = Q({
      get() {
        return a.value === "" ? "#0f5c47" : e(a.value);
      },
      set(i) {
        a.value = e(i);
      }
    }), [r, s] = ht(!1);
    return (i, l) => (m(), C("div", {
      class: le(["border flex outline-hidden overflow-hidden ring-blue-600 rounded-full w-full", {
        "ring-2": j(r)
      }])
    }, [
      Ne(g("input", {
        id: i.name,
        "onUpdate:modelValue": l[0] || (l[0] = (f) => o.value = f),
        class: "flex-1 outline-hidden px-3 py-2 rounded-l-full",
        type: "text",
        placeholder: i.placeholder,
        onFocus: l[1] || (l[1] = () => j(s)(!0)),
        onBlur: l[2] || (l[2] = () => j(s)(!1))
      }, null, 40, Bd), [
        [_a, o.value]
      ]),
      g("div", Id, [
        Ne(g("input", {
          id: `${i.name}-swatch`,
          "onUpdate:modelValue": l[3] || (l[3] = (f) => n.value = f),
          "data-test": "color-input-swatch",
          class: "appearance-none border-none h-6 p-0 rounded-full w-6",
          type: "color",
          onFocus: l[4] || (l[4] = () => j(s)(!0)),
          onBlur: l[5] || (l[5] = () => j(s)(!1))
        }, null, 40, Zd), [
          [_a, n.value]
        ])
      ])
    ], 2));
  }
}), Rx = /* @__PURE__ */ se(Rd, [["__scopeId", "data-v-5f376928"]]), Nd = { class: "flex items-center px-3 py-[.375rem]" }, qd = ["id", "value", "name"], Nx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "CurrencyInput",
  props: {
    modelValue: {},
    name: {},
    isValid: { type: Boolean, default: !0 },
    wrapperClass: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const {
      currency: { format: a }
    } = Fr, o = t, n = e, r = (l) => {
      l = l?.trim() ?? "";
      const f = Math.max(l.lastIndexOf("."), l.lastIndexOf(","));
      if (f >= 0) {
        let d = l.substring(0, f), k = l.substring(f + 1);
        return d = d.replace(/[.,]/g, ""), k.length < 2 ? k = k.padEnd(2, "0") : k.length > 2 && (k = k.substring(0, 2)), parseInt(d + k);
      }
      return parseInt(l.replace(/[.,]/g, ""));
    }, s = (l) => {
      const f = l.target;
      let { value: u } = f;
      u || (u = "0"), !u.includes(",") && !u.includes(".") && (u += ".00"), n("update:modelValue", r(u));
    }, i = Q(() => {
      const l = r(o.modelValue?.toString());
      return isNaN(l) ? "" : a(l, {
        currencyDisplay: "code"
      }).slice(4);
    });
    return (l, f) => (m(), C("div", {
      class: le([[{ "border-red": !l.isValid }, { "bg-gray-200 text-gray-800": l.$attrs.disabled }, l.wrapperClass], "border flex outline-hidden overflow-hidden rounded-xl"])
    }, [
      g("span", Nd, [
        ye(j(Oe), { class: "text-secondary" }, {
          default: ue(() => [
            ye(j(p6))
          ]),
          _: 1
        })
      ]),
      g("input", Re(l.$attrs, {
        id: l.name,
        value: i.value,
        name: l.name,
        type: "text",
        class: "outline-hidden placeholder-gray-800 py-[.375rem] w-full",
        onBlur: s
      }), null, 16, qd)
    ], 2));
  }
}), qi = 6048e5, Ud = 864e5, Yd = 6e4, Ui = 36e5, Wd = 1e3, x0 = Symbol.for("constructDateFrom");
function Je(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && x0 in t ? t[x0](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Se(t, e) {
  return Je(e || t, t);
}
function q1(t, e, a) {
  const o = Se(t, a?.in);
  return isNaN(e) ? Je(a?.in || t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function tt(t, e, a) {
  const o = Se(t, a?.in);
  if (isNaN(e)) return Je(t, NaN);
  if (!e)
    return o;
  const n = o.getDate(), r = Je(t, o.getTime());
  r.setMonth(o.getMonth() + e + 1, 0);
  const s = r.getDate();
  return n >= s ? r : (o.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    n
  ), o);
}
function Yi(t, e, a) {
  const {
    years: o = 0,
    months: n = 0,
    weeks: r = 0,
    days: s = 0,
    hours: i = 0,
    minutes: l = 0,
    seconds: f = 0
  } = e, u = Se(t, a?.in), d = n || o ? tt(u, n + o * 12) : u, k = s || r ? q1(d, s + r * 7) : d, y = l + i * 60, M = (f + y * 60) * 1e3;
  return Je(t, +k + M);
}
function Kd(t, e, a) {
  return Je(t, +Se(t) + e);
}
function Gd(t, e, a) {
  return Kd(t, e * Ui);
}
let Xd = {};
function sa() {
  return Xd;
}
function at(t, e) {
  const a = sa(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, n = Se(t, e?.in), r = n.getDay(), s = (r < o ? 7 : 0) + r - o;
  return n.setDate(n.getDate() - s), n.setHours(0, 0, 0, 0), n;
}
function Ha(t, e) {
  return at(t, { ...e, weekStartsOn: 1 });
}
function Wi(t, e) {
  const a = Se(t, e?.in), o = a.getFullYear(), n = Je(a, 0);
  n.setFullYear(o + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const r = Ha(n), s = Je(a, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Ha(s);
  return a.getTime() >= r.getTime() ? o + 1 : a.getTime() >= i.getTime() ? o : o - 1;
}
function un(t) {
  const e = Se(t), a = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return a.setUTCFullYear(e.getFullYear()), +t - +a;
}
function io(t, ...e) {
  const a = Je.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(a);
}
function $0(t, e) {
  const a = Se(t, e?.in);
  return a.setHours(0, 0, 0, 0), a;
}
function Ki(t, e, a) {
  const [o, n] = io(
    a?.in,
    t,
    e
  ), r = $0(o), s = $0(n), i = +r - un(r), l = +s - un(s);
  return Math.round((i - l) / Ud);
}
function Qd(t, e) {
  const a = Wi(t, e), o = Je(t, 0);
  return o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0), Ha(o);
}
function Jd(t, e, a) {
  return tt(t, e * 3, a);
}
function Zr(t, e, a) {
  return tt(t, e * 12, a);
}
function M0(t, e) {
  const a = +Se(t) - +Se(e);
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function Gi(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Ga(t) {
  return !(!Gi(t) && typeof t != "number" || isNaN(+Se(t)));
}
function V0(t, e) {
  const a = Se(t, e?.in);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function em(t, e, a) {
  const [o, n] = io(
    a?.in,
    t,
    e
  );
  return o.getFullYear() - n.getFullYear();
}
function tm(t, e, a) {
  const [o, n] = io(
    a?.in,
    t,
    e
  ), r = M0(o, n), s = Math.abs(em(o, n));
  o.setFullYear(1584), n.setFullYear(1584);
  const i = M0(o, n) === -r, l = r * (s - +i);
  return l === 0 ? 0 : l;
}
function Xi(t, e) {
  const [a, o] = io(t, e.start, e.end);
  return { start: a, end: o };
}
function Qi(t, e) {
  const { start: a, end: o } = Xi(e?.in, t);
  let n = +a > +o;
  const r = n ? +a : +o, s = n ? o : a;
  s.setHours(0, 0, 0, 0);
  let i = 1;
  const l = [];
  for (; +s <= r; )
    l.push(Je(a, s)), s.setDate(s.getDate() + i), s.setHours(0, 0, 0, 0);
  return n ? l.reverse() : l;
}
function Gt(t, e) {
  const a = Se(t, e?.in), o = a.getMonth(), n = o - o % 3;
  return a.setMonth(n, 1), a.setHours(0, 0, 0, 0), a;
}
function am(t, e) {
  const { start: a, end: o } = Xi(e?.in, t);
  let n = +a > +o;
  const r = n ? +Gt(a) : +Gt(o);
  let s = Gt(n ? o : a), i = 1;
  const l = [];
  for (; +s <= r; )
    l.push(Je(a, s)), s = Jd(s, i);
  return n ? l.reverse() : l;
}
function om(t, e) {
  const a = Se(t, e?.in);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function Ji(t, e) {
  const a = Se(t, e?.in), o = a.getFullYear();
  return a.setFullYear(o + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function Ja(t, e) {
  const a = Se(t, e?.in);
  return a.setFullYear(a.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function e2(t, e) {
  const a = sa(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, n = Se(t, e?.in), r = n.getDay(), s = (r < o ? -7 : 0) + 6 - (r - o);
  return n.setDate(n.getDate() + s), n.setHours(23, 59, 59, 999), n;
}
function S0(t, e) {
  const a = Se(t, e?.in), o = a.getMonth(), n = o - o % 3 + 3;
  return a.setMonth(n, 0), a.setHours(23, 59, 59, 999), a;
}
const nm = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, rm = (t, e, a) => {
  let o;
  const n = nm[t];
  return typeof n == "string" ? o = n : e === 1 ? o = n.one : o = n.other.replace("{{count}}", e.toString()), a?.addSuffix ? a.comparison && a.comparison > 0 ? "in " + o : o + " ago" : o;
};
function er(t) {
  return (e = {}) => {
    const a = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[a] || t.formats[t.defaultWidth];
  };
}
const sm = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, im = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, lm = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, um = {
  date: er({
    formats: sm,
    defaultWidth: "full"
  }),
  time: er({
    formats: im,
    defaultWidth: "full"
  }),
  dateTime: er({
    formats: lm,
    defaultWidth: "full"
  })
}, cm = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dm = (t, e, a, o) => cm[t];
function Ia(t) {
  return (e, a) => {
    const o = a?.context ? String(a.context) : "standalone";
    let n;
    if (o === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, i = a?.width ? String(a.width) : s;
      n = t.formattingValues[i] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, i = a?.width ? String(a.width) : t.defaultWidth;
      n = t.values[i] || t.values[s];
    }
    const r = t.argumentCallback ? t.argumentCallback(e) : e;
    return n[r];
  };
}
const mm = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, fm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, hm = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, gm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ym = (t, e) => {
  const a = Number(t), o = a % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, bm = {
  ordinalNumber: ym,
  era: Ia({
    values: mm,
    defaultWidth: "wide"
  }),
  quarter: Ia({
    values: pm,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Ia({
    values: fm,
    defaultWidth: "wide"
  }),
  day: Ia({
    values: hm,
    defaultWidth: "wide"
  }),
  dayPeriod: Ia({
    values: vm,
    defaultWidth: "wide",
    formattingValues: gm,
    defaultFormattingWidth: "wide"
  })
};
function Za(t) {
  return (e, a = {}) => {
    const o = a.width, n = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], r = e.match(n);
    if (!r)
      return null;
    const s = r[0], i = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(i) ? Cm(i, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      km(i, (d) => d.test(s))
    );
    let f;
    f = t.valueCallback ? t.valueCallback(l) : l, f = a.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      a.valueCallback(f)
    ) : f;
    const u = e.slice(s.length);
    return { value: f, rest: u };
  };
}
function km(t, e) {
  for (const a in t)
    if (Object.prototype.hasOwnProperty.call(t, a) && e(t[a]))
      return a;
}
function Cm(t, e) {
  for (let a = 0; a < t.length; a++)
    if (e(t[a]))
      return a;
}
function wm(t) {
  return (e, a = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const n = o[0], r = e.match(t.parsePattern);
    if (!r) return null;
    let s = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    s = a.valueCallback ? a.valueCallback(s) : s;
    const i = e.slice(n.length);
    return { value: s, rest: i };
  };
}
const _m = /^(\d+)(th|st|nd|rd)?/i, Hm = /\d+/i, jm = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Lm = {
  any: [/^b/i, /^(a|c)/i]
}, xm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, $m = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Vm = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Sm = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Am = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Em = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Dm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Pm = {
  ordinalNumber: wm({
    matchPattern: _m,
    parsePattern: Hm,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Za({
    matchPatterns: jm,
    defaultMatchWidth: "wide",
    parsePatterns: Lm,
    defaultParseWidth: "any"
  }),
  quarter: Za({
    matchPatterns: xm,
    defaultMatchWidth: "wide",
    parsePatterns: $m,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Za({
    matchPatterns: Mm,
    defaultMatchWidth: "wide",
    parsePatterns: Vm,
    defaultParseWidth: "any"
  }),
  day: Za({
    matchPatterns: Sm,
    defaultMatchWidth: "wide",
    parsePatterns: Am,
    defaultParseWidth: "any"
  }),
  dayPeriod: Za({
    matchPatterns: Em,
    defaultMatchWidth: "any",
    parsePatterns: Dm,
    defaultParseWidth: "any"
  })
}, t2 = {
  code: "en-US",
  formatDistance: rm,
  formatLong: um,
  formatRelative: dm,
  localize: bm,
  match: Pm,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function zm(t, e) {
  const a = Se(t, e?.in);
  return Ki(a, Ja(a)) + 1;
}
function Rr(t, e) {
  const a = Se(t, e?.in), o = +Ha(a) - +Qd(a);
  return Math.round(o / qi) + 1;
}
function Nr(t, e) {
  const a = Se(t, e?.in), o = a.getFullYear(), n = sa(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, s = Je(e?.in || t, 0);
  s.setFullYear(o + 1, 0, r), s.setHours(0, 0, 0, 0);
  const i = at(s, e), l = Je(e?.in || t, 0);
  l.setFullYear(o, 0, r), l.setHours(0, 0, 0, 0);
  const f = at(l, e);
  return +a >= +i ? o + 1 : +a >= +f ? o : o - 1;
}
function Tm(t, e) {
  const a = sa(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, n = Nr(t, e), r = Je(e?.in || t, 0);
  return r.setFullYear(n, 0, o), r.setHours(0, 0, 0, 0), at(r, e);
}
function qr(t, e) {
  const a = Se(t, e?.in), o = +at(a, e) - +Tm(a, e);
  return Math.round(o / qi) + 1;
}
function Qe(t, e) {
  const a = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return a + o;
}
const xt = {
  // Year
  y(t, e) {
    const a = t.getFullYear(), o = a > 0 ? a : 1 - a;
    return Qe(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const a = t.getMonth();
    return e === "M" ? String(a + 1) : Qe(a + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Qe(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Qe(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Qe(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Qe(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Qe(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const a = e.length, o = t.getMilliseconds(), n = Math.trunc(
      o * Math.pow(10, a - 3)
    );
    return Qe(n, e.length);
  }
}, ca = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, A0 = {
  // Era
  G: function(t, e, a) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return a.era(o, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return a.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, a) {
    if (e === "yo") {
      const o = t.getFullYear(), n = o > 0 ? o : 1 - o;
      return a.ordinalNumber(n, { unit: "year" });
    }
    return xt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, a, o) {
    const n = Nr(t, o), r = n > 0 ? n : 1 - n;
    if (e === "YY") {
      const s = r % 100;
      return Qe(s, 2);
    }
    return e === "Yo" ? a.ordinalNumber(r, { unit: "year" }) : Qe(r, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const a = Wi(t);
    return Qe(a, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const a = t.getFullYear();
    return Qe(a, e.length);
  },
  // Quarter
  Q: function(t, e, a) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return Qe(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return a.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, a) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return Qe(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return a.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, a) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return xt.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return a.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return a.month(o, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return a.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, a) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return Qe(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return a.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return a.month(o, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return a.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, a, o) {
    const n = qr(t, o);
    return e === "wo" ? a.ordinalNumber(n, { unit: "week" }) : Qe(n, e.length);
  },
  // ISO week of year
  I: function(t, e, a) {
    const o = Rr(t);
    return e === "Io" ? a.ordinalNumber(o, { unit: "week" }) : Qe(o, e.length);
  },
  // Day of the month
  d: function(t, e, a) {
    return e === "do" ? a.ordinalNumber(t.getDate(), { unit: "date" }) : xt.d(t, e);
  },
  // Day of year
  D: function(t, e, a) {
    const o = zm(t);
    return e === "Do" ? a.ordinalNumber(o, { unit: "dayOfYear" }) : Qe(o, e.length);
  },
  // Day of week
  E: function(t, e, a) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return a.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return a.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, a, o) {
    const n = t.getDay(), r = (n - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(r);
      // Padded numerical value
      case "ee":
        return Qe(r, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return a.ordinalNumber(r, { unit: "day" });
      case "eee":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, a, o) {
    const n = t.getDay(), r = (n - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(r);
      // Padded numerical value
      case "cc":
        return Qe(r, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return a.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return a.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return a.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(n, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return a.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, a) {
    const o = t.getDay(), n = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(n);
      // 02
      case "ii":
        return Qe(n, e.length);
      // 2nd
      case "io":
        return a.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return a.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return a.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return a.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return a.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, a) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, a) {
    const o = t.getHours();
    let n;
    switch (o === 12 ? n = ca.noon : o === 0 ? n = ca.midnight : n = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, a) {
    const o = t.getHours();
    let n;
    switch (o >= 17 ? n = ca.evening : o >= 12 ? n = ca.afternoon : o >= 4 ? n = ca.morning : n = ca.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, a) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), a.ordinalNumber(o, { unit: "hour" });
    }
    return xt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, a) {
    return e === "Ho" ? a.ordinalNumber(t.getHours(), { unit: "hour" }) : xt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, a) {
    const o = t.getHours() % 12;
    return e === "Ko" ? a.ordinalNumber(o, { unit: "hour" }) : Qe(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, a) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? a.ordinalNumber(o, { unit: "hour" }) : Qe(o, e.length);
  },
  // Minute
  m: function(t, e, a) {
    return e === "mo" ? a.ordinalNumber(t.getMinutes(), { unit: "minute" }) : xt.m(t, e);
  },
  // Second
  s: function(t, e, a) {
    return e === "so" ? a.ordinalNumber(t.getSeconds(), { unit: "second" }) : xt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return xt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, a) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return D0(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Wt(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Wt(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, a) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return D0(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Wt(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Wt(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, a) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + E0(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Wt(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, a) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + E0(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Wt(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, a) {
    const o = Math.trunc(+t / 1e3);
    return Qe(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, a) {
    return Qe(+t, e.length);
  }
};
function E0(t, e = "") {
  const a = t > 0 ? "-" : "+", o = Math.abs(t), n = Math.trunc(o / 60), r = o % 60;
  return r === 0 ? a + String(n) : a + String(n) + e + Qe(r, 2);
}
function D0(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Qe(Math.abs(t) / 60, 2) : Wt(t, e);
}
function Wt(t, e = "") {
  const a = t > 0 ? "-" : "+", o = Math.abs(t), n = Qe(Math.trunc(o / 60), 2), r = Qe(o % 60, 2);
  return a + n + e + r;
}
const P0 = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, a2 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Om = (t, e) => {
  const a = t.match(/(P+)(p+)?/) || [], o = a[1], n = a[2];
  if (!n)
    return P0(t, e);
  let r;
  switch (o) {
    case "P":
      r = e.dateTime({ width: "short" });
      break;
    case "PP":
      r = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = e.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", P0(o, e)).replace("{{time}}", a2(n, e));
}, jr = {
  p: a2,
  P: Om
}, Fm = /^D+$/, Bm = /^Y+$/, Im = ["D", "DD", "YY", "YYYY"];
function o2(t) {
  return Fm.test(t);
}
function n2(t) {
  return Bm.test(t);
}
function Lr(t, e, a) {
  const o = Zm(t, e, a);
  if (console.warn(o), Im.includes(t)) throw new RangeError(o);
}
function Zm(t, e, a) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${a}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Rm = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Nm = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qm = /^'([^]*?)'?$/, Um = /''/g, Ym = /[a-zA-Z]/;
function pt(t, e, a) {
  const o = sa(), n = a?.locale ?? o.locale ?? t2, r = a?.firstWeekContainsDate ?? a?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, i = Se(t, a?.in);
  if (!Ga(i))
    throw new RangeError("Invalid time value");
  let l = e.match(Nm).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const k = jr[d];
      return k(u, n.formatLong);
    }
    return u;
  }).join("").match(Rm).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: Wm(u) };
    if (A0[d])
      return { isToken: !0, value: u };
    if (d.match(Ym))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  n.localize.preprocessor && (l = n.localize.preprocessor(i, l));
  const f = {
    firstWeekContainsDate: r,
    weekStartsOn: s,
    locale: n
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!a?.useAdditionalWeekYearTokens && n2(d) || !a?.useAdditionalDayOfYearTokens && o2(d)) && Lr(d, e, String(t));
    const k = A0[d[0]];
    return k(i, d, n.localize, f);
  }).join("");
}
function Wm(t) {
  const e = t.match(qm);
  return e ? e[1].replace(Um, "'") : t;
}
function Km(t, e) {
  return Se(t, e?.in).getDay();
}
function Gm(t, e) {
  const a = Se(t, e?.in), o = a.getFullYear(), n = a.getMonth(), r = Je(a, 0);
  return r.setFullYear(o, n + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function Xm() {
  return Object.assign({}, sa());
}
function wt(t, e) {
  return Se(t, e?.in).getHours();
}
function Qm(t, e) {
  const a = Se(t, e?.in).getDay();
  return a === 0 ? 7 : a;
}
function Tt(t, e) {
  return Se(t, e?.in).getMinutes();
}
function Be(t, e) {
  return Se(t, e?.in).getMonth();
}
function ja(t) {
  return Se(t).getSeconds();
}
function Ee(t, e) {
  return Se(t, e?.in).getFullYear();
}
function aa(t, e) {
  return +Se(t) > +Se(e);
}
function La(t, e) {
  return +Se(t) < +Se(e);
}
function ba(t, e) {
  return +Se(t) == +Se(e);
}
function Jm(t, e) {
  const a = ep(e) ? new e(0) : Je(e, 0);
  return a.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), a.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), a;
}
function ep(t) {
  return typeof t == "function" && t.prototype?.constructor === t;
}
const tp = 10;
class r2 {
  subPriority = 0;
  validate(e, a) {
    return !0;
  }
}
class ap extends r2 {
  constructor(e, a, o, n, r) {
    super(), this.value = e, this.validateValue = a, this.setValue = o, this.priority = n, r && (this.subPriority = r);
  }
  validate(e, a) {
    return this.validateValue(e, this.value, a);
  }
  set(e, a, o) {
    return this.setValue(e, a, this.value, o);
  }
}
class op extends r2 {
  priority = tp;
  subPriority = -1;
  constructor(e, a) {
    super(), this.context = e || ((o) => Je(a, o));
  }
  set(e, a) {
    return a.timestampIsSet ? e : Je(e, Jm(e, this.context));
  }
}
class Ge {
  run(e, a, o, n) {
    const r = this.parse(e, a, o, n);
    return r ? {
      setter: new ap(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(e, a, o) {
    return !0;
  }
}
class np extends Ge {
  priority = 140;
  parse(e, a, o) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return o.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(e, { width: "wide" }) || o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
    }
  }
  set(e, a, o) {
    return a.era = o, e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const d1 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ct = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function m1(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function s1(t, e) {
  const a = e.match(t);
  return a ? {
    value: parseInt(a[0], 10),
    rest: e.slice(a[0].length)
  } : null;
}
function dt(t, e) {
  const a = e.match(t);
  if (!a)
    return null;
  if (a[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const o = a[1] === "+" ? 1 : -1, n = a[2] ? parseInt(a[2], 10) : 0, r = a[3] ? parseInt(a[3], 10) : 0, s = a[5] ? parseInt(a[5], 10) : 0;
  return {
    value: o * (n * Ui + r * Yd + s * Wd),
    rest: e.slice(a[0].length)
  };
}
function s2(t) {
  return s1(d1.anyDigitsSigned, t);
}
function l1(t, e) {
  switch (t) {
    case 1:
      return s1(d1.singleDigit, e);
    case 2:
      return s1(d1.twoDigits, e);
    case 3:
      return s1(d1.threeDigits, e);
    case 4:
      return s1(d1.fourDigits, e);
    default:
      return s1(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function cn(t, e) {
  switch (t) {
    case 1:
      return s1(d1.singleDigitSigned, e);
    case 2:
      return s1(d1.twoDigitsSigned, e);
    case 3:
      return s1(d1.threeDigitsSigned, e);
    case 4:
      return s1(d1.fourDigitsSigned, e);
    default:
      return s1(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Ur(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function i2(t, e) {
  const a = e > 0, o = a ? e : 1 - e;
  let n;
  if (o <= 50)
    n = t || 100;
  else {
    const r = o + 50, s = Math.trunc(r / 100) * 100, i = t >= r % 100;
    n = t + s - (i ? 100 : 0);
  }
  return a ? n : 1 - n;
}
function l2(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class rp extends Ge {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(e, a, o) {
    const n = (r) => ({
      year: r,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return m1(l1(4, e), n);
      case "yo":
        return m1(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          n
        );
      default:
        return m1(l1(a.length, e), n);
    }
  }
  validate(e, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(e, a, o) {
    const n = e.getFullYear();
    if (o.isTwoDigitYear) {
      const s = i2(
        o.year,
        n
      );
      return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const r = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class sp extends Ge {
  priority = 130;
  parse(e, a, o) {
    const n = (r) => ({
      year: r,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return m1(l1(4, e), n);
      case "Yo":
        return m1(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          n
        );
      default:
        return m1(l1(a.length, e), n);
    }
  }
  validate(e, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(e, a, o, n) {
    const r = Nr(e, n);
    if (o.isTwoDigitYear) {
      const i = i2(
        o.year,
        r
      );
      return e.setFullYear(
        i,
        0,
        n.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), at(e, n);
    }
    const s = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(s, 0, n.firstWeekContainsDate), e.setHours(0, 0, 0, 0), at(e, n);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class ip extends Ge {
  priority = 130;
  parse(e, a) {
    return cn(a === "R" ? 4 : a.length, e);
  }
  set(e, a, o) {
    const n = Je(e, 0);
    return n.setFullYear(o, 0, 4), n.setHours(0, 0, 0, 0), Ha(n);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class lp extends Ge {
  priority = 130;
  parse(e, a) {
    return cn(a === "u" ? 4 : a.length, e);
  }
  set(e, a, o) {
    return e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class up extends Ge {
  priority = 120;
  parse(e, a, o) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return l1(a.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 4;
  }
  set(e, a, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class cp extends Ge {
  priority = 120;
  parse(e, a, o) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return l1(a.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 4;
  }
  set(e, a, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class dp extends Ge {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(e, a, o) {
    const n = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return m1(
          s1(d1.month, e),
          n
        );
      // 01, 02, ..., 12
      case "MM":
        return m1(l1(2, e), n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return m1(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          n
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return o.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(e, { width: "wide", context: "formatting" }) || o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 11;
  }
  set(e, a, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class mp extends Ge {
  priority = 110;
  parse(e, a, o) {
    const n = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return m1(
          s1(d1.month, e),
          n
        );
      // 01, 02, ..., 12
      case "LL":
        return m1(l1(2, e), n);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return m1(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          n
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return o.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(e, { width: "wide", context: "standalone" }) || o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 11;
  }
  set(e, a, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function pp(t, e, a) {
  const o = Se(t, a?.in), n = qr(o, a) - e;
  return o.setDate(o.getDate() - n * 7), Se(o, a?.in);
}
class fp extends Ge {
  priority = 100;
  parse(e, a, o) {
    switch (a) {
      case "w":
        return s1(d1.week, e);
      case "wo":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 53;
  }
  set(e, a, o, n) {
    return at(pp(e, o, n), n);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function hp(t, e, a) {
  const o = Se(t, a?.in), n = Rr(o, a) - e;
  return o.setDate(o.getDate() - n * 7), o;
}
class vp extends Ge {
  priority = 100;
  parse(e, a, o) {
    switch (a) {
      case "I":
        return s1(d1.week, e);
      case "Io":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 53;
  }
  set(e, a, o) {
    return Ha(hp(e, o));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const gp = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], yp = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class bp extends Ge {
  priority = 90;
  subPriority = 1;
  parse(e, a, o) {
    switch (a) {
      case "d":
        return s1(d1.date, e);
      case "do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    const o = e.getFullYear(), n = l2(o), r = e.getMonth();
    return n ? a >= 1 && a <= yp[r] : a >= 1 && a <= gp[r];
  }
  set(e, a, o) {
    return e.setDate(o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class kp extends Ge {
  priority = 90;
  subpriority = 1;
  parse(e, a, o) {
    switch (a) {
      case "D":
      case "DD":
        return s1(d1.dayOfYear, e);
      case "Do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    const o = e.getFullYear();
    return l2(o) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(e, a, o) {
    return e.setMonth(0, o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function Yr(t, e, a) {
  const o = sa(), n = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, r = Se(t, a?.in), s = r.getDay(), l = (e % 7 + 7) % 7, f = 7 - n, u = e < 0 || e > 6 ? e - (s + f) % 7 : (l + f) % 7 - (s + f) % 7;
  return q1(r, u, a);
}
class Cp extends Ge {
  priority = 90;
  parse(e, a, o) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 6;
  }
  set(e, a, o, n) {
    return e = Yr(e, o, n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class wp extends Ge {
  priority = 90;
  parse(e, a, o, n) {
    const r = (s) => {
      const i = Math.floor((s - 1) / 7) * 7;
      return (s + n.weekStartsOn + 6) % 7 + i;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return m1(l1(a.length, e), r);
      // 3rd
      case "eo":
        return m1(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 6;
  }
  set(e, a, o, n) {
    return e = Yr(e, o, n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class _p extends Ge {
  priority = 90;
  parse(e, a, o, n) {
    const r = (s) => {
      const i = Math.floor((s - 1) / 7) * 7;
      return (s + n.weekStartsOn + 6) % 7 + i;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return m1(l1(a.length, e), r);
      // 3rd
      case "co":
        return m1(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return o.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return o.day(e, { width: "wide", context: "standalone" }) || o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 6;
  }
  set(e, a, o, n) {
    return e = Yr(e, o, n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function Hp(t, e, a) {
  const o = Se(t, a?.in), n = Qm(o, a), r = e - n;
  return q1(o, r, a);
}
class jp extends Ge {
  priority = 90;
  parse(e, a, o) {
    const n = (r) => r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return l1(a.length, e);
      // 2nd
      case "io":
        return o.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return m1(
          o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      // T
      case "iiiii":
        return m1(
          o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      // Tu
      case "iiiiii":
        return m1(
          o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
      // Tuesday
      case "iiii":
      default:
        return m1(
          o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          n
        );
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 7;
  }
  set(e, a, o) {
    return e = Hp(e, o), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Lp extends Ge {
  priority = 80;
  parse(e, a, o) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, a, o) {
    return e.setHours(Ur(o), 0, 0, 0), e;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class xp extends Ge {
  priority = 80;
  parse(e, a, o) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, a, o) {
    return e.setHours(Ur(o), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class $p extends Ge {
  priority = 80;
  parse(e, a, o) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, a, o) {
    return e.setHours(Ur(o), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class Mp extends Ge {
  priority = 70;
  parse(e, a, o) {
    switch (a) {
      case "h":
        return s1(d1.hour12h, e);
      case "ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 12;
  }
  set(e, a, o) {
    const n = e.getHours() >= 12;
    return n && o < 12 ? e.setHours(o + 12, 0, 0, 0) : !n && o === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class Vp extends Ge {
  priority = 70;
  parse(e, a, o) {
    switch (a) {
      case "H":
        return s1(d1.hour23h, e);
      case "Ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 23;
  }
  set(e, a, o) {
    return e.setHours(o, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class Sp extends Ge {
  priority = 70;
  parse(e, a, o) {
    switch (a) {
      case "K":
        return s1(d1.hour11h, e);
      case "Ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 11;
  }
  set(e, a, o) {
    return e.getHours() >= 12 && o < 12 ? e.setHours(o + 12, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class Ap extends Ge {
  priority = 70;
  parse(e, a, o) {
    switch (a) {
      case "k":
        return s1(d1.hour24h, e);
      case "ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 1 && a <= 24;
  }
  set(e, a, o) {
    const n = o <= 24 ? o % 24 : o;
    return e.setHours(n, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class Ep extends Ge {
  priority = 60;
  parse(e, a, o) {
    switch (a) {
      case "m":
        return s1(d1.minute, e);
      case "mo":
        return o.ordinalNumber(e, { unit: "minute" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 59;
  }
  set(e, a, o) {
    return e.setMinutes(o, 0, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class Dp extends Ge {
  priority = 50;
  parse(e, a, o) {
    switch (a) {
      case "s":
        return s1(d1.second, e);
      case "so":
        return o.ordinalNumber(e, { unit: "second" });
      default:
        return l1(a.length, e);
    }
  }
  validate(e, a) {
    return a >= 0 && a <= 59;
  }
  set(e, a, o) {
    return e.setSeconds(o, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class Pp extends Ge {
  priority = 30;
  parse(e, a) {
    const o = (n) => Math.trunc(n * Math.pow(10, -a.length + 3));
    return m1(l1(a.length, e), o);
  }
  set(e, a, o) {
    return e.setMilliseconds(o), e;
  }
  incompatibleTokens = ["t", "T"];
}
class zp extends Ge {
  priority = 10;
  parse(e, a) {
    switch (a) {
      case "X":
        return dt(
          ct.basicOptionalMinutes,
          e
        );
      case "XX":
        return dt(ct.basic, e);
      case "XXXX":
        return dt(
          ct.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return dt(
          ct.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return dt(ct.extended, e);
    }
  }
  set(e, a, o) {
    return a.timestampIsSet ? e : Je(
      e,
      e.getTime() - un(e) - o
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class Tp extends Ge {
  priority = 10;
  parse(e, a) {
    switch (a) {
      case "x":
        return dt(
          ct.basicOptionalMinutes,
          e
        );
      case "xx":
        return dt(ct.basic, e);
      case "xxxx":
        return dt(
          ct.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return dt(
          ct.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return dt(ct.extended, e);
    }
  }
  set(e, a, o) {
    return a.timestampIsSet ? e : Je(
      e,
      e.getTime() - un(e) - o
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class Op extends Ge {
  priority = 40;
  parse(e) {
    return s2(e);
  }
  set(e, a, o) {
    return [Je(e, o * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class Fp extends Ge {
  priority = 20;
  parse(e) {
    return s2(e);
  }
  set(e, a, o) {
    return [Je(e, o), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const Bp = {
  G: new np(),
  y: new rp(),
  Y: new sp(),
  R: new ip(),
  u: new lp(),
  Q: new up(),
  q: new cp(),
  M: new dp(),
  L: new mp(),
  w: new fp(),
  I: new vp(),
  d: new bp(),
  D: new kp(),
  E: new Cp(),
  e: new wp(),
  c: new _p(),
  i: new jp(),
  a: new Lp(),
  b: new xp(),
  B: new $p(),
  h: new Mp(),
  H: new Vp(),
  K: new Sp(),
  k: new Ap(),
  m: new Ep(),
  s: new Dp(),
  S: new Pp(),
  X: new zp(),
  x: new Tp(),
  t: new Op(),
  T: new Fp()
}, Ip = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Zp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Rp = /^'([^]*?)'?$/, Np = /''/g, qp = /\S/, Up = /[a-zA-Z]/;
function xr(t, e, a, o) {
  const n = () => Je(o?.in || a, NaN), r = Xm(), s = o?.locale ?? r.locale ?? t2, i = o?.firstWeekContainsDate ?? o?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, l = o?.weekStartsOn ?? o?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0;
  if (!e)
    return t ? n() : Se(a, o?.in);
  const f = {
    firstWeekContainsDate: i,
    weekStartsOn: l,
    locale: s
  }, u = [new op(o?.in, a)], d = e.match(Zp).map((c) => {
    const p = c[0];
    if (p in jr) {
      const h = jr[p];
      return h(c, s.formatLong);
    }
    return c;
  }).join("").match(Ip), k = [];
  for (let c of d) {
    !o?.useAdditionalWeekYearTokens && n2(c) && Lr(c, e, t), !o?.useAdditionalDayOfYearTokens && o2(c) && Lr(c, e, t);
    const p = c[0], h = Bp[p];
    if (h) {
      const { incompatibleTokens: v } = h;
      if (Array.isArray(v)) {
        const w = k.find(
          (_) => v.includes(_.token) || _.token === p
        );
        if (w)
          throw new RangeError(
            `The format string mustn't contain \`${w.fullToken}\` and \`${c}\` at the same time`
          );
      } else if (h.incompatibleTokens === "*" && k.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${c}\` and any other token at the same time`
        );
      k.push({ token: p, fullToken: c });
      const H = h.run(
        t,
        c,
        s.match,
        f
      );
      if (!H)
        return n();
      u.push(H.setter), t = H.rest;
    } else {
      if (p.match(Up))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + p + "`"
        );
      if (c === "''" ? c = "'" : p === "'" && (c = Yp(c)), t.indexOf(c) === 0)
        t = t.slice(c.length);
      else
        return n();
    }
  }
  if (t.length > 0 && qp.test(t))
    return n();
  const y = u.map((c) => c.priority).sort((c, p) => p - c).filter((c, p, h) => h.indexOf(c) === p).map(
    (c) => u.filter((p) => p.priority === c).sort((p, h) => h.subPriority - p.subPriority)
  ).map((c) => c[0]);
  let b = Se(a, o?.in);
  if (isNaN(+b)) return n();
  const M = {};
  for (const c of y) {
    if (!c.validate(b, f))
      return n();
    const p = c.set(b, M, f);
    Array.isArray(p) ? (b = p[0], Object.assign(M, p[1])) : b = p;
  }
  return b;
}
function Yp(t) {
  return t.match(Rp)[1].replace(Np, "'");
}
function z0(t, e, a) {
  const [o, n] = io(
    a?.in,
    t,
    e
  );
  return +Gt(o) == +Gt(n);
}
function u2(t, e, a) {
  return q1(t, -e, a);
}
function c2(t, e, a) {
  const o = Se(t, a?.in), n = o.getFullYear(), r = o.getDate(), s = Je(t, 0);
  s.setFullYear(n, e, 15), s.setHours(0, 0, 0, 0);
  const i = Gm(s);
  return o.setMonth(e, Math.min(r, i)), o;
}
function t1(t, e, a) {
  let o = Se(t, a?.in);
  return isNaN(+o) ? Je(t, NaN) : (e.year != null && o.setFullYear(e.year), e.month != null && (o = c2(o, e.month)), e.date != null && o.setDate(e.date), e.hours != null && o.setHours(e.hours), e.minutes != null && o.setMinutes(e.minutes), e.seconds != null && o.setSeconds(e.seconds), e.milliseconds != null && o.setMilliseconds(e.milliseconds), o);
}
function Wp(t, e, a) {
  const o = Se(t, a?.in);
  return o.setHours(e), o;
}
function d2(t, e, a) {
  const o = Se(t, a?.in);
  return o.setMilliseconds(e), o;
}
function Kp(t, e, a) {
  const o = Se(t, a?.in);
  return o.setMinutes(e), o;
}
function m2(t, e, a) {
  const o = Se(t, a?.in);
  return o.setSeconds(e), o;
}
function mt(t, e, a) {
  const o = Se(t, a?.in);
  return isNaN(+o) ? Je(t, NaN) : (o.setFullYear(e), o);
}
function xa(t, e, a) {
  return tt(t, -e, a);
}
function Gp(t, e, a) {
  const {
    years: o = 0,
    months: n = 0,
    weeks: r = 0,
    days: s = 0,
    hours: i = 0,
    minutes: l = 0,
    seconds: f = 0
  } = e, u = xa(t, n + o * 12, a), d = u2(u, s + r * 7, a), k = l + i * 60, b = (f + k * 60) * 1e3;
  return Je(t, +d - b);
}
function p2(t, e, a) {
  return Zr(t, -e, a);
}
function Pa() {
  const t = F1();
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...t
    },
    [
      g("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      g("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      g("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      g("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Pa.compatConfig = {
  MODE: 3
};
function f2() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      g("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
f2.compatConfig = {
  MODE: 3
};
function Wr() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Wr.compatConfig = {
  MODE: 3
};
function Kr() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
Kr.compatConfig = {
  MODE: 3
};
function Gr() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      g("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Gr.compatConfig = {
  MODE: 3
};
function Xr() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Xr.compatConfig = {
  MODE: 3
};
function Qr() {
  return m(), C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      g("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Qr.compatConfig = {
  MODE: 3
};
const O1 = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), Jr = (t, e, a) => $r(t, e, a) || be(), Xp = (t, e, a) => {
  const o = e.dateInTz ? O1(new Date(t), e.dateInTz) : be(t);
  return a ? x1(o, !0) : o;
}, $r = (t, e, a) => {
  if (!t) return null;
  const o = a ? x1(be(t), !0) : be(t);
  return e ? e.exactMatch ? Xp(t, e, a) : O1(o, e.timezone) : o;
}, Qp = (t) => {
  const e = new Date(t.getFullYear(), 0, 1).getTimezoneOffset();
  return t.getTimezoneOffset() < e;
}, Jp = (t, e) => {
  if (!t) return 0;
  const a = /* @__PURE__ */ new Date(), o = new Date(a.toLocaleString("en-US", { timeZone: "UTC" })), n = new Date(a.toLocaleString("en-US", { timeZone: t })), r = (Qp(e ?? n) ? n : e ?? n).getTimezoneOffset() / 60;
  return (+o - +n) / (1e3 * 60 * 60) - r;
};
var K1 = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(K1 || {}), G1 = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(G1 || {}), Xt = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Xt || {}), M1 = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(M1 || {});
const ef = ["timestamp", "date", "iso"];
var z1 = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(z1 || {}), o1 = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(o1 || {}), Ca = /* @__PURE__ */ ((t) => (t.MONTH_AND_YEAR = "MM-yyyy", t.YEAR = "yyyy", t.DATE = "dd-MM-yyyy", t))(Ca || {});
function T0(t) {
  return (e) => new Intl.DateTimeFormat(t, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`)).slice(0, 2);
}
function tf(t) {
  return (e) => pt(O1(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const af = (t, e, a) => {
  const o = [1, 2, 3, 4, 5, 6, 7];
  let n;
  if (t !== null)
    try {
      n = o.map(tf(t));
    } catch {
      n = o.map(T0(e));
    }
  else
    n = o.map(T0(e));
  const r = n.slice(0, a), s = n.slice(a + 1, n.length);
  return [n[a]].concat(...s).concat(...r);
}, e0 = (t, e, a) => {
  const o = [];
  for (let n = +t[0]; n <= +t[1]; n++)
    o.push({ value: +n, text: y2(n, e) });
  return a ? o.reverse() : o;
}, h2 = (t, e, a) => {
  const o = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const s = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${s}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const r = a === "long" ? "LLLL" : "LLL";
      return o.map((s, i) => {
        const l = pt(O1(s, "UTC"), r, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: i
        };
      });
    } catch {
    }
  const n = new Intl.DateTimeFormat(e, { month: a, timeZone: "UTC" });
  return o.map((r, s) => {
    const i = n.format(r);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: s
    };
  });
}, of = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], y1 = (t) => {
  const e = j(t);
  return e != null && e.$el ? e?.$el : e;
}, nf = (t) => ({ type: "dot", ...t ?? {} }), v2 = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, t0 = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, C1 = (t) => t, O0 = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, F0 = (t) => t === null, g2 = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, rf = (t) => {
  const e = [], a = (o) => o.filter((n) => n);
  for (let o = 0; o < t.length; o += 3) {
    const n = [t[o], t[o + 1], t[o + 2]];
    e.push(a(n));
  }
  return e;
}, eo = (t, e, a) => {
  const o = a != null, n = e != null;
  if (!o && !n) return !1;
  const r = +a, s = +e;
  return o && n ? +t > r || +t < s : o ? +t > r : n ? +t < s : !1;
}, $a = (t, e) => rf(t).map((a) => a.map((o) => {
  const { active: n, disabled: r, isBetween: s, highlighted: i } = e(o);
  return {
    ...o,
    active: n,
    disabled: r,
    className: {
      dp__overlay_cell_active: n,
      dp__overlay_cell: !n,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && n,
      dp__cell_in_between: s,
      "dp--highlighted": i
    }
  };
})), Pt = (t, e, a = !1) => {
  t && e.allowStopPropagation && (a && t.stopImmediatePropagation(), t.stopPropagation());
}, sf = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function lf(t, e) {
  let a = [...document.querySelectorAll(sf())];
  a = a.filter((n) => !t.contains(n) || n.hasAttribute("data-datepicker-instance"));
  const o = a.indexOf(t);
  if (o >= 0 && (e ? o - 1 >= 0 : o + 1 <= a.length))
    return a[o + (e ? -1 : 1)];
}
const Mr = (t, e) => t?.querySelector(`[data-dp-element="${e}"]`), y2 = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), a0 = (t, e) => pt(t, e ?? Ca.DATE), tr = (t) => Array.isArray(t), dn = (t, e, a) => e.get(a0(t, a)), uf = (t, e) => t ? e ? e instanceof Map ? !!dn(t, e) : e(be(t)) : !1 : !0, T1 = (t, e, a = !1, o) => {
  if (t.key === o1.enter || t.key === o1.space)
    return a && t.preventDefault(), e();
  if (o) return o(t);
}, cf = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, df = (t, e) => t ? Ca.MONTH_AND_YEAR : e ? Ca.YEAR : Ca.DATE, b2 = (t) => t < 10 ? `0${t}` : t, B0 = (t, e, a, o, n, r) => {
  const s = xr(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: r });
  return Ga(s) && Gi(s) ? o || n ? s : t1(s, {
    hours: +a.hours,
    minutes: +a?.minutes,
    seconds: +a?.seconds,
    milliseconds: 0
  }) : null;
}, mf = (t, e, a, o, n, r) => {
  const s = Array.isArray(a) ? a[0] : a;
  if (typeof e == "string")
    return B0(t, e, s, o, n, r);
  if (Array.isArray(e)) {
    let i = null;
    for (const l of e)
      if (i = B0(t, l, s, o, n, r), i)
        break;
    return i;
  }
  return typeof e == "function" ? e(t) : null;
}, be = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), pf = (t, e, a) => {
  if (e) {
    const n = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), s = t.getHours().toString().padStart(2, "0"), i = t.getMinutes().toString().padStart(2, "0"), l = a ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${n}-${r}T${s}:${i}:${l}.000Z`;
  }
  const o = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(o).toISOString();
}, x1 = (t, e) => {
  const a = be(JSON.parse(JSON.stringify(t))), o = t1(a, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? om(o) : o;
}, zt = (t, e, a, o) => {
  let n = t ? be(t) : be();
  return (e || e === 0) && (n = Wp(n, +e)), (a || a === 0) && (n = Kp(n, +a)), (o || o === 0) && (n = m2(n, +o)), d2(n, 0);
}, i1 = (t, e) => !t || !e ? !1 : La(x1(t), x1(e)), Ie = (t, e) => !t || !e ? !1 : ba(x1(t), x1(e)), c1 = (t, e) => !t || !e ? !1 : aa(x1(t), x1(e)), to = (t, e, a) => t != null && t[0] && t != null && t[1] ? c1(a, t[0]) && i1(a, t[1]) : t != null && t[0] && e ? c1(a, t[0]) && i1(a, e) || i1(a, t[0]) && c1(a, e) : !1, Q1 = (t) => {
  const e = t1(new Date(t), { date: 1 });
  return x1(e);
}, ar = (t, e, a) => e && (a || a === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((o) => o === e ? [o, a] : [o, isNaN(+t[o]) ? void 0 : +t[o]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Qt = (t) => ({
  hours: wt(t),
  minutes: Tt(t),
  seconds: ja(t)
}), k2 = (t, e) => {
  if (e) {
    const a = Ee(be(e));
    if (a > t) return 12;
    if (a === t) return Be(be(e));
  }
}, C2 = (t, e) => {
  if (e) {
    const a = Ee(be(e));
    return a < t ? -1 : a === t ? Be(be(e)) : void 0;
  }
}, Ma = (t) => {
  if (t) return Ee(be(t));
}, w2 = (t, e) => {
  const a = c1(t, e) ? e : t, o = c1(e, t) ? e : t;
  return Qi({ start: a, end: o });
}, ff = (t) => {
  const e = tt(t, 1);
  return { month: Be(e), year: Ee(e) };
}, kt = (t, e) => {
  const a = at(t, { weekStartsOn: +e }), o = e2(t, { weekStartsOn: +e });
  return [a, o];
}, _2 = (t, e) => {
  const a = {
    hours: wt(be()),
    minutes: Tt(be()),
    seconds: e ? ja(be()) : 0
  };
  return Object.assign(a, t);
}, Dt = (t, e, a) => [t1(be(t), { date: 1 }), t1(be(), { month: e, year: a, date: 1 })], Ct = (t, e, a) => {
  let o = t ? be(t) : be();
  return (e || e === 0) && (o = c2(o, e)), a && (o = mt(o, a)), o;
}, H2 = (t, e, a, o, n) => {
  if (!o || n && !e || !n && !a) return !1;
  const r = n ? tt(t, 1) : xa(t, 1), s = [Be(r), Ee(r)];
  return n ? !vf(...s, e) : !hf(...s, a);
}, hf = (t, e, a) => i1(...Dt(a, t, e)) || Ie(...Dt(a, t, e)), vf = (t, e, a) => c1(...Dt(a, t, e)) || Ie(...Dt(a, t, e)), j2 = (t, e, a, o, n, r, s) => {
  if (typeof e == "function" && !s) return e(t);
  const i = a ? { locale: a } : void 0;
  return Array.isArray(t) ? `${pt(t[0], r, i)}${n && !t[1] ? "" : o}${t[1] ? pt(t[1], r, i) : ""}` : pt(t, r, i);
}, da = (t) => {
  if (t) return null;
  throw new Error(t0.prop("partial-range"));
}, yo = (t, e) => {
  if (e) return t();
  throw new Error(t0.prop("range"));
}, Vr = (t) => Array.isArray(t) ? Ga(t[0]) && (t[1] ? Ga(t[1]) : !0) : t ? Ga(t) : !1, gf = (t, e) => t1(e ?? be(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), or = (t, e, a, o) => {
  if (!t) return !0;
  if (o) {
    const n = a === "max" ? La(t, e) : aa(t, e), r = { seconds: 0, milliseconds: 0 };
    return n || ba(t1(t, r), t1(e, r));
  }
  return a === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, nr = (t, e, a) => t ? gf(t, e) : be(a ?? e), I0 = (t, e, a, o, n) => {
  if (Array.isArray(o)) {
    const s = nr(t, o[0], e), i = nr(t, o[1], e);
    return or(o[0], s, a, !!e) && or(o[1], i, a, !!e) && n;
  }
  const r = nr(t, o, e);
  return or(o, r, a, !!e) && n;
}, rr = (t) => t1(be(), Qt(t)), yf = (t, e, a) => {
  if (t instanceof Map) {
    const o = `${b2(a + 1)}-${e}`;
    return t.size ? t.has(o) : !1;
  }
  return !1;
}, bf = (t, e, a) => {
  if (t instanceof Map) {
    const o = `${b2(a + 1)}-${e}`;
    return t.size ? t.has(o) : !0;
  }
  return !0;
}, L2 = (t, e, a) => typeof t == "function" ? t({ month: e, year: a }) : !!t.months.find((o) => o.month === e && o.year === a), o0 = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), Sr = (t) => `dp-${pt(t, "yyyy-MM-dd")}`, Z0 = (t, e) => {
  const a = u2(x1(e), t), o = q1(x1(e), t);
  return { before: a, after: o };
}, Ra = so({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), x2 = () => {
  const t = (a) => {
    Ra.menuFocused = a;
  }, e = (a) => {
    Ra.shiftKeyInMenu !== a && (Ra.shiftKeyInMenu = a);
  };
  return {
    control: Q(() => ({ shiftKeyInMenu: Ra.shiftKeyInMenu, menuFocused: Ra.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, a1 = so({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), sr = me(null), bo = me(!1), ir = me(!1), lr = me(!1), ur = me(!1), $1 = me(0), u1 = me(0), Bt = () => {
  const t = Q(() => bo.value ? [...a1.selectionGrid, a1.actionRow].filter((d) => d.length) : ir.value ? [
    ...a1.timePicker[0],
    ...a1.timePicker[1],
    ur.value ? [] : [sr.value],
    a1.actionRow
  ].filter((d) => d.length) : lr.value ? [...a1.monthPicker, a1.actionRow] : [a1.monthYear, ...a1.calendar, a1.time, a1.actionRow].filter((d) => d.length)), e = (d) => {
    $1.value = d ? $1.value + 1 : $1.value - 1;
    let k = null;
    t.value[u1.value] && (k = t.value[u1.value][$1.value]), !k && t.value[u1.value + (d ? 1 : -1)] ? (u1.value = u1.value + (d ? 1 : -1), $1.value = d ? 0 : t.value[u1.value].length - 1) : k || ($1.value = d ? $1.value - 1 : $1.value + 1);
  }, a = (d) => {
    u1.value === 0 && !d || u1.value === t.value.length && d || (u1.value = d ? u1.value + 1 : u1.value - 1, t.value[u1.value] ? t.value[u1.value] && !t.value[u1.value][$1.value] && $1.value !== 0 && ($1.value = t.value[u1.value].length - 1) : u1.value = d ? u1.value - 1 : u1.value + 1);
  }, o = (d) => {
    let k = null;
    t.value[u1.value] && (k = t.value[u1.value][$1.value]), k ? k.focus({ preventScroll: !bo.value }) : $1.value = d ? $1.value - 1 : $1.value + 1;
  }, n = () => {
    e(!0), o(!0);
  }, r = () => {
    e(!1), o(!1);
  }, s = () => {
    a(!1), o(!0);
  }, i = () => {
    a(!0), o(!0);
  }, l = (d, k) => {
    a1[k] = d;
  }, f = (d, k) => {
    a1[k] = d;
  }, u = () => {
    $1.value = 0, u1.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: f,
    setTimePickerBackRef: (d) => {
      sr.value = d;
    },
    setSelectionGrid: (d) => {
      bo.value = d, u(), d || (a1.selectionGrid = []);
    },
    setTimePicker: (d, k = !1) => {
      ir.value = d, ur.value = k, u(), d || (a1.timePicker[0] = [], a1.timePicker[1] = []);
    },
    setTimePickerElements: (d, k = 0) => {
      a1.timePicker[k] = d;
    },
    arrowRight: n,
    arrowLeft: r,
    arrowUp: s,
    arrowDown: i,
    clearArrowNav: () => {
      a1.monthYear = [], a1.calendar = [], a1.time = [], a1.actionRow = [], a1.selectionGrid = [], a1.timePicker[0] = [], a1.timePicker[1] = [], bo.value = !1, ir.value = !1, ur.value = !1, lr.value = !1, u(), sr.value = null;
    },
    setMonthPicker: (d) => {
      lr.value = d, u();
    },
    refSets: a1
    // exposed for testing
  };
}, R0 = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), kf = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`,
  ...t ?? {}
}), N0 = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, Cf = (t) => {
  const e = typeof t == "object" && t, a = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...a, count: N0(!1) };
  const o = e ? t : {}, n = e ? o.count ?? !0 : t, r = N0(n);
  return Object.assign(a, o, { count: r });
}, wf = (t, e, a) => t || (typeof a == "string" ? a : e), _f = (t) => typeof t == "boolean" ? t ? R0({}) : !1 : R0(t), Hf = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, jf = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), Lf = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), xf = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, $f = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...t ?? {} }), Mf = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((a) => be(a)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, Vf = (t) => typeof t == "object" ? {
  type: t?.type ?? "local",
  hideOnOffsetDates: t?.hideOnOffsetDates ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, Sf = (t) => {
  const e = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof t == "object" ? { enabled: !0, ...e, ...t } : {
    enabled: t,
    ...e
  };
}, Af = (t) => t ? typeof t == "string" ? {
  timezone: t,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: t.emitTimezone ?? void 0,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, cr = (t, e, a, o) => new Map(
  t.map((n) => {
    const r = Jr(n, e, o);
    return [a0(r, a), r];
  })
), Ef = (t, e) => t.length ? new Map(
  t.map((a) => {
    const o = Jr(a.date, e);
    return [a0(o, Ca.DATE), a];
  })
) : null, Df = (t) => {
  var e;
  const a = df(t.isMonthPicker, t.isYearPicker);
  return {
    minDate: $r(t.minDate, t.timezone, t.isSpecific),
    maxDate: $r(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: tr(t.disabledDates) ? cr(t.disabledDates, t.timezone, a, t.isSpecific) : t.disabledDates,
    allowedDates: tr(t.allowedDates) ? cr(t.allowedDates, t.timezone, a, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && tr((e = t.highlight) == null ? void 0 : e.dates) ? cr(t.highlight.dates, t.timezone, a) : t.highlight,
    markers: Ef(t.markers, t.timezone)
  };
}, Pf = (t) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: null } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, zf = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const a = e, o = t[a], n = typeof t[a] == "string" ? { [o]: !0 } : Object.fromEntries(o.map((r) => [r, !0]));
      return [e, n];
    })
  )
}), n1 = (t) => {
  const e = () => {
    const _ = t.enableSeconds ? ":ss" : "", L = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${L}${_}` : `hh${L}${_} aa`;
  }, a = () => {
    var _;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((_ = c.value) == null ? void 0 : _.type) === "iso" ? "II" : "ww"}-RR` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, o = (_) => _2(_, t.enableSeconds), n = () => H.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [o(t.startTime[0]), o(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? o(t.startTime) : null, r = Q(() => Cf(t.multiCalendars)), s = Q(() => n()), i = Q(() => kf(t.ariaLabels)), l = Q(() => jf(t.filters)), f = Q(() => _f(t.transitions)), u = Q(() => Lf(t.actionRow)), d = Q(
    () => wf(t.previewFormat, t.format, a())
  ), k = Q(() => Hf(t.textInput)), y = Q(() => xf(t.inline)), b = Q(() => $f(t.config)), M = Q(() => Mf(t.highlight)), c = Q(() => Vf(t.weekNumbers)), p = Q(() => Af(t.timezone)), h = Q(() => Pf(t.multiDates)), v = Q(
    () => Df({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: M.value,
      markers: t.markers,
      timezone: p.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker,
      isMonthPicker: t.monthPicker,
      isYearPicker: t.yearPicker
    })
  ), H = Q(() => Sf(t.range)), w = Q(() => zf(t.ui));
  return {
    defaultedTransitions: f,
    defaultedMultiCalendars: r,
    defaultedStartTime: s,
    defaultedAriaLabels: i,
    defaultedFilters: l,
    defaultedActionRow: u,
    defaultedPreviewFormat: d,
    defaultedTextInput: k,
    defaultedInline: y,
    defaultedConfig: b,
    defaultedHighlight: M,
    defaultedWeekNumbers: c,
    defaultedRange: H,
    propDates: v,
    defaultedTz: p,
    defaultedMultiDates: h,
    defaultedUI: w,
    getDefaultPattern: a,
    getDefaultStartTime: n
  };
}, Tf = (t, e, a) => {
  const o = me(), { defaultedTextInput: n, defaultedRange: r, defaultedTz: s, defaultedMultiDates: i, getDefaultPattern: l } = n1(e), f = me(""), u = Qa(e, "format"), d = Qa(e, "formatLocale");
  Ue(
    o,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", o.value, N(!0));
    },
    { deep: !0 }
  ), Ue(r, ($, W) => {
    $.enabled !== W.enabled && (o.value = null);
  }), Ue(u, () => {
    ne();
  });
  const k = ($) => s.value.timezone && s.value.convertModel ? O1($, s.value.timezone) : $, y = ($) => {
    if (s.value.timezone && s.value.convertModel) {
      const W = Jp(s.value.timezone, $);
      return Gd($, W);
    }
    return $;
  }, b = ($, W, fe = !1) => j2(
    $,
    e.format,
    e.formatLocale,
    n.value.rangeSeparator,
    e.modelAuto,
    W ?? l(),
    fe
  ), M = ($) => $ ? e.modelType ? G($) : {
    hours: wt($),
    minutes: Tt($),
    seconds: e.enableSeconds ? ja($) : 0
  } : null, c = ($) => e.modelType ? G($) : { month: Be($), year: Ee($) }, p = ($) => Array.isArray($) ? i.value.enabled ? $.map((W) => h(W, mt(be(), W))) : yo(
    () => [
      mt(be(), $[0]),
      $[1] ? mt(be(), $[1]) : da(r.value.partialRange)
    ],
    r.value.enabled
  ) : mt(be(), +$), h = ($, W) => (typeof $ == "string" || typeof $ == "number") && e.modelType ? te($) : W, v = ($) => Array.isArray($) ? [
    h(
      $[0],
      zt(null, +$[0].hours, +$[0].minutes, $[0].seconds)
    ),
    h(
      $[1],
      zt(null, +$[1].hours, +$[1].minutes, $[1].seconds)
    )
  ] : h($, zt(null, $.hours, $.minutes, $.seconds)), H = ($) => {
    const W = t1(be(), { date: 1 });
    return Array.isArray($) ? i.value.enabled ? $.map((fe) => h(fe, Ct(W, +fe.month, +fe.year))) : yo(
      () => [
        h($[0], Ct(W, +$[0].month, +$[0].year)),
        h(
          $[1],
          $[1] ? Ct(W, +$[1].month, +$[1].year) : da(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : h($, Ct(W, +$.month, +$.year));
  }, w = ($) => {
    if (Array.isArray($))
      return $.map((W) => te(W));
    throw new Error(t0.dateArr("multi-dates"));
  }, _ = ($) => {
    if (Array.isArray($) && r.value.enabled) {
      const W = $[0], fe = $[1];
      return [
        be(Array.isArray(W) ? W[0] : null),
        Array.isArray(fe) && fe.length ? be(fe[0]) : null
      ];
    }
    return be($[0]);
  }, L = ($) => e.modelAuto ? Array.isArray($) ? [te($[0]), te($[1])] : e.autoApply ? [te($)] : [te($), null] : Array.isArray($) ? yo(
    () => $[1] ? [
      te($[0]),
      $[1] ? te($[1]) : da(r.value.partialRange)
    ] : [te($[0])],
    r.value.enabled
  ) : te($), I = () => {
    Array.isArray(o.value) && r.value.enabled && o.value.length === 1 && o.value.push(da(r.value.partialRange));
  }, F = () => {
    const $ = o.value;
    return [
      G($[0]),
      $[1] ? G($[1]) : da(r.value.partialRange)
    ];
  }, B = () => o.value[1] ? F() : G(C1(o.value[0])), K = () => (o.value || []).map(($) => G($)), ee = ($ = !1) => ($ || I(), e.modelAuto ? B() : i.value.enabled ? K() : Array.isArray(o.value) ? yo(() => F(), r.value.enabled) : G(C1(o.value))), ve = ($) => !$ || Array.isArray($) && !$.length ? null : e.timePicker ? v(C1($)) : e.monthPicker ? H(C1($)) : e.yearPicker ? p(C1($)) : i.value.enabled ? w(C1($)) : e.weekPicker ? _(C1($)) : L(C1($)), q = ($) => {
    const W = ve($);
    Vr(C1(W)) ? (o.value = C1(W), ne()) : (o.value = null, f.value = "");
  }, O = () => {
    const $ = (W) => pt(W, n.value.format);
    return `${$(o.value[0])} ${n.value.rangeSeparator} ${o.value[1] ? $(o.value[1]) : ""}`;
  }, Y = () => a.value && o.value ? Array.isArray(o.value) ? O() : pt(o.value, n.value.format) : b(o.value), U = () => o.value ? i.value.enabled ? o.value.map(($) => b($)).join("; ") : n.value.enabled && typeof n.value.format == "string" ? Y() : b(o.value) : "", ne = () => {
    !e.format || typeof e.format == "string" || n.value.enabled && typeof n.value.format == "string" ? f.value = U() : f.value = e.format(o.value);
  }, te = ($) => {
    if (e.utc) {
      const W = new Date($);
      return e.utc === "preserve" ? new Date(W.getTime() + W.getTimezoneOffset() * 6e4) : W;
    }
    return e.modelType ? ef.includes(e.modelType) ? k(new Date($)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? k(
      xr($, l(), /* @__PURE__ */ new Date(), { locale: d.value })
    ) : k(
      xr($, e.modelType, /* @__PURE__ */ new Date(), { locale: d.value })
    ) : k(new Date($));
  }, G = ($) => $ ? e.utc ? pf($, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +y($) : e.modelType === "iso" ? y($).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? b(y($)) : b(y($), e.modelType, !0) : y($) : "", T = ($, W = !1, fe = !1) => {
    if (fe) return $;
    if (t("update:model-value", $), s.value.emitTimezone && W) {
      const Le = Array.isArray($) ? $.map((z) => O1(C1(z), s.value.emitTimezone)) : O1(C1($), s.value.emitTimezone);
      t("update:model-timezone-value", Le);
    }
  }, Z = ($) => Array.isArray(o.value) ? i.value.enabled ? o.value.map((W) => $(W)) : [
    $(o.value[0]),
    o.value[1] ? $(o.value[1]) : da(r.value.partialRange)
  ] : $(C1(o.value)), D = () => {
    if (Array.isArray(o.value)) {
      const $ = kt(o.value[0], e.weekStart), W = o.value[1] ? kt(o.value[1], e.weekStart) : [];
      return [$.map((fe) => be(fe)), W.map((fe) => be(fe))];
    }
    return kt(o.value, e.weekStart).map(($) => be($));
  }, x = ($, W) => T(C1(Z($)), !1, W), A = ($) => {
    const W = D();
    return $ ? W : t("update:model-value", D());
  }, N = ($ = !1) => ($ || ne(), e.monthPicker ? x(c, $) : e.timePicker ? x(M, $) : e.yearPicker ? x(Ee, $) : e.weekPicker ? A($) : T(ee($), !0, $));
  return {
    inputValue: f,
    internalModelValue: o,
    checkBeforeEmit: () => o.value ? r.value.enabled ? r.value.partialRange ? o.value.length >= 1 : o.value.length === 2 : !!o.value : !1,
    parseExternalModelValue: q,
    formatInputValue: ne,
    emitModelValue: N
  };
}, Of = (t, e) => {
  const { defaultedFilters: a, propDates: o } = n1(t), { validateMonthYearInRange: n } = It(t), r = (u, d) => {
    let k = u;
    return a.value.months.includes(Be(k)) ? (k = d ? tt(u, 1) : xa(u, 1), r(k, d)) : k;
  }, s = (u, d) => {
    let k = u;
    return a.value.years.includes(Ee(k)) ? (k = d ? Zr(u, 1) : p2(u, 1), s(k, d)) : k;
  }, i = (u, d = !1) => {
    const k = t1(be(), { month: t.month, year: t.year });
    let y = u ? tt(k, 1) : xa(k, 1);
    t.disableYearSelect && (y = mt(y, t.year));
    let b = Be(y), M = Ee(y);
    a.value.months.includes(b) && (y = r(y, u), b = Be(y), M = Ee(y)), a.value.years.includes(M) && (y = s(y, u), M = Ee(y)), n(b, M, u, t.preventMinMaxNavigation) && l(b, M, d);
  }, l = (u, d, k) => {
    e("update-month-year", { month: u, year: d, fromNav: k });
  }, f = Q(() => (u) => H2(
    t1(be(), { month: t.month, year: t.year }),
    o.value.maxDate,
    o.value.minDate,
    t.preventMinMaxNavigation,
    u
  ));
  return { handleMonthYearChange: i, isDisabled: f, updateMonthYear: l };
}, _n = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, ot = {
  ..._n,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, Ff = ["title"], Bf = ["disabled"], If = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...ot
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const a = e, o = t, {
      defaultedActionRow: n,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: s,
      defaultedTextInput: i,
      defaultedInline: l,
      defaultedRange: f,
      defaultedMultiDates: u
    } = n1(o), { isTimeValid: d, isMonthValid: k } = It(o), { buildMatrix: y } = Bt(), b = me(null), M = me(null), c = me(!1), p = me({}), h = me(null), v = me(null);
    h1(() => {
      o.arrowNavigation && y([y1(b), y1(M)], "actionRow"), H(), window.addEventListener("resize", H);
    }), oa(() => {
      window.removeEventListener("resize", H);
    });
    const H = () => {
      c.value = !1, setTimeout(() => {
        var q, O;
        const Y = (q = h.value) == null ? void 0 : q.getBoundingClientRect(), U = (O = v.value) == null ? void 0 : O.getBoundingClientRect();
        Y && U && (p.value.maxWidth = `${U.width - Y.width - 20}px`), c.value = !0;
      }, 0);
    }, w = Q(() => f.value.enabled && !f.value.partialRange && o.internalModelValue ? o.internalModelValue.length === 2 : !0), _ = Q(
      () => !d.value(o.internalModelValue) || !k.value(o.internalModelValue) || !w.value
    ), L = () => {
      const q = r.value;
      return o.timePicker || o.monthPicker, q(C1(o.internalModelValue));
    }, I = () => {
      const q = o.internalModelValue;
      return s.value.count > 0 ? `${F(q[0])} - ${F(q[1])}` : [F(q[0]), F(q[1])];
    }, F = (q) => j2(
      q,
      r.value,
      o.formatLocale,
      i.value.rangeSeparator,
      o.modelAuto,
      r.value
    ), B = Q(() => !o.internalModelValue || !o.menuMount ? "" : typeof r.value == "string" ? Array.isArray(o.internalModelValue) ? o.internalModelValue.length === 2 && o.internalModelValue[1] ? I() : u.value.enabled ? o.internalModelValue.map((q) => `${F(q)}`) : o.modelAuto ? `${F(o.internalModelValue[0])}` : `${F(o.internalModelValue[0])} -` : F(o.internalModelValue) : L()), K = () => u.value.enabled ? "; " : " - ", ee = Q(
      () => Array.isArray(B.value) ? B.value.join(K()) : B.value
    ), ve = () => {
      d.value(o.internalModelValue) && k.value(o.internalModelValue) && w.value ? a("select-date") : a("invalid-select");
    };
    return (q, O) => (m(), C("div", {
      ref_key: "actionRowRef",
      ref: v,
      class: "dp__action_row"
    }, [
      q.$slots["action-row"] ? oe(q.$slots, "action-row", v1(Re({ key: 0 }, {
        internalModelValue: q.internalModelValue,
        disabled: _.value,
        selectDate: () => q.$emit("select-date"),
        closePicker: () => q.$emit("close-picker")
      }))) : (m(), C(ge, { key: 1 }, [
        j(n).showPreview ? (m(), C("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ee.value,
          style: w1(p.value)
        }, [
          q.$slots["action-preview"] && c.value ? oe(q.$slots, "action-preview", {
            key: 0,
            value: q.internalModelValue
          }) : ae("", !0),
          !q.$slots["action-preview"] && c.value ? (m(), C(ge, { key: 1 }, [
            qe(_e(ee.value), 1)
          ], 64)) : ae("", !0)
        ], 12, Ff)) : ae("", !0),
        g("div", {
          ref_key: "actionBtnContainer",
          ref: h,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          q.$slots["action-buttons"] ? oe(q.$slots, "action-buttons", {
            key: 0,
            value: q.internalModelValue
          }) : ae("", !0),
          q.$slots["action-buttons"] ? ae("", !0) : (m(), C(ge, { key: 1 }, [
            !j(l).enabled && j(n).showCancel ? (m(), C("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: b,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: O[0] || (O[0] = (Y) => q.$emit("close-picker")),
              onKeydown: O[1] || (O[1] = (Y) => j(T1)(Y, () => q.$emit("close-picker")))
            }, _e(q.cancelText), 545)) : ae("", !0),
            j(n).showNow ? (m(), C("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: O[2] || (O[2] = (Y) => q.$emit("select-now")),
              onKeydown: O[3] || (O[3] = (Y) => j(T1)(Y, () => q.$emit("select-now")))
            }, _e(q.nowButtonLabel), 33)) : ae("", !0),
            j(n).showSelect ? (m(), C("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: M,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: _.value,
              "data-test-id": "select-button",
              onKeydown: O[4] || (O[4] = (Y) => j(T1)(Y, () => ve())),
              onClick: ve
            }, _e(q.selectText), 41, Bf)) : ae("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Zf = ["role", "aria-label", "tabindex"], Rf = { class: "dp__selection_grid_header" }, Nf = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], qf = ["aria-label"], lo = /* @__PURE__ */ J({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: a }) {
    const { setSelectionGrid: o, buildMultiLevelMatrix: n, setMonthPicker: r } = Bt(), s = a, i = t, { defaultedAriaLabels: l, defaultedTextInput: f, defaultedConfig: u } = n1(
      i
    ), { hideNavigationButtons: d } = Ln(), k = me(!1), y = me(null), b = me(null), M = me([]), c = me(), p = me(null), h = me(0), v = me(null);
    Fl(() => {
      y.value = null;
    }), h1(() => {
      p1().then(() => K()), i.noOverlayFocus || w(), H(!0);
    }), oa(() => H(!1));
    const H = (Z) => {
      var D;
      i.arrowNavigation && ((D = i.headerRefs) != null && D.length ? r(Z) : o(Z));
    }, w = () => {
      var Z;
      const D = y1(b);
      D && (f.value.enabled || (y.value ? (Z = y.value) == null || Z.focus({ preventScroll: !0 }) : D.focus({ preventScroll: !0 })), k.value = D.clientHeight < D.scrollHeight);
    }, _ = Q(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), L = Q(
      () => i.useRelative ? { height: `${i.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), I = Q(() => ({
      dp__overlay_col: !0
    })), F = Q(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: k.value,
        dp__button_bottom: i.isLast
      })
    ), B = Q(() => {
      var Z, D;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((Z = i.items) == null ? void 0 : Z.length) <= 6,
        dp__container_block: ((D = i.items) == null ? void 0 : D.length) > 6
      };
    });
    Ue(
      () => i.items,
      () => K(!1),
      { deep: !0 }
    );
    const K = (Z = !0) => {
      p1().then(() => {
        const D = y1(y), x = y1(b), A = y1(p), N = y1(v), $ = A ? A.getBoundingClientRect().height : 0;
        x && (x.getBoundingClientRect().height ? h.value = x.getBoundingClientRect().height - $ : h.value = u.value.modeHeight - $), D && N && Z && (N.scrollTop = D.offsetTop - N.offsetTop - (h.value / 2 - D.getBoundingClientRect().height) - $);
      });
    }, ee = (Z) => {
      Z.disabled || s("selected", Z.value);
    }, ve = () => {
      s("toggle"), s("reset-flow");
    }, q = () => {
      i.escClose && ve();
    }, O = (Z, D, x, A) => {
      Z && ((D.active || D.value === i.focusValue) && (y.value = Z), i.arrowNavigation && (Array.isArray(M.value[x]) ? M.value[x][A] = Z : M.value[x] = [Z], Y()));
    }, Y = () => {
      var Z, D;
      const x = (Z = i.headerRefs) != null && Z.length ? [i.headerRefs].concat(M.value) : M.value.concat([i.skipButtonRef ? [] : [p.value]]);
      n(C1(x), (D = i.headerRefs) != null && D.length ? "monthPicker" : "selectionGrid");
    }, U = (Z) => {
      i.arrowNavigation || Pt(Z, u.value, !0);
    }, ne = (Z) => {
      c.value = Z, s("hover-value", Z);
    }, te = () => {
      if (ve(), !i.isLast) {
        const Z = Mr(i.menuWrapRef ?? null, "action-row");
        if (Z) {
          const D = g2(Z);
          D?.focus();
        }
      }
    }, G = (Z) => {
      switch (Z.key) {
        case o1.esc:
          return q();
        case o1.arrowLeft:
          return U(Z);
        case o1.arrowRight:
          return U(Z);
        case o1.arrowUp:
          return U(Z);
        case o1.arrowDown:
          return U(Z);
        default:
          return;
      }
    }, T = (Z) => {
      if (Z.key === o1.enter) return ve();
      if (Z.key === o1.tab) return te();
    };
    return e({ focusGrid: w }), (Z, D) => {
      var x;
      return m(), C("div", {
        ref_key: "gridWrapRef",
        ref: b,
        class: le(_.value),
        style: w1(L.value),
        role: Z.useRelative ? void 0 : "dialog",
        "aria-label": Z.overlayLabel,
        tabindex: Z.useRelative ? void 0 : "0",
        onKeydown: G,
        onClick: D[0] || (D[0] = $e(() => {
        }, ["prevent"]))
      }, [
        g("div", {
          ref_key: "containerRef",
          ref: v,
          class: le(B.value),
          style: w1({ "--dp-overlay-height": `${h.value}px` }),
          role: "grid"
        }, [
          g("div", Rf, [
            oe(Z.$slots, "header")
          ]),
          Z.$slots.overlay ? oe(Z.$slots, "overlay", { key: 0 }) : (m(!0), C(ge, { key: 1 }, De(Z.items, (A, N) => (m(), C("div", {
            key: N,
            class: le(["dp__overlay_row", { dp__flex_row: Z.items.length >= 3 }]),
            role: "row"
          }, [
            (m(!0), C(ge, null, De(A, ($, W) => (m(), C("div", {
              key: $.value,
              ref_for: !0,
              ref: (fe) => O(fe, $, N, W),
              role: "gridcell",
              class: le(I.value),
              "aria-selected": $.active || void 0,
              "aria-disabled": $.disabled || void 0,
              tabindex: "0",
              "data-test-id": $.text,
              onClick: $e((fe) => ee($), ["prevent"]),
              onKeydown: (fe) => j(T1)(fe, () => ee($), !0),
              onMouseover: (fe) => ne($.value)
            }, [
              g("div", {
                class: le($.className)
              }, [
                Z.$slots.item ? oe(Z.$slots, "item", {
                  key: 0,
                  item: $
                }) : ae("", !0),
                Z.$slots.item ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                  qe(_e($.text), 1)
                ], 64))
              ], 2)
            ], 42, Nf))), 128))
          ], 2))), 128))
        ], 6),
        Z.$slots["button-icon"] ? Ne((m(), C("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: p,
          type: "button",
          "aria-label": (x = j(l)) == null ? void 0 : x.toggleOverlay,
          class: le(F.value),
          tabindex: "0",
          onClick: ve,
          onKeydown: T
        }, [
          oe(Z.$slots, "button-icon")
        ], 42, qf)), [
          [L1, !j(d)(Z.hideNavigation, Z.type)]
        ]) : ae("", !0)
      ], 46, Zf);
    };
  }
}), Uf = ["data-dp-mobile"], Hn = /* @__PURE__ */ J({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(t) {
    const e = t, a = Q(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), o = Q(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (n, r) => (m(), C("div", {
      class: le({
        dp__menu_inner: !n.stretch,
        "dp--menu--inner-stretched": n.stretch,
        dp__flex_display: n.multiCalendars > 0,
        "dp--flex-display-collapsed": n.collapse
      }),
      "data-dp-mobile": n.isMobile
    }, [
      (m(!0), C(ge, null, De(a.value, (s, i) => (m(), C("div", {
        key: s,
        class: le(o.value)
      }, [
        oe(n.$slots, "default", {
          instance: s,
          index: i
        })
      ], 2))), 128))
    ], 10, Uf));
  }
}), Yf = ["data-dp-element", "aria-label", "aria-disabled"], Xa = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const a = e, o = me(null);
    return h1(() => a("set-ref", o)), (n, r) => (m(), C("button", {
      ref_key: "elRef",
      ref: o,
      type: "button",
      "data-dp-element": n.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": n.ariaLabel,
      "aria-disabled": n.disabled || void 0,
      onClick: r[0] || (r[0] = (s) => n.$emit("activate")),
      onKeydown: r[1] || (r[1] = (s) => j(T1)(s, () => n.$emit("activate"), !0))
    }, [
      g("span", {
        class: le(["dp__inner_nav", { dp__inner_nav_disabled: n.disabled }])
      }, [
        oe(n.$slots, "default")
      ], 2)
    ], 40, Yf));
  }
}), Wf = ["aria-label", "data-test-id"], $2 = /* @__PURE__ */ J({
  __name: "YearModePicker",
  props: {
    ...ot,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const a = e, o = t, { showRightIcon: n, showLeftIcon: r } = Ln(), { defaultedConfig: s, defaultedMultiCalendars: i, defaultedAriaLabels: l, defaultedTransitions: f, defaultedUI: u } = n1(o), { showTransition: d, transitionName: k } = uo(f), y = me(!1), b = (p = !1, h) => {
      y.value = !y.value, a("toggle-year-picker", { flow: p, show: h });
    }, M = (p) => {
      y.value = !1, a("year-select", p);
    }, c = (p = !1) => {
      a("handle-year", p);
    };
    return (p, h) => {
      var v, H, w, _, L;
      return m(), C(ge, null, [
        g("div", {
          class: le(["dp--year-mode-picker", { "dp--hidden-el": y.value }])
        }, [
          j(r)(j(i), t.instance) ? (m(), he(Xa, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (v = j(l)) == null ? void 0 : v.prevYear,
            disabled: t.isDisabled(!1),
            class: le((H = j(u)) == null ? void 0 : H.navBtnPrev),
            onActivate: h[0] || (h[0] = (I) => c(!1))
          }, {
            default: ue(() => [
              p.$slots["arrow-left"] ? oe(p.$slots, "arrow-left", { key: 0 }) : ae("", !0),
              p.$slots["arrow-left"] ? ae("", !0) : (m(), he(j(Wr), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : ae("", !0),
          g("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${t.year}-${(w = j(l)) == null ? void 0 : w.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${t.instance}`,
            onClick: h[1] || (h[1] = () => b(!1)),
            onKeydown: h[2] || (h[2] = Ae(() => b(!1), ["enter"]))
          }, [
            p.$slots.year ? oe(p.$slots, "year", {
              key: 0,
              year: t.year
            }) : ae("", !0),
            p.$slots.year ? ae("", !0) : (m(), C(ge, { key: 1 }, [
              qe(_e(t.year), 1)
            ], 64))
          ], 40, Wf),
          j(n)(j(i), t.instance) ? (m(), he(Xa, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (_ = j(l)) == null ? void 0 : _.nextYear,
            disabled: t.isDisabled(!0),
            class: le((L = j(u)) == null ? void 0 : L.navBtnNext),
            onActivate: h[3] || (h[3] = (I) => c(!0))
          }, {
            default: ue(() => [
              p.$slots["arrow-right"] ? oe(p.$slots, "arrow-right", { key: 0 }) : ae("", !0),
              p.$slots["arrow-right"] ? ae("", !0) : (m(), he(j(Kr), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : ae("", !0)
        ], 2),
        ye(Va, {
          name: j(k)(t.showYearPicker),
          css: j(d)
        }, {
          default: ue(() => {
            var I, F;
            return [
              t.showYearPicker ? (m(), he(lo, {
                key: 0,
                items: t.items,
                "text-input": p.textInput,
                "esc-close": p.escClose,
                config: p.config,
                "is-last": p.autoApply && !j(s).keepActionRow,
                "hide-navigation": p.hideNavigation,
                "aria-labels": p.ariaLabels,
                "overlay-label": (F = (I = j(l)) == null ? void 0 : I.yearPicker) == null ? void 0 : F.call(I, !0),
                type: "year",
                onToggle: b,
                onSelected: h[4] || (h[4] = (B) => M(B))
              }, f1({
                "button-icon": ue(() => [
                  p.$slots["calendar-icon"] ? oe(p.$slots, "calendar-icon", { key: 0 }) : ae("", !0),
                  p.$slots["calendar-icon"] ? ae("", !0) : (m(), he(j(Pa), { key: 1 }))
                ]),
                _: 2
              }, [
                p.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: ue(({ item: B }) => [
                    oe(p.$slots, "year-overlay-value", {
                      text: B.text,
                      value: B.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : ae("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), n0 = (t, e, a) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((o) => Ie(t, o))) {
      const o = e.value.filter((n) => !Ie(n, t));
      e.value = o.length ? o : null;
    } else (a && +a > e.value.length || !a) && e.value.push(t);
  else
    e.value = [t];
}, r0 = (t, e, a) => {
  let o = t.value ? t.value.slice() : [];
  return o.length === 2 && o[1] !== null && (o = []), o.length ? (i1(e, o[0]) ? o.unshift(e) : o[1] = e, a("range-end", e)) : (o = [e], a("range-start", e)), o;
}, jn = (t, e, a, o) => {
  t && (t[0] && t[1] && a && e("auto-apply"), t[0] && !t[1] && o && a && e("auto-apply"));
}, M2 = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => O1(be(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = O1(be(t.value), t.timezone));
}, V2 = (t, e, a, o) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && o.value.partialRange) ? o.value.fixedStart && (c1(t, e.value[0]) || Ie(t, e.value[0])) ? [e.value[0], t] : o.value.fixedEnd && (i1(t, e.value[1]) || Ie(t, e.value[1])) ? [t, e.value[1]] : (a("invalid-fixed-range", t), e.value) : [], S2 = ({
  multiCalendars: t,
  range: e,
  highlight: a,
  propDates: o,
  calendars: n,
  modelValue: r,
  props: s,
  filters: i,
  year: l,
  month: f,
  emit: u
}) => {
  const d = Q(() => e0(s.yearRange, s.locale, s.reverseYears)), k = me([!1]), y = Q(() => (B, K) => {
    const ee = t1(Q1(/* @__PURE__ */ new Date()), {
      month: f.value(B),
      year: l.value(B)
    }), ve = K ? Ji(ee) : Ja(ee);
    return H2(
      ve,
      o.value.maxDate,
      o.value.minDate,
      s.preventMinMaxNavigation,
      K
    );
  }), b = () => Array.isArray(r.value) && t.value.solo && r.value[1], M = () => {
    for (let B = 0; B < t.value.count; B++)
      if (B === 0)
        n.value[B] = n.value[0];
      else if (B === t.value.count - 1 && b())
        n.value[B] = {
          month: Be(r.value[1]),
          year: Ee(r.value[1])
        };
      else {
        const K = t1(be(), n.value[B - 1]);
        n.value[B] = { month: Be(K), year: Ee(Zr(K, 1)) };
      }
  }, c = (B) => {
    if (!B) return M();
    const K = t1(be(), n.value[B]);
    return n.value[0].year = Ee(p2(K, t.value.count - 1)), M();
  }, p = (B, K) => {
    const ee = tm(K, B);
    return e.value.showLastInRange && ee > 1 ? K : B;
  }, h = (B) => s.focusStartDate || t.value.solo ? B[0] : B[1] ? p(B[0], B[1]) : B[0], v = () => {
    if (r.value) {
      const B = Array.isArray(r.value) ? h(r.value) : r.value;
      n.value[0] = { month: Be(B), year: Ee(B) };
    }
  }, H = () => {
    v(), t.value.count && M();
  };
  Ue(r, (B, K) => {
    s.isTextInputDate && JSON.stringify(B ?? {}) !== JSON.stringify(K ?? {}) && H();
  }), h1(() => {
    H();
  });
  const w = (B, K) => {
    n.value[K].year = B, u("update-month-year", { instance: K, year: B, month: n.value[K].month }), t.value.count && !t.value.solo && c(K);
  }, _ = Q(() => (B) => $a(d.value, (K) => {
    var ee;
    const ve = l.value(B) === K.value, q = eo(
      K.value,
      Ma(o.value.minDate),
      Ma(o.value.maxDate)
    ) || ((ee = i.value.years) == null ? void 0 : ee.includes(l.value(B))), O = o0(a.value, K.value);
    return { active: ve, disabled: q, highlighted: O };
  })), L = (B, K) => {
    w(B, K), F(K);
  }, I = (B, K = !1) => {
    if (!y.value(B, K)) {
      const ee = K ? l.value(B) + 1 : l.value(B) - 1;
      w(ee, B);
    }
  }, F = (B, K = !1, ee) => {
    K || u("reset-flow"), ee !== void 0 ? k.value[B] = ee : k.value[B] = !k.value[B], k.value[B] ? u("overlay-toggle", { open: !0, overlay: M1.year }) : (u("overlay-closed"), u("overlay-toggle", { open: !1, overlay: M1.year }));
  };
  return {
    isDisabled: y,
    groupedYears: _,
    showYearPicker: k,
    selectYear: w,
    toggleYearPicker: F,
    handleYearSelect: L,
    handleYear: I
  };
}, Kf = (t, e) => {
  const {
    defaultedMultiCalendars: a,
    defaultedAriaLabels: o,
    defaultedTransitions: n,
    defaultedConfig: r,
    defaultedRange: s,
    defaultedHighlight: i,
    propDates: l,
    defaultedTz: f,
    defaultedFilters: u,
    defaultedMultiDates: d
  } = n1(t), k = () => {
    t.isTextInputDate && H(Ee(be(t.startDate)), 0);
  }, { modelValue: y, year: b, month: M, calendars: c } = co(t, e, k), p = Q(() => h2(t.formatLocale, t.locale, t.monthNameFormat)), h = me(null), { checkMinMaxRange: v } = It(t), {
    selectYear: H,
    groupedYears: w,
    showYearPicker: _,
    toggleYearPicker: L,
    handleYearSelect: I,
    handleYear: F,
    isDisabled: B
  } = S2({
    modelValue: y,
    multiCalendars: a,
    range: s,
    highlight: i,
    calendars: c,
    year: b,
    propDates: l,
    month: M,
    filters: u,
    props: t,
    emit: e
  });
  h1(() => {
    t.startDate && (y.value && t.focusStartDate || !y.value) && H(Ee(be(t.startDate)), 0);
  });
  const K = (x) => x ? { month: Be(x), year: Ee(x) } : { month: null, year: null }, ee = () => y.value ? Array.isArray(y.value) ? y.value.map((x) => K(x)) : K(y.value) : K(), ve = (x, A) => {
    const N = c.value[x], $ = ee();
    return Array.isArray($) ? $.some((W) => W.year === N?.year && W.month === A) : N?.year === $.year && A === $.month;
  }, q = (x, A, N) => {
    var $, W;
    const fe = ee();
    return Array.isArray(fe) ? b.value(A) === (($ = fe[N]) == null ? void 0 : $.year) && x === ((W = fe[N]) == null ? void 0 : W.month) : !1;
  }, O = (x, A) => {
    if (s.value.enabled) {
      const N = ee();
      if (Array.isArray(y.value) && Array.isArray(N)) {
        const $ = q(x, A, 0) || q(x, A, 1), W = Ct(Q1(be()), x, b.value(A));
        return to(y.value, h.value, W) && !$;
      }
      return !1;
    }
    return !1;
  }, Y = Q(() => (x) => $a(p.value, (A) => {
    var N;
    const $ = ve(x, A.value), W = eo(
      A.value,
      k2(b.value(x), l.value.minDate),
      C2(b.value(x), l.value.maxDate)
    ) || yf(l.value.disabledDates, b.value(x), A.value) || ((N = u.value.months) == null ? void 0 : N.includes(A.value)) || !bf(l.value.allowedDates, b.value(x), A.value), fe = O(A.value, x), Le = L2(i.value, A.value, b.value(x));
    return { active: $, disabled: W, isBetween: fe, highlighted: Le };
  })), U = (x, A) => Ct(Q1(be()), x, b.value(A)), ne = (x, A) => {
    const N = y.value ? y.value : Q1(/* @__PURE__ */ new Date());
    y.value = Ct(N, x, b.value(A)), e("auto-apply"), e("update-flow-step");
  }, te = (x, A) => {
    const N = U(x, A);
    s.value.fixedEnd || s.value.fixedStart ? y.value = V2(N, y, e, s) : y.value ? v(N, y.value) && (y.value = r0(y, U(x, A), e)) : y.value = [U(x, A)], p1().then(() => {
      jn(y.value, e, t.autoApply, t.modelAuto);
    });
  }, G = (x, A) => {
    n0(U(x, A), y, d.value.limit), e("auto-apply", !0);
  }, T = (x, A) => (c.value[A].month = x, D(A, c.value[A].year, x), d.value.enabled ? G(x, A) : s.value.enabled ? te(x, A) : ne(x, A)), Z = (x, A) => {
    H(x, A), D(A, x, null);
  }, D = (x, A, N) => {
    let $ = N;
    if (!$ && $ !== 0) {
      const W = ee();
      $ = Array.isArray(W) ? W[x].month : W.month;
    }
    e("update-month-year", { instance: x, year: A, month: $ });
  };
  return {
    groupedMonths: Y,
    groupedYears: w,
    year: b,
    isDisabled: B,
    defaultedMultiCalendars: a,
    defaultedAriaLabels: o,
    defaultedTransitions: n,
    defaultedConfig: r,
    showYearPicker: _,
    modelValue: y,
    presetDate: (x, A) => {
      M2({
        value: x,
        modelValue: y,
        range: s.value.enabled,
        timezone: A ? void 0 : f.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (x, A) => {
      h.value = U(x, A);
    },
    selectMonth: T,
    selectYear: Z,
    toggleYearPicker: L,
    handleYearSelect: I,
    handleYear: F,
    getModelMonthYear: ee
  };
}, Gf = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...ot
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = _t(), r = Z1(n, "yearMode"), s = t;
    h1(() => {
      s.shadow || o("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: l,
      year: f,
      isDisabled: u,
      defaultedMultiCalendars: d,
      defaultedConfig: k,
      showYearPicker: y,
      modelValue: b,
      presetDate: M,
      setHoverDate: c,
      selectMonth: p,
      selectYear: h,
      toggleYearPicker: v,
      handleYearSelect: H,
      handleYear: w,
      getModelMonthYear: _
    } = Kf(s, o);
    return e({ getSidebarProps: () => ({
      modelValue: b,
      year: f,
      getModelMonthYear: _,
      selectMonth: p,
      selectYear: h,
      handleYear: w
    }), presetDate: M, toggleYearPicker: (L) => v(0, L) }), (L, I) => (m(), he(Hn, {
      "multi-calendars": j(d).count,
      collapse: L.collapse,
      stretch: "",
      "is-mobile": L.isMobile
    }, {
      default: ue(({ instance: F }) => [
        L.$slots["top-extra"] ? oe(L.$slots, "top-extra", {
          key: 0,
          value: L.internalModelValue
        }) : ae("", !0),
        L.$slots["month-year"] ? oe(L.$slots, "month-year", v1(Re({ key: 1 }, {
          year: j(f),
          months: j(i)(F),
          years: j(l)(F),
          selectMonth: j(p),
          selectYear: j(h),
          instance: F
        }))) : (m(), he(lo, {
          key: 2,
          items: j(i)(F),
          "arrow-navigation": L.arrowNavigation,
          "is-last": L.autoApply && !j(k).keepActionRow,
          "esc-close": L.escClose,
          height: j(k).modeHeight,
          config: L.config,
          "no-overlay-focus": !!(L.noOverlayFocus || L.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (B) => j(p)(B, F),
          onHoverValue: (B) => j(c)(B, F)
        }, f1({
          header: ue(() => [
            ye($2, Re(L.$props, {
              items: j(l)(F),
              instance: F,
              "show-year-picker": j(y)[F],
              year: j(f)(F),
              "is-disabled": (B) => j(u)(F, B),
              onHandleYear: (B) => j(w)(F, B),
              onYearSelect: (B) => j(H)(B, F),
              onToggleYearPicker: (B) => j(v)(F, B?.flow, B?.show)
            }), f1({ _: 2 }, [
              De(j(r), (B, K) => ({
                name: B,
                fn: ue((ee) => [
                  oe(L.$slots, B, v1(V1(ee)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          L.$slots["month-overlay-value"] ? {
            name: "item",
            fn: ue(({ item: B }) => [
              oe(L.$slots, "month-overlay-value", {
                text: B.text,
                value: B.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Xf = (t, e) => {
  const a = () => {
    t.isTextInputDate && (u.value = Ee(be(t.startDate)));
  }, { modelValue: o } = co(t, e, a), n = me(null), { defaultedHighlight: r, defaultedMultiDates: s, defaultedFilters: i, defaultedRange: l, propDates: f } = n1(t), u = me();
  h1(() => {
    t.startDate && (o.value && t.focusStartDate || !o.value) && (u.value = Ee(be(t.startDate)));
  });
  const d = (p) => Array.isArray(o.value) ? o.value.some((h) => Ee(h) === p) : o.value ? Ee(o.value) === p : !1, k = (p) => l.value.enabled && Array.isArray(o.value) ? to(o.value, n.value, c(p)) : !1, y = (p) => f.value.allowedDates instanceof Map ? f.value.allowedDates.size ? f.value.allowedDates.has(`${p}`) : !1 : !0, b = (p) => f.value.disabledDates instanceof Map ? f.value.disabledDates.size ? f.value.disabledDates.has(`${p}`) : !1 : !0, M = Q(() => $a(e0(t.yearRange, t.locale, t.reverseYears), (p) => {
    const h = d(p.value), v = eo(
      p.value,
      Ma(f.value.minDate),
      Ma(f.value.maxDate)
    ) || i.value.years.includes(p.value) || !y(p.value) || b(p.value), H = k(p.value) && !h, w = o0(r.value, p.value);
    return { active: h, disabled: v, isBetween: H, highlighted: w };
  })), c = (p) => mt(Q1(Ja(/* @__PURE__ */ new Date())), p);
  return {
    groupedYears: M,
    modelValue: o,
    focusYear: u,
    setHoverValue: (p) => {
      n.value = mt(Q1(/* @__PURE__ */ new Date()), p);
    },
    selectYear: (p) => {
      var h;
      if (e("update-month-year", { instance: 0, year: p }), s.value.enabled)
        return o.value ? Array.isArray(o.value) && (((h = o.value) == null ? void 0 : h.map((v) => Ee(v))).includes(p) ? o.value = o.value.filter((v) => Ee(v) !== p) : o.value.push(mt(x1(be()), p))) : o.value = [mt(x1(Ja(be())), p)], e("auto-apply", !0);
      l.value.enabled ? (o.value = r0(o, c(p), e), p1().then(() => {
        jn(o.value, e, t.autoApply, t.modelAuto);
      })) : (o.value = c(p), e("auto-apply"));
    }
  };
}, Qf = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...ot
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, { groupedYears: r, modelValue: s, focusYear: i, selectYear: l, setHoverValue: f } = Xf(n, o), { defaultedConfig: u } = n1(n);
    return e({ getSidebarProps: () => ({
      modelValue: s,
      selectYear: l
    }) }), (d, k) => (m(), C("div", null, [
      d.$slots["top-extra"] ? oe(d.$slots, "top-extra", {
        key: 0,
        value: d.internalModelValue
      }) : ae("", !0),
      d.$slots["month-year"] ? oe(d.$slots, "month-year", v1(Re({ key: 1 }, {
        years: j(r),
        selectYear: j(l)
      }))) : (m(), he(lo, {
        key: 2,
        items: j(r),
        "is-last": d.autoApply && !j(u).keepActionRow,
        height: j(u).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": j(i),
        type: "year",
        "use-relative": "",
        onSelected: j(l),
        onHoverValue: j(f)
      }, f1({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ue(({ item: y }) => [
            oe(d.$slots, "year-overlay-value", {
              text: y.text,
              value: y.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), Jf = {
  key: 0,
  class: "dp__time_input"
}, eh = ["data-compact", "data-collapsed"], th = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], ah = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], oh = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], nh = { key: 0 }, rh = ["aria-label", "data-compact"], sh = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...ot
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, { setTimePickerElements: r, setTimePickerBackRef: s } = Bt(), {
      defaultedAriaLabels: i,
      defaultedTransitions: l,
      defaultedFilters: f,
      defaultedConfig: u,
      defaultedRange: d,
      defaultedMultiCalendars: k
    } = n1(n), { transitionName: y, showTransition: b } = uo(l), M = so({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), c = me("AM"), p = me(null), h = me([]), v = me(), H = me(!1);
    h1(() => {
      o("mounted");
    });
    const w = (S) => t1(/* @__PURE__ */ new Date(), {
      hours: S.hours,
      minutes: S.minutes,
      seconds: n.enableSeconds ? S.seconds : 0,
      milliseconds: 0
    }), _ = Q(
      () => (S) => te(S, n[S]) || I(S, n[S])
    ), L = Q(() => ({ hours: n.hours, minutes: n.minutes, seconds: n.seconds })), I = (S, R) => d.value.enabled && !d.value.disableTimeRangeValidation ? !n.validateTime(S, R) : !1, F = (S, R) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const ie = R ? +n[`${S}Increment`] : -+n[`${S}Increment`], de = n[S] + ie;
        return !n.validateTime(S, de);
      }
      return !1;
    }, B = Q(() => (S) => !x(+n[S] + +n[`${S}Increment`], S) || F(S, !0)), K = Q(() => (S) => !x(+n[S] - +n[`${S}Increment`], S) || F(S, !1)), ee = (S, R) => Yi(t1(be(), S), R), ve = (S, R) => Gp(t1(be(), S), R), q = Q(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !n.timePickerInline,
        dp__time_col_reg_block: !n.enableSeconds && n.is24 && !n.timePickerInline,
        dp__time_col_reg_inline: !n.enableSeconds && n.is24 && n.timePickerInline,
        dp__time_col_reg_with_button: !n.enableSeconds && !n.is24,
        dp__time_col_sec: n.enableSeconds && n.is24,
        dp__time_col_sec_with_button: n.enableSeconds && !n.is24
      })
    ), O = Q(
      () => n.timePickerInline && d.value.enabled && !k.value.count
    ), Y = Q(() => {
      const S = [{ type: "hours" }];
      return n.enableMinutes && S.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), n.enableSeconds && S.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), S;
    }), U = Q(() => Y.value.filter((S) => !S.separator)), ne = Q(() => (S) => {
      if (S === "hours") {
        const R = Le(+n.hours);
        return { text: R < 10 ? `0${R}` : `${R}`, value: R };
      }
      return { text: n[S] < 10 ? `0${n[S]}` : `${n[S]}`, value: n[S] };
    }), te = (S, R) => {
      var ie;
      if (!n.disabledTimesConfig) return !1;
      const de = n.disabledTimesConfig(n.order, S === "hours" ? R : void 0);
      return de[S] ? !!((ie = de[S]) != null && ie.includes(R)) : !0;
    }, G = (S, R) => R !== "hours" || c.value === "AM" ? S : S + 12, T = (S) => {
      const R = n.is24 ? 24 : 12, ie = S === "hours" ? R : 60, de = +n[`${S}GridIncrement`], Ce = S === "hours" && !n.is24 ? de : 0, He = [];
      for (let X = Ce; X < ie; X += de)
        He.push({ value: n.is24 ? X : G(X, S), text: X < 10 ? `0${X}` : `${X}` });
      return S === "hours" && !n.is24 && He.unshift({ value: c.value === "PM" ? 12 : 0, text: "12" }), $a(He, (X) => ({ active: !1, disabled: f.value.times[S].includes(X.value) || !x(X.value, S) || te(S, X.value) || I(S, X.value) }));
    }, Z = (S) => S >= 0 ? S : 59, D = (S) => S >= 0 ? S : 23, x = (S, R) => {
      const ie = n.minTime ? w(ar(n.minTime)) : null, de = n.maxTime ? w(ar(n.maxTime)) : null, Ce = w(
        ar(
          L.value,
          R,
          R === "minutes" || R === "seconds" ? Z(S) : D(S)
        )
      );
      return ie && de ? (La(Ce, de) || ba(Ce, de)) && (aa(Ce, ie) || ba(Ce, ie)) : ie ? aa(Ce, ie) || ba(Ce, ie) : de ? La(Ce, de) || ba(Ce, de) : !0;
    }, A = (S) => n[`no${S[0].toUpperCase() + S.slice(1)}Overlay`], N = (S) => {
      A(S) || (M[S] = !M[S], M[S] ? (H.value = !0, o("overlay-opened", S)) : (H.value = !1, o("overlay-closed", S)));
    }, $ = (S) => S === "hours" ? wt : S === "minutes" ? Tt : ja, W = () => {
      v.value && clearTimeout(v.value);
    }, fe = (S, R = !0, ie) => {
      const de = R ? ee : ve, Ce = R ? +n[`${S}Increment`] : -+n[`${S}Increment`];
      x(+n[S] + Ce, S) && o(
        `update:${S}`,
        $(S)(de({ [S]: +n[S] }, { [S]: +n[`${S}Increment`] }))
      ), !(ie != null && ie.keyboard) && u.value.timeArrowHoldThreshold && (v.value = setTimeout(() => {
        fe(S, R);
      }, u.value.timeArrowHoldThreshold));
    }, Le = (S) => n.is24 ? S : (S >= 12 ? c.value = "PM" : c.value = "AM", of(S)), z = () => {
      c.value === "PM" ? (c.value = "AM", o("update:hours", n.hours - 12)) : (c.value = "PM", o("update:hours", n.hours + 12)), o("am-pm-change", c.value);
    }, P = (S) => {
      M[S] = !0;
    }, V = (S, R, ie) => {
      if (S && n.arrowNavigation) {
        Array.isArray(h.value[R]) ? h.value[R][ie] = S : h.value[R] = [S];
        const de = h.value.reduce(
          (Ce, He) => He.map((X, ce) => [...Ce[ce] || [], He[ce]]),
          []
        );
        s(n.closeTimePickerBtn), p.value && (de[1] = de[1].concat(p.value)), r(de, n.order);
      }
    }, E = (S, R) => (N(S), o(`update:${S}`, R));
    return e({ openChildCmp: P }), (S, R) => {
      var ie;
      return S.disabled ? ae("", !0) : (m(), C("div", Jf, [
        (m(!0), C(ge, null, De(Y.value, (de, Ce) => {
          var He, X, ce;
          return m(), C("div", {
            key: Ce,
            class: le(q.value),
            "data-compact": O.value && !S.enableSeconds,
            "data-collapsed": O.value && S.enableSeconds
          }, [
            de.separator ? (m(), C(ge, { key: 0 }, [
              H.value ? ae("", !0) : (m(), C(ge, { key: 0 }, [
                qe(":")
              ], 64))
            ], 64)) : (m(), C(ge, { key: 1 }, [
              g("button", {
                ref_for: !0,
                ref: (je) => V(je, Ce, 0),
                type: "button",
                class: le({
                  dp__btn: !0,
                  dp__inc_dec_button: !S.timePickerInline,
                  dp__inc_dec_button_inline: S.timePickerInline,
                  dp__tp_inline_btn_top: S.timePickerInline,
                  dp__inc_dec_button_disabled: B.value(de.type),
                  "dp--hidden-el": H.value
                }),
                "data-test-id": `${de.type}-time-inc-btn-${n.order}`,
                "aria-label": (He = j(i)) == null ? void 0 : He.incrementValue(de.type),
                tabindex: "0",
                onKeydown: (je) => j(T1)(je, () => fe(de.type, !0, { keyboard: !0 }), !0),
                onClick: (je) => j(u).timeArrowHoldThreshold ? void 0 : fe(de.type, !0),
                onMousedown: (je) => j(u).timeArrowHoldThreshold ? fe(de.type, !0) : void 0,
                onMouseup: W
              }, [
                n.timePickerInline ? (m(), C(ge, { key: 1 }, [
                  S.$slots["tp-inline-arrow-up"] ? oe(S.$slots, "tp-inline-arrow-up", { key: 0 }) : (m(), C(ge, { key: 1 }, [
                    R[2] || (R[2] = g("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    R[3] || (R[3] = g("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (m(), C(ge, { key: 0 }, [
                  S.$slots["arrow-up"] ? oe(S.$slots, "arrow-up", { key: 0 }) : ae("", !0),
                  S.$slots["arrow-up"] ? ae("", !0) : (m(), he(j(Xr), { key: 1 }))
                ], 64))
              ], 42, th),
              g("button", {
                ref_for: !0,
                ref: (je) => V(je, Ce, 1),
                type: "button",
                "aria-label": `${ne.value(de.type).text}-${(X = j(i)) == null ? void 0 : X.openTpOverlay(de.type)}`,
                class: le({
                  dp__time_display: !0,
                  dp__time_display_block: !S.timePickerInline,
                  dp__time_display_inline: S.timePickerInline,
                  "dp--time-invalid": _.value(de.type),
                  "dp--time-overlay-btn": !_.value(de.type),
                  "dp--hidden-el": H.value
                }),
                disabled: A(de.type),
                tabindex: "0",
                "data-test-id": `${de.type}-toggle-overlay-btn-${n.order}`,
                onKeydown: (je) => j(T1)(je, () => N(de.type), !0),
                onClick: (je) => N(de.type)
              }, [
                S.$slots[de.type] ? oe(S.$slots, de.type, {
                  key: 0,
                  text: ne.value(de.type).text,
                  value: ne.value(de.type).value
                }) : ae("", !0),
                S.$slots[de.type] ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                  qe(_e(ne.value(de.type).text), 1)
                ], 64))
              ], 42, ah),
              g("button", {
                ref_for: !0,
                ref: (je) => V(je, Ce, 2),
                type: "button",
                class: le({
                  dp__btn: !0,
                  dp__inc_dec_button: !S.timePickerInline,
                  dp__inc_dec_button_inline: S.timePickerInline,
                  dp__tp_inline_btn_bottom: S.timePickerInline,
                  dp__inc_dec_button_disabled: K.value(de.type),
                  "dp--hidden-el": H.value
                }),
                "data-test-id": `${de.type}-time-dec-btn-${n.order}`,
                "aria-label": (ce = j(i)) == null ? void 0 : ce.decrementValue(de.type),
                tabindex: "0",
                onKeydown: (je) => j(T1)(je, () => fe(de.type, !1, { keyboard: !0 }), !0),
                onClick: (je) => j(u).timeArrowHoldThreshold ? void 0 : fe(de.type, !1),
                onMousedown: (je) => j(u).timeArrowHoldThreshold ? fe(de.type, !1) : void 0,
                onMouseup: W
              }, [
                n.timePickerInline ? (m(), C(ge, { key: 1 }, [
                  S.$slots["tp-inline-arrow-down"] ? oe(S.$slots, "tp-inline-arrow-down", { key: 0 }) : (m(), C(ge, { key: 1 }, [
                    R[4] || (R[4] = g("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    R[5] || (R[5] = g("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (m(), C(ge, { key: 0 }, [
                  S.$slots["arrow-down"] ? oe(S.$slots, "arrow-down", { key: 0 }) : ae("", !0),
                  S.$slots["arrow-down"] ? ae("", !0) : (m(), he(j(Qr), { key: 1 }))
                ], 64))
              ], 42, oh)
            ], 64))
          ], 10, eh);
        }), 128)),
        S.is24 ? ae("", !0) : (m(), C("div", nh, [
          S.$slots["am-pm-button"] ? oe(S.$slots, "am-pm-button", {
            key: 0,
            toggle: z,
            value: c.value
          }) : ae("", !0),
          S.$slots["am-pm-button"] ? ae("", !0) : (m(), C("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: p,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (ie = j(i)) == null ? void 0 : ie.amPmButton,
            tabindex: "0",
            "data-compact": O.value,
            onClick: z,
            onKeydown: R[0] || (R[0] = (de) => j(T1)(de, () => z(), !0))
          }, _e(c.value), 41, rh))
        ])),
        (m(!0), C(ge, null, De(U.value, (de, Ce) => (m(), he(Va, {
          key: Ce,
          name: j(y)(M[de.type]),
          css: j(b)
        }, {
          default: ue(() => {
            var He, X;
            return [
              M[de.type] ? (m(), he(lo, {
                key: 0,
                items: T(de.type),
                "is-last": S.autoApply && !j(u).keepActionRow,
                "esc-close": S.escClose,
                type: de.type,
                "text-input": S.textInput,
                config: S.config,
                "arrow-navigation": S.arrowNavigation,
                "aria-labels": S.ariaLabels,
                "overlay-label": (X = (He = j(i)).timeOverlay) == null ? void 0 : X.call(He, de.type),
                onSelected: (ce) => E(de.type, ce),
                onToggle: (ce) => N(de.type),
                onResetFlow: R[1] || (R[1] = (ce) => S.$emit("reset-flow"))
              }, f1({
                "button-icon": ue(() => [
                  S.$slots["clock-icon"] ? oe(S.$slots, "clock-icon", { key: 0 }) : ae("", !0),
                  S.$slots["clock-icon"] ? ae("", !0) : (m(), he(S1(S.timePickerInline ? j(Pa) : j(Gr)), { key: 1 }))
                ]),
                _: 2
              }, [
                S.$slots[`${de.type}-overlay-value`] ? {
                  name: "item",
                  fn: ue(({ item: ce }) => [
                    oe(S.$slots, `${de.type}-overlay-value`, {
                      text: ce.text,
                      value: ce.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                S.$slots[`${de.type}-overlay-header`] ? {
                  name: "header",
                  fn: ue(() => [
                    oe(S.$slots, `${de.type}-overlay-header`, {
                      toggle: () => N(de.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : ae("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), ih = ["data-dp-mobile"], lh = ["aria-label", "tabindex"], uh = ["role", "aria-label", "tabindex"], ch = ["aria-label"], A2 = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...ot
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, { buildMatrix: r, setTimePicker: s } = Bt(), i = _t(), { defaultedTransitions: l, defaultedAriaLabels: f, defaultedTextInput: u, defaultedConfig: d, defaultedRange: k } = n1(n), { transitionName: y, showTransition: b } = uo(l), { hideNavigationButtons: M } = Ln(), c = me(null), p = me(null), h = me([]), v = me(null), H = me(!1);
    h1(() => {
      o("mount"), !n.timePicker && n.arrowNavigation ? r([y1(c.value)], "time") : s(!0, n.timePicker);
    });
    const w = Q(() => k.value.enabled && n.modelAuto ? v2(n.internalModelValue) : !0), _ = me(!1), L = (te) => ({
      hours: Array.isArray(n.hours) ? n.hours[te] : n.hours,
      minutes: Array.isArray(n.minutes) ? n.minutes[te] : n.minutes,
      seconds: Array.isArray(n.seconds) ? n.seconds[te] : n.seconds
    }), I = Q(() => {
      const te = [];
      if (k.value.enabled)
        for (let G = 0; G < 2; G++)
          te.push(L(G));
      else
        te.push(L(0));
      return te;
    }), F = (te, G = !1, T = "") => {
      G || o("reset-flow"), _.value = te, o(te ? "overlay-opened" : "overlay-closed", M1.time), n.arrowNavigation && s(te), p1(() => {
        T !== "" && h.value[0] && h.value[0].openChildCmp(T);
      });
    }, B = Q(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: n.autoApply && !d.value.keepActionRow
    })), K = Z1(i, "timePicker"), ee = (te, G, T) => k.value.enabled ? G === 0 ? [te, I.value[1][T]] : [I.value[0][T], te] : te, ve = (te) => {
      o("update:hours", te);
    }, q = (te) => {
      o("update:minutes", te);
    }, O = (te) => {
      o("update:seconds", te);
    }, Y = () => {
      if (v.value && !u.value.enabled && !n.noOverlayFocus) {
        const te = g2(v.value);
        te && te.focus({ preventScroll: !0 });
      }
    }, U = (te) => {
      H.value = !1, o("overlay-closed", te);
    }, ne = (te) => {
      H.value = !0, o("overlay-opened", te);
    };
    return e({ toggleTimePicker: F }), (te, G) => {
      var T;
      return m(), C("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": te.isMobile
      }, [
        !te.timePicker && !te.timePickerInline ? Ne((m(), C("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: c,
          type: "button",
          class: le({ ...B.value, "dp--hidden-el": _.value }),
          "aria-label": (T = j(f)) == null ? void 0 : T.openTimePicker,
          tabindex: te.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: G[0] || (G[0] = (Z) => j(T1)(Z, () => F(!0))),
          onClick: G[1] || (G[1] = (Z) => F(!0))
        }, [
          te.$slots["clock-icon"] ? oe(te.$slots, "clock-icon", { key: 0 }) : ae("", !0),
          te.$slots["clock-icon"] ? ae("", !0) : (m(), he(j(Gr), { key: 1 }))
        ], 42, lh)), [
          [L1, !j(M)(te.hideNavigation, "time")]
        ]) : ae("", !0),
        ye(Va, {
          name: j(y)(_.value),
          css: j(b) && !te.timePickerInline
        }, {
          default: ue(() => {
            var Z, D;
            return [
              _.value || te.timePicker || te.timePickerInline ? (m(), C("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: v,
                role: te.timePickerInline ? void 0 : "dialog",
                class: le({
                  dp__overlay: !te.timePickerInline,
                  "dp--overlay-absolute": !n.timePicker && !te.timePickerInline,
                  "dp--overlay-relative": n.timePicker
                }),
                style: w1(te.timePicker ? { height: `${j(d).modeHeight}px` } : void 0),
                "aria-label": (Z = j(f)) == null ? void 0 : Z.timePicker,
                tabindex: te.timePickerInline ? void 0 : 0
              }, [
                g("div", {
                  class: le(
                    te.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  te.$slots["time-picker-overlay"] ? oe(te.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: ve,
                    setMinutes: q,
                    setSeconds: O
                  }) : ae("", !0),
                  te.$slots["time-picker-overlay"] ? ae("", !0) : (m(), C("div", {
                    key: 1,
                    class: le(te.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (m(!0), C(ge, null, De(I.value, (x, A) => Ne((m(), he(sh, Re({
                      key: A,
                      ref_for: !0
                    }, {
                      ...te.$props,
                      order: A,
                      hours: x.hours,
                      minutes: x.minutes,
                      seconds: x.seconds,
                      closeTimePickerBtn: p.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: A === 0 ? j(k).fixedStart : j(k).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: h,
                      "validate-time": (N, $) => t.validateTime(N, ee($, A, N)),
                      "onUpdate:hours": (N) => ve(ee(N, A, "hours")),
                      "onUpdate:minutes": (N) => q(ee(N, A, "minutes")),
                      "onUpdate:seconds": (N) => O(ee(N, A, "seconds")),
                      onMounted: Y,
                      onOverlayClosed: U,
                      onOverlayOpened: ne,
                      onAmPmChange: G[2] || (G[2] = (N) => te.$emit("am-pm-change", N))
                    }), f1({ _: 2 }, [
                      De(j(K), (N, $) => ({
                        name: N,
                        fn: ue((W) => [
                          oe(te.$slots, N, Re({ ref_for: !0 }, W))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [L1, A === 0 ? !0 : w.value]
                    ])), 128))
                  ], 2)),
                  !te.timePicker && !te.timePickerInline ? Ne((m(), C("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: p,
                    type: "button",
                    class: le({ ...B.value, "dp--hidden-el": H.value }),
                    "aria-label": (D = j(f)) == null ? void 0 : D.closeTimePicker,
                    tabindex: "0",
                    onKeydown: G[3] || (G[3] = (x) => j(T1)(x, () => F(!1))),
                    onClick: G[4] || (G[4] = (x) => F(!1))
                  }, [
                    te.$slots["calendar-icon"] ? oe(te.$slots, "calendar-icon", { key: 0 }) : ae("", !0),
                    te.$slots["calendar-icon"] ? ae("", !0) : (m(), he(j(Pa), { key: 1 }))
                  ], 42, ch)), [
                    [L1, !j(M)(te.hideNavigation, "time")]
                  ]) : ae("", !0)
                ], 2)
              ], 14, uh)) : ae("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, ih);
    };
  }
}), E2 = (t, e, a, o) => {
  const { defaultedRange: n } = n1(t), r = (v, H) => Array.isArray(e[v]) ? e[v][H] : e[v], s = (v) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[v] : e.seconds : 0, i = (v, H) => v ? H !== void 0 ? zt(v, r("hours", H), r("minutes", H), s(H)) : zt(v, e.hours, e.minutes, s()) : m2(be(), s(H)), l = (v, H) => {
    e[v] = H;
  }, f = Q(() => t.modelAuto && n.value.enabled ? Array.isArray(a.value) ? a.value.length > 1 : !1 : n.value.enabled), u = (v, H) => {
    const w = Object.fromEntries(
      Object.keys(e).map((_) => _ === v ? [_, H] : [_, e[_]].slice())
    );
    if (f.value && !n.value.disableTimeRangeValidation) {
      const _ = (I) => a.value ? zt(
        a.value[I],
        w.hours[I],
        w.minutes[I],
        w.seconds[I]
      ) : null, L = (I) => d2(a.value[I], 0);
      return !(Ie(_(0), _(1)) && (aa(_(0), L(1)) || La(_(1), L(0))));
    }
    return !0;
  }, d = (v, H) => {
    u(v, H) && (l(v, H), o && o());
  }, k = (v) => {
    d("hours", v);
  }, y = (v) => {
    d("minutes", v);
  }, b = (v) => {
    d("seconds", v);
  }, M = (v, H, w, _) => {
    H && k(v), !H && !w && y(v), w && b(v), a.value && _(a.value);
  }, c = (v) => {
    if (v) {
      const H = Array.isArray(v), w = H ? [+v[0].hours, +v[1].hours] : +v.hours, _ = H ? [+v[0].minutes, +v[1].minutes] : +v.minutes, L = H ? [+v[0].seconds, +v[1].seconds] : +v.seconds;
      l("hours", w), l("minutes", _), t.enableSeconds && l("seconds", L);
    }
  }, p = (v, H) => {
    const w = {
      hours: Array.isArray(e.hours) ? e.hours[v] : e.hours,
      disabledArr: []
    };
    return (H || H === 0) && (w.hours = H), Array.isArray(t.disabledTimes) && (w.disabledArr = n.value.enabled && Array.isArray(t.disabledTimes[v]) ? t.disabledTimes[v] : t.disabledTimes), w;
  }, h = Q(() => (v, H) => {
    var w;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: _, hours: L } = p(v, H), I = _.filter((F) => +F.hours === L);
      return ((w = I[0]) == null ? void 0 : w.minutes) === "*" ? { hours: [L], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: I?.map((F) => +F.minutes) ?? [],
        seconds: I?.map((F) => F.seconds ? +F.seconds : void 0) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: k,
    updateMinutes: y,
    updateSeconds: b,
    getSetDateTime: i,
    updateTimeValues: M,
    getSecondsValue: s,
    assignStartTime: c,
    validateTime: u,
    disabledTimesConfig: h
  };
}, dh = (t, e) => {
  const a = () => {
    t.isTextInputDate && H();
  }, { modelValue: o, time: n } = co(t, e, a), { defaultedStartTime: r, defaultedRange: s, defaultedTz: i } = n1(t), { updateTimeValues: l, getSetDateTime: f, setTime: u, assignStartTime: d, disabledTimesConfig: k, validateTime: y } = E2(t, n, o, b);
  function b() {
    e("update-flow-step");
  }
  const M = (_) => {
    const { hours: L, minutes: I, seconds: F } = _;
    return { hours: +L, minutes: +I, seconds: F ? +F : 0 };
  }, c = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const L = M(t.startTime[0]), I = M(t.startTime[1]);
        return [t1(be(), L), t1(be(), I)];
      }
      const _ = M(t.startTime);
      return t1(be(), _);
    }
    return s.value.enabled ? [null, null] : null;
  }, p = () => {
    if (s.value.enabled) {
      const [_, L] = c();
      o.value = [
        O1(f(_, 0), i.value.timezone),
        O1(f(L, 1), i.value.timezone)
      ];
    } else
      o.value = O1(f(c()), i.value.timezone);
  }, h = (_) => Array.isArray(_) ? [Qt(be(_[0])), Qt(be(_[1]))] : [Qt(_ ?? be())], v = (_, L, I) => {
    u("hours", _), u("minutes", L), u("seconds", t.enableSeconds ? I : 0);
  }, H = () => {
    const [_, L] = h(o.value);
    return s.value.enabled ? v(
      [_.hours, L.hours],
      [_.minutes, L.minutes],
      [_.seconds, L.seconds]
    ) : v(_.hours, _.minutes, _.seconds);
  };
  h1(() => {
    if (!t.shadow)
      return d(r.value), o.value ? H() : p();
  });
  const w = () => {
    Array.isArray(o.value) ? o.value = o.value.map((_, L) => _ && f(_, L)) : o.value = f(o.value), e("time-update");
  };
  return {
    modelValue: o,
    time: n,
    disabledTimesConfig: k,
    updateTime: (_, L = !0, I = !1) => {
      l(_, L, I, w);
    },
    validateTime: y
  };
}, mh = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...ot
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, r = _t(), s = Z1(r, "timePicker"), i = me(null), { time: l, modelValue: f, disabledTimesConfig: u, updateTime: d, validateTime: k } = dh(n, o);
    return h1(() => {
      n.shadow || o("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: f,
      time: l,
      updateTime: d
    }), toggleTimePicker: (y, b = !1, M = "") => {
      var c;
      (c = i.value) == null || c.toggleTimePicker(y, b, M);
    } }), (y, b) => (m(), he(Hn, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": y.isMobile
    }, {
      default: ue(() => [
        ye(A2, Re({
          ref_key: "tpRef",
          ref: i
        }, y.$props, {
          hours: j(l).hours,
          minutes: j(l).minutes,
          seconds: j(l).seconds,
          "internal-model-value": y.internalModelValue,
          "disabled-times-config": j(u),
          "validate-time": j(k),
          "onUpdate:hours": b[0] || (b[0] = (M) => j(d)(M)),
          "onUpdate:minutes": b[1] || (b[1] = (M) => j(d)(M, !1)),
          "onUpdate:seconds": b[2] || (b[2] = (M) => j(d)(M, !1, !0)),
          onAmPmChange: b[3] || (b[3] = (M) => y.$emit("am-pm-change", M)),
          onResetFlow: b[4] || (b[4] = (M) => y.$emit("reset-flow")),
          onOverlayClosed: b[5] || (b[5] = (M) => y.$emit("overlay-toggle", { open: !1, overlay: M })),
          onOverlayOpened: b[6] || (b[6] = (M) => y.$emit("overlay-toggle", { open: !0, overlay: M }))
        }), f1({ _: 2 }, [
          De(j(s), (M, c) => ({
            name: M,
            fn: ue((p) => [
              oe(y.$slots, M, v1(V1(p)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), ph = { class: "dp--header-wrap" }, fh = {
  key: 0,
  class: "dp__month_year_wrap"
}, hh = { key: 0 }, vh = { class: "dp__month_year_wrap" }, gh = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], yh = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...ot
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, {
      defaultedTransitions: r,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: i,
      defaultedFilters: l,
      defaultedConfig: f,
      defaultedHighlight: u,
      propDates: d,
      defaultedUI: k
    } = n1(n), { transitionName: y, showTransition: b } = uo(r), { buildMatrix: M } = Bt(), { handleMonthYearChange: c, isDisabled: p, updateMonthYear: h } = Of(n, o), { showLeftIcon: v, showRightIcon: H } = Ln(), w = me(!1), _ = me(!1), L = me(!1), I = me([null, null, null, null]);
    h1(() => {
      o("mount");
    });
    const F = (D) => ({
      get: () => n[D],
      set: (x) => {
        const A = D === K1.month ? K1.year : K1.month;
        o("update-month-year", { [D]: x, [A]: n[A] }), D === K1.month ? U(!0) : ne(!0);
      }
    }), B = Q(F(K1.month)), K = Q(F(K1.year)), ee = Q(() => (D) => ({
      month: n.month,
      year: n.year,
      items: D === K1.month ? n.months : n.years,
      instance: n.instance,
      updateMonthYear: h,
      toggle: D === K1.month ? U : ne
    })), ve = Q(() => n.months.find((x) => x.value === n.month) || { text: "", value: 0 }), q = Q(() => $a(n.months, (D) => {
      const x = n.month === D.value, A = eo(
        D.value,
        k2(n.year, d.value.minDate),
        C2(n.year, d.value.maxDate)
      ) || l.value.months.includes(D.value), N = L2(u.value, D.value, n.year);
      return { active: x, disabled: A, highlighted: N };
    })), O = Q(() => $a(n.years, (D) => {
      const x = n.year === D.value, A = eo(
        D.value,
        Ma(d.value.minDate),
        Ma(d.value.maxDate)
      ) || l.value.years.includes(D.value), N = o0(u.value, D.value);
      return { active: x, disabled: A, highlighted: N };
    })), Y = (D, x, A) => {
      A !== void 0 ? D.value = A : D.value = !D.value, D.value ? (L.value = !0, o("overlay-opened", x)) : (L.value = !1, o("overlay-closed", x));
    }, U = (D = !1, x) => {
      te(D), Y(w, M1.month, x);
    }, ne = (D = !1, x) => {
      te(D), Y(_, M1.year, x);
    }, te = (D) => {
      D || o("reset-flow");
    }, G = (D, x) => {
      n.arrowNavigation && (I.value[x] = y1(D), M(I.value, "monthYear"));
    }, T = Q(() => {
      var D, x, A, N, $, W;
      return [
        {
          type: K1.month,
          index: 1,
          toggle: U,
          modelValue: B.value,
          updateModelValue: (fe) => B.value = fe,
          text: ve.value.text,
          showSelectionGrid: w.value,
          items: q.value,
          ariaLabel: (D = s.value) == null ? void 0 : D.openMonthsOverlay,
          overlayLabel: ((A = (x = s.value).monthPicker) == null ? void 0 : A.call(x, !0)) ?? void 0
        },
        {
          type: K1.year,
          index: 2,
          toggle: ne,
          modelValue: K.value,
          updateModelValue: (fe) => K.value = fe,
          text: y2(n.year, n.locale),
          showSelectionGrid: _.value,
          items: O.value,
          ariaLabel: (N = s.value) == null ? void 0 : N.openYearsOverlay,
          overlayLabel: ((W = ($ = s.value).yearPicker) == null ? void 0 : W.call($, !0)) ?? void 0
        }
      ];
    }), Z = Q(() => n.disableYearSelect ? [T.value[0]] : n.yearFirst ? [...T.value].reverse() : T.value);
    return e({
      toggleMonthPicker: U,
      toggleYearPicker: ne,
      handleMonthYearChange: c
    }), (D, x) => {
      var A, N, $, W, fe, Le;
      return m(), C("div", ph, [
        D.$slots["month-year"] ? (m(), C("div", fh, [
          oe(D.$slots, "month-year", v1(V1({
            month: t.month,
            year: t.year,
            months: t.months,
            years: t.years,
            updateMonthYear: j(h),
            handleMonthYearChange: j(c),
            instance: t.instance,
            isDisabled: j(p)
          })))
        ])) : (m(), C(ge, { key: 1 }, [
          D.$slots["top-extra"] ? (m(), C("div", hh, [
            oe(D.$slots, "top-extra", { value: D.internalModelValue })
          ])) : ae("", !0),
          g("div", vh, [
            j(v)(j(i), t.instance) && !D.vertical ? (m(), he(Xa, {
              key: 0,
              "aria-label": (A = j(s)) == null ? void 0 : A.prevMonth,
              disabled: j(p)(!1),
              class: le((N = j(k)) == null ? void 0 : N.navBtnPrev),
              "el-name": "action-prev",
              onActivate: x[0] || (x[0] = (z) => j(c)(!1, !0)),
              onSetRef: x[1] || (x[1] = (z) => G(z, 0))
            }, {
              default: ue(() => [
                D.$slots["arrow-left"] ? oe(D.$slots, "arrow-left", { key: 0 }) : ae("", !0),
                D.$slots["arrow-left"] ? ae("", !0) : (m(), he(j(Wr), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : ae("", !0),
            g("div", {
              class: le(["dp__month_year_wrap", {
                dp__year_disable_select: D.disableYearSelect
              }])
            }, [
              (m(!0), C(ge, null, De(Z.value, (z, P) => (m(), C(ge, {
                key: z.type
              }, [
                g("button", {
                  ref_for: !0,
                  ref: (V) => G(V, P + 1),
                  type: "button",
                  "data-dp-element": `overlay-${z.type}`,
                  class: le(["dp__btn dp__month_year_select", { "dp--hidden-el": L.value }]),
                  "aria-label": `${z.text}-${z.ariaLabel}`,
                  "data-test-id": `${z.type}-toggle-overlay-${t.instance}`,
                  onClick: z.toggle,
                  onKeydown: (V) => j(T1)(V, () => z.toggle(), !0)
                }, [
                  D.$slots[z.type] ? oe(D.$slots, z.type, {
                    key: 0,
                    text: z.text,
                    value: n[z.type]
                  }) : ae("", !0),
                  D.$slots[z.type] ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                    qe(_e(z.text), 1)
                  ], 64))
                ], 42, gh),
                ye(Va, {
                  name: j(y)(z.showSelectionGrid),
                  css: j(b)
                }, {
                  default: ue(() => [
                    z.showSelectionGrid ? (m(), he(lo, {
                      key: 0,
                      items: z.items,
                      "arrow-navigation": D.arrowNavigation,
                      "hide-navigation": D.hideNavigation,
                      "is-last": D.autoApply && !j(f).keepActionRow,
                      "skip-button-ref": !1,
                      config: D.config,
                      type: z.type,
                      "header-refs": [],
                      "esc-close": D.escClose,
                      "menu-wrap-ref": D.menuWrapRef,
                      "text-input": D.textInput,
                      "aria-labels": D.ariaLabels,
                      "overlay-label": z.overlayLabel,
                      onSelected: z.updateModelValue,
                      onToggle: z.toggle
                    }, f1({
                      "button-icon": ue(() => [
                        D.$slots["calendar-icon"] ? oe(D.$slots, "calendar-icon", { key: 0 }) : ae("", !0),
                        D.$slots["calendar-icon"] ? ae("", !0) : (m(), he(j(Pa), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      D.$slots[`${z.type}-overlay-value`] ? {
                        name: "item",
                        fn: ue(({ item: V }) => [
                          oe(D.$slots, `${z.type}-overlay-value`, {
                            text: V.text,
                            value: V.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      D.$slots[`${z.type}-overlay`] ? {
                        name: "overlay",
                        fn: ue(() => [
                          oe(D.$slots, `${z.type}-overlay`, Re({ ref_for: !0 }, ee.value(z.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      D.$slots[`${z.type}-overlay-header`] ? {
                        name: "header",
                        fn: ue(() => [
                          oe(D.$slots, `${z.type}-overlay-header`, {
                            toggle: z.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : ae("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            j(v)(j(i), t.instance) && D.vertical ? (m(), he(Xa, {
              key: 1,
              "aria-label": ($ = j(s)) == null ? void 0 : $.prevMonth,
              "el-name": "action-prev",
              disabled: j(p)(!1),
              class: le((W = j(k)) == null ? void 0 : W.navBtnPrev),
              onActivate: x[2] || (x[2] = (z) => j(c)(!1, !0))
            }, {
              default: ue(() => [
                D.$slots["arrow-up"] ? oe(D.$slots, "arrow-up", { key: 0 }) : ae("", !0),
                D.$slots["arrow-up"] ? ae("", !0) : (m(), he(j(Xr), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : ae("", !0),
            j(H)(j(i), t.instance) ? (m(), he(Xa, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: j(p)(!0),
              "aria-label": (fe = j(s)) == null ? void 0 : fe.nextMonth,
              class: le((Le = j(k)) == null ? void 0 : Le.navBtnNext),
              onActivate: x[3] || (x[3] = (z) => j(c)(!0, !0)),
              onSetRef: x[4] || (x[4] = (z) => G(z, D.disableYearSelect ? 2 : 3))
            }, {
              default: ue(() => [
                D.$slots[D.vertical ? "arrow-down" : "arrow-right"] ? oe(D.$slots, D.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : ae("", !0),
                D.$slots[D.vertical ? "arrow-down" : "arrow-right"] ? ae("", !0) : (m(), he(S1(D.vertical ? j(Qr) : j(Kr)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : ae("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), bh = {
  class: "dp__calendar_header",
  role: "row"
}, kh = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, Ch = ["aria-label"], wh = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, _h = { class: "dp__cell_inner" }, Hh = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], jh = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...ot
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, { buildMultiLevelMatrix: r } = Bt(), {
      defaultedTransitions: s,
      defaultedConfig: i,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: f,
      defaultedWeekNumbers: u,
      defaultedMultiDates: d,
      defaultedUI: k
    } = n1(n), y = me(null), b = me({
      bottom: "",
      left: "",
      transform: ""
    }), M = me([]), c = me(null), p = me(!0), h = me(""), v = me({ startX: 0, endX: 0, startY: 0, endY: 0 }), H = me([]), w = me({ left: "50%" }), _ = me(!1), L = Q(() => n.calendar ? n.calendar(n.mappedDates) : n.mappedDates), I = Q(() => n.dayNames ? Array.isArray(n.dayNames) ? n.dayNames : n.dayNames(n.locale, +n.weekStart) : af(n.formatLocale, n.locale, +n.weekStart));
    h1(() => {
      o("mount", { cmp: "calendar", refs: M }), i.value.noSwipe || c.value && (c.value.addEventListener("touchstart", G, { passive: !1 }), c.value.addEventListener("touchend", T, { passive: !1 }), c.value.addEventListener("touchmove", Z, { passive: !1 })), n.monthChangeOnScroll && c.value && c.value.addEventListener("wheel", A, { passive: !1 });
    });
    const F = (z) => z ? n.vertical ? "vNext" : "next" : n.vertical ? "vPrevious" : "previous", B = (z, P) => {
      if (n.transitions) {
        const V = x1(Ct(be(), n.month, n.year));
        h.value = c1(x1(Ct(be(), z, P)), V) ? s.value[F(!0)] : s.value[F(!1)], p.value = !1, p1(() => {
          p.value = !0;
        });
      }
    }, K = Q(
      () => ({
        ...k.value.calendar ?? {}
      })
    ), ee = Q(() => (z) => {
      const P = nf(z);
      return {
        dp__marker_dot: P.type === "dot",
        dp__marker_line: P.type === "line"
      };
    }), ve = Q(() => (z) => Ie(z, y.value)), q = Q(() => ({
      dp__calendar: !0,
      dp__calendar_next: f.value.count > 0 && n.instance !== 0
    })), O = Q(() => (z) => n.hideOffsetDates ? z.current : !0), Y = async (z, P) => {
      const { width: V, height: E } = z.getBoundingClientRect();
      y.value = P.value;
      let S = { left: `${V / 2}px` }, R = -50;
      if (await p1(), H.value[0]) {
        const { left: ie, width: de } = H.value[0].getBoundingClientRect();
        ie < 0 && (S = { left: "0" }, R = 0, w.value.left = `${V / 2}px`), window.innerWidth < ie + de && (S = { right: "0" }, R = 0, w.value.left = `${de - V / 2}px`);
      }
      b.value = {
        bottom: `${E}px`,
        ...S,
        transform: `translateX(${R}%)`
      };
    }, U = async (z, P, V) => {
      var E, S, R;
      const ie = y1(M.value[P][V]);
      ie && ((E = z.marker) != null && E.customPosition && (R = (S = z.marker) == null ? void 0 : S.tooltip) != null && R.length ? b.value = z.marker.customPosition(ie) : await Y(ie, z), o("tooltip-open", z.marker));
    }, ne = async (z, P, V) => {
      var E, S;
      if (_.value && d.value.enabled && d.value.dragSelect)
        return o("select-date", z);
      if (o("set-hover-date", z), (S = (E = z.marker) == null ? void 0 : E.tooltip) != null && S.length) {
        if (n.hideOffsetDates && !z.current) return;
        await U(z, P, V);
      }
    }, te = (z) => {
      y.value && (y.value = null, b.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), o("tooltip-close", z.marker));
    }, G = (z) => {
      v.value.startX = z.changedTouches[0].screenX, v.value.startY = z.changedTouches[0].screenY;
    }, T = (z) => {
      v.value.endX = z.changedTouches[0].screenX, v.value.endY = z.changedTouches[0].screenY, D();
    }, Z = (z) => {
      n.vertical && !n.inline && z.preventDefault();
    }, D = () => {
      const z = n.vertical ? "Y" : "X";
      Math.abs(v.value[`start${z}`] - v.value[`end${z}`]) > 10 && o("handle-swipe", v.value[`start${z}`] > v.value[`end${z}`] ? "right" : "left");
    }, x = (z, P, V) => {
      z && (Array.isArray(M.value[P]) ? M.value[P][V] = z : M.value[P] = [z]), n.arrowNavigation && r(M.value, "calendar");
    }, A = (z) => {
      n.monthChangeOnScroll && (z.preventDefault(), o("handle-scroll", z));
    }, N = (z) => u.value.type === "local" ? qr(z.value, { weekStartsOn: +n.weekStart }) : u.value.type === "iso" ? Rr(z.value) : typeof u.value.type == "function" ? u.value.type(z.value) : "", $ = (z) => {
      const P = z[0];
      return u.value.hideOnOffsetDates ? z.some((V) => V.current) ? N(P) : "" : N(P);
    }, W = (z, P, V = !0) => {
      !V && cf() || (!d.value.enabled || i.value.allowPreventDefault) && (Pt(z, i.value), o("select-date", P));
    }, fe = (z) => {
      Pt(z, i.value);
    }, Le = (z) => {
      d.value.enabled && d.value.dragSelect ? (_.value = !0, o("select-date", z)) : d.value.enabled && o("select-date", z);
    };
    return e({ triggerTransition: B }), (z, P) => (m(), C("div", {
      class: le(q.value)
    }, [
      g("div", {
        ref_key: "calendarWrapRef",
        ref: c,
        class: le(K.value),
        role: "grid"
      }, [
        g("div", bh, [
          z.weekNumbers ? (m(), C("div", kh, _e(z.weekNumName), 1)) : ae("", !0),
          (m(!0), C(ge, null, De(I.value, (V, E) => {
            var S, R;
            return m(), C("div", {
              key: E,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (R = (S = j(l)) == null ? void 0 : S.weekDay) == null ? void 0 : R.call(S, E)
            }, [
              z.$slots["calendar-header"] ? oe(z.$slots, "calendar-header", {
                key: 0,
                day: V,
                index: E
              }) : ae("", !0),
              z.$slots["calendar-header"] ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                qe(_e(V), 1)
              ], 64))
            ], 8, Ch);
          }), 128))
        ]),
        P[2] || (P[2] = g("div", { class: "dp__calendar_header_separator" }, null, -1)),
        ye(Va, {
          name: h.value,
          css: !!z.transitions
        }, {
          default: ue(() => [
            p.value ? (m(), C("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: P[1] || (P[1] = (V) => _.value = !1)
            }, [
              (m(!0), C(ge, null, De(L.value, (V, E) => (m(), C("div", {
                key: E,
                class: "dp__calendar_row",
                role: "row"
              }, [
                z.weekNumbers ? (m(), C("div", wh, [
                  g("div", _h, _e($(V.days)), 1)
                ])) : ae("", !0),
                (m(!0), C(ge, null, De(V.days, (S, R) => {
                  var ie, de, Ce;
                  return m(), C("div", {
                    id: j(Sr)(S.value),
                    ref_for: !0,
                    ref: (He) => x(He, E, R),
                    key: R + E,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (S.classData.dp__active_date || S.classData.dp__range_start || S.classData.dp__range_start) ?? void 0,
                    "aria-disabled": S.classData.dp__cell_disabled || void 0,
                    "aria-label": (de = (ie = j(l)) == null ? void 0 : ie.day) == null ? void 0 : de.call(ie, S),
                    tabindex: !S.current && z.hideOffsetDates ? void 0 : 0,
                    "data-test-id": j(Sr)(S.value),
                    onClick: $e((He) => W(He, S), ["prevent"]),
                    onTouchend: (He) => W(He, S, !1),
                    onKeydown: (He) => j(T1)(He, () => z.$emit("select-date", S)),
                    onMouseenter: (He) => ne(S, E, R),
                    onMouseleave: (He) => te(S),
                    onMousedown: (He) => Le(S),
                    onMouseup: P[0] || (P[0] = (He) => _.value = !1)
                  }, [
                    g("div", {
                      class: le(["dp__cell_inner", S.classData])
                    }, [
                      z.$slots.day && O.value(S) ? oe(z.$slots, "day", {
                        key: 0,
                        day: +S.text,
                        date: S.value
                      }) : ae("", !0),
                      z.$slots.day ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                        qe(_e(S.text), 1)
                      ], 64)),
                      S.marker && O.value(S) ? (m(), C(ge, { key: 2 }, [
                        z.$slots.marker ? oe(z.$slots, "marker", {
                          key: 0,
                          marker: S.marker,
                          day: +S.text,
                          date: S.value
                        }) : (m(), C("div", {
                          key: 1,
                          class: le(ee.value(S.marker)),
                          style: w1(S.marker.color ? { backgroundColor: S.marker.color } : {})
                        }, null, 6))
                      ], 64)) : ae("", !0),
                      ve.value(S.value) ? (m(), C("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: H,
                        class: "dp__marker_tooltip",
                        style: w1(b.value)
                      }, [
                        (Ce = S.marker) != null && Ce.tooltip ? (m(), C("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: fe
                        }, [
                          (m(!0), C(ge, null, De(S.marker.tooltip, (He, X) => (m(), C("div", {
                            key: X,
                            class: "dp__tooltip_text"
                          }, [
                            z.$slots["marker-tooltip"] ? oe(z.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: He,
                              day: S.value
                            }) : ae("", !0),
                            z.$slots["marker-tooltip"] ? ae("", !0) : (m(), C(ge, { key: 1 }, [
                              g("div", {
                                class: "dp__tooltip_mark",
                                style: w1(He.color ? { backgroundColor: He.color } : {})
                              }, null, 4),
                              g("div", null, _e(He.text), 1)
                            ], 64))
                          ]))), 128)),
                          g("div", {
                            class: "dp__arrow_bottom_tp",
                            style: w1(w.value)
                          }, null, 4)
                        ])) : ae("", !0)
                      ], 4)) : ae("", !0)
                    ], 2)
                  ], 40, Hh);
                }), 128))
              ]))), 128))
            ], 32)) : ae("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), q0 = (t) => Array.isArray(t), Lh = (t, e, a, o) => {
  const n = me([]), r = me(/* @__PURE__ */ new Date()), s = me(), i = () => T(t.isTextInputDate), { modelValue: l, calendars: f, time: u, today: d } = co(t, e, i), {
    defaultedMultiCalendars: k,
    defaultedStartTime: y,
    defaultedRange: b,
    defaultedConfig: M,
    defaultedTz: c,
    propDates: p,
    defaultedMultiDates: h
  } = n1(t), { validateMonthYearInRange: v, isDisabled: H, isDateRangeAllowed: w, checkMinMaxRange: _ } = It(t), { updateTimeValues: L, getSetDateTime: I, setTime: F, assignStartTime: B, validateTime: K, disabledTimesConfig: ee } = E2(t, u, l, o), ve = Q(
    () => (re) => f.value[re] ? f.value[re].month : 0
  ), q = Q(
    () => (re) => f.value[re] ? f.value[re].year : 0
  ), O = (re) => !M.value.keepViewOnOffsetClick || re ? !0 : !s.value, Y = (re, ke, Ve, pe = !1) => {
    var we, Me;
    O(pe) && (f.value[re] || (f.value[re] = { month: 0, year: 0 }), f.value[re].month = F0(ke) ? (we = f.value[re]) == null ? void 0 : we.month : ke, f.value[re].year = F0(Ve) ? (Me = f.value[re]) == null ? void 0 : Me.year : Ve);
  }, U = () => {
    t.autoApply && e("select-date");
  }, ne = () => {
    y.value && B(y.value);
  };
  h1(() => {
    t.shadow || (l.value || (P(), ne()), T(!0), t.focusStartDate && t.startDate && P());
  });
  const te = Q(() => {
    var re;
    return (re = t.flow) != null && re.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), G = () => {
    t.autoApply && te.value && e("auto-apply", t.partialFlow ? t.flowStep !== t.flow.length : !1);
  }, T = (re = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (n.value = l.value, W(re)) : x(l.value, re);
    if (k.value.count && re && !t.startDate)
      return D(be(), re);
  }, Z = () => Array.isArray(l.value) && b.value.enabled ? Be(l.value[0]) === Be(l.value[1] ?? l.value[0]) : !1, D = (re = /* @__PURE__ */ new Date(), ke = !1) => {
    if ((!k.value.count || !k.value.static || ke) && Y(0, Be(re), Ee(re)), k.value.count && (!l.value || Z() || !k.value.solo) && (!k.value.solo || ke))
      for (let Ve = 1; Ve < k.value.count; Ve++) {
        const pe = t1(be(), { month: ve.value(Ve - 1), year: q.value(Ve - 1) }), we = Yi(pe, { months: 1 });
        f.value[Ve] = { month: Be(we), year: Ee(we) };
      }
  }, x = (re, ke) => {
    D(re), F("hours", wt(re)), F("minutes", Tt(re)), F("seconds", ja(re)), k.value.count && ke && z();
  }, A = (re) => {
    if (k.value.count) {
      if (k.value.solo) return 0;
      const ke = Be(re[0]), Ve = Be(re[1]);
      return Math.abs(Ve - ke) < k.value.count ? 0 : 1;
    }
    return 1;
  }, N = (re, ke) => {
    re[1] && b.value.showLastInRange ? D(re[A(re)], ke) : D(re[0], ke);
    const Ve = (pe, we) => [
      pe(re[0]),
      re[1] ? pe(re[1]) : u[we][1]
    ];
    F("hours", Ve(wt, "hours")), F("minutes", Ve(Tt, "minutes")), F("seconds", Ve(ja, "seconds"));
  }, $ = (re, ke) => {
    if ((b.value.enabled || t.weekPicker) && !h.value.enabled)
      return N(re, ke);
    if (h.value.enabled && ke) {
      const Ve = re[re.length - 1];
      return x(Ve, ke);
    }
  }, W = (re) => {
    const ke = l.value;
    $(ke, re), k.value.count && k.value.solo && z();
  }, fe = (re, ke) => {
    const Ve = t1(be(), { month: ve.value(ke), year: q.value(ke) }), pe = re < 0 ? tt(Ve, 1) : xa(Ve, 1);
    v(Be(pe), Ee(pe), re < 0, t.preventMinMaxNavigation) && (Y(ke, Be(pe), Ee(pe)), e("update-month-year", { instance: ke, month: Be(pe), year: Ee(pe) }), k.value.count && !k.value.solo && Le(ke), a());
  }, Le = (re) => {
    for (let ke = re - 1; ke >= 0; ke--) {
      const Ve = xa(t1(be(), { month: ve.value(ke + 1), year: q.value(ke + 1) }), 1);
      Y(ke, Be(Ve), Ee(Ve));
    }
    for (let ke = re + 1; ke <= k.value.count - 1; ke++) {
      const Ve = tt(t1(be(), { month: ve.value(ke - 1), year: q.value(ke - 1) }), 1);
      Y(ke, Be(Ve), Ee(Ve));
    }
  }, z = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const re = be(
        be(l.value[1] ? l.value[1] : tt(l.value[0], 1))
      ), [ke, Ve] = [Be(l.value[0]), Ee(l.value[0])], [pe, we] = [Be(l.value[1]), Ee(l.value[1])];
      (ke !== pe || ke === pe && Ve !== we) && k.value.solo && Y(1, Be(re), Ee(re));
    } else l.value && !Array.isArray(l.value) && (Y(0, Be(l.value), Ee(l.value)), D(be()));
  }, P = () => {
    t.startDate && (Y(0, Be(be(t.startDate)), Ee(be(t.startDate))), k.value.count && Le(0));
  }, V = (re, ke) => {
    if (t.monthChangeOnScroll) {
      const Ve = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), pe = Math.abs(re.deltaY);
      let we = 500;
      pe > 1 && (we = 100), pe > 100 && (we = 0), Ve > we && (r.value = /* @__PURE__ */ new Date(), fe(t.monthChangeOnScroll !== "inverse" ? -re.deltaY : re.deltaY, ke));
    }
  }, E = (re, ke, Ve = !1) => {
    t.monthChangeOnArrows && t.vertical === Ve && S(re, ke);
  }, S = (re, ke) => {
    fe(re === "right" ? -1 : 1, ke);
  }, R = (re) => {
    if (p.value.markers)
      return dn(re.value, p.value.markers);
  }, ie = (re, ke) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [re == 0, !0];
      case "fair":
        return [re == 0 || ke > re, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, de = (re, ke, Ve, pe) => {
    if (t.sixWeeks && re.length < 6) {
      const we = 6 - re.length, Me = (ke.getDay() + 7 - pe) % 7, st = 6 - (Ve.getDay() + 7 - pe) % 7, [U1, la] = ie(Me, st);
      for (let Ta = 1; Ta <= we; Ta++)
        if (la ? !!(Ta % 2) == U1 : U1) {
          const Ht = re[0].days[0], Fn = Ce(q1(Ht.value, -7), Be(ke));
          re.unshift({ days: Fn });
        } else {
          const Ht = re[re.length - 1], Fn = Ht.days[Ht.days.length - 1], Dl = Ce(q1(Fn.value, 1), Be(ke));
          re.push({ days: Dl });
        }
    }
    return re;
  }, Ce = (re, ke) => {
    const Ve = be(re), pe = [];
    for (let we = 0; we < 7; we++) {
      const Me = q1(Ve, we), st = Be(Me) !== ke;
      pe.push({
        text: t.hideOffsetDates && st ? "" : Me.getDate(),
        value: Me,
        current: !st,
        classData: {}
      });
    }
    return pe;
  }, He = (re, ke) => {
    const Ve = [], pe = new Date(ke, re), we = new Date(ke, re + 1, 0), Me = t.weekStart, st = at(pe, { weekStartsOn: Me }), U1 = (la) => {
      const Ta = Ce(la, re);
      if (Ve.push({ days: Ta }), !Ve[Ve.length - 1].days.some(
        (Ht) => Ie(x1(Ht.value), x1(we))
      )) {
        const Ht = q1(la, 7);
        U1(Ht);
      }
    };
    return U1(st), de(Ve, pe, we, Me);
  }, X = (re) => {
    const ke = zt(be(re.value), u.hours, u.minutes, Pe());
    e("date-update", ke), h.value.enabled ? n0(ke, l, h.value.limit) : l.value = ke, o(), p1().then(() => {
      G();
    });
  }, ce = (re) => b.value.noDisabledRange ? w2(n.value[0], re).some((ke) => H(ke)) : !1, je = () => {
    n.value = l.value ? l.value.slice() : [], n.value.length === 2 && !(b.value.fixedStart || b.value.fixedEnd) && (n.value = []);
  }, Ze = (re, ke) => {
    const Ve = [
      be(re.value),
      q1(be(re.value), +b.value.autoRange)
    ];
    w(Ve) ? (ke && r1(re.value), n.value = Ve) : e("invalid-date", re.value);
  }, r1 = (re) => {
    const ke = Be(be(re)), Ve = Ee(be(re));
    if (Y(0, ke, Ve), k.value.count > 0)
      for (let pe = 1; pe < k.value.count; pe++) {
        const we = ff(
          t1(be(re), { year: q.value(pe - 1), month: ve.value(pe - 1) })
        );
        Y(pe, we.month, we.year);
      }
  }, xe = (re) => {
    if (ce(re.value) || !_(re.value, l.value, b.value.fixedStart ? 0 : 1))
      return e("invalid-date", re.value);
    n.value = V2(be(re.value), l, e, b);
  }, ze = (re, ke) => {
    if (je(), b.value.autoRange) return Ze(re, ke);
    if (b.value.fixedStart || b.value.fixedEnd) return xe(re);
    n.value[0] ? _(be(re.value), l.value) && !ce(re.value) ? i1(be(re.value), be(n.value[0])) ? (n.value.unshift(be(re.value)), e("range-end", n.value[0])) : (n.value[1] = be(re.value), e("range-end", n.value[1])) : (t.autoApply && e("auto-apply-invalid", re.value), e("invalid-date", re.value)) : (n.value[0] = be(re.value), e("range-start", n.value[0]));
  }, Pe = (re = !0) => t.enableSeconds ? Array.isArray(u.seconds) ? re ? u.seconds[0] : u.seconds[1] : u.seconds : 0, E1 = (re) => {
    n.value[re] = zt(
      n.value[re],
      u.hours[re],
      u.minutes[re],
      Pe(re !== 1)
    );
  }, rt = () => {
    var re, ke;
    n.value[0] && n.value[1] && +((re = n.value) == null ? void 0 : re[0]) > +((ke = n.value) == null ? void 0 : ke[1]) && (n.value.reverse(), e("range-start", n.value[0]), e("range-end", n.value[1]));
  }, fo = () => {
    n.value.length && (n.value[0] && !n.value[1] ? E1(0) : (E1(0), E1(1), o()), rt(), l.value = n.value.slice(), jn(n.value, e, t.autoApply, t.modelAuto));
  }, En = (re, ke = !1) => {
    if (H(re.value) || !re.current && t.hideOffsetDates) return e("invalid-date", re.value);
    if (s.value = JSON.parse(JSON.stringify(re)), !b.value.enabled) return X(re);
    q0(u.hours) && q0(u.minutes) && !h.value.enabled && (ze(re, ke), fo());
  }, Dn = (re, ke) => {
    var Ve;
    Y(re, ke.month, ke.year, !0), k.value.count && !k.value.solo && Le(re), e("update-month-year", { instance: re, month: ke.month, year: ke.year }), a(k.value.solo ? re : void 0);
    const pe = (Ve = t.flow) != null && Ve.length ? t.flow[t.flowStep] : void 0;
    !ke.fromNav && (pe === M1.month || pe === M1.year) && o();
  }, Pn = (re, ke) => {
    M2({
      value: re,
      modelValue: l,
      range: b.value.enabled,
      timezone: ke ? void 0 : c.value.timezone
    }), U(), t.multiCalendars && p1().then(() => T(!0));
  }, zn = () => {
    const re = Jr(be(), c.value);
    !b.value.enabled && !h.value.enabled ? l.value = re : l.value && Array.isArray(l.value) && l.value[0] ? h.value.enabled ? l.value = [...l.value, re] : l.value = i1(re, l.value[0]) ? [re, l.value[0]] : [l.value[0], re] : l.value = [re], U();
  }, Tn = () => {
    if (Array.isArray(l.value))
      if (h.value.enabled) {
        const re = On();
        l.value[l.value.length - 1] = I(re);
      } else
        l.value = l.value.map((re, ke) => re && I(re, ke));
    else
      l.value = I(l.value);
    e("time-update");
  }, On = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: f,
    modelValue: l,
    month: ve,
    year: q,
    time: u,
    disabledTimesConfig: ee,
    today: d,
    validateTime: K,
    getCalendarDays: He,
    getMarker: R,
    handleScroll: V,
    handleSwipe: S,
    handleArrow: E,
    selectDate: En,
    updateMonthYear: Dn,
    presetDate: Pn,
    selectCurrentDate: zn,
    updateTime: (re, ke = !0, Ve = !1) => {
      L(re, ke, Ve, Tn);
    },
    assignMonthAndYear: D,
    setStartTime: ne
  };
}, xh = { key: 0 }, $h = /* @__PURE__ */ J({
  __name: "DatePicker",
  props: {
    ...ot
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, {
      calendars: r,
      month: s,
      year: i,
      modelValue: l,
      time: f,
      disabledTimesConfig: u,
      today: d,
      validateTime: k,
      getCalendarDays: y,
      getMarker: b,
      handleArrow: M,
      handleScroll: c,
      handleSwipe: p,
      selectDate: h,
      updateMonthYear: v,
      presetDate: H,
      selectCurrentDate: w,
      updateTime: _,
      assignMonthAndYear: L,
      setStartTime: I
    } = Lh(n, o, Z, D), F = _t(), { setHoverDate: B, getDayClassData: K, clearHoverDate: ee } = qh(l, n), { defaultedMultiCalendars: ve } = n1(n), q = me([]), O = me([]), Y = me(null), U = Z1(F, "calendar"), ne = Z1(F, "monthYear"), te = Z1(F, "timePicker"), G = (V) => {
      n.shadow || o("mount", V);
    };
    Ue(
      r,
      () => {
        n.shadow || setTimeout(() => {
          o("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), Ue(
      ve,
      (V, E) => {
        V.count - E.count > 0 && L();
      },
      { deep: !0 }
    );
    const T = Q(() => (V) => y(s.value(V), i.value(V)).map((E) => ({
      ...E,
      days: E.days.map((S) => (S.marker = b(S), S.classData = K(S), S))
    })));
    function Z(V) {
      var E;
      V || V === 0 ? (E = O.value[V]) == null || E.triggerTransition(s.value(V), i.value(V)) : O.value.forEach((S, R) => S.triggerTransition(s.value(R), i.value(R)));
    }
    function D() {
      o("update-flow-step");
    }
    const x = (V, E = !1) => {
      h(V, E), n.spaceConfirm && o("select-date");
    }, A = (V, E, S = 0) => {
      var R;
      (R = q.value[S]) == null || R.toggleMonthPicker(V, E);
    }, N = (V, E, S = 0) => {
      var R;
      (R = q.value[S]) == null || R.toggleYearPicker(V, E);
    }, $ = (V, E, S) => {
      var R;
      (R = Y.value) == null || R.toggleTimePicker(V, E, S);
    }, W = (V, E) => {
      var S;
      if (!n.range) {
        const R = l.value ? l.value : d, ie = E ? new Date(E) : R, de = V ? at(ie, { weekStartsOn: 1 }) : e2(ie, { weekStartsOn: 1 });
        h({
          value: de,
          current: Be(ie) === s.value(0),
          text: "",
          classData: {}
        }), (S = document.getElementById(Sr(de))) == null || S.focus();
      }
    }, fe = (V) => {
      var E;
      (E = q.value[0]) == null || E.handleMonthYearChange(V, !0);
    }, Le = (V) => {
      v(0, { month: s.value(0), year: i.value(0) + (V ? 1 : -1), fromNav: !0 });
    }, z = (V, E) => {
      V === M1.time && o(`time-picker-${E ? "open" : "close"}`), o("overlay-toggle", { open: E, overlay: V });
    }, P = (V) => {
      o("overlay-toggle", { open: !1, overlay: V }), o("focus-menu");
    };
    return e({
      clearHoverDate: ee,
      presetDate: H,
      selectCurrentDate: w,
      toggleMonthPicker: A,
      toggleYearPicker: N,
      toggleTimePicker: $,
      handleArrow: M,
      updateMonthYear: v,
      getSidebarProps: () => ({
        modelValue: l,
        month: s,
        year: i,
        time: f,
        updateTime: _,
        updateMonthYear: v,
        selectDate: h,
        presetDate: H
      }),
      changeMonth: fe,
      changeYear: Le,
      selectWeekDate: W,
      setStartTime: I
    }), (V, E) => (m(), C(ge, null, [
      ye(Hn, {
        "multi-calendars": j(ve).count,
        collapse: V.collapse,
        "is-mobile": V.isMobile
      }, {
        default: ue(({ instance: S, index: R }) => [
          V.disableMonthYearSelect ? ae("", !0) : (m(), he(yh, Re({
            key: 0,
            ref: (ie) => {
              ie && (q.value[R] = ie);
            },
            months: j(h2)(V.formatLocale, V.locale, V.monthNameFormat),
            years: j(e0)(V.yearRange, V.locale, V.reverseYears),
            month: j(s)(S),
            year: j(i)(S),
            instance: S
          }, V.$props, {
            onMount: E[0] || (E[0] = (ie) => G(j(Xt).header)),
            onResetFlow: E[1] || (E[1] = (ie) => V.$emit("reset-flow")),
            onUpdateMonthYear: (ie) => j(v)(S, ie),
            onOverlayClosed: P,
            onOverlayOpened: E[2] || (E[2] = (ie) => V.$emit("overlay-toggle", { open: !0, overlay: ie }))
          }), f1({ _: 2 }, [
            De(j(ne), (ie, de) => ({
              name: ie,
              fn: ue((Ce) => [
                oe(V.$slots, ie, v1(V1(Ce)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          ye(jh, Re({
            ref: (ie) => {
              ie && (O.value[R] = ie);
            },
            "mapped-dates": T.value(S),
            month: j(s)(S),
            year: j(i)(S),
            instance: S
          }, V.$props, {
            onSelectDate: (ie) => j(h)(ie, S !== 1),
            onHandleSpace: (ie) => x(ie, S !== 1),
            onSetHoverDate: E[3] || (E[3] = (ie) => j(B)(ie)),
            onHandleScroll: (ie) => j(c)(ie, S),
            onHandleSwipe: (ie) => j(p)(ie, S),
            onMount: E[4] || (E[4] = (ie) => G(j(Xt).calendar)),
            onResetFlow: E[5] || (E[5] = (ie) => V.$emit("reset-flow")),
            onTooltipOpen: E[6] || (E[6] = (ie) => V.$emit("tooltip-open", ie)),
            onTooltipClose: E[7] || (E[7] = (ie) => V.$emit("tooltip-close", ie))
          }), f1({ _: 2 }, [
            De(j(U), (ie, de) => ({
              name: ie,
              fn: ue((Ce) => [
                oe(V.$slots, ie, v1(V1({ ...Ce })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      V.enableTimePicker ? (m(), C("div", xh, [
        V.$slots["time-picker"] ? oe(V.$slots, "time-picker", v1(Re({ key: 0 }, { time: j(f), updateTime: j(_) }))) : (m(), he(A2, Re({
          key: 1,
          ref_key: "timePickerRef",
          ref: Y
        }, V.$props, {
          hours: j(f).hours,
          minutes: j(f).minutes,
          seconds: j(f).seconds,
          "internal-model-value": V.internalModelValue,
          "disabled-times-config": j(u),
          "validate-time": j(k),
          onMount: E[8] || (E[8] = (S) => G(j(Xt).timePicker)),
          "onUpdate:hours": E[9] || (E[9] = (S) => j(_)(S)),
          "onUpdate:minutes": E[10] || (E[10] = (S) => j(_)(S, !1)),
          "onUpdate:seconds": E[11] || (E[11] = (S) => j(_)(S, !1, !0)),
          onResetFlow: E[12] || (E[12] = (S) => V.$emit("reset-flow")),
          onOverlayClosed: E[13] || (E[13] = (S) => z(S, !1)),
          onOverlayOpened: E[14] || (E[14] = (S) => z(S, !0)),
          onAmPmChange: E[15] || (E[15] = (S) => V.$emit("am-pm-change", S))
        }), f1({ _: 2 }, [
          De(j(te), (S, R) => ({
            name: S,
            fn: ue((ie) => [
              oe(V.$slots, S, v1(V1(ie)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : ae("", !0)
    ], 64));
  }
}), Mh = (t, e) => {
  const a = me(), {
    defaultedMultiCalendars: o,
    defaultedConfig: n,
    defaultedHighlight: r,
    defaultedRange: s,
    propDates: i,
    defaultedFilters: l,
    defaultedMultiDates: f
  } = n1(t), { modelValue: u, year: d, month: k, calendars: y } = co(t, e), { isDisabled: b } = It(t), { selectYear: M, groupedYears: c, showYearPicker: p, isDisabled: h, toggleYearPicker: v, handleYearSelect: H, handleYear: w } = S2({
    modelValue: u,
    multiCalendars: o,
    range: s,
    highlight: r,
    calendars: y,
    propDates: i,
    month: k,
    year: d,
    filters: l,
    props: t,
    emit: e
  }), _ = (O, Y) => [O, Y].map((U) => pt(U, "MMMM", { locale: t.formatLocale })).join("-"), L = Q(() => (O) => u.value ? Array.isArray(u.value) ? u.value.some((Y) => z0(O, Y)) : z0(u.value, O) : !1), I = (O) => {
    if (s.value.enabled) {
      if (Array.isArray(u.value)) {
        const Y = Ie(O, u.value[0]) || Ie(O, u.value[1]);
        return to(u.value, a.value, O) && !Y;
      }
      return !1;
    }
    return !1;
  }, F = (O, Y) => O.quarter === V0(Y) && O.year === Ee(Y), B = (O) => typeof r.value == "function" ? r.value({ quarter: V0(O), year: Ee(O) }) : !!r.value.quarters.find((Y) => F(Y, O)), K = Q(() => (O) => {
    const Y = t1(/* @__PURE__ */ new Date(), { year: d.value(O) });
    return am({
      start: Ja(Y),
      end: Ji(Y)
    }).map((U) => {
      const ne = Gt(U), te = S0(U), G = b(U), T = I(ne), Z = B(ne);
      return {
        text: _(ne, te),
        value: ne,
        active: L.value(ne),
        highlighted: Z,
        disabled: G,
        isBetween: T
      };
    });
  }), ee = (O) => {
    n0(O, u, f.value.limit), e("auto-apply", !0);
  }, ve = (O) => {
    u.value = r0(u, O, e), jn(u.value, e, t.autoApply, t.modelAuto);
  }, q = (O) => {
    u.value = O, e("auto-apply");
  };
  return {
    defaultedConfig: n,
    defaultedMultiCalendars: o,
    groupedYears: c,
    year: d,
    isDisabled: h,
    quarters: K,
    showYearPicker: p,
    modelValue: u,
    setHoverDate: (O) => {
      a.value = O;
    },
    selectYear: M,
    selectQuarter: (O, Y, U) => {
      if (!U)
        return y.value[Y].month = Be(S0(O)), f.value.enabled ? ee(O) : s.value.enabled ? ve(O) : q(O);
    },
    toggleYearPicker: v,
    handleYearSelect: H,
    handleYear: w
  };
}, Vh = { class: "dp--quarter-items" }, Sh = ["data-test-id", "disabled", "onClick", "onMouseover"], Ah = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...ot
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, r = _t(), s = Z1(r, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: l,
      groupedYears: f,
      year: u,
      isDisabled: d,
      quarters: k,
      modelValue: y,
      showYearPicker: b,
      setHoverDate: M,
      selectQuarter: c,
      toggleYearPicker: p,
      handleYearSelect: h,
      handleYear: v
    } = Mh(n, o);
    return e({ getSidebarProps: () => ({
      modelValue: y,
      year: u,
      selectQuarter: c,
      handleYearSelect: h,
      handleYear: v
    }) }), (H, w) => (m(), he(Hn, {
      "multi-calendars": j(i).count,
      collapse: H.collapse,
      stretch: "",
      "is-mobile": H.isMobile
    }, {
      default: ue(({ instance: _ }) => [
        g("div", {
          class: "dp-quarter-picker-wrap",
          style: w1({ minHeight: `${j(l).modeHeight}px` })
        }, [
          H.$slots["top-extra"] ? oe(H.$slots, "top-extra", {
            key: 0,
            value: H.internalModelValue
          }) : ae("", !0),
          g("div", null, [
            ye($2, Re(H.$props, {
              items: j(f)(_),
              instance: _,
              "show-year-picker": j(b)[_],
              year: j(u)(_),
              "is-disabled": (L) => j(d)(_, L),
              onHandleYear: (L) => j(v)(_, L),
              onYearSelect: (L) => j(h)(L, _),
              onToggleYearPicker: (L) => j(p)(_, L?.flow, L?.show)
            }), f1({ _: 2 }, [
              De(j(s), (L, I) => ({
                name: L,
                fn: ue((F) => [
                  oe(H.$slots, L, v1(V1(F)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          g("div", Vh, [
            (m(!0), C(ge, null, De(j(k)(_), (L, I) => (m(), C("div", { key: I }, [
              g("button", {
                type: "button",
                class: le(["dp--qr-btn", {
                  "dp--qr-btn-active": L.active,
                  "dp--qr-btn-between": L.isBetween,
                  "dp--qr-btn-disabled": L.disabled,
                  "dp--highlighted": L.highlighted
                }]),
                "data-test-id": L.value,
                disabled: L.disabled,
                onClick: (F) => j(c)(L.value, _, L.disabled),
                onMouseover: (F) => j(M)(L.value)
              }, [
                H.$slots.quarter ? oe(H.$slots, "quarter", {
                  key: 0,
                  value: L.value,
                  text: L.text
                }) : (m(), C(ge, { key: 1 }, [
                  qe(_e(L.text), 1)
                ], 64))
              ], 42, Sh)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), D2 = (t, e) => {
  const a = me(0);
  h1(() => {
    o(), window.addEventListener("resize", o, { passive: !0 });
  }), oa(() => {
    window.removeEventListener("resize", o);
  });
  const o = () => {
    a.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: Q(
      () => a.value <= t.value.mobileBreakpoint && !e ? !0 : void 0
    )
  };
}, Eh = ["id", "tabindex", "role", "aria-label"], Dh = {
  key: 0,
  class: "dp--menu-load-container"
}, Ph = {
  key: 1,
  class: "dp--menu-header"
}, zh = ["data-dp-mobile"], Th = {
  key: 0,
  class: "dp__sidebar_left"
}, Oh = ["data-dp-mobile"], Fh = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], Bh = {
  key: 2,
  class: "dp__sidebar_right"
}, Ih = {
  key: 3,
  class: "dp__action_extra"
}, U0 = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ..._n,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, r = me(null), s = Q(() => {
      const { openOnTop: X, ...ce } = n;
      return {
        ...ce,
        isMobile: M.value,
        flowStep: K.value,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: i, setShiftKey: l, control: f } = x2(), u = _t(), { defaultedTextInput: d, defaultedInline: k, defaultedConfig: y, defaultedUI: b } = n1(n), { isMobile: M } = D2(y, n.shadow), c = me(null), p = me(0), h = me(null), v = me(!1), H = me(null), w = me(!1);
    h1(() => {
      if (!n.shadow) {
        v.value = !0, _(), window.addEventListener("resize", _);
        const X = y1(r);
        if (X && !d.value.enabled && !k.value.enabled && (i(!0), ne()), X) {
          const ce = (je) => {
            w.value = !0, y.value.allowPreventDefault && je.preventDefault(), Pt(je, y.value, !0);
          };
          X.addEventListener("pointerdown", ce), X.addEventListener("mousedown", ce);
        }
      }
      document.addEventListener("mousedown", He);
    }), oa(() => {
      window.removeEventListener("resize", _), document.addEventListener("mousedown", He);
    });
    const _ = () => {
      const X = y1(h);
      X && (p.value = X.getBoundingClientRect().width);
    }, { arrowRight: L, arrowLeft: I, arrowDown: F, arrowUp: B } = Bt(), { flowStep: K, updateFlowStep: ee, childMount: ve, resetFlow: q, handleFlow: O } = Uh(n, o, H), Y = Q(() => n.monthPicker ? Gf : n.yearPicker ? Qf : n.timePicker ? mh : n.quarterPicker ? Ah : $h), U = Q(() => {
      var X;
      if (y.value.arrowLeft) return y.value.arrowLeft;
      const ce = (X = r.value) == null ? void 0 : X.getBoundingClientRect(), je = n.getInputRect();
      return je?.width < p?.value && je?.left <= (ce?.left ?? 0) ? `${je?.width / 2}px` : je?.right >= (ce?.right ?? 0) && je?.width < p?.value ? `${p?.value - je?.width / 2}px` : "50%";
    }), ne = () => {
      const X = y1(r);
      X && X.focus({ preventScroll: !0 });
    }, te = Q(() => {
      var X;
      return ((X = H.value) == null ? void 0 : X.getSidebarProps()) || {};
    }), G = () => {
      n.openOnTop && o("recalculate-position");
    }, T = Z1(u, "action"), Z = Q(() => n.monthPicker || n.yearPicker ? Z1(u, "monthYear") : n.timePicker ? Z1(u, "timePicker") : Z1(u, "shared")), D = Q(() => n.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), x = Q(() => ({
      dp__menu_disabled: n.disabled,
      dp__menu_readonly: n.readonly,
      "dp-menu-loading": n.loading
    })), A = Q(
      () => ({
        dp__menu: !0,
        dp__menu_index: !k.value.enabled,
        dp__relative: k.value.enabled,
        ...b.value.menu ?? {}
      })
    ), N = (X) => {
      Pt(X, y.value, !0);
    }, $ = () => {
      n.escClose && o("close-picker");
    }, W = (X) => {
      if (n.arrowNavigation) {
        if (X === z1.up) return B();
        if (X === z1.down) return F();
        if (X === z1.left) return I();
        if (X === z1.right) return L();
      } else X === z1.left || X === z1.up ? V("handleArrow", z1.left, 0, X === z1.up) : V("handleArrow", z1.right, 0, X === z1.down);
    }, fe = (X) => {
      l(X.shiftKey), !n.disableMonthYearSelect && X.code === o1.tab && X.target.classList.contains("dp__menu") && f.value.shiftKeyInMenu && (X.preventDefault(), Pt(X, y.value, !0), o("close-picker"));
    }, Le = () => {
      ne(), o("time-picker-close");
    }, z = (X) => {
      var ce, je, Ze;
      (ce = H.value) == null || ce.toggleTimePicker(!1, !1), (je = H.value) == null || je.toggleMonthPicker(!1, !1, X), (Ze = H.value) == null || Ze.toggleYearPicker(!1, !1, X);
    }, P = (X, ce = 0) => {
      var je, Ze, r1;
      return X === "month" ? (je = H.value) == null ? void 0 : je.toggleMonthPicker(!1, !0, ce) : X === "year" ? (Ze = H.value) == null ? void 0 : Ze.toggleYearPicker(!1, !0, ce) : X === "time" ? (r1 = H.value) == null ? void 0 : r1.toggleTimePicker(!0, !1) : z(ce);
    }, V = (X, ...ce) => {
      var je, Ze;
      (je = H.value) != null && je[X] && ((Ze = H.value) == null || Ze[X](...ce));
    }, E = () => {
      V("selectCurrentDate");
    }, S = (X, ce) => {
      V("presetDate", zl(X), ce);
    }, R = () => {
      V("clearHoverDate");
    }, ie = (X, ce) => {
      V("updateMonthYear", X, ce);
    }, de = (X, ce) => {
      X.preventDefault(), W(ce);
    }, Ce = (X) => {
      var ce, je, Ze;
      if (fe(X), X.key === o1.home || X.key === o1.end)
        return V(
          "selectWeekDate",
          X.key === o1.home,
          X.target.getAttribute("id")
        );
      switch ((X.key === o1.pageUp || X.key === o1.pageDown) && (X.shiftKey ? (V("changeYear", X.key === o1.pageUp), (ce = Mr(r.value, "overlay-year")) == null || ce.focus()) : (V("changeMonth", X.key === o1.pageUp), (je = Mr(r.value, X.key === o1.pageUp ? "action-prev" : "action-next")) == null || je.focus()), X.target.getAttribute("id") && ((Ze = r.value) == null || Ze.focus({ preventScroll: !0 }))), X.key) {
        case o1.esc:
          return $();
        case o1.arrowLeft:
          return de(X, z1.left);
        case o1.arrowRight:
          return de(X, z1.right);
        case o1.arrowUp:
          return de(X, z1.up);
        case o1.arrowDown:
          return de(X, z1.down);
        default:
          return;
      }
    }, He = (X) => {
      var ce;
      k.value.enabled && !k.value.input && !((ce = r.value) != null && ce.contains(X.target)) && w.value && (w.value = !1, o("menu-blur"));
    };
    return e({
      updateMonthYear: ie,
      switchView: P,
      handleFlow: O,
      onValueCleared: () => {
        var X, ce;
        (ce = (X = H.value) == null ? void 0 : X.setStartTime) == null || ce.call(X);
      }
    }), (X, ce) => {
      var je, Ze, r1;
      return m(), C("div", {
        id: X.uid ? `dp-menu-${X.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: j(k).enabled ? void 0 : "0",
        role: j(k).enabled ? void 0 : "dialog",
        "aria-label": (je = X.ariaLabels) == null ? void 0 : je.menu,
        class: le(A.value),
        style: w1({ "--dp-arrow-left": U.value }),
        onMouseleave: R,
        onClick: N,
        onKeydown: Ce
      }, [
        (X.disabled || X.readonly) && j(k).enabled || X.loading ? (m(), C("div", {
          key: 0,
          class: le(x.value)
        }, [
          X.loading ? (m(), C("div", Dh, ce[19] || (ce[19] = [
            g("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : ae("", !0)
        ], 2)) : ae("", !0),
        X.$slots["menu-header"] ? (m(), C("div", Ph, [
          oe(X.$slots, "menu-header")
        ])) : ae("", !0),
        !j(k).enabled && !X.teleportCenter ? (m(), C("div", {
          key: 2,
          class: le(D.value)
        }, null, 2)) : ae("", !0),
        g("div", {
          ref_key: "innerMenuRef",
          ref: h,
          class: le({
            dp__menu_content_wrapper: ((Ze = X.presetDates) == null ? void 0 : Ze.length) || !!X.$slots["left-sidebar"] || !!X.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((r1 = X.presetDates) == null ? void 0 : r1.length) || !!X.$slots["left-sidebar"] || !!X.$slots["right-sidebar"])
          }),
          "data-dp-mobile": j(M),
          style: w1({ "--dp-menu-width": `${p.value}px` })
        }, [
          X.$slots["left-sidebar"] ? (m(), C("div", Th, [
            oe(X.$slots, "left-sidebar", v1(V1(te.value)))
          ])) : ae("", !0),
          X.presetDates.length ? (m(), C("div", {
            key: 1,
            class: le({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": j(M)
          }, [
            (m(!0), C(ge, null, De(X.presetDates, (xe, ze) => (m(), C(ge, { key: ze }, [
              xe.slot ? oe(X.$slots, xe.slot, {
                key: 0,
                presetDate: S,
                label: xe.label,
                value: xe.value
              }) : (m(), C("button", {
                key: 1,
                type: "button",
                style: w1(xe.style || {}),
                class: le(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test-id": xe.testId ?? void 0,
                "data-dp-mobile": j(M),
                onClick: $e((Pe) => S(xe.value, xe.noTz), ["prevent"]),
                onKeydown: (Pe) => j(T1)(Pe, () => S(xe.value, xe.noTz), !0)
              }, _e(xe.label), 47, Fh))
            ], 64))), 128))
          ], 10, Oh)) : ae("", !0),
          g("div", {
            ref_key: "calendarWrapperRef",
            ref: c,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (m(), he(S1(Y.value), Re({
              ref_key: "dynCmpRef",
              ref: H
            }, s.value, {
              "flow-step": j(K),
              onMount: j(ve),
              onUpdateFlowStep: j(ee),
              onResetFlow: j(q),
              onFocusMenu: ne,
              onSelectDate: ce[0] || (ce[0] = (xe) => X.$emit("select-date")),
              onDateUpdate: ce[1] || (ce[1] = (xe) => X.$emit("date-update", xe)),
              onTooltipOpen: ce[2] || (ce[2] = (xe) => X.$emit("tooltip-open", xe)),
              onTooltipClose: ce[3] || (ce[3] = (xe) => X.$emit("tooltip-close", xe)),
              onAutoApply: ce[4] || (ce[4] = (xe) => X.$emit("auto-apply", xe)),
              onRangeStart: ce[5] || (ce[5] = (xe) => X.$emit("range-start", xe)),
              onRangeEnd: ce[6] || (ce[6] = (xe) => X.$emit("range-end", xe)),
              onInvalidFixedRange: ce[7] || (ce[7] = (xe) => X.$emit("invalid-fixed-range", xe)),
              onTimeUpdate: ce[8] || (ce[8] = (xe) => X.$emit("time-update")),
              onAmPmChange: ce[9] || (ce[9] = (xe) => X.$emit("am-pm-change", xe)),
              onTimePickerOpen: ce[10] || (ce[10] = (xe) => X.$emit("time-picker-open", xe)),
              onTimePickerClose: Le,
              onRecalculatePosition: G,
              onUpdateMonthYear: ce[11] || (ce[11] = (xe) => X.$emit("update-month-year", xe)),
              onAutoApplyInvalid: ce[12] || (ce[12] = (xe) => X.$emit("auto-apply-invalid", xe)),
              onInvalidDate: ce[13] || (ce[13] = (xe) => X.$emit("invalid-date", xe)),
              onOverlayToggle: ce[14] || (ce[14] = (xe) => X.$emit("overlay-toggle", xe)),
              "onUpdate:internalModelValue": ce[15] || (ce[15] = (xe) => X.$emit("update:internal-model-value", xe))
            }), f1({ _: 2 }, [
              De(Z.value, (xe, ze) => ({
                name: xe,
                fn: ue((Pe) => [
                  oe(X.$slots, xe, v1(V1({ ...Pe })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          X.$slots["right-sidebar"] ? (m(), C("div", Bh, [
            oe(X.$slots, "right-sidebar", v1(V1(te.value)))
          ])) : ae("", !0),
          X.$slots["action-extra"] ? (m(), C("div", Ih, [
            X.$slots["action-extra"] ? oe(X.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: E
            }) : ae("", !0)
          ])) : ae("", !0)
        ], 14, zh),
        !X.autoApply || j(y).keepActionRow ? (m(), he(If, Re({
          key: 3,
          "menu-mount": v.value
        }, s.value, {
          "calendar-width": p.value,
          onClosePicker: ce[16] || (ce[16] = (xe) => X.$emit("close-picker")),
          onSelectDate: ce[17] || (ce[17] = (xe) => X.$emit("select-date")),
          onInvalidSelect: ce[18] || (ce[18] = (xe) => X.$emit("invalid-select")),
          onSelectNow: E
        }), f1({ _: 2 }, [
          De(j(T), (xe, ze) => ({
            name: xe,
            fn: ue((Pe) => [
              oe(X.$slots, xe, v1(V1({ ...Pe })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : ae("", !0)
      ], 46, Eh);
    };
  }
});
var va = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(va || {});
const Zh = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: a,
  pickerWrapperRef: o,
  inline: n,
  emit: r,
  props: s,
  slots: i
}) => {
  const { defaultedConfig: l } = n1(s), f = me({}), u = me(!1), d = me({
    top: "0",
    left: "0"
  }), k = me(!1), y = Qa(s, "teleportCenter");
  Ue(y, () => {
    d.value = JSON.parse(JSON.stringify({})), w();
  });
  const b = (Y) => {
    if (s.teleport) {
      const U = Y.getBoundingClientRect();
      return {
        left: U.left + window.scrollX,
        top: U.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, M = (Y, U) => {
    d.value.left = `${Y + U - f.value.width}px`;
  }, c = (Y) => {
    d.value.left = `${Y}px`;
  }, p = (Y, U) => {
    s.position === va.left && c(Y), s.position === va.right && M(Y, U), s.position === va.center && (d.value.left = `${Y + U / 2 - f.value.width / 2}px`);
  }, h = (Y) => {
    const { width: U, height: ne } = Y.getBoundingClientRect(), { top: te, left: G } = b(Y);
    return { top: +te, left: +G, width: U, height: ne };
  }, v = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, H = () => {
    const Y = y1(a);
    d.value = s.altPosition(Y);
  }, w = (Y = !0) => {
    var U;
    if (!n.value.enabled) {
      if (y.value) return v();
      if (s.altPosition !== null) return H();
      if (Y) {
        const ne = s.teleport ? (U = e.value) == null ? void 0 : U.$el : t.value;
        ne && (f.value = ne.getBoundingClientRect()), r("recalculate-position");
      }
      return ee();
    }
  }, _ = ({ inputEl: Y, left: U, width: ne }) => {
    window.screen.width > 768 && !u.value && p(U, ne), F(Y);
  }, L = (Y) => {
    const { top: U, left: ne, height: te, width: G } = h(Y);
    d.value.top = `${te + U + +s.offset}px`, k.value = !1, u.value || (d.value.left = `${ne + G / 2 - f.value.width / 2}px`), _({ inputEl: Y, left: ne, width: G });
  }, I = (Y) => {
    const { top: U, left: ne, width: te } = h(Y);
    d.value.top = `${U - +s.offset - f.value.height}px`, k.value = !0, _({ inputEl: Y, left: ne, width: te });
  }, F = (Y) => {
    if (s.autoPosition) {
      const { left: U, width: ne } = h(Y), { left: te, right: G } = f.value;
      if (!u.value) {
        if (Math.abs(te) !== Math.abs(G)) {
          if (te <= 0)
            return u.value = !0, c(U);
          if (G >= document.documentElement.clientWidth)
            return u.value = !0, M(U, ne);
        }
        return p(U, ne);
      }
    }
  }, B = () => {
    const Y = y1(a);
    if (Y) {
      if (s.autoPosition === G1.top) return G1.top;
      if (s.autoPosition === G1.bottom) return G1.bottom;
      const { height: U } = f.value, { top: ne, height: te } = Y.getBoundingClientRect(), G = window.innerHeight - ne - te, T = ne;
      return U <= G ? G1.bottom : U > G && U <= T ? G1.top : G >= T ? G1.bottom : G1.top;
    }
    return G1.bottom;
  }, K = (Y) => B() === G1.bottom ? L(Y) : I(Y), ee = () => {
    const Y = y1(a);
    if (Y)
      return s.autoPosition ? K(Y) : L(Y);
  }, ve = function(Y) {
    if (Y) {
      const U = Y.scrollHeight > Y.clientHeight, ne = window.getComputedStyle(Y).overflowY.indexOf("hidden") !== -1;
      return U && !ne;
    }
    return !0;
  }, q = function(Y) {
    return !Y || Y === document.body || Y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : ve(Y) ? Y : q(
      Y.assignedSlot && l.value.shadowDom ? Y.assignedSlot.parentNode : Y.parentNode
    );
  }, O = (Y) => {
    if (Y)
      switch (s.position) {
        case va.left:
          return { left: 0, transform: "translateX(0)" };
        case va.right:
          return { left: `${Y.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${Y.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: k,
    menuStyle: d,
    xCorrect: u,
    setMenuPosition: w,
    getScrollableParent: q,
    shadowRender: (Y, U) => {
      var ne, te, G;
      const T = document.createElement("div"), Z = (ne = y1(a)) == null ? void 0 : ne.getBoundingClientRect();
      T.setAttribute("id", "dp--temp-container");
      const D = (te = o.value) != null && te.clientWidth ? o.value : document.body;
      D.append(T);
      const x = O(Z), A = l.value.shadowDom ? Object.keys(i).filter(
        ($) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes($)
      ) : Object.keys(i), N = Pl(
        Y,
        {
          ...U,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...x }
        },
        Object.fromEntries(A.map(($) => [$, i[$]]))
      );
      b0(N, T), f.value = (G = N.el) == null ? void 0 : G.getBoundingClientRect(), b0(null, T), D.removeChild(T);
    }
  };
}, $t = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], Rh = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], Nh = {
  all: () => $t,
  monthYear: () => $t.filter((t) => t.use.includes("month-year")),
  input: () => Rh,
  timePicker: () => $t.filter((t) => t.use.includes("time")),
  action: () => $t.filter((t) => t.use.includes("action")),
  calendar: () => $t.filter((t) => t.use.includes("calendar")),
  menu: () => $t.filter((t) => t.use.includes("menu")),
  shared: () => $t.filter((t) => t.use.includes("shared")),
  yearMode: () => $t.filter((t) => t.use.includes("year-mode"))
}, Z1 = (t, e, a) => {
  const o = [];
  return Nh[e]().forEach((n) => {
    t[n.name] && o.push(n.name);
  }), a != null && a.length && a.forEach((n) => {
    n.slot && o.push(n.slot);
  }), o;
}, uo = (t) => {
  const e = Q(() => (o) => t.value ? o ? t.value.open : t.value.close : ""), a = Q(() => (o) => t.value ? o ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: a };
}, co = (t, e, a) => {
  const { defaultedRange: o, defaultedTz: n } = n1(t), r = be(O1(be(), n.value.timezone)), s = me([{ month: Be(r), year: Ee(r) }]), i = (k) => {
    const y = {
      hours: wt(r),
      minutes: Tt(r),
      seconds: 0
    };
    return o.value.enabled ? [y[k], y[k]] : y[k];
  }, l = so({
    hours: i("hours"),
    minutes: i("minutes"),
    seconds: i("seconds")
  });
  Ue(
    o,
    (k, y) => {
      k.enabled !== y.enabled && (l.hours = i("hours"), l.minutes = i("minutes"), l.seconds = i("seconds"));
    },
    { deep: !0 }
  );
  const f = Q({
    get: () => t.internalModelValue,
    set: (k) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", k);
    }
  }), u = Q(
    () => (k) => s.value[k] ? s.value[k].month : 0
  ), d = Q(
    () => (k) => s.value[k] ? s.value[k].year : 0
  );
  return Ue(
    f,
    (k, y) => {
      a && JSON.stringify(k ?? {}) !== JSON.stringify(y ?? {}) && a();
    },
    { deep: !0 }
  ), {
    calendars: s,
    time: l,
    modelValue: f,
    month: u,
    year: d,
    today: r
  };
}, qh = (t, e) => {
  const {
    defaultedMultiCalendars: a,
    defaultedMultiDates: o,
    defaultedUI: n,
    defaultedHighlight: r,
    defaultedTz: s,
    propDates: i,
    defaultedRange: l
  } = n1(e), { isDisabled: f } = It(e), u = me(null), d = me(O1(/* @__PURE__ */ new Date(), s.value.timezone)), k = ($) => {
    !$.current && e.hideOffsetDates || (u.value = $.value);
  }, y = () => {
    u.value = null;
  }, b = ($) => Array.isArray(t.value) && l.value.enabled && t.value[0] && u.value ? $ ? c1(u.value, t.value[0]) : i1(u.value, t.value[0]) : !0, M = ($, W) => {
    const fe = () => t.value ? W ? t.value[0] || null : t.value[1] : null, Le = t.value && Array.isArray(t.value) ? fe() : null;
    return Ie(be($.value), Le);
  }, c = ($) => {
    const W = Array.isArray(t.value) ? t.value[0] : null;
    return $ ? !i1(u.value ?? null, W) : !0;
  }, p = ($, W = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !$.current ? !1 : Ie(be($.value), t.value[W ? 0 : 1]) : l.value.enabled ? M($, W) && c(W) || Ie($.value, Array.isArray(t.value) ? t.value[0] : null) && b(W) : !1, h = ($, W) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const fe = Ie($.value, u.value);
      return W ? c1(t.value[0], $.value) && fe : i1(t.value[0], $.value) && fe;
    }
    return !1;
  }, v = ($) => !t.value || e.hideOffsetDates && !$.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? Ie($.value, t.value[0] ? t.value[0] : d.value) : !1 : o.value.enabled && Array.isArray(t.value) ? t.value.some((W) => Ie(W, $.value)) : Ie($.value, t.value ? t.value : d.value), H = ($) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        if (e.hideOffsetDates && !$.current) return !1;
        const W = q1(u.value, +l.value.autoRange), fe = kt(be(u.value), e.weekStart);
        return e.weekPicker ? Ie(fe[1], be($.value)) : Ie(W, be($.value));
      }
      return !1;
    }
    return !1;
  }, w = ($) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        const W = q1(u.value, +l.value.autoRange);
        if (e.hideOffsetDates && !$.current) return !1;
        const fe = kt(be(u.value), e.weekStart);
        return e.weekPicker ? c1($.value, fe[0]) && i1($.value, fe[1]) : c1($.value, u.value) && i1($.value, W);
      }
      return !1;
    }
    return !1;
  }, _ = ($) => {
    if (l.value.autoRange || e.weekPicker) {
      if (u.value) {
        if (e.hideOffsetDates && !$.current) return !1;
        const W = kt(be(u.value), e.weekStart);
        return e.weekPicker ? Ie(W[0], $.value) : Ie(u.value, $.value);
      }
      return !1;
    }
    return !1;
  }, L = ($) => to(t.value, u.value, $.value), I = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, F = () => e.modelAuto ? v2(e.internalModelValue) : !0, B = ($) => {
    if (e.weekPicker) return !1;
    const W = l.value.enabled ? !p($) && !p($, !1) : !0;
    return !f($.value) && !v($) && !(!$.current && e.hideOffsetDates) && W;
  }, K = ($) => l.value.enabled ? e.modelAuto ? I() && v($) : !1 : v($), ee = ($) => r.value ? uf($.value, i.value.highlight) : !1, ve = ($) => {
    const W = f($.value);
    return W && (typeof r.value == "function" ? !r.value($.value, W) : !r.value.options.highlightDisabled);
  }, q = ($) => {
    var W;
    return typeof r.value == "function" ? r.value($.value) : (W = r.value.weekdays) == null ? void 0 : W.includes($.value.getDay());
  }, O = ($) => (l.value.enabled || e.weekPicker) && (!(a.value.count > 0) || $.current) && F() && !(!$.current && e.hideOffsetDates) && !v($) ? L($) : !1, Y = ($) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: W, after: fe } = Z0(+l.value.maxRange, t.value[0]);
      return La($.value, W) || aa($.value, fe);
    }
    return !1;
  }, U = ($) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: W, after: fe } = Z0(+l.value.minRange, t.value[0]);
      return to([W, fe], t.value[0], $.value);
    }
    return !1;
  }, ne = ($) => l.value.enabled && (l.value.maxRange || l.value.minRange) ? l.value.maxRange && l.value.minRange ? Y($) || U($) : l.value.maxRange ? Y($) : U($) : !1, te = ($) => {
    const { isRangeStart: W, isRangeEnd: fe } = D($), Le = l.value.enabled ? W || fe : !1;
    return {
      dp__cell_offset: !$.current,
      dp__pointer: !e.disabled && !(!$.current && e.hideOffsetDates) && !f($.value) && !ne($),
      dp__cell_disabled: f($.value) || ne($),
      dp__cell_highlight: !ve($) && (ee($) || q($)) && !K($) && !Le && !_($) && !(O($) && e.weekPicker) && !fe,
      dp__cell_highlight_active: !ve($) && (ee($) || q($)) && K($),
      dp__today: !e.noToday && Ie($.value, d.value) && $.current,
      "dp--past": i1($.value, d.value),
      "dp--future": c1($.value, d.value)
    };
  }, G = ($) => ({
    dp__active_date: K($),
    dp__date_hover: B($)
  }), T = ($) => {
    if (t.value && !Array.isArray(t.value)) {
      const W = kt(t.value, e.weekStart);
      return {
        ...A($),
        dp__range_start: Ie(W[0], $.value),
        dp__range_end: Ie(W[1], $.value),
        dp__range_between_week: c1($.value, W[0]) && i1($.value, W[1])
      };
    }
    return {
      ...A($)
    };
  }, Z = ($) => {
    if (t.value && Array.isArray(t.value)) {
      const W = kt(t.value[0], e.weekStart), fe = t.value[1] ? kt(t.value[1], e.weekStart) : [];
      return {
        ...A($),
        dp__range_start: Ie(W[0], $.value) || Ie(fe[0], $.value),
        dp__range_end: Ie(W[1], $.value) || Ie(fe[1], $.value),
        dp__range_between_week: c1($.value, W[0]) && i1($.value, W[1]) || c1($.value, fe[0]) && i1($.value, fe[1]),
        dp__range_between: c1($.value, W[1]) && i1($.value, fe[0])
      };
    }
    return {
      ...A($)
    };
  }, D = ($) => {
    const W = a.value.count > 0 ? $.current && p($) && F() : p($) && F(), fe = a.value.count > 0 ? $.current && p($, !1) && F() : p($, !1) && F();
    return { isRangeStart: W, isRangeEnd: fe };
  }, x = ($) => {
    const { isRangeStart: W, isRangeEnd: fe } = D($);
    return {
      dp__range_start: W,
      dp__range_end: fe,
      dp__range_between: O($),
      dp__date_hover: Ie($.value, u.value) && !W && !fe && !e.weekPicker,
      dp__date_hover_start: h($, !0),
      dp__date_hover_end: h($, !1)
    };
  }, A = ($) => ({
    ...x($),
    dp__cell_auto_range: w($),
    dp__cell_auto_range_start: _($),
    dp__cell_auto_range_end: H($)
  }), N = ($) => l.value.enabled ? l.value.autoRange ? A($) : e.modelAuto ? { ...G($), ...x($) } : e.weekPicker ? Z($) : x($) : e.weekPicker ? T($) : G($);
  return {
    setHoverDate: k,
    clearHoverDate: y,
    getDayClassData: ($) => e.hideOffsetDates && !$.current ? {} : {
      ...te($),
      ...N($),
      [e.dayClass ? e.dayClass($.value, e.internalModelValue) : ""]: !0,
      ...n.value.calendarCell ?? {}
    }
  };
}, It = (t) => {
  const { defaultedFilters: e, defaultedRange: a, propDates: o, defaultedMultiDates: n } = n1(t), r = (q) => o.value.disabledDates ? typeof o.value.disabledDates == "function" ? o.value.disabledDates(be(q)) : !!dn(q, o.value.disabledDates) : !1, s = (q) => o.value.maxDate ? t.yearPicker ? Ee(q) > Ee(o.value.maxDate) : c1(q, o.value.maxDate) : !1, i = (q) => o.value.minDate ? t.yearPicker ? Ee(q) < Ee(o.value.minDate) : i1(q, o.value.minDate) : !1, l = (q) => {
    const O = s(q), Y = i(q), U = r(q), ne = e.value.months.map((D) => +D).includes(Be(q)), te = t.disabledWeekDays.length ? t.disabledWeekDays.some((D) => +D === Km(q)) : !1, G = y(q), T = Ee(q), Z = T < +t.yearRange[0] || T > +t.yearRange[1];
    return !(O || Y || U || ne || Z || te || G);
  }, f = (q, O) => i1(...Dt(o.value.minDate, q, O)) || Ie(...Dt(o.value.minDate, q, O)), u = (q, O) => c1(...Dt(o.value.maxDate, q, O)) || Ie(...Dt(o.value.maxDate, q, O)), d = (q, O, Y) => {
    let U = !1;
    return o.value.maxDate && Y && u(q, O) && (U = !0), o.value.minDate && !Y && f(q, O) && (U = !0), U;
  }, k = (q, O, Y, U) => {
    let ne = !1;
    return U && (o.value.minDate || o.value.maxDate) ? o.value.minDate && o.value.maxDate ? ne = d(q, O, Y) : (o.value.minDate && f(q, O) || o.value.maxDate && u(q, O)) && (ne = !0) : ne = !0, ne;
  }, y = (q) => Array.isArray(o.value.allowedDates) && !o.value.allowedDates.length ? !0 : o.value.allowedDates ? !dn(q, o.value.allowedDates) : !1, b = (q) => !l(q), M = (q) => a.value.noDisabledRange ? !Qi({ start: q[0], end: q[1] }).some((O) => b(O)) : !0, c = (q) => {
    if (q) {
      const O = Ee(q);
      return O >= +t.yearRange[0] && O <= t.yearRange[1];
    }
    return !0;
  }, p = (q, O) => !!(Array.isArray(q) && q[O] && (a.value.maxRange || a.value.minRange) && c(q[O])), h = (q, O, Y = 0) => {
    if (p(O, Y) && c(q)) {
      const U = Ki(q, O[Y]), ne = w2(O[Y], q), te = ne.length === 1 ? 0 : ne.filter((T) => b(T)).length, G = Math.abs(U) - (a.value.minMaxRawRange ? 0 : te);
      if (a.value.minRange && a.value.maxRange)
        return G >= +a.value.minRange && G <= +a.value.maxRange;
      if (a.value.minRange) return G >= +a.value.minRange;
      if (a.value.maxRange) return G <= +a.value.maxRange;
    }
    return !0;
  }, v = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, H = (q) => Array.isArray(q) ? [q[0] ? rr(q[0]) : null, q[1] ? rr(q[1]) : null] : rr(q), w = (q, O, Y) => q.find(
    (U) => +U.hours === wt(O) && U.minutes === "*" ? !0 : +U.minutes === Tt(O) && +U.hours === wt(O)
  ) && Y, _ = (q, O, Y) => {
    const [U, ne] = q, [te, G] = O;
    return !w(U, te, Y) && !w(ne, G, Y) && Y;
  }, L = (q, O) => {
    const Y = Array.isArray(O) ? O : [O];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? _(t.disabledTimes, Y, q) : !Y.some((U) => w(t.disabledTimes, U, q)) : q;
  }, I = (q, O) => {
    const Y = Array.isArray(O) ? [Qt(O[0]), O[1] ? Qt(O[1]) : void 0] : Qt(O), U = !t.disabledTimes(Y);
    return q && U;
  }, F = (q, O) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? L(O, q) : I(O, q) : O, B = (q) => {
    let O = !0;
    if (!q || v()) return !0;
    const Y = !o.value.minDate && !o.value.maxDate ? H(q) : q;
    return (t.maxTime || o.value.maxDate) && (O = I0(
      t.maxTime,
      o.value.maxDate,
      "max",
      C1(Y),
      O
    )), (t.minTime || o.value.minDate) && (O = I0(
      t.minTime,
      o.value.minDate,
      "min",
      C1(Y),
      O
    )), F(q, O);
  }, K = (q) => {
    if (!t.monthPicker) return !0;
    let O = !0;
    const Y = be(Q1(q));
    if (o.value.minDate && o.value.maxDate) {
      const U = be(Q1(o.value.minDate)), ne = be(Q1(o.value.maxDate));
      return c1(Y, U) && i1(Y, ne) || Ie(Y, U) || Ie(Y, ne);
    }
    if (o.value.minDate) {
      const U = be(Q1(o.value.minDate));
      O = c1(Y, U) || Ie(Y, U);
    }
    if (o.value.maxDate) {
      const U = be(Q1(o.value.maxDate));
      O = i1(Y, U) || Ie(Y, U);
    }
    return O;
  }, ee = Q(() => (q) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : B(q)), ve = Q(() => (q) => t.monthPicker ? Array.isArray(q) && (a.value.enabled || n.value.enabled) ? !q.filter((O) => !K(O)).length : K(q) : !0);
  return {
    isDisabled: b,
    validateDate: l,
    validateMonthYearInRange: k,
    isDateRangeAllowed: M,
    checkMinMaxRange: h,
    isValidTime: B,
    isTimeValid: ee,
    isMonthValid: ve
  };
}, Ln = () => {
  const t = Q(() => (o, n) => o?.includes(n)), e = Q(() => (o, n) => o.count ? o.solo ? !0 : n === 0 : !0), a = Q(() => (o, n) => o.count ? o.solo ? !0 : n === o.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: a };
}, Uh = (t, e, a) => {
  const o = me(0), n = so({
    [Xt.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Xt.calendar]: !1,
    [Xt.header]: !1
  }), r = Q(() => t.monthPicker || t.timePicker), s = (d) => {
    var k;
    if ((k = t.flow) != null && k.length) {
      if (!d && r.value) return u();
      n[d] = !0, Object.keys(n).filter((y) => !n[y]).length || u();
    }
  }, i = () => {
    var d, k;
    (d = t.flow) != null && d.length && o.value !== -1 && (o.value += 1, e("flow-step", o.value), u()), ((k = t.flow) == null ? void 0 : k.length) === o.value && p1().then(() => l());
  }, l = () => {
    o.value = -1;
  }, f = (d, k, ...y) => {
    var b, M;
    t.flow[o.value] === d && a.value && ((M = (b = a.value)[k]) == null || M.call(b, ...y));
  }, u = (d = 0) => {
    d && (o.value += d), f(M1.month, "toggleMonthPicker", !0), f(M1.year, "toggleYearPicker", !0), f(M1.calendar, "toggleTimePicker", !1, !0), f(M1.time, "toggleTimePicker", !0, !0);
    const k = t.flow[o.value];
    (k === M1.hours || k === M1.minutes || k === M1.seconds) && f(k, "toggleTimePicker", !0, !0, k);
  };
  return { childMount: s, updateFlowStep: i, resetFlow: l, handleFlow: u, flowStep: o };
}, Yh = {
  key: 1,
  class: "dp__input_wrap"
}, Wh = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], Kh = {
  key: 2,
  class: "dp--clear-btn"
}, Gh = ["aria-label"], Xh = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ..._n
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, {
      defaultedTextInput: r,
      defaultedAriaLabels: s,
      defaultedInline: i,
      defaultedConfig: l,
      defaultedRange: f,
      defaultedMultiDates: u,
      defaultedUI: d,
      getDefaultPattern: k,
      getDefaultStartTime: y
    } = n1(n), { checkMinMaxRange: b } = It(n), M = me(), c = me(null), p = me(!1), h = me(!1), v = Q(
      () => ({
        dp__pointer: !n.disabled && !n.readonly && !r.value.enabled,
        dp__disabled: n.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !n.hideInputIcon,
        dp__input_valid: typeof n.state == "boolean" ? n.state : !1,
        dp__input_invalid: typeof n.state == "boolean" ? !n.state : !1,
        dp__input_focus: p.value || n.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        ...d.value.input ?? {}
      })
    ), H = () => {
      o("set-input-date", null), n.clearable && n.autoApply && (o("set-empty-date"), M.value = null);
    }, w = (T) => {
      const Z = y();
      return mf(
        T,
        r.value.format ?? k(),
        Z ?? _2({}, n.enableSeconds),
        n.inputValue,
        h.value,
        n.formatLocale
      );
    }, _ = (T) => {
      const { rangeSeparator: Z } = r.value, [D, x] = T.split(`${Z}`);
      if (D) {
        const A = w(D.trim()), N = x ? w(x.trim()) : null;
        if (aa(A, N)) return;
        const $ = A && N ? [A, N] : [A];
        b(N, $, 0) && (M.value = A ? $ : null);
      }
    }, L = () => {
      h.value = !0;
    }, I = (T) => {
      if (f.value.enabled)
        _(T);
      else if (u.value.enabled) {
        const Z = T.split(";");
        M.value = Z.map((D) => w(D.trim())).filter((D) => D);
      } else
        M.value = w(T);
    }, F = (T) => {
      var Z;
      const D = typeof T == "string" ? T : (Z = T.target) == null ? void 0 : Z.value;
      D !== "" ? (r.value.openMenu && !n.isMenuOpen && o("open"), I(D), o("set-input-date", M.value)) : H(), h.value = !1, o("update:input-value", D), o("text-input", T, M.value);
    }, B = (T) => {
      r.value.enabled ? (I(T.target.value), r.value.enterSubmit && Vr(M.value) && n.inputValue !== "" ? (o("set-input-date", M.value, !0), M.value = null) : r.value.enterSubmit && n.inputValue === "" && (M.value = null, o("clear"))) : ve(T);
    }, K = (T, Z) => {
      r.value.enabled && r.value.tabSubmit && !Z && I(T.target.value), r.value.tabSubmit && Vr(M.value) && n.inputValue !== "" ? (o("set-input-date", M.value, !0, !0), M.value = null) : r.value.tabSubmit && n.inputValue === "" && (M.value = null, o("clear", !0));
    }, ee = () => {
      p.value = !0, o("focus"), p1().then(() => {
        var T;
        r.value.enabled && r.value.selectOnFocus && ((T = c.value) == null || T.select());
      });
    }, ve = (T) => {
      if (Pt(T, l.value, !0), r.value.enabled && r.value.openMenu && !i.value.input) {
        if (r.value.openMenu === "open" && !n.isMenuOpen) return o("open");
        if (r.value.openMenu === "toggle") return o("toggle");
      } else r.value.enabled || o("toggle");
    }, q = () => {
      o("real-blur"), p.value = !1, (!n.isMenuOpen || i.value.enabled && i.value.input) && o("blur"), n.autoApply && r.value.enabled && M.value && !n.isMenuOpen && (o("set-input-date", M.value), o("select-date"), M.value = null);
    }, O = (T) => {
      Pt(T, l.value, !0), o("clear");
    }, Y = () => {
      o("close");
    }, U = (T) => {
      if (T.key === "Tab" && K(T), T.key === "Enter" && B(T), T.key === "Escape" && r.value.escClose && Y(), !r.value.enabled) {
        if (T.code === "Tab") return;
        T.preventDefault();
      }
    }, ne = () => {
      var T;
      (T = c.value) == null || T.focus({ preventScroll: !0 });
    }, te = (T) => {
      M.value = T;
    }, G = (T) => {
      T.key === o1.tab && K(T, !0);
    };
    return e({
      focusInput: ne,
      setParsedDate: te
    }), (T, Z) => {
      var D, x, A;
      return m(), C("div", { onClick: ve }, [
        T.$slots.trigger && !T.$slots["dp-input"] && !j(i).enabled ? oe(T.$slots, "trigger", { key: 0 }) : ae("", !0),
        !T.$slots.trigger && (!j(i).enabled || j(i).input) ? (m(), C("div", Yh, [
          T.$slots["dp-input"] && !T.$slots.trigger && (!j(i).enabled || j(i).enabled && j(i).input) ? oe(T.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: F,
            onEnter: B,
            onTab: K,
            onClear: O,
            onBlur: q,
            onKeypress: U,
            onPaste: L,
            onFocus: ee,
            openMenu: () => T.$emit("open"),
            closeMenu: () => T.$emit("close"),
            toggleMenu: () => T.$emit("toggle")
          }) : ae("", !0),
          T.$slots["dp-input"] ? ae("", !0) : (m(), C("input", {
            key: 1,
            id: T.uid ? `dp-input-${T.uid}` : void 0,
            ref_key: "inputRef",
            ref: c,
            "data-test-id": "dp-input",
            name: T.name,
            class: le(v.value),
            inputmode: j(r).enabled ? "text" : "none",
            placeholder: T.placeholder,
            disabled: T.disabled,
            readonly: T.readonly,
            required: T.required,
            value: t.inputValue,
            autocomplete: T.autocomplete,
            "aria-label": (D = j(s)) == null ? void 0 : D.input,
            "aria-disabled": T.disabled || void 0,
            "aria-invalid": T.state === !1 ? !0 : void 0,
            onInput: F,
            onBlur: q,
            onFocus: ee,
            onKeypress: U,
            onKeydown: Z[0] || (Z[0] = (N) => U(N)),
            onPaste: L
          }, null, 42, Wh)),
          g("div", {
            onClick: Z[3] || (Z[3] = (N) => o("toggle"))
          }, [
            T.$slots["input-icon"] && !T.hideInputIcon ? (m(), C("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Z[1] || (Z[1] = (N) => o("toggle"))
            }, [
              oe(T.$slots, "input-icon")
            ])) : ae("", !0),
            !T.$slots["input-icon"] && !T.hideInputIcon && !T.$slots["dp-input"] ? (m(), he(j(Pa), {
              key: 1,
              "aria-label": (x = j(s)) == null ? void 0 : x.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: Z[2] || (Z[2] = (N) => o("toggle"))
            }, null, 8, ["aria-label"])) : ae("", !0)
          ]),
          T.$slots["clear-icon"] && (T.alwaysClearable || t.inputValue && T.clearable && !T.disabled && !T.readonly) ? (m(), C("span", Kh, [
            oe(T.$slots, "clear-icon", { clear: O })
          ])) : ae("", !0),
          !T.$slots["clear-icon"] && (T.alwaysClearable || T.clearable && t.inputValue && !T.disabled && !T.readonly) ? (m(), C("button", {
            key: 3,
            "aria-label": (A = j(s)) == null ? void 0 : A.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: Z[4] || (Z[4] = (N) => j(T1)(N, () => O(N), !0, G)),
            onClick: Z[5] || (Z[5] = $e((N) => O(N), ["prevent"]))
          }, [
            ye(j(f2), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, Gh)) : ae("", !0)
        ])) : ae("", !0)
      ]);
    };
  }
}), Qh = typeof window < "u" ? window : void 0, dr = () => {
}, Jh = (t) => Tl() ? (Ol(t), !0) : !1, ev = (t, e, a, o) => {
  if (!t) return dr;
  let n = dr;
  const r = Ue(
    () => j(t),
    (i) => {
      n(), i && (i.addEventListener(e, a, o), n = () => {
        i.removeEventListener(e, a, o), n = dr;
      });
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    r(), n();
  };
  return Jh(s), s;
}, tv = (t, e, a, o = {}) => {
  const { window: n = Qh, event: r = "pointerdown" } = o;
  return n ? ev(n, r, (s) => {
    const i = y1(t), l = y1(e);
    !i || !l || i === s.target || s.composedPath().includes(i) || s.composedPath().includes(l) || a(s);
  }, { passive: !0 }) : void 0;
}, av = ["data-dp-mobile"], ov = /* @__PURE__ */ J({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ..._n
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(t, { expose: e, emit: a }) {
    const o = a, n = t, r = _t(), s = me(!1), i = Qa(n, "modelValue"), l = Qa(n, "timezone"), f = me(null), u = me(null), d = me(null), k = me(!1), y = me(null), b = me(!1), M = me(!1), c = me(!1), p = me(!1), { setMenuFocused: h, setShiftKey: v } = x2(), { clearArrowNav: H } = Bt(), { validateDate: w, isValidTime: _ } = It(n), {
      defaultedTransitions: L,
      defaultedTextInput: I,
      defaultedInline: F,
      defaultedConfig: B,
      defaultedRange: K,
      defaultedMultiDates: ee
    } = n1(n), { menuTransition: ve, showTransition: q } = uo(L), { isMobile: O } = D2(B);
    h1(() => {
      N(n.modelValue), p1().then(() => {
        if (!F.value.enabled) {
          const pe = Z(y.value);
          pe?.addEventListener("scroll", R), window?.addEventListener("resize", ie);
        }
      }), F.value.enabled && (s.value = !0), window?.addEventListener("keyup", de), window?.addEventListener("keydown", Ce);
    }), oa(() => {
      if (!F.value.enabled) {
        const pe = Z(y.value);
        pe?.removeEventListener("scroll", R), window?.removeEventListener("resize", ie);
      }
      window?.removeEventListener("keyup", de), window?.removeEventListener("keydown", Ce);
    });
    const Y = Z1(r, "all", n.presetDates), U = Z1(r, "input");
    Ue(
      [i, l],
      () => {
        N(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: ne, menuStyle: te, xCorrect: G, setMenuPosition: T, getScrollableParent: Z, shadowRender: D } = Zh({
      menuRef: f,
      menuRefInner: u,
      inputRef: d,
      pickerWrapperRef: y,
      inline: F,
      emit: o,
      props: n,
      slots: r
    }), {
      inputValue: x,
      internalModelValue: A,
      parseExternalModelValue: N,
      emitModelValue: $,
      formatInputValue: W,
      checkBeforeEmit: fe
    } = Tf(o, n, k), Le = Q(
      () => ({
        dp__main: !0,
        dp__theme_dark: n.dark,
        dp__theme_light: !n.dark,
        dp__flex_display: F.value.enabled,
        "dp--flex-display-collapsed": c.value,
        dp__flex_display_with_input: F.value.input
      })
    ), z = Q(() => n.dark ? "dp__theme_dark" : "dp__theme_light"), P = Q(() => n.teleport ? {
      to: typeof n.teleport == "boolean" ? "body" : n.teleport,
      disabled: !n.teleport || F.value.enabled
    } : {}), V = Q(() => ({ class: "dp__outer_menu_wrap" })), E = Q(() => F.value.enabled && (n.timePicker || n.monthPicker || n.yearPicker || n.quarterPicker)), S = () => {
      var pe, we;
      return ((we = (pe = d.value) == null ? void 0 : pe.$el) == null ? void 0 : we.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, R = () => {
      s.value && (B.value.closeOnScroll ? Pe() : T());
    }, ie = () => {
      var pe;
      s.value && T();
      const we = ((pe = u.value) == null ? void 0 : pe.$el.getBoundingClientRect().width) ?? 0;
      c.value = document.body.offsetWidth <= we;
    }, de = (pe) => {
      pe.key === "Tab" && !F.value.enabled && !n.teleport && B.value.tabOutClosesMenu && (y.value.contains(document.activeElement) || Pe()), M.value = pe.shiftKey;
    }, Ce = (pe) => {
      M.value = pe.shiftKey;
    }, He = () => {
      !n.disabled && !n.readonly && (D(U0, n), T(!1), s.value = !0, s.value && o("open"), s.value || ze(), N(n.modelValue));
    }, X = () => {
      var pe, we;
      x.value = "", ze(), (pe = u.value) == null || pe.onValueCleared(), (we = d.value) == null || we.setParsedDate(null), o("update:model-value", null), o("update:model-timezone-value", null), o("cleared"), B.value.closeOnClearValue && Pe();
    }, ce = () => {
      const pe = A.value;
      return !pe || !Array.isArray(pe) && w(pe) ? !0 : Array.isArray(pe) ? ee.value.enabled || pe.length === 2 && w(pe[0]) && w(pe[1]) ? !0 : K.value.partialRange && !n.timePicker ? w(pe[0]) : !1 : !1;
    }, je = () => {
      fe() && ce() ? ($(), Pe()) : o("invalid-select", A.value);
    }, Ze = (pe) => {
      r1(), $(), B.value.closeOnAutoApply && !pe && Pe();
    }, r1 = () => {
      d.value && I.value.enabled && d.value.setParsedDate(A.value);
    }, xe = (pe = !1) => {
      n.autoApply && _(A.value) && ce() && (K.value.enabled && Array.isArray(A.value) ? (K.value.partialRange || A.value.length === 2) && Ze(pe) : Ze(pe));
    }, ze = () => {
      I.value.enabled || (A.value = null);
    }, Pe = (pe = !1) => {
      pe && A.value && B.value.setDateOnMenuClose && je(), F.value.enabled || (s.value && (s.value = !1, G.value = !1, h(!1), v(!1), H(), o("closed"), x.value && N(i.value)), ze(), o("blur"));
    }, E1 = (pe, we, Me = !1) => {
      if (!pe) {
        A.value = null;
        return;
      }
      const st = Array.isArray(pe) ? !pe.some((la) => !w(la)) : w(pe), U1 = _(pe);
      st && U1 ? (p.value = !0, A.value = pe, we && (b.value = Me, je(), o("text-submit")), p1().then(() => {
        p.value = !1;
      })) : o("invalid-date", pe);
    }, rt = () => {
      n.autoApply && _(A.value) && $(), r1();
    }, fo = () => s.value ? Pe() : He(), En = (pe) => {
      A.value = pe;
    }, Dn = () => {
      I.value.enabled && (k.value = !0, W()), o("focus");
    }, Pn = () => {
      if (I.value.enabled && (k.value = !1, N(n.modelValue), b.value)) {
        const pe = lf(y.value, M.value);
        pe?.focus();
      }
      o("blur");
    }, zn = (pe) => {
      u.value && u.value.updateMonthYear(0, {
        month: O0(pe.month),
        year: O0(pe.year)
      });
    }, Tn = (pe) => {
      N(pe ?? n.modelValue);
    }, On = (pe, we) => {
      var Me;
      (Me = u.value) == null || Me.switchView(pe, we);
    }, re = (pe, we) => B.value.onClickOutside ? B.value.onClickOutside(pe, we) : Pe(!0), ke = (pe = 0) => {
      var we;
      (we = u.value) == null || we.handleFlow(pe);
    }, Ve = () => f;
    return tv(
      f,
      d,
      (pe) => re(ce, pe)
    ), e({
      closeMenu: Pe,
      selectDate: je,
      clearValue: X,
      openMenu: He,
      onScroll: R,
      formatInputValue: W,
      // exposed for testing purposes
      updateInternalModelValue: En,
      // modify internal modelValue
      setMonthYear: zn,
      parseModel: Tn,
      switchView: On,
      toggleMenu: fo,
      handleFlow: ke,
      getDpWrapMenuRef: Ve
    }), (pe, we) => (m(), C("div", {
      ref_key: "pickerWrapperRef",
      ref: y,
      class: le(Le.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": j(O)
    }, [
      ye(Xh, Re({
        ref_key: "inputRef",
        ref: d,
        "input-value": j(x),
        "onUpdate:inputValue": we[0] || (we[0] = (Me) => y0(x) ? x.value = Me : null),
        "is-menu-open": s.value
      }, pe.$props, {
        onClear: X,
        onOpen: He,
        onSetInputDate: E1,
        onSetEmptyDate: j($),
        onSelectDate: je,
        onToggle: fo,
        onClose: Pe,
        onFocus: Dn,
        onBlur: Pn,
        onRealBlur: we[1] || (we[1] = (Me) => k.value = !1),
        onTextInput: we[2] || (we[2] = (Me) => pe.$emit("text-input", Me))
      }), f1({ _: 2 }, [
        De(j(U), (Me, st) => ({
          name: Me,
          fn: ue((U1) => [
            oe(pe.$slots, Me, v1(V1(U1)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (m(), he(S1(pe.teleport ? Pi : "div"), v1(V1(P.value)), {
        default: ue(() => [
          ye(Va, {
            name: j(ve)(j(ne)),
            css: j(q) && !j(F).enabled
          }, {
            default: ue(() => [
              s.value ? (m(), C("div", Re({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: f
              }, V.value, {
                class: { "dp--menu-wrapper": !j(F).enabled },
                style: j(F).enabled ? void 0 : j(te)
              }), [
                ye(U0, Re({
                  ref_key: "dpMenuRef",
                  ref: u
                }, pe.$props, {
                  "internal-model-value": j(A),
                  "onUpdate:internalModelValue": we[3] || (we[3] = (Me) => y0(A) ? A.value = Me : null),
                  class: { [z.value]: !0, "dp--menu-wrapper": pe.teleport },
                  "open-on-top": j(ne),
                  "no-overlay-focus": E.value,
                  collapse: c.value,
                  "get-input-rect": S,
                  "is-text-input-date": p.value,
                  onClosePicker: Pe,
                  onSelectDate: je,
                  onAutoApply: xe,
                  onTimeUpdate: rt,
                  onFlowStep: we[4] || (we[4] = (Me) => pe.$emit("flow-step", Me)),
                  onUpdateMonthYear: we[5] || (we[5] = (Me) => pe.$emit("update-month-year", Me)),
                  onInvalidSelect: we[6] || (we[6] = (Me) => pe.$emit("invalid-select", j(A))),
                  onAutoApplyInvalid: we[7] || (we[7] = (Me) => pe.$emit("invalid-select", Me)),
                  onInvalidFixedRange: we[8] || (we[8] = (Me) => pe.$emit("invalid-fixed-range", Me)),
                  onRecalculatePosition: j(T),
                  onTooltipOpen: we[9] || (we[9] = (Me) => pe.$emit("tooltip-open", Me)),
                  onTooltipClose: we[10] || (we[10] = (Me) => pe.$emit("tooltip-close", Me)),
                  onTimePickerOpen: we[11] || (we[11] = (Me) => pe.$emit("time-picker-open", Me)),
                  onTimePickerClose: we[12] || (we[12] = (Me) => pe.$emit("time-picker-close", Me)),
                  onAmPmChange: we[13] || (we[13] = (Me) => pe.$emit("am-pm-change", Me)),
                  onRangeStart: we[14] || (we[14] = (Me) => pe.$emit("range-start", Me)),
                  onRangeEnd: we[15] || (we[15] = (Me) => pe.$emit("range-end", Me)),
                  onDateUpdate: we[16] || (we[16] = (Me) => pe.$emit("date-update", Me)),
                  onInvalidDate: we[17] || (we[17] = (Me) => pe.$emit("invalid-date", Me)),
                  onOverlayToggle: we[18] || (we[18] = (Me) => pe.$emit("overlay-toggle", Me)),
                  onMenuBlur: we[19] || (we[19] = (Me) => pe.$emit("blur"))
                }), f1({ _: 2 }, [
                  De(j(Y), (Me, st) => ({
                    name: Me,
                    fn: ue((U1) => [
                      oe(pe.$slots, Me, v1(V1({ ...U1 })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : ae("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, av));
  }
}), ao = /* @__PURE__ */ (() => {
  const t = ov;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), nv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ao
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(nv).forEach(([t, e]) => {
  t !== "default" && (ao[t] = e);
});
const qx = /* @__PURE__ */ J({
  __name: "DatePicker",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    uid: {},
    is24: { type: Boolean },
    enableTimePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    locale: {},
    position: {},
    dark: { type: Boolean },
    placeholder: { default: "dd/mm/yyyy" },
    weekNumbers: {},
    hoursIncrement: {},
    hoursGridIncrement: {},
    secondsGridIncrement: {},
    minutesGridIncrement: {},
    minutesIncrement: {},
    secondsIncrement: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    minTime: {},
    maxTime: {},
    weekStart: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean },
    required: { type: Boolean },
    format: {},
    previewFormat: {},
    hideInputIcon: { type: Boolean },
    state: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    alwaysClearable: { type: Boolean },
    autoApply: { type: Boolean },
    filters: {},
    disableMonthYearSelect: { type: Boolean },
    yearRange: {},
    disabledDates: {},
    inline: { type: [Boolean, Object] },
    selectText: {},
    cancelText: {},
    weekNumName: {},
    autoPosition: { type: [Boolean, String] },
    monthPicker: { type: Boolean },
    timePicker: { type: Boolean },
    textInput: { type: [Boolean, Object] },
    monthNameFormat: {},
    startDate: {},
    startTime: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    noHoursOverlay: { type: Boolean },
    noMinutesOverlay: { type: Boolean },
    noSecondsOverlay: { type: Boolean },
    altPosition: {},
    disabledWeekDays: {},
    allowedDates: {},
    nowButtonLabel: {},
    monthChangeOnScroll: { type: [Boolean, String] },
    markers: {},
    transitions: { type: [Boolean, Object] },
    enableSeconds: { type: Boolean },
    escClose: { type: Boolean },
    spaceConfirm: { type: Boolean },
    monthChangeOnArrows: { type: Boolean },
    formatLocale: {},
    autocomplete: {},
    multiDates: { type: [Boolean, Object] },
    presetDates: {},
    flow: {},
    partialFlow: { type: Boolean },
    preventMinMaxNavigation: { type: Boolean },
    utc: { type: [Boolean, String] },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    vertical: { type: Boolean },
    ariaLabels: {},
    arrowNavigation: { type: Boolean },
    yearPicker: { type: Boolean },
    dayNames: {},
    modelType: {},
    modelAuto: { type: Boolean },
    highlight: {},
    offset: {},
    teleportCenter: { type: Boolean },
    teleport: { type: [Boolean, String] },
    ignoreTimeValidation: { type: Boolean },
    dayClass: {},
    hideNavigation: {},
    sixWeeks: { type: [Boolean, String] },
    timezone: {},
    disableYearSelect: { type: Boolean },
    focusStartDate: { type: Boolean },
    disabledTimes: {},
    timePickerInline: { type: Boolean },
    calendar: {},
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    onInternalModelChange: {},
    enableMinutes: { type: Boolean },
    ui: {},
    date: { default: void 0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = Q(() => ({
      input: ["date-input", e.isValid ? "" : "!border-red"].join(" ")
    })), o = (s) => J1(s).format("DD-MM-YYYY"), n = Q(() => {
      if (e.date)
        return J1(e.date).startOf("day").toISOString();
    }), r = e1(t, "modelValue", {
      get(s) {
        return J1(s).toDate();
      },
      set(s) {
        return s ? J1(s).startOf("day").toISOString() : "";
      }
    });
    return (s, i) => (m(), he(j(ao), {
      modelValue: r.value,
      "onUpdate:modelValue": i[0] || (i[0] = (l) => r.value = l),
      name: s.name,
      ui: a.value,
      date: n.value,
      "text-input": !1,
      "prevent-min-max-navigation": !0,
      "enable-time-picker": !1,
      "auto-apply": !0,
      clearable: s.clearable,
      placeholder: s.placeholder,
      disabled: s.disabled,
      "min-date": s.minDate,
      "max-date": s.maxDate,
      "aria-labels": s.ariaLabels,
      format: o
    }, null, 8, ["modelValue", "name", "ui", "date", "clearable", "placeholder", "disabled", "min-date", "max-date", "aria-labels"]));
  }
}), rv = { class: "flex" }, sv = /* @__PURE__ */ J({
  __name: "DatePickerRange",
  props: {
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean },
    uid: {},
    is24: { type: Boolean },
    enableTimePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    locale: {},
    position: {},
    dark: { type: Boolean },
    placeholder: { default: "dd/mm/yyyy" },
    weekNumbers: {},
    hoursIncrement: {},
    hoursGridIncrement: {},
    secondsGridIncrement: {},
    minutesGridIncrement: {},
    minutesIncrement: {},
    secondsIncrement: {},
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    weekStart: {},
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean },
    required: { type: Boolean },
    format: {},
    previewFormat: {},
    hideInputIcon: { type: Boolean },
    state: { type: Boolean },
    clearable: { type: Boolean, default: !1 },
    alwaysClearable: { type: Boolean },
    autoApply: { type: Boolean },
    filters: {},
    disableMonthYearSelect: { type: Boolean },
    yearRange: {},
    disabledDates: {},
    inline: { type: [Boolean, Object] },
    selectText: {},
    cancelText: {},
    weekNumName: {},
    autoPosition: { type: [Boolean, String] },
    monthPicker: { type: Boolean },
    timePicker: { type: Boolean },
    textInput: { type: [Boolean, Object] },
    monthNameFormat: {},
    startDate: {},
    startTime: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    noHoursOverlay: { type: Boolean },
    noMinutesOverlay: { type: Boolean },
    noSecondsOverlay: { type: Boolean },
    altPosition: {},
    disabledWeekDays: {},
    allowedDates: {},
    nowButtonLabel: {},
    monthChangeOnScroll: { type: [Boolean, String] },
    markers: {},
    transitions: { type: [Boolean, Object] },
    enableSeconds: { type: Boolean },
    escClose: { type: Boolean },
    spaceConfirm: { type: Boolean },
    monthChangeOnArrows: { type: Boolean },
    formatLocale: {},
    autocomplete: {},
    multiDates: { type: [Boolean, Object] },
    presetDates: {},
    flow: {},
    partialFlow: { type: Boolean },
    preventMinMaxNavigation: { type: Boolean },
    utc: { type: [Boolean, String] },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    vertical: { type: Boolean },
    ariaLabels: {},
    arrowNavigation: { type: Boolean },
    yearPicker: { type: Boolean },
    dayNames: {},
    modelType: {},
    modelAuto: { type: Boolean },
    highlight: {},
    offset: {},
    teleportCenter: { type: Boolean },
    teleport: { type: [Boolean, String] },
    ignoreTimeValidation: { type: Boolean },
    dayClass: {},
    hideNavigation: {},
    sixWeeks: { type: [Boolean, String] },
    timezone: {},
    disableYearSelect: { type: Boolean },
    focusStartDate: { type: Boolean },
    disabledTimes: {},
    timePickerInline: { type: Boolean },
    calendar: {},
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    onInternalModelChange: {},
    enableMinutes: { type: Boolean },
    ui: {},
    fromDate: {},
    endDate: {},
    placeholderEndDate: { default: "dd/mm/yyyy" },
    startDateInputProps: { default: () => ({}) },
    endDateInputProps: { default: () => ({}) },
    startDateIsValid: { type: Boolean, default: !0 },
    endDateIsValid: { type: Boolean, default: !0 }
  },
  emits: ["update:fromDate", "update:endDate"],
  setup(t, { emit: e }) {
    const a = (d) => J1(d).format("DD-MM-YYYY"), o = t, n = e, r = (d) => {
      if (d instanceof Date)
        return d;
      if (d)
        return J1(d).toDate();
    }, s = Q({
      get: () => r(o.fromDate),
      set: (d) => {
        n("update:fromDate", J1(d).toDate());
      }
    }), i = Q({
      get: () => r(o.endDate),
      set: (d) => {
        n("update:endDate", J1(d).toDate());
      }
    }), l = {
      "auto-apply": !0,
      "enable-time-picker": !1,
      "text-input": !1,
      "prevent-min-max-navigation": !0,
      clearable: o.clearable,
      disabled: o.disabled,
      timezone: "UTC"
    }, f = Q(() => ({
      // We apply a red border to the start if its invalid or only a right border when the end date is invalid so that the right one looks like it has a full border.
      input: ["date-input", o.startDateIsValid ? o.endDateIsValid ? "" : "border-r-red!" : "border-red!"].join(
        " "
      )
    })), u = Q(() => ({
      input: ["date-input", o.endDateIsValid ? "" : "border-red!"].join(" ")
    }));
    return (d, k) => (m(), C("div", rv, [
      ye(j(ao), Re({
        modelValue: s.value,
        "onUpdate:modelValue": k[0] || (k[0] = (y) => s.value = y)
      }, { ...l, ...d.startDateInputProps }, {
        "max-date": i.value ?? d.maxDate,
        format: a,
        placeholder: d.placeholder,
        ui: f.value
      }), null, 16, ["modelValue", "max-date", "placeholder", "ui"]),
      ye(j(ao), Re({
        modelValue: i.value,
        "onUpdate:modelValue": k[1] || (k[1] = (y) => i.value = y)
      }, { ...l, ...d.endDateInputProps }, {
        "min-date": s.value ?? void 0,
        format: a,
        "max-date": d.maxDate,
        placeholder: d.placeholderEndDate,
        ui: u.value
      }), null, 16, ["modelValue", "min-date", "max-date", "placeholder", "ui"])
    ]));
  }
}), mr = {
  Top: "top",
  Right: "right",
  Left: "left"
}, Y0 = {
  Right: "right",
  Left: "left"
}, iv = /* @__PURE__ */ J({
  __name: "FormRow",
  props: {
    labelPosition: { default: mr.Right },
    inputPosition: { default: Y0.Left },
    inline: { type: Boolean },
    hideLabel: { type: Boolean },
    preserveLabelGap: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t, a = Q(() => e.labelPosition === mr.Right), o = Q(() => e.labelPosition === mr.Left), n = Q(() => e.inputPosition === Y0.Right);
    return (r, s) => (m(), C("div", null, [
      g("div", {
        class: le(["flex flex-col gap-2 w-full", {
          "lg:flex-row! lg:gap-4": a.value || o.value,
          "flex-row!": r.inline
        }])
      }, [
        g("div", {
          class: le(["flex flex-1 justify-between", {
            "lg:h-[42px] lg:min-h-max": a.value || o.value,
            "grow-2!": r.inline,
            "lg:max-w-1/3": (a.value || o.value) && !r.inline,
            "lg:text-right flex-row-reverse lg:justify-normal": a.value,
            "gap-2": r.$slots.note,
            invisible: r.hideLabel && r.preserveLabelGap,
            hidden: r.hideLabel && !r.preserveLabelGap
          }])
        }, [
          g("div", {
            class: le(["self-center", {
              "order-2 w-full": a.value
            }])
          }, [
            oe(r.$slots, "label")
          ], 2),
          g("div", {
            class: le(["flex items-center text-left", {
              "w-[40px]": r.$slots.note || a.value || o.value,
              "order-1": a.value,
              "justify-end lg:justify-start! grow-2!": r.inline
            }])
          }, [
            oe(r.$slots, "note")
          ], 2)
        ], 2),
        g("div", {
          class: le(["flex flex-1 items-center w-full", {
            "lg:max-w-2/3": (a.value || o.value) && (!r.hideLabel || r.preserveLabelGap),
            "lg:justify-end": n.value,
            "justify-end": n.value && r.inline
          }])
        }, [
          oe(r.$slots, "default")
        ], 2)
      ], 2),
      r.$slots.errors ? (m(), C("div", {
        key: 0,
        class: le(["flex gap-2 text-left w-full", {
          "lg:flex-row lg:gap-4": a.value || o.value
        }])
      }, [
        g("div", {
          class: le(["flex-1", {
            "lg:max-w-1/3": (a.value || o.value) && (!r.hideLabel || r.preserveLabelGap),
            "max-lg:hidden": a.value || o.value,
            invisible: r.hideLabel && r.preserveLabelGap,
            hidden: r.hideLabel && !r.preserveLabelGap
          }])
        }, null, 2),
        g("div", {
          class: le(["flex-1", {
            "lg:max-w-2/3": (a.value || o.value) && (!r.hideLabel || r.preserveLabelGap)
          }])
        }, [
          oe(r.$slots, "errors")
        ], 2)
      ], 2)) : ae("", !0)
    ]));
  }
}), lv = { class: "border h-[144px] p- p-4 relative rounded-regular w-[144px]" }, uv = { class: "flex h-full items-center overflow-hidden rounded-regular w-full" }, cv = ["src"], dv = { key: 0 }, Ux = /* @__PURE__ */ J({
  __name: "ImageUpload",
  props: {
    emptyText: {},
    deleteButtonText: {},
    editButtonText: {},
    src: {}
  },
  emits: ["edit", "delete", "upload"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = me(!1), r = () => {
      n.value = !0;
    }, s = Q(() => n.value ? void 0 : a.src);
    return (i, l) => (m(), C("div", lv, [
      s.value ? (m(), he(j(Ri), {
        key: 0,
        class: "absolute right-2 top-2"
      }, {
        default: ue(() => [
          ye(j(Hr), {
            class: "text-primary",
            title: i.editButtonText,
            onClick: l[0] || (l[0] = (f) => o("edit"))
          }, {
            default: ue(() => [
              ye(j(Oe), null, {
                default: ue(() => [
                  ye(j(e5))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          ye(j(Hr), {
            class: "text-red",
            title: i.deleteButtonText,
            onClick: l[1] || (l[1] = (f) => o("delete"))
          }, {
            default: ue(() => [
              ye(j(Oe), null, {
                default: ue(() => [
                  ye(j(_7))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })) : ae("", !0),
      g("div", uv, [
        s.value ? (m(), C("img", {
          key: 0,
          src: s.value,
          class: "h-auto w-full",
          onError: r
        }, null, 40, cv)) : (m(), C("button", {
          key: 1,
          type: "button",
          class: "flex flex-col gap-2 h-full hover:bg-gray-200 items-center justify-center text-secondary w-full",
          onClick: l[2] || (l[2] = (f) => o("upload"))
        }, [
          ye(j(Oe), null, {
            default: ue(() => [
              ye(j(Ii))
            ]),
            _: 1
          }),
          i.emptyText ? (m(), C("p", dv, _e(i.emptyText), 1)) : ae("", !0)
        ]))
      ])
    ]));
  }
}), mv = { class: "flex flex-col" }, pv = {
  key: 0,
  class: "text-gray-900 text-xs"
}, fv = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Label",
  setup(t) {
    return (e, a) => (m(), C("div", mv, [
      g("label", v1(V1(e.$attrs)), [
        oe(e.$slots, "default")
      ], 16),
      e.$slots.sublabel ? (m(), C("span", pv, [
        oe(e.$slots, "sublabel")
      ])) : ae("", !0)
    ]));
  }
}), hv = ["id", "disabled", "name", "aria-labelledby"], vv = /* @__PURE__ */ J({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    isValid: { type: Boolean, default: !0 },
    hideSpinButtons: { type: Boolean },
    labelledBy: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => Ne((m(), C("input", {
      id: a.name,
      "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
      disabled: a.disabled,
      name: a.name,
      type: "number",
      class: le(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-full text-black w-full", {
        "text-gray-800 bg-gray-200 pr-5": a.disabled,
        "border-red": !a.isValid,
        "[&::-webkit-inner-spin-button]:appearance-none": a.hideSpinButtons
      }]),
      "aria-labelledby": a.labelledBy
    }, null, 10, hv)), [
      [_a, e.value]
    ]);
  }
}), gv = { class: "flex w-full" }, yv = ["disabled"], bv = ["id", "name", "min", "max"], kv = ["disabled"], W0 = 300, K0 = 100, Cv = 20, Yx = /* @__PURE__ */ J({
  __name: "NumberInputStepper",
  props: /* @__PURE__ */ Ye({
    modelValue: {},
    name: {},
    minimum: {},
    maximum: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const a = t, o = e1(t, "modelValue", {
      set(c) {
        return c || a.minimum || 0;
      }
    }), n = _r("input"), {
      count: r,
      inc: s,
      reset: i
    } = na(0, { min: a.minimum, max: a.maximum }), l = Q(() => r.value < Cv ? K0 : K0 / 2), f = () => {
      s(), o.value = (o.value || 0) - 1;
    }, u = () => {
      s(), o.value = (o.value || 0) + 1;
    }, { resume: d, pause: k } = C0(f, l, {
      immediate: !1
    }), { resume: y, pause: b } = C0(u, l, {
      immediate: !1
    });
    oa(() => {
      i();
    });
    const M = () => {
      const c = o.value;
      c && (a.minimum !== void 0 && c < a.minimum && (o.value = a.minimum), a.maximum !== void 0 && c > a.maximum && (o.value = a.maximum));
    };
    return Ue(o, () => {
      M();
    }), e({
      element: n
    }), (c, p) => (m(), C("div", gv, [
      Ne((m(), C("button", {
        type: "button",
        class: le(["border border-r-0 font-thin px-4 rounded-l-full text-secondary hover:bg-gray-100", { "text-gray bg-gray-100": o.value === c.minimum }]),
        "aria-label": "decrease",
        disabled: o.value === c.minimum,
        onClick: f
      }, [
        ye(Oe, { class: "mt-1.5" }, {
          default: ue(() => [
            ye(j(w3))
          ]),
          _: 1
        })
      ], 10, yv)), [
        [
          j(k0),
          [
            j(d),
            {
              onMouseUp: () => {
                j(k)(), j(i)();
              },
              delay: W0
            }
          ],
          void 0,
          { prevent: !0 }
        ]
      ]),
      Ne(g("input", {
        id: c.name,
        "onUpdate:modelValue": p[0] || (p[0] = (h) => o.value = h),
        name: c.name,
        ref: "input",
        type: "number",
        min: c.minimum,
        max: c.maximum,
        onBlur: M,
        class: "rounded-l-none! rounded-r-none! [&::-webkit-inner-spin-button]:appearance-none border focus:ring-2 outline-hidden py-2 ring-blue-600 text-black text-center w-full"
      }, null, 40, bv), [
        [_a, o.value]
      ]),
      Ne((m(), C("button", {
        type: "button",
        class: le(["border border-l-0 px-4 rounded-r-full text-secondary hover:bg-gray-100", { "text-gray bg-gray-100": o.value === c.maximum }]),
        "aria-label": "increase",
        disabled: o.value === c.maximum,
        onClick: u
      }, [
        ye(Oe, { class: "mt-1.5" }, {
          default: ue(() => [
            ye(j(Ii))
          ]),
          _: 1
        })
      ], 10, kv)), [
        [
          j(k0),
          [
            j(y),
            {
              onMouseUp: () => {
                j(b)(), j(i)();
              },
              delay: W0
            }
          ],
          void 0,
          { prevent: !0 }
        ]
      ])
    ]));
  }
}), R1 = (t, e) => {
  const a = t.__vccOpts || t;
  for (const [o, n] of e)
    a[o] = n;
  return a;
}, wv = {}, _v = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM6 6.79v-.71h2.441v4.07H10v.707H6v-.706h1.625V6.79H6Zm1.638-1.633a.477.477 0 0 1-.12-.33c0-.071.011-.138.032-.2a.42.42 0 0 1 .25-.247.58.58 0 0 1 .208-.035c.076 0 .144.012.203.035a.38.38 0 0 1 .146.089.382.382 0 0 1 .106.154.58.58 0 0 1 .035.203.467.467 0 0 1-.124.331c-.082.089-.204.133-.366.133-.165 0-.289-.044-.371-.133Z",
  "clip-rule": "evenodd"
};
function Hv(t, e) {
  return m(), C("path", _v);
}
const jv = /* @__PURE__ */ R1(wv, [["render", Hv]]), Lv = {}, xv = {
  d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
  fill: "currentColor"
};
function $v(t, e) {
  return m(), C("path", xv);
}
const Mv = /* @__PURE__ */ R1(Lv, [["render", $v]]), Vv = {};
function Sv(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      d: "M19.5 19h-15c-.8 0-1.5-.7-1.5-1.5v-11C3 5.7 3.7 5 4.5 5h15c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5zM4.5 6c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-11c0-.3-.2-.5-.5-.5h-15z",
      fill: "currentColor"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M17.5 9h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm-1 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm1 2h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5z",
      fill: "currentColor"
    }, null, -1))
  ], 64);
}
const Av = /* @__PURE__ */ R1(Vv, [["render", Sv]]), Ev = {};
function Dv(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M 11.853 1.527 C 11.948 1.491 12.054 1.491 12.15 1.527 L 13.377 1.992 C 13.587 2.072 13.692 2.303 13.61 2.508 C 13.528 2.714 13.291 2.815 13.08 2.736 L 12.001 2.327 L 10.922 2.736 C 10.712 2.815 10.475 2.714 10.393 2.508 C 10.311 2.303 10.415 2.072 10.626 1.992 L 11.853 1.527 Z M 15.302 3.15 C 15.384 2.945 15.621 2.843 15.831 2.923 L 18.286 3.853 C 18.496 3.933 18.601 4.164 18.519 4.369 C 18.437 4.574 18.2 4.676 17.989 4.596 L 15.535 3.666 C 15.324 3.586 15.22 3.355 15.302 3.15 Z M 8.701 3.15 C 8.783 3.355 8.678 3.586 8.468 3.666 L 6.013 4.596 C 5.803 4.676 5.566 4.574 5.484 4.369 C 5.402 4.164 5.506 3.933 5.717 3.853 L 8.171 2.923 C 8.382 2.843 8.619 2.945 8.701 3.15 Z M 20.211 5.011 C 20.293 4.805 20.53 4.704 20.74 4.783 L 21.968 5.249 C 22.125 5.308 22.228 5.456 22.228 5.62 L 22.228 6.949 C 22.228 7.17 22.045 7.348 21.819 7.348 C 21.593 7.348 21.41 7.17 21.41 6.949 L 21.41 5.893 L 20.444 5.527 C 20.233 5.447 20.129 5.216 20.211 5.011 Z M 3.792 5.011 C 3.874 5.216 3.769 5.447 3.559 5.527 L 2.592 5.893 L 2.592 6.639 C 2.592 6.86 2.409 7.038 2.183 7.038 C 1.957 7.038 1.774 6.86 1.774 6.639 L 1.774 5.62 C 1.774 5.456 1.878 5.308 2.035 5.249 L 3.262 4.783 C 3.473 4.704 3.71 4.805 3.792 5.011 Z M 2.183 8.279 C 2.409 8.279 2.592 8.457 2.592 8.677 L 2.592 10.715 C 2.592 10.935 2.409 11.114 2.183 11.114 C 1.957 11.114 1.774 10.935 1.774 10.715 L 1.774 8.677 C 1.774 8.457 1.957 8.279 2.183 8.279 Z M 21.819 9.209 C 22.045 9.209 22.228 9.387 22.228 9.607 L 22.228 10.937 C 22.228 11.157 22.045 11.335 21.819 11.335 C 21.593 11.335 21.41 11.157 21.41 10.937 L 21.41 9.607 C 21.41 9.387 21.593 9.209 21.819 9.209 Z M 2.183 12.354 C 2.409 12.354 2.592 12.533 2.592 12.753 L 2.592 14.791 C 2.592 15.011 2.409 15.19 2.183 15.19 C 1.957 15.19 1.774 15.011 1.774 14.791 L 1.774 12.753 C 1.774 12.533 1.957 12.354 2.183 12.354 Z M 2.183 16.43 C 2.409 16.43 2.592 16.609 2.592 16.829 L 2.592 17.589 L 3.577 18.015 C 3.783 18.105 3.876 18.34 3.784 18.542 C 3.692 18.743 3.451 18.834 3.244 18.744 L 2.017 18.213 C 1.869 18.149 1.774 18.006 1.774 17.848 L 1.774 16.829 C 1.774 16.609 1.957 16.43 2.183 16.43 Z M 5.491 19.281 C 5.583 19.08 5.825 18.989 6.031 19.079 L 8.486 20.142 C 8.692 20.231 8.785 20.467 8.693 20.668 C 8.602 20.869 8.36 20.96 8.153 20.871 L 5.699 19.807 C 5.492 19.718 5.399 19.482 5.491 19.281 Z M 17.146 19.809 C 17.24 20.009 17.15 20.246 16.944 20.337 L 15.751 20.869 C 15.545 20.96 15.303 20.872 15.209 20.672 C 15.115 20.472 15.205 20.235 15.411 20.144 L 16.604 19.612 C 16.809 19.52 17.052 19.609 17.146 19.809 Z M 13.567 21.404 C 13.66 21.604 13.57 21.841 13.365 21.932 L 12.171 22.464 C 12.065 22.511 11.942 22.512 11.835 22.466 L 10.608 21.934 C 10.401 21.845 10.308 21.609 10.4 21.408 C 10.492 21.206 10.734 21.116 10.94 21.205 L 11.999 21.664 L 13.024 21.207 C 13.23 21.115 13.473 21.204 13.567 21.404 Z",
      fill: "currentColor",
      transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M 1.808 5.458 C 1.9 5.257 2.142 5.166 2.348 5.256 L 3.576 5.787 C 3.782 5.877 3.875 6.112 3.783 6.314 C 3.691 6.515 3.45 6.606 3.243 6.516 L 2.016 5.984 C 1.809 5.895 1.717 5.659 1.808 5.458 Z M 22.192 5.458 C 22.284 5.659 22.191 5.895 21.985 5.984 L 20.757 6.516 C 20.551 6.606 20.309 6.515 20.217 6.314 C 20.126 6.112 20.219 5.877 20.425 5.787 L 21.652 5.256 C 21.859 5.166 22.1 5.257 22.192 5.458 Z M 18.51 7.053 C 18.602 7.254 18.509 7.49 18.303 7.579 L 15.848 8.643 C 15.642 8.732 15.4 8.642 15.308 8.44 C 15.216 8.239 15.309 8.003 15.516 7.914 L 17.97 6.851 C 18.177 6.761 18.419 6.852 18.51 7.053 Z M 5.49 7.053 C 5.582 6.852 5.824 6.761 6.03 6.851 L 8.485 7.914 C 8.691 8.003 8.784 8.239 8.692 8.44 C 8.6 8.642 8.359 8.732 8.152 8.643 L 5.698 7.579 C 5.491 7.49 5.398 7.254 5.49 7.053 Z M 10.399 9.18 C 10.491 8.979 10.733 8.888 10.939 8.977 L 12 9.437 L 13.061 8.977 C 13.268 8.888 13.51 8.979 13.601 9.18 C 13.693 9.381 13.6 9.617 13.394 9.706 L 12.166 10.238 C 12.061 10.284 11.94 10.284 11.834 10.238 L 10.607 9.706 C 10.4 9.617 10.307 9.381 10.399 9.18 Z",
      fill: "currentColor",
      transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
    }, null, -1)),
    e[2] || (e[2] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M 12.001 11.07 C 12.227 11.07 12.41 11.248 12.41 11.468 L 12.41 12.532 C 12.41 12.752 12.227 12.93 12.001 12.93 C 11.775 12.93 11.592 12.752 11.592 12.532 L 11.592 11.468 C 11.592 11.248 11.775 11.07 12.001 11.07 Z M 12.001 14.259 C 12.227 14.259 12.41 14.438 12.41 14.658 L 12.41 16.785 C 12.41 17.005 12.227 17.183 12.001 17.183 C 11.775 17.183 11.592 17.005 11.592 16.785 L 11.592 14.658 C 11.592 14.438 11.775 14.259 12.001 14.259 Z M 12.001 18.513 C 12.227 18.513 12.41 18.691 12.41 18.911 L 12.41 19.975 C 12.41 20.195 12.227 20.373 12.001 20.373 C 11.775 20.373 11.592 20.195 11.592 19.975 L 11.592 18.911 C 11.592 18.691 11.775 18.513 12.001 18.513 Z",
      fill: "currentColor",
      transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
    }, null, -1)),
    e[3] || (e[3] = g("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M 20.183 15.057 C 19.806 15.057 19.501 15.354 19.501 15.721 L 19.501 16.253 C 19.501 16.473 19.318 16.652 19.092 16.652 C 18.866 16.652 18.683 16.473 18.683 16.253 L 18.683 15.721 C 18.683 14.914 19.355 14.259 20.183 14.259 L 21.274 14.259 C 22.102 14.259 22.774 14.914 22.774 15.721 L 22.774 16.216 C 22.774 16.705 22.523 17.161 22.106 17.432 L 21.441 17.864 C 21.252 17.987 21.138 18.195 21.138 18.417 L 21.138 18.911 C 21.138 19.132 20.954 19.31 20.729 19.31 C 20.503 19.31 20.319 19.132 20.319 18.911 L 20.319 18.417 C 20.319 17.928 20.57 17.472 20.987 17.201 L 21.652 16.769 C 21.842 16.645 21.956 16.438 21.956 16.216 L 21.956 15.721 C 21.956 15.354 21.651 15.057 21.274 15.057 L 20.183 15.057 Z",
      fill: "currentColor",
      transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
    }, null, -1)),
    e[4] || (e[4] = g("path", {
      d: "M 20.183 20.506 C 20.183 20.213 20.427 19.975 20.729 19.975 C 21.03 19.975 21.274 20.213 21.274 20.506 C 21.274 20.8 21.03 21.038 20.729 21.038 C 20.427 21.038 20.183 20.8 20.183 20.506 Z",
      fill: "currentColor",
      transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
    }, null, -1))
  ], 64);
}
const Pv = /* @__PURE__ */ R1(Ev, [["render", Dv]]), zv = {}, Tv = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.354 5.646a.5.5 0 0 0-.708 0l-5 5a.5.5 0 1 0 .708.707L8 6.707l4.646 4.646a.5.5 0 0 0 .708-.707l-5-5Z",
  "clip-rule": "evenodd"
};
function Ov(t, e) {
  return m(), C("path", Tv);
}
const Fv = /* @__PURE__ */ R1(zv, [["render", Ov]]), Bv = {}, Iv = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.354 11.354a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.707L8 10.293l4.646-4.646a.5.5 0 0 1 .708.707l-5 5Z",
  "clip-rule": "evenodd"
};
function Zv(t, e) {
  return m(), C("path", Iv);
}
const Rv = /* @__PURE__ */ R1(Bv, [["render", Zv]]), Nv = {}, qv = {
  fill: "currentColor",
  d: "M14.854 1.146a.5.5 0 0 1 0 .708l-13 13a.5.5 0 0 1-.708-.708l1.985-1.984C2.19 11.388 1.468 10.5.964 9.77a12.752 12.752 0 0 1-.857-1.435 5.73 5.73 0 0 1-.045-.092L.05 8.218l-.003-.007-.002-.003L.5 8a42.876 42.876 0 0 1-.482-.132v-.002L.02 7.86l.004-.016a3.3 3.3 0 0 1 .08-.247 9.191 9.191 0 0 1 1.509-2.665C2.813 3.466 4.822 2 8 2c1.729 0 3.117.434 4.22 1.073l1.926-1.927a.5.5 0 0 1 .708 0ZM.5 8l-.455.207a.5.5 0 0 1-.027-.339L.5 8Zm5.055 1.738a3 3 0 0 1 4.184-4.184l1.745-1.745C10.567 3.326 9.424 3 8 3 5.178 3 3.436 4.284 2.387 5.567a8.192 8.192 0 0 0-1.339 2.362l-.01.031a11.752 11.752 0 0 0 .75 1.243c.483.702 1.17 1.539 2.054 2.248l1.713-1.713Zm.722-.722 2.74-2.74a2 2 0 0 0-2.74 2.74Zm7.998-3.435a.5.5 0 0 1 .691.147c.372.573.624 1.101.783 1.488a7.307 7.307 0 0 1 .229.636l.003.01v.004l.001.001v.001L15.5 8l.455.207v.002l-.003.005-.007.014a11.484 11.484 0 0 1-.486.89 12.883 12.883 0 0 1-1.464 1.968C12.697 12.514 10.698 14 8 14c-.37 0-.73-.028-1.075-.08a.5.5 0 0 1 .15-.99c.297.046.605.07.925.07 2.302 0 4.053-1.264 5.255-2.586a11.89 11.89 0 0 0 1.684-2.408l.024-.046a6.503 6.503 0 0 0-.138-.363 8.22 8.22 0 0 0-.698-1.325.5.5 0 0 1 .148-.691ZM15.5 8l.482-.132a.5.5 0 0 1-.027.339L15.5 8Z"
};
function Uv(t, e) {
  return m(), C("path", qv);
}
const Yv = /* @__PURE__ */ R1(Nv, [["render", Uv]]), Wv = {}, Kv = {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.934 8.486a13.149 13.149 0 0 1-.367-.527 9.368 9.368 0 0 1 1.43-2.124C4.06 4.651 5.686 3.5 8 3.5s3.939 1.152 5.003 2.334a9.368 9.368 0 0 1 1.43 2.125 14.539 14.539 0 0 1-1.787 2.188C11.424 11.368 9.796 12.5 8 12.5c-1.796 0-3.424-1.131-4.646-2.354a14.538 14.538 0 0 1-1.42-1.66Zm13.494-.228L15 8l.429.257.127-.212-.092-.23L15 8l.464-.186v-.002l-.003-.004-.005-.014-.021-.049a9.048 9.048 0 0 0-.39-.773 10.364 10.364 0 0 0-1.298-1.806C12.56 3.848 10.686 2.5 8 2.5S3.439 3.848 2.253 5.166a10.368 10.368 0 0 0-1.61 2.406 6.066 6.066 0 0 0-.099.222l-.006.014-.001.004v.001H.535L1 8l-.464-.186-.092.23.127.213L1 8l-.429.258.001.001.003.004.007.013a5.364 5.364 0 0 0 .137.213 15.54 15.54 0 0 0 1.928 2.364C3.923 12.132 5.796 13.5 8 13.5c2.204 0 4.076-1.369 5.354-2.646a15.54 15.54 0 0 0 2.035-2.532l.029-.046.007-.013.003-.004v-.001ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
  "clip-rule": "evenodd"
};
function Gv(t, e) {
  return m(), C("path", Kv);
}
const Xv = /* @__PURE__ */ R1(Wv, [["render", Gv]]), Qv = {}, Jv = {
  fill: "currentColor",
  d: "M18.854 5.147a.5.5 0 0 1 0 .707L12.707 12l6.147 6.146a.5.5 0 0 1-.708.708L12 12.707l-6.146 6.147a.5.5 0 1 1-.708-.707L11.293 12 5.146 5.854a.5.5 0 1 1 .707-.707L12 11.293l6.146-6.146a.5.5 0 0 1 .708 0Z"
};
function eg(t, e) {
  return m(), C("path", Jv);
}
const tg = /* @__PURE__ */ R1(Qv, [["render", eg]]), ag = {}, og = {
  d: "M0 7C0 6.44772 0.447715 6 1 6H17.0858C17.4836 6 17.8651 6.15804 18.1464 6.43934L24 12.2929V16C24 16.5523 23.5523 17 23 17L19.2929 17.0001L15.2929 13H11V16C11 16.5523 10.5523 17 9.99999 17L6.29289 17L0.43934 11.1464C0.158035 10.8651 0 10.4836 0 10.0858V7ZM10.7071 12H13.7929L8.79289 7H5.7071L10.7071 12ZM15.2071 12H18.2929L13.2929 7H10.2071L15.2071 12ZM14.7071 7L19.7071 12H22.2929L17.4393 7.14645C17.3456 7.05268 17.2184 7 17.0858 7H14.7071ZM23 13H20V16L23 16V13ZM19 15.2929V13H16.7071L19 15.2929ZM4.29289 7H1.7071L6.70711 12H9.2929L4.29289 7ZM6 12.7072L1 7.70711V10.0858C1 10.2184 1.05268 10.3456 1.14645 10.4393L6 15.2929V12.7072ZM7 16L10 16V13H7V16Z",
  fill: "currentColor"
};
function ng(t, e) {
  return m(), C("path", og);
}
const rg = /* @__PURE__ */ R1(ag, [["render", ng]]), sg = {}, ig = {
  d: "M12.5821 4.20251C12.2099 4.04578 11.7901 4.04578 11.4179 4.20251L2.91791 7.78147C2.36169 8.01567 2 8.56041 2 9.16392V14.8359C2 15.4394 2.36169 15.9842 2.91792 16.2184L11.4179 19.7973C11.7901 19.954 12.2099 19.954 12.5821 19.7973L21.0821 16.2183C21.6383 15.9842 22 15.4394 22 14.8359V9.16391C22 8.56039 21.6383 8.01565 21.0821 7.78146L12.5821 4.20251ZM11.806 5.12414C11.93 5.0719 12.07 5.0719 12.194 5.12414L19.984 8.40415L16.4999 9.95264L8.63751 6.45824L11.806 5.12414ZM7.37313 6.99061L15.2688 10.4998L12.6092 11.6819C12.2214 11.8542 11.7786 11.8542 11.3908 11.6819L4.01598 8.40415L7.37313 6.99061ZM16 11.2692V13.9998C16 14.276 16.2239 14.4998 16.5 14.4998C16.7761 14.4998 17 14.276 17 13.9998V10.8247L20.9875 9.0525C20.9957 9.08856 21 9.12588 21 9.16391V14.8359C21 15.0371 20.8794 15.2186 20.694 15.2967L12.5 18.7468V12.7606C12.6758 12.7248 12.8486 12.6698 13.0153 12.5957L16 11.2692ZM3.01255 9.0525L10.9847 12.5957C11.1514 12.6698 11.3242 12.7248 11.5 12.7606V18.7468L3.30597 15.2967C3.12056 15.2187 3 15.0371 3 14.8359V9.16392C3 9.12589 3.00431 9.08857 3.01255 9.0525Z",
  fill: "currentColor"
};
function lg(t, e) {
  return m(), C("path", ig);
}
const ug = /* @__PURE__ */ R1(sg, [["render", lg]]), cg = {};
function dg(t, e) {
  return m(), C(ge, null, [
    e[0] || (e[0] = g("path", {
      d: "M21 22h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H8v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H3v-4h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3v-3h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V8h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v4h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v4zm-2.1-1H20v-2.1c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9v-1.2c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V8.9c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V3h-1.1c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1h-1.2c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1H8.9c-.2.5-.8 1-1.9 1s-1.7-.5-1.9-1H4v2.1c.5.2 1 .8 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9V21h1.1c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1z",
      fill: "currentColor"
    }, null, -1)),
    e[1] || (e[1] = g("path", {
      d: "M9.3 14.5c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l5.5-3.2c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2l-5.5 3.2c0 .2-.2.2-.3.2zm2.7 1.6c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l2.7-1.6c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2L12.5 16c-.2.1-.3.1-.5.1zm-2.8-4.7c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.1.2-.3.4-.4l2.7-1.6c.3-.1.5-.1.7-.1.2.1.4.2.5.4.1.2.1.4.1.7-.1.2-.2.4-.4.5l-2.7 1.6c-.1.1-.3.2-.5.2z",
      fill: "currentColor"
    }, null, -1))
  ], 64);
}
const mg = /* @__PURE__ */ R1(cg, [["render", dg]]), pg = {}, fg = {
  d: "M10.4116 5.20544C10.7894 5.04636 11.2158 5.04884 11.5918 5.21229L22.0981 9.78026C22.6458 10.0184 23 10.5587 23 11.1559V12.8362C23 13.4397 22.6383 13.9844 22.0821 14.2186L13.5884 17.7949C13.2106 17.954 12.7842 17.9515 12.4082 17.7881L1.90191 13.2201C1.35424 12.982 1 12.4417 1 11.8445V10.1642C1 9.56067 1.36169 9.01593 1.91792 8.78173L10.4116 5.20544ZM11.1931 6.12936C11.0677 6.07487 10.9256 6.07405 10.7997 6.12707L7.64807 7.45406L17.745 11.844L21.0046 10.3953L11.1931 6.12936ZM18.5 12.6028V13.5001C18.5 13.7763 18.2761 14.0001 18 14.0001C17.7239 14.0001 17.5 13.7763 17.5 13.5001V13.0472L14.0065 14.5999C13.8426 14.6727 13.6727 14.7271 13.5 14.763V16.7471L21.694 13.297C21.8794 13.2189 22 13.0374 22 12.8362V11.1559C22 11.1205 21.9963 11.0857 21.9891 11.052L18.5 12.6028ZM16.5048 12.3952L6.37396 7.99052L2.77115 9.5075L12.3931 13.6909C12.7784 13.8585 13.2164 13.8567 13.6004 13.6861L16.5048 12.3952ZM2.30064 12.303L12.5 16.7375V14.7666C12.3277 14.7321 12.1582 14.6792 11.9943 14.608L2 10.2626V11.8445C2 12.0436 2.11808 12.2237 2.30064 12.303Z",
  fill: "currentColor"
};
function hg(t, e) {
  return m(), C("path", fg);
}
const vg = /* @__PURE__ */ R1(pg, [["render", hg]]), gg = {
  Normal: "0 0 16 16",
  Medium: "0 0 24 24",
  MediumLarge: "0 0 32 32",
  Large: "0 0 48 48",
  Social: "0 0 50 50",
  XLarge: "0 0 88 88",
  XXLarge: "0 0 200 200"
}, ka = {
  Normal: 16,
  Medium: 24,
  MediumLarge: 32,
  Large: 48,
  Social: 50,
  XLarge: 88,
  XXLarge: 200
}, yg = ["width", "height", "viewBox"], za = /* @__PURE__ */ J({
  __name: "IconBase",
  props: {
    width: { default: void 0 },
    height: { default: void 0 },
    viewbox: { default: void 0 },
    size: { default: ka.Normal }
  },
  setup(t) {
    const e = F1(), a = t, o = Object.entries(ka).find(([, i]) => i === a.size)[0], n = Q(() => String(a.height ?? ka[o])), r = Q(() => String(a.width ?? ka[o])), s = Q(() => String(a.viewbox ?? gg[o]));
    return (i, l) => (m(), C("svg", {
      class: le(j(g1)("align-baseline inline-block overflow-visible", j(e).class)),
      xmlns: "http://www.w3.org/2000/svg",
      width: r.value,
      height: n.value,
      viewBox: s.value,
      role: "presentation"
    }, [
      oe(i.$slots, "default")
    ], 10, yg));
  }
}), bg = ["id", "disabled", "name", "aria-labelledby", "type"], mo = /* @__PURE__ */ J({
  __name: "TextInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    modelValue: {},
    autoFocus: { type: Boolean },
    labelledBy: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur"], ["update:modelValue"]),
  setup(t, { expose: e }) {
    const a = t, o = e1(t, "modelValue"), n = me();
    h1(() => {
      a.autoFocus && r();
    });
    function r() {
      n.value?.focus();
    }
    return e({
      focus: r
    }), (s, i) => Ne((m(), C("input", {
      id: s.name,
      ref_key: "component",
      ref: n,
      "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l),
      disabled: s.disabled,
      name: s.name,
      "aria-labelledby": s.labelledBy,
      type: s.type,
      onBlur: i[1] || (i[1] = (l) => s.$emit("blur", l)),
      class: le(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-full w-full", {
        "text-gray-800 bg-gray-200 pr-5": s.disabled,
        "border-red": !s.isValid
      }])
    }, null, 42, bg)), [
      [Bl, o.value]
    ]);
  }
}), kg = { class: "flex w-full" }, Cg = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "TextInputWithButton",
  props: /* @__PURE__ */ Ye({
    type: { default: "text" },
    name: {},
    placeholder: { default: void 0 },
    disabled: { type: Boolean },
    labelledBy: { default: void 0 },
    buttonVariant: { default: "secondary-outline" },
    buttonDisabled: { type: Boolean },
    buttonAriaLabel: { default: void 0 },
    buttonClass: { default: void 0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur", "click"], ["update:modelValue"]),
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => (m(), C("div", kg, [
      ye(mo, Re(a.$attrs, {
        modelValue: e.value,
        "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
        placeholder: a.placeholder,
        name: a.name,
        type: a.type,
        disabled: a.disabled,
        "labelled-by": a.labelledBy,
        class: j(g1)("border-r-0! rounded-r-none!", a.$attrs.class),
        onBlur: o[1] || (o[1] = (n) => a.$emit("blur", n))
      }), null, 16, ["modelValue", "placeholder", "name", "type", "disabled", "labelled-by", "class"]),
      ye(b1, {
        disabled: a.buttonDisabled,
        variant: a.buttonVariant,
        "aria-label": a.buttonAriaLabel,
        class: le(j(g1)("rounded-l-none! flex items-center rounded-r-full", a.buttonClass)),
        onClick: o[2] || (o[2] = (n) => a.$emit("click", n))
      }, {
        default: ue(() => [
          oe(a.$slots, "button")
        ]),
        _: 3
      }, 8, ["disabled", "variant", "aria-label", "class"])
    ]));
  }
}), Wx = /* @__PURE__ */ J({
  __name: "PasswordInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    placeholder: { default: void 0 },
    disabled: { type: Boolean },
    labelledBy: { default: void 0 },
    buttonVariant: { default: "secondary-outline" },
    buttonDisabled: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const [e, a] = ht(!1), o = e1(t, "modelValue");
    return (n, r) => (m(), he(Cg, Re(n.$props, {
      modelValue: o.value,
      "onUpdate:modelValue": r[0] || (r[0] = (s) => o.value = s),
      type: j(e) ? "text" : "password",
      onClick: r[1] || (r[1] = () => j(a)())
    }), {
      button: ue(() => [
        ye(j(za), null, {
          default: ue(() => [
            j(e) ? (m(), he(j(Yv), { key: 0 })) : (m(), he(j(Xv), { key: 1 }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["modelValue", "type"]));
  }
}), wg = ["aria-labelledby", "aria-disabled", "name"], _g = ["tabindex", "aria-checked", "aria-disabled", "data-test", "onClick", "onKeydown"], Hg = /* @__PURE__ */ J({
  __name: "RadioGroup",
  props: /* @__PURE__ */ Ye({
    name: { default: void 0 },
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    options: {},
    labelledBy: { default: void 0 },
    alignment: { default: "vertical" },
    disabled: { type: Boolean },
    radioClass: { default: void 0 },
    activeClass: { default: void 0 }
  }, {
    modelValue: { type: [String, Number, Boolean, null, Object] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = me(), o = e1(t, "modelValue"), n = Q(() => e.options.length - 1), { count: r, inc: s, dec: i, reset: l, set: f } = na(0, {
      min: 0,
      max: n.value
    }), u = (v) => {
      e.disabled || v.disabled || v.value !== o.value && (o.value = v.value);
    }, d = () => {
      a.value.children[r.value]?.focus();
    }, k = () => {
      r.value === n.value ? l() : s(), d();
    }, y = () => {
      r.value === 0 ? f(n.value) : i(), d();
    }, b = (v) => typeof v.value == "object" ? JSON.stringify(v.value) === JSON.stringify(o.value) : o.value === v.value, M = me(e.alignment), c = async () => {
      if (e.alignment === "vertical") {
        M.value = "vertical";
        return;
      }
      if (!a.value) {
        M.value = "horizontal";
        return;
      }
      const v = a.value, { clientWidth: H, scrollWidth: w } = v;
      if (H < w) {
        M.value = "vertical";
        return;
      }
      M.value = "horizontal", await p1();
      const { clientWidth: _, scrollWidth: L } = v;
      _ < L && (M.value = "vertical");
    };
    Ue(
      [() => e.alignment, () => e.options, () => o.value],
      () => {
        c();
      },
      {
        deep: !0
      }
    );
    const { watchResize: p, unwatchResize: h } = zi();
    return h1(() => {
      c(), p(() => {
        c();
      });
    }), oa(() => {
      h(() => {
        c();
      });
    }), (v, H) => (m(), C("div", {
      ref_key: "radioGroup",
      ref: a,
      role: "radiogroup",
      "aria-labelledby": v.labelledBy,
      "aria-disabled": v.disabled,
      name: v.name,
      class: le(["flex border rounded-[10px] w-full", {
        "flex-row": M.value === "horizontal",
        "flex-col": M.value === "vertical",
        "border-red": !v.isValid
      }])
    }, [
      (m(!0), C(ge, null, De(v.options, (w, _) => (m(), C("div", {
        key: w.label || `radio-${w.value}`,
        role: "radio",
        tabindex: _ === j(r) ? "0" : "-1",
        "aria-checked": b(w),
        "aria-disabled": v.disabled || w.disabled,
        class: le(["cursor-pointer flex focus:ring-2 z-1 gap-2 items-center outline-hidden ring-blue-600 px-4 py-2 last:border-none", {
          [v.radioClass]: !0,
          [v.activeClass]: b(w),
          "border-b": M.value === "vertical",
          "border-r flex-1 whitespace-nowrap": M.value === "horizontal"
        }]),
        "data-test": `radio ${v.name} ${w.value}`,
        onClick: (L) => u(w),
        onKeydown: [
          Ae($e(k, ["exact", "prevent"]), ["down"]),
          Ae($e(k, ["exact", "prevent"]), ["right"]),
          Ae($e(y, ["exact", "prevent"]), ["up"]),
          Ae($e(y, ["exact", "prevent"]), ["left"]),
          Ae($e((L) => u(w), ["exact", "prevent"]), ["space"])
        ]
      }, [
        g("span", {
          class: le(["border border-gray-400 h-4 inline-block relative rounded-full w-4", {
            "bg-secondary border-secondary": b(w) && !(v.disabled || w.disabled),
            "bg-gray-300 border-gray-500": v.disabled || w.disabled
          }])
        }, [
          b(w) ? (m(), C("span", {
            key: 0,
            class: le(["absolute h-[6px] left-[4px] rounded-full top-[4px] w-[6px]", {
              "bg-white": !(v.disabled || w.disabled),
              "bg-gray-800": v.disabled || w.disabled
            }])
          }, null, 2)) : ae("", !0)
        ], 2),
        w.icon ? oe(v.$slots, "icon", {
          key: 0,
          option: w
        }) : ae("", !0),
        oe(v.$slots, "label", { option: w }, () => [
          qe(_e(w.label), 1)
        ]),
        oe(v.$slots, "default", { option: w })
      ], 42, _g))), 128))
    ], 10, wg));
  }
}), jg = ["name", "tabindex", "aria-labelledby", "aria-disabled", "aria-expanded", "aria-controls", "aria-activedescendant", "onKeydown"], Lg = { class: "flex gap-2 p-2 px-3 w-full" }, xg = ["id"], $g = ["id", "aria-disabled", "aria-selected", "onClick"], Mg = 500, G0 = 10, Vg = /* @__PURE__ */ J({
  __name: "Select",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    modelValue: {},
    options: {},
    disabled: { type: Boolean },
    placeholder: { default: void 0 },
    labelledBy: { default: void 0 },
    listBoxClass: { default: "" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const a = t, o = e, n = e1(t, "modelValue"), r = me(!1), { count: s, ...i } = na(0, {
      min: 0,
      max: a.options.length - 1
    }), l = Q(() => a.options.map((U) => U.value)), f = Q(() => a.options.find((U) => U.value === n.value)), u = Q(() => a.options.some(({ isGroupLabel: U }) => U)), d = () => {
      a.disabled || (n.value && i.set(l.value.indexOf(n.value)), r.value = !0, p1(h));
    }, k = () => {
      r.value = !1, i.reset(0);
    }, y = (U) => {
      U.disabled || (n.value = U.value, k());
    }, b = me(), M = me(), { placement: c } = Aa(M, b, {
      middleware: [
        Ea({
          fallbackPlacements: ["bottom-start", "top-start"],
          padding: 100
        })
      ],
      whileElementsMounted: Da,
      placement: "bottom-start"
    }), p = Q(() => c.value === "bottom-start"), h = () => {
      b.value && b.value.children[s.value] && (b.value.scrollTop = b.value.children[s.value].offsetTop);
    };
    Ue(s, h);
    const v = () => {
      if (!r.value) {
        d();
        return;
      }
      i.inc(1);
    }, H = () => {
      if (!r.value) {
        d();
        return;
      }
      i.dec(1);
    }, w = () => {
      r.value && y(a.options[s.value]);
    }, _ = () => {
      if (!r.value) {
        d();
        return;
      }
      y(a.options[s.value]);
    }, L = () => {
      r.value && y(a.options[s.value]);
    }, I = () => {
      i.set(0), r.value || d();
    }, F = () => {
      i.set(a.options.length - 1), r.value || d();
    }, B = me([]), K = me("");
    let ee = null;
    const ve = () => {
      ee = setTimeout(() => {
        B.value = [];
      }, Mg);
    }, q = (U) => {
      if (!(U.key.length === 1 && U.key.match(/[a-z]|[0-9]/i))) return;
      if (ee && clearTimeout(ee), ve(), B.value.push(U.key), r.value || d(), K.value === U.key) {
        const Z = a.options.filter(
          (N) => N.label.toLowerCase().startsWith(K.value.toLowerCase())
        );
        if (Z.length === 1 || Z.length === 0)
          return;
        const D = l.value.indexOf(a.options[s.value].value), x = l.value.indexOf(Z[0].value), A = l.value.indexOf(Z[Z.length - 1].value);
        D >= A ? i.set(x) : i.inc(1);
        return;
      }
      const te = B.value.join("").toLowerCase(), G = a.options.find((Z) => Z.label.toLowerCase().startsWith(te));
      if (!G) return;
      const T = l.value.indexOf(G.value);
      i.set(T), K.value = U.key;
    }, O = () => {
      r.value && i.inc(G0);
    }, Y = () => {
      r.value && i.dec(G0);
    };
    return (U, ne) => Ne((m(), C("div", {
      ref_key: "inputRef",
      ref: M,
      class: le(["border border-t group outline-hidden relative ring-blue-600 rounded-b-[25px] rounded-t-[25px] w-full", {
        "rounded-b-none! border-b-transparent!": r.value && p.value,
        "rounded-t-none! border-t-transparent!": r.value && !p.value,
        "bg-gray-200 text-gray-800 cursor-not-allowed": U.disabled,
        "border-red": !U.isValid,
        "focus:ring-2 cursor-pointer": !U.disabled
      }]),
      role: "combobox",
      name: U.name,
      tabindex: U.disabled ? -1 : 0,
      "aria-labelledby": U.labelledBy,
      "aria-disabled": U.disabled,
      "aria-expanded": r.value,
      "aria-haspopup": "listbox",
      "aria-controls": `listbox-${U.name}`,
      "aria-activedescendant": r.value ? `option-${l.value[j(s)]}` : void 0,
      onClick: ne[0] || (ne[0] = (te) => r.value ? k() : d()),
      onKeydown: [
        Ae($e(_, ["exact"]), ["space"]),
        Ae($e(k, ["exact"]), ["escape"]),
        Ae($e(H, ["exact", "prevent"]), ["up"]),
        Ae($e(w, ["exact", "alt"]), ["up"]),
        Ae($e(v, ["exact", "prevent"]), ["down"]),
        Ae($e(_, ["exact"]), ["enter"]),
        Ae($e(F, ["exact", "prevent"]), ["end"]),
        Ae($e(I, ["exact", "prevent"]), ["home"]),
        Ae($e(L, ["exact"]), ["tab"]),
        Ae($e(O, ["exact", "prevent"]), ["page-down"]),
        Ae($e(Y, ["exact", "prevent"]), ["page-up"]),
        q
      ],
      onBlur: ne[1] || (ne[1] = (te) => o("blur", te))
    }, [
      g("div", Lg, [
        f.value?.label ? (m(), C("span", {
          key: 0,
          class: le(f.value?.class)
        }, [
          oe(U.$slots, "value", { option: f.value }, () => [
            qe(_e(f.value?.label), 1)
          ])
        ], 2)) : (m(), C("span", {
          key: 1,
          class: le(["text-gray-400", { "text-gray-800": U.disabled }])
        }, _e(U.placeholder), 3)),
        ye(ra, {
          "is-open": r.value,
          class: le(["ml-auto self-center", { "text-gray-800": U.disabled }])
        }, null, 8, ["is-open", "class"])
      ]),
      Ne(g("div", {
        id: `listbox-${U.name}`,
        ref_key: "selectBodyRef",
        ref: b,
        role: "listbox",
        tabindex: "-1",
        class: le(
          j(g1)(
            "-left-[1px] absolute bg-white border border-gray-400 group-focus:ring-2 hide-scrollbar max-h-52 overflow-auto py-2 ring-blue-600 shadow-card w-[calc(100%+2px)] z-20",
            p.value ? "top-[calc(100%+1px)] rounded-b-[20px] " : "bottom-[calc(100%+1px)] rounded-t-[20px]",
            U.listBoxClass
          )
        )
      }, [
        (m(!0), C(ge, null, De(U.options, (te, G) => (m(), C("div", {
          id: `option-${te.value}`,
          key: String(te.value),
          class: le(
            j(g1)([
              "border-y flex p-2",
              te.isGroupLabel ? "text-primary font-bold border-b-gray-400" : "hover:bg-gray-200 cursor-pointer",
              j(s) !== G ? "border-transparent" : "border-gray-400",
              te.disabled ? "bg-gray-200 text-gray-800 cursor-not-allowed" : "",
              te.class,
              // When the select contains any group label, all options need padding left.
              u.value && !te.isGroupLabel ? "pl-5" : ""
            ])
          ),
          role: "option",
          "aria-disabled": te.disabled,
          "aria-selected": te.value === n.value,
          onClick: $e((T) => y(te), ["stop", "prevent"])
        }, [
          g("span", null, [
            oe(U.$slots, "option", { option: te }, () => [
              qe(_e(te.label), 1)
            ])
          ]),
          te.value === n.value ? (m(), he(Oe, {
            key: 0,
            class: "ml-auto self-center"
          }, {
            default: ue(() => [
              ye(Ir)
            ]),
            _: 1
          })) : ae("", !0)
        ], 10, $g))), 128))
      ], 10, xg), [
        [L1, r.value]
      ])
    ], 42, jg)), [
      [j(Ft), k]
    ]);
  }
}), Sg = { class: "flex w-full" }, Kx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Search",
  props: /* @__PURE__ */ Ye({
    name: { default: void 0 },
    placeholder: { default: void 0 },
    disabled: { type: Boolean },
    labelledBy: { default: void 0 },
    buttonVariant: { default: "secondary-outline" },
    buttonDisabled: { type: Boolean },
    options: { default: () => [] }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {},
    queryAttribute: {
      required: !1,
      default: ""
    },
    queryAttributeModifiers: {},
    search: {
      required: !1,
      default: null
    },
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur", "click"], ["update:modelValue", "update:queryAttribute", "update:search"]),
  setup(t) {
    const e = t, a = ro(), o = e1(t, "modelValue"), n = e1(t, "queryAttribute"), r = e1(t, "search");
    return e.options.length && Ue(
      [o, n],
      () => {
        r.value = {
          [n.value]: o.value
        };
      },
      {
        immediate: !0
      }
    ), (s, i) => (m(), C("div", Sg, [
      ye(mo, Re(s.$attrs, {
        modelValue: o.value,
        "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l),
        placeholder: s.placeholder,
        name: s.name,
        type: "search",
        disabled: s.disabled,
        "labelled-by": s.labelledBy,
        class: "border-r-0! rounded-r-none!",
        onBlur: i[1] || (i[1] = (l) => s.$emit("blur", l))
      }), null, 16, ["modelValue", "placeholder", "name", "disabled", "labelled-by"]),
      s.options.length > 0 ? (m(), he(Vg, {
        key: 0,
        modelValue: n.value,
        "onUpdate:modelValue": i[2] || (i[2] = (l) => n.value = l),
        class: "rounded-none! flex items-center max-w-max",
        options: s.options,
        name: j(a)
      }, null, 8, ["modelValue", "options", "name"])) : ae("", !0),
      ye(b1, {
        disabled: s.buttonDisabled,
        variant: s.buttonVariant,
        class: "rounded-l-none! flex items-center rounded-r-full",
        onClick: i[3] || (i[3] = (l) => s.$emit("click", l))
      }, {
        default: ue(() => [
          ye(Oe, null, {
            default: ue(() => [
              ye(j(ku))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled", "variant"])
    ]));
  }
}), Ag = { class: "flex w-full" }, Eg = {
  key: 0,
  class: "absolute bg-white border border-gray mt-2 overflow-hidden rounded-xl top top-full w-full z-30",
  role: "listbox"
}, Dg = ["onClick"], Pg = {
  key: 0,
  class: "text-black-light"
}, zg = {
  key: 0,
  class: "border-t flex flex-row justify-end py-0.5 w-full"
}, Gx = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "SearchSuggestTextInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    cancelLabel: { default: void 0 },
    placeholder: {},
    disabled: { type: Boolean },
    maxLength: { default: void 0 },
    suggestions: {},
    buttonVariant: { default: "secondary" },
    isValid: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur", "search", "selected"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const a = t, o = e, n = me(!1), r = me(), s = me(null), { focused: i } = Kl(r), l = _t(), f = F1(), u = Q(() => !!l.button);
    Ue(i, async (ee) => {
      await p1(), ee ? c() : p();
    });
    const d = e1(t, "modelValue", {
      set(ee) {
        return ee.trimStart();
      }
    }), { count: k, dec: y, inc: b } = na(0, {
      min: 0
    }), M = Q(() => a.suggestions.map((ee) => ee.value)), c = () => {
      a.suggestions.length !== 0 && (n.value = !0);
    }, p = () => {
      n.value = !1;
    }, h = async (ee) => {
      H(), d.value = ee.value, await p1(), d.value = ee.label, p(), await p1(), w(), o("selected", ee);
    }, v = Gl(() => {
      i.value && o("search", d.value);
    }, 750), { pause: H, resume: w } = Xl(d, () => {
      v();
    });
    Ue(
      () => a.suggestions,
      () => {
        i.value && c();
      }
    );
    const _ = me();
    Ue(k, () => {
      if (!_.value) return;
      const ee = _.value.children[k.value];
      ee && (_.value.scrollTop = ee.offsetTop);
    });
    const I = async () => {
      if (!n.value) {
        n.value = !0;
        return;
      }
      if (n.value && k.value >= 0) {
        await h(a.suggestions[k.value]);
        return;
      }
      v();
    }, F = () => {
      n.value && k.value !== a.suggestions.length - 1 && b();
    }, B = () => {
      n.value && y();
    }, K = () => {
      s.value?.focus();
    };
    return (ee, ve) => (m(), C("div", {
      ref_key: "containerRef",
      ref: r,
      class: "flex flex-col relative w-full"
    }, [
      g("div", Ag, [
        ye(mo, Re({
          ref_key: "textInputRef",
          ref: s,
          modelValue: d.value,
          "onUpdate:modelValue": ve[0] || (ve[0] = (q) => d.value = q),
          name: ee.name
        }, j(f), {
          role: "combobox",
          disabled: ee.disabled,
          placeholder: ee.placeholder,
          class: { "border-r-0! rounded-r-none!": u.value },
          maxlength: ee.maxLength,
          "is-valid": ee.isValid,
          "aria-activedescendant": n.value ? `option-${M.value[j(k)]}` : void 0,
          onBlur: ve[1] || (ve[1] = (q) => o("blur", d.value)),
          onKeydown: [
            Ae($e(p, ["exact"]), ["escape"]),
            Ae($e(I, ["exact", "prevent"]), ["enter"]),
            Ae($e(F, ["exact"]), ["down"]),
            Ae($e(B, ["exact"]), ["up"])
          ]
        }), null, 16, ["modelValue", "name", "disabled", "placeholder", "class", "maxlength", "is-valid", "aria-activedescendant", "onKeydown"]),
        u.value ? (m(), he(b1, {
          key: 0,
          tabindex: "-1",
          disabled: ee.disabled,
          variant: ee.buttonVariant,
          class: "flex items-center rounded-r-full",
          onClick: K
        }, {
          default: ue(() => [
            oe(ee.$slots, "button")
          ]),
          _: 3
        }, 8, ["disabled", "variant"])) : ae("", !0)
      ]),
      oe(ee.$slots, "sublabel"),
      n.value && ee.suggestions?.length ? (m(), C("div", Eg, [
        g("ul", {
          tabindex: "-1",
          ref_key: "selectBodyRef",
          ref: _,
          class: "max-h-64 overflow-auto"
        }, [
          (m(!0), C(ge, null, De(ee.suggestions, (q, O) => (m(), C("li", {
            key: q.label,
            role: "option",
            class: le(["border-gray cursor-pointer flex flex-col hover:bg-gray-100 px-3 py-3", {
              "bg-gray-100": j(k) === O,
              "border-b": ee.suggestions.length > 1
            }]),
            onClick: $e((Y) => h(q), ["stop"])
          }, [
            oe(ee.$slots, "listitem", { suggestion: q }, () => [
              g("strong", null, _e(q.label), 1),
              q.sublabel ? (m(), C("span", Pg, _e(q.sublabel), 1)) : ae("", !0)
            ])
          ], 10, Dg))), 128))
        ], 512),
        ee.cancelLabel ? (m(), C("div", zg, [
          ye(b1, {
            tabindex: "-1",
            type: "button",
            variant: "primary-basic",
            onClick: $e(p, ["stop"])
          }, {
            default: ue(() => [
              qe(_e(ee.cancelLabel), 1)
            ]),
            _: 1
          })
        ])) : ae("", !0)
      ])) : ae("", !0)
    ], 512));
  }
}), Tg = ["id", "name", "tabindex", "aria-labelledby", "aria-label", "aria-disabled", "aria-expanded", "aria-controls", "aria-activedescendant", "onKeydown"], Og = { class: "flex gap-2 px-3 py-2 w-full" }, Fg = { key: 0 }, Bg = { key: 0 }, Ig = ["id"], Zg = ["id", "aria-disabled", "aria-selected", "onClick"], Rg = 500, X0 = 10, P2 = /* @__PURE__ */ J({
  __name: "MultiSelect",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean },
    options: {},
    disabled: { type: Boolean },
    placeholder: {},
    max: {},
    labelledBy: {},
    ariaLabel: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = e1(t, "modelValue"), o = me(!1), { count: n, ...r } = na(0, {
      min: 0,
      max: e.options.length - 1
    }), s = Q(() => e.options.map((U) => U.value)), i = Q(() => e.options.map((U) => a.value.includes(U.value) && U).filter(Boolean)), l = Q(() => e.max ? a.value.length === e.max : !1), f = Q(() => i.value.length ? i.value.map((U) => U.label).join(", ") : ""), u = () => {
      e.disabled || (o.value = !0, p1(h));
    }, d = () => {
      o.value = !1, r.reset(0);
    }, k = (U) => {
      if (a.value.includes(U.value)) {
        y(U);
        return;
      }
      l.value || (a.value = [...a.value, U.value]);
    }, y = (U) => {
      a.value = a.value.filter((ne) => ne !== U.value);
    }, b = me(), M = me(), { placement: c } = Aa(M, b, {
      middleware: [
        Ea({
          fallbackPlacements: ["bottom-start", "top-start"],
          padding: 100
        })
      ],
      whileElementsMounted: Da,
      placement: "bottom-start"
    }), p = Q(() => c.value === "bottom-start"), h = () => {
      b.value && b.value.children[n.value] && (b.value.scrollTop = b.value.children[n.value].offsetTop);
    };
    Ue(n, h);
    const v = () => {
      if (!o.value) {
        u();
        return;
      }
      r.inc(1);
    }, H = () => {
      if (!o.value) {
        u();
        return;
      }
      r.dec(1);
    }, w = () => {
      o.value && k(e.options[n.value]);
    }, _ = () => {
      if (!o.value) {
        u();
        return;
      }
      k(e.options[n.value]);
    }, L = () => {
      o.value && k(e.options[n.value]);
    }, I = () => {
      r.set(0), o.value || u();
    }, F = () => {
      r.set(e.options.length - 1), o.value || u();
    }, B = me([]), K = me("");
    let ee = null;
    const ve = () => {
      ee = setTimeout(() => {
        B.value = [];
      }, Rg);
    }, q = (U) => {
      if (!(U.key.length === 1 && U.key.match(/[a-z]|[0-9]/i))) return;
      if (ee && clearTimeout(ee), ve(), B.value.push(U.key), o.value || u(), K.value === U.key) {
        const Z = e.options.filter(
          (N) => N.label.toLowerCase().startsWith(K.value.toLowerCase())
        );
        if (Z.length === 1 || Z.length === 0)
          return;
        const D = s.value.indexOf(e.options[n.value].value), x = s.value.indexOf(Z[0].value), A = s.value.indexOf(Z[Z.length - 1].value);
        D >= A ? r.set(x) : r.inc(1);
        return;
      }
      const te = B.value.join("").toLowerCase(), G = e.options.find((Z) => Z.label.toLowerCase().startsWith(te));
      if (!G) return;
      const T = s.value.indexOf(G.value);
      r.set(T), K.value = U.key;
    }, O = () => {
      o.value && r.inc(X0);
    }, Y = () => {
      o.value && r.dec(X0);
    };
    return (U, ne) => (m(), C(ge, null, [
      Ne((m(), C("div", {
        id: U.name,
        class: le(["border border-t group outline-hidden relative ring-blue-600 rounded-b-[25px] rounded-t-[25px] w-full", {
          "rounded-b-none! border-b-transparent!": o.value && p.value,
          "rounded-t-none! border-t-transparent!": o.value && !p.value,
          "bg-gray-200 text-gray-800 cursor-not-allowed": U.disabled,
          "focus:ring-2 cursor-pointer": !U.disabled
        }]),
        ref_key: "inputRef",
        ref: M,
        role: "combobox",
        name: U.name,
        tabindex: U.disabled ? -1 : 0,
        "aria-labelledby": U.labelledBy,
        "aria-label": U.ariaLabel,
        "aria-disabled": U.disabled,
        "aria-expanded": o.value,
        "aria-haspopup": "listbox",
        "aria-controls": `listbox-${U.name}`,
        "aria-multiselectable": "true",
        "aria-activedescendant": o.value ? `option-${s.value[j(n)]}` : void 0,
        onClick: ne[0] || (ne[0] = (te) => o.value ? d() : u()),
        onKeydown: [
          Ae($e(_, ["exact"]), ["space"]),
          Ae($e(d, ["exact"]), ["escape"]),
          Ae($e(H, ["exact", "prevent"]), ["up"]),
          Ae($e(w, ["exact", "alt"]), ["up"]),
          Ae($e(v, ["exact", "prevent"]), ["down"]),
          Ae($e(_, ["exact"]), ["enter"]),
          Ae($e(F, ["exact", "prevent"]), ["end"]),
          Ae($e(I, ["exact", "prevent"]), ["home"]),
          Ae($e(L, ["exact"]), ["tab"]),
          Ae($e(O, ["exact", "prevent"]), ["page-down"]),
          Ae($e(Y, ["exact", "prevent"]), ["page-up"]),
          q
        ]
      }, [
        g("div", Og, [
          f.value ? (m(), C("span", Fg, [
            oe(U.$slots, "value", {
              options: i.value,
              selectItem: k,
              deselectItem: y
            }, () => [
              U.$slots.outsideBadges ? ae("", !0) : (m(), C("span", Bg, _e(f.value), 1))
            ])
          ])) : (m(), C("span", {
            key: 1,
            class: le(["text-gray-400", { "text-gray-800": U.disabled }])
          }, _e(U.placeholder), 3)),
          ye(ra, {
            "is-open": o.value,
            class: le(["ml-auto self-center", { "text-gray-800": U.disabled }])
          }, null, 8, ["is-open", "class"])
        ]),
        Ne(g("div", {
          id: `listbox-${U.name}`,
          ref_key: "selectBodyRef",
          ref: b,
          role: "listbox",
          tabindex: "-1",
          class: le(["-left-[1px] absolute border border-gray-400 group-focus:ring-2 hide-scrollbar max-h-52 overflow-auto py-2 ring-blue-600 shadow-card w-[calc(100%+2px)] z-20", {
            "top-[calc(100%+1px)] rounded-b-[20px]": p.value,
            "bottom-[calc(100%+1px)] rounded-t-[20px]": !p.value,
            "bg-white": !l.value,
            "bg-gray-200": l.value
          }])
        }, [
          (m(!0), C(ge, null, De(U.options, (te, G) => (m(), C("div", {
            id: `option-${te.value}`,
            key: String(te.value),
            class: le(["bg-white border-y cursor-pointer flex hover:bg-gray-200 p-2", {
              "border-transparent": j(n) !== G,
              "border-gray-400": j(n) === G,
              "bg-gray-200! text-gray-800 cursor-not-allowed!": l.value && !a.value.includes(te.value)
            }]),
            role: "option",
            "aria-disabled": l.value && !a.value.includes(te.value),
            "aria-selected": a.value.includes(te.value),
            onClick: $e((T) => k(te), ["stop", "prevent"])
          }, [
            g("span", null, [
              oe(U.$slots, "option", { option: te }, () => [
                qe(_e(te.label), 1)
              ])
            ]),
            a.value.includes(te.value) ? (m(), he(Oe, {
              key: 0,
              class: "ml-auto self-center"
            }, {
              default: ue(() => [
                ye(Ir)
              ]),
              _: 1
            })) : ae("", !0)
          ], 10, Zg))), 128))
        ], 10, Ig), [
          [L1, o.value]
        ])
      ], 42, Tg)), [
        [j(Ft), d]
      ]),
      U.$slots.outsideBadges ? oe(U.$slots, "outsideBadges", {
        key: 0,
        options: i.value,
        deselectItem: y
      }) : ae("", !0)
    ], 64));
  }
}), Ng = { "data-test": "selectedOptions" }, qg = { class: "flex flex-wrap gap-2" }, Ug = { class: "bg-secondary flex px-2 py-0.5 rounded-full text-sm text-white" }, Yg = ["onClick"], Xx = /* @__PURE__ */ J({
  __name: "MultiSelectWithBadges",
  props: /* @__PURE__ */ Ye({
    options: {},
    disabled: { type: Boolean },
    name: {},
    placeholder: {},
    labelledBy: {},
    label: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => (m(), he(P2, {
      modelValue: e.value,
      "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
      options: a.options,
      name: a.name,
      placeholder: a.placeholder,
      "aria-label": a.label,
      "labelled-by": a.labelledBy,
      disabled: a.disabled
    }, {
      value: ue(({ options: n, deselectItem: r }) => [
        g("div", Ng, [
          g("div", qg, [
            (m(!0), C(ge, null, De(n, (s) => (m(), C("div", {
              key: s.label,
              class: ""
            }, [
              g("p", Ug, [
                qe(_e(s.label) + " ", 1),
                g("button", {
                  type: "button",
                  class: "hover:text-white text-[#ffe3bf]",
                  onClick: $e((i) => r(s), ["stop", "prevent"])
                }, [
                  ye(Oe, { class: "flex ml-1 p-0.5" }, {
                    default: ue(() => [
                      ye(j(Oi))
                    ]),
                    _: 1
                  })
                ], 8, Yg)
              ])
            ]))), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "name", "placeholder", "aria-label", "labelled-by", "disabled"]));
  }
}), Wg = { class: "flex flex-col w-full" }, Kg = {
  key: 0,
  "data-test": "selectedOptions",
  class: "mt-2"
}, Gg = { class: "flex flex-wrap gap-2" }, Xg = { class: "bg-secondary flex px-2 py-0.5 rounded-full text-sm text-white" }, Qg = ["onClick"], Qx = /* @__PURE__ */ J({
  __name: "MultiSelectWithBadgesOutside",
  props: /* @__PURE__ */ Ye({
    options: {},
    disabled: { type: Boolean },
    name: {},
    placeholder: {},
    labelledBy: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => (m(), C("div", Wg, [
      ye(P2, {
        modelValue: e.value,
        "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
        options: a.options,
        name: a.name,
        placeholder: a.placeholder,
        "labelled-by": a.labelledBy,
        disabled: a.disabled
      }, {
        outsideBadges: ue(({ options: n, deselectItem: r }) => [
          n?.length ? (m(), C("div", Kg, [
            g("div", Gg, [
              (m(!0), C(ge, null, De(n, (s) => (m(), C("div", {
                key: s.label
              }, [
                g("p", Xg, [
                  qe(_e(s.label) + " ", 1),
                  g("button", {
                    type: "button",
                    class: "hover:text-white text-(--color-secondary-light)",
                    onClick: (i) => r(s)
                  }, [
                    ye(Oe, { class: "flex ml-1 p-0.5" }, {
                      default: ue(() => [
                        ye(j(Oi))
                      ]),
                      _: 1
                    })
                  ], 8, Qg)
                ])
              ]))), 128))
            ])
          ])) : ae("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "name", "placeholder", "labelled-by", "disabled"])
    ]));
  }
}), Jg = { class: "flex group" }, ey = ["name", "disabled", "placeholder", "aria-labelledby", "aria-controls", "aria-expanded", "aria-activedescendant", "onKeydown"], ty = ["disabled", "aria-controls", "aria-expanded"], ay = ["id"], oy = {
  key: 0,
  role: "presentation",
  class: "border-b font-bold option-group-header px-4 py-2 text-primary"
}, ny = ["aria-selected", "onClick"], Jx = /* @__PURE__ */ J({
  __name: "SelectAutocomplete",
  props: /* @__PURE__ */ Ye({
    modelValue: {},
    options: {},
    disabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    labelledBy: { default: void 0 },
    isValid: { type: Boolean, default: !0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = me(!1), o = () => {
      a.value = !0;
    }, n = () => {
      a.value = !1;
    }, r = me(), s = me(!1);
    Ue(r, () => {
      y.value && (s.value = !0);
    });
    const i = Q(() => !r.value || !s.value ? e.options : e.options.filter((I) => I.label.toLocaleLowerCase().includes(r.value.toLocaleLowerCase()))), l = e1(t, "modelValue"), f = Q(() => i.value.find((I) => I.value === l.value)), { count: u, ...d } = na(0, {
      min: 0,
      max: i.value.length
    }), k = Q(() => u.value - 1), y = me(!1);
    Ue(
      f,
      () => {
        y.value || (r.value = f.value?.label);
      },
      {
        immediate: !0
      }
    );
    const b = () => {
      l.value && f.value && (r.value = f.value.label), y.value = !0;
    }, M = () => {
      y.value = !1, d.reset(0), p1(() => {
        f.value && (r.value = f.value.label), s.value = !1;
      });
    }, c = (I) => {
      l.value = I.value, M();
    }, p = me();
    Ue(u, () => {
      p.value && p.value.children[k.value] && (p.value.scrollTop = p.value.children[k.value].offsetTop);
    });
    const v = () => {
      if (!y.value) {
        d.set(1), b();
        return;
      }
      if (u.value === i.value.length) {
        d.set(1), i.value[k.value]?.isGroupLabel && v();
        return;
      }
      d.inc(1), i.value[k.value]?.isGroupLabel && v();
    }, H = () => {
      if (!y.value) {
        d.set(i.value.length), b();
        return;
      }
      if (u.value === 0 || u.value === 1) {
        d.set(i.value.length), i.value[k.value]?.isGroupLabel && H();
        return;
      }
      d.dec(1), i.value[k.value]?.isGroupLabel && H();
    }, w = () => {
      if (!y.value) {
        b();
        return;
      }
      u.value && c(i.value[k.value]);
    }, _ = () => {
      if (y.value) {
        M();
        return;
      }
      r.value = "";
    }, L = (I) => {
      const F = I.key.length === 1 && I.key.match(/[a-z]|[0-9]/i);
      !y.value && F && b();
    };
    return (I, F) => Ne((m(), C("div", {
      class: le(["border outline-hidden relative rounded-[20px] w-full", {
        "rounded-b-none! border-b-transparent! rounded-tl-[17px]! rounded-tr-[17px]!": y.value,
        "bg-gray-200 text-gray-800 cursor-not-allowed": I.disabled,
        "cursor-pointer": !I.disabled,
        "border-red": !I.isValid,
        "ring-2 ring-blue-600": a.value
      }])
    }, [
      g("div", Jg, [
        Ne(g("input", {
          "onUpdate:modelValue": F[0] || (F[0] = (B) => r.value = B),
          type: "text",
          name: I.name,
          role: "combobox",
          disabled: I.disabled,
          placeholder: I.placeholder,
          "aria-labelledby": I.labelledBy,
          "aria-controls": `listbox-${I.name}`,
          "aria-autocomplete": "list",
          "aria-haspopup": "listbox",
          "aria-expanded": y.value,
          "aria-activedescendant": y.value && j(u) !== 0 && i.value.length ? `option-${i.value[k.value].value}` : void 0,
          class: le(["outline-none pl-3 py-2 rounded-l-[20px] w-full", {
            "rounded-bl-none! rounded-l-[17px]": y.value,
            "cursor-not-allowed": I.disabled
          }]),
          onClick: F[1] || (F[1] = (B) => y.value ? M() : b()),
          onKeydown: [
            Ae($e(v, ["exact", "prevent"]), ["down"]),
            Ae($e(H, ["exact", "prevent"]), ["up"]),
            Ae($e(w, ["exact", "prevent"]), ["enter"]),
            Ae($e(_, ["exact", "prevent"]), ["escape"]),
            Ae($e(M, ["exact"]), ["tab"]),
            L
          ],
          onFocus: o,
          onBlur: n
        }, null, 42, ey), [
          [_a, r.value]
        ]),
        g("button", {
          id: "cb1-button",
          type: "button",
          tabindex: "-1",
          disabled: I.disabled,
          "aria-controls": `listbox-${I.name}`,
          "aria-expanded": y.value,
          class: "flex items-center px-3",
          onClick: F[2] || (F[2] = (B) => y.value ? M() : b())
        }, [
          ye(ra, {
            "is-open": y.value,
            class: le({ "text-gray-800": I.disabled })
          }, null, 8, ["is-open", "class"])
        ], 8, ty)
      ]),
      Ne(g("ul", {
        id: `listbox-${I.name}`,
        ref_key: "selectBodyRef",
        ref: p,
        tabindex: "-1",
        role: "listbox",
        class: le(["-left-[1px] absolute bg-white border border-gray-400 hide-scrollbar max-h-52 overflow-auto py-2 rounded-b-[20px] shadow-card top-[calc(100%+1px)] w-[calc(100%+2px)] z-20", {
          "ring-2 ring-blue-600": a.value
        }])
      }, [
        (m(!0), C(ge, null, De(i.value, (B, K) => (m(), C(ge, {
          key: B.label
        }, [
          B.isGroupLabel ? (m(), C("li", oy, _e(B.label), 1)) : (m(), C("li", {
            key: 1,
            role: "option",
            class: le(["border-y cursor-pointer flex hover:bg-gray-200 p-2", {
              "border-transparent": j(u) !== K + 1,
              "border-gray-400": j(u) === K + 1
            }]),
            "aria-selected": B.value === l.value,
            onClick: $e((ee) => c(B), ["stop", "prevent"])
          }, [
            qe(_e(B.label) + " ", 1),
            B.value === l.value ? (m(), he(Oe, {
              key: 0,
              class: "ml-auto self-center"
            }, {
              default: ue(() => [
                ye(Ir)
              ]),
              _: 1
            })) : ae("", !0)
          ], 10, ny))
        ], 64))), 128))
      ], 10, ay), [
        [L1, y.value]
      ])
    ], 2)), [
      [j(Ft), M]
    ]);
  }
}), ry = ["id", "name", "disabled"], sy = ["for", "aria-labelledby", "onKeydown"], e$ = /* @__PURE__ */ J({
  __name: "Switch",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean },
    modelValue: { type: Boolean },
    labelledBy: {},
    disabled: { type: Boolean }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue"), a = () => {
      e.value = !e.value;
    };
    return (o, n) => (m(), C("div", null, [
      Ne(g("input", {
        id: o.name,
        "onUpdate:modelValue": n[0] || (n[0] = (r) => e.value = r),
        name: o.name,
        disabled: o.disabled,
        type: "checkbox",
        role: "switch",
        class: "appearance-none h-0 hidden w-0"
      }, null, 8, ry), [
        [Il, e.value]
      ]),
      g("label", {
        tabindex: "0",
        for: o.name,
        "aria-labelledby": o.labelledBy,
        class: le(["block border cursor-pointer focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 h-[20px] outline-hidden relative rounded-full w-[40px]", {
          "bg-gray-500 border-gray-800": o.disabled || !e.value,
          "bg-primary border-primary": e.value && !o.disabled
        }]),
        onKeydown: Ae($e(a, ["exact"]), ["space"])
      }, [
        g("span", {
          class: le(["absolute block h-[18px] rounded-full transition-all w-[18px]", {
            "bg-white": !o.disabled,
            "bg-gray-800": o.disabled,
            "left-5": e.value,
            "left-0": !e.value
          }])
        }, null, 2)
      ], 42, sy)
    ]));
  }
}), iy = ["id", "name"], t$ = /* @__PURE__ */ J({
  __name: "TextArea",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    modelValue: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => Ne((m(), C("textarea", {
      id: a.name,
      "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
      name: a.name,
      type: "text",
      class: le(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-lg w-full", {
        "border-red": !a.isValid
      }])
    }, null, 10, iy)), [
      [_a, e.value]
    ]);
  }
}), ly = { class: "flex w-full" }, uy = {
  key: 0,
  class: "border border-r-0 font-thin px-3 py-2 rounded-l-full text-secondary"
}, cy = {
  key: 1,
  class: "border border-l-0 font-thin px-3 py-2 rounded-r-full text-secondary"
}, a$ = /* @__PURE__ */ J({
  __name: "TextInputWithInfo",
  props: /* @__PURE__ */ Ye({
    suffix: {},
    prefix: {},
    name: {},
    labelledBy: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ye(["blur"], ["update:modelValue"]),
  setup(t) {
    const e = t, a = (n) => {
      let r = n;
      return e.prefix && (r = r.split(e.prefix)?.pop() || r), e.suffix && (r = r.split(e.suffix)?.splice(0, 1).join("") || r), r;
    }, o = e1(t, "modelValue", {
      set(n) {
        return a(n);
      },
      get(n) {
        return a(n);
      }
    });
    return (n, r) => (m(), C("div", ly, [
      n.prefix ? (m(), C("div", uy, _e(n.prefix), 1)) : ae("", !0),
      ye(mo, {
        modelValue: o.value,
        "onUpdate:modelValue": r[0] || (r[0] = (s) => o.value = s),
        name: n.name,
        "labelled-by": n.labelledBy,
        class: le({
          "rounded-r-none!": !!n.suffix,
          "rounded-l-none!": !!n.prefix
        }),
        onBlur: r[1] || (r[1] = (s) => n.$emit("blur", s))
      }, null, 8, ["modelValue", "name", "labelled-by", "class"]),
      n.suffix ? (m(), C("div", cy, _e(n.suffix), 1)) : ae("", !0)
    ]));
  }
}), o$ = /* @__PURE__ */ J({
  __name: "TimeInput",
  props: /* @__PURE__ */ Ye({
    name: {},
    isVisible: { type: Boolean },
    isDirty: { type: Boolean },
    isDisabled: { type: Boolean },
    isOptional: { type: Boolean },
    isReadOnly: { type: Boolean },
    isSuspended: { type: Boolean },
    isTouched: { type: Boolean },
    isValid: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    modelValue: {},
    autoFocus: { type: Boolean },
    labelledBy: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue");
    return (a, o) => (m(), he(mo, Re(a.$props, {
      modelValue: e.value,
      "onUpdate:modelValue": o[0] || (o[0] = (n) => e.value = n),
      class: "md:w-32 relative sm:w-full",
      type: "time"
    }), null, 16, ["modelValue"]));
  }
}), dy = { class: "relative" }, my = ["aria-controls", "aria-expanded", "aria-label"], py = { class: "pr-2 flex justify-between w-full" }, fy = { class: "whitespace-nowrap" }, hy = ["aria-label"], vy = { key: 1 }, gy = { class: "text-primary whitespace-nowrap ml-2" }, yy = ["id"], by = { class: "mt-2" }, po = /* @__PURE__ */ J({
  __name: "FilterDropdown",
  props: {
    label: {},
    amount: {},
    activeLabel: {},
    hasValue: { type: Boolean }
  },
  emits: ["deleteFilters"],
  setup(t, { emit: e }) {
    const a = e, o = t, { t: n } = Sa({
      useScope: "local",
      inheritLocale: !0
    }), r = () => {
      s.value = !1;
    }, s = me(!1), i = Q(() => o.activeLabel ?? o.label), l = () => {
      s.value = !s.value;
    }, f = ro(), u = () => {
      s.value = !1, a("deleteFilters");
    };
    return (d, k) => Ne((m(), C("div", dy, [
      g("button", {
        type: "button",
        class: le(["min-w-max bg-white border cursor-pointer flex h-10 items-center justify-between px-3 py-2 rounded-full text-black text-left transition-color w-full", s.value ? "border-black" : "border-gray-400"]),
        "aria-controls": `listbox-${j(f)}`,
        "aria-expanded": s.value,
        "aria-haspopup": "listbox",
        role: "combobox",
        tabindex: "0",
        "aria-label": d.label,
        onClick: l
      }, [
        g("span", py, [
          g("span", fy, _e(d.label), 1),
          d.amount ? (m(), C("span", {
            key: 0,
            "aria-label": j(n)("amountSelected"),
            class: "ml-2 rounded-full text-primary border border-primary text-sm flex text-center justify-center min-w-6 px-0.5 bg-primary/5"
          }, _e(d.amount), 9, hy)) : d.hasValue ? (m(), C("span", vy, [
            g("span", gy, _e(i.value), 1)
          ])) : ae("", !0)
        ]),
        ye(j(za), null, {
          default: ue(() => [
            s.value ? (m(), he(j(Fv), { key: 0 })) : ae("", !0),
            s.value ? ae("", !0) : (m(), he(j(Rv), { key: 1 }))
          ]),
          _: 1
        })
      ], 10, my),
      Ne(g("div", {
        id: `listbox-${j(f)}`,
        class: "absolute bg-white min-w-max px-4 py-3 rounded-regular shadow-[0px_4px_12px_rgba(0,0,0,0.15)] top-[calc(100%+8px)] z-20",
        tabindex: "-1"
      }, [
        oe(d.$slots, "default"),
        g("div", by, [
          ye(j(b1), {
            class: le({
              "text-gray-800 hover:text-gray-800 cursor-default disabled:bg-white disabled:border-none": !d.hasValue
            }),
            variant: "danger-basic",
            size: "none",
            disabled: !d.hasValue,
            onClick: u
          }, {
            default: ue(() => [
              qe(_e(j(n)("deleteFilter")), 1)
            ]),
            _: 1
          }, 8, ["class", "disabled"])
        ])
      ], 8, yy), [
        [L1, s.value]
      ])
    ])), [
      [j(Ft), () => r()]
    ]);
  }
});
function Q0(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      "nl-NL": {
        amountSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aantal geselecteerde filters" } },
        deleteFilter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Verwijder filter" } }
      },
      "nl-BE": {
        amountSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aantal geselecteerde filters" } },
        deleteFilter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Verwijder filter" } }
      },
      "en-GB": {
        amountSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount of selected filters" } },
        deleteFilter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Delete filter" } }
      },
      "fr-BE": {
        amountSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de filtres sélectionnés" } },
        deleteFilter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supprimer le filtre" } }
      }
    }
  });
}
typeof Q0 == "function" && Q0(po);
const ky = /* @__PURE__ */ J({
  __name: "CheckboxFilter",
  props: /* @__PURE__ */ Ye({
    item: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = e1(t, "modelValue"), o = Q(() => e.item.options.map((r) => ({ ...r, value: String(r.value) }))), n = () => {
      a.value = [];
    };
    return (r, s) => (m(), he(po, {
      label: r.item.label,
      amount: a.value.length,
      "has-value": a.value.length > 0,
      onDeleteFilters: n
    }, {
      default: ue(() => [
        ye(j(Fd), {
          modelValue: a.value,
          "onUpdate:modelValue": s[0] || (s[0] = (i) => a.value = i),
          options: o.value,
          name: r.item.name
        }, null, 8, ["modelValue", "options", "name"])
      ]),
      _: 1
    }, 8, ["label", "amount", "has-value"]));
  }
}), z2 = /* @__PURE__ */ J({
  __name: "DateRangeFilter",
  props: /* @__PURE__ */ Ye({
    item: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const { t: e } = Sa({
      useScope: "local",
      inheritLocale: !0
    }), a = e1(t, "modelValue"), o = (l) => J1(l).format("DD-MM-YYYY"), n = (l) => {
      a.value = { from: l, to: a.value.to };
    }, r = (l) => {
      a.value = { from: a.value.from, to: l };
    }, s = () => {
      a.value = { from: null, to: null };
    }, i = Q(() => {
      const l = a.value?.from ? o(a.value.from) : "", f = a.value?.to ? o(a.value.to) : "";
      return l && f ? e("dates.between", { from: l, to: f }) : l ? e("dates.from", { from: l }) : f ? e("dates.to", { to: f }) : "";
    });
    return (l, f) => (m(), he(po, {
      "active-label": i.value,
      label: l.item.label,
      "has-value": !!a.value.from || !!a.value.to,
      onDeleteFilters: s
    }, {
      default: ue(() => [
        ye(j(sv), {
          "from-date": a.value?.from,
          "end-date": a.value?.to,
          placeholder: j(e)("from"),
          "placeholder-end-date": j(e)("to"),
          "onUpdate:fromDate": n,
          "onUpdate:endDate": r
        }, null, 8, ["from-date", "end-date", "placeholder", "placeholder-end-date"])
      ]),
      _: 1
    }, 8, ["active-label", "label", "has-value"]));
  }
});
function J0(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      "nl-NL": {
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Van" } },
        to: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tot" } },
        dates: {
          between: { t: 0, b: { t: 2, i: [{ t: 4, k: "from" }, { t: 3, v: " tot " }, { t: 4, k: "to" }] } },
          from: { t: 0, b: { t: 2, i: [{ t: 3, v: "Van " }, { t: 4, k: "from" }] } },
          to: { t: 0, b: { t: 2, i: [{ t: 3, v: "Tot " }, { t: 4, k: "to" }] } }
        }
      },
      "nl-BE": {
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Van" } },
        to: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tot" } },
        dates: {
          between: { t: 0, b: { t: 2, i: [{ t: 4, k: "from" }, { t: 3, v: " tot " }, { t: 4, k: "to" }] } },
          from: { t: 0, b: { t: 2, i: [{ t: 3, v: "Van " }, { t: 4, k: "from" }] } },
          to: { t: 0, b: { t: 2, i: [{ t: 3, v: "Tot " }, { t: 4, k: "to" }] } }
        }
      },
      "en-GB": {
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "From" } },
        to: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "To" } },
        dates: {
          between: { t: 0, b: { t: 2, i: [{ t: 4, k: "from" }, { t: 3, v: " till " }, { t: 4, k: "to" }] } },
          from: { t: 0, b: { t: 2, i: [{ t: 3, v: "From " }, { t: 4, k: "from" }] } },
          to: { t: 0, b: { t: 2, i: [{ t: 3, v: "To " }, { t: 4, k: "to" }] } }
        }
      },
      "fr-BE": {
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "De" } },
        to: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À" } },
        dates: {
          between: { t: 0, b: { t: 2, i: [{ t: 4, k: "from" }, { t: 3, v: " à " }, { t: 4, k: "to" }] } },
          from: { t: 0, b: { t: 2, i: [{ t: 3, v: "De " }, { t: 4, k: "from" }] } },
          to: { t: 0, b: { t: 2, i: [{ t: 3, v: "À " }, { t: 4, k: "to" }] } }
        }
      }
    }
  });
}
typeof J0 == "function" && J0(z2);
const Cy = /* @__PURE__ */ J({
  __name: "NumberFilter",
  props: /* @__PURE__ */ Ye({
    item: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue"), a = () => {
      e.value = null;
    };
    return (o, n) => (m(), he(po, {
      "active-label": String(e.value),
      label: o.item.label,
      "has-value": e.value !== null,
      onDeleteFilters: a
    }, {
      default: ue(() => [
        ye(j(vv), {
          modelValue: e.value,
          "onUpdate:modelValue": n[0] || (n[0] = (r) => e.value = r),
          name: o.item.name
        }, null, 8, ["modelValue", "name"])
      ]),
      _: 1
    }, 8, ["active-label", "label", "has-value"]));
  }
}), wy = /* @__PURE__ */ J({
  __name: "RadioFilter",
  props: /* @__PURE__ */ Ye({
    item: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = e1(t, "modelValue"), a = () => {
      e.value = null;
    };
    return (o, n) => (m(), he(po, {
      "active-label": o.item.options.find((r) => r.value === e.value)?.label,
      label: o.item.label,
      "has-value": !!e.value,
      onDeleteFilters: a
    }, {
      default: ue(() => [
        ye(j(Hg), {
          modelValue: e.value,
          "onUpdate:modelValue": n[0] || (n[0] = (r) => e.value = r),
          options: o.item.options,
          name: o.item.name
        }, null, 8, ["modelValue", "options", "name"])
      ]),
      _: 1
    }, 8, ["active-label", "label", "has-value"]));
  }
}), _y = { class: "flex gap-4 flex-wrap w-max" }, Hy = { class: "ml-2 px-1.5 py-.5 rounded-full duration-[inherit] ease-[inherit] text-red border border-red text-sm bg-red/5 group-hover:border-white group-hover:text-white" }, jy = /* @__PURE__ */ J({
  __name: "FilterBar",
  props: /* @__PURE__ */ Ye({
    config: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, a = e1(t, "modelValue"), { t: o } = Sa({
      useScope: "local",
      inheritLocale: !0
    }), n = Q(() => Object.values(a.value).filter((f) => Array.isArray(f) ? f.length > 0 : f && typeof f == "object" && "from" in f && "to" in f ? f.from !== null || f.to !== null : f !== void 0 && f !== "" && f !== null).length), r = () => {
      const l = {}, f = {
        checkbox: [],
        dateRange: { from: null, to: null },
        number: null,
        radio: null
      };
      return e.config.forEach((u) => {
        l[u.name] = f[u.type];
      }), l;
    }, s = () => {
      const l = a.value, f = r();
      Object.keys(l).forEach((u) => {
        u in f || delete l[u], Array.isArray(a.value[u]) && (a.value[u] = a.value[u].map((d) => String(d)));
      }), a.value = { ...f, ...l };
    }, i = () => {
      a.value = { ...r() };
    };
    return Ue(
      () => e.config,
      () => {
        s();
      },
      { immediate: !0 }
    ), (l, f) => (m(), C("div", _y, [
      (m(!0), C(ge, null, De(l.config, (u) => (m(), C("div", {
        key: u.name,
        class: "flex-1 min-w-max md:max-w-1/3"
      }, [
        u.type === "radio" && a.value[u.name] !== void 0 ? (m(), he(wy, {
          key: 0,
          item: u,
          modelValue: a.value[u.name],
          "onUpdate:modelValue": (d) => a.value[u.name] = d
        }, null, 8, ["item", "modelValue", "onUpdate:modelValue"])) : ae("", !0),
        u.type === "checkbox" && a.value[u.name] !== void 0 ? (m(), he(ky, {
          key: 1,
          item: u,
          modelValue: a.value[u.name],
          "onUpdate:modelValue": (d) => a.value[u.name] = d
        }, null, 8, ["item", "modelValue", "onUpdate:modelValue"])) : ae("", !0),
        u.type === "number" && a.value[u.name] !== void 0 ? (m(), he(Cy, {
          key: 2,
          item: u,
          modelValue: a.value[u.name],
          "onUpdate:modelValue": (d) => a.value[u.name] = d
        }, null, 8, ["item", "modelValue", "onUpdate:modelValue"])) : ae("", !0),
        u.type === "dateRange" && a.value[u.name] !== void 0 ? (m(), he(z2, {
          key: 3,
          item: u,
          modelValue: a.value[u.name],
          "onUpdate:modelValue": (d) => a.value[u.name] = d
        }, null, 8, ["item", "modelValue", "onUpdate:modelValue"])) : ae("", !0)
      ]))), 128)),
      n.value > 0 ? (m(), he(j(b1), {
        key: 0,
        class: "flex-1 md:max-w-1/3 group",
        variant: "danger-outline",
        onClick: i
      }, {
        default: ue(() => [
          qe(_e(j(o)("deleteFilters")) + " ", 1),
          g("span", Hy, _e(n.value), 1)
        ]),
        _: 1
      })) : ae("", !0)
    ]));
  }
});
function es(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "",
    resource: {
      "nl-NL": {
        deleteFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Verwijder filters" } }
      },
      "nl-BE": {
        deleteFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Verwijder filters" } }
      },
      "en-GB": {
        deleteFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Delete filters" } }
      },
      "fr-BE": {
        deleteFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supprimer les filtres" } }
      }
    }
  });
}
typeof es == "function" && es(jy);
const Ly = { class: "flex gap-x-4 mb-4" }, xy = ["textContent"], $y = { class: "text-sm" }, n$ = /* @__PURE__ */ J({
  __name: "InfoCard",
  props: {
    title: {}
  },
  setup(t) {
    return (e, a) => (m(), he(j(Ni), { class: "bg-white gap-y-4 shadow-card" }, {
      default: ue(() => [
        g("div", Ly, [
          ye(Oe, null, {
            default: ue(() => [
              ye(j(Tu))
            ]),
            _: 1
          }),
          g("h3", {
            class: "font-bold font-heading",
            textContent: _e(e.title)
          }, null, 8, xy)
        ]),
        g("div", $y, [
          oe(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), r$ = /* @__PURE__ */ J({
  __name: "Backdrop",
  props: {
    show: { type: Boolean }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = (r) => {
      a.show && o("click", r);
    };
    return (r, s) => (m(), C("div", {
      "data-test": "backdrop",
      class: le(["absolute bg-black duration-200 ease-in-out h-full left-0 top-0 transition-opacity w-full z-30", {
        "opacity-0 pointer-events-none": !r.show,
        "opacity-50": r.show
      }]),
      onClick: s[0] || (s[0] = (i) => n(i))
    }, null, 2));
  }
}), My = {
  type: "button",
  class: "flex gap-2 hover:bg-gray-200 items-center px-4 py-2"
}, s$ = /* @__PURE__ */ J({
  __name: "CollapseMenuButton",
  props: {
    isCollapsed: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("button", My, [
      ye(Oe, { size: 24 }, {
        default: ue(() => [
          e.isCollapsed ? (m(), he(j(k8), { key: 0 })) : (m(), he(j(v8), { key: 1 }))
        ]),
        _: 1
      })
    ]));
  }
}), Vy = {};
function Sy(t, e) {
  return m(), C("li", null, e[0] || (e[0] = [
    g("hr", { class: "my-0.5" }, null, -1)
  ]));
}
const i$ = /* @__PURE__ */ se(Vy, [["render", Sy]]), Ay = { class: "border-l-2 border-transparent flex flex-col hover:bg-gray-200" }, Ey = ["href"], Dy = {
  key: 1,
  class: "mr-1 w-[24px]"
}, Py = { class: "flex-1" }, l$ = /* @__PURE__ */ J({
  __name: "ExternalMenuItem",
  props: {
    item: {},
    hideIcon: { type: Boolean },
    linkClass: {}
  },
  setup(t) {
    return (e, a) => (m(), C("li", Ay, [
      g("a", {
        target: "_blank",
        href: e.item.href,
        rel: "noopener noreferrer",
        class: le(["flex gap-2 grow items-center pl-[14px] pr-4 py-2", e.linkClass])
      }, [
        e.item.icon && !e.hideIcon ? (m(), he(Oe, {
          key: 0,
          class: "mr-1 text-secondary",
          size: 24
        }, {
          default: ue(() => [
            (m(), he(S1(e.item.icon)))
          ]),
          _: 1
        })) : e.hideIcon ? ae("", !0) : (m(), C("div", Dy)),
        g("span", Py, [
          oe(e.$slots, "default")
        ]),
        ye(Oe, {
          class: "ml-auto text-black-light",
          size: 24
        }, {
          default: ue(() => [
            ye(j(_6))
          ]),
          _: 1
        })
      ], 10, Ey)
    ]));
  }
}), zy = {
  key: 1,
  class: "mr-1 w-[24px]"
}, Ty = {
  key: 2,
  class: "flex-1 text-left"
}, Oy = /* @__PURE__ */ J({
  __name: "InternalMenuItem",
  props: {
    linkComponent: {},
    linkClass: {},
    item: {},
    isActive: { type: Boolean },
    hideIcon: { type: Boolean },
    hideLabel: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("li", {
      class: le(["flex flex-col hover:bg-gray-200 menu-item relative", {
        "font-bold before:bg-secondary": e.isActive
      }])
    }, [
      (m(), he(S1(e.linkComponent), {
        to: e.item.to,
        class: le(["flex gap-2 items-center px-4 py-2 text-left", e.linkClass])
      }, {
        default: ue(() => [
          e.item.icon && !e.hideIcon ? (m(), he(Oe, {
            key: 0,
            class: "mr-1 text-secondary",
            size: 24
          }, {
            default: ue(() => [
              (m(), he(S1(e.item.icon)))
            ]),
            _: 1
          })) : e.hideIcon ? ae("", !0) : (m(), C("div", zy)),
          e.hideLabel ? ae("", !0) : (m(), C("div", Ty, [
            oe(e.$slots, "default", {}, void 0, !0)
          ]))
        ]),
        _: 3
      }, 8, ["to", "class"]))
    ], 2));
  }
}), u$ = /* @__PURE__ */ se(Oy, [["__scopeId", "data-v-55533381"]]), c$ = {
  Internal: "internal",
  External: "external",
  Parent: "parent",
  Divider: "divider"
}, Fy = {
  key: 1,
  class: "w-[24px]"
}, By = /* @__PURE__ */ J({
  __name: "ParentMenuItemCollapsed",
  props: {
    item: {},
    activeRouteName: {},
    hideIcon: { type: Boolean },
    iconClass: {}
  },
  setup(t) {
    const e = t, [a, o] = ht(!1), n = Q(() => e.item.children.some((l) => l.type === "internal" ? l.to.name === e.activeRouteName || l.activeRouteNameAliases?.includes(e.activeRouteName) : !1)), r = me(), s = me(), { floatingStyles: i } = Aa(r, s, {
      placement: "right-start",
      whileElementsMounted: Da,
      middleware: [
        Ea(),
        Cn(),
        wn({
          padding: 8
        })
      ]
    });
    return (l, f) => Ne((m(), C("li", {
      ref_key: "reference",
      ref: r,
      class: "flex flex-col group",
      onMouseleave: f[1] || (f[1] = () => j(o)(!1))
    }, [
      g("button", {
        type: "button",
        class: le(["flex gap-2 hover:bg-gray-200 items-center menu-item px-4 py-2 relative", {
          "before:bg-secondary font-bold": n.value
        }]),
        onClick: f[0] || (f[0] = () => j(o)())
      }, [
        l.item.icon && !l.hideIcon ? (m(), he(Oe, {
          key: 0,
          class: le(["text-secondary", l.iconClass]),
          size: 24
        }, {
          default: ue(() => [
            (m(), he(S1(l.item.icon)))
          ]),
          _: 1
        }, 8, ["class"])) : l.hideIcon ? ae("", !0) : (m(), C("div", Fy)),
        oe(l.$slots, "label", {}, void 0, !0)
      ], 2),
      g("ul", {
        ref_key: "floating",
        ref: s,
        style: w1([j(i)]),
        class: le([
          "absolute bg-white flex-col group-hover:flex left-full margin-l-4 shadow-[0px_0px_7px_-3px_rgba(0,0,0,0.5)] translate-x-2 w-max z-20",
          "hover-fix",
          "rounded-regular py-2",
          {
            flex: j(a),
            hidden: !j(a)
          }
        ])
      }, [
        (m(!0), C(ge, null, De(l.item.children, (u) => (m(), C(ge, {
          key: u.label
        }, [
          u.type === "external" ? oe(l.$slots, "external-menu-item", {
            key: 0,
            child: u
          }, void 0, !0) : u.type === "internal" ? oe(l.$slots, "internal-menu-item", {
            key: 1,
            child: u
          }, void 0, !0) : ae("", !0)
        ], 64))), 128)),
        oe(l.$slots, "default", {}, void 0, !0)
      ], 6)
    ], 32)), [
      [j(Ft), () => j(o)(!1)]
    ]);
  }
}), d$ = /* @__PURE__ */ se(By, [["__scopeId", "data-v-d2357f92"]]), Iy = {
  class: /* @__PURE__ */ le([
    "hide-scrollbar z-10 shadow-[inset_0px_0px_7px_-3px_rgba(0,0,0,0.5)]",
    "bg-gray-100 border-r flex flex-col h-full",
    "justify-between pt-3"
  ])
}, Zy = { class: "flex flex-col gap-2" }, Ry = { class: "flex justify-end lg:hidden pr-1" }, Ny = {
  key: 0,
  class: "d-flex flex-column"
}, m$ = /* @__PURE__ */ J({
  __name: "SideMenuCollapsed",
  props: {
    menu: {}
  },
  emits: ["close"],
  setup(t) {
    return (e, a) => (m(), C("nav", Iy, [
      g("ul", Zy, [
        g("li", Ry, [
          ye(j(b1), {
            variant: "none",
            onClick: a[0] || (a[0] = (o) => e.$emit("close"))
          }, {
            default: ue(() => [
              ye(Oe, {
                class: "text-black-light",
                size: 24
              }, {
                default: ue(() => [
                  ye(j(Fi))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (m(!0), C(ge, null, De(e.menu, (o) => (m(), C(ge, {
          key: o.label
        }, [
          o.type === "parent" ? oe(e.$slots, "parent-menu-item", {
            key: 0,
            item: o
          }) : ae("", !0),
          o.type === "external" ? oe(e.$slots, "external-menu-item", {
            key: 1,
            item: o
          }) : ae("", !0),
          o.type === "internal" ? oe(e.$slots, "internal-menu-item", {
            key: 2,
            item: o
          }) : ae("", !0),
          o.type === "divider" ? oe(e.$slots, "divider-menu-item", {
            key: 3,
            item: o
          }) : ae("", !0)
        ], 64))), 128))
      ]),
      e.$slots.default ? (m(), C("div", Ny, [
        oe(e.$slots, "default")
      ])) : ae("", !0)
    ]));
  }
}), qy = {
  key: 1,
  class: "mr-1 w-[24px]"
}, Uy = { class: "flex flex-col" }, Yy = /* @__PURE__ */ J({
  __name: "ParentMenuItemExpanded",
  props: {
    item: {},
    activeRouteName: {}
  },
  setup(t) {
    const e = t, [a, o] = ht(!1), n = Q(() => e.item.children.some((r) => r.type === "internal" ? r.to.name === e.activeRouteName || r.activeRouteNameAliases?.includes(e.activeRouteName) : !1));
    return Ue(
      () => e.activeRouteName,
      () => {
        n.value && !a.value && o();
      },
      {
        immediate: !0
      }
    ), (r, s) => (m(), C(ge, null, [
      g("li", {
        class: le(["flex flex-col menu-item relative", {
          "before:bg-secondary font-bold": n.value && !j(a)
        }])
      }, [
        g("button", {
          type: "button",
          class: "flex gap-2 hover:bg-gray-200 items-center px-4 py-2 text-left",
          onClick: s[0] || (s[0] = () => j(o)())
        }, [
          r.item.icon ? (m(), he(Oe, {
            key: 0,
            class: "mr-1 text-secondary",
            size: 24
          }, {
            default: ue(() => [
              (m(), he(S1(r.item.icon)))
            ]),
            _: 1
          })) : (m(), C("div", qy)),
          oe(r.$slots, "default", { item: r.item }, void 0, !0),
          ye(Oe, { class: "ml-auto text-black-light" }, {
            default: ue(() => [
              (m(), he(S1(j(a) ? j(w5) : j(L5))))
            ]),
            _: 1
          })
        ])
      ], 2),
      Ne(g("ul", Uy, [
        (m(!0), C(ge, null, De(r.item.children, (i) => (m(), C(ge, {
          key: i.label
        }, [
          i.type === "external" ? oe(r.$slots, "external-menu-item", {
            key: 0,
            child: i
          }, void 0, !0) : i.type === "internal" ? oe(r.$slots, "internal-menu-item", {
            key: 1,
            child: i
          }, void 0, !0) : ae("", !0)
        ], 64))), 128))
      ], 512), [
        [L1, j(a)]
      ])
    ], 64));
  }
}), p$ = /* @__PURE__ */ se(Yy, [["__scopeId", "data-v-183c53a6"]]), Wy = {
  class: /* @__PURE__ */ le([
    "hide-scrollbar overflow-y-auto shadow-[inset_0px_0px_7px_-3px_rgba(0,0,0,0.5)]",
    "bg-gray-100 border-r flex flex-col h-full",
    "justify-between pt-3"
  ])
}, Ky = { class: "flex flex-col gap-2" }, Gy = { class: "flex justify-end lg:hidden pr-1" }, Xy = {
  key: 0,
  class: "d-flex flex-column"
}, f$ = /* @__PURE__ */ J({
  __name: "SideMenuExpanded",
  props: {
    menu: {}
  },
  emits: ["close"],
  setup(t) {
    return (e, a) => (m(), C("nav", Wy, [
      g("ul", Ky, [
        g("li", Gy, [
          ye(j(b1), {
            variant: "none",
            onClick: a[0] || (a[0] = (o) => e.$emit("close"))
          }, {
            default: ue(() => [
              ye(Oe, {
                class: "text-black-light",
                size: 24
              }, {
                default: ue(() => [
                  ye(j(Fi))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (m(!0), C(ge, null, De(e.menu, (o) => (m(), C(ge, {
          key: o.label
        }, [
          o.type === "parent" ? oe(e.$slots, "parent-menu-item", {
            key: 0,
            item: o
          }) : o.type === "internal" ? oe(e.$slots, "internal-menu-item", {
            key: 1,
            item: o
          }) : o.type === "external" ? oe(e.$slots, "external-menu-item", {
            key: 2,
            item: o
          }) : o.type === "divider" ? oe(e.$slots, "divider-menu-item", {
            key: 3,
            item: o
          }) : ae("", !0)
        ], 64))), 128))
      ]),
      e.$slots.default ? (m(), C("div", Xy, [
        oe(e.$slots, "default")
      ])) : ae("", !0)
    ]));
  }
}), [Qy, ts] = ht(!1), Jy = () => ({
  isOpen: Qy,
  openSidePanel: () => ts(!0),
  closeSidePanel: () => ts(!1)
}), eb = { class: "max-w-screen-xs w-full ml-auto border-l border-gray-200 h-full absolute right-0 top-0 pt-6 overflow-y-clip overflow-x-hidden bg-white z-50" }, tb = { class: "flex items-center gap-2 mb-6 px-6" }, ab = { class: "font-semibold text-xl flex-1" }, ob = { class: "w-full h-full overflow-y-auto px-6" }, nb = { class: "relative w-full" }, rb = { class: "fixed bottom-0 w-full max-w-screen-xs" }, h$ = /* @__PURE__ */ J({
  __name: "SidePanel",
  props: {
    title: {}
  },
  setup(t) {
    const { isOpen: e, closeSidePanel: a } = Jy();
    return (o, n) => j(e) ? (m(), he(Pi, {
      key: 0,
      to: "#globals-side-panel-container",
      "data-test": "side-panel"
    }, [
      Ne(g("div", {
        "data-test": "side-panel-backdrop",
        class: "bg-black fixed flex h-screen justify-center left-0 opacity-50 top-0 w-screen z-40",
        onClick: n[0] || (n[0] = //@ts-ignore
        (...r) => j(a) && j(a)(...r))
      }, null, 512), [
        [L1, j(e)]
      ]),
      g("div", eb, [
        g("div", tb, [
          g("h3", ab, _e(o.title), 1),
          ye(b1, {
            class: "h-full flex items-center justify-center",
            variant: "none",
            title: "Close",
            onClick: j(a)
          }, {
            default: ue(() => [
              ye(j(za), {
                class: "hover:text-secondary stroke-3",
                size: j(ka).Medium
              }, {
                default: ue(() => [
                  ye(j(tg))
                ]),
                _: 1
              }, 8, ["size"])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        g("div", ob, [
          oe(o.$slots, "default")
        ]),
        g("div", nb, [
          g("div", rb, [
            oe(o.$slots, "footer")
          ])
        ])
      ])
    ])) : ae("", !0);
  }
}), sb = {}, ib = { id: "globals-side-panel-container" };
function lb(t, e) {
  return m(), C("div", ib);
}
const v$ = /* @__PURE__ */ se(sb, [["render", lb]]), ub = { class: "relative w-fit" }, cb = { class: "overflow-hidden text-ellipsis whitespace-nowrap" }, db = ["id", "aria-labelledby", "aria-activedescendant"], mb = ["id", "onClick"], pb = 500, fb = 16, g$ = /* @__PURE__ */ J({
  __name: "MenuButton",
  props: {
    name: {},
    buttonText: {},
    options: {},
    buttonVariant: { default: k1.None }
  },
  setup(t) {
    const e = t, a = Q(() => e.options.map((ee) => ee.key)), o = Q(() => a.value.find((ee) => ee === e.options[s.value].key)), [n, r] = ht(), { count: s, ...i } = na(0, {
      min: 0,
      max: a.value.length - 1
    }), l = (ee) => {
      r(!1), ee.onClick();
    };
    Ue(n, (ee) => {
      ee || i.reset(0);
    });
    const f = () => {
      n.value = !0;
    }, u = () => {
      n.value = !1;
    }, d = () => {
      if (!n.value) {
        f();
        return;
      }
      if (s.value === a.value.length - 1) {
        i.set(0);
        return;
      }
      i.inc(1);
    }, k = () => {
      if (!n.value) {
        f(), i.set(a.value.length - 1);
        return;
      }
      if (s.value === 0) {
        i.set(a.value.length - 1);
        return;
      }
      i.dec(1);
    }, y = () => {
      if (!n.value) {
        f();
        return;
      }
      l(e.options[s.value]);
    }, b = () => {
      n.value && u();
    }, M = () => {
      n.value && i.set(0);
    }, c = () => {
      n.value && i.set(a.value.length - 1);
    }, p = me([]), h = me("");
    let v = null;
    const H = () => {
      v = setTimeout(() => {
        p.value = [];
      }, pb);
    }, w = (ee, ve) => {
      const q = ve.find((Y) => Y.key === ve[ee].key);
      if (!q)
        return;
      const O = a.value.findIndex((Y) => Y === q.key);
      i.set(O);
    }, _ = (ee) => {
      if (!n.value || !(ee.key.length === 1 && ee.key.match(/[a-z]|[0-9]/i))) return;
      if (v && clearTimeout(v), H(), p.value.push(ee.key), h.value === ee.key) {
        const U = e.options.filter(
          (G) => G.label.toLowerCase().startsWith(h.value.toLowerCase())
        );
        if (U.length === 1 || U.length === 0)
          return;
        const ne = U.find((G) => G.key === o.value);
        if (!ne)
          return;
        const te = U.findIndex((G) => G.key === ne.key);
        if (te === U.length - 1) {
          w(0, U);
          return;
        }
        w(te + 1, U);
      }
      const q = p.value.join("").toLowerCase(), O = e.options.find((U) => U.label.toLowerCase().startsWith(q));
      if (!O) return;
      const Y = a.value.indexOf(O.key);
      i.set(Y), h.value = ee.key;
    }, L = me(), I = me(), F = me(), { floatingStyles: B, middlewareData: K } = Aa(L, I, {
      placement: "bottom-start",
      whileElementsMounted: Da,
      middleware: [
        Ql({ element: F }),
        Br(8),
        Ea(),
        Cn(),
        wn({
          padding: fb
        })
      ]
    });
    return (ee, ve) => Ne((m(), C("div", ub, [
      ye(j(b1), {
        id: `${ee.name}-menu-button-button`,
        ref_key: "reference",
        ref: L,
        type: "button",
        "aria-haspopup": "true",
        "aria-expanded": j(n),
        "aria-controls": `${ee.name}-menu-button-menu`,
        class: "flex focus-within:ring-2 gap-2 items-center ring-blue-600",
        variant: ee.buttonVariant,
        onClick: ve[0] || (ve[0] = () => j(r)()),
        onKeydown: [
          Ae($e(d, ["exact", "prevent"]), ["down"]),
          Ae($e(k, ["exact", "prevent"]), ["up"]),
          Ae($e(b, ["exact", "prevent"]), ["escape"]),
          Ae($e(y, ["exact", "prevent"]), ["enter"]),
          Ae($e(c, ["exact", "prevent"]), ["end"]),
          Ae($e(M, ["exact", "prevent"]), ["home"]),
          $e(_, ["stop"])
        ]
      }, {
        default: ue(() => [
          g("span", cb, _e(ee.buttonText), 1),
          ye(j(ra), {
            "aria-hidden": "true",
            "is-open": j(n)
          }, null, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["id", "aria-expanded", "aria-controls", "variant", "onKeydown"]),
      Ne(g("ul", {
        id: `${ee.name}-menu-button-menu`,
        ref_key: "floating",
        ref: I,
        style: w1([j(B)]),
        role: "menu",
        tabindex: "-1",
        "aria-labelledby": `${ee.name}-menu-button-button`,
        "aria-activedescendant": j(n) ? `option-${a.value[j(s)]}` : void 0,
        class: "absolute bg-white border drop-shadow-lg py-2 rounded-regular w-max z-20"
      }, [
        g("div", {
          ref_key: "floatingArrow",
          ref: F,
          class: "absolute bg-white border border-b-0 border-gray border-r-0 h-3 rotate-45 transform w-3 z-30",
          style: w1({
            left: j(K).arrow?.x != null ? `${j(K).arrow.x}px` : "",
            top: j(K).arrow?.y != null ? `${j(K).arrow.y}px` : "-7px"
          })
        }, null, 4),
        (m(!0), C(ge, null, De(ee.options, (q, O) => (m(), C("li", {
          id: `${ee.name}-option-${q.key}`,
          key: q.key,
          role: "menuitem",
          class: le(["active:bg-primary active:text-white border-y cursor-pointer hover:bg-gray-200 px-5 py-2 text-black text-center", {
            "border-transparent": j(s) !== O,
            "border-gray": j(s) === O
          }]),
          onClick: () => l(q)
        }, _e(q.label), 11, mb))), 128))
      ], 12, db), [
        [L1, j(n)]
      ])
    ])), [
      [j(Ft), () => j(r)(!1)]
    ]);
  }
}), hb = { key: 0 }, vb = { class: "content flex flex-col grow" }, gb = { class: "empty:hidden font-bold" }, yb = { class: "body" }, bb = /* @__PURE__ */ J({
  __name: "Toast",
  props: {
    id: {},
    variant: {},
    timeout: { default: 6e3 },
    size: { default: ln.Full },
    canClose: { type: Boolean },
    withShadow: { type: Boolean }
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    Zl((f) => ({
      "07b0827e": n.value
    }));
    const a = t, o = e;
    a.timeout && setTimeout(() => {
      o("remove", a.id);
    }, a.timeout);
    const n = Q(() => `${a.timeout}ms`), r = Q(() => a.variant === go.Info), s = Q(() => a.variant === go.Error), i = Q(() => a.variant === go.Warning), l = Q(() => a.variant === go.Success);
    return (f, u) => (m(), C("div", {
      class: le(["border border-gray-400 flex items-center mb-4 md:text-base overflow-hidden p-4 pointer-events-auto relative rounded-lg transform-gpu", {
        "drop-shadow-md": f.withShadow,
        "pb-5!": !!f.timeout,
        "md:min-w-[400px] md:max-w-3xl md:min-h-[56px]": f.size === j(ln).Half,
        "bg-green-100": l.value,
        "bg-blue-100": r.value,
        "bg-yellow-100": i.value,
        "bg-red-100": s.value
      }]),
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      "data-test": "toast"
    }, [
      f.timeout ? (m(), C("div", hb, [
        g("div", {
          class: le(["absolute bottom-0 h-1 left-0 origin-left toast__timer w-full", {
            "bg-blue": r.value,
            "bg-green": l.value,
            "bg-yellow": i.value,
            "bg-red": s.value
          }])
        }, null, 2),
        g("div", {
          class: le(["absolute bottom-0 h-1 left-0 opacity-20 w-full", {
            "bg-blue": r.value,
            "bg-green": l.value,
            "bg-yellow": i.value,
            "bg-red": s.value
          }])
        }, null, 2)
      ])) : (m(), C("div", {
        key: 1,
        class: le(["absolute h-full left-0 top-0 w-1", {
          "bg-blue": r.value,
          "bg-green": l.value,
          "bg-yellow": i.value,
          "bg-red": s.value
        }])
      }, null, 2)),
      g("div", {
        class: le(["flex-none pr-4", {
          "text-blue": r.value,
          "text-green": l.value,
          "text-yellow": i.value,
          "text-red": s.value
        }])
      }, [
        ye(Oe, {
          size: j(et).Normal
        }, {
          default: ue(() => [
            r.value ? (m(), he(pu, { key: 0 })) : ae("", !0),
            s.value ? (m(), he(w0, { key: 1 })) : ae("", !0),
            i.value ? (m(), he(w0, { key: 2 })) : ae("", !0),
            l.value ? (m(), he(z6, { key: 3 })) : ae("", !0)
          ]),
          _: 1
        }, 8, ["size"])
      ], 2),
      g("div", vb, [
        g("div", gb, [
          oe(f.$slots, "title", {}, void 0, !0)
        ]),
        g("div", yb, [
          oe(f.$slots, "default", {}, void 0, !0)
        ])
      ]),
      f.canClose ? (m(), C("button", {
        key: 2,
        type: "button",
        class: "button close flex-none pl-4",
        onClick: u[0] || (u[0] = (d) => f.$emit("remove", f.id))
      }, [
        ye(Oe, {
          size: j(et).Normal,
          class: "cursor-pointer"
        }, {
          default: ue(() => [
            ye(n7)
          ]),
          _: 1
        }, 8, ["size"])
      ])) : ae("", !0)
    ], 2));
  }
}), s0 = /* @__PURE__ */ se(bb, [["__scopeId", "data-v-6eca710f"]]), kb = { id: "notification__container" }, Cb = /* @__PURE__ */ J({
  __name: "Container",
  setup(t) {
    const { notifications: e, removeNotification: a } = Ti(), o = Q(() => e.value.filter(
      (n) => n.location === pd.Toaster
    ));
    return (n, r) => (m(), C("div", kb, [
      ye(Rl, { name: "list" }, {
        default: ue(() => [
          (m(!0), C(ge, null, De(o.value, (s) => (m(), he(s0, {
            id: s.id ?? "",
            key: s.id,
            size: j(ln).Half,
            timeout: s.timeout ?? void 0,
            variant: s.variant,
            "can-close": s.canClose,
            "with-shadow": s.withShadow,
            class: "flex-none",
            onRemove: j(a)
          }, f1({
            default: ue(() => [
              qe(" " + _e(s.body), 1)
            ]),
            _: 2
          }, [
            s.title ? {
              name: "title",
              fn: ue(() => [
                qe(_e(s.title), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["id", "size", "timeout", "variant", "can-close", "with-shadow", "onRemove"]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), wb = /* @__PURE__ */ se(Cb, [["__scopeId", "data-v-a63bbf81"]]), _b = ["data-test"], Hb = /* @__PURE__ */ J({
  __name: "LocationContainer",
  props: {
    location: {}
  },
  setup(t) {
    const { notifications: e, removeNotification: a } = Ti(), o = t, n = Q(() => e.value.filter((r) => r.location === o.location));
    return (r, s) => (m(), C("div", {
      "data-test": `notifications ${r.location}`
    }, [
      (m(!0), C(ge, null, De(n.value, (i) => (m(), he(s0, {
        id: i.id ?? "",
        key: i.id,
        size: j(ln).Full,
        timeout: i.timeout,
        variant: i.variant,
        "can-close": i.canClose,
        "with-shadow": i.withShadow,
        class: "flex-none",
        onRemove: j(a)
      }, f1({
        default: ue(() => [
          qe(" " + _e(i.body), 1)
        ]),
        _: 2
      }, [
        i.title ? {
          name: "title",
          fn: ue(() => [
            qe(_e(i.title), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "size", "timeout", "variant", "can-close", "with-shadow", "onRemove"]))), 128))
    ], 8, _b));
  }
}), jb = /* @__PURE__ */ se(Hb, [["__scopeId", "data-v-8db16b2c"]]), T2 = /* @__PURE__ */ J({
  __name: "Notification",
  props: {
    id: {},
    variant: {},
    canClose: { type: Boolean },
    withShadow: { type: Boolean }
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const a = e, o = me(!0), n = () => {
      o.value = !1, a("remove");
    };
    return (r, s) => o.value ? (m(), he(s0, {
      key: 0,
      id: r.id,
      class: "relative",
      variant: r.variant,
      "can-close": r.canClose,
      "with-shadow": r.withShadow,
      timeout: 0,
      "data-test": "notification",
      onRemove: n
    }, {
      title: ue(() => [
        oe(r.$slots, "title")
      ]),
      default: ue(() => [
        oe(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "variant", "can-close", "with-shadow"])) : ae("", !0);
  }
});
T2.Container = wb;
T2.LocationContainer = jb;
var Lb = /(%?)(%([sdijo]))/g;
function xb(t, e) {
  switch (e) {
    case "s":
      return t;
    case "d":
    case "i":
      return Number(t);
    case "j":
      return JSON.stringify(t);
    case "o": {
      if (typeof t == "string")
        return t;
      const a = JSON.stringify(t);
      return a === "{}" || a === "[]" || /^\[object .+?\]$/.test(a) ? t : a;
    }
  }
}
function i0(t, ...e) {
  if (e.length === 0)
    return t;
  let a = 0, o = t.replace(
    Lb,
    (n, r, s, i) => {
      const l = e[a], f = xb(l, i);
      return r ? n : (a++, f);
    }
  );
  return a < e.length && (o += ` ${e.slice(a).join(" ")}`), o = o.replace(/%{2,2}/g, "%"), o;
}
var $b = 2;
function Mb(t) {
  if (!t.stack)
    return;
  const e = t.stack.split(`
`);
  e.splice(1, $b), t.stack = e.join(`
`);
}
var Vb = class extends Error {
  constructor(t, ...e) {
    super(t), this.message = t, this.name = "Invariant Violation", this.message = i0(t, ...e), Mb(this);
  }
}, l0 = (t, e, ...a) => {
  if (!t)
    throw new Vb(e, ...a);
};
l0.as = (t, e, a, ...o) => {
  if (!e) {
    const n = o.length === 0 ? a : i0(a, ...o);
    let r;
    try {
      r = Reflect.construct(t, [
        n
      ]);
    } catch {
      r = t(n);
    }
    throw r;
  }
};
const Sb = "[MSW]";
function u0(t, ...e) {
  const a = i0(t, ...e);
  return `${Sb} ${a}`;
}
function Ab(t, ...e) {
  console.warn(u0(t, ...e));
}
function Eb(t, ...e) {
  console.error(u0(t, ...e));
}
const Ar = {
  formatMessage: u0,
  warn: Ab,
  error: Eb
};
function Db() {
  l0(
    typeof URL < "u",
    Ar.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
const Pb = /[\/\\]msw[\/\\]src[\/\\](.+)/, zb = /(node_modules)?[\/\\]lib[\/\\](core|browser|node|native|iife)[\/\\]|^[^\/\\]*$/;
function Tb(t) {
  const e = t.stack;
  if (!e)
    return;
  const o = e.split(`
`).slice(1).find((r) => !(Pb.test(r) || zb.test(r)));
  return o ? o.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
}
function Ob(t) {
  return t ? Reflect.has(t, Symbol.iterator) || Reflect.has(t, Symbol.asyncIterator) : !1;
}
class mn {
  static cache = /* @__PURE__ */ new WeakMap();
  __kind;
  info;
  /**
   * Indicates whether this request handler has been used
   * (its resolver has successfully executed).
   */
  isUsed;
  resolver;
  resolverIterator;
  resolverIteratorResult;
  options;
  constructor(e) {
    this.resolver = e.resolver, this.options = e.options;
    const a = Tb(new Error());
    this.info = {
      ...e.info,
      callFrame: a
    }, this.isUsed = !1, this.__kind = "RequestHandler";
  }
  /**
   * Parse the intercepted request to extract additional information from it.
   * Parsed result is then exposed to other methods of this request handler.
   */
  async parse(e) {
    return {};
  }
  /**
   * Test if this handler matches the given request.
   *
   * This method is not used internally but is exposed
   * as a convenience method for consumers writing custom
   * handlers.
   */
  async test(e) {
    const a = await this.parse({
      request: e.request,
      resolutionContext: e.resolutionContext
    });
    return this.predicate({
      request: e.request,
      parsedResult: a,
      resolutionContext: e.resolutionContext
    });
  }
  extendResolverArgs(e) {
    return {};
  }
  // Clone the request instance before it's passed to the handler phases
  // and the response resolver so we can always read it for logging.
  // We only clone it once per request to avoid unnecessary overhead.
  cloneRequestOrGetFromCache(e) {
    const a = mn.cache.get(e);
    if (typeof a < "u")
      return a;
    const o = e.clone();
    return mn.cache.set(e, o), o;
  }
  /**
   * Execute this request handler and produce a mocked response
   * using the given resolver function.
   */
  async run(e) {
    if (this.isUsed && this.options?.once)
      return null;
    const a = this.cloneRequestOrGetFromCache(e.request), o = await this.parse({
      request: e.request,
      resolutionContext: e.resolutionContext
    });
    if (!this.predicate({
      request: e.request,
      parsedResult: o,
      resolutionContext: e.resolutionContext
    }) || this.isUsed && this.options?.once)
      return null;
    this.isUsed = !0;
    const r = this.wrapResolver(this.resolver), s = this.extendResolverArgs({
      request: e.request,
      parsedResult: o
    }), l = await r({
      ...s,
      requestId: e.requestId,
      request: e.request
    }).catch((u) => {
      if (u instanceof Response)
        return u;
      throw u;
    });
    return this.createExecutionResult({
      // Pass the cloned request to the result so that logging
      // and other consumers could read its body once more.
      request: a,
      requestId: e.requestId,
      response: l,
      parsedResult: o
    });
  }
  wrapResolver(e) {
    return async (a) => {
      if (!this.resolverIterator) {
        const s = await e(a);
        if (!Ob(s))
          return s;
        this.resolverIterator = Symbol.iterator in s ? s[Symbol.iterator]() : s[Symbol.asyncIterator]();
      }
      this.isUsed = !1;
      const { done: o, value: n } = await this.resolverIterator.next(), r = await n;
      return r && (this.resolverIteratorResult = r.clone()), o ? (this.isUsed = !0, this.resolverIteratorResult?.clone()) : r;
    };
  }
  createExecutionResult(e) {
    return {
      handler: this,
      request: e.request,
      requestId: e.requestId,
      response: e.response,
      parsedResult: e.parsedResult
    };
  }
}
function Fb(t, e) {
  return t.toLowerCase() === e.toLowerCase();
}
function Bb(t) {
  return t < 300 ? "#69AB32" : t < 400 ? "#F0BB4B" : "#E95F5D";
}
function Ib(t) {
  const e = /* @__PURE__ */ new Date();
  return `${e.getHours().toString().padStart(2, "0")}:${e.getMinutes().toString().padStart(2, "0")}:${e.getSeconds().toString().padStart(2, "0")}`;
}
async function Zb(t) {
  const a = await t.clone().text();
  return {
    url: new URL(t.url),
    method: t.method,
    headers: Object.fromEntries(t.headers.entries()),
    body: a
  };
}
var Rb = Object.create, O2 = Object.defineProperty, Nb = Object.getOwnPropertyDescriptor, F2 = Object.getOwnPropertyNames, qb = Object.getPrototypeOf, Ub = Object.prototype.hasOwnProperty, B2 = (t, e) => function() {
  return e || (0, t[F2(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Yb = (t, e, a, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of F2(e))
      !Ub.call(t, n) && n !== a && O2(t, n, { get: () => e[n], enumerable: !(o = Nb(e, n)) || o.enumerable });
  return t;
}, Wb = (t, e, a) => (a = t != null ? Rb(qb(t)) : {}, Yb(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  O2(a, "default", { value: t, enumerable: !0 }),
  t
)), Kb = B2({
  "node_modules/statuses/codes.json"(t, e) {
    e.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      103: "Early Hints",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a Teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Too Early",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }
}), Gb = B2({
  "node_modules/statuses/index.js"(t, e) {
    var a = Kb();
    e.exports = i, i.message = a, i.code = o(a), i.codes = n(a), i.redirect = {
      300: !0,
      301: !0,
      302: !0,
      303: !0,
      305: !0,
      307: !0,
      308: !0
    }, i.empty = {
      204: !0,
      205: !0,
      304: !0
    }, i.retry = {
      502: !0,
      503: !0,
      504: !0
    };
    function o(l) {
      var f = {};
      return Object.keys(l).forEach(function(d) {
        var k = l[d], y = Number(d);
        f[k.toLowerCase()] = y;
      }), f;
    }
    function n(l) {
      return Object.keys(l).map(function(u) {
        return Number(u);
      });
    }
    function r(l) {
      var f = l.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(i.code, f))
        throw new Error('invalid status message: "' + l + '"');
      return i.code[f];
    }
    function s(l) {
      if (!Object.prototype.hasOwnProperty.call(i.message, l))
        throw new Error("invalid status code: " + l);
      return i.message[l];
    }
    function i(l) {
      if (typeof l == "number")
        return s(l);
      if (typeof l != "string")
        throw new TypeError("code must be a number or string");
      var f = parseInt(l, 10);
      return isNaN(f) ? r(l) : s(f);
    }
  }
}), Xb = Wb(Gb()), I2 = Xb.default;
/*! Bundled license information:

statuses/index.js:
  (*!
   * statuses
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
const { message: Qb } = I2;
async function Jb(t) {
  const e = t.clone(), a = await e.text(), o = e.status || 200, n = e.statusText || Qb[o] || "OK";
  return {
    status: o,
    statusText: n,
    headers: Object.fromEntries(e.headers.entries()),
    body: a
  };
}
function ek(t) {
  for (var e = [], a = 0; a < t.length; ) {
    var o = t[a];
    if (o === "*" || o === "+" || o === "?") {
      e.push({ type: "MODIFIER", index: a, value: t[a++] });
      continue;
    }
    if (o === "\\") {
      e.push({ type: "ESCAPED_CHAR", index: a++, value: t[a++] });
      continue;
    }
    if (o === "{") {
      e.push({ type: "OPEN", index: a, value: t[a++] });
      continue;
    }
    if (o === "}") {
      e.push({ type: "CLOSE", index: a, value: t[a++] });
      continue;
    }
    if (o === ":") {
      for (var n = "", r = a + 1; r < t.length; ) {
        var s = t.charCodeAt(r);
        if (
          // `0-9`
          s >= 48 && s <= 57 || // `A-Z`
          s >= 65 && s <= 90 || // `a-z`
          s >= 97 && s <= 122 || // `_`
          s === 95
        ) {
          n += t[r++];
          continue;
        }
        break;
      }
      if (!n)
        throw new TypeError("Missing parameter name at ".concat(a));
      e.push({ type: "NAME", index: a, value: n }), a = r;
      continue;
    }
    if (o === "(") {
      var i = 1, l = "", r = a + 1;
      if (t[r] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(r));
      for (; r < t.length; ) {
        if (t[r] === "\\") {
          l += t[r++] + t[r++];
          continue;
        }
        if (t[r] === ")") {
          if (i--, i === 0) {
            r++;
            break;
          }
        } else if (t[r] === "(" && (i++, t[r + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(r));
        l += t[r++];
      }
      if (i)
        throw new TypeError("Unbalanced pattern at ".concat(a));
      if (!l)
        throw new TypeError("Missing pattern at ".concat(a));
      e.push({ type: "PATTERN", index: a, value: l }), a = r;
      continue;
    }
    e.push({ type: "CHAR", index: a, value: t[a++] });
  }
  return e.push({ type: "END", index: a, value: "" }), e;
}
function tk(t, e) {
  e === void 0 && (e = {});
  for (var a = ek(t), o = e.prefixes, n = o === void 0 ? "./" : o, r = e.delimiter, s = r === void 0 ? "/#?" : r, i = [], l = 0, f = 0, u = "", d = function(F) {
    if (f < a.length && a[f].type === F)
      return a[f++].value;
  }, k = function(F) {
    var B = d(F);
    if (B !== void 0)
      return B;
    var K = a[f], ee = K.type, ve = K.index;
    throw new TypeError("Unexpected ".concat(ee, " at ").concat(ve, ", expected ").concat(F));
  }, y = function() {
    for (var F = "", B; B = d("CHAR") || d("ESCAPED_CHAR"); )
      F += B;
    return F;
  }, b = function(F) {
    for (var B = 0, K = s; B < K.length; B++) {
      var ee = K[B];
      if (F.indexOf(ee) > -1)
        return !0;
    }
    return !1;
  }, M = function(F) {
    var B = i[i.length - 1], K = F || (B && typeof B == "string" ? B : "");
    if (B && !K)
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(B.name, '"'));
    return !K || b(K) ? "[^".concat(Et(s), "]+?") : "(?:(?!".concat(Et(K), ")[^").concat(Et(s), "])+?");
  }; f < a.length; ) {
    var c = d("CHAR"), p = d("NAME"), h = d("PATTERN");
    if (p || h) {
      var v = c || "";
      n.indexOf(v) === -1 && (u += v, v = ""), u && (i.push(u), u = ""), i.push({
        name: p || l++,
        prefix: v,
        suffix: "",
        pattern: h || M(v),
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    var H = c || d("ESCAPED_CHAR");
    if (H) {
      u += H;
      continue;
    }
    u && (i.push(u), u = "");
    var w = d("OPEN");
    if (w) {
      var v = y(), _ = d("NAME") || "", L = d("PATTERN") || "", I = y();
      k("CLOSE"), i.push({
        name: _ || (L ? l++ : ""),
        pattern: _ && !L ? M(v) : L,
        prefix: v,
        suffix: I,
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    k("END");
  }
  return i;
}
function ak(t, e) {
  var a = [], o = R2(t, a, e);
  return ok(o, a, e);
}
function ok(t, e, a) {
  a === void 0 && (a = {});
  var o = a.decode, n = o === void 0 ? function(r) {
    return r;
  } : o;
  return function(r) {
    var s = t.exec(r);
    if (!s)
      return !1;
    for (var i = s[0], l = s.index, f = /* @__PURE__ */ Object.create(null), u = function(k) {
      if (s[k] === void 0)
        return "continue";
      var y = e[k - 1];
      y.modifier === "*" || y.modifier === "+" ? f[y.name] = s[k].split(y.prefix + y.suffix).map(function(b) {
        return n(b, y);
      }) : f[y.name] = n(s[k], y);
    }, d = 1; d < s.length; d++)
      u(d);
    return { path: i, index: l, params: f };
  };
}
function Et(t) {
  return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function Z2(t) {
  return t && t.sensitive ? "" : "i";
}
function nk(t, e) {
  if (!e)
    return t;
  for (var a = /\((?:\?<(.*?)>)?(?!\?)/g, o = 0, n = a.exec(t.source); n; )
    e.push({
      // Use parenthesized substring match if available, index otherwise
      name: n[1] || o++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), n = a.exec(t.source);
  return t;
}
function rk(t, e, a) {
  var o = t.map(function(n) {
    return R2(n, e, a).source;
  });
  return new RegExp("(?:".concat(o.join("|"), ")"), Z2(a));
}
function sk(t, e, a) {
  return ik(tk(t, a), e, a);
}
function ik(t, e, a) {
  a === void 0 && (a = {});
  for (var o = a.strict, n = o === void 0 ? !1 : o, r = a.start, s = r === void 0 ? !0 : r, i = a.end, l = i === void 0 ? !0 : i, f = a.encode, u = f === void 0 ? function(B) {
    return B;
  } : f, d = a.delimiter, k = d === void 0 ? "/#?" : d, y = a.endsWith, b = y === void 0 ? "" : y, M = "[".concat(Et(b), "]|$"), c = "[".concat(Et(k), "]"), p = s ? "^" : "", h = 0, v = t; h < v.length; h++) {
    var H = v[h];
    if (typeof H == "string")
      p += Et(u(H));
    else {
      var w = Et(u(H.prefix)), _ = Et(u(H.suffix));
      if (H.pattern)
        if (e && e.push(H), w || _)
          if (H.modifier === "+" || H.modifier === "*") {
            var L = H.modifier === "*" ? "?" : "";
            p += "(?:".concat(w, "((?:").concat(H.pattern, ")(?:").concat(_).concat(w, "(?:").concat(H.pattern, "))*)").concat(_, ")").concat(L);
          } else
            p += "(?:".concat(w, "(").concat(H.pattern, ")").concat(_, ")").concat(H.modifier);
        else {
          if (H.modifier === "+" || H.modifier === "*")
            throw new TypeError('Can not repeat "'.concat(H.name, '" without a prefix and suffix'));
          p += "(".concat(H.pattern, ")").concat(H.modifier);
        }
      else
        p += "(?:".concat(w).concat(_, ")").concat(H.modifier);
    }
  }
  if (l)
    n || (p += "".concat(c, "?")), p += a.endsWith ? "(?=".concat(M, ")") : "$";
  else {
    var I = t[t.length - 1], F = typeof I == "string" ? c.indexOf(I[I.length - 1]) > -1 : I === void 0;
    n || (p += "(?:".concat(c, "(?=").concat(M, "))?")), F || (p += "(?=".concat(c, "|").concat(M, ")"));
  }
  return new RegExp(p, Z2(a));
}
function R2(t, e, a) {
  return t instanceof RegExp ? nk(t, e) : Array.isArray(t) ? rk(t, e, a) : sk(t, e, a);
}
new TextEncoder();
var ga = class extends Response {
  static isConfigurableStatusCode(t) {
    return t >= 200 && t <= 599;
  }
  static isRedirectResponse(t) {
    return ga.STATUS_CODES_WITH_REDIRECT.includes(t);
  }
  /**
   * Returns a boolean indicating whether the given response status
   * code represents a response that can have a body.
   */
  static isResponseWithBody(t) {
    return !ga.STATUS_CODES_WITHOUT_BODY.includes(t);
  }
  static setUrl(t, e) {
    t && e.url == "" && Object.defineProperty(e, "url", {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !1
    });
  }
  constructor(t, e = {}) {
    var a;
    const o = (a = e.status) != null ? a : 200, n = ga.isConfigurableStatusCode(o) ? o : 200, r = ga.isResponseWithBody(o) ? t : null;
    if (super(r, {
      ...e,
      status: n
    }), o !== n) {
      const s = Object.getOwnPropertySymbols(this).find(
        (i) => i.description === "state"
      );
      if (s) {
        const i = Reflect.get(this, s);
        Reflect.set(i, "status", o);
      } else
        Object.defineProperty(this, "status", {
          value: o,
          enumerable: !0,
          configurable: !0,
          writable: !1
        });
    }
    ga.setUrl(e.url, this);
  }
}, N2 = ga;
N2.STATUS_CODES_WITHOUT_BODY = [101, 103, 204, 205, 304];
N2.STATUS_CODES_WITH_REDIRECT = [301, 302, 303, 307, 308];
function q2() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const t = process.type;
    return t === "renderer" || t === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var lk = Object.defineProperty, uk = (t, e) => {
  for (var a in e)
    lk(t, a, { get: e[a], enumerable: !0 });
}, ck = {};
uk(ck, {
  blue: () => mk,
  gray: () => pk,
  green: () => hk,
  red: () => fk,
  yellow: () => dk
});
function dk(t) {
  return `\x1B[33m${t}\x1B[0m`;
}
function mk(t) {
  return `\x1B[34m${t}\x1B[0m`;
}
function pk(t) {
  return `\x1B[90m${t}\x1B[0m`;
}
function fk(t) {
  return `\x1B[31m${t}\x1B[0m`;
}
function hk(t) {
  return `\x1B[32m${t}\x1B[0m`;
}
q2();
function vk(t, e = !0) {
  return [e && t.origin, t.pathname].filter(Boolean).join("");
}
const gk = /[\?|#].*$/g;
function yk(t) {
  return new URL(`/${t}`, "http://localhost").searchParams;
}
function U2(t) {
  return t.endsWith("?") ? t : t.replace(gk, "");
}
function bk(t) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
}
function kk(t, e) {
  if (bk(t) || t.startsWith("*"))
    return t;
  const a = e || typeof document < "u" && document.baseURI;
  return a ? (
    // Encode and decode the path to preserve escaped characters.
    decodeURI(new URL(encodeURI(t), a).href)
  ) : t;
}
function Ck(t, e) {
  if (t instanceof RegExp)
    return t;
  const a = kk(t, e);
  return U2(a);
}
function wk(t) {
  return t.replace(
    /([:a-zA-Z_-]*)(\*{1,2})+/g,
    (e, a, o) => {
      const n = "(.*)";
      return a ? a.startsWith(":") ? `${a}${o}` : `${a}${n}` : n;
    }
  ).replace(/([^\/])(:)(?=\d+)/, "$1\\$2").replace(/^([^\/]+)(:)(?=\/\/)/, "$1\\$2");
}
function _k(t, e, a) {
  const o = Ck(e, a), n = typeof o == "string" ? wk(o) : o, r = vk(t), s = ak(n, { decode: decodeURIComponent })(r), i = s && s.params || {};
  return {
    matches: s !== !1,
    params: i
  };
}
function Hk(t) {
  if (typeof location > "u")
    return t.toString();
  const e = t instanceof URL ? t : new URL(t);
  return e.origin === location.origin ? e.pathname : e.origin + e.pathname;
}
var jk = Object.create, Y2 = Object.defineProperty, Lk = Object.getOwnPropertyDescriptor, W2 = Object.getOwnPropertyNames, xk = Object.getPrototypeOf, $k = Object.prototype.hasOwnProperty, Mk = (t, e) => function() {
  return e || (0, t[W2(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Vk = (t, e, a, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of W2(e))
      !$k.call(t, n) && n !== a && Y2(t, n, { get: () => e[n], enumerable: !(o = Lk(e, n)) || o.enumerable });
  return t;
}, Sk = (t, e, a) => (a = t != null ? jk(xk(t)) : {}, Vk(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Y2(a, "default", { value: t, enumerable: !0 }),
  t
)), Ak = Mk({
  "node_modules/cookie/index.js"(t) {
    t.parse = i, t.serialize = u;
    var e = Object.prototype.toString, a = Object.prototype.hasOwnProperty, o = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, s = /^[\u0020-\u003A\u003D-\u007E]*$/;
    function i(b, M) {
      if (typeof b != "string")
        throw new TypeError("argument str must be a string");
      var c = {}, p = b.length;
      if (p < 2) return c;
      var h = M && M.decode || d, v = 0, H = 0, w = 0;
      do {
        if (H = b.indexOf("=", v), H === -1) break;
        if (w = b.indexOf(";", v), w === -1)
          w = p;
        else if (H > w) {
          v = b.lastIndexOf(";", H - 1) + 1;
          continue;
        }
        var _ = l(b, v, H), L = f(b, H, _), I = b.slice(_, L);
        if (!a.call(c, I)) {
          var F = l(b, H + 1, w), B = f(b, w, F);
          b.charCodeAt(F) === 34 && b.charCodeAt(B - 1) === 34 && (F++, B--);
          var K = b.slice(F, B);
          c[I] = y(K, h);
        }
        v = w + 1;
      } while (v < p);
      return c;
    }
    function l(b, M, c) {
      do {
        var p = b.charCodeAt(M);
        if (p !== 32 && p !== 9) return M;
      } while (++M < c);
      return c;
    }
    function f(b, M, c) {
      for (; M > c; ) {
        var p = b.charCodeAt(--M);
        if (p !== 32 && p !== 9) return M + 1;
      }
      return c;
    }
    function u(b, M, c) {
      var p = c && c.encode || encodeURIComponent;
      if (typeof p != "function")
        throw new TypeError("option encode is invalid");
      if (!o.test(b))
        throw new TypeError("argument name is invalid");
      var h = p(M);
      if (!n.test(h))
        throw new TypeError("argument val is invalid");
      var v = b + "=" + h;
      if (!c) return v;
      if (c.maxAge != null) {
        var H = Math.floor(c.maxAge);
        if (!isFinite(H))
          throw new TypeError("option maxAge is invalid");
        v += "; Max-Age=" + H;
      }
      if (c.domain) {
        if (!r.test(c.domain))
          throw new TypeError("option domain is invalid");
        v += "; Domain=" + c.domain;
      }
      if (c.path) {
        if (!s.test(c.path))
          throw new TypeError("option path is invalid");
        v += "; Path=" + c.path;
      }
      if (c.expires) {
        var w = c.expires;
        if (!k(w) || isNaN(w.valueOf()))
          throw new TypeError("option expires is invalid");
        v += "; Expires=" + w.toUTCString();
      }
      if (c.httpOnly && (v += "; HttpOnly"), c.secure && (v += "; Secure"), c.partitioned && (v += "; Partitioned"), c.priority) {
        var _ = typeof c.priority == "string" ? c.priority.toLowerCase() : c.priority;
        switch (_) {
          case "low":
            v += "; Priority=Low";
            break;
          case "medium":
            v += "; Priority=Medium";
            break;
          case "high":
            v += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (c.sameSite) {
        var L = typeof c.sameSite == "string" ? c.sameSite.toLowerCase() : c.sameSite;
        switch (L) {
          case !0:
            v += "; SameSite=Strict";
            break;
          case "lax":
            v += "; SameSite=Lax";
            break;
          case "strict":
            v += "; SameSite=Strict";
            break;
          case "none":
            v += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return v;
    }
    function d(b) {
      return b.indexOf("%") !== -1 ? decodeURIComponent(b) : b;
    }
    function k(b) {
      return e.call(b) === "[object Date]";
    }
    function y(b, M) {
      try {
        return M(b);
      } catch {
        return b;
      }
    }
  }
}), Ek = Sk(Ak()), K2 = Ek.default;
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
var Dk = Object.create, G2 = Object.defineProperty, Pk = Object.getOwnPropertyDescriptor, X2 = Object.getOwnPropertyNames, zk = Object.getPrototypeOf, Tk = Object.prototype.hasOwnProperty, Ok = /* @__PURE__ */ ((t) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(t, {
  get: (e, a) => (typeof require < "u" ? require : e)[a]
}) : t)(function(t) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + t + '" is not supported');
}), A1 = (t, e) => function() {
  return e || (0, t[X2(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Fk = (t, e, a, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of X2(e))
      !Tk.call(t, n) && n !== a && G2(t, n, { get: () => e[n], enumerable: !(o = Pk(e, n)) || o.enumerable });
  return t;
}, Bk = (t, e, a) => (a = t != null ? Dk(zk(t)) : {}, Fk(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  G2(a, "default", { value: t, enumerable: !0 }),
  t
)), Q2 = A1({
  "node_modules/punycode/punycode.js"(t, e) {
    var a = 2147483647, o = 36, n = 1, r = 26, s = 38, i = 700, l = 72, f = 128, u = "-", d = /^xn--/, k = /[^\0-\x7F]/, y = /[\x2E\u3002\uFF0E\uFF61]/g, b = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, M = o - n, c = Math.floor, p = String.fromCharCode;
    function h(O) {
      throw new RangeError(b[O]);
    }
    function v(O, Y) {
      const U = [];
      let ne = O.length;
      for (; ne--; )
        U[ne] = Y(O[ne]);
      return U;
    }
    function H(O, Y) {
      const U = O.split("@");
      let ne = "";
      U.length > 1 && (ne = U[0] + "@", O = U[1]), O = O.replace(y, ".");
      const te = O.split("."), G = v(te, Y).join(".");
      return ne + G;
    }
    function w(O) {
      const Y = [];
      let U = 0;
      const ne = O.length;
      for (; U < ne; ) {
        const te = O.charCodeAt(U++);
        if (te >= 55296 && te <= 56319 && U < ne) {
          const G = O.charCodeAt(U++);
          (G & 64512) == 56320 ? Y.push(((te & 1023) << 10) + (G & 1023) + 65536) : (Y.push(te), U--);
        } else
          Y.push(te);
      }
      return Y;
    }
    var _ = (O) => String.fromCodePoint(...O), L = function(O) {
      return O >= 48 && O < 58 ? 26 + (O - 48) : O >= 65 && O < 91 ? O - 65 : O >= 97 && O < 123 ? O - 97 : o;
    }, I = function(O, Y) {
      return O + 22 + 75 * (O < 26) - ((Y != 0) << 5);
    }, F = function(O, Y, U) {
      let ne = 0;
      for (O = U ? c(O / i) : O >> 1, O += c(O / Y); O > M * r >> 1; ne += o)
        O = c(O / M);
      return c(ne + (M + 1) * O / (O + s));
    }, B = function(O) {
      const Y = [], U = O.length;
      let ne = 0, te = f, G = l, T = O.lastIndexOf(u);
      T < 0 && (T = 0);
      for (let Z = 0; Z < T; ++Z)
        O.charCodeAt(Z) >= 128 && h("not-basic"), Y.push(O.charCodeAt(Z));
      for (let Z = T > 0 ? T + 1 : 0; Z < U; ) {
        const D = ne;
        for (let A = 1, N = o; ; N += o) {
          Z >= U && h("invalid-input");
          const $ = L(O.charCodeAt(Z++));
          $ >= o && h("invalid-input"), $ > c((a - ne) / A) && h("overflow"), ne += $ * A;
          const W = N <= G ? n : N >= G + r ? r : N - G;
          if ($ < W)
            break;
          const fe = o - W;
          A > c(a / fe) && h("overflow"), A *= fe;
        }
        const x = Y.length + 1;
        G = F(ne - D, x, D == 0), c(ne / x) > a - te && h("overflow"), te += c(ne / x), ne %= x, Y.splice(ne++, 0, te);
      }
      return String.fromCodePoint(...Y);
    }, K = function(O) {
      const Y = [];
      O = w(O);
      const U = O.length;
      let ne = f, te = 0, G = l;
      for (const D of O)
        D < 128 && Y.push(p(D));
      const T = Y.length;
      let Z = T;
      for (T && Y.push(u); Z < U; ) {
        let D = a;
        for (const A of O)
          A >= ne && A < D && (D = A);
        const x = Z + 1;
        D - ne > c((a - te) / x) && h("overflow"), te += (D - ne) * x, ne = D;
        for (const A of O)
          if (A < ne && ++te > a && h("overflow"), A === ne) {
            let N = te;
            for (let $ = o; ; $ += o) {
              const W = $ <= G ? n : $ >= G + r ? r : $ - G;
              if (N < W)
                break;
              const fe = N - W, Le = o - W;
              Y.push(
                p(I(W + fe % Le, 0))
              ), N = c(fe / Le);
            }
            Y.push(p(I(N, 0))), G = F(te, x, Z === T), te = 0, ++Z;
          }
        ++te, ++ne;
      }
      return Y.join("");
    }, ee = function(O) {
      return H(O, function(Y) {
        return d.test(Y) ? B(Y.slice(4).toLowerCase()) : Y;
      });
    }, ve = function(O) {
      return H(O, function(Y) {
        return k.test(Y) ? "xn--" + K(Y) : Y;
      });
    }, q = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      version: "2.3.1",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      ucs2: {
        decode: w,
        encode: _
      },
      decode: B,
      encode: K,
      toASCII: ve,
      toUnicode: ee
    };
    e.exports = q;
  }
}), Ik = A1({
  "node_modules/requires-port/index.js"(t, e) {
    e.exports = function(o, n) {
      if (n = n.split(":")[0], o = +o, !o) return !1;
      switch (n) {
        case "http":
        case "ws":
          return o !== 80;
        case "https":
        case "wss":
          return o !== 443;
        case "ftp":
          return o !== 21;
        case "gopher":
          return o !== 70;
        case "file":
          return !1;
      }
      return o !== 0;
    };
  }
}), Zk = A1({
  "node_modules/querystringify/index.js"(t) {
    var e = Object.prototype.hasOwnProperty, a;
    function o(i) {
      try {
        return decodeURIComponent(i.replace(/\+/g, " "));
      } catch {
        return null;
      }
    }
    function n(i) {
      try {
        return encodeURIComponent(i);
      } catch {
        return null;
      }
    }
    function r(i) {
      for (var l = /([^=?#&]+)=?([^&]*)/g, f = {}, u; u = l.exec(i); ) {
        var d = o(u[1]), k = o(u[2]);
        d === null || k === null || d in f || (f[d] = k);
      }
      return f;
    }
    function s(i, l) {
      l = l || "";
      var f = [], u, d;
      typeof l != "string" && (l = "?");
      for (d in i)
        if (e.call(i, d)) {
          if (u = i[d], !u && (u === null || u === a || isNaN(u)) && (u = ""), d = n(d), u = n(u), d === null || u === null) continue;
          f.push(d + "=" + u);
        }
      return f.length ? l + f.join("&") : "";
    }
    t.stringify = s, t.parse = r;
  }
}), Rk = A1({
  "node_modules/url-parse/index.js"(t, e) {
    var a = Ik(), o = Zk(), n = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, r = /[\n\r\t]/g, s = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, i = /:\d+$/, l = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, f = /^[a-zA-Z]:/;
    function u(H) {
      return (H || "").toString().replace(n, "");
    }
    var d = [
      ["#", "hash"],
      // Extract from the back.
      ["?", "query"],
      // Extract from the back.
      function(w, _) {
        return b(_.protocol) ? w.replace(/\\/g, "/") : w;
      },
      ["/", "pathname"],
      // Extract from the back.
      ["@", "auth", 1],
      // Extract from the front.
      [NaN, "host", void 0, 1, 1],
      // Set left over value.
      [/:(\d*)$/, "port", void 0, 1],
      // RegExp the back.
      [NaN, "hostname", void 0, 1, 1]
      // Set left over.
    ], k = { hash: 1, query: 1 };
    function y(H) {
      var w;
      typeof window < "u" ? w = window : typeof global < "u" ? w = global : typeof self < "u" ? w = self : w = {};
      var _ = w.location || {};
      H = H || _;
      var L = {}, I = typeof H, F;
      if (H.protocol === "blob:")
        L = new p(unescape(H.pathname), {});
      else if (I === "string") {
        L = new p(H, {});
        for (F in k) delete L[F];
      } else if (I === "object") {
        for (F in H)
          F in k || (L[F] = H[F]);
        L.slashes === void 0 && (L.slashes = s.test(H.href));
      }
      return L;
    }
    function b(H) {
      return H === "file:" || H === "ftp:" || H === "http:" || H === "https:" || H === "ws:" || H === "wss:";
    }
    function M(H, w) {
      H = u(H), H = H.replace(r, ""), w = w || {};
      var _ = l.exec(H), L = _[1] ? _[1].toLowerCase() : "", I = !!_[2], F = !!_[3], B = 0, K;
      return I ? F ? (K = _[2] + _[3] + _[4], B = _[2].length + _[3].length) : (K = _[2] + _[4], B = _[2].length) : F ? (K = _[3] + _[4], B = _[3].length) : K = _[4], L === "file:" ? B >= 2 && (K = K.slice(2)) : b(L) ? K = _[4] : L ? I && (K = K.slice(2)) : B >= 2 && b(w.protocol) && (K = _[4]), {
        protocol: L,
        slashes: I || b(L),
        slashesCount: B,
        rest: K
      };
    }
    function c(H, w) {
      if (H === "") return w;
      for (var _ = (w || "/").split("/").slice(0, -1).concat(H.split("/")), L = _.length, I = _[L - 1], F = !1, B = 0; L--; )
        _[L] === "." ? _.splice(L, 1) : _[L] === ".." ? (_.splice(L, 1), B++) : B && (L === 0 && (F = !0), _.splice(L, 1), B--);
      return F && _.unshift(""), (I === "." || I === "..") && _.push(""), _.join("/");
    }
    function p(H, w, _) {
      if (H = u(H), H = H.replace(r, ""), !(this instanceof p))
        return new p(H, w, _);
      var L, I, F, B, K, ee, ve = d.slice(), q = typeof w, O = this, Y = 0;
      for (q !== "object" && q !== "string" && (_ = w, w = null), _ && typeof _ != "function" && (_ = o.parse), w = y(w), I = M(H || "", w), L = !I.protocol && !I.slashes, O.slashes = I.slashes || L && w.slashes, O.protocol = I.protocol || w.protocol || "", H = I.rest, (I.protocol === "file:" && (I.slashesCount !== 2 || f.test(H)) || !I.slashes && (I.protocol || I.slashesCount < 2 || !b(O.protocol))) && (ve[3] = [/(.*)/, "pathname"]); Y < ve.length; Y++) {
        if (B = ve[Y], typeof B == "function") {
          H = B(H, O);
          continue;
        }
        F = B[0], ee = B[1], F !== F ? O[ee] = H : typeof F == "string" ? (K = F === "@" ? H.lastIndexOf(F) : H.indexOf(F), ~K && (typeof B[2] == "number" ? (O[ee] = H.slice(0, K), H = H.slice(K + B[2])) : (O[ee] = H.slice(K), H = H.slice(0, K)))) : (K = F.exec(H)) && (O[ee] = K[1], H = H.slice(0, K.index)), O[ee] = O[ee] || L && B[3] && w[ee] || "", B[4] && (O[ee] = O[ee].toLowerCase());
      }
      _ && (O.query = _(O.query)), L && w.slashes && O.pathname.charAt(0) !== "/" && (O.pathname !== "" || w.pathname !== "") && (O.pathname = c(O.pathname, w.pathname)), O.pathname.charAt(0) !== "/" && b(O.protocol) && (O.pathname = "/" + O.pathname), a(O.port, O.protocol) || (O.host = O.hostname, O.port = ""), O.username = O.password = "", O.auth && (K = O.auth.indexOf(":"), ~K ? (O.username = O.auth.slice(0, K), O.username = encodeURIComponent(decodeURIComponent(O.username)), O.password = O.auth.slice(K + 1), O.password = encodeURIComponent(decodeURIComponent(O.password))) : O.username = encodeURIComponent(decodeURIComponent(O.auth)), O.auth = O.password ? O.username + ":" + O.password : O.username), O.origin = O.protocol !== "file:" && b(O.protocol) && O.host ? O.protocol + "//" + O.host : "null", O.href = O.toString();
    }
    function h(H, w, _) {
      var L = this;
      switch (H) {
        case "query":
          typeof w == "string" && w.length && (w = (_ || o.parse)(w)), L[H] = w;
          break;
        case "port":
          L[H] = w, a(w, L.protocol) ? w && (L.host = L.hostname + ":" + w) : (L.host = L.hostname, L[H] = "");
          break;
        case "hostname":
          L[H] = w, L.port && (w += ":" + L.port), L.host = w;
          break;
        case "host":
          L[H] = w, i.test(w) ? (w = w.split(":"), L.port = w.pop(), L.hostname = w.join(":")) : (L.hostname = w, L.port = "");
          break;
        case "protocol":
          L.protocol = w.toLowerCase(), L.slashes = !_;
          break;
        case "pathname":
        case "hash":
          if (w) {
            var I = H === "pathname" ? "/" : "#";
            L[H] = w.charAt(0) !== I ? I + w : w;
          } else
            L[H] = w;
          break;
        case "username":
        case "password":
          L[H] = encodeURIComponent(w);
          break;
        case "auth":
          var F = w.indexOf(":");
          ~F ? (L.username = w.slice(0, F), L.username = encodeURIComponent(decodeURIComponent(L.username)), L.password = w.slice(F + 1), L.password = encodeURIComponent(decodeURIComponent(L.password))) : L.username = encodeURIComponent(decodeURIComponent(w));
      }
      for (var B = 0; B < d.length; B++) {
        var K = d[B];
        K[4] && (L[K[1]] = L[K[1]].toLowerCase());
      }
      return L.auth = L.password ? L.username + ":" + L.password : L.username, L.origin = L.protocol !== "file:" && b(L.protocol) && L.host ? L.protocol + "//" + L.host : "null", L.href = L.toString(), L;
    }
    function v(H) {
      (!H || typeof H != "function") && (H = o.stringify);
      var w, _ = this, L = _.host, I = _.protocol;
      I && I.charAt(I.length - 1) !== ":" && (I += ":");
      var F = I + (_.protocol && _.slashes || b(_.protocol) ? "//" : "");
      return _.username ? (F += _.username, _.password && (F += ":" + _.password), F += "@") : _.password ? (F += ":" + _.password, F += "@") : _.protocol !== "file:" && b(_.protocol) && !L && _.pathname !== "/" && (F += "@"), (L[L.length - 1] === ":" || i.test(_.hostname) && !_.port) && (L += ":"), F += L + _.pathname, w = typeof _.query == "object" ? H(_.query) : _.query, w && (F += w.charAt(0) !== "?" ? "?" + w : w), _.hash && (F += _.hash), F;
    }
    p.prototype = { set: h, toString: v }, p.extractProtocol = M, p.location = y, p.trimLeft = u, p.qs = o, e.exports = p;
  }
}), Nk = A1({
  "node_modules/psl/data/rules.json"(t, e) {
    e.exports = [
      "ac",
      "com.ac",
      "edu.ac",
      "gov.ac",
      "net.ac",
      "mil.ac",
      "org.ac",
      "ad",
      "nom.ad",
      "ae",
      "co.ae",
      "net.ae",
      "org.ae",
      "sch.ae",
      "ac.ae",
      "gov.ae",
      "mil.ae",
      "aero",
      "accident-investigation.aero",
      "accident-prevention.aero",
      "aerobatic.aero",
      "aeroclub.aero",
      "aerodrome.aero",
      "agents.aero",
      "aircraft.aero",
      "airline.aero",
      "airport.aero",
      "air-surveillance.aero",
      "airtraffic.aero",
      "air-traffic-control.aero",
      "ambulance.aero",
      "amusement.aero",
      "association.aero",
      "author.aero",
      "ballooning.aero",
      "broker.aero",
      "caa.aero",
      "cargo.aero",
      "catering.aero",
      "certification.aero",
      "championship.aero",
      "charter.aero",
      "civilaviation.aero",
      "club.aero",
      "conference.aero",
      "consultant.aero",
      "consulting.aero",
      "control.aero",
      "council.aero",
      "crew.aero",
      "design.aero",
      "dgca.aero",
      "educator.aero",
      "emergency.aero",
      "engine.aero",
      "engineer.aero",
      "entertainment.aero",
      "equipment.aero",
      "exchange.aero",
      "express.aero",
      "federation.aero",
      "flight.aero",
      "fuel.aero",
      "gliding.aero",
      "government.aero",
      "groundhandling.aero",
      "group.aero",
      "hanggliding.aero",
      "homebuilt.aero",
      "insurance.aero",
      "journal.aero",
      "journalist.aero",
      "leasing.aero",
      "logistics.aero",
      "magazine.aero",
      "maintenance.aero",
      "media.aero",
      "microlight.aero",
      "modelling.aero",
      "navigation.aero",
      "parachuting.aero",
      "paragliding.aero",
      "passenger-association.aero",
      "pilot.aero",
      "press.aero",
      "production.aero",
      "recreation.aero",
      "repbody.aero",
      "res.aero",
      "research.aero",
      "rotorcraft.aero",
      "safety.aero",
      "scientist.aero",
      "services.aero",
      "show.aero",
      "skydiving.aero",
      "software.aero",
      "student.aero",
      "trader.aero",
      "trading.aero",
      "trainer.aero",
      "union.aero",
      "workinggroup.aero",
      "works.aero",
      "af",
      "gov.af",
      "com.af",
      "org.af",
      "net.af",
      "edu.af",
      "ag",
      "com.ag",
      "org.ag",
      "net.ag",
      "co.ag",
      "nom.ag",
      "ai",
      "off.ai",
      "com.ai",
      "net.ai",
      "org.ai",
      "al",
      "com.al",
      "edu.al",
      "gov.al",
      "mil.al",
      "net.al",
      "org.al",
      "am",
      "co.am",
      "com.am",
      "commune.am",
      "net.am",
      "org.am",
      "ao",
      "ed.ao",
      "gv.ao",
      "og.ao",
      "co.ao",
      "pb.ao",
      "it.ao",
      "aq",
      "ar",
      "bet.ar",
      "com.ar",
      "coop.ar",
      "edu.ar",
      "gob.ar",
      "gov.ar",
      "int.ar",
      "mil.ar",
      "musica.ar",
      "mutual.ar",
      "net.ar",
      "org.ar",
      "senasa.ar",
      "tur.ar",
      "arpa",
      "e164.arpa",
      "in-addr.arpa",
      "ip6.arpa",
      "iris.arpa",
      "uri.arpa",
      "urn.arpa",
      "as",
      "gov.as",
      "asia",
      "at",
      "ac.at",
      "co.at",
      "gv.at",
      "or.at",
      "sth.ac.at",
      "au",
      "com.au",
      "net.au",
      "org.au",
      "edu.au",
      "gov.au",
      "asn.au",
      "id.au",
      "info.au",
      "conf.au",
      "oz.au",
      "act.au",
      "nsw.au",
      "nt.au",
      "qld.au",
      "sa.au",
      "tas.au",
      "vic.au",
      "wa.au",
      "act.edu.au",
      "catholic.edu.au",
      "nsw.edu.au",
      "nt.edu.au",
      "qld.edu.au",
      "sa.edu.au",
      "tas.edu.au",
      "vic.edu.au",
      "wa.edu.au",
      "qld.gov.au",
      "sa.gov.au",
      "tas.gov.au",
      "vic.gov.au",
      "wa.gov.au",
      "schools.nsw.edu.au",
      "aw",
      "com.aw",
      "ax",
      "az",
      "com.az",
      "net.az",
      "int.az",
      "gov.az",
      "org.az",
      "edu.az",
      "info.az",
      "pp.az",
      "mil.az",
      "name.az",
      "pro.az",
      "biz.az",
      "ba",
      "com.ba",
      "edu.ba",
      "gov.ba",
      "mil.ba",
      "net.ba",
      "org.ba",
      "bb",
      "biz.bb",
      "co.bb",
      "com.bb",
      "edu.bb",
      "gov.bb",
      "info.bb",
      "net.bb",
      "org.bb",
      "store.bb",
      "tv.bb",
      "*.bd",
      "be",
      "ac.be",
      "bf",
      "gov.bf",
      "bg",
      "a.bg",
      "b.bg",
      "c.bg",
      "d.bg",
      "e.bg",
      "f.bg",
      "g.bg",
      "h.bg",
      "i.bg",
      "j.bg",
      "k.bg",
      "l.bg",
      "m.bg",
      "n.bg",
      "o.bg",
      "p.bg",
      "q.bg",
      "r.bg",
      "s.bg",
      "t.bg",
      "u.bg",
      "v.bg",
      "w.bg",
      "x.bg",
      "y.bg",
      "z.bg",
      "0.bg",
      "1.bg",
      "2.bg",
      "3.bg",
      "4.bg",
      "5.bg",
      "6.bg",
      "7.bg",
      "8.bg",
      "9.bg",
      "bh",
      "com.bh",
      "edu.bh",
      "net.bh",
      "org.bh",
      "gov.bh",
      "bi",
      "co.bi",
      "com.bi",
      "edu.bi",
      "or.bi",
      "org.bi",
      "biz",
      "bj",
      "asso.bj",
      "barreau.bj",
      "gouv.bj",
      "bm",
      "com.bm",
      "edu.bm",
      "gov.bm",
      "net.bm",
      "org.bm",
      "bn",
      "com.bn",
      "edu.bn",
      "gov.bn",
      "net.bn",
      "org.bn",
      "bo",
      "com.bo",
      "edu.bo",
      "gob.bo",
      "int.bo",
      "org.bo",
      "net.bo",
      "mil.bo",
      "tv.bo",
      "web.bo",
      "academia.bo",
      "agro.bo",
      "arte.bo",
      "blog.bo",
      "bolivia.bo",
      "ciencia.bo",
      "cooperativa.bo",
      "democracia.bo",
      "deporte.bo",
      "ecologia.bo",
      "economia.bo",
      "empresa.bo",
      "indigena.bo",
      "industria.bo",
      "info.bo",
      "medicina.bo",
      "movimiento.bo",
      "musica.bo",
      "natural.bo",
      "nombre.bo",
      "noticias.bo",
      "patria.bo",
      "politica.bo",
      "profesional.bo",
      "plurinacional.bo",
      "pueblo.bo",
      "revista.bo",
      "salud.bo",
      "tecnologia.bo",
      "tksat.bo",
      "transporte.bo",
      "wiki.bo",
      "br",
      "9guacu.br",
      "abc.br",
      "adm.br",
      "adv.br",
      "agr.br",
      "aju.br",
      "am.br",
      "anani.br",
      "aparecida.br",
      "app.br",
      "arq.br",
      "art.br",
      "ato.br",
      "b.br",
      "barueri.br",
      "belem.br",
      "bhz.br",
      "bib.br",
      "bio.br",
      "blog.br",
      "bmd.br",
      "boavista.br",
      "bsb.br",
      "campinagrande.br",
      "campinas.br",
      "caxias.br",
      "cim.br",
      "cng.br",
      "cnt.br",
      "com.br",
      "contagem.br",
      "coop.br",
      "coz.br",
      "cri.br",
      "cuiaba.br",
      "curitiba.br",
      "def.br",
      "des.br",
      "det.br",
      "dev.br",
      "ecn.br",
      "eco.br",
      "edu.br",
      "emp.br",
      "enf.br",
      "eng.br",
      "esp.br",
      "etc.br",
      "eti.br",
      "far.br",
      "feira.br",
      "flog.br",
      "floripa.br",
      "fm.br",
      "fnd.br",
      "fortal.br",
      "fot.br",
      "foz.br",
      "fst.br",
      "g12.br",
      "geo.br",
      "ggf.br",
      "goiania.br",
      "gov.br",
      "ac.gov.br",
      "al.gov.br",
      "am.gov.br",
      "ap.gov.br",
      "ba.gov.br",
      "ce.gov.br",
      "df.gov.br",
      "es.gov.br",
      "go.gov.br",
      "ma.gov.br",
      "mg.gov.br",
      "ms.gov.br",
      "mt.gov.br",
      "pa.gov.br",
      "pb.gov.br",
      "pe.gov.br",
      "pi.gov.br",
      "pr.gov.br",
      "rj.gov.br",
      "rn.gov.br",
      "ro.gov.br",
      "rr.gov.br",
      "rs.gov.br",
      "sc.gov.br",
      "se.gov.br",
      "sp.gov.br",
      "to.gov.br",
      "gru.br",
      "imb.br",
      "ind.br",
      "inf.br",
      "jab.br",
      "jampa.br",
      "jdf.br",
      "joinville.br",
      "jor.br",
      "jus.br",
      "leg.br",
      "lel.br",
      "log.br",
      "londrina.br",
      "macapa.br",
      "maceio.br",
      "manaus.br",
      "maringa.br",
      "mat.br",
      "med.br",
      "mil.br",
      "morena.br",
      "mp.br",
      "mus.br",
      "natal.br",
      "net.br",
      "niteroi.br",
      "*.nom.br",
      "not.br",
      "ntr.br",
      "odo.br",
      "ong.br",
      "org.br",
      "osasco.br",
      "palmas.br",
      "poa.br",
      "ppg.br",
      "pro.br",
      "psc.br",
      "psi.br",
      "pvh.br",
      "qsl.br",
      "radio.br",
      "rec.br",
      "recife.br",
      "rep.br",
      "ribeirao.br",
      "rio.br",
      "riobranco.br",
      "riopreto.br",
      "salvador.br",
      "sampa.br",
      "santamaria.br",
      "santoandre.br",
      "saobernardo.br",
      "saogonca.br",
      "seg.br",
      "sjc.br",
      "slg.br",
      "slz.br",
      "sorocaba.br",
      "srv.br",
      "taxi.br",
      "tc.br",
      "tec.br",
      "teo.br",
      "the.br",
      "tmp.br",
      "trd.br",
      "tur.br",
      "tv.br",
      "udi.br",
      "vet.br",
      "vix.br",
      "vlog.br",
      "wiki.br",
      "zlg.br",
      "bs",
      "com.bs",
      "net.bs",
      "org.bs",
      "edu.bs",
      "gov.bs",
      "bt",
      "com.bt",
      "edu.bt",
      "gov.bt",
      "net.bt",
      "org.bt",
      "bv",
      "bw",
      "co.bw",
      "org.bw",
      "by",
      "gov.by",
      "mil.by",
      "com.by",
      "of.by",
      "bz",
      "com.bz",
      "net.bz",
      "org.bz",
      "edu.bz",
      "gov.bz",
      "ca",
      "ab.ca",
      "bc.ca",
      "mb.ca",
      "nb.ca",
      "nf.ca",
      "nl.ca",
      "ns.ca",
      "nt.ca",
      "nu.ca",
      "on.ca",
      "pe.ca",
      "qc.ca",
      "sk.ca",
      "yk.ca",
      "gc.ca",
      "cat",
      "cc",
      "cd",
      "gov.cd",
      "cf",
      "cg",
      "ch",
      "ci",
      "org.ci",
      "or.ci",
      "com.ci",
      "co.ci",
      "edu.ci",
      "ed.ci",
      "ac.ci",
      "net.ci",
      "go.ci",
      "asso.ci",
      "aéroport.ci",
      "int.ci",
      "presse.ci",
      "md.ci",
      "gouv.ci",
      "*.ck",
      "!www.ck",
      "cl",
      "co.cl",
      "gob.cl",
      "gov.cl",
      "mil.cl",
      "cm",
      "co.cm",
      "com.cm",
      "gov.cm",
      "net.cm",
      "cn",
      "ac.cn",
      "com.cn",
      "edu.cn",
      "gov.cn",
      "net.cn",
      "org.cn",
      "mil.cn",
      "公司.cn",
      "网络.cn",
      "網絡.cn",
      "ah.cn",
      "bj.cn",
      "cq.cn",
      "fj.cn",
      "gd.cn",
      "gs.cn",
      "gz.cn",
      "gx.cn",
      "ha.cn",
      "hb.cn",
      "he.cn",
      "hi.cn",
      "hl.cn",
      "hn.cn",
      "jl.cn",
      "js.cn",
      "jx.cn",
      "ln.cn",
      "nm.cn",
      "nx.cn",
      "qh.cn",
      "sc.cn",
      "sd.cn",
      "sh.cn",
      "sn.cn",
      "sx.cn",
      "tj.cn",
      "xj.cn",
      "xz.cn",
      "yn.cn",
      "zj.cn",
      "hk.cn",
      "mo.cn",
      "tw.cn",
      "co",
      "arts.co",
      "com.co",
      "edu.co",
      "firm.co",
      "gov.co",
      "info.co",
      "int.co",
      "mil.co",
      "net.co",
      "nom.co",
      "org.co",
      "rec.co",
      "web.co",
      "com",
      "coop",
      "cr",
      "ac.cr",
      "co.cr",
      "ed.cr",
      "fi.cr",
      "go.cr",
      "or.cr",
      "sa.cr",
      "cu",
      "com.cu",
      "edu.cu",
      "org.cu",
      "net.cu",
      "gov.cu",
      "inf.cu",
      "cv",
      "com.cv",
      "edu.cv",
      "int.cv",
      "nome.cv",
      "org.cv",
      "cw",
      "com.cw",
      "edu.cw",
      "net.cw",
      "org.cw",
      "cx",
      "gov.cx",
      "cy",
      "ac.cy",
      "biz.cy",
      "com.cy",
      "ekloges.cy",
      "gov.cy",
      "ltd.cy",
      "mil.cy",
      "net.cy",
      "org.cy",
      "press.cy",
      "pro.cy",
      "tm.cy",
      "cz",
      "de",
      "dj",
      "dk",
      "dm",
      "com.dm",
      "net.dm",
      "org.dm",
      "edu.dm",
      "gov.dm",
      "do",
      "art.do",
      "com.do",
      "edu.do",
      "gob.do",
      "gov.do",
      "mil.do",
      "net.do",
      "org.do",
      "sld.do",
      "web.do",
      "dz",
      "art.dz",
      "asso.dz",
      "com.dz",
      "edu.dz",
      "gov.dz",
      "org.dz",
      "net.dz",
      "pol.dz",
      "soc.dz",
      "tm.dz",
      "ec",
      "com.ec",
      "info.ec",
      "net.ec",
      "fin.ec",
      "k12.ec",
      "med.ec",
      "pro.ec",
      "org.ec",
      "edu.ec",
      "gov.ec",
      "gob.ec",
      "mil.ec",
      "edu",
      "ee",
      "edu.ee",
      "gov.ee",
      "riik.ee",
      "lib.ee",
      "med.ee",
      "com.ee",
      "pri.ee",
      "aip.ee",
      "org.ee",
      "fie.ee",
      "eg",
      "com.eg",
      "edu.eg",
      "eun.eg",
      "gov.eg",
      "mil.eg",
      "name.eg",
      "net.eg",
      "org.eg",
      "sci.eg",
      "*.er",
      "es",
      "com.es",
      "nom.es",
      "org.es",
      "gob.es",
      "edu.es",
      "et",
      "com.et",
      "gov.et",
      "org.et",
      "edu.et",
      "biz.et",
      "name.et",
      "info.et",
      "net.et",
      "eu",
      "fi",
      "aland.fi",
      "fj",
      "ac.fj",
      "biz.fj",
      "com.fj",
      "gov.fj",
      "info.fj",
      "mil.fj",
      "name.fj",
      "net.fj",
      "org.fj",
      "pro.fj",
      "*.fk",
      "com.fm",
      "edu.fm",
      "net.fm",
      "org.fm",
      "fm",
      "fo",
      "fr",
      "asso.fr",
      "com.fr",
      "gouv.fr",
      "nom.fr",
      "prd.fr",
      "tm.fr",
      "aeroport.fr",
      "avocat.fr",
      "avoues.fr",
      "cci.fr",
      "chambagri.fr",
      "chirurgiens-dentistes.fr",
      "experts-comptables.fr",
      "geometre-expert.fr",
      "greta.fr",
      "huissier-justice.fr",
      "medecin.fr",
      "notaires.fr",
      "pharmacien.fr",
      "port.fr",
      "veterinaire.fr",
      "ga",
      "gb",
      "edu.gd",
      "gov.gd",
      "gd",
      "ge",
      "com.ge",
      "edu.ge",
      "gov.ge",
      "org.ge",
      "mil.ge",
      "net.ge",
      "pvt.ge",
      "gf",
      "gg",
      "co.gg",
      "net.gg",
      "org.gg",
      "gh",
      "com.gh",
      "edu.gh",
      "gov.gh",
      "org.gh",
      "mil.gh",
      "gi",
      "com.gi",
      "ltd.gi",
      "gov.gi",
      "mod.gi",
      "edu.gi",
      "org.gi",
      "gl",
      "co.gl",
      "com.gl",
      "edu.gl",
      "net.gl",
      "org.gl",
      "gm",
      "gn",
      "ac.gn",
      "com.gn",
      "edu.gn",
      "gov.gn",
      "org.gn",
      "net.gn",
      "gov",
      "gp",
      "com.gp",
      "net.gp",
      "mobi.gp",
      "edu.gp",
      "org.gp",
      "asso.gp",
      "gq",
      "gr",
      "com.gr",
      "edu.gr",
      "net.gr",
      "org.gr",
      "gov.gr",
      "gs",
      "gt",
      "com.gt",
      "edu.gt",
      "gob.gt",
      "ind.gt",
      "mil.gt",
      "net.gt",
      "org.gt",
      "gu",
      "com.gu",
      "edu.gu",
      "gov.gu",
      "guam.gu",
      "info.gu",
      "net.gu",
      "org.gu",
      "web.gu",
      "gw",
      "gy",
      "co.gy",
      "com.gy",
      "edu.gy",
      "gov.gy",
      "net.gy",
      "org.gy",
      "hk",
      "com.hk",
      "edu.hk",
      "gov.hk",
      "idv.hk",
      "net.hk",
      "org.hk",
      "公司.hk",
      "教育.hk",
      "敎育.hk",
      "政府.hk",
      "個人.hk",
      "个��.hk",
      "箇人.hk",
      "網络.hk",
      "网络.hk",
      "组織.hk",
      "網絡.hk",
      "网絡.hk",
      "组织.hk",
      "組織.hk",
      "組织.hk",
      "hm",
      "hn",
      "com.hn",
      "edu.hn",
      "org.hn",
      "net.hn",
      "mil.hn",
      "gob.hn",
      "hr",
      "iz.hr",
      "from.hr",
      "name.hr",
      "com.hr",
      "ht",
      "com.ht",
      "shop.ht",
      "firm.ht",
      "info.ht",
      "adult.ht",
      "net.ht",
      "pro.ht",
      "org.ht",
      "med.ht",
      "art.ht",
      "coop.ht",
      "pol.ht",
      "asso.ht",
      "edu.ht",
      "rel.ht",
      "gouv.ht",
      "perso.ht",
      "hu",
      "co.hu",
      "info.hu",
      "org.hu",
      "priv.hu",
      "sport.hu",
      "tm.hu",
      "2000.hu",
      "agrar.hu",
      "bolt.hu",
      "casino.hu",
      "city.hu",
      "erotica.hu",
      "erotika.hu",
      "film.hu",
      "forum.hu",
      "games.hu",
      "hotel.hu",
      "ingatlan.hu",
      "jogasz.hu",
      "konyvelo.hu",
      "lakas.hu",
      "media.hu",
      "news.hu",
      "reklam.hu",
      "sex.hu",
      "shop.hu",
      "suli.hu",
      "szex.hu",
      "tozsde.hu",
      "utazas.hu",
      "video.hu",
      "id",
      "ac.id",
      "biz.id",
      "co.id",
      "desa.id",
      "go.id",
      "mil.id",
      "my.id",
      "net.id",
      "or.id",
      "ponpes.id",
      "sch.id",
      "web.id",
      "ie",
      "gov.ie",
      "il",
      "ac.il",
      "co.il",
      "gov.il",
      "idf.il",
      "k12.il",
      "muni.il",
      "net.il",
      "org.il",
      "im",
      "ac.im",
      "co.im",
      "com.im",
      "ltd.co.im",
      "net.im",
      "org.im",
      "plc.co.im",
      "tt.im",
      "tv.im",
      "in",
      "co.in",
      "firm.in",
      "net.in",
      "org.in",
      "gen.in",
      "ind.in",
      "nic.in",
      "ac.in",
      "edu.in",
      "res.in",
      "gov.in",
      "mil.in",
      "info",
      "int",
      "eu.int",
      "io",
      "com.io",
      "iq",
      "gov.iq",
      "edu.iq",
      "mil.iq",
      "com.iq",
      "org.iq",
      "net.iq",
      "ir",
      "ac.ir",
      "co.ir",
      "gov.ir",
      "id.ir",
      "net.ir",
      "org.ir",
      "sch.ir",
      "ایران.ir",
      "ايران.ir",
      "is",
      "net.is",
      "com.is",
      "edu.is",
      "gov.is",
      "org.is",
      "int.is",
      "it",
      "gov.it",
      "edu.it",
      "abr.it",
      "abruzzo.it",
      "aosta-valley.it",
      "aostavalley.it",
      "bas.it",
      "basilicata.it",
      "cal.it",
      "calabria.it",
      "cam.it",
      "campania.it",
      "emilia-romagna.it",
      "emiliaromagna.it",
      "emr.it",
      "friuli-v-giulia.it",
      "friuli-ve-giulia.it",
      "friuli-vegiulia.it",
      "friuli-venezia-giulia.it",
      "friuli-veneziagiulia.it",
      "friuli-vgiulia.it",
      "friuliv-giulia.it",
      "friulive-giulia.it",
      "friulivegiulia.it",
      "friulivenezia-giulia.it",
      "friuliveneziagiulia.it",
      "friulivgiulia.it",
      "fvg.it",
      "laz.it",
      "lazio.it",
      "lig.it",
      "liguria.it",
      "lom.it",
      "lombardia.it",
      "lombardy.it",
      "lucania.it",
      "mar.it",
      "marche.it",
      "mol.it",
      "molise.it",
      "piedmont.it",
      "piemonte.it",
      "pmn.it",
      "pug.it",
      "puglia.it",
      "sar.it",
      "sardegna.it",
      "sardinia.it",
      "sic.it",
      "sicilia.it",
      "sicily.it",
      "taa.it",
      "tos.it",
      "toscana.it",
      "trentin-sud-tirol.it",
      "trentin-süd-tirol.it",
      "trentin-sudtirol.it",
      "trentin-südtirol.it",
      "trentin-sued-tirol.it",
      "trentin-suedtirol.it",
      "trentino-a-adige.it",
      "trentino-aadige.it",
      "trentino-alto-adige.it",
      "trentino-altoadige.it",
      "trentino-s-tirol.it",
      "trentino-stirol.it",
      "trentino-sud-tirol.it",
      "trentino-süd-tirol.it",
      "trentino-sudtirol.it",
      "trentino-südtirol.it",
      "trentino-sued-tirol.it",
      "trentino-suedtirol.it",
      "trentino.it",
      "trentinoa-adige.it",
      "trentinoaadige.it",
      "trentinoalto-adige.it",
      "trentinoaltoadige.it",
      "trentinos-tirol.it",
      "trentinostirol.it",
      "trentinosud-tirol.it",
      "trentinosüd-tirol.it",
      "trentinosudtirol.it",
      "trentinosüdtirol.it",
      "trentinosued-tirol.it",
      "trentinosuedtirol.it",
      "trentinsud-tirol.it",
      "trentinsüd-tirol.it",
      "trentinsudtirol.it",
      "trentinsüdtirol.it",
      "trentinsued-tirol.it",
      "trentinsuedtirol.it",
      "tuscany.it",
      "umb.it",
      "umbria.it",
      "val-d-aosta.it",
      "val-daosta.it",
      "vald-aosta.it",
      "valdaosta.it",
      "valle-aosta.it",
      "valle-d-aosta.it",
      "valle-daosta.it",
      "valleaosta.it",
      "valled-aosta.it",
      "valledaosta.it",
      "vallee-aoste.it",
      "vallée-aoste.it",
      "vallee-d-aoste.it",
      "vallée-d-aoste.it",
      "valleeaoste.it",
      "valléeaoste.it",
      "valleedaoste.it",
      "valléedaoste.it",
      "vao.it",
      "vda.it",
      "ven.it",
      "veneto.it",
      "ag.it",
      "agrigento.it",
      "al.it",
      "alessandria.it",
      "alto-adige.it",
      "altoadige.it",
      "an.it",
      "ancona.it",
      "andria-barletta-trani.it",
      "andria-trani-barletta.it",
      "andriabarlettatrani.it",
      "andriatranibarletta.it",
      "ao.it",
      "aosta.it",
      "aoste.it",
      "ap.it",
      "aq.it",
      "aquila.it",
      "ar.it",
      "arezzo.it",
      "ascoli-piceno.it",
      "ascolipiceno.it",
      "asti.it",
      "at.it",
      "av.it",
      "avellino.it",
      "ba.it",
      "balsan-sudtirol.it",
      "balsan-südtirol.it",
      "balsan-suedtirol.it",
      "balsan.it",
      "bari.it",
      "barletta-trani-andria.it",
      "barlettatraniandria.it",
      "belluno.it",
      "benevento.it",
      "bergamo.it",
      "bg.it",
      "bi.it",
      "biella.it",
      "bl.it",
      "bn.it",
      "bo.it",
      "bologna.it",
      "bolzano-altoadige.it",
      "bolzano.it",
      "bozen-sudtirol.it",
      "bozen-südtirol.it",
      "bozen-suedtirol.it",
      "bozen.it",
      "br.it",
      "brescia.it",
      "brindisi.it",
      "bs.it",
      "bt.it",
      "bulsan-sudtirol.it",
      "bulsan-südtirol.it",
      "bulsan-suedtirol.it",
      "bulsan.it",
      "bz.it",
      "ca.it",
      "cagliari.it",
      "caltanissetta.it",
      "campidano-medio.it",
      "campidanomedio.it",
      "campobasso.it",
      "carbonia-iglesias.it",
      "carboniaiglesias.it",
      "carrara-massa.it",
      "carraramassa.it",
      "caserta.it",
      "catania.it",
      "catanzaro.it",
      "cb.it",
      "ce.it",
      "cesena-forli.it",
      "cesena-forlì.it",
      "cesenaforli.it",
      "cesenaforlì.it",
      "ch.it",
      "chieti.it",
      "ci.it",
      "cl.it",
      "cn.it",
      "co.it",
      "como.it",
      "cosenza.it",
      "cr.it",
      "cremona.it",
      "crotone.it",
      "cs.it",
      "ct.it",
      "cuneo.it",
      "cz.it",
      "dell-ogliastra.it",
      "dellogliastra.it",
      "en.it",
      "enna.it",
      "fc.it",
      "fe.it",
      "fermo.it",
      "ferrara.it",
      "fg.it",
      "fi.it",
      "firenze.it",
      "florence.it",
      "fm.it",
      "foggia.it",
      "forli-cesena.it",
      "forlì-cesena.it",
      "forlicesena.it",
      "forlìcesena.it",
      "fr.it",
      "frosinone.it",
      "ge.it",
      "genoa.it",
      "genova.it",
      "go.it",
      "gorizia.it",
      "gr.it",
      "grosseto.it",
      "iglesias-carbonia.it",
      "iglesiascarbonia.it",
      "im.it",
      "imperia.it",
      "is.it",
      "isernia.it",
      "kr.it",
      "la-spezia.it",
      "laquila.it",
      "laspezia.it",
      "latina.it",
      "lc.it",
      "le.it",
      "lecce.it",
      "lecco.it",
      "li.it",
      "livorno.it",
      "lo.it",
      "lodi.it",
      "lt.it",
      "lu.it",
      "lucca.it",
      "macerata.it",
      "mantova.it",
      "massa-carrara.it",
      "massacarrara.it",
      "matera.it",
      "mb.it",
      "mc.it",
      "me.it",
      "medio-campidano.it",
      "mediocampidano.it",
      "messina.it",
      "mi.it",
      "milan.it",
      "milano.it",
      "mn.it",
      "mo.it",
      "modena.it",
      "monza-brianza.it",
      "monza-e-della-brianza.it",
      "monza.it",
      "monzabrianza.it",
      "monzaebrianza.it",
      "monzaedellabrianza.it",
      "ms.it",
      "mt.it",
      "na.it",
      "naples.it",
      "napoli.it",
      "no.it",
      "novara.it",
      "nu.it",
      "nuoro.it",
      "og.it",
      "ogliastra.it",
      "olbia-tempio.it",
      "olbiatempio.it",
      "or.it",
      "oristano.it",
      "ot.it",
      "pa.it",
      "padova.it",
      "padua.it",
      "palermo.it",
      "parma.it",
      "pavia.it",
      "pc.it",
      "pd.it",
      "pe.it",
      "perugia.it",
      "pesaro-urbino.it",
      "pesarourbino.it",
      "pescara.it",
      "pg.it",
      "pi.it",
      "piacenza.it",
      "pisa.it",
      "pistoia.it",
      "pn.it",
      "po.it",
      "pordenone.it",
      "potenza.it",
      "pr.it",
      "prato.it",
      "pt.it",
      "pu.it",
      "pv.it",
      "pz.it",
      "ra.it",
      "ragusa.it",
      "ravenna.it",
      "rc.it",
      "re.it",
      "reggio-calabria.it",
      "reggio-emilia.it",
      "reggiocalabria.it",
      "reggioemilia.it",
      "rg.it",
      "ri.it",
      "rieti.it",
      "rimini.it",
      "rm.it",
      "rn.it",
      "ro.it",
      "roma.it",
      "rome.it",
      "rovigo.it",
      "sa.it",
      "salerno.it",
      "sassari.it",
      "savona.it",
      "si.it",
      "siena.it",
      "siracusa.it",
      "so.it",
      "sondrio.it",
      "sp.it",
      "sr.it",
      "ss.it",
      "suedtirol.it",
      "südtirol.it",
      "sv.it",
      "ta.it",
      "taranto.it",
      "te.it",
      "tempio-olbia.it",
      "tempioolbia.it",
      "teramo.it",
      "terni.it",
      "tn.it",
      "to.it",
      "torino.it",
      "tp.it",
      "tr.it",
      "trani-andria-barletta.it",
      "trani-barletta-andria.it",
      "traniandriabarletta.it",
      "tranibarlettaandria.it",
      "trapani.it",
      "trento.it",
      "treviso.it",
      "trieste.it",
      "ts.it",
      "turin.it",
      "tv.it",
      "ud.it",
      "udine.it",
      "urbino-pesaro.it",
      "urbinopesaro.it",
      "va.it",
      "varese.it",
      "vb.it",
      "vc.it",
      "ve.it",
      "venezia.it",
      "venice.it",
      "verbania.it",
      "vercelli.it",
      "verona.it",
      "vi.it",
      "vibo-valentia.it",
      "vibovalentia.it",
      "vicenza.it",
      "viterbo.it",
      "vr.it",
      "vs.it",
      "vt.it",
      "vv.it",
      "je",
      "co.je",
      "net.je",
      "org.je",
      "*.jm",
      "jo",
      "com.jo",
      "org.jo",
      "net.jo",
      "edu.jo",
      "sch.jo",
      "gov.jo",
      "mil.jo",
      "name.jo",
      "jobs",
      "jp",
      "ac.jp",
      "ad.jp",
      "co.jp",
      "ed.jp",
      "go.jp",
      "gr.jp",
      "lg.jp",
      "ne.jp",
      "or.jp",
      "aichi.jp",
      "akita.jp",
      "aomori.jp",
      "chiba.jp",
      "ehime.jp",
      "fukui.jp",
      "fukuoka.jp",
      "fukushima.jp",
      "gifu.jp",
      "gunma.jp",
      "hiroshima.jp",
      "hokkaido.jp",
      "hyogo.jp",
      "ibaraki.jp",
      "ishikawa.jp",
      "iwate.jp",
      "kagawa.jp",
      "kagoshima.jp",
      "kanagawa.jp",
      "kochi.jp",
      "kumamoto.jp",
      "kyoto.jp",
      "mie.jp",
      "miyagi.jp",
      "miyazaki.jp",
      "nagano.jp",
      "nagasaki.jp",
      "nara.jp",
      "niigata.jp",
      "oita.jp",
      "okayama.jp",
      "okinawa.jp",
      "osaka.jp",
      "saga.jp",
      "saitama.jp",
      "shiga.jp",
      "shimane.jp",
      "shizuoka.jp",
      "tochigi.jp",
      "tokushima.jp",
      "tokyo.jp",
      "tottori.jp",
      "toyama.jp",
      "wakayama.jp",
      "yamagata.jp",
      "yamaguchi.jp",
      "yamanashi.jp",
      "栃木.jp",
      "愛知.jp",
      "愛媛.jp",
      "兵庫.jp",
      "熊本.jp",
      "茨城.jp",
      "北海道.jp",
      "千葉.jp",
      "和歌山.jp",
      "長崎.jp",
      "長野.jp",
      "新潟.jp",
      "青森.jp",
      "静岡.jp",
      "東京.jp",
      "石川.jp",
      "埼玉.jp",
      "三重.jp",
      "京都.jp",
      "佐賀.jp",
      "大分.jp",
      "大阪.jp",
      "奈良.jp",
      "宮城.jp",
      "宮崎.jp",
      "富山.jp",
      "山口.jp",
      "山形.jp",
      "山梨.jp",
      "岩手.jp",
      "岐阜.jp",
      "岡山.jp",
      "島根.jp",
      "広島.jp",
      "徳島.jp",
      "沖縄.jp",
      "滋賀.jp",
      "神奈川.jp",
      "福井.jp",
      "福岡.jp",
      "福島.jp",
      "秋田.jp",
      "群馬.jp",
      "香川.jp",
      "高知.jp",
      "鳥取.jp",
      "鹿児島.jp",
      "*.kawasaki.jp",
      "*.kitakyushu.jp",
      "*.kobe.jp",
      "*.nagoya.jp",
      "*.sapporo.jp",
      "*.sendai.jp",
      "*.yokohama.jp",
      "!city.kawasaki.jp",
      "!city.kitakyushu.jp",
      "!city.kobe.jp",
      "!city.nagoya.jp",
      "!city.sapporo.jp",
      "!city.sendai.jp",
      "!city.yokohama.jp",
      "aisai.aichi.jp",
      "ama.aichi.jp",
      "anjo.aichi.jp",
      "asuke.aichi.jp",
      "chiryu.aichi.jp",
      "chita.aichi.jp",
      "fuso.aichi.jp",
      "gamagori.aichi.jp",
      "handa.aichi.jp",
      "hazu.aichi.jp",
      "hekinan.aichi.jp",
      "higashiura.aichi.jp",
      "ichinomiya.aichi.jp",
      "inazawa.aichi.jp",
      "inuyama.aichi.jp",
      "isshiki.aichi.jp",
      "iwakura.aichi.jp",
      "kanie.aichi.jp",
      "kariya.aichi.jp",
      "kasugai.aichi.jp",
      "kira.aichi.jp",
      "kiyosu.aichi.jp",
      "komaki.aichi.jp",
      "konan.aichi.jp",
      "kota.aichi.jp",
      "mihama.aichi.jp",
      "miyoshi.aichi.jp",
      "nishio.aichi.jp",
      "nisshin.aichi.jp",
      "obu.aichi.jp",
      "oguchi.aichi.jp",
      "oharu.aichi.jp",
      "okazaki.aichi.jp",
      "owariasahi.aichi.jp",
      "seto.aichi.jp",
      "shikatsu.aichi.jp",
      "shinshiro.aichi.jp",
      "shitara.aichi.jp",
      "tahara.aichi.jp",
      "takahama.aichi.jp",
      "tobishima.aichi.jp",
      "toei.aichi.jp",
      "togo.aichi.jp",
      "tokai.aichi.jp",
      "tokoname.aichi.jp",
      "toyoake.aichi.jp",
      "toyohashi.aichi.jp",
      "toyokawa.aichi.jp",
      "toyone.aichi.jp",
      "toyota.aichi.jp",
      "tsushima.aichi.jp",
      "yatomi.aichi.jp",
      "akita.akita.jp",
      "daisen.akita.jp",
      "fujisato.akita.jp",
      "gojome.akita.jp",
      "hachirogata.akita.jp",
      "happou.akita.jp",
      "higashinaruse.akita.jp",
      "honjo.akita.jp",
      "honjyo.akita.jp",
      "ikawa.akita.jp",
      "kamikoani.akita.jp",
      "kamioka.akita.jp",
      "katagami.akita.jp",
      "kazuno.akita.jp",
      "kitaakita.akita.jp",
      "kosaka.akita.jp",
      "kyowa.akita.jp",
      "misato.akita.jp",
      "mitane.akita.jp",
      "moriyoshi.akita.jp",
      "nikaho.akita.jp",
      "noshiro.akita.jp",
      "odate.akita.jp",
      "oga.akita.jp",
      "ogata.akita.jp",
      "semboku.akita.jp",
      "yokote.akita.jp",
      "yurihonjo.akita.jp",
      "aomori.aomori.jp",
      "gonohe.aomori.jp",
      "hachinohe.aomori.jp",
      "hashikami.aomori.jp",
      "hiranai.aomori.jp",
      "hirosaki.aomori.jp",
      "itayanagi.aomori.jp",
      "kuroishi.aomori.jp",
      "misawa.aomori.jp",
      "mutsu.aomori.jp",
      "nakadomari.aomori.jp",
      "noheji.aomori.jp",
      "oirase.aomori.jp",
      "owani.aomori.jp",
      "rokunohe.aomori.jp",
      "sannohe.aomori.jp",
      "shichinohe.aomori.jp",
      "shingo.aomori.jp",
      "takko.aomori.jp",
      "towada.aomori.jp",
      "tsugaru.aomori.jp",
      "tsuruta.aomori.jp",
      "abiko.chiba.jp",
      "asahi.chiba.jp",
      "chonan.chiba.jp",
      "chosei.chiba.jp",
      "choshi.chiba.jp",
      "chuo.chiba.jp",
      "funabashi.chiba.jp",
      "futtsu.chiba.jp",
      "hanamigawa.chiba.jp",
      "ichihara.chiba.jp",
      "ichikawa.chiba.jp",
      "ichinomiya.chiba.jp",
      "inzai.chiba.jp",
      "isumi.chiba.jp",
      "kamagaya.chiba.jp",
      "kamogawa.chiba.jp",
      "kashiwa.chiba.jp",
      "katori.chiba.jp",
      "katsuura.chiba.jp",
      "kimitsu.chiba.jp",
      "kisarazu.chiba.jp",
      "kozaki.chiba.jp",
      "kujukuri.chiba.jp",
      "kyonan.chiba.jp",
      "matsudo.chiba.jp",
      "midori.chiba.jp",
      "mihama.chiba.jp",
      "minamiboso.chiba.jp",
      "mobara.chiba.jp",
      "mutsuzawa.chiba.jp",
      "nagara.chiba.jp",
      "nagareyama.chiba.jp",
      "narashino.chiba.jp",
      "narita.chiba.jp",
      "noda.chiba.jp",
      "oamishirasato.chiba.jp",
      "omigawa.chiba.jp",
      "onjuku.chiba.jp",
      "otaki.chiba.jp",
      "sakae.chiba.jp",
      "sakura.chiba.jp",
      "shimofusa.chiba.jp",
      "shirako.chiba.jp",
      "shiroi.chiba.jp",
      "shisui.chiba.jp",
      "sodegaura.chiba.jp",
      "sosa.chiba.jp",
      "tako.chiba.jp",
      "tateyama.chiba.jp",
      "togane.chiba.jp",
      "tohnosho.chiba.jp",
      "tomisato.chiba.jp",
      "urayasu.chiba.jp",
      "yachimata.chiba.jp",
      "yachiyo.chiba.jp",
      "yokaichiba.chiba.jp",
      "yokoshibahikari.chiba.jp",
      "yotsukaido.chiba.jp",
      "ainan.ehime.jp",
      "honai.ehime.jp",
      "ikata.ehime.jp",
      "imabari.ehime.jp",
      "iyo.ehime.jp",
      "kamijima.ehime.jp",
      "kihoku.ehime.jp",
      "kumakogen.ehime.jp",
      "masaki.ehime.jp",
      "matsuno.ehime.jp",
      "matsuyama.ehime.jp",
      "namikata.ehime.jp",
      "niihama.ehime.jp",
      "ozu.ehime.jp",
      "saijo.ehime.jp",
      "seiyo.ehime.jp",
      "shikokuchuo.ehime.jp",
      "tobe.ehime.jp",
      "toon.ehime.jp",
      "uchiko.ehime.jp",
      "uwajima.ehime.jp",
      "yawatahama.ehime.jp",
      "echizen.fukui.jp",
      "eiheiji.fukui.jp",
      "fukui.fukui.jp",
      "ikeda.fukui.jp",
      "katsuyama.fukui.jp",
      "mihama.fukui.jp",
      "minamiechizen.fukui.jp",
      "obama.fukui.jp",
      "ohi.fukui.jp",
      "ono.fukui.jp",
      "sabae.fukui.jp",
      "sakai.fukui.jp",
      "takahama.fukui.jp",
      "tsuruga.fukui.jp",
      "wakasa.fukui.jp",
      "ashiya.fukuoka.jp",
      "buzen.fukuoka.jp",
      "chikugo.fukuoka.jp",
      "chikuho.fukuoka.jp",
      "chikujo.fukuoka.jp",
      "chikushino.fukuoka.jp",
      "chikuzen.fukuoka.jp",
      "chuo.fukuoka.jp",
      "dazaifu.fukuoka.jp",
      "fukuchi.fukuoka.jp",
      "hakata.fukuoka.jp",
      "higashi.fukuoka.jp",
      "hirokawa.fukuoka.jp",
      "hisayama.fukuoka.jp",
      "iizuka.fukuoka.jp",
      "inatsuki.fukuoka.jp",
      "kaho.fukuoka.jp",
      "kasuga.fukuoka.jp",
      "kasuya.fukuoka.jp",
      "kawara.fukuoka.jp",
      "keisen.fukuoka.jp",
      "koga.fukuoka.jp",
      "kurate.fukuoka.jp",
      "kurogi.fukuoka.jp",
      "kurume.fukuoka.jp",
      "minami.fukuoka.jp",
      "miyako.fukuoka.jp",
      "miyama.fukuoka.jp",
      "miyawaka.fukuoka.jp",
      "mizumaki.fukuoka.jp",
      "munakata.fukuoka.jp",
      "nakagawa.fukuoka.jp",
      "nakama.fukuoka.jp",
      "nishi.fukuoka.jp",
      "nogata.fukuoka.jp",
      "ogori.fukuoka.jp",
      "okagaki.fukuoka.jp",
      "okawa.fukuoka.jp",
      "oki.fukuoka.jp",
      "omuta.fukuoka.jp",
      "onga.fukuoka.jp",
      "onojo.fukuoka.jp",
      "oto.fukuoka.jp",
      "saigawa.fukuoka.jp",
      "sasaguri.fukuoka.jp",
      "shingu.fukuoka.jp",
      "shinyoshitomi.fukuoka.jp",
      "shonai.fukuoka.jp",
      "soeda.fukuoka.jp",
      "sue.fukuoka.jp",
      "tachiarai.fukuoka.jp",
      "tagawa.fukuoka.jp",
      "takata.fukuoka.jp",
      "toho.fukuoka.jp",
      "toyotsu.fukuoka.jp",
      "tsuiki.fukuoka.jp",
      "ukiha.fukuoka.jp",
      "umi.fukuoka.jp",
      "usui.fukuoka.jp",
      "yamada.fukuoka.jp",
      "yame.fukuoka.jp",
      "yanagawa.fukuoka.jp",
      "yukuhashi.fukuoka.jp",
      "aizubange.fukushima.jp",
      "aizumisato.fukushima.jp",
      "aizuwakamatsu.fukushima.jp",
      "asakawa.fukushima.jp",
      "bandai.fukushima.jp",
      "date.fukushima.jp",
      "fukushima.fukushima.jp",
      "furudono.fukushima.jp",
      "futaba.fukushima.jp",
      "hanawa.fukushima.jp",
      "higashi.fukushima.jp",
      "hirata.fukushima.jp",
      "hirono.fukushima.jp",
      "iitate.fukushima.jp",
      "inawashiro.fukushima.jp",
      "ishikawa.fukushima.jp",
      "iwaki.fukushima.jp",
      "izumizaki.fukushima.jp",
      "kagamiishi.fukushima.jp",
      "kaneyama.fukushima.jp",
      "kawamata.fukushima.jp",
      "kitakata.fukushima.jp",
      "kitashiobara.fukushima.jp",
      "koori.fukushima.jp",
      "koriyama.fukushima.jp",
      "kunimi.fukushima.jp",
      "miharu.fukushima.jp",
      "mishima.fukushima.jp",
      "namie.fukushima.jp",
      "nango.fukushima.jp",
      "nishiaizu.fukushima.jp",
      "nishigo.fukushima.jp",
      "okuma.fukushima.jp",
      "omotego.fukushima.jp",
      "ono.fukushima.jp",
      "otama.fukushima.jp",
      "samegawa.fukushima.jp",
      "shimogo.fukushima.jp",
      "shirakawa.fukushima.jp",
      "showa.fukushima.jp",
      "soma.fukushima.jp",
      "sukagawa.fukushima.jp",
      "taishin.fukushima.jp",
      "tamakawa.fukushima.jp",
      "tanagura.fukushima.jp",
      "tenei.fukushima.jp",
      "yabuki.fukushima.jp",
      "yamato.fukushima.jp",
      "yamatsuri.fukushima.jp",
      "yanaizu.fukushima.jp",
      "yugawa.fukushima.jp",
      "anpachi.gifu.jp",
      "ena.gifu.jp",
      "gifu.gifu.jp",
      "ginan.gifu.jp",
      "godo.gifu.jp",
      "gujo.gifu.jp",
      "hashima.gifu.jp",
      "hichiso.gifu.jp",
      "hida.gifu.jp",
      "higashishirakawa.gifu.jp",
      "ibigawa.gifu.jp",
      "ikeda.gifu.jp",
      "kakamigahara.gifu.jp",
      "kani.gifu.jp",
      "kasahara.gifu.jp",
      "kasamatsu.gifu.jp",
      "kawaue.gifu.jp",
      "kitagata.gifu.jp",
      "mino.gifu.jp",
      "minokamo.gifu.jp",
      "mitake.gifu.jp",
      "mizunami.gifu.jp",
      "motosu.gifu.jp",
      "nakatsugawa.gifu.jp",
      "ogaki.gifu.jp",
      "sakahogi.gifu.jp",
      "seki.gifu.jp",
      "sekigahara.gifu.jp",
      "shirakawa.gifu.jp",
      "tajimi.gifu.jp",
      "takayama.gifu.jp",
      "tarui.gifu.jp",
      "toki.gifu.jp",
      "tomika.gifu.jp",
      "wanouchi.gifu.jp",
      "yamagata.gifu.jp",
      "yaotsu.gifu.jp",
      "yoro.gifu.jp",
      "annaka.gunma.jp",
      "chiyoda.gunma.jp",
      "fujioka.gunma.jp",
      "higashiagatsuma.gunma.jp",
      "isesaki.gunma.jp",
      "itakura.gunma.jp",
      "kanna.gunma.jp",
      "kanra.gunma.jp",
      "katashina.gunma.jp",
      "kawaba.gunma.jp",
      "kiryu.gunma.jp",
      "kusatsu.gunma.jp",
      "maebashi.gunma.jp",
      "meiwa.gunma.jp",
      "midori.gunma.jp",
      "minakami.gunma.jp",
      "naganohara.gunma.jp",
      "nakanojo.gunma.jp",
      "nanmoku.gunma.jp",
      "numata.gunma.jp",
      "oizumi.gunma.jp",
      "ora.gunma.jp",
      "ota.gunma.jp",
      "shibukawa.gunma.jp",
      "shimonita.gunma.jp",
      "shinto.gunma.jp",
      "showa.gunma.jp",
      "takasaki.gunma.jp",
      "takayama.gunma.jp",
      "tamamura.gunma.jp",
      "tatebayashi.gunma.jp",
      "tomioka.gunma.jp",
      "tsukiyono.gunma.jp",
      "tsumagoi.gunma.jp",
      "ueno.gunma.jp",
      "yoshioka.gunma.jp",
      "asaminami.hiroshima.jp",
      "daiwa.hiroshima.jp",
      "etajima.hiroshima.jp",
      "fuchu.hiroshima.jp",
      "fukuyama.hiroshima.jp",
      "hatsukaichi.hiroshima.jp",
      "higashihiroshima.hiroshima.jp",
      "hongo.hiroshima.jp",
      "jinsekikogen.hiroshima.jp",
      "kaita.hiroshima.jp",
      "kui.hiroshima.jp",
      "kumano.hiroshima.jp",
      "kure.hiroshima.jp",
      "mihara.hiroshima.jp",
      "miyoshi.hiroshima.jp",
      "naka.hiroshima.jp",
      "onomichi.hiroshima.jp",
      "osakikamijima.hiroshima.jp",
      "otake.hiroshima.jp",
      "saka.hiroshima.jp",
      "sera.hiroshima.jp",
      "seranishi.hiroshima.jp",
      "shinichi.hiroshima.jp",
      "shobara.hiroshima.jp",
      "takehara.hiroshima.jp",
      "abashiri.hokkaido.jp",
      "abira.hokkaido.jp",
      "aibetsu.hokkaido.jp",
      "akabira.hokkaido.jp",
      "akkeshi.hokkaido.jp",
      "asahikawa.hokkaido.jp",
      "ashibetsu.hokkaido.jp",
      "ashoro.hokkaido.jp",
      "assabu.hokkaido.jp",
      "atsuma.hokkaido.jp",
      "bibai.hokkaido.jp",
      "biei.hokkaido.jp",
      "bifuka.hokkaido.jp",
      "bihoro.hokkaido.jp",
      "biratori.hokkaido.jp",
      "chippubetsu.hokkaido.jp",
      "chitose.hokkaido.jp",
      "date.hokkaido.jp",
      "ebetsu.hokkaido.jp",
      "embetsu.hokkaido.jp",
      "eniwa.hokkaido.jp",
      "erimo.hokkaido.jp",
      "esan.hokkaido.jp",
      "esashi.hokkaido.jp",
      "fukagawa.hokkaido.jp",
      "fukushima.hokkaido.jp",
      "furano.hokkaido.jp",
      "furubira.hokkaido.jp",
      "haboro.hokkaido.jp",
      "hakodate.hokkaido.jp",
      "hamatonbetsu.hokkaido.jp",
      "hidaka.hokkaido.jp",
      "higashikagura.hokkaido.jp",
      "higashikawa.hokkaido.jp",
      "hiroo.hokkaido.jp",
      "hokuryu.hokkaido.jp",
      "hokuto.hokkaido.jp",
      "honbetsu.hokkaido.jp",
      "horokanai.hokkaido.jp",
      "horonobe.hokkaido.jp",
      "ikeda.hokkaido.jp",
      "imakane.hokkaido.jp",
      "ishikari.hokkaido.jp",
      "iwamizawa.hokkaido.jp",
      "iwanai.hokkaido.jp",
      "kamifurano.hokkaido.jp",
      "kamikawa.hokkaido.jp",
      "kamishihoro.hokkaido.jp",
      "kamisunagawa.hokkaido.jp",
      "kamoenai.hokkaido.jp",
      "kayabe.hokkaido.jp",
      "kembuchi.hokkaido.jp",
      "kikonai.hokkaido.jp",
      "kimobetsu.hokkaido.jp",
      "kitahiroshima.hokkaido.jp",
      "kitami.hokkaido.jp",
      "kiyosato.hokkaido.jp",
      "koshimizu.hokkaido.jp",
      "kunneppu.hokkaido.jp",
      "kuriyama.hokkaido.jp",
      "kuromatsunai.hokkaido.jp",
      "kushiro.hokkaido.jp",
      "kutchan.hokkaido.jp",
      "kyowa.hokkaido.jp",
      "mashike.hokkaido.jp",
      "matsumae.hokkaido.jp",
      "mikasa.hokkaido.jp",
      "minamifurano.hokkaido.jp",
      "mombetsu.hokkaido.jp",
      "moseushi.hokkaido.jp",
      "mukawa.hokkaido.jp",
      "muroran.hokkaido.jp",
      "naie.hokkaido.jp",
      "nakagawa.hokkaido.jp",
      "nakasatsunai.hokkaido.jp",
      "nakatombetsu.hokkaido.jp",
      "nanae.hokkaido.jp",
      "nanporo.hokkaido.jp",
      "nayoro.hokkaido.jp",
      "nemuro.hokkaido.jp",
      "niikappu.hokkaido.jp",
      "niki.hokkaido.jp",
      "nishiokoppe.hokkaido.jp",
      "noboribetsu.hokkaido.jp",
      "numata.hokkaido.jp",
      "obihiro.hokkaido.jp",
      "obira.hokkaido.jp",
      "oketo.hokkaido.jp",
      "okoppe.hokkaido.jp",
      "otaru.hokkaido.jp",
      "otobe.hokkaido.jp",
      "otofuke.hokkaido.jp",
      "otoineppu.hokkaido.jp",
      "oumu.hokkaido.jp",
      "ozora.hokkaido.jp",
      "pippu.hokkaido.jp",
      "rankoshi.hokkaido.jp",
      "rebun.hokkaido.jp",
      "rikubetsu.hokkaido.jp",
      "rishiri.hokkaido.jp",
      "rishirifuji.hokkaido.jp",
      "saroma.hokkaido.jp",
      "sarufutsu.hokkaido.jp",
      "shakotan.hokkaido.jp",
      "shari.hokkaido.jp",
      "shibecha.hokkaido.jp",
      "shibetsu.hokkaido.jp",
      "shikabe.hokkaido.jp",
      "shikaoi.hokkaido.jp",
      "shimamaki.hokkaido.jp",
      "shimizu.hokkaido.jp",
      "shimokawa.hokkaido.jp",
      "shinshinotsu.hokkaido.jp",
      "shintoku.hokkaido.jp",
      "shiranuka.hokkaido.jp",
      "shiraoi.hokkaido.jp",
      "shiriuchi.hokkaido.jp",
      "sobetsu.hokkaido.jp",
      "sunagawa.hokkaido.jp",
      "taiki.hokkaido.jp",
      "takasu.hokkaido.jp",
      "takikawa.hokkaido.jp",
      "takinoue.hokkaido.jp",
      "teshikaga.hokkaido.jp",
      "tobetsu.hokkaido.jp",
      "tohma.hokkaido.jp",
      "tomakomai.hokkaido.jp",
      "tomari.hokkaido.jp",
      "toya.hokkaido.jp",
      "toyako.hokkaido.jp",
      "toyotomi.hokkaido.jp",
      "toyoura.hokkaido.jp",
      "tsubetsu.hokkaido.jp",
      "tsukigata.hokkaido.jp",
      "urakawa.hokkaido.jp",
      "urausu.hokkaido.jp",
      "uryu.hokkaido.jp",
      "utashinai.hokkaido.jp",
      "wakkanai.hokkaido.jp",
      "wassamu.hokkaido.jp",
      "yakumo.hokkaido.jp",
      "yoichi.hokkaido.jp",
      "aioi.hyogo.jp",
      "akashi.hyogo.jp",
      "ako.hyogo.jp",
      "amagasaki.hyogo.jp",
      "aogaki.hyogo.jp",
      "asago.hyogo.jp",
      "ashiya.hyogo.jp",
      "awaji.hyogo.jp",
      "fukusaki.hyogo.jp",
      "goshiki.hyogo.jp",
      "harima.hyogo.jp",
      "himeji.hyogo.jp",
      "ichikawa.hyogo.jp",
      "inagawa.hyogo.jp",
      "itami.hyogo.jp",
      "kakogawa.hyogo.jp",
      "kamigori.hyogo.jp",
      "kamikawa.hyogo.jp",
      "kasai.hyogo.jp",
      "kasuga.hyogo.jp",
      "kawanishi.hyogo.jp",
      "miki.hyogo.jp",
      "minamiawaji.hyogo.jp",
      "nishinomiya.hyogo.jp",
      "nishiwaki.hyogo.jp",
      "ono.hyogo.jp",
      "sanda.hyogo.jp",
      "sannan.hyogo.jp",
      "sasayama.hyogo.jp",
      "sayo.hyogo.jp",
      "shingu.hyogo.jp",
      "shinonsen.hyogo.jp",
      "shiso.hyogo.jp",
      "sumoto.hyogo.jp",
      "taishi.hyogo.jp",
      "taka.hyogo.jp",
      "takarazuka.hyogo.jp",
      "takasago.hyogo.jp",
      "takino.hyogo.jp",
      "tamba.hyogo.jp",
      "tatsuno.hyogo.jp",
      "toyooka.hyogo.jp",
      "yabu.hyogo.jp",
      "yashiro.hyogo.jp",
      "yoka.hyogo.jp",
      "yokawa.hyogo.jp",
      "ami.ibaraki.jp",
      "asahi.ibaraki.jp",
      "bando.ibaraki.jp",
      "chikusei.ibaraki.jp",
      "daigo.ibaraki.jp",
      "fujishiro.ibaraki.jp",
      "hitachi.ibaraki.jp",
      "hitachinaka.ibaraki.jp",
      "hitachiomiya.ibaraki.jp",
      "hitachiota.ibaraki.jp",
      "ibaraki.ibaraki.jp",
      "ina.ibaraki.jp",
      "inashiki.ibaraki.jp",
      "itako.ibaraki.jp",
      "iwama.ibaraki.jp",
      "joso.ibaraki.jp",
      "kamisu.ibaraki.jp",
      "kasama.ibaraki.jp",
      "kashima.ibaraki.jp",
      "kasumigaura.ibaraki.jp",
      "koga.ibaraki.jp",
      "miho.ibaraki.jp",
      "mito.ibaraki.jp",
      "moriya.ibaraki.jp",
      "naka.ibaraki.jp",
      "namegata.ibaraki.jp",
      "oarai.ibaraki.jp",
      "ogawa.ibaraki.jp",
      "omitama.ibaraki.jp",
      "ryugasaki.ibaraki.jp",
      "sakai.ibaraki.jp",
      "sakuragawa.ibaraki.jp",
      "shimodate.ibaraki.jp",
      "shimotsuma.ibaraki.jp",
      "shirosato.ibaraki.jp",
      "sowa.ibaraki.jp",
      "suifu.ibaraki.jp",
      "takahagi.ibaraki.jp",
      "tamatsukuri.ibaraki.jp",
      "tokai.ibaraki.jp",
      "tomobe.ibaraki.jp",
      "tone.ibaraki.jp",
      "toride.ibaraki.jp",
      "tsuchiura.ibaraki.jp",
      "tsukuba.ibaraki.jp",
      "uchihara.ibaraki.jp",
      "ushiku.ibaraki.jp",
      "yachiyo.ibaraki.jp",
      "yamagata.ibaraki.jp",
      "yawara.ibaraki.jp",
      "yuki.ibaraki.jp",
      "anamizu.ishikawa.jp",
      "hakui.ishikawa.jp",
      "hakusan.ishikawa.jp",
      "kaga.ishikawa.jp",
      "kahoku.ishikawa.jp",
      "kanazawa.ishikawa.jp",
      "kawakita.ishikawa.jp",
      "komatsu.ishikawa.jp",
      "nakanoto.ishikawa.jp",
      "nanao.ishikawa.jp",
      "nomi.ishikawa.jp",
      "nonoichi.ishikawa.jp",
      "noto.ishikawa.jp",
      "shika.ishikawa.jp",
      "suzu.ishikawa.jp",
      "tsubata.ishikawa.jp",
      "tsurugi.ishikawa.jp",
      "uchinada.ishikawa.jp",
      "wajima.ishikawa.jp",
      "fudai.iwate.jp",
      "fujisawa.iwate.jp",
      "hanamaki.iwate.jp",
      "hiraizumi.iwate.jp",
      "hirono.iwate.jp",
      "ichinohe.iwate.jp",
      "ichinoseki.iwate.jp",
      "iwaizumi.iwate.jp",
      "iwate.iwate.jp",
      "joboji.iwate.jp",
      "kamaishi.iwate.jp",
      "kanegasaki.iwate.jp",
      "karumai.iwate.jp",
      "kawai.iwate.jp",
      "kitakami.iwate.jp",
      "kuji.iwate.jp",
      "kunohe.iwate.jp",
      "kuzumaki.iwate.jp",
      "miyako.iwate.jp",
      "mizusawa.iwate.jp",
      "morioka.iwate.jp",
      "ninohe.iwate.jp",
      "noda.iwate.jp",
      "ofunato.iwate.jp",
      "oshu.iwate.jp",
      "otsuchi.iwate.jp",
      "rikuzentakata.iwate.jp",
      "shiwa.iwate.jp",
      "shizukuishi.iwate.jp",
      "sumita.iwate.jp",
      "tanohata.iwate.jp",
      "tono.iwate.jp",
      "yahaba.iwate.jp",
      "yamada.iwate.jp",
      "ayagawa.kagawa.jp",
      "higashikagawa.kagawa.jp",
      "kanonji.kagawa.jp",
      "kotohira.kagawa.jp",
      "manno.kagawa.jp",
      "marugame.kagawa.jp",
      "mitoyo.kagawa.jp",
      "naoshima.kagawa.jp",
      "sanuki.kagawa.jp",
      "tadotsu.kagawa.jp",
      "takamatsu.kagawa.jp",
      "tonosho.kagawa.jp",
      "uchinomi.kagawa.jp",
      "utazu.kagawa.jp",
      "zentsuji.kagawa.jp",
      "akune.kagoshima.jp",
      "amami.kagoshima.jp",
      "hioki.kagoshima.jp",
      "isa.kagoshima.jp",
      "isen.kagoshima.jp",
      "izumi.kagoshima.jp",
      "kagoshima.kagoshima.jp",
      "kanoya.kagoshima.jp",
      "kawanabe.kagoshima.jp",
      "kinko.kagoshima.jp",
      "kouyama.kagoshima.jp",
      "makurazaki.kagoshima.jp",
      "matsumoto.kagoshima.jp",
      "minamitane.kagoshima.jp",
      "nakatane.kagoshima.jp",
      "nishinoomote.kagoshima.jp",
      "satsumasendai.kagoshima.jp",
      "soo.kagoshima.jp",
      "tarumizu.kagoshima.jp",
      "yusui.kagoshima.jp",
      "aikawa.kanagawa.jp",
      "atsugi.kanagawa.jp",
      "ayase.kanagawa.jp",
      "chigasaki.kanagawa.jp",
      "ebina.kanagawa.jp",
      "fujisawa.kanagawa.jp",
      "hadano.kanagawa.jp",
      "hakone.kanagawa.jp",
      "hiratsuka.kanagawa.jp",
      "isehara.kanagawa.jp",
      "kaisei.kanagawa.jp",
      "kamakura.kanagawa.jp",
      "kiyokawa.kanagawa.jp",
      "matsuda.kanagawa.jp",
      "minamiashigara.kanagawa.jp",
      "miura.kanagawa.jp",
      "nakai.kanagawa.jp",
      "ninomiya.kanagawa.jp",
      "odawara.kanagawa.jp",
      "oi.kanagawa.jp",
      "oiso.kanagawa.jp",
      "sagamihara.kanagawa.jp",
      "samukawa.kanagawa.jp",
      "tsukui.kanagawa.jp",
      "yamakita.kanagawa.jp",
      "yamato.kanagawa.jp",
      "yokosuka.kanagawa.jp",
      "yugawara.kanagawa.jp",
      "zama.kanagawa.jp",
      "zushi.kanagawa.jp",
      "aki.kochi.jp",
      "geisei.kochi.jp",
      "hidaka.kochi.jp",
      "higashitsuno.kochi.jp",
      "ino.kochi.jp",
      "kagami.kochi.jp",
      "kami.kochi.jp",
      "kitagawa.kochi.jp",
      "kochi.kochi.jp",
      "mihara.kochi.jp",
      "motoyama.kochi.jp",
      "muroto.kochi.jp",
      "nahari.kochi.jp",
      "nakamura.kochi.jp",
      "nankoku.kochi.jp",
      "nishitosa.kochi.jp",
      "niyodogawa.kochi.jp",
      "ochi.kochi.jp",
      "okawa.kochi.jp",
      "otoyo.kochi.jp",
      "otsuki.kochi.jp",
      "sakawa.kochi.jp",
      "sukumo.kochi.jp",
      "susaki.kochi.jp",
      "tosa.kochi.jp",
      "tosashimizu.kochi.jp",
      "toyo.kochi.jp",
      "tsuno.kochi.jp",
      "umaji.kochi.jp",
      "yasuda.kochi.jp",
      "yusuhara.kochi.jp",
      "amakusa.kumamoto.jp",
      "arao.kumamoto.jp",
      "aso.kumamoto.jp",
      "choyo.kumamoto.jp",
      "gyokuto.kumamoto.jp",
      "kamiamakusa.kumamoto.jp",
      "kikuchi.kumamoto.jp",
      "kumamoto.kumamoto.jp",
      "mashiki.kumamoto.jp",
      "mifune.kumamoto.jp",
      "minamata.kumamoto.jp",
      "minamioguni.kumamoto.jp",
      "nagasu.kumamoto.jp",
      "nishihara.kumamoto.jp",
      "oguni.kumamoto.jp",
      "ozu.kumamoto.jp",
      "sumoto.kumamoto.jp",
      "takamori.kumamoto.jp",
      "uki.kumamoto.jp",
      "uto.kumamoto.jp",
      "yamaga.kumamoto.jp",
      "yamato.kumamoto.jp",
      "yatsushiro.kumamoto.jp",
      "ayabe.kyoto.jp",
      "fukuchiyama.kyoto.jp",
      "higashiyama.kyoto.jp",
      "ide.kyoto.jp",
      "ine.kyoto.jp",
      "joyo.kyoto.jp",
      "kameoka.kyoto.jp",
      "kamo.kyoto.jp",
      "kita.kyoto.jp",
      "kizu.kyoto.jp",
      "kumiyama.kyoto.jp",
      "kyotamba.kyoto.jp",
      "kyotanabe.kyoto.jp",
      "kyotango.kyoto.jp",
      "maizuru.kyoto.jp",
      "minami.kyoto.jp",
      "minamiyamashiro.kyoto.jp",
      "miyazu.kyoto.jp",
      "muko.kyoto.jp",
      "nagaokakyo.kyoto.jp",
      "nakagyo.kyoto.jp",
      "nantan.kyoto.jp",
      "oyamazaki.kyoto.jp",
      "sakyo.kyoto.jp",
      "seika.kyoto.jp",
      "tanabe.kyoto.jp",
      "uji.kyoto.jp",
      "ujitawara.kyoto.jp",
      "wazuka.kyoto.jp",
      "yamashina.kyoto.jp",
      "yawata.kyoto.jp",
      "asahi.mie.jp",
      "inabe.mie.jp",
      "ise.mie.jp",
      "kameyama.mie.jp",
      "kawagoe.mie.jp",
      "kiho.mie.jp",
      "kisosaki.mie.jp",
      "kiwa.mie.jp",
      "komono.mie.jp",
      "kumano.mie.jp",
      "kuwana.mie.jp",
      "matsusaka.mie.jp",
      "meiwa.mie.jp",
      "mihama.mie.jp",
      "minamiise.mie.jp",
      "misugi.mie.jp",
      "miyama.mie.jp",
      "nabari.mie.jp",
      "shima.mie.jp",
      "suzuka.mie.jp",
      "tado.mie.jp",
      "taiki.mie.jp",
      "taki.mie.jp",
      "tamaki.mie.jp",
      "toba.mie.jp",
      "tsu.mie.jp",
      "udono.mie.jp",
      "ureshino.mie.jp",
      "watarai.mie.jp",
      "yokkaichi.mie.jp",
      "furukawa.miyagi.jp",
      "higashimatsushima.miyagi.jp",
      "ishinomaki.miyagi.jp",
      "iwanuma.miyagi.jp",
      "kakuda.miyagi.jp",
      "kami.miyagi.jp",
      "kawasaki.miyagi.jp",
      "marumori.miyagi.jp",
      "matsushima.miyagi.jp",
      "minamisanriku.miyagi.jp",
      "misato.miyagi.jp",
      "murata.miyagi.jp",
      "natori.miyagi.jp",
      "ogawara.miyagi.jp",
      "ohira.miyagi.jp",
      "onagawa.miyagi.jp",
      "osaki.miyagi.jp",
      "rifu.miyagi.jp",
      "semine.miyagi.jp",
      "shibata.miyagi.jp",
      "shichikashuku.miyagi.jp",
      "shikama.miyagi.jp",
      "shiogama.miyagi.jp",
      "shiroishi.miyagi.jp",
      "tagajo.miyagi.jp",
      "taiwa.miyagi.jp",
      "tome.miyagi.jp",
      "tomiya.miyagi.jp",
      "wakuya.miyagi.jp",
      "watari.miyagi.jp",
      "yamamoto.miyagi.jp",
      "zao.miyagi.jp",
      "aya.miyazaki.jp",
      "ebino.miyazaki.jp",
      "gokase.miyazaki.jp",
      "hyuga.miyazaki.jp",
      "kadogawa.miyazaki.jp",
      "kawaminami.miyazaki.jp",
      "kijo.miyazaki.jp",
      "kitagawa.miyazaki.jp",
      "kitakata.miyazaki.jp",
      "kitaura.miyazaki.jp",
      "kobayashi.miyazaki.jp",
      "kunitomi.miyazaki.jp",
      "kushima.miyazaki.jp",
      "mimata.miyazaki.jp",
      "miyakonojo.miyazaki.jp",
      "miyazaki.miyazaki.jp",
      "morotsuka.miyazaki.jp",
      "nichinan.miyazaki.jp",
      "nishimera.miyazaki.jp",
      "nobeoka.miyazaki.jp",
      "saito.miyazaki.jp",
      "shiiba.miyazaki.jp",
      "shintomi.miyazaki.jp",
      "takaharu.miyazaki.jp",
      "takanabe.miyazaki.jp",
      "takazaki.miyazaki.jp",
      "tsuno.miyazaki.jp",
      "achi.nagano.jp",
      "agematsu.nagano.jp",
      "anan.nagano.jp",
      "aoki.nagano.jp",
      "asahi.nagano.jp",
      "azumino.nagano.jp",
      "chikuhoku.nagano.jp",
      "chikuma.nagano.jp",
      "chino.nagano.jp",
      "fujimi.nagano.jp",
      "hakuba.nagano.jp",
      "hara.nagano.jp",
      "hiraya.nagano.jp",
      "iida.nagano.jp",
      "iijima.nagano.jp",
      "iiyama.nagano.jp",
      "iizuna.nagano.jp",
      "ikeda.nagano.jp",
      "ikusaka.nagano.jp",
      "ina.nagano.jp",
      "karuizawa.nagano.jp",
      "kawakami.nagano.jp",
      "kiso.nagano.jp",
      "kisofukushima.nagano.jp",
      "kitaaiki.nagano.jp",
      "komagane.nagano.jp",
      "komoro.nagano.jp",
      "matsukawa.nagano.jp",
      "matsumoto.nagano.jp",
      "miasa.nagano.jp",
      "minamiaiki.nagano.jp",
      "minamimaki.nagano.jp",
      "minamiminowa.nagano.jp",
      "minowa.nagano.jp",
      "miyada.nagano.jp",
      "miyota.nagano.jp",
      "mochizuki.nagano.jp",
      "nagano.nagano.jp",
      "nagawa.nagano.jp",
      "nagiso.nagano.jp",
      "nakagawa.nagano.jp",
      "nakano.nagano.jp",
      "nozawaonsen.nagano.jp",
      "obuse.nagano.jp",
      "ogawa.nagano.jp",
      "okaya.nagano.jp",
      "omachi.nagano.jp",
      "omi.nagano.jp",
      "ookuwa.nagano.jp",
      "ooshika.nagano.jp",
      "otaki.nagano.jp",
      "otari.nagano.jp",
      "sakae.nagano.jp",
      "sakaki.nagano.jp",
      "saku.nagano.jp",
      "sakuho.nagano.jp",
      "shimosuwa.nagano.jp",
      "shinanomachi.nagano.jp",
      "shiojiri.nagano.jp",
      "suwa.nagano.jp",
      "suzaka.nagano.jp",
      "takagi.nagano.jp",
      "takamori.nagano.jp",
      "takayama.nagano.jp",
      "tateshina.nagano.jp",
      "tatsuno.nagano.jp",
      "togakushi.nagano.jp",
      "togura.nagano.jp",
      "tomi.nagano.jp",
      "ueda.nagano.jp",
      "wada.nagano.jp",
      "yamagata.nagano.jp",
      "yamanouchi.nagano.jp",
      "yasaka.nagano.jp",
      "yasuoka.nagano.jp",
      "chijiwa.nagasaki.jp",
      "futsu.nagasaki.jp",
      "goto.nagasaki.jp",
      "hasami.nagasaki.jp",
      "hirado.nagasaki.jp",
      "iki.nagasaki.jp",
      "isahaya.nagasaki.jp",
      "kawatana.nagasaki.jp",
      "kuchinotsu.nagasaki.jp",
      "matsuura.nagasaki.jp",
      "nagasaki.nagasaki.jp",
      "obama.nagasaki.jp",
      "omura.nagasaki.jp",
      "oseto.nagasaki.jp",
      "saikai.nagasaki.jp",
      "sasebo.nagasaki.jp",
      "seihi.nagasaki.jp",
      "shimabara.nagasaki.jp",
      "shinkamigoto.nagasaki.jp",
      "togitsu.nagasaki.jp",
      "tsushima.nagasaki.jp",
      "unzen.nagasaki.jp",
      "ando.nara.jp",
      "gose.nara.jp",
      "heguri.nara.jp",
      "higashiyoshino.nara.jp",
      "ikaruga.nara.jp",
      "ikoma.nara.jp",
      "kamikitayama.nara.jp",
      "kanmaki.nara.jp",
      "kashiba.nara.jp",
      "kashihara.nara.jp",
      "katsuragi.nara.jp",
      "kawai.nara.jp",
      "kawakami.nara.jp",
      "kawanishi.nara.jp",
      "koryo.nara.jp",
      "kurotaki.nara.jp",
      "mitsue.nara.jp",
      "miyake.nara.jp",
      "nara.nara.jp",
      "nosegawa.nara.jp",
      "oji.nara.jp",
      "ouda.nara.jp",
      "oyodo.nara.jp",
      "sakurai.nara.jp",
      "sango.nara.jp",
      "shimoichi.nara.jp",
      "shimokitayama.nara.jp",
      "shinjo.nara.jp",
      "soni.nara.jp",
      "takatori.nara.jp",
      "tawaramoto.nara.jp",
      "tenkawa.nara.jp",
      "tenri.nara.jp",
      "uda.nara.jp",
      "yamatokoriyama.nara.jp",
      "yamatotakada.nara.jp",
      "yamazoe.nara.jp",
      "yoshino.nara.jp",
      "aga.niigata.jp",
      "agano.niigata.jp",
      "gosen.niigata.jp",
      "itoigawa.niigata.jp",
      "izumozaki.niigata.jp",
      "joetsu.niigata.jp",
      "kamo.niigata.jp",
      "kariwa.niigata.jp",
      "kashiwazaki.niigata.jp",
      "minamiuonuma.niigata.jp",
      "mitsuke.niigata.jp",
      "muika.niigata.jp",
      "murakami.niigata.jp",
      "myoko.niigata.jp",
      "nagaoka.niigata.jp",
      "niigata.niigata.jp",
      "ojiya.niigata.jp",
      "omi.niigata.jp",
      "sado.niigata.jp",
      "sanjo.niigata.jp",
      "seiro.niigata.jp",
      "seirou.niigata.jp",
      "sekikawa.niigata.jp",
      "shibata.niigata.jp",
      "tagami.niigata.jp",
      "tainai.niigata.jp",
      "tochio.niigata.jp",
      "tokamachi.niigata.jp",
      "tsubame.niigata.jp",
      "tsunan.niigata.jp",
      "uonuma.niigata.jp",
      "yahiko.niigata.jp",
      "yoita.niigata.jp",
      "yuzawa.niigata.jp",
      "beppu.oita.jp",
      "bungoono.oita.jp",
      "bungotakada.oita.jp",
      "hasama.oita.jp",
      "hiji.oita.jp",
      "himeshima.oita.jp",
      "hita.oita.jp",
      "kamitsue.oita.jp",
      "kokonoe.oita.jp",
      "kuju.oita.jp",
      "kunisaki.oita.jp",
      "kusu.oita.jp",
      "oita.oita.jp",
      "saiki.oita.jp",
      "taketa.oita.jp",
      "tsukumi.oita.jp",
      "usa.oita.jp",
      "usuki.oita.jp",
      "yufu.oita.jp",
      "akaiwa.okayama.jp",
      "asakuchi.okayama.jp",
      "bizen.okayama.jp",
      "hayashima.okayama.jp",
      "ibara.okayama.jp",
      "kagamino.okayama.jp",
      "kasaoka.okayama.jp",
      "kibichuo.okayama.jp",
      "kumenan.okayama.jp",
      "kurashiki.okayama.jp",
      "maniwa.okayama.jp",
      "misaki.okayama.jp",
      "nagi.okayama.jp",
      "niimi.okayama.jp",
      "nishiawakura.okayama.jp",
      "okayama.okayama.jp",
      "satosho.okayama.jp",
      "setouchi.okayama.jp",
      "shinjo.okayama.jp",
      "shoo.okayama.jp",
      "soja.okayama.jp",
      "takahashi.okayama.jp",
      "tamano.okayama.jp",
      "tsuyama.okayama.jp",
      "wake.okayama.jp",
      "yakage.okayama.jp",
      "aguni.okinawa.jp",
      "ginowan.okinawa.jp",
      "ginoza.okinawa.jp",
      "gushikami.okinawa.jp",
      "haebaru.okinawa.jp",
      "higashi.okinawa.jp",
      "hirara.okinawa.jp",
      "iheya.okinawa.jp",
      "ishigaki.okinawa.jp",
      "ishikawa.okinawa.jp",
      "itoman.okinawa.jp",
      "izena.okinawa.jp",
      "kadena.okinawa.jp",
      "kin.okinawa.jp",
      "kitadaito.okinawa.jp",
      "kitanakagusuku.okinawa.jp",
      "kumejima.okinawa.jp",
      "kunigami.okinawa.jp",
      "minamidaito.okinawa.jp",
      "motobu.okinawa.jp",
      "nago.okinawa.jp",
      "naha.okinawa.jp",
      "nakagusuku.okinawa.jp",
      "nakijin.okinawa.jp",
      "nanjo.okinawa.jp",
      "nishihara.okinawa.jp",
      "ogimi.okinawa.jp",
      "okinawa.okinawa.jp",
      "onna.okinawa.jp",
      "shimoji.okinawa.jp",
      "taketomi.okinawa.jp",
      "tarama.okinawa.jp",
      "tokashiki.okinawa.jp",
      "tomigusuku.okinawa.jp",
      "tonaki.okinawa.jp",
      "urasoe.okinawa.jp",
      "uruma.okinawa.jp",
      "yaese.okinawa.jp",
      "yomitan.okinawa.jp",
      "yonabaru.okinawa.jp",
      "yonaguni.okinawa.jp",
      "zamami.okinawa.jp",
      "abeno.osaka.jp",
      "chihayaakasaka.osaka.jp",
      "chuo.osaka.jp",
      "daito.osaka.jp",
      "fujiidera.osaka.jp",
      "habikino.osaka.jp",
      "hannan.osaka.jp",
      "higashiosaka.osaka.jp",
      "higashisumiyoshi.osaka.jp",
      "higashiyodogawa.osaka.jp",
      "hirakata.osaka.jp",
      "ibaraki.osaka.jp",
      "ikeda.osaka.jp",
      "izumi.osaka.jp",
      "izumiotsu.osaka.jp",
      "izumisano.osaka.jp",
      "kadoma.osaka.jp",
      "kaizuka.osaka.jp",
      "kanan.osaka.jp",
      "kashiwara.osaka.jp",
      "katano.osaka.jp",
      "kawachinagano.osaka.jp",
      "kishiwada.osaka.jp",
      "kita.osaka.jp",
      "kumatori.osaka.jp",
      "matsubara.osaka.jp",
      "minato.osaka.jp",
      "minoh.osaka.jp",
      "misaki.osaka.jp",
      "moriguchi.osaka.jp",
      "neyagawa.osaka.jp",
      "nishi.osaka.jp",
      "nose.osaka.jp",
      "osakasayama.osaka.jp",
      "sakai.osaka.jp",
      "sayama.osaka.jp",
      "sennan.osaka.jp",
      "settsu.osaka.jp",
      "shijonawate.osaka.jp",
      "shimamoto.osaka.jp",
      "suita.osaka.jp",
      "tadaoka.osaka.jp",
      "taishi.osaka.jp",
      "tajiri.osaka.jp",
      "takaishi.osaka.jp",
      "takatsuki.osaka.jp",
      "tondabayashi.osaka.jp",
      "toyonaka.osaka.jp",
      "toyono.osaka.jp",
      "yao.osaka.jp",
      "ariake.saga.jp",
      "arita.saga.jp",
      "fukudomi.saga.jp",
      "genkai.saga.jp",
      "hamatama.saga.jp",
      "hizen.saga.jp",
      "imari.saga.jp",
      "kamimine.saga.jp",
      "kanzaki.saga.jp",
      "karatsu.saga.jp",
      "kashima.saga.jp",
      "kitagata.saga.jp",
      "kitahata.saga.jp",
      "kiyama.saga.jp",
      "kouhoku.saga.jp",
      "kyuragi.saga.jp",
      "nishiarita.saga.jp",
      "ogi.saga.jp",
      "omachi.saga.jp",
      "ouchi.saga.jp",
      "saga.saga.jp",
      "shiroishi.saga.jp",
      "taku.saga.jp",
      "tara.saga.jp",
      "tosu.saga.jp",
      "yoshinogari.saga.jp",
      "arakawa.saitama.jp",
      "asaka.saitama.jp",
      "chichibu.saitama.jp",
      "fujimi.saitama.jp",
      "fujimino.saitama.jp",
      "fukaya.saitama.jp",
      "hanno.saitama.jp",
      "hanyu.saitama.jp",
      "hasuda.saitama.jp",
      "hatogaya.saitama.jp",
      "hatoyama.saitama.jp",
      "hidaka.saitama.jp",
      "higashichichibu.saitama.jp",
      "higashimatsuyama.saitama.jp",
      "honjo.saitama.jp",
      "ina.saitama.jp",
      "iruma.saitama.jp",
      "iwatsuki.saitama.jp",
      "kamiizumi.saitama.jp",
      "kamikawa.saitama.jp",
      "kamisato.saitama.jp",
      "kasukabe.saitama.jp",
      "kawagoe.saitama.jp",
      "kawaguchi.saitama.jp",
      "kawajima.saitama.jp",
      "kazo.saitama.jp",
      "kitamoto.saitama.jp",
      "koshigaya.saitama.jp",
      "kounosu.saitama.jp",
      "kuki.saitama.jp",
      "kumagaya.saitama.jp",
      "matsubushi.saitama.jp",
      "minano.saitama.jp",
      "misato.saitama.jp",
      "miyashiro.saitama.jp",
      "miyoshi.saitama.jp",
      "moroyama.saitama.jp",
      "nagatoro.saitama.jp",
      "namegawa.saitama.jp",
      "niiza.saitama.jp",
      "ogano.saitama.jp",
      "ogawa.saitama.jp",
      "ogose.saitama.jp",
      "okegawa.saitama.jp",
      "omiya.saitama.jp",
      "otaki.saitama.jp",
      "ranzan.saitama.jp",
      "ryokami.saitama.jp",
      "saitama.saitama.jp",
      "sakado.saitama.jp",
      "satte.saitama.jp",
      "sayama.saitama.jp",
      "shiki.saitama.jp",
      "shiraoka.saitama.jp",
      "soka.saitama.jp",
      "sugito.saitama.jp",
      "toda.saitama.jp",
      "tokigawa.saitama.jp",
      "tokorozawa.saitama.jp",
      "tsurugashima.saitama.jp",
      "urawa.saitama.jp",
      "warabi.saitama.jp",
      "yashio.saitama.jp",
      "yokoze.saitama.jp",
      "yono.saitama.jp",
      "yorii.saitama.jp",
      "yoshida.saitama.jp",
      "yoshikawa.saitama.jp",
      "yoshimi.saitama.jp",
      "aisho.shiga.jp",
      "gamo.shiga.jp",
      "higashiomi.shiga.jp",
      "hikone.shiga.jp",
      "koka.shiga.jp",
      "konan.shiga.jp",
      "kosei.shiga.jp",
      "koto.shiga.jp",
      "kusatsu.shiga.jp",
      "maibara.shiga.jp",
      "moriyama.shiga.jp",
      "nagahama.shiga.jp",
      "nishiazai.shiga.jp",
      "notogawa.shiga.jp",
      "omihachiman.shiga.jp",
      "otsu.shiga.jp",
      "ritto.shiga.jp",
      "ryuoh.shiga.jp",
      "takashima.shiga.jp",
      "takatsuki.shiga.jp",
      "torahime.shiga.jp",
      "toyosato.shiga.jp",
      "yasu.shiga.jp",
      "akagi.shimane.jp",
      "ama.shimane.jp",
      "gotsu.shimane.jp",
      "hamada.shimane.jp",
      "higashiizumo.shimane.jp",
      "hikawa.shimane.jp",
      "hikimi.shimane.jp",
      "izumo.shimane.jp",
      "kakinoki.shimane.jp",
      "masuda.shimane.jp",
      "matsue.shimane.jp",
      "misato.shimane.jp",
      "nishinoshima.shimane.jp",
      "ohda.shimane.jp",
      "okinoshima.shimane.jp",
      "okuizumo.shimane.jp",
      "shimane.shimane.jp",
      "tamayu.shimane.jp",
      "tsuwano.shimane.jp",
      "unnan.shimane.jp",
      "yakumo.shimane.jp",
      "yasugi.shimane.jp",
      "yatsuka.shimane.jp",
      "arai.shizuoka.jp",
      "atami.shizuoka.jp",
      "fuji.shizuoka.jp",
      "fujieda.shizuoka.jp",
      "fujikawa.shizuoka.jp",
      "fujinomiya.shizuoka.jp",
      "fukuroi.shizuoka.jp",
      "gotemba.shizuoka.jp",
      "haibara.shizuoka.jp",
      "hamamatsu.shizuoka.jp",
      "higashiizu.shizuoka.jp",
      "ito.shizuoka.jp",
      "iwata.shizuoka.jp",
      "izu.shizuoka.jp",
      "izunokuni.shizuoka.jp",
      "kakegawa.shizuoka.jp",
      "kannami.shizuoka.jp",
      "kawanehon.shizuoka.jp",
      "kawazu.shizuoka.jp",
      "kikugawa.shizuoka.jp",
      "kosai.shizuoka.jp",
      "makinohara.shizuoka.jp",
      "matsuzaki.shizuoka.jp",
      "minamiizu.shizuoka.jp",
      "mishima.shizuoka.jp",
      "morimachi.shizuoka.jp",
      "nishiizu.shizuoka.jp",
      "numazu.shizuoka.jp",
      "omaezaki.shizuoka.jp",
      "shimada.shizuoka.jp",
      "shimizu.shizuoka.jp",
      "shimoda.shizuoka.jp",
      "shizuoka.shizuoka.jp",
      "susono.shizuoka.jp",
      "yaizu.shizuoka.jp",
      "yoshida.shizuoka.jp",
      "ashikaga.tochigi.jp",
      "bato.tochigi.jp",
      "haga.tochigi.jp",
      "ichikai.tochigi.jp",
      "iwafune.tochigi.jp",
      "kaminokawa.tochigi.jp",
      "kanuma.tochigi.jp",
      "karasuyama.tochigi.jp",
      "kuroiso.tochigi.jp",
      "mashiko.tochigi.jp",
      "mibu.tochigi.jp",
      "moka.tochigi.jp",
      "motegi.tochigi.jp",
      "nasu.tochigi.jp",
      "nasushiobara.tochigi.jp",
      "nikko.tochigi.jp",
      "nishikata.tochigi.jp",
      "nogi.tochigi.jp",
      "ohira.tochigi.jp",
      "ohtawara.tochigi.jp",
      "oyama.tochigi.jp",
      "sakura.tochigi.jp",
      "sano.tochigi.jp",
      "shimotsuke.tochigi.jp",
      "shioya.tochigi.jp",
      "takanezawa.tochigi.jp",
      "tochigi.tochigi.jp",
      "tsuga.tochigi.jp",
      "ujiie.tochigi.jp",
      "utsunomiya.tochigi.jp",
      "yaita.tochigi.jp",
      "aizumi.tokushima.jp",
      "anan.tokushima.jp",
      "ichiba.tokushima.jp",
      "itano.tokushima.jp",
      "kainan.tokushima.jp",
      "komatsushima.tokushima.jp",
      "matsushige.tokushima.jp",
      "mima.tokushima.jp",
      "minami.tokushima.jp",
      "miyoshi.tokushima.jp",
      "mugi.tokushima.jp",
      "nakagawa.tokushima.jp",
      "naruto.tokushima.jp",
      "sanagochi.tokushima.jp",
      "shishikui.tokushima.jp",
      "tokushima.tokushima.jp",
      "wajiki.tokushima.jp",
      "adachi.tokyo.jp",
      "akiruno.tokyo.jp",
      "akishima.tokyo.jp",
      "aogashima.tokyo.jp",
      "arakawa.tokyo.jp",
      "bunkyo.tokyo.jp",
      "chiyoda.tokyo.jp",
      "chofu.tokyo.jp",
      "chuo.tokyo.jp",
      "edogawa.tokyo.jp",
      "fuchu.tokyo.jp",
      "fussa.tokyo.jp",
      "hachijo.tokyo.jp",
      "hachioji.tokyo.jp",
      "hamura.tokyo.jp",
      "higashikurume.tokyo.jp",
      "higashimurayama.tokyo.jp",
      "higashiyamato.tokyo.jp",
      "hino.tokyo.jp",
      "hinode.tokyo.jp",
      "hinohara.tokyo.jp",
      "inagi.tokyo.jp",
      "itabashi.tokyo.jp",
      "katsushika.tokyo.jp",
      "kita.tokyo.jp",
      "kiyose.tokyo.jp",
      "kodaira.tokyo.jp",
      "koganei.tokyo.jp",
      "kokubunji.tokyo.jp",
      "komae.tokyo.jp",
      "koto.tokyo.jp",
      "kouzushima.tokyo.jp",
      "kunitachi.tokyo.jp",
      "machida.tokyo.jp",
      "meguro.tokyo.jp",
      "minato.tokyo.jp",
      "mitaka.tokyo.jp",
      "mizuho.tokyo.jp",
      "musashimurayama.tokyo.jp",
      "musashino.tokyo.jp",
      "nakano.tokyo.jp",
      "nerima.tokyo.jp",
      "ogasawara.tokyo.jp",
      "okutama.tokyo.jp",
      "ome.tokyo.jp",
      "oshima.tokyo.jp",
      "ota.tokyo.jp",
      "setagaya.tokyo.jp",
      "shibuya.tokyo.jp",
      "shinagawa.tokyo.jp",
      "shinjuku.tokyo.jp",
      "suginami.tokyo.jp",
      "sumida.tokyo.jp",
      "tachikawa.tokyo.jp",
      "taito.tokyo.jp",
      "tama.tokyo.jp",
      "toshima.tokyo.jp",
      "chizu.tottori.jp",
      "hino.tottori.jp",
      "kawahara.tottori.jp",
      "koge.tottori.jp",
      "kotoura.tottori.jp",
      "misasa.tottori.jp",
      "nanbu.tottori.jp",
      "nichinan.tottori.jp",
      "sakaiminato.tottori.jp",
      "tottori.tottori.jp",
      "wakasa.tottori.jp",
      "yazu.tottori.jp",
      "yonago.tottori.jp",
      "asahi.toyama.jp",
      "fuchu.toyama.jp",
      "fukumitsu.toyama.jp",
      "funahashi.toyama.jp",
      "himi.toyama.jp",
      "imizu.toyama.jp",
      "inami.toyama.jp",
      "johana.toyama.jp",
      "kamiichi.toyama.jp",
      "kurobe.toyama.jp",
      "nakaniikawa.toyama.jp",
      "namerikawa.toyama.jp",
      "nanto.toyama.jp",
      "nyuzen.toyama.jp",
      "oyabe.toyama.jp",
      "taira.toyama.jp",
      "takaoka.toyama.jp",
      "tateyama.toyama.jp",
      "toga.toyama.jp",
      "tonami.toyama.jp",
      "toyama.toyama.jp",
      "unazuki.toyama.jp",
      "uozu.toyama.jp",
      "yamada.toyama.jp",
      "arida.wakayama.jp",
      "aridagawa.wakayama.jp",
      "gobo.wakayama.jp",
      "hashimoto.wakayama.jp",
      "hidaka.wakayama.jp",
      "hirogawa.wakayama.jp",
      "inami.wakayama.jp",
      "iwade.wakayama.jp",
      "kainan.wakayama.jp",
      "kamitonda.wakayama.jp",
      "katsuragi.wakayama.jp",
      "kimino.wakayama.jp",
      "kinokawa.wakayama.jp",
      "kitayama.wakayama.jp",
      "koya.wakayama.jp",
      "koza.wakayama.jp",
      "kozagawa.wakayama.jp",
      "kudoyama.wakayama.jp",
      "kushimoto.wakayama.jp",
      "mihama.wakayama.jp",
      "misato.wakayama.jp",
      "nachikatsuura.wakayama.jp",
      "shingu.wakayama.jp",
      "shirahama.wakayama.jp",
      "taiji.wakayama.jp",
      "tanabe.wakayama.jp",
      "wakayama.wakayama.jp",
      "yuasa.wakayama.jp",
      "yura.wakayama.jp",
      "asahi.yamagata.jp",
      "funagata.yamagata.jp",
      "higashine.yamagata.jp",
      "iide.yamagata.jp",
      "kahoku.yamagata.jp",
      "kaminoyama.yamagata.jp",
      "kaneyama.yamagata.jp",
      "kawanishi.yamagata.jp",
      "mamurogawa.yamagata.jp",
      "mikawa.yamagata.jp",
      "murayama.yamagata.jp",
      "nagai.yamagata.jp",
      "nakayama.yamagata.jp",
      "nanyo.yamagata.jp",
      "nishikawa.yamagata.jp",
      "obanazawa.yamagata.jp",
      "oe.yamagata.jp",
      "oguni.yamagata.jp",
      "ohkura.yamagata.jp",
      "oishida.yamagata.jp",
      "sagae.yamagata.jp",
      "sakata.yamagata.jp",
      "sakegawa.yamagata.jp",
      "shinjo.yamagata.jp",
      "shirataka.yamagata.jp",
      "shonai.yamagata.jp",
      "takahata.yamagata.jp",
      "tendo.yamagata.jp",
      "tozawa.yamagata.jp",
      "tsuruoka.yamagata.jp",
      "yamagata.yamagata.jp",
      "yamanobe.yamagata.jp",
      "yonezawa.yamagata.jp",
      "yuza.yamagata.jp",
      "abu.yamaguchi.jp",
      "hagi.yamaguchi.jp",
      "hikari.yamaguchi.jp",
      "hofu.yamaguchi.jp",
      "iwakuni.yamaguchi.jp",
      "kudamatsu.yamaguchi.jp",
      "mitou.yamaguchi.jp",
      "nagato.yamaguchi.jp",
      "oshima.yamaguchi.jp",
      "shimonoseki.yamaguchi.jp",
      "shunan.yamaguchi.jp",
      "tabuse.yamaguchi.jp",
      "tokuyama.yamaguchi.jp",
      "toyota.yamaguchi.jp",
      "ube.yamaguchi.jp",
      "yuu.yamaguchi.jp",
      "chuo.yamanashi.jp",
      "doshi.yamanashi.jp",
      "fuefuki.yamanashi.jp",
      "fujikawa.yamanashi.jp",
      "fujikawaguchiko.yamanashi.jp",
      "fujiyoshida.yamanashi.jp",
      "hayakawa.yamanashi.jp",
      "hokuto.yamanashi.jp",
      "ichikawamisato.yamanashi.jp",
      "kai.yamanashi.jp",
      "kofu.yamanashi.jp",
      "koshu.yamanashi.jp",
      "kosuge.yamanashi.jp",
      "minami-alps.yamanashi.jp",
      "minobu.yamanashi.jp",
      "nakamichi.yamanashi.jp",
      "nanbu.yamanashi.jp",
      "narusawa.yamanashi.jp",
      "nirasaki.yamanashi.jp",
      "nishikatsura.yamanashi.jp",
      "oshino.yamanashi.jp",
      "otsuki.yamanashi.jp",
      "showa.yamanashi.jp",
      "tabayama.yamanashi.jp",
      "tsuru.yamanashi.jp",
      "uenohara.yamanashi.jp",
      "yamanakako.yamanashi.jp",
      "yamanashi.yamanashi.jp",
      "ke",
      "ac.ke",
      "co.ke",
      "go.ke",
      "info.ke",
      "me.ke",
      "mobi.ke",
      "ne.ke",
      "or.ke",
      "sc.ke",
      "kg",
      "org.kg",
      "net.kg",
      "com.kg",
      "edu.kg",
      "gov.kg",
      "mil.kg",
      "*.kh",
      "ki",
      "edu.ki",
      "biz.ki",
      "net.ki",
      "org.ki",
      "gov.ki",
      "info.ki",
      "com.ki",
      "km",
      "org.km",
      "nom.km",
      "gov.km",
      "prd.km",
      "tm.km",
      "edu.km",
      "mil.km",
      "ass.km",
      "com.km",
      "coop.km",
      "asso.km",
      "presse.km",
      "medecin.km",
      "notaires.km",
      "pharmaciens.km",
      "veterinaire.km",
      "gouv.km",
      "kn",
      "net.kn",
      "org.kn",
      "edu.kn",
      "gov.kn",
      "kp",
      "com.kp",
      "edu.kp",
      "gov.kp",
      "org.kp",
      "rep.kp",
      "tra.kp",
      "kr",
      "ac.kr",
      "co.kr",
      "es.kr",
      "go.kr",
      "hs.kr",
      "kg.kr",
      "mil.kr",
      "ms.kr",
      "ne.kr",
      "or.kr",
      "pe.kr",
      "re.kr",
      "sc.kr",
      "busan.kr",
      "chungbuk.kr",
      "chungnam.kr",
      "daegu.kr",
      "daejeon.kr",
      "gangwon.kr",
      "gwangju.kr",
      "gyeongbuk.kr",
      "gyeonggi.kr",
      "gyeongnam.kr",
      "incheon.kr",
      "jeju.kr",
      "jeonbuk.kr",
      "jeonnam.kr",
      "seoul.kr",
      "ulsan.kr",
      "kw",
      "com.kw",
      "edu.kw",
      "emb.kw",
      "gov.kw",
      "ind.kw",
      "net.kw",
      "org.kw",
      "ky",
      "com.ky",
      "edu.ky",
      "net.ky",
      "org.ky",
      "kz",
      "org.kz",
      "edu.kz",
      "net.kz",
      "gov.kz",
      "mil.kz",
      "com.kz",
      "la",
      "int.la",
      "net.la",
      "info.la",
      "edu.la",
      "gov.la",
      "per.la",
      "com.la",
      "org.la",
      "lb",
      "com.lb",
      "edu.lb",
      "gov.lb",
      "net.lb",
      "org.lb",
      "lc",
      "com.lc",
      "net.lc",
      "co.lc",
      "org.lc",
      "edu.lc",
      "gov.lc",
      "li",
      "lk",
      "gov.lk",
      "sch.lk",
      "net.lk",
      "int.lk",
      "com.lk",
      "org.lk",
      "edu.lk",
      "ngo.lk",
      "soc.lk",
      "web.lk",
      "ltd.lk",
      "assn.lk",
      "grp.lk",
      "hotel.lk",
      "ac.lk",
      "lr",
      "com.lr",
      "edu.lr",
      "gov.lr",
      "org.lr",
      "net.lr",
      "ls",
      "ac.ls",
      "biz.ls",
      "co.ls",
      "edu.ls",
      "gov.ls",
      "info.ls",
      "net.ls",
      "org.ls",
      "sc.ls",
      "lt",
      "gov.lt",
      "lu",
      "lv",
      "com.lv",
      "edu.lv",
      "gov.lv",
      "org.lv",
      "mil.lv",
      "id.lv",
      "net.lv",
      "asn.lv",
      "conf.lv",
      "ly",
      "com.ly",
      "net.ly",
      "gov.ly",
      "plc.ly",
      "edu.ly",
      "sch.ly",
      "med.ly",
      "org.ly",
      "id.ly",
      "ma",
      "co.ma",
      "net.ma",
      "gov.ma",
      "org.ma",
      "ac.ma",
      "press.ma",
      "mc",
      "tm.mc",
      "asso.mc",
      "md",
      "me",
      "co.me",
      "net.me",
      "org.me",
      "edu.me",
      "ac.me",
      "gov.me",
      "its.me",
      "priv.me",
      "mg",
      "org.mg",
      "nom.mg",
      "gov.mg",
      "prd.mg",
      "tm.mg",
      "edu.mg",
      "mil.mg",
      "com.mg",
      "co.mg",
      "mh",
      "mil",
      "mk",
      "com.mk",
      "org.mk",
      "net.mk",
      "edu.mk",
      "gov.mk",
      "inf.mk",
      "name.mk",
      "ml",
      "com.ml",
      "edu.ml",
      "gouv.ml",
      "gov.ml",
      "net.ml",
      "org.ml",
      "presse.ml",
      "*.mm",
      "mn",
      "gov.mn",
      "edu.mn",
      "org.mn",
      "mo",
      "com.mo",
      "net.mo",
      "org.mo",
      "edu.mo",
      "gov.mo",
      "mobi",
      "mp",
      "mq",
      "mr",
      "gov.mr",
      "ms",
      "com.ms",
      "edu.ms",
      "gov.ms",
      "net.ms",
      "org.ms",
      "mt",
      "com.mt",
      "edu.mt",
      "net.mt",
      "org.mt",
      "mu",
      "com.mu",
      "net.mu",
      "org.mu",
      "gov.mu",
      "ac.mu",
      "co.mu",
      "or.mu",
      "museum",
      "academy.museum",
      "agriculture.museum",
      "air.museum",
      "airguard.museum",
      "alabama.museum",
      "alaska.museum",
      "amber.museum",
      "ambulance.museum",
      "american.museum",
      "americana.museum",
      "americanantiques.museum",
      "americanart.museum",
      "amsterdam.museum",
      "and.museum",
      "annefrank.museum",
      "anthro.museum",
      "anthropology.museum",
      "antiques.museum",
      "aquarium.museum",
      "arboretum.museum",
      "archaeological.museum",
      "archaeology.museum",
      "architecture.museum",
      "art.museum",
      "artanddesign.museum",
      "artcenter.museum",
      "artdeco.museum",
      "arteducation.museum",
      "artgallery.museum",
      "arts.museum",
      "artsandcrafts.museum",
      "asmatart.museum",
      "assassination.museum",
      "assisi.museum",
      "association.museum",
      "astronomy.museum",
      "atlanta.museum",
      "austin.museum",
      "australia.museum",
      "automotive.museum",
      "aviation.museum",
      "axis.museum",
      "badajoz.museum",
      "baghdad.museum",
      "bahn.museum",
      "bale.museum",
      "baltimore.museum",
      "barcelona.museum",
      "baseball.museum",
      "basel.museum",
      "baths.museum",
      "bauern.museum",
      "beauxarts.museum",
      "beeldengeluid.museum",
      "bellevue.museum",
      "bergbau.museum",
      "berkeley.museum",
      "berlin.museum",
      "bern.museum",
      "bible.museum",
      "bilbao.museum",
      "bill.museum",
      "birdart.museum",
      "birthplace.museum",
      "bonn.museum",
      "boston.museum",
      "botanical.museum",
      "botanicalgarden.museum",
      "botanicgarden.museum",
      "botany.museum",
      "brandywinevalley.museum",
      "brasil.museum",
      "bristol.museum",
      "british.museum",
      "britishcolumbia.museum",
      "broadcast.museum",
      "brunel.museum",
      "brussel.museum",
      "brussels.museum",
      "bruxelles.museum",
      "building.museum",
      "burghof.museum",
      "bus.museum",
      "bushey.museum",
      "cadaques.museum",
      "california.museum",
      "cambridge.museum",
      "can.museum",
      "canada.museum",
      "capebreton.museum",
      "carrier.museum",
      "cartoonart.museum",
      "casadelamoneda.museum",
      "castle.museum",
      "castres.museum",
      "celtic.museum",
      "center.museum",
      "chattanooga.museum",
      "cheltenham.museum",
      "chesapeakebay.museum",
      "chicago.museum",
      "children.museum",
      "childrens.museum",
      "childrensgarden.museum",
      "chiropractic.museum",
      "chocolate.museum",
      "christiansburg.museum",
      "cincinnati.museum",
      "cinema.museum",
      "circus.museum",
      "civilisation.museum",
      "civilization.museum",
      "civilwar.museum",
      "clinton.museum",
      "clock.museum",
      "coal.museum",
      "coastaldefence.museum",
      "cody.museum",
      "coldwar.museum",
      "collection.museum",
      "colonialwilliamsburg.museum",
      "coloradoplateau.museum",
      "columbia.museum",
      "columbus.museum",
      "communication.museum",
      "communications.museum",
      "community.museum",
      "computer.museum",
      "computerhistory.museum",
      "comunicações.museum",
      "contemporary.museum",
      "contemporaryart.museum",
      "convent.museum",
      "copenhagen.museum",
      "corporation.museum",
      "correios-e-telecomunicações.museum",
      "corvette.museum",
      "costume.museum",
      "countryestate.museum",
      "county.museum",
      "crafts.museum",
      "cranbrook.museum",
      "creation.museum",
      "cultural.museum",
      "culturalcenter.museum",
      "culture.museum",
      "cyber.museum",
      "cymru.museum",
      "dali.museum",
      "dallas.museum",
      "database.museum",
      "ddr.museum",
      "decorativearts.museum",
      "delaware.museum",
      "delmenhorst.museum",
      "denmark.museum",
      "depot.museum",
      "design.museum",
      "detroit.museum",
      "dinosaur.museum",
      "discovery.museum",
      "dolls.museum",
      "donostia.museum",
      "durham.museum",
      "eastafrica.museum",
      "eastcoast.museum",
      "education.museum",
      "educational.museum",
      "egyptian.museum",
      "eisenbahn.museum",
      "elburg.museum",
      "elvendrell.museum",
      "embroidery.museum",
      "encyclopedic.museum",
      "england.museum",
      "entomology.museum",
      "environment.museum",
      "environmentalconservation.museum",
      "epilepsy.museum",
      "essex.museum",
      "estate.museum",
      "ethnology.museum",
      "exeter.museum",
      "exhibition.museum",
      "family.museum",
      "farm.museum",
      "farmequipment.museum",
      "farmers.museum",
      "farmstead.museum",
      "field.museum",
      "figueres.museum",
      "filatelia.museum",
      "film.museum",
      "fineart.museum",
      "finearts.museum",
      "finland.museum",
      "flanders.museum",
      "florida.museum",
      "force.museum",
      "fortmissoula.museum",
      "fortworth.museum",
      "foundation.museum",
      "francaise.museum",
      "frankfurt.museum",
      "franziskaner.museum",
      "freemasonry.museum",
      "freiburg.museum",
      "fribourg.museum",
      "frog.museum",
      "fundacio.museum",
      "furniture.museum",
      "gallery.museum",
      "garden.museum",
      "gateway.museum",
      "geelvinck.museum",
      "gemological.museum",
      "geology.museum",
      "georgia.museum",
      "giessen.museum",
      "glas.museum",
      "glass.museum",
      "gorge.museum",
      "grandrapids.museum",
      "graz.museum",
      "guernsey.museum",
      "halloffame.museum",
      "hamburg.museum",
      "handson.museum",
      "harvestcelebration.museum",
      "hawaii.museum",
      "health.museum",
      "heimatunduhren.museum",
      "hellas.museum",
      "helsinki.museum",
      "hembygdsforbund.museum",
      "heritage.museum",
      "histoire.museum",
      "historical.museum",
      "historicalsociety.museum",
      "historichouses.museum",
      "historisch.museum",
      "historisches.museum",
      "history.museum",
      "historyofscience.museum",
      "horology.museum",
      "house.museum",
      "humanities.museum",
      "illustration.museum",
      "imageandsound.museum",
      "indian.museum",
      "indiana.museum",
      "indianapolis.museum",
      "indianmarket.museum",
      "intelligence.museum",
      "interactive.museum",
      "iraq.museum",
      "iron.museum",
      "isleofman.museum",
      "jamison.museum",
      "jefferson.museum",
      "jerusalem.museum",
      "jewelry.museum",
      "jewish.museum",
      "jewishart.museum",
      "jfk.museum",
      "journalism.museum",
      "judaica.museum",
      "judygarland.museum",
      "juedisches.museum",
      "juif.museum",
      "karate.museum",
      "karikatur.museum",
      "kids.museum",
      "koebenhavn.museum",
      "koeln.museum",
      "kunst.museum",
      "kunstsammlung.museum",
      "kunstunddesign.museum",
      "labor.museum",
      "labour.museum",
      "lajolla.museum",
      "lancashire.museum",
      "landes.museum",
      "lans.museum",
      "läns.museum",
      "larsson.museum",
      "lewismiller.museum",
      "lincoln.museum",
      "linz.museum",
      "living.museum",
      "livinghistory.museum",
      "localhistory.museum",
      "london.museum",
      "losangeles.museum",
      "louvre.museum",
      "loyalist.museum",
      "lucerne.museum",
      "luxembourg.museum",
      "luzern.museum",
      "mad.museum",
      "madrid.museum",
      "mallorca.museum",
      "manchester.museum",
      "mansion.museum",
      "mansions.museum",
      "manx.museum",
      "marburg.museum",
      "maritime.museum",
      "maritimo.museum",
      "maryland.museum",
      "marylhurst.museum",
      "media.museum",
      "medical.museum",
      "medizinhistorisches.museum",
      "meeres.museum",
      "memorial.museum",
      "mesaverde.museum",
      "michigan.museum",
      "midatlantic.museum",
      "military.museum",
      "mill.museum",
      "miners.museum",
      "mining.museum",
      "minnesota.museum",
      "missile.museum",
      "missoula.museum",
      "modern.museum",
      "moma.museum",
      "money.museum",
      "monmouth.museum",
      "monticello.museum",
      "montreal.museum",
      "moscow.museum",
      "motorcycle.museum",
      "muenchen.museum",
      "muenster.museum",
      "mulhouse.museum",
      "muncie.museum",
      "museet.museum",
      "museumcenter.museum",
      "museumvereniging.museum",
      "music.museum",
      "national.museum",
      "nationalfirearms.museum",
      "nationalheritage.museum",
      "nativeamerican.museum",
      "naturalhistory.museum",
      "naturalhistorymuseum.museum",
      "naturalsciences.museum",
      "nature.museum",
      "naturhistorisches.museum",
      "natuurwetenschappen.museum",
      "naumburg.museum",
      "naval.museum",
      "nebraska.museum",
      "neues.museum",
      "newhampshire.museum",
      "newjersey.museum",
      "newmexico.museum",
      "newport.museum",
      "newspaper.museum",
      "newyork.museum",
      "niepce.museum",
      "norfolk.museum",
      "north.museum",
      "nrw.museum",
      "nyc.museum",
      "nyny.museum",
      "oceanographic.museum",
      "oceanographique.museum",
      "omaha.museum",
      "online.museum",
      "ontario.museum",
      "openair.museum",
      "oregon.museum",
      "oregontrail.museum",
      "otago.museum",
      "oxford.museum",
      "pacific.museum",
      "paderborn.museum",
      "palace.museum",
      "paleo.museum",
      "palmsprings.museum",
      "panama.museum",
      "paris.museum",
      "pasadena.museum",
      "pharmacy.museum",
      "philadelphia.museum",
      "philadelphiaarea.museum",
      "philately.museum",
      "phoenix.museum",
      "photography.museum",
      "pilots.museum",
      "pittsburgh.museum",
      "planetarium.museum",
      "plantation.museum",
      "plants.museum",
      "plaza.museum",
      "portal.museum",
      "portland.museum",
      "portlligat.museum",
      "posts-and-telecommunications.museum",
      "preservation.museum",
      "presidio.museum",
      "press.museum",
      "project.museum",
      "public.museum",
      "pubol.museum",
      "quebec.museum",
      "railroad.museum",
      "railway.museum",
      "research.museum",
      "resistance.museum",
      "riodejaneiro.museum",
      "rochester.museum",
      "rockart.museum",
      "roma.museum",
      "russia.museum",
      "saintlouis.museum",
      "salem.museum",
      "salvadordali.museum",
      "salzburg.museum",
      "sandiego.museum",
      "sanfrancisco.museum",
      "santabarbara.museum",
      "santacruz.museum",
      "santafe.museum",
      "saskatchewan.museum",
      "satx.museum",
      "savannahga.museum",
      "schlesisches.museum",
      "schoenbrunn.museum",
      "schokoladen.museum",
      "school.museum",
      "schweiz.museum",
      "science.museum",
      "scienceandhistory.museum",
      "scienceandindustry.museum",
      "sciencecenter.museum",
      "sciencecenters.museum",
      "science-fiction.museum",
      "sciencehistory.museum",
      "sciences.museum",
      "sciencesnaturelles.museum",
      "scotland.museum",
      "seaport.museum",
      "settlement.museum",
      "settlers.museum",
      "shell.museum",
      "sherbrooke.museum",
      "sibenik.museum",
      "silk.museum",
      "ski.museum",
      "skole.museum",
      "society.museum",
      "sologne.museum",
      "soundandvision.museum",
      "southcarolina.museum",
      "southwest.museum",
      "space.museum",
      "spy.museum",
      "square.museum",
      "stadt.museum",
      "stalbans.museum",
      "starnberg.museum",
      "state.museum",
      "stateofdelaware.museum",
      "station.museum",
      "steam.museum",
      "steiermark.museum",
      "stjohn.museum",
      "stockholm.museum",
      "stpetersburg.museum",
      "stuttgart.museum",
      "suisse.museum",
      "surgeonshall.museum",
      "surrey.museum",
      "svizzera.museum",
      "sweden.museum",
      "sydney.museum",
      "tank.museum",
      "tcm.museum",
      "technology.museum",
      "telekommunikation.museum",
      "television.museum",
      "texas.museum",
      "textile.museum",
      "theater.museum",
      "time.museum",
      "timekeeping.museum",
      "topology.museum",
      "torino.museum",
      "touch.museum",
      "town.museum",
      "transport.museum",
      "tree.museum",
      "trolley.museum",
      "trust.museum",
      "trustee.museum",
      "uhren.museum",
      "ulm.museum",
      "undersea.museum",
      "university.museum",
      "usa.museum",
      "usantiques.museum",
      "usarts.museum",
      "uscountryestate.museum",
      "usculture.museum",
      "usdecorativearts.museum",
      "usgarden.museum",
      "ushistory.museum",
      "ushuaia.museum",
      "uslivinghistory.museum",
      "utah.museum",
      "uvic.museum",
      "valley.museum",
      "vantaa.museum",
      "versailles.museum",
      "viking.museum",
      "village.museum",
      "virginia.museum",
      "virtual.museum",
      "virtuel.museum",
      "vlaanderen.museum",
      "volkenkunde.museum",
      "wales.museum",
      "wallonie.museum",
      "war.museum",
      "washingtondc.museum",
      "watchandclock.museum",
      "watch-and-clock.museum",
      "western.museum",
      "westfalen.museum",
      "whaling.museum",
      "wildlife.museum",
      "williamsburg.museum",
      "windmill.museum",
      "workshop.museum",
      "york.museum",
      "yorkshire.museum",
      "yosemite.museum",
      "youth.museum",
      "zoological.museum",
      "zoology.museum",
      "ירושלים.museum",
      "иком.museum",
      "mv",
      "aero.mv",
      "biz.mv",
      "com.mv",
      "coop.mv",
      "edu.mv",
      "gov.mv",
      "info.mv",
      "int.mv",
      "mil.mv",
      "museum.mv",
      "name.mv",
      "net.mv",
      "org.mv",
      "pro.mv",
      "mw",
      "ac.mw",
      "biz.mw",
      "co.mw",
      "com.mw",
      "coop.mw",
      "edu.mw",
      "gov.mw",
      "int.mw",
      "museum.mw",
      "net.mw",
      "org.mw",
      "mx",
      "com.mx",
      "org.mx",
      "gob.mx",
      "edu.mx",
      "net.mx",
      "my",
      "biz.my",
      "com.my",
      "edu.my",
      "gov.my",
      "mil.my",
      "name.my",
      "net.my",
      "org.my",
      "mz",
      "ac.mz",
      "adv.mz",
      "co.mz",
      "edu.mz",
      "gov.mz",
      "mil.mz",
      "net.mz",
      "org.mz",
      "na",
      "info.na",
      "pro.na",
      "name.na",
      "school.na",
      "or.na",
      "dr.na",
      "us.na",
      "mx.na",
      "ca.na",
      "in.na",
      "cc.na",
      "tv.na",
      "ws.na",
      "mobi.na",
      "co.na",
      "com.na",
      "org.na",
      "name",
      "nc",
      "asso.nc",
      "nom.nc",
      "ne",
      "net",
      "nf",
      "com.nf",
      "net.nf",
      "per.nf",
      "rec.nf",
      "web.nf",
      "arts.nf",
      "firm.nf",
      "info.nf",
      "other.nf",
      "store.nf",
      "ng",
      "com.ng",
      "edu.ng",
      "gov.ng",
      "i.ng",
      "mil.ng",
      "mobi.ng",
      "name.ng",
      "net.ng",
      "org.ng",
      "sch.ng",
      "ni",
      "ac.ni",
      "biz.ni",
      "co.ni",
      "com.ni",
      "edu.ni",
      "gob.ni",
      "in.ni",
      "info.ni",
      "int.ni",
      "mil.ni",
      "net.ni",
      "nom.ni",
      "org.ni",
      "web.ni",
      "nl",
      "no",
      "fhs.no",
      "vgs.no",
      "fylkesbibl.no",
      "folkebibl.no",
      "museum.no",
      "idrett.no",
      "priv.no",
      "mil.no",
      "stat.no",
      "dep.no",
      "kommune.no",
      "herad.no",
      "aa.no",
      "ah.no",
      "bu.no",
      "fm.no",
      "hl.no",
      "hm.no",
      "jan-mayen.no",
      "mr.no",
      "nl.no",
      "nt.no",
      "of.no",
      "ol.no",
      "oslo.no",
      "rl.no",
      "sf.no",
      "st.no",
      "svalbard.no",
      "tm.no",
      "tr.no",
      "va.no",
      "vf.no",
      "gs.aa.no",
      "gs.ah.no",
      "gs.bu.no",
      "gs.fm.no",
      "gs.hl.no",
      "gs.hm.no",
      "gs.jan-mayen.no",
      "gs.mr.no",
      "gs.nl.no",
      "gs.nt.no",
      "gs.of.no",
      "gs.ol.no",
      "gs.oslo.no",
      "gs.rl.no",
      "gs.sf.no",
      "gs.st.no",
      "gs.svalbard.no",
      "gs.tm.no",
      "gs.tr.no",
      "gs.va.no",
      "gs.vf.no",
      "akrehamn.no",
      "åkrehamn.no",
      "algard.no",
      "ålgård.no",
      "arna.no",
      "brumunddal.no",
      "bryne.no",
      "bronnoysund.no",
      "brønnøysund.no",
      "drobak.no",
      "drøbak.no",
      "egersund.no",
      "fetsund.no",
      "floro.no",
      "florø.no",
      "fredrikstad.no",
      "hokksund.no",
      "honefoss.no",
      "hønefoss.no",
      "jessheim.no",
      "jorpeland.no",
      "jørpeland.no",
      "kirkenes.no",
      "kopervik.no",
      "krokstadelva.no",
      "langevag.no",
      "langevåg.no",
      "leirvik.no",
      "mjondalen.no",
      "mjøndalen.no",
      "mo-i-rana.no",
      "mosjoen.no",
      "mosjøen.no",
      "nesoddtangen.no",
      "orkanger.no",
      "osoyro.no",
      "osøyro.no",
      "raholt.no",
      "råholt.no",
      "sandnessjoen.no",
      "sandnessjøen.no",
      "skedsmokorset.no",
      "slattum.no",
      "spjelkavik.no",
      "stathelle.no",
      "stavern.no",
      "stjordalshalsen.no",
      "stjørdalshalsen.no",
      "tananger.no",
      "tranby.no",
      "vossevangen.no",
      "afjord.no",
      "åfjord.no",
      "agdenes.no",
      "al.no",
      "ål.no",
      "alesund.no",
      "ålesund.no",
      "alstahaug.no",
      "alta.no",
      "áltá.no",
      "alaheadju.no",
      "álaheadju.no",
      "alvdal.no",
      "amli.no",
      "åmli.no",
      "amot.no",
      "åmot.no",
      "andebu.no",
      "andoy.no",
      "andøy.no",
      "andasuolo.no",
      "ardal.no",
      "årdal.no",
      "aremark.no",
      "arendal.no",
      "ås.no",
      "aseral.no",
      "åseral.no",
      "asker.no",
      "askim.no",
      "askvoll.no",
      "askoy.no",
      "askøy.no",
      "asnes.no",
      "åsnes.no",
      "audnedaln.no",
      "aukra.no",
      "aure.no",
      "aurland.no",
      "aurskog-holand.no",
      "aurskog-høland.no",
      "austevoll.no",
      "austrheim.no",
      "averoy.no",
      "averøy.no",
      "balestrand.no",
      "ballangen.no",
      "balat.no",
      "bálát.no",
      "balsfjord.no",
      "bahccavuotna.no",
      "báhccavuotna.no",
      "bamble.no",
      "bardu.no",
      "beardu.no",
      "beiarn.no",
      "bajddar.no",
      "bájddar.no",
      "baidar.no",
      "báidár.no",
      "berg.no",
      "bergen.no",
      "berlevag.no",
      "berlevåg.no",
      "bearalvahki.no",
      "bearalváhki.no",
      "bindal.no",
      "birkenes.no",
      "bjarkoy.no",
      "bjarkøy.no",
      "bjerkreim.no",
      "bjugn.no",
      "bodo.no",
      "bodø.no",
      "badaddja.no",
      "bådåddjå.no",
      "budejju.no",
      "bokn.no",
      "bremanger.no",
      "bronnoy.no",
      "brønnøy.no",
      "bygland.no",
      "bykle.no",
      "barum.no",
      "bærum.no",
      "bo.telemark.no",
      "bø.telemark.no",
      "bo.nordland.no",
      "bø.nordland.no",
      "bievat.no",
      "bievát.no",
      "bomlo.no",
      "bømlo.no",
      "batsfjord.no",
      "båtsfjord.no",
      "bahcavuotna.no",
      "báhcavuotna.no",
      "dovre.no",
      "drammen.no",
      "drangedal.no",
      "dyroy.no",
      "dyrøy.no",
      "donna.no",
      "dønna.no",
      "eid.no",
      "eidfjord.no",
      "eidsberg.no",
      "eidskog.no",
      "eidsvoll.no",
      "eigersund.no",
      "elverum.no",
      "enebakk.no",
      "engerdal.no",
      "etne.no",
      "etnedal.no",
      "evenes.no",
      "evenassi.no",
      "evenášši.no",
      "evje-og-hornnes.no",
      "farsund.no",
      "fauske.no",
      "fuossko.no",
      "fuoisku.no",
      "fedje.no",
      "fet.no",
      "finnoy.no",
      "finnøy.no",
      "fitjar.no",
      "fjaler.no",
      "fjell.no",
      "flakstad.no",
      "flatanger.no",
      "flekkefjord.no",
      "flesberg.no",
      "flora.no",
      "fla.no",
      "flå.no",
      "folldal.no",
      "forsand.no",
      "fosnes.no",
      "frei.no",
      "frogn.no",
      "froland.no",
      "frosta.no",
      "frana.no",
      "fræna.no",
      "froya.no",
      "frøya.no",
      "fusa.no",
      "fyresdal.no",
      "forde.no",
      "førde.no",
      "gamvik.no",
      "gangaviika.no",
      "gáŋgaviika.no",
      "gaular.no",
      "gausdal.no",
      "gildeskal.no",
      "gildeskål.no",
      "giske.no",
      "gjemnes.no",
      "gjerdrum.no",
      "gjerstad.no",
      "gjesdal.no",
      "gjovik.no",
      "gjøvik.no",
      "gloppen.no",
      "gol.no",
      "gran.no",
      "grane.no",
      "granvin.no",
      "gratangen.no",
      "grimstad.no",
      "grong.no",
      "kraanghke.no",
      "kråanghke.no",
      "grue.no",
      "gulen.no",
      "hadsel.no",
      "halden.no",
      "halsa.no",
      "hamar.no",
      "hamaroy.no",
      "habmer.no",
      "hábmer.no",
      "hapmir.no",
      "hápmir.no",
      "hammerfest.no",
      "hammarfeasta.no",
      "hámmárfeasta.no",
      "haram.no",
      "hareid.no",
      "harstad.no",
      "hasvik.no",
      "aknoluokta.no",
      "ákŋoluokta.no",
      "hattfjelldal.no",
      "aarborte.no",
      "haugesund.no",
      "hemne.no",
      "hemnes.no",
      "hemsedal.no",
      "heroy.more-og-romsdal.no",
      "herøy.møre-og-romsdal.no",
      "heroy.nordland.no",
      "herøy.nordland.no",
      "hitra.no",
      "hjartdal.no",
      "hjelmeland.no",
      "hobol.no",
      "hobøl.no",
      "hof.no",
      "hol.no",
      "hole.no",
      "holmestrand.no",
      "holtalen.no",
      "holtålen.no",
      "hornindal.no",
      "horten.no",
      "hurdal.no",
      "hurum.no",
      "hvaler.no",
      "hyllestad.no",
      "hagebostad.no",
      "hægebostad.no",
      "hoyanger.no",
      "høyanger.no",
      "hoylandet.no",
      "høylandet.no",
      "ha.no",
      "hå.no",
      "ibestad.no",
      "inderoy.no",
      "inderøy.no",
      "iveland.no",
      "jevnaker.no",
      "jondal.no",
      "jolster.no",
      "jølster.no",
      "karasjok.no",
      "karasjohka.no",
      "kárášjohka.no",
      "karlsoy.no",
      "galsa.no",
      "gálsá.no",
      "karmoy.no",
      "karmøy.no",
      "kautokeino.no",
      "guovdageaidnu.no",
      "klepp.no",
      "klabu.no",
      "klæbu.no",
      "kongsberg.no",
      "kongsvinger.no",
      "kragero.no",
      "kragerø.no",
      "kristiansand.no",
      "kristiansund.no",
      "krodsherad.no",
      "krødsherad.no",
      "kvalsund.no",
      "rahkkeravju.no",
      "ráhkkerávju.no",
      "kvam.no",
      "kvinesdal.no",
      "kvinnherad.no",
      "kviteseid.no",
      "kvitsoy.no",
      "kvitsøy.no",
      "kvafjord.no",
      "kvæfjord.no",
      "giehtavuoatna.no",
      "kvanangen.no",
      "kvænangen.no",
      "navuotna.no",
      "návuotna.no",
      "kafjord.no",
      "kåfjord.no",
      "gaivuotna.no",
      "gáivuotna.no",
      "larvik.no",
      "lavangen.no",
      "lavagis.no",
      "loabat.no",
      "loabát.no",
      "lebesby.no",
      "davvesiida.no",
      "leikanger.no",
      "leirfjord.no",
      "leka.no",
      "leksvik.no",
      "lenvik.no",
      "leangaviika.no",
      "leaŋgaviika.no",
      "lesja.no",
      "levanger.no",
      "lier.no",
      "lierne.no",
      "lillehammer.no",
      "lillesand.no",
      "lindesnes.no",
      "lindas.no",
      "lindås.no",
      "lom.no",
      "loppa.no",
      "lahppi.no",
      "láhppi.no",
      "lund.no",
      "lunner.no",
      "luroy.no",
      "lurøy.no",
      "luster.no",
      "lyngdal.no",
      "lyngen.no",
      "ivgu.no",
      "lardal.no",
      "lerdal.no",
      "lærdal.no",
      "lodingen.no",
      "lødingen.no",
      "lorenskog.no",
      "lørenskog.no",
      "loten.no",
      "løten.no",
      "malvik.no",
      "masoy.no",
      "måsøy.no",
      "muosat.no",
      "muosát.no",
      "mandal.no",
      "marker.no",
      "marnardal.no",
      "masfjorden.no",
      "meland.no",
      "meldal.no",
      "melhus.no",
      "meloy.no",
      "meløy.no",
      "meraker.no",
      "meråker.no",
      "moareke.no",
      "moåreke.no",
      "midsund.no",
      "midtre-gauldal.no",
      "modalen.no",
      "modum.no",
      "molde.no",
      "moskenes.no",
      "moss.no",
      "mosvik.no",
      "malselv.no",
      "målselv.no",
      "malatvuopmi.no",
      "málatvuopmi.no",
      "namdalseid.no",
      "aejrie.no",
      "namsos.no",
      "namsskogan.no",
      "naamesjevuemie.no",
      "nååmesjevuemie.no",
      "laakesvuemie.no",
      "nannestad.no",
      "narvik.no",
      "narviika.no",
      "naustdal.no",
      "nedre-eiker.no",
      "nes.akershus.no",
      "nes.buskerud.no",
      "nesna.no",
      "nesodden.no",
      "nesseby.no",
      "unjarga.no",
      "unjárga.no",
      "nesset.no",
      "nissedal.no",
      "nittedal.no",
      "nord-aurdal.no",
      "nord-fron.no",
      "nord-odal.no",
      "norddal.no",
      "nordkapp.no",
      "davvenjarga.no",
      "davvenjárga.no",
      "nordre-land.no",
      "nordreisa.no",
      "raisa.no",
      "ráisa.no",
      "nore-og-uvdal.no",
      "notodden.no",
      "naroy.no",
      "nærøy.no",
      "notteroy.no",
      "nøtterøy.no",
      "odda.no",
      "oksnes.no",
      "øksnes.no",
      "oppdal.no",
      "oppegard.no",
      "oppegård.no",
      "orkdal.no",
      "orland.no",
      "ørland.no",
      "orskog.no",
      "ørskog.no",
      "orsta.no",
      "ørsta.no",
      "os.hedmark.no",
      "os.hordaland.no",
      "osen.no",
      "osteroy.no",
      "osterøy.no",
      "ostre-toten.no",
      "østre-toten.no",
      "overhalla.no",
      "ovre-eiker.no",
      "øvre-eiker.no",
      "oyer.no",
      "øyer.no",
      "oygarden.no",
      "øygarden.no",
      "oystre-slidre.no",
      "øystre-slidre.no",
      "porsanger.no",
      "porsangu.no",
      "porsáŋgu.no",
      "porsgrunn.no",
      "radoy.no",
      "radøy.no",
      "rakkestad.no",
      "rana.no",
      "ruovat.no",
      "randaberg.no",
      "rauma.no",
      "rendalen.no",
      "rennebu.no",
      "rennesoy.no",
      "rennesøy.no",
      "rindal.no",
      "ringebu.no",
      "ringerike.no",
      "ringsaker.no",
      "rissa.no",
      "risor.no",
      "risør.no",
      "roan.no",
      "rollag.no",
      "rygge.no",
      "ralingen.no",
      "rælingen.no",
      "rodoy.no",
      "rødøy.no",
      "romskog.no",
      "rømskog.no",
      "roros.no",
      "røros.no",
      "rost.no",
      "røst.no",
      "royken.no",
      "røyken.no",
      "royrvik.no",
      "røyrvik.no",
      "rade.no",
      "råde.no",
      "salangen.no",
      "siellak.no",
      "saltdal.no",
      "salat.no",
      "sálát.no",
      "sálat.no",
      "samnanger.no",
      "sande.more-og-romsdal.no",
      "sande.møre-og-romsdal.no",
      "sande.vestfold.no",
      "sandefjord.no",
      "sandnes.no",
      "sandoy.no",
      "sandøy.no",
      "sarpsborg.no",
      "sauda.no",
      "sauherad.no",
      "sel.no",
      "selbu.no",
      "selje.no",
      "seljord.no",
      "sigdal.no",
      "siljan.no",
      "sirdal.no",
      "skaun.no",
      "skedsmo.no",
      "ski.no",
      "skien.no",
      "skiptvet.no",
      "skjervoy.no",
      "skjervøy.no",
      "skierva.no",
      "skiervá.no",
      "skjak.no",
      "skjåk.no",
      "skodje.no",
      "skanland.no",
      "skånland.no",
      "skanit.no",
      "skánit.no",
      "smola.no",
      "smøla.no",
      "snillfjord.no",
      "snasa.no",
      "snåsa.no",
      "snoasa.no",
      "snaase.no",
      "snåase.no",
      "sogndal.no",
      "sokndal.no",
      "sola.no",
      "solund.no",
      "songdalen.no",
      "sortland.no",
      "spydeberg.no",
      "stange.no",
      "stavanger.no",
      "steigen.no",
      "steinkjer.no",
      "stjordal.no",
      "stjørdal.no",
      "stokke.no",
      "stor-elvdal.no",
      "stord.no",
      "stordal.no",
      "storfjord.no",
      "omasvuotna.no",
      "strand.no",
      "stranda.no",
      "stryn.no",
      "sula.no",
      "suldal.no",
      "sund.no",
      "sunndal.no",
      "surnadal.no",
      "sveio.no",
      "svelvik.no",
      "sykkylven.no",
      "sogne.no",
      "søgne.no",
      "somna.no",
      "sømna.no",
      "sondre-land.no",
      "søndre-land.no",
      "sor-aurdal.no",
      "sør-aurdal.no",
      "sor-fron.no",
      "sør-fron.no",
      "sor-odal.no",
      "sør-odal.no",
      "sor-varanger.no",
      "sør-varanger.no",
      "matta-varjjat.no",
      "mátta-várjjat.no",
      "sorfold.no",
      "sørfold.no",
      "sorreisa.no",
      "sørreisa.no",
      "sorum.no",
      "sørum.no",
      "tana.no",
      "deatnu.no",
      "time.no",
      "tingvoll.no",
      "tinn.no",
      "tjeldsund.no",
      "dielddanuorri.no",
      "tjome.no",
      "tjøme.no",
      "tokke.no",
      "tolga.no",
      "torsken.no",
      "tranoy.no",
      "tranøy.no",
      "tromso.no",
      "tromsø.no",
      "tromsa.no",
      "romsa.no",
      "trondheim.no",
      "troandin.no",
      "trysil.no",
      "trana.no",
      "træna.no",
      "trogstad.no",
      "trøgstad.no",
      "tvedestrand.no",
      "tydal.no",
      "tynset.no",
      "tysfjord.no",
      "divtasvuodna.no",
      "divttasvuotna.no",
      "tysnes.no",
      "tysvar.no",
      "tysvær.no",
      "tonsberg.no",
      "tønsberg.no",
      "ullensaker.no",
      "ullensvang.no",
      "ulvik.no",
      "utsira.no",
      "vadso.no",
      "vadsø.no",
      "cahcesuolo.no",
      "čáhcesuolo.no",
      "vaksdal.no",
      "valle.no",
      "vang.no",
      "vanylven.no",
      "vardo.no",
      "vardø.no",
      "varggat.no",
      "várggát.no",
      "vefsn.no",
      "vaapste.no",
      "vega.no",
      "vegarshei.no",
      "vegårshei.no",
      "vennesla.no",
      "verdal.no",
      "verran.no",
      "vestby.no",
      "vestnes.no",
      "vestre-slidre.no",
      "vestre-toten.no",
      "vestvagoy.no",
      "vestvågøy.no",
      "vevelstad.no",
      "vik.no",
      "vikna.no",
      "vindafjord.no",
      "volda.no",
      "voss.no",
      "varoy.no",
      "værøy.no",
      "vagan.no",
      "vågan.no",
      "voagat.no",
      "vagsoy.no",
      "vågsøy.no",
      "vaga.no",
      "vågå.no",
      "valer.ostfold.no",
      "våler.østfold.no",
      "valer.hedmark.no",
      "våler.hedmark.no",
      "*.np",
      "nr",
      "biz.nr",
      "info.nr",
      "gov.nr",
      "edu.nr",
      "org.nr",
      "net.nr",
      "com.nr",
      "nu",
      "nz",
      "ac.nz",
      "co.nz",
      "cri.nz",
      "geek.nz",
      "gen.nz",
      "govt.nz",
      "health.nz",
      "iwi.nz",
      "kiwi.nz",
      "maori.nz",
      "mil.nz",
      "māori.nz",
      "net.nz",
      "org.nz",
      "parliament.nz",
      "school.nz",
      "om",
      "co.om",
      "com.om",
      "edu.om",
      "gov.om",
      "med.om",
      "museum.om",
      "net.om",
      "org.om",
      "pro.om",
      "onion",
      "org",
      "pa",
      "ac.pa",
      "gob.pa",
      "com.pa",
      "org.pa",
      "sld.pa",
      "edu.pa",
      "net.pa",
      "ing.pa",
      "abo.pa",
      "med.pa",
      "nom.pa",
      "pe",
      "edu.pe",
      "gob.pe",
      "nom.pe",
      "mil.pe",
      "org.pe",
      "com.pe",
      "net.pe",
      "pf",
      "com.pf",
      "org.pf",
      "edu.pf",
      "*.pg",
      "ph",
      "com.ph",
      "net.ph",
      "org.ph",
      "gov.ph",
      "edu.ph",
      "ngo.ph",
      "mil.ph",
      "i.ph",
      "pk",
      "com.pk",
      "net.pk",
      "edu.pk",
      "org.pk",
      "fam.pk",
      "biz.pk",
      "web.pk",
      "gov.pk",
      "gob.pk",
      "gok.pk",
      "gon.pk",
      "gop.pk",
      "gos.pk",
      "info.pk",
      "pl",
      "com.pl",
      "net.pl",
      "org.pl",
      "aid.pl",
      "agro.pl",
      "atm.pl",
      "auto.pl",
      "biz.pl",
      "edu.pl",
      "gmina.pl",
      "gsm.pl",
      "info.pl",
      "mail.pl",
      "miasta.pl",
      "media.pl",
      "mil.pl",
      "nieruchomosci.pl",
      "nom.pl",
      "pc.pl",
      "powiat.pl",
      "priv.pl",
      "realestate.pl",
      "rel.pl",
      "sex.pl",
      "shop.pl",
      "sklep.pl",
      "sos.pl",
      "szkola.pl",
      "targi.pl",
      "tm.pl",
      "tourism.pl",
      "travel.pl",
      "turystyka.pl",
      "gov.pl",
      "ap.gov.pl",
      "ic.gov.pl",
      "is.gov.pl",
      "us.gov.pl",
      "kmpsp.gov.pl",
      "kppsp.gov.pl",
      "kwpsp.gov.pl",
      "psp.gov.pl",
      "wskr.gov.pl",
      "kwp.gov.pl",
      "mw.gov.pl",
      "ug.gov.pl",
      "um.gov.pl",
      "umig.gov.pl",
      "ugim.gov.pl",
      "upow.gov.pl",
      "uw.gov.pl",
      "starostwo.gov.pl",
      "pa.gov.pl",
      "po.gov.pl",
      "psse.gov.pl",
      "pup.gov.pl",
      "rzgw.gov.pl",
      "sa.gov.pl",
      "so.gov.pl",
      "sr.gov.pl",
      "wsa.gov.pl",
      "sko.gov.pl",
      "uzs.gov.pl",
      "wiih.gov.pl",
      "winb.gov.pl",
      "pinb.gov.pl",
      "wios.gov.pl",
      "witd.gov.pl",
      "wzmiuw.gov.pl",
      "piw.gov.pl",
      "wiw.gov.pl",
      "griw.gov.pl",
      "wif.gov.pl",
      "oum.gov.pl",
      "sdn.gov.pl",
      "zp.gov.pl",
      "uppo.gov.pl",
      "mup.gov.pl",
      "wuoz.gov.pl",
      "konsulat.gov.pl",
      "oirm.gov.pl",
      "augustow.pl",
      "babia-gora.pl",
      "bedzin.pl",
      "beskidy.pl",
      "bialowieza.pl",
      "bialystok.pl",
      "bielawa.pl",
      "bieszczady.pl",
      "boleslawiec.pl",
      "bydgoszcz.pl",
      "bytom.pl",
      "cieszyn.pl",
      "czeladz.pl",
      "czest.pl",
      "dlugoleka.pl",
      "elblag.pl",
      "elk.pl",
      "glogow.pl",
      "gniezno.pl",
      "gorlice.pl",
      "grajewo.pl",
      "ilawa.pl",
      "jaworzno.pl",
      "jelenia-gora.pl",
      "jgora.pl",
      "kalisz.pl",
      "kazimierz-dolny.pl",
      "karpacz.pl",
      "kartuzy.pl",
      "kaszuby.pl",
      "katowice.pl",
      "kepno.pl",
      "ketrzyn.pl",
      "klodzko.pl",
      "kobierzyce.pl",
      "kolobrzeg.pl",
      "konin.pl",
      "konskowola.pl",
      "kutno.pl",
      "lapy.pl",
      "lebork.pl",
      "legnica.pl",
      "lezajsk.pl",
      "limanowa.pl",
      "lomza.pl",
      "lowicz.pl",
      "lubin.pl",
      "lukow.pl",
      "malbork.pl",
      "malopolska.pl",
      "mazowsze.pl",
      "mazury.pl",
      "mielec.pl",
      "mielno.pl",
      "mragowo.pl",
      "naklo.pl",
      "nowaruda.pl",
      "nysa.pl",
      "olawa.pl",
      "olecko.pl",
      "olkusz.pl",
      "olsztyn.pl",
      "opoczno.pl",
      "opole.pl",
      "ostroda.pl",
      "ostroleka.pl",
      "ostrowiec.pl",
      "ostrowwlkp.pl",
      "pila.pl",
      "pisz.pl",
      "podhale.pl",
      "podlasie.pl",
      "polkowice.pl",
      "pomorze.pl",
      "pomorskie.pl",
      "prochowice.pl",
      "pruszkow.pl",
      "przeworsk.pl",
      "pulawy.pl",
      "radom.pl",
      "rawa-maz.pl",
      "rybnik.pl",
      "rzeszow.pl",
      "sanok.pl",
      "sejny.pl",
      "slask.pl",
      "slupsk.pl",
      "sosnowiec.pl",
      "stalowa-wola.pl",
      "skoczow.pl",
      "starachowice.pl",
      "stargard.pl",
      "suwalki.pl",
      "swidnica.pl",
      "swiebodzin.pl",
      "swinoujscie.pl",
      "szczecin.pl",
      "szczytno.pl",
      "tarnobrzeg.pl",
      "tgory.pl",
      "turek.pl",
      "tychy.pl",
      "ustka.pl",
      "walbrzych.pl",
      "warmia.pl",
      "warszawa.pl",
      "waw.pl",
      "wegrow.pl",
      "wielun.pl",
      "wlocl.pl",
      "wloclawek.pl",
      "wodzislaw.pl",
      "wolomin.pl",
      "wroclaw.pl",
      "zachpomor.pl",
      "zagan.pl",
      "zarow.pl",
      "zgora.pl",
      "zgorzelec.pl",
      "pm",
      "pn",
      "gov.pn",
      "co.pn",
      "org.pn",
      "edu.pn",
      "net.pn",
      "post",
      "pr",
      "com.pr",
      "net.pr",
      "org.pr",
      "gov.pr",
      "edu.pr",
      "isla.pr",
      "pro.pr",
      "biz.pr",
      "info.pr",
      "name.pr",
      "est.pr",
      "prof.pr",
      "ac.pr",
      "pro",
      "aaa.pro",
      "aca.pro",
      "acct.pro",
      "avocat.pro",
      "bar.pro",
      "cpa.pro",
      "eng.pro",
      "jur.pro",
      "law.pro",
      "med.pro",
      "recht.pro",
      "ps",
      "edu.ps",
      "gov.ps",
      "sec.ps",
      "plo.ps",
      "com.ps",
      "org.ps",
      "net.ps",
      "pt",
      "net.pt",
      "gov.pt",
      "org.pt",
      "edu.pt",
      "int.pt",
      "publ.pt",
      "com.pt",
      "nome.pt",
      "pw",
      "co.pw",
      "ne.pw",
      "or.pw",
      "ed.pw",
      "go.pw",
      "belau.pw",
      "py",
      "com.py",
      "coop.py",
      "edu.py",
      "gov.py",
      "mil.py",
      "net.py",
      "org.py",
      "qa",
      "com.qa",
      "edu.qa",
      "gov.qa",
      "mil.qa",
      "name.qa",
      "net.qa",
      "org.qa",
      "sch.qa",
      "re",
      "asso.re",
      "com.re",
      "nom.re",
      "ro",
      "arts.ro",
      "com.ro",
      "firm.ro",
      "info.ro",
      "nom.ro",
      "nt.ro",
      "org.ro",
      "rec.ro",
      "store.ro",
      "tm.ro",
      "www.ro",
      "rs",
      "ac.rs",
      "co.rs",
      "edu.rs",
      "gov.rs",
      "in.rs",
      "org.rs",
      "ru",
      "rw",
      "ac.rw",
      "co.rw",
      "coop.rw",
      "gov.rw",
      "mil.rw",
      "net.rw",
      "org.rw",
      "sa",
      "com.sa",
      "net.sa",
      "org.sa",
      "gov.sa",
      "med.sa",
      "pub.sa",
      "edu.sa",
      "sch.sa",
      "sb",
      "com.sb",
      "edu.sb",
      "gov.sb",
      "net.sb",
      "org.sb",
      "sc",
      "com.sc",
      "gov.sc",
      "net.sc",
      "org.sc",
      "edu.sc",
      "sd",
      "com.sd",
      "net.sd",
      "org.sd",
      "edu.sd",
      "med.sd",
      "tv.sd",
      "gov.sd",
      "info.sd",
      "se",
      "a.se",
      "ac.se",
      "b.se",
      "bd.se",
      "brand.se",
      "c.se",
      "d.se",
      "e.se",
      "f.se",
      "fh.se",
      "fhsk.se",
      "fhv.se",
      "g.se",
      "h.se",
      "i.se",
      "k.se",
      "komforb.se",
      "kommunalforbund.se",
      "komvux.se",
      "l.se",
      "lanbib.se",
      "m.se",
      "n.se",
      "naturbruksgymn.se",
      "o.se",
      "org.se",
      "p.se",
      "parti.se",
      "pp.se",
      "press.se",
      "r.se",
      "s.se",
      "t.se",
      "tm.se",
      "u.se",
      "w.se",
      "x.se",
      "y.se",
      "z.se",
      "sg",
      "com.sg",
      "net.sg",
      "org.sg",
      "gov.sg",
      "edu.sg",
      "per.sg",
      "sh",
      "com.sh",
      "net.sh",
      "gov.sh",
      "org.sh",
      "mil.sh",
      "si",
      "sj",
      "sk",
      "sl",
      "com.sl",
      "net.sl",
      "edu.sl",
      "gov.sl",
      "org.sl",
      "sm",
      "sn",
      "art.sn",
      "com.sn",
      "edu.sn",
      "gouv.sn",
      "org.sn",
      "perso.sn",
      "univ.sn",
      "so",
      "com.so",
      "edu.so",
      "gov.so",
      "me.so",
      "net.so",
      "org.so",
      "sr",
      "ss",
      "biz.ss",
      "com.ss",
      "edu.ss",
      "gov.ss",
      "me.ss",
      "net.ss",
      "org.ss",
      "sch.ss",
      "st",
      "co.st",
      "com.st",
      "consulado.st",
      "edu.st",
      "embaixada.st",
      "mil.st",
      "net.st",
      "org.st",
      "principe.st",
      "saotome.st",
      "store.st",
      "su",
      "sv",
      "com.sv",
      "edu.sv",
      "gob.sv",
      "org.sv",
      "red.sv",
      "sx",
      "gov.sx",
      "sy",
      "edu.sy",
      "gov.sy",
      "net.sy",
      "mil.sy",
      "com.sy",
      "org.sy",
      "sz",
      "co.sz",
      "ac.sz",
      "org.sz",
      "tc",
      "td",
      "tel",
      "tf",
      "tg",
      "th",
      "ac.th",
      "co.th",
      "go.th",
      "in.th",
      "mi.th",
      "net.th",
      "or.th",
      "tj",
      "ac.tj",
      "biz.tj",
      "co.tj",
      "com.tj",
      "edu.tj",
      "go.tj",
      "gov.tj",
      "int.tj",
      "mil.tj",
      "name.tj",
      "net.tj",
      "nic.tj",
      "org.tj",
      "test.tj",
      "web.tj",
      "tk",
      "tl",
      "gov.tl",
      "tm",
      "com.tm",
      "co.tm",
      "org.tm",
      "net.tm",
      "nom.tm",
      "gov.tm",
      "mil.tm",
      "edu.tm",
      "tn",
      "com.tn",
      "ens.tn",
      "fin.tn",
      "gov.tn",
      "ind.tn",
      "info.tn",
      "intl.tn",
      "mincom.tn",
      "nat.tn",
      "net.tn",
      "org.tn",
      "perso.tn",
      "tourism.tn",
      "to",
      "com.to",
      "gov.to",
      "net.to",
      "org.to",
      "edu.to",
      "mil.to",
      "tr",
      "av.tr",
      "bbs.tr",
      "bel.tr",
      "biz.tr",
      "com.tr",
      "dr.tr",
      "edu.tr",
      "gen.tr",
      "gov.tr",
      "info.tr",
      "mil.tr",
      "k12.tr",
      "kep.tr",
      "name.tr",
      "net.tr",
      "org.tr",
      "pol.tr",
      "tel.tr",
      "tsk.tr",
      "tv.tr",
      "web.tr",
      "nc.tr",
      "gov.nc.tr",
      "tt",
      "co.tt",
      "com.tt",
      "org.tt",
      "net.tt",
      "biz.tt",
      "info.tt",
      "pro.tt",
      "int.tt",
      "coop.tt",
      "jobs.tt",
      "mobi.tt",
      "travel.tt",
      "museum.tt",
      "aero.tt",
      "name.tt",
      "gov.tt",
      "edu.tt",
      "tv",
      "tw",
      "edu.tw",
      "gov.tw",
      "mil.tw",
      "com.tw",
      "net.tw",
      "org.tw",
      "idv.tw",
      "game.tw",
      "ebiz.tw",
      "club.tw",
      "網路.tw",
      "組織.tw",
      "商業.tw",
      "tz",
      "ac.tz",
      "co.tz",
      "go.tz",
      "hotel.tz",
      "info.tz",
      "me.tz",
      "mil.tz",
      "mobi.tz",
      "ne.tz",
      "or.tz",
      "sc.tz",
      "tv.tz",
      "ua",
      "com.ua",
      "edu.ua",
      "gov.ua",
      "in.ua",
      "net.ua",
      "org.ua",
      "cherkassy.ua",
      "cherkasy.ua",
      "chernigov.ua",
      "chernihiv.ua",
      "chernivtsi.ua",
      "chernovtsy.ua",
      "ck.ua",
      "cn.ua",
      "cr.ua",
      "crimea.ua",
      "cv.ua",
      "dn.ua",
      "dnepropetrovsk.ua",
      "dnipropetrovsk.ua",
      "donetsk.ua",
      "dp.ua",
      "if.ua",
      "ivano-frankivsk.ua",
      "kh.ua",
      "kharkiv.ua",
      "kharkov.ua",
      "kherson.ua",
      "khmelnitskiy.ua",
      "khmelnytskyi.ua",
      "kiev.ua",
      "kirovograd.ua",
      "km.ua",
      "kr.ua",
      "krym.ua",
      "ks.ua",
      "kv.ua",
      "kyiv.ua",
      "lg.ua",
      "lt.ua",
      "lugansk.ua",
      "lutsk.ua",
      "lv.ua",
      "lviv.ua",
      "mk.ua",
      "mykolaiv.ua",
      "nikolaev.ua",
      "od.ua",
      "odesa.ua",
      "odessa.ua",
      "pl.ua",
      "poltava.ua",
      "rivne.ua",
      "rovno.ua",
      "rv.ua",
      "sb.ua",
      "sebastopol.ua",
      "sevastopol.ua",
      "sm.ua",
      "sumy.ua",
      "te.ua",
      "ternopil.ua",
      "uz.ua",
      "uzhgorod.ua",
      "vinnica.ua",
      "vinnytsia.ua",
      "vn.ua",
      "volyn.ua",
      "yalta.ua",
      "zaporizhzhe.ua",
      "zaporizhzhia.ua",
      "zhitomir.ua",
      "zhytomyr.ua",
      "zp.ua",
      "zt.ua",
      "ug",
      "co.ug",
      "or.ug",
      "ac.ug",
      "sc.ug",
      "go.ug",
      "ne.ug",
      "com.ug",
      "org.ug",
      "uk",
      "ac.uk",
      "co.uk",
      "gov.uk",
      "ltd.uk",
      "me.uk",
      "net.uk",
      "nhs.uk",
      "org.uk",
      "plc.uk",
      "police.uk",
      "*.sch.uk",
      "us",
      "dni.us",
      "fed.us",
      "isa.us",
      "kids.us",
      "nsn.us",
      "ak.us",
      "al.us",
      "ar.us",
      "as.us",
      "az.us",
      "ca.us",
      "co.us",
      "ct.us",
      "dc.us",
      "de.us",
      "fl.us",
      "ga.us",
      "gu.us",
      "hi.us",
      "ia.us",
      "id.us",
      "il.us",
      "in.us",
      "ks.us",
      "ky.us",
      "la.us",
      "ma.us",
      "md.us",
      "me.us",
      "mi.us",
      "mn.us",
      "mo.us",
      "ms.us",
      "mt.us",
      "nc.us",
      "nd.us",
      "ne.us",
      "nh.us",
      "nj.us",
      "nm.us",
      "nv.us",
      "ny.us",
      "oh.us",
      "ok.us",
      "or.us",
      "pa.us",
      "pr.us",
      "ri.us",
      "sc.us",
      "sd.us",
      "tn.us",
      "tx.us",
      "ut.us",
      "vi.us",
      "vt.us",
      "va.us",
      "wa.us",
      "wi.us",
      "wv.us",
      "wy.us",
      "k12.ak.us",
      "k12.al.us",
      "k12.ar.us",
      "k12.as.us",
      "k12.az.us",
      "k12.ca.us",
      "k12.co.us",
      "k12.ct.us",
      "k12.dc.us",
      "k12.de.us",
      "k12.fl.us",
      "k12.ga.us",
      "k12.gu.us",
      "k12.ia.us",
      "k12.id.us",
      "k12.il.us",
      "k12.in.us",
      "k12.ks.us",
      "k12.ky.us",
      "k12.la.us",
      "k12.ma.us",
      "k12.md.us",
      "k12.me.us",
      "k12.mi.us",
      "k12.mn.us",
      "k12.mo.us",
      "k12.ms.us",
      "k12.mt.us",
      "k12.nc.us",
      "k12.ne.us",
      "k12.nh.us",
      "k12.nj.us",
      "k12.nm.us",
      "k12.nv.us",
      "k12.ny.us",
      "k12.oh.us",
      "k12.ok.us",
      "k12.or.us",
      "k12.pa.us",
      "k12.pr.us",
      "k12.sc.us",
      "k12.tn.us",
      "k12.tx.us",
      "k12.ut.us",
      "k12.vi.us",
      "k12.vt.us",
      "k12.va.us",
      "k12.wa.us",
      "k12.wi.us",
      "k12.wy.us",
      "cc.ak.us",
      "cc.al.us",
      "cc.ar.us",
      "cc.as.us",
      "cc.az.us",
      "cc.ca.us",
      "cc.co.us",
      "cc.ct.us",
      "cc.dc.us",
      "cc.de.us",
      "cc.fl.us",
      "cc.ga.us",
      "cc.gu.us",
      "cc.hi.us",
      "cc.ia.us",
      "cc.id.us",
      "cc.il.us",
      "cc.in.us",
      "cc.ks.us",
      "cc.ky.us",
      "cc.la.us",
      "cc.ma.us",
      "cc.md.us",
      "cc.me.us",
      "cc.mi.us",
      "cc.mn.us",
      "cc.mo.us",
      "cc.ms.us",
      "cc.mt.us",
      "cc.nc.us",
      "cc.nd.us",
      "cc.ne.us",
      "cc.nh.us",
      "cc.nj.us",
      "cc.nm.us",
      "cc.nv.us",
      "cc.ny.us",
      "cc.oh.us",
      "cc.ok.us",
      "cc.or.us",
      "cc.pa.us",
      "cc.pr.us",
      "cc.ri.us",
      "cc.sc.us",
      "cc.sd.us",
      "cc.tn.us",
      "cc.tx.us",
      "cc.ut.us",
      "cc.vi.us",
      "cc.vt.us",
      "cc.va.us",
      "cc.wa.us",
      "cc.wi.us",
      "cc.wv.us",
      "cc.wy.us",
      "lib.ak.us",
      "lib.al.us",
      "lib.ar.us",
      "lib.as.us",
      "lib.az.us",
      "lib.ca.us",
      "lib.co.us",
      "lib.ct.us",
      "lib.dc.us",
      "lib.fl.us",
      "lib.ga.us",
      "lib.gu.us",
      "lib.hi.us",
      "lib.ia.us",
      "lib.id.us",
      "lib.il.us",
      "lib.in.us",
      "lib.ks.us",
      "lib.ky.us",
      "lib.la.us",
      "lib.ma.us",
      "lib.md.us",
      "lib.me.us",
      "lib.mi.us",
      "lib.mn.us",
      "lib.mo.us",
      "lib.ms.us",
      "lib.mt.us",
      "lib.nc.us",
      "lib.nd.us",
      "lib.ne.us",
      "lib.nh.us",
      "lib.nj.us",
      "lib.nm.us",
      "lib.nv.us",
      "lib.ny.us",
      "lib.oh.us",
      "lib.ok.us",
      "lib.or.us",
      "lib.pa.us",
      "lib.pr.us",
      "lib.ri.us",
      "lib.sc.us",
      "lib.sd.us",
      "lib.tn.us",
      "lib.tx.us",
      "lib.ut.us",
      "lib.vi.us",
      "lib.vt.us",
      "lib.va.us",
      "lib.wa.us",
      "lib.wi.us",
      "lib.wy.us",
      "pvt.k12.ma.us",
      "chtr.k12.ma.us",
      "paroch.k12.ma.us",
      "ann-arbor.mi.us",
      "cog.mi.us",
      "dst.mi.us",
      "eaton.mi.us",
      "gen.mi.us",
      "mus.mi.us",
      "tec.mi.us",
      "washtenaw.mi.us",
      "uy",
      "com.uy",
      "edu.uy",
      "gub.uy",
      "mil.uy",
      "net.uy",
      "org.uy",
      "uz",
      "co.uz",
      "com.uz",
      "net.uz",
      "org.uz",
      "va",
      "vc",
      "com.vc",
      "net.vc",
      "org.vc",
      "gov.vc",
      "mil.vc",
      "edu.vc",
      "ve",
      "arts.ve",
      "bib.ve",
      "co.ve",
      "com.ve",
      "e12.ve",
      "edu.ve",
      "firm.ve",
      "gob.ve",
      "gov.ve",
      "info.ve",
      "int.ve",
      "mil.ve",
      "net.ve",
      "nom.ve",
      "org.ve",
      "rar.ve",
      "rec.ve",
      "store.ve",
      "tec.ve",
      "web.ve",
      "vg",
      "vi",
      "co.vi",
      "com.vi",
      "k12.vi",
      "net.vi",
      "org.vi",
      "vn",
      "com.vn",
      "net.vn",
      "org.vn",
      "edu.vn",
      "gov.vn",
      "int.vn",
      "ac.vn",
      "biz.vn",
      "info.vn",
      "name.vn",
      "pro.vn",
      "health.vn",
      "vu",
      "com.vu",
      "edu.vu",
      "net.vu",
      "org.vu",
      "wf",
      "ws",
      "com.ws",
      "net.ws",
      "org.ws",
      "gov.ws",
      "edu.ws",
      "yt",
      "امارات",
      "հայ",
      "বাংলা",
      "бг",
      "البحرين",
      "бел",
      "中国",
      "中國",
      "الجزائر",
      "مصر",
      "ею",
      "ευ",
      "موريتانيا",
      "გე",
      "ελ",
      "香港",
      "公司.香港",
      "教育.香港",
      "政府.香港",
      "個人.香港",
      "網絡.香港",
      "組織.香港",
      "ಭಾರತ",
      "ଭାରତ",
      "ভাৰত",
      "भारतम्",
      "भारोत",
      "ڀارت",
      "ഭാരതം",
      "भारत",
      "بارت",
      "بھارت",
      "భారత్",
      "ભારત",
      "ਭਾਰਤ",
      "ভারত",
      "இந்தியா",
      "ایران",
      "ايران",
      "عراق",
      "الاردن",
      "한국",
      "қаз",
      "ລາວ",
      "ලංකා",
      "இலங்கை",
      "المغرب",
      "мкд",
      "мон",
      "澳門",
      "澳门",
      "مليسيا",
      "عمان",
      "پاکستان",
      "پاكستان",
      "فلسطين",
      "срб",
      "пр.срб",
      "орг.срб",
      "обр.срб",
      "од.срб",
      "упр.срб",
      "ак.срб",
      "рф",
      "قطر",
      "السعودية",
      "السعودیة",
      "السعودیۃ",
      "السعوديه",
      "سودان",
      "新加坡",
      "சிங்கப்பூர்",
      "سورية",
      "سوريا",
      "ไทย",
      "ศึกษา.ไทย",
      "ธุรกิจ.ไทย",
      "รัฐบาล.ไทย",
      "ทหาร.ไทย",
      "เน็ต.ไทย",
      "องค์กร.ไทย",
      "تونس",
      "台灣",
      "台湾",
      "臺灣",
      "укр",
      "اليمن",
      "xxx",
      "ye",
      "com.ye",
      "edu.ye",
      "gov.ye",
      "net.ye",
      "mil.ye",
      "org.ye",
      "ac.za",
      "agric.za",
      "alt.za",
      "co.za",
      "edu.za",
      "gov.za",
      "grondar.za",
      "law.za",
      "mil.za",
      "net.za",
      "ngo.za",
      "nic.za",
      "nis.za",
      "nom.za",
      "org.za",
      "school.za",
      "tm.za",
      "web.za",
      "zm",
      "ac.zm",
      "biz.zm",
      "co.zm",
      "com.zm",
      "edu.zm",
      "gov.zm",
      "info.zm",
      "mil.zm",
      "net.zm",
      "org.zm",
      "sch.zm",
      "zw",
      "ac.zw",
      "co.zw",
      "gov.zw",
      "mil.zw",
      "org.zw",
      "aaa",
      "aarp",
      "abarth",
      "abb",
      "abbott",
      "abbvie",
      "abc",
      "able",
      "abogado",
      "abudhabi",
      "academy",
      "accenture",
      "accountant",
      "accountants",
      "aco",
      "actor",
      "adac",
      "ads",
      "adult",
      "aeg",
      "aetna",
      "afl",
      "africa",
      "agakhan",
      "agency",
      "aig",
      "airbus",
      "airforce",
      "airtel",
      "akdn",
      "alfaromeo",
      "alibaba",
      "alipay",
      "allfinanz",
      "allstate",
      "ally",
      "alsace",
      "alstom",
      "amazon",
      "americanexpress",
      "americanfamily",
      "amex",
      "amfam",
      "amica",
      "amsterdam",
      "analytics",
      "android",
      "anquan",
      "anz",
      "aol",
      "apartments",
      "app",
      "apple",
      "aquarelle",
      "arab",
      "aramco",
      "archi",
      "army",
      "art",
      "arte",
      "asda",
      "associates",
      "athleta",
      "attorney",
      "auction",
      "audi",
      "audible",
      "audio",
      "auspost",
      "author",
      "auto",
      "autos",
      "avianca",
      "aws",
      "axa",
      "azure",
      "baby",
      "baidu",
      "banamex",
      "bananarepublic",
      "band",
      "bank",
      "bar",
      "barcelona",
      "barclaycard",
      "barclays",
      "barefoot",
      "bargains",
      "baseball",
      "basketball",
      "bauhaus",
      "bayern",
      "bbc",
      "bbt",
      "bbva",
      "bcg",
      "bcn",
      "beats",
      "beauty",
      "beer",
      "bentley",
      "berlin",
      "best",
      "bestbuy",
      "bet",
      "bharti",
      "bible",
      "bid",
      "bike",
      "bing",
      "bingo",
      "bio",
      "black",
      "blackfriday",
      "blockbuster",
      "blog",
      "bloomberg",
      "blue",
      "bms",
      "bmw",
      "bnpparibas",
      "boats",
      "boehringer",
      "bofa",
      "bom",
      "bond",
      "boo",
      "book",
      "booking",
      "bosch",
      "bostik",
      "boston",
      "bot",
      "boutique",
      "box",
      "bradesco",
      "bridgestone",
      "broadway",
      "broker",
      "brother",
      "brussels",
      "bugatti",
      "build",
      "builders",
      "business",
      "buy",
      "buzz",
      "bzh",
      "cab",
      "cafe",
      "cal",
      "call",
      "calvinklein",
      "cam",
      "camera",
      "camp",
      "cancerresearch",
      "canon",
      "capetown",
      "capital",
      "capitalone",
      "car",
      "caravan",
      "cards",
      "care",
      "career",
      "careers",
      "cars",
      "casa",
      "case",
      "cash",
      "casino",
      "catering",
      "catholic",
      "cba",
      "cbn",
      "cbre",
      "cbs",
      "center",
      "ceo",
      "cern",
      "cfa",
      "cfd",
      "chanel",
      "channel",
      "charity",
      "chase",
      "chat",
      "cheap",
      "chintai",
      "christmas",
      "chrome",
      "church",
      "cipriani",
      "circle",
      "cisco",
      "citadel",
      "citi",
      "citic",
      "city",
      "cityeats",
      "claims",
      "cleaning",
      "click",
      "clinic",
      "clinique",
      "clothing",
      "cloud",
      "club",
      "clubmed",
      "coach",
      "codes",
      "coffee",
      "college",
      "cologne",
      "comcast",
      "commbank",
      "community",
      "company",
      "compare",
      "computer",
      "comsec",
      "condos",
      "construction",
      "consulting",
      "contact",
      "contractors",
      "cooking",
      "cookingchannel",
      "cool",
      "corsica",
      "country",
      "coupon",
      "coupons",
      "courses",
      "cpa",
      "credit",
      "creditcard",
      "creditunion",
      "cricket",
      "crown",
      "crs",
      "cruise",
      "cruises",
      "cuisinella",
      "cymru",
      "cyou",
      "dabur",
      "dad",
      "dance",
      "data",
      "date",
      "dating",
      "datsun",
      "day",
      "dclk",
      "dds",
      "deal",
      "dealer",
      "deals",
      "degree",
      "delivery",
      "dell",
      "deloitte",
      "delta",
      "democrat",
      "dental",
      "dentist",
      "desi",
      "design",
      "dev",
      "dhl",
      "diamonds",
      "diet",
      "digital",
      "direct",
      "directory",
      "discount",
      "discover",
      "dish",
      "diy",
      "dnp",
      "docs",
      "doctor",
      "dog",
      "domains",
      "dot",
      "download",
      "drive",
      "dtv",
      "dubai",
      "dunlop",
      "dupont",
      "durban",
      "dvag",
      "dvr",
      "earth",
      "eat",
      "eco",
      "edeka",
      "education",
      "email",
      "emerck",
      "energy",
      "engineer",
      "engineering",
      "enterprises",
      "epson",
      "equipment",
      "ericsson",
      "erni",
      "esq",
      "estate",
      "etisalat",
      "eurovision",
      "eus",
      "events",
      "exchange",
      "expert",
      "exposed",
      "express",
      "extraspace",
      "fage",
      "fail",
      "fairwinds",
      "faith",
      "family",
      "fan",
      "fans",
      "farm",
      "farmers",
      "fashion",
      "fast",
      "fedex",
      "feedback",
      "ferrari",
      "ferrero",
      "fiat",
      "fidelity",
      "fido",
      "film",
      "final",
      "finance",
      "financial",
      "fire",
      "firestone",
      "firmdale",
      "fish",
      "fishing",
      "fit",
      "fitness",
      "flickr",
      "flights",
      "flir",
      "florist",
      "flowers",
      "fly",
      "foo",
      "food",
      "foodnetwork",
      "football",
      "ford",
      "forex",
      "forsale",
      "forum",
      "foundation",
      "fox",
      "free",
      "fresenius",
      "frl",
      "frogans",
      "frontdoor",
      "frontier",
      "ftr",
      "fujitsu",
      "fun",
      "fund",
      "furniture",
      "futbol",
      "fyi",
      "gal",
      "gallery",
      "gallo",
      "gallup",
      "game",
      "games",
      "gap",
      "garden",
      "gay",
      "gbiz",
      "gdn",
      "gea",
      "gent",
      "genting",
      "george",
      "ggee",
      "gift",
      "gifts",
      "gives",
      "giving",
      "glass",
      "gle",
      "global",
      "globo",
      "gmail",
      "gmbh",
      "gmo",
      "gmx",
      "godaddy",
      "gold",
      "goldpoint",
      "golf",
      "goo",
      "goodyear",
      "goog",
      "google",
      "gop",
      "got",
      "grainger",
      "graphics",
      "gratis",
      "green",
      "gripe",
      "grocery",
      "group",
      "guardian",
      "gucci",
      "guge",
      "guide",
      "guitars",
      "guru",
      "hair",
      "hamburg",
      "hangout",
      "haus",
      "hbo",
      "hdfc",
      "hdfcbank",
      "health",
      "healthcare",
      "help",
      "helsinki",
      "here",
      "hermes",
      "hgtv",
      "hiphop",
      "hisamitsu",
      "hitachi",
      "hiv",
      "hkt",
      "hockey",
      "holdings",
      "holiday",
      "homedepot",
      "homegoods",
      "homes",
      "homesense",
      "honda",
      "horse",
      "hospital",
      "host",
      "hosting",
      "hot",
      "hoteles",
      "hotels",
      "hotmail",
      "house",
      "how",
      "hsbc",
      "hughes",
      "hyatt",
      "hyundai",
      "ibm",
      "icbc",
      "ice",
      "icu",
      "ieee",
      "ifm",
      "ikano",
      "imamat",
      "imdb",
      "immo",
      "immobilien",
      "inc",
      "industries",
      "infiniti",
      "ing",
      "ink",
      "institute",
      "insurance",
      "insure",
      "international",
      "intuit",
      "investments",
      "ipiranga",
      "irish",
      "ismaili",
      "ist",
      "istanbul",
      "itau",
      "itv",
      "jaguar",
      "java",
      "jcb",
      "jeep",
      "jetzt",
      "jewelry",
      "jio",
      "jll",
      "jmp",
      "jnj",
      "joburg",
      "jot",
      "joy",
      "jpmorgan",
      "jprs",
      "juegos",
      "juniper",
      "kaufen",
      "kddi",
      "kerryhotels",
      "kerrylogistics",
      "kerryproperties",
      "kfh",
      "kia",
      "kids",
      "kim",
      "kinder",
      "kindle",
      "kitchen",
      "kiwi",
      "koeln",
      "komatsu",
      "kosher",
      "kpmg",
      "kpn",
      "krd",
      "kred",
      "kuokgroup",
      "kyoto",
      "lacaixa",
      "lamborghini",
      "lamer",
      "lancaster",
      "lancia",
      "land",
      "landrover",
      "lanxess",
      "lasalle",
      "lat",
      "latino",
      "latrobe",
      "law",
      "lawyer",
      "lds",
      "lease",
      "leclerc",
      "lefrak",
      "legal",
      "lego",
      "lexus",
      "lgbt",
      "lidl",
      "life",
      "lifeinsurance",
      "lifestyle",
      "lighting",
      "like",
      "lilly",
      "limited",
      "limo",
      "lincoln",
      "linde",
      "link",
      "lipsy",
      "live",
      "living",
      "llc",
      "llp",
      "loan",
      "loans",
      "locker",
      "locus",
      "loft",
      "lol",
      "london",
      "lotte",
      "lotto",
      "love",
      "lpl",
      "lplfinancial",
      "ltd",
      "ltda",
      "lundbeck",
      "luxe",
      "luxury",
      "macys",
      "madrid",
      "maif",
      "maison",
      "makeup",
      "man",
      "management",
      "mango",
      "map",
      "market",
      "marketing",
      "markets",
      "marriott",
      "marshalls",
      "maserati",
      "mattel",
      "mba",
      "mckinsey",
      "med",
      "media",
      "meet",
      "melbourne",
      "meme",
      "memorial",
      "men",
      "menu",
      "merckmsd",
      "miami",
      "microsoft",
      "mini",
      "mint",
      "mit",
      "mitsubishi",
      "mlb",
      "mls",
      "mma",
      "mobile",
      "moda",
      "moe",
      "moi",
      "mom",
      "monash",
      "money",
      "monster",
      "mormon",
      "mortgage",
      "moscow",
      "moto",
      "motorcycles",
      "mov",
      "movie",
      "msd",
      "mtn",
      "mtr",
      "music",
      "mutual",
      "nab",
      "nagoya",
      "natura",
      "navy",
      "nba",
      "nec",
      "netbank",
      "netflix",
      "network",
      "neustar",
      "new",
      "news",
      "next",
      "nextdirect",
      "nexus",
      "nfl",
      "ngo",
      "nhk",
      "nico",
      "nike",
      "nikon",
      "ninja",
      "nissan",
      "nissay",
      "nokia",
      "northwesternmutual",
      "norton",
      "now",
      "nowruz",
      "nowtv",
      "nra",
      "nrw",
      "ntt",
      "nyc",
      "obi",
      "observer",
      "office",
      "okinawa",
      "olayan",
      "olayangroup",
      "oldnavy",
      "ollo",
      "omega",
      "one",
      "ong",
      "onl",
      "online",
      "ooo",
      "open",
      "oracle",
      "orange",
      "organic",
      "origins",
      "osaka",
      "otsuka",
      "ott",
      "ovh",
      "page",
      "panasonic",
      "paris",
      "pars",
      "partners",
      "parts",
      "party",
      "passagens",
      "pay",
      "pccw",
      "pet",
      "pfizer",
      "pharmacy",
      "phd",
      "philips",
      "phone",
      "photo",
      "photography",
      "photos",
      "physio",
      "pics",
      "pictet",
      "pictures",
      "pid",
      "pin",
      "ping",
      "pink",
      "pioneer",
      "pizza",
      "place",
      "play",
      "playstation",
      "plumbing",
      "plus",
      "pnc",
      "pohl",
      "poker",
      "politie",
      "porn",
      "pramerica",
      "praxi",
      "press",
      "prime",
      "prod",
      "productions",
      "prof",
      "progressive",
      "promo",
      "properties",
      "property",
      "protection",
      "pru",
      "prudential",
      "pub",
      "pwc",
      "qpon",
      "quebec",
      "quest",
      "racing",
      "radio",
      "read",
      "realestate",
      "realtor",
      "realty",
      "recipes",
      "red",
      "redstone",
      "redumbrella",
      "rehab",
      "reise",
      "reisen",
      "reit",
      "reliance",
      "ren",
      "rent",
      "rentals",
      "repair",
      "report",
      "republican",
      "rest",
      "restaurant",
      "review",
      "reviews",
      "rexroth",
      "rich",
      "richardli",
      "ricoh",
      "ril",
      "rio",
      "rip",
      "rocher",
      "rocks",
      "rodeo",
      "rogers",
      "room",
      "rsvp",
      "rugby",
      "ruhr",
      "run",
      "rwe",
      "ryukyu",
      "saarland",
      "safe",
      "safety",
      "sakura",
      "sale",
      "salon",
      "samsclub",
      "samsung",
      "sandvik",
      "sandvikcoromant",
      "sanofi",
      "sap",
      "sarl",
      "sas",
      "save",
      "saxo",
      "sbi",
      "sbs",
      "sca",
      "scb",
      "schaeffler",
      "schmidt",
      "scholarships",
      "school",
      "schule",
      "schwarz",
      "science",
      "scot",
      "search",
      "seat",
      "secure",
      "security",
      "seek",
      "select",
      "sener",
      "services",
      "ses",
      "seven",
      "sew",
      "sex",
      "sexy",
      "sfr",
      "shangrila",
      "sharp",
      "shaw",
      "shell",
      "shia",
      "shiksha",
      "shoes",
      "shop",
      "shopping",
      "shouji",
      "show",
      "showtime",
      "silk",
      "sina",
      "singles",
      "site",
      "ski",
      "skin",
      "sky",
      "skype",
      "sling",
      "smart",
      "smile",
      "sncf",
      "soccer",
      "social",
      "softbank",
      "software",
      "sohu",
      "solar",
      "solutions",
      "song",
      "sony",
      "soy",
      "spa",
      "space",
      "sport",
      "spot",
      "srl",
      "stada",
      "staples",
      "star",
      "statebank",
      "statefarm",
      "stc",
      "stcgroup",
      "stockholm",
      "storage",
      "store",
      "stream",
      "studio",
      "study",
      "style",
      "sucks",
      "supplies",
      "supply",
      "support",
      "surf",
      "surgery",
      "suzuki",
      "swatch",
      "swiss",
      "sydney",
      "systems",
      "tab",
      "taipei",
      "talk",
      "taobao",
      "target",
      "tatamotors",
      "tatar",
      "tattoo",
      "tax",
      "taxi",
      "tci",
      "tdk",
      "team",
      "tech",
      "technology",
      "temasek",
      "tennis",
      "teva",
      "thd",
      "theater",
      "theatre",
      "tiaa",
      "tickets",
      "tienda",
      "tiffany",
      "tips",
      "tires",
      "tirol",
      "tjmaxx",
      "tjx",
      "tkmaxx",
      "tmall",
      "today",
      "tokyo",
      "tools",
      "top",
      "toray",
      "toshiba",
      "total",
      "tours",
      "town",
      "toyota",
      "toys",
      "trade",
      "trading",
      "training",
      "travel",
      "travelchannel",
      "travelers",
      "travelersinsurance",
      "trust",
      "trv",
      "tube",
      "tui",
      "tunes",
      "tushu",
      "tvs",
      "ubank",
      "ubs",
      "unicom",
      "university",
      "uno",
      "uol",
      "ups",
      "vacations",
      "vana",
      "vanguard",
      "vegas",
      "ventures",
      "verisign",
      "versicherung",
      "vet",
      "viajes",
      "video",
      "vig",
      "viking",
      "villas",
      "vin",
      "vip",
      "virgin",
      "visa",
      "vision",
      "viva",
      "vivo",
      "vlaanderen",
      "vodka",
      "volkswagen",
      "volvo",
      "vote",
      "voting",
      "voto",
      "voyage",
      "vuelos",
      "wales",
      "walmart",
      "walter",
      "wang",
      "wanggou",
      "watch",
      "watches",
      "weather",
      "weatherchannel",
      "webcam",
      "weber",
      "website",
      "wedding",
      "weibo",
      "weir",
      "whoswho",
      "wien",
      "wiki",
      "williamhill",
      "win",
      "windows",
      "wine",
      "winners",
      "wme",
      "wolterskluwer",
      "woodside",
      "work",
      "works",
      "world",
      "wow",
      "wtc",
      "wtf",
      "xbox",
      "xerox",
      "xfinity",
      "xihuan",
      "xin",
      "कॉम",
      "セール",
      "佛山",
      "慈善",
      "集团",
      "在线",
      "点看",
      "คอม",
      "八卦",
      "موقع",
      "公益",
      "公司",
      "香格里拉",
      "网站",
      "移动",
      "我爱你",
      "москва",
      "католик",
      "онлайн",
      "сайт",
      "联通",
      "קום",
      "时尚",
      "微博",
      "淡马锡",
      "ファッション",
      "орг",
      "नेट",
      "ストア",
      "アマゾン",
      "삼성",
      "商标",
      "商店",
      "商城",
      "дети",
      "ポイント",
      "新闻",
      "家電",
      "كوم",
      "中文网",
      "中信",
      "娱乐",
      "谷歌",
      "電訊盈科",
      "购物",
      "クラウド",
      "通販",
      "网店",
      "संगठन",
      "餐厅",
      "网络",
      "ком",
      "亚马逊",
      "诺基亚",
      "食品",
      "飞利浦",
      "手机",
      "ارامكو",
      "العليان",
      "اتصالات",
      "بازار",
      "ابوظبي",
      "كاثوليك",
      "همراه",
      "닷컴",
      "政府",
      "شبكة",
      "بيتك",
      "عرب",
      "机构",
      "组织机构",
      "健康",
      "招聘",
      "рус",
      "大拿",
      "みんな",
      "グーグル",
      "世界",
      "書籍",
      "网址",
      "닷넷",
      "コム",
      "天主教",
      "游戏",
      "vermögensberater",
      "vermögensberatung",
      "企业",
      "信息",
      "嘉里大酒店",
      "嘉里",
      "广东",
      "政务",
      "xyz",
      "yachts",
      "yahoo",
      "yamaxun",
      "yandex",
      "yodobashi",
      "yoga",
      "yokohama",
      "you",
      "youtube",
      "yun",
      "zappos",
      "zara",
      "zero",
      "zip",
      "zone",
      "zuerich",
      "cc.ua",
      "inf.ua",
      "ltd.ua",
      "611.to",
      "graphox.us",
      "*.devcdnaccesso.com",
      "adobeaemcloud.com",
      "*.dev.adobeaemcloud.com",
      "hlx.live",
      "adobeaemcloud.net",
      "hlx.page",
      "hlx3.page",
      "beep.pl",
      "airkitapps.com",
      "airkitapps-au.com",
      "airkitapps.eu",
      "aivencloud.com",
      "barsy.ca",
      "*.compute.estate",
      "*.alces.network",
      "kasserver.com",
      "altervista.org",
      "alwaysdata.net",
      "cloudfront.net",
      "*.compute.amazonaws.com",
      "*.compute-1.amazonaws.com",
      "*.compute.amazonaws.com.cn",
      "us-east-1.amazonaws.com",
      "cn-north-1.eb.amazonaws.com.cn",
      "cn-northwest-1.eb.amazonaws.com.cn",
      "elasticbeanstalk.com",
      "ap-northeast-1.elasticbeanstalk.com",
      "ap-northeast-2.elasticbeanstalk.com",
      "ap-northeast-3.elasticbeanstalk.com",
      "ap-south-1.elasticbeanstalk.com",
      "ap-southeast-1.elasticbeanstalk.com",
      "ap-southeast-2.elasticbeanstalk.com",
      "ca-central-1.elasticbeanstalk.com",
      "eu-central-1.elasticbeanstalk.com",
      "eu-west-1.elasticbeanstalk.com",
      "eu-west-2.elasticbeanstalk.com",
      "eu-west-3.elasticbeanstalk.com",
      "sa-east-1.elasticbeanstalk.com",
      "us-east-1.elasticbeanstalk.com",
      "us-east-2.elasticbeanstalk.com",
      "us-gov-west-1.elasticbeanstalk.com",
      "us-west-1.elasticbeanstalk.com",
      "us-west-2.elasticbeanstalk.com",
      "*.elb.amazonaws.com",
      "*.elb.amazonaws.com.cn",
      "awsglobalaccelerator.com",
      "s3.amazonaws.com",
      "s3-ap-northeast-1.amazonaws.com",
      "s3-ap-northeast-2.amazonaws.com",
      "s3-ap-south-1.amazonaws.com",
      "s3-ap-southeast-1.amazonaws.com",
      "s3-ap-southeast-2.amazonaws.com",
      "s3-ca-central-1.amazonaws.com",
      "s3-eu-central-1.amazonaws.com",
      "s3-eu-west-1.amazonaws.com",
      "s3-eu-west-2.amazonaws.com",
      "s3-eu-west-3.amazonaws.com",
      "s3-external-1.amazonaws.com",
      "s3-fips-us-gov-west-1.amazonaws.com",
      "s3-sa-east-1.amazonaws.com",
      "s3-us-gov-west-1.amazonaws.com",
      "s3-us-east-2.amazonaws.com",
      "s3-us-west-1.amazonaws.com",
      "s3-us-west-2.amazonaws.com",
      "s3.ap-northeast-2.amazonaws.com",
      "s3.ap-south-1.amazonaws.com",
      "s3.cn-north-1.amazonaws.com.cn",
      "s3.ca-central-1.amazonaws.com",
      "s3.eu-central-1.amazonaws.com",
      "s3.eu-west-2.amazonaws.com",
      "s3.eu-west-3.amazonaws.com",
      "s3.us-east-2.amazonaws.com",
      "s3.dualstack.ap-northeast-1.amazonaws.com",
      "s3.dualstack.ap-northeast-2.amazonaws.com",
      "s3.dualstack.ap-south-1.amazonaws.com",
      "s3.dualstack.ap-southeast-1.amazonaws.com",
      "s3.dualstack.ap-southeast-2.amazonaws.com",
      "s3.dualstack.ca-central-1.amazonaws.com",
      "s3.dualstack.eu-central-1.amazonaws.com",
      "s3.dualstack.eu-west-1.amazonaws.com",
      "s3.dualstack.eu-west-2.amazonaws.com",
      "s3.dualstack.eu-west-3.amazonaws.com",
      "s3.dualstack.sa-east-1.amazonaws.com",
      "s3.dualstack.us-east-1.amazonaws.com",
      "s3.dualstack.us-east-2.amazonaws.com",
      "s3-website-us-east-1.amazonaws.com",
      "s3-website-us-west-1.amazonaws.com",
      "s3-website-us-west-2.amazonaws.com",
      "s3-website-ap-northeast-1.amazonaws.com",
      "s3-website-ap-southeast-1.amazonaws.com",
      "s3-website-ap-southeast-2.amazonaws.com",
      "s3-website-eu-west-1.amazonaws.com",
      "s3-website-sa-east-1.amazonaws.com",
      "s3-website.ap-northeast-2.amazonaws.com",
      "s3-website.ap-south-1.amazonaws.com",
      "s3-website.ca-central-1.amazonaws.com",
      "s3-website.eu-central-1.amazonaws.com",
      "s3-website.eu-west-2.amazonaws.com",
      "s3-website.eu-west-3.amazonaws.com",
      "s3-website.us-east-2.amazonaws.com",
      "t3l3p0rt.net",
      "tele.amune.org",
      "apigee.io",
      "siiites.com",
      "appspacehosted.com",
      "appspaceusercontent.com",
      "appudo.net",
      "on-aptible.com",
      "user.aseinet.ne.jp",
      "gv.vc",
      "d.gv.vc",
      "user.party.eus",
      "pimienta.org",
      "poivron.org",
      "potager.org",
      "sweetpepper.org",
      "myasustor.com",
      "cdn.prod.atlassian-dev.net",
      "translated.page",
      "myfritz.net",
      "onavstack.net",
      "*.awdev.ca",
      "*.advisor.ws",
      "ecommerce-shop.pl",
      "b-data.io",
      "backplaneapp.io",
      "balena-devices.com",
      "rs.ba",
      "*.banzai.cloud",
      "app.banzaicloud.io",
      "*.backyards.banzaicloud.io",
      "base.ec",
      "official.ec",
      "buyshop.jp",
      "fashionstore.jp",
      "handcrafted.jp",
      "kawaiishop.jp",
      "supersale.jp",
      "theshop.jp",
      "shopselect.net",
      "base.shop",
      "*.beget.app",
      "betainabox.com",
      "bnr.la",
      "bitbucket.io",
      "blackbaudcdn.net",
      "of.je",
      "bluebite.io",
      "boomla.net",
      "boutir.com",
      "boxfuse.io",
      "square7.ch",
      "bplaced.com",
      "bplaced.de",
      "square7.de",
      "bplaced.net",
      "square7.net",
      "shop.brendly.rs",
      "browsersafetymark.io",
      "uk0.bigv.io",
      "dh.bytemark.co.uk",
      "vm.bytemark.co.uk",
      "cafjs.com",
      "mycd.eu",
      "drr.ac",
      "uwu.ai",
      "carrd.co",
      "crd.co",
      "ju.mp",
      "ae.org",
      "br.com",
      "cn.com",
      "com.de",
      "com.se",
      "de.com",
      "eu.com",
      "gb.net",
      "hu.net",
      "jp.net",
      "jpn.com",
      "mex.com",
      "ru.com",
      "sa.com",
      "se.net",
      "uk.com",
      "uk.net",
      "us.com",
      "za.bz",
      "za.com",
      "ar.com",
      "hu.com",
      "kr.com",
      "no.com",
      "qc.com",
      "uy.com",
      "africa.com",
      "gr.com",
      "in.net",
      "web.in",
      "us.org",
      "co.com",
      "aus.basketball",
      "nz.basketball",
      "radio.am",
      "radio.fm",
      "c.la",
      "certmgr.org",
      "cx.ua",
      "discourse.group",
      "discourse.team",
      "cleverapps.io",
      "clerk.app",
      "clerkstage.app",
      "*.lcl.dev",
      "*.lclstage.dev",
      "*.stg.dev",
      "*.stgstage.dev",
      "clickrising.net",
      "c66.me",
      "cloud66.ws",
      "cloud66.zone",
      "jdevcloud.com",
      "wpdevcloud.com",
      "cloudaccess.host",
      "freesite.host",
      "cloudaccess.net",
      "cloudcontrolled.com",
      "cloudcontrolapp.com",
      "*.cloudera.site",
      "pages.dev",
      "trycloudflare.com",
      "workers.dev",
      "wnext.app",
      "co.ca",
      "*.otap.co",
      "co.cz",
      "c.cdn77.org",
      "cdn77-ssl.net",
      "r.cdn77.net",
      "rsc.cdn77.org",
      "ssl.origin.cdn77-secure.org",
      "cloudns.asia",
      "cloudns.biz",
      "cloudns.club",
      "cloudns.cc",
      "cloudns.eu",
      "cloudns.in",
      "cloudns.info",
      "cloudns.org",
      "cloudns.pro",
      "cloudns.pw",
      "cloudns.us",
      "cnpy.gdn",
      "codeberg.page",
      "co.nl",
      "co.no",
      "webhosting.be",
      "hosting-cluster.nl",
      "ac.ru",
      "edu.ru",
      "gov.ru",
      "int.ru",
      "mil.ru",
      "test.ru",
      "dyn.cosidns.de",
      "dynamisches-dns.de",
      "dnsupdater.de",
      "internet-dns.de",
      "l-o-g-i-n.de",
      "dynamic-dns.info",
      "feste-ip.net",
      "knx-server.net",
      "static-access.net",
      "realm.cz",
      "*.cryptonomic.net",
      "cupcake.is",
      "curv.dev",
      "*.customer-oci.com",
      "*.oci.customer-oci.com",
      "*.ocp.customer-oci.com",
      "*.ocs.customer-oci.com",
      "cyon.link",
      "cyon.site",
      "fnwk.site",
      "folionetwork.site",
      "platform0.app",
      "daplie.me",
      "localhost.daplie.me",
      "dattolocal.com",
      "dattorelay.com",
      "dattoweb.com",
      "mydatto.com",
      "dattolocal.net",
      "mydatto.net",
      "biz.dk",
      "co.dk",
      "firm.dk",
      "reg.dk",
      "store.dk",
      "dyndns.dappnode.io",
      "*.dapps.earth",
      "*.bzz.dapps.earth",
      "builtwithdark.com",
      "demo.datadetect.com",
      "instance.datadetect.com",
      "edgestack.me",
      "ddns5.com",
      "debian.net",
      "deno.dev",
      "deno-staging.dev",
      "dedyn.io",
      "deta.app",
      "deta.dev",
      "*.rss.my.id",
      "*.diher.solutions",
      "discordsays.com",
      "discordsez.com",
      "jozi.biz",
      "dnshome.de",
      "online.th",
      "shop.th",
      "drayddns.com",
      "shoparena.pl",
      "dreamhosters.com",
      "mydrobo.com",
      "drud.io",
      "drud.us",
      "duckdns.org",
      "bip.sh",
      "bitbridge.net",
      "dy.fi",
      "tunk.org",
      "dyndns-at-home.com",
      "dyndns-at-work.com",
      "dyndns-blog.com",
      "dyndns-free.com",
      "dyndns-home.com",
      "dyndns-ip.com",
      "dyndns-mail.com",
      "dyndns-office.com",
      "dyndns-pics.com",
      "dyndns-remote.com",
      "dyndns-server.com",
      "dyndns-web.com",
      "dyndns-wiki.com",
      "dyndns-work.com",
      "dyndns.biz",
      "dyndns.info",
      "dyndns.org",
      "dyndns.tv",
      "at-band-camp.net",
      "ath.cx",
      "barrel-of-knowledge.info",
      "barrell-of-knowledge.info",
      "better-than.tv",
      "blogdns.com",
      "blogdns.net",
      "blogdns.org",
      "blogsite.org",
      "boldlygoingnowhere.org",
      "broke-it.net",
      "buyshouses.net",
      "cechire.com",
      "dnsalias.com",
      "dnsalias.net",
      "dnsalias.org",
      "dnsdojo.com",
      "dnsdojo.net",
      "dnsdojo.org",
      "does-it.net",
      "doesntexist.com",
      "doesntexist.org",
      "dontexist.com",
      "dontexist.net",
      "dontexist.org",
      "doomdns.com",
      "doomdns.org",
      "dvrdns.org",
      "dyn-o-saur.com",
      "dynalias.com",
      "dynalias.net",
      "dynalias.org",
      "dynathome.net",
      "dyndns.ws",
      "endofinternet.net",
      "endofinternet.org",
      "endoftheinternet.org",
      "est-a-la-maison.com",
      "est-a-la-masion.com",
      "est-le-patron.com",
      "est-mon-blogueur.com",
      "for-better.biz",
      "for-more.biz",
      "for-our.info",
      "for-some.biz",
      "for-the.biz",
      "forgot.her.name",
      "forgot.his.name",
      "from-ak.com",
      "from-al.com",
      "from-ar.com",
      "from-az.net",
      "from-ca.com",
      "from-co.net",
      "from-ct.com",
      "from-dc.com",
      "from-de.com",
      "from-fl.com",
      "from-ga.com",
      "from-hi.com",
      "from-ia.com",
      "from-id.com",
      "from-il.com",
      "from-in.com",
      "from-ks.com",
      "from-ky.com",
      "from-la.net",
      "from-ma.com",
      "from-md.com",
      "from-me.org",
      "from-mi.com",
      "from-mn.com",
      "from-mo.com",
      "from-ms.com",
      "from-mt.com",
      "from-nc.com",
      "from-nd.com",
      "from-ne.com",
      "from-nh.com",
      "from-nj.com",
      "from-nm.com",
      "from-nv.com",
      "from-ny.net",
      "from-oh.com",
      "from-ok.com",
      "from-or.com",
      "from-pa.com",
      "from-pr.com",
      "from-ri.com",
      "from-sc.com",
      "from-sd.com",
      "from-tn.com",
      "from-tx.com",
      "from-ut.com",
      "from-va.com",
      "from-vt.com",
      "from-wa.com",
      "from-wi.com",
      "from-wv.com",
      "from-wy.com",
      "ftpaccess.cc",
      "fuettertdasnetz.de",
      "game-host.org",
      "game-server.cc",
      "getmyip.com",
      "gets-it.net",
      "go.dyndns.org",
      "gotdns.com",
      "gotdns.org",
      "groks-the.info",
      "groks-this.info",
      "ham-radio-op.net",
      "here-for-more.info",
      "hobby-site.com",
      "hobby-site.org",
      "home.dyndns.org",
      "homedns.org",
      "homeftp.net",
      "homeftp.org",
      "homeip.net",
      "homelinux.com",
      "homelinux.net",
      "homelinux.org",
      "homeunix.com",
      "homeunix.net",
      "homeunix.org",
      "iamallama.com",
      "in-the-band.net",
      "is-a-anarchist.com",
      "is-a-blogger.com",
      "is-a-bookkeeper.com",
      "is-a-bruinsfan.org",
      "is-a-bulls-fan.com",
      "is-a-candidate.org",
      "is-a-caterer.com",
      "is-a-celticsfan.org",
      "is-a-chef.com",
      "is-a-chef.net",
      "is-a-chef.org",
      "is-a-conservative.com",
      "is-a-cpa.com",
      "is-a-cubicle-slave.com",
      "is-a-democrat.com",
      "is-a-designer.com",
      "is-a-doctor.com",
      "is-a-financialadvisor.com",
      "is-a-geek.com",
      "is-a-geek.net",
      "is-a-geek.org",
      "is-a-green.com",
      "is-a-guru.com",
      "is-a-hard-worker.com",
      "is-a-hunter.com",
      "is-a-knight.org",
      "is-a-landscaper.com",
      "is-a-lawyer.com",
      "is-a-liberal.com",
      "is-a-libertarian.com",
      "is-a-linux-user.org",
      "is-a-llama.com",
      "is-a-musician.com",
      "is-a-nascarfan.com",
      "is-a-nurse.com",
      "is-a-painter.com",
      "is-a-patsfan.org",
      "is-a-personaltrainer.com",
      "is-a-photographer.com",
      "is-a-player.com",
      "is-a-republican.com",
      "is-a-rockstar.com",
      "is-a-socialist.com",
      "is-a-soxfan.org",
      "is-a-student.com",
      "is-a-teacher.com",
      "is-a-techie.com",
      "is-a-therapist.com",
      "is-an-accountant.com",
      "is-an-actor.com",
      "is-an-actress.com",
      "is-an-anarchist.com",
      "is-an-artist.com",
      "is-an-engineer.com",
      "is-an-entertainer.com",
      "is-by.us",
      "is-certified.com",
      "is-found.org",
      "is-gone.com",
      "is-into-anime.com",
      "is-into-cars.com",
      "is-into-cartoons.com",
      "is-into-games.com",
      "is-leet.com",
      "is-lost.org",
      "is-not-certified.com",
      "is-saved.org",
      "is-slick.com",
      "is-uberleet.com",
      "is-very-bad.org",
      "is-very-evil.org",
      "is-very-good.org",
      "is-very-nice.org",
      "is-very-sweet.org",
      "is-with-theband.com",
      "isa-geek.com",
      "isa-geek.net",
      "isa-geek.org",
      "isa-hockeynut.com",
      "issmarterthanyou.com",
      "isteingeek.de",
      "istmein.de",
      "kicks-ass.net",
      "kicks-ass.org",
      "knowsitall.info",
      "land-4-sale.us",
      "lebtimnetz.de",
      "leitungsen.de",
      "likes-pie.com",
      "likescandy.com",
      "merseine.nu",
      "mine.nu",
      "misconfused.org",
      "mypets.ws",
      "myphotos.cc",
      "neat-url.com",
      "office-on-the.net",
      "on-the-web.tv",
      "podzone.net",
      "podzone.org",
      "readmyblog.org",
      "saves-the-whales.com",
      "scrapper-site.net",
      "scrapping.cc",
      "selfip.biz",
      "selfip.com",
      "selfip.info",
      "selfip.net",
      "selfip.org",
      "sells-for-less.com",
      "sells-for-u.com",
      "sells-it.net",
      "sellsyourhome.org",
      "servebbs.com",
      "servebbs.net",
      "servebbs.org",
      "serveftp.net",
      "serveftp.org",
      "servegame.org",
      "shacknet.nu",
      "simple-url.com",
      "space-to-rent.com",
      "stuff-4-sale.org",
      "stuff-4-sale.us",
      "teaches-yoga.com",
      "thruhere.net",
      "traeumtgerade.de",
      "webhop.biz",
      "webhop.info",
      "webhop.net",
      "webhop.org",
      "worse-than.tv",
      "writesthisblog.com",
      "ddnss.de",
      "dyn.ddnss.de",
      "dyndns.ddnss.de",
      "dyndns1.de",
      "dyn-ip24.de",
      "home-webserver.de",
      "dyn.home-webserver.de",
      "myhome-server.de",
      "ddnss.org",
      "definima.net",
      "definima.io",
      "ondigitalocean.app",
      "*.digitaloceanspaces.com",
      "bci.dnstrace.pro",
      "ddnsfree.com",
      "ddnsgeek.com",
      "giize.com",
      "gleeze.com",
      "kozow.com",
      "loseyourip.com",
      "ooguy.com",
      "theworkpc.com",
      "casacam.net",
      "dynu.net",
      "accesscam.org",
      "camdvr.org",
      "freeddns.org",
      "mywire.org",
      "webredirect.org",
      "myddns.rocks",
      "blogsite.xyz",
      "dynv6.net",
      "e4.cz",
      "eero.online",
      "eero-stage.online",
      "elementor.cloud",
      "elementor.cool",
      "en-root.fr",
      "mytuleap.com",
      "tuleap-partners.com",
      "encr.app",
      "encoreapi.com",
      "onred.one",
      "staging.onred.one",
      "eu.encoway.cloud",
      "eu.org",
      "al.eu.org",
      "asso.eu.org",
      "at.eu.org",
      "au.eu.org",
      "be.eu.org",
      "bg.eu.org",
      "ca.eu.org",
      "cd.eu.org",
      "ch.eu.org",
      "cn.eu.org",
      "cy.eu.org",
      "cz.eu.org",
      "de.eu.org",
      "dk.eu.org",
      "edu.eu.org",
      "ee.eu.org",
      "es.eu.org",
      "fi.eu.org",
      "fr.eu.org",
      "gr.eu.org",
      "hr.eu.org",
      "hu.eu.org",
      "ie.eu.org",
      "il.eu.org",
      "in.eu.org",
      "int.eu.org",
      "is.eu.org",
      "it.eu.org",
      "jp.eu.org",
      "kr.eu.org",
      "lt.eu.org",
      "lu.eu.org",
      "lv.eu.org",
      "mc.eu.org",
      "me.eu.org",
      "mk.eu.org",
      "mt.eu.org",
      "my.eu.org",
      "net.eu.org",
      "ng.eu.org",
      "nl.eu.org",
      "no.eu.org",
      "nz.eu.org",
      "paris.eu.org",
      "pl.eu.org",
      "pt.eu.org",
      "q-a.eu.org",
      "ro.eu.org",
      "ru.eu.org",
      "se.eu.org",
      "si.eu.org",
      "sk.eu.org",
      "tr.eu.org",
      "uk.eu.org",
      "us.eu.org",
      "eurodir.ru",
      "eu-1.evennode.com",
      "eu-2.evennode.com",
      "eu-3.evennode.com",
      "eu-4.evennode.com",
      "us-1.evennode.com",
      "us-2.evennode.com",
      "us-3.evennode.com",
      "us-4.evennode.com",
      "twmail.cc",
      "twmail.net",
      "twmail.org",
      "mymailer.com.tw",
      "url.tw",
      "onfabrica.com",
      "apps.fbsbx.com",
      "ru.net",
      "adygeya.ru",
      "bashkiria.ru",
      "bir.ru",
      "cbg.ru",
      "com.ru",
      "dagestan.ru",
      "grozny.ru",
      "kalmykia.ru",
      "kustanai.ru",
      "marine.ru",
      "mordovia.ru",
      "msk.ru",
      "mytis.ru",
      "nalchik.ru",
      "nov.ru",
      "pyatigorsk.ru",
      "spb.ru",
      "vladikavkaz.ru",
      "vladimir.ru",
      "abkhazia.su",
      "adygeya.su",
      "aktyubinsk.su",
      "arkhangelsk.su",
      "armenia.su",
      "ashgabad.su",
      "azerbaijan.su",
      "balashov.su",
      "bashkiria.su",
      "bryansk.su",
      "bukhara.su",
      "chimkent.su",
      "dagestan.su",
      "east-kazakhstan.su",
      "exnet.su",
      "georgia.su",
      "grozny.su",
      "ivanovo.su",
      "jambyl.su",
      "kalmykia.su",
      "kaluga.su",
      "karacol.su",
      "karaganda.su",
      "karelia.su",
      "khakassia.su",
      "krasnodar.su",
      "kurgan.su",
      "kustanai.su",
      "lenug.su",
      "mangyshlak.su",
      "mordovia.su",
      "msk.su",
      "murmansk.su",
      "nalchik.su",
      "navoi.su",
      "north-kazakhstan.su",
      "nov.su",
      "obninsk.su",
      "penza.su",
      "pokrovsk.su",
      "sochi.su",
      "spb.su",
      "tashkent.su",
      "termez.su",
      "togliatti.su",
      "troitsk.su",
      "tselinograd.su",
      "tula.su",
      "tuva.su",
      "vladikavkaz.su",
      "vladimir.su",
      "vologda.su",
      "channelsdvr.net",
      "u.channelsdvr.net",
      "edgecompute.app",
      "fastly-terrarium.com",
      "fastlylb.net",
      "map.fastlylb.net",
      "freetls.fastly.net",
      "map.fastly.net",
      "a.prod.fastly.net",
      "global.prod.fastly.net",
      "a.ssl.fastly.net",
      "b.ssl.fastly.net",
      "global.ssl.fastly.net",
      "fastvps-server.com",
      "fastvps.host",
      "myfast.host",
      "fastvps.site",
      "myfast.space",
      "fedorainfracloud.org",
      "fedorapeople.org",
      "cloud.fedoraproject.org",
      "app.os.fedoraproject.org",
      "app.os.stg.fedoraproject.org",
      "conn.uk",
      "copro.uk",
      "hosp.uk",
      "mydobiss.com",
      "fh-muenster.io",
      "filegear.me",
      "filegear-au.me",
      "filegear-de.me",
      "filegear-gb.me",
      "filegear-ie.me",
      "filegear-jp.me",
      "filegear-sg.me",
      "firebaseapp.com",
      "fireweb.app",
      "flap.id",
      "onflashdrive.app",
      "fldrv.com",
      "fly.dev",
      "edgeapp.net",
      "shw.io",
      "flynnhosting.net",
      "forgeblocks.com",
      "id.forgerock.io",
      "framer.app",
      "framercanvas.com",
      "*.frusky.de",
      "ravpage.co.il",
      "0e.vc",
      "freebox-os.com",
      "freeboxos.com",
      "fbx-os.fr",
      "fbxos.fr",
      "freebox-os.fr",
      "freeboxos.fr",
      "freedesktop.org",
      "freemyip.com",
      "wien.funkfeuer.at",
      "*.futurecms.at",
      "*.ex.futurecms.at",
      "*.in.futurecms.at",
      "futurehosting.at",
      "futuremailing.at",
      "*.ex.ortsinfo.at",
      "*.kunden.ortsinfo.at",
      "*.statics.cloud",
      "independent-commission.uk",
      "independent-inquest.uk",
      "independent-inquiry.uk",
      "independent-panel.uk",
      "independent-review.uk",
      "public-inquiry.uk",
      "royal-commission.uk",
      "campaign.gov.uk",
      "service.gov.uk",
      "api.gov.uk",
      "gehirn.ne.jp",
      "usercontent.jp",
      "gentapps.com",
      "gentlentapis.com",
      "lab.ms",
      "cdn-edges.net",
      "ghost.io",
      "gsj.bz",
      "githubusercontent.com",
      "githubpreview.dev",
      "github.io",
      "gitlab.io",
      "gitapp.si",
      "gitpage.si",
      "glitch.me",
      "nog.community",
      "co.ro",
      "shop.ro",
      "lolipop.io",
      "angry.jp",
      "babyblue.jp",
      "babymilk.jp",
      "backdrop.jp",
      "bambina.jp",
      "bitter.jp",
      "blush.jp",
      "boo.jp",
      "boy.jp",
      "boyfriend.jp",
      "but.jp",
      "candypop.jp",
      "capoo.jp",
      "catfood.jp",
      "cheap.jp",
      "chicappa.jp",
      "chillout.jp",
      "chips.jp",
      "chowder.jp",
      "chu.jp",
      "ciao.jp",
      "cocotte.jp",
      "coolblog.jp",
      "cranky.jp",
      "cutegirl.jp",
      "daa.jp",
      "deca.jp",
      "deci.jp",
      "digick.jp",
      "egoism.jp",
      "fakefur.jp",
      "fem.jp",
      "flier.jp",
      "floppy.jp",
      "fool.jp",
      "frenchkiss.jp",
      "girlfriend.jp",
      "girly.jp",
      "gloomy.jp",
      "gonna.jp",
      "greater.jp",
      "hacca.jp",
      "heavy.jp",
      "her.jp",
      "hiho.jp",
      "hippy.jp",
      "holy.jp",
      "hungry.jp",
      "icurus.jp",
      "itigo.jp",
      "jellybean.jp",
      "kikirara.jp",
      "kill.jp",
      "kilo.jp",
      "kuron.jp",
      "littlestar.jp",
      "lolipopmc.jp",
      "lolitapunk.jp",
      "lomo.jp",
      "lovepop.jp",
      "lovesick.jp",
      "main.jp",
      "mods.jp",
      "mond.jp",
      "mongolian.jp",
      "moo.jp",
      "namaste.jp",
      "nikita.jp",
      "nobushi.jp",
      "noor.jp",
      "oops.jp",
      "parallel.jp",
      "parasite.jp",
      "pecori.jp",
      "peewee.jp",
      "penne.jp",
      "pepper.jp",
      "perma.jp",
      "pigboat.jp",
      "pinoko.jp",
      "punyu.jp",
      "pupu.jp",
      "pussycat.jp",
      "pya.jp",
      "raindrop.jp",
      "readymade.jp",
      "sadist.jp",
      "schoolbus.jp",
      "secret.jp",
      "staba.jp",
      "stripper.jp",
      "sub.jp",
      "sunnyday.jp",
      "thick.jp",
      "tonkotsu.jp",
      "under.jp",
      "upper.jp",
      "velvet.jp",
      "verse.jp",
      "versus.jp",
      "vivian.jp",
      "watson.jp",
      "weblike.jp",
      "whitesnow.jp",
      "zombie.jp",
      "heteml.net",
      "cloudapps.digital",
      "london.cloudapps.digital",
      "pymnt.uk",
      "homeoffice.gov.uk",
      "ro.im",
      "goip.de",
      "run.app",
      "a.run.app",
      "web.app",
      "*.0emm.com",
      "appspot.com",
      "*.r.appspot.com",
      "codespot.com",
      "googleapis.com",
      "googlecode.com",
      "pagespeedmobilizer.com",
      "publishproxy.com",
      "withgoogle.com",
      "withyoutube.com",
      "*.gateway.dev",
      "cloud.goog",
      "translate.goog",
      "*.usercontent.goog",
      "cloudfunctions.net",
      "blogspot.ae",
      "blogspot.al",
      "blogspot.am",
      "blogspot.ba",
      "blogspot.be",
      "blogspot.bg",
      "blogspot.bj",
      "blogspot.ca",
      "blogspot.cf",
      "blogspot.ch",
      "blogspot.cl",
      "blogspot.co.at",
      "blogspot.co.id",
      "blogspot.co.il",
      "blogspot.co.ke",
      "blogspot.co.nz",
      "blogspot.co.uk",
      "blogspot.co.za",
      "blogspot.com",
      "blogspot.com.ar",
      "blogspot.com.au",
      "blogspot.com.br",
      "blogspot.com.by",
      "blogspot.com.co",
      "blogspot.com.cy",
      "blogspot.com.ee",
      "blogspot.com.eg",
      "blogspot.com.es",
      "blogspot.com.mt",
      "blogspot.com.ng",
      "blogspot.com.tr",
      "blogspot.com.uy",
      "blogspot.cv",
      "blogspot.cz",
      "blogspot.de",
      "blogspot.dk",
      "blogspot.fi",
      "blogspot.fr",
      "blogspot.gr",
      "blogspot.hk",
      "blogspot.hr",
      "blogspot.hu",
      "blogspot.ie",
      "blogspot.in",
      "blogspot.is",
      "blogspot.it",
      "blogspot.jp",
      "blogspot.kr",
      "blogspot.li",
      "blogspot.lt",
      "blogspot.lu",
      "blogspot.md",
      "blogspot.mk",
      "blogspot.mr",
      "blogspot.mx",
      "blogspot.my",
      "blogspot.nl",
      "blogspot.no",
      "blogspot.pe",
      "blogspot.pt",
      "blogspot.qa",
      "blogspot.re",
      "blogspot.ro",
      "blogspot.rs",
      "blogspot.ru",
      "blogspot.se",
      "blogspot.sg",
      "blogspot.si",
      "blogspot.sk",
      "blogspot.sn",
      "blogspot.td",
      "blogspot.tw",
      "blogspot.ug",
      "blogspot.vn",
      "goupile.fr",
      "gov.nl",
      "awsmppl.com",
      "günstigbestellen.de",
      "günstigliefern.de",
      "fin.ci",
      "free.hr",
      "caa.li",
      "ua.rs",
      "conf.se",
      "hs.zone",
      "hs.run",
      "hashbang.sh",
      "hasura.app",
      "hasura-app.io",
      "pages.it.hs-heilbronn.de",
      "hepforge.org",
      "herokuapp.com",
      "herokussl.com",
      "ravendb.cloud",
      "myravendb.com",
      "ravendb.community",
      "ravendb.me",
      "development.run",
      "ravendb.run",
      "homesklep.pl",
      "secaas.hk",
      "hoplix.shop",
      "orx.biz",
      "biz.gl",
      "col.ng",
      "firm.ng",
      "gen.ng",
      "ltd.ng",
      "ngo.ng",
      "edu.scot",
      "sch.so",
      "hostyhosting.io",
      "häkkinen.fi",
      "*.moonscale.io",
      "moonscale.net",
      "iki.fi",
      "ibxos.it",
      "iliadboxos.it",
      "impertrixcdn.com",
      "impertrix.com",
      "smushcdn.com",
      "wphostedmail.com",
      "wpmucdn.com",
      "tempurl.host",
      "wpmudev.host",
      "dyn-berlin.de",
      "in-berlin.de",
      "in-brb.de",
      "in-butter.de",
      "in-dsl.de",
      "in-dsl.net",
      "in-dsl.org",
      "in-vpn.de",
      "in-vpn.net",
      "in-vpn.org",
      "biz.at",
      "info.at",
      "info.cx",
      "ac.leg.br",
      "al.leg.br",
      "am.leg.br",
      "ap.leg.br",
      "ba.leg.br",
      "ce.leg.br",
      "df.leg.br",
      "es.leg.br",
      "go.leg.br",
      "ma.leg.br",
      "mg.leg.br",
      "ms.leg.br",
      "mt.leg.br",
      "pa.leg.br",
      "pb.leg.br",
      "pe.leg.br",
      "pi.leg.br",
      "pr.leg.br",
      "rj.leg.br",
      "rn.leg.br",
      "ro.leg.br",
      "rr.leg.br",
      "rs.leg.br",
      "sc.leg.br",
      "se.leg.br",
      "sp.leg.br",
      "to.leg.br",
      "pixolino.com",
      "na4u.ru",
      "iopsys.se",
      "ipifony.net",
      "iservschule.de",
      "mein-iserv.de",
      "schulplattform.de",
      "schulserver.de",
      "test-iserv.de",
      "iserv.dev",
      "iobb.net",
      "mel.cloudlets.com.au",
      "cloud.interhostsolutions.be",
      "users.scale.virtualcloud.com.br",
      "mycloud.by",
      "alp1.ae.flow.ch",
      "appengine.flow.ch",
      "es-1.axarnet.cloud",
      "diadem.cloud",
      "vip.jelastic.cloud",
      "jele.cloud",
      "it1.eur.aruba.jenv-aruba.cloud",
      "it1.jenv-aruba.cloud",
      "keliweb.cloud",
      "cs.keliweb.cloud",
      "oxa.cloud",
      "tn.oxa.cloud",
      "uk.oxa.cloud",
      "primetel.cloud",
      "uk.primetel.cloud",
      "ca.reclaim.cloud",
      "uk.reclaim.cloud",
      "us.reclaim.cloud",
      "ch.trendhosting.cloud",
      "de.trendhosting.cloud",
      "jele.club",
      "amscompute.com",
      "clicketcloud.com",
      "dopaas.com",
      "hidora.com",
      "paas.hosted-by-previder.com",
      "rag-cloud.hosteur.com",
      "rag-cloud-ch.hosteur.com",
      "jcloud.ik-server.com",
      "jcloud-ver-jpc.ik-server.com",
      "demo.jelastic.com",
      "kilatiron.com",
      "paas.massivegrid.com",
      "jed.wafaicloud.com",
      "lon.wafaicloud.com",
      "ryd.wafaicloud.com",
      "j.scaleforce.com.cy",
      "jelastic.dogado.eu",
      "fi.cloudplatform.fi",
      "demo.datacenter.fi",
      "paas.datacenter.fi",
      "jele.host",
      "mircloud.host",
      "paas.beebyte.io",
      "sekd1.beebyteapp.io",
      "jele.io",
      "cloud-fr1.unispace.io",
      "jc.neen.it",
      "cloud.jelastic.open.tim.it",
      "jcloud.kz",
      "upaas.kazteleport.kz",
      "cloudjiffy.net",
      "fra1-de.cloudjiffy.net",
      "west1-us.cloudjiffy.net",
      "jls-sto1.elastx.net",
      "jls-sto2.elastx.net",
      "jls-sto3.elastx.net",
      "faststacks.net",
      "fr-1.paas.massivegrid.net",
      "lon-1.paas.massivegrid.net",
      "lon-2.paas.massivegrid.net",
      "ny-1.paas.massivegrid.net",
      "ny-2.paas.massivegrid.net",
      "sg-1.paas.massivegrid.net",
      "jelastic.saveincloud.net",
      "nordeste-idc.saveincloud.net",
      "j.scaleforce.net",
      "jelastic.tsukaeru.net",
      "sdscloud.pl",
      "unicloud.pl",
      "mircloud.ru",
      "jelastic.regruhosting.ru",
      "enscaled.sg",
      "jele.site",
      "jelastic.team",
      "orangecloud.tn",
      "j.layershift.co.uk",
      "phx.enscaled.us",
      "mircloud.us",
      "myjino.ru",
      "*.hosting.myjino.ru",
      "*.landing.myjino.ru",
      "*.spectrum.myjino.ru",
      "*.vps.myjino.ru",
      "jotelulu.cloud",
      "*.triton.zone",
      "*.cns.joyent.com",
      "js.org",
      "kaas.gg",
      "khplay.nl",
      "ktistory.com",
      "kapsi.fi",
      "keymachine.de",
      "kinghost.net",
      "uni5.net",
      "knightpoint.systems",
      "koobin.events",
      "oya.to",
      "kuleuven.cloud",
      "ezproxy.kuleuven.be",
      "co.krd",
      "edu.krd",
      "krellian.net",
      "webthings.io",
      "git-repos.de",
      "lcube-server.de",
      "svn-repos.de",
      "leadpages.co",
      "lpages.co",
      "lpusercontent.com",
      "lelux.site",
      "co.business",
      "co.education",
      "co.events",
      "co.financial",
      "co.network",
      "co.place",
      "co.technology",
      "app.lmpm.com",
      "linkyard.cloud",
      "linkyard-cloud.ch",
      "members.linode.com",
      "*.nodebalancer.linode.com",
      "*.linodeobjects.com",
      "ip.linodeusercontent.com",
      "we.bs",
      "*.user.localcert.dev",
      "localzone.xyz",
      "loginline.app",
      "loginline.dev",
      "loginline.io",
      "loginline.services",
      "loginline.site",
      "servers.run",
      "lohmus.me",
      "krasnik.pl",
      "leczna.pl",
      "lubartow.pl",
      "lublin.pl",
      "poniatowa.pl",
      "swidnik.pl",
      "glug.org.uk",
      "lug.org.uk",
      "lugs.org.uk",
      "barsy.bg",
      "barsy.co.uk",
      "barsyonline.co.uk",
      "barsycenter.com",
      "barsyonline.com",
      "barsy.club",
      "barsy.de",
      "barsy.eu",
      "barsy.in",
      "barsy.info",
      "barsy.io",
      "barsy.me",
      "barsy.menu",
      "barsy.mobi",
      "barsy.net",
      "barsy.online",
      "barsy.org",
      "barsy.pro",
      "barsy.pub",
      "barsy.ro",
      "barsy.shop",
      "barsy.site",
      "barsy.support",
      "barsy.uk",
      "*.magentosite.cloud",
      "mayfirst.info",
      "mayfirst.org",
      "hb.cldmail.ru",
      "cn.vu",
      "mazeplay.com",
      "mcpe.me",
      "mcdir.me",
      "mcdir.ru",
      "mcpre.ru",
      "vps.mcdir.ru",
      "mediatech.by",
      "mediatech.dev",
      "hra.health",
      "miniserver.com",
      "memset.net",
      "messerli.app",
      "*.cloud.metacentrum.cz",
      "custom.metacentrum.cz",
      "flt.cloud.muni.cz",
      "usr.cloud.muni.cz",
      "meteorapp.com",
      "eu.meteorapp.com",
      "co.pl",
      "*.azurecontainer.io",
      "azurewebsites.net",
      "azure-mobile.net",
      "cloudapp.net",
      "azurestaticapps.net",
      "1.azurestaticapps.net",
      "centralus.azurestaticapps.net",
      "eastasia.azurestaticapps.net",
      "eastus2.azurestaticapps.net",
      "westeurope.azurestaticapps.net",
      "westus2.azurestaticapps.net",
      "csx.cc",
      "mintere.site",
      "forte.id",
      "mozilla-iot.org",
      "bmoattachments.org",
      "net.ru",
      "org.ru",
      "pp.ru",
      "hostedpi.com",
      "customer.mythic-beasts.com",
      "caracal.mythic-beasts.com",
      "fentiger.mythic-beasts.com",
      "lynx.mythic-beasts.com",
      "ocelot.mythic-beasts.com",
      "oncilla.mythic-beasts.com",
      "onza.mythic-beasts.com",
      "sphinx.mythic-beasts.com",
      "vs.mythic-beasts.com",
      "x.mythic-beasts.com",
      "yali.mythic-beasts.com",
      "cust.retrosnub.co.uk",
      "ui.nabu.casa",
      "pony.club",
      "of.fashion",
      "in.london",
      "of.london",
      "from.marketing",
      "with.marketing",
      "for.men",
      "repair.men",
      "and.mom",
      "for.mom",
      "for.one",
      "under.one",
      "for.sale",
      "that.win",
      "from.work",
      "to.work",
      "cloud.nospamproxy.com",
      "netlify.app",
      "4u.com",
      "ngrok.io",
      "nh-serv.co.uk",
      "nfshost.com",
      "*.developer.app",
      "noop.app",
      "*.northflank.app",
      "*.build.run",
      "*.code.run",
      "*.database.run",
      "*.migration.run",
      "noticeable.news",
      "dnsking.ch",
      "mypi.co",
      "n4t.co",
      "001www.com",
      "ddnslive.com",
      "myiphost.com",
      "forumz.info",
      "16-b.it",
      "32-b.it",
      "64-b.it",
      "soundcast.me",
      "tcp4.me",
      "dnsup.net",
      "hicam.net",
      "now-dns.net",
      "ownip.net",
      "vpndns.net",
      "dynserv.org",
      "now-dns.org",
      "x443.pw",
      "now-dns.top",
      "ntdll.top",
      "freeddns.us",
      "crafting.xyz",
      "zapto.xyz",
      "nsupdate.info",
      "nerdpol.ovh",
      "blogsyte.com",
      "brasilia.me",
      "cable-modem.org",
      "ciscofreak.com",
      "collegefan.org",
      "couchpotatofries.org",
      "damnserver.com",
      "ddns.me",
      "ditchyourip.com",
      "dnsfor.me",
      "dnsiskinky.com",
      "dvrcam.info",
      "dynns.com",
      "eating-organic.net",
      "fantasyleague.cc",
      "geekgalaxy.com",
      "golffan.us",
      "health-carereform.com",
      "homesecuritymac.com",
      "homesecuritypc.com",
      "hopto.me",
      "ilovecollege.info",
      "loginto.me",
      "mlbfan.org",
      "mmafan.biz",
      "myactivedirectory.com",
      "mydissent.net",
      "myeffect.net",
      "mymediapc.net",
      "mypsx.net",
      "mysecuritycamera.com",
      "mysecuritycamera.net",
      "mysecuritycamera.org",
      "net-freaks.com",
      "nflfan.org",
      "nhlfan.net",
      "no-ip.ca",
      "no-ip.co.uk",
      "no-ip.net",
      "noip.us",
      "onthewifi.com",
      "pgafan.net",
      "point2this.com",
      "pointto.us",
      "privatizehealthinsurance.net",
      "quicksytes.com",
      "read-books.org",
      "securitytactics.com",
      "serveexchange.com",
      "servehumour.com",
      "servep2p.com",
      "servesarcasm.com",
      "stufftoread.com",
      "ufcfan.org",
      "unusualperson.com",
      "workisboring.com",
      "3utilities.com",
      "bounceme.net",
      "ddns.net",
      "ddnsking.com",
      "gotdns.ch",
      "hopto.org",
      "myftp.biz",
      "myftp.org",
      "myvnc.com",
      "no-ip.biz",
      "no-ip.info",
      "no-ip.org",
      "noip.me",
      "redirectme.net",
      "servebeer.com",
      "serveblog.net",
      "servecounterstrike.com",
      "serveftp.com",
      "servegame.com",
      "servehalflife.com",
      "servehttp.com",
      "serveirc.com",
      "serveminecraft.net",
      "servemp3.com",
      "servepics.com",
      "servequake.com",
      "sytes.net",
      "webhop.me",
      "zapto.org",
      "stage.nodeart.io",
      "pcloud.host",
      "nyc.mn",
      "static.observableusercontent.com",
      "cya.gg",
      "omg.lol",
      "cloudycluster.net",
      "omniwe.site",
      "service.one",
      "nid.io",
      "opensocial.site",
      "opencraft.hosting",
      "orsites.com",
      "operaunite.com",
      "tech.orange",
      "authgear-staging.com",
      "authgearapps.com",
      "skygearapp.com",
      "outsystemscloud.com",
      "*.webpaas.ovh.net",
      "*.hosting.ovh.net",
      "ownprovider.com",
      "own.pm",
      "*.owo.codes",
      "ox.rs",
      "oy.lc",
      "pgfog.com",
      "pagefrontapp.com",
      "pagexl.com",
      "*.paywhirl.com",
      "bar0.net",
      "bar1.net",
      "bar2.net",
      "rdv.to",
      "art.pl",
      "gliwice.pl",
      "krakow.pl",
      "poznan.pl",
      "wroc.pl",
      "zakopane.pl",
      "pantheonsite.io",
      "gotpantheon.com",
      "mypep.link",
      "perspecta.cloud",
      "lk3.ru",
      "on-web.fr",
      "bc.platform.sh",
      "ent.platform.sh",
      "eu.platform.sh",
      "us.platform.sh",
      "*.platformsh.site",
      "*.tst.site",
      "platter-app.com",
      "platter-app.dev",
      "platterp.us",
      "pdns.page",
      "plesk.page",
      "pleskns.com",
      "dyn53.io",
      "onporter.run",
      "co.bn",
      "postman-echo.com",
      "pstmn.io",
      "mock.pstmn.io",
      "httpbin.org",
      "prequalifyme.today",
      "xen.prgmr.com",
      "priv.at",
      "prvcy.page",
      "*.dweb.link",
      "protonet.io",
      "chirurgiens-dentistes-en-france.fr",
      "byen.site",
      "pubtls.org",
      "pythonanywhere.com",
      "eu.pythonanywhere.com",
      "qoto.io",
      "qualifioapp.com",
      "qbuser.com",
      "cloudsite.builders",
      "instances.spawn.cc",
      "instantcloud.cn",
      "ras.ru",
      "qa2.com",
      "qcx.io",
      "*.sys.qcx.io",
      "dev-myqnapcloud.com",
      "alpha-myqnapcloud.com",
      "myqnapcloud.com",
      "*.quipelements.com",
      "vapor.cloud",
      "vaporcloud.io",
      "rackmaze.com",
      "rackmaze.net",
      "g.vbrplsbx.io",
      "*.on-k3s.io",
      "*.on-rancher.cloud",
      "*.on-rio.io",
      "readthedocs.io",
      "rhcloud.com",
      "app.render.com",
      "onrender.com",
      "repl.co",
      "id.repl.co",
      "repl.run",
      "resindevice.io",
      "devices.resinstaging.io",
      "hzc.io",
      "wellbeingzone.eu",
      "wellbeingzone.co.uk",
      "adimo.co.uk",
      "itcouldbewor.se",
      "git-pages.rit.edu",
      "rocky.page",
      "биз.рус",
      "ком.рус",
      "крым.рус",
      "мир.рус",
      "мск.рус",
      "орг.рус",
      "самара.рус",
      "сочи.рус",
      "спб.рус",
      "я.рус",
      "*.builder.code.com",
      "*.dev-builder.code.com",
      "*.stg-builder.code.com",
      "sandcats.io",
      "logoip.de",
      "logoip.com",
      "fr-par-1.baremetal.scw.cloud",
      "fr-par-2.baremetal.scw.cloud",
      "nl-ams-1.baremetal.scw.cloud",
      "fnc.fr-par.scw.cloud",
      "functions.fnc.fr-par.scw.cloud",
      "k8s.fr-par.scw.cloud",
      "nodes.k8s.fr-par.scw.cloud",
      "s3.fr-par.scw.cloud",
      "s3-website.fr-par.scw.cloud",
      "whm.fr-par.scw.cloud",
      "priv.instances.scw.cloud",
      "pub.instances.scw.cloud",
      "k8s.scw.cloud",
      "k8s.nl-ams.scw.cloud",
      "nodes.k8s.nl-ams.scw.cloud",
      "s3.nl-ams.scw.cloud",
      "s3-website.nl-ams.scw.cloud",
      "whm.nl-ams.scw.cloud",
      "k8s.pl-waw.scw.cloud",
      "nodes.k8s.pl-waw.scw.cloud",
      "s3.pl-waw.scw.cloud",
      "s3-website.pl-waw.scw.cloud",
      "scalebook.scw.cloud",
      "smartlabeling.scw.cloud",
      "dedibox.fr",
      "schokokeks.net",
      "gov.scot",
      "service.gov.scot",
      "scrysec.com",
      "firewall-gateway.com",
      "firewall-gateway.de",
      "my-gateway.de",
      "my-router.de",
      "spdns.de",
      "spdns.eu",
      "firewall-gateway.net",
      "my-firewall.org",
      "myfirewall.org",
      "spdns.org",
      "seidat.net",
      "sellfy.store",
      "senseering.net",
      "minisite.ms",
      "magnet.page",
      "biz.ua",
      "co.ua",
      "pp.ua",
      "shiftcrypto.dev",
      "shiftcrypto.io",
      "shiftedit.io",
      "myshopblocks.com",
      "myshopify.com",
      "shopitsite.com",
      "shopware.store",
      "mo-siemens.io",
      "1kapp.com",
      "appchizi.com",
      "applinzi.com",
      "sinaapp.com",
      "vipsinaapp.com",
      "siteleaf.net",
      "bounty-full.com",
      "alpha.bounty-full.com",
      "beta.bounty-full.com",
      "small-web.org",
      "vp4.me",
      "try-snowplow.com",
      "srht.site",
      "stackhero-network.com",
      "musician.io",
      "novecore.site",
      "static.land",
      "dev.static.land",
      "sites.static.land",
      "storebase.store",
      "vps-host.net",
      "atl.jelastic.vps-host.net",
      "njs.jelastic.vps-host.net",
      "ric.jelastic.vps-host.net",
      "playstation-cloud.com",
      "apps.lair.io",
      "*.stolos.io",
      "spacekit.io",
      "customer.speedpartner.de",
      "myspreadshop.at",
      "myspreadshop.com.au",
      "myspreadshop.be",
      "myspreadshop.ca",
      "myspreadshop.ch",
      "myspreadshop.com",
      "myspreadshop.de",
      "myspreadshop.dk",
      "myspreadshop.es",
      "myspreadshop.fi",
      "myspreadshop.fr",
      "myspreadshop.ie",
      "myspreadshop.it",
      "myspreadshop.net",
      "myspreadshop.nl",
      "myspreadshop.no",
      "myspreadshop.pl",
      "myspreadshop.se",
      "myspreadshop.co.uk",
      "api.stdlib.com",
      "storj.farm",
      "utwente.io",
      "soc.srcf.net",
      "user.srcf.net",
      "temp-dns.com",
      "supabase.co",
      "supabase.in",
      "supabase.net",
      "su.paba.se",
      "*.s5y.io",
      "*.sensiosite.cloud",
      "syncloud.it",
      "dscloud.biz",
      "direct.quickconnect.cn",
      "dsmynas.com",
      "familyds.com",
      "diskstation.me",
      "dscloud.me",
      "i234.me",
      "myds.me",
      "synology.me",
      "dscloud.mobi",
      "dsmynas.net",
      "familyds.net",
      "dsmynas.org",
      "familyds.org",
      "vpnplus.to",
      "direct.quickconnect.to",
      "tabitorder.co.il",
      "taifun-dns.de",
      "beta.tailscale.net",
      "ts.net",
      "gda.pl",
      "gdansk.pl",
      "gdynia.pl",
      "med.pl",
      "sopot.pl",
      "site.tb-hosting.com",
      "edugit.io",
      "s3.teckids.org",
      "telebit.app",
      "telebit.io",
      "*.telebit.xyz",
      "gwiddle.co.uk",
      "*.firenet.ch",
      "*.svc.firenet.ch",
      "reservd.com",
      "thingdustdata.com",
      "cust.dev.thingdust.io",
      "cust.disrec.thingdust.io",
      "cust.prod.thingdust.io",
      "cust.testing.thingdust.io",
      "reservd.dev.thingdust.io",
      "reservd.disrec.thingdust.io",
      "reservd.testing.thingdust.io",
      "tickets.io",
      "arvo.network",
      "azimuth.network",
      "tlon.network",
      "torproject.net",
      "pages.torproject.net",
      "bloxcms.com",
      "townnews-staging.com",
      "tbits.me",
      "12hp.at",
      "2ix.at",
      "4lima.at",
      "lima-city.at",
      "12hp.ch",
      "2ix.ch",
      "4lima.ch",
      "lima-city.ch",
      "trafficplex.cloud",
      "de.cool",
      "12hp.de",
      "2ix.de",
      "4lima.de",
      "lima-city.de",
      "1337.pictures",
      "clan.rip",
      "lima-city.rocks",
      "webspace.rocks",
      "lima.zone",
      "*.transurl.be",
      "*.transurl.eu",
      "*.transurl.nl",
      "site.transip.me",
      "tuxfamily.org",
      "dd-dns.de",
      "diskstation.eu",
      "diskstation.org",
      "dray-dns.de",
      "draydns.de",
      "dyn-vpn.de",
      "dynvpn.de",
      "mein-vigor.de",
      "my-vigor.de",
      "my-wan.de",
      "syno-ds.de",
      "synology-diskstation.de",
      "synology-ds.de",
      "typedream.app",
      "pro.typeform.com",
      "uber.space",
      "*.uberspace.de",
      "hk.com",
      "hk.org",
      "ltd.hk",
      "inc.hk",
      "name.pm",
      "sch.tf",
      "biz.wf",
      "sch.wf",
      "org.yt",
      "virtualuser.de",
      "virtual-user.de",
      "upli.io",
      "urown.cloud",
      "dnsupdate.info",
      "lib.de.us",
      "2038.io",
      "vercel.app",
      "vercel.dev",
      "now.sh",
      "router.management",
      "v-info.info",
      "voorloper.cloud",
      "neko.am",
      "nyaa.am",
      "be.ax",
      "cat.ax",
      "es.ax",
      "eu.ax",
      "gg.ax",
      "mc.ax",
      "us.ax",
      "xy.ax",
      "nl.ci",
      "xx.gl",
      "app.gp",
      "blog.gt",
      "de.gt",
      "to.gt",
      "be.gy",
      "cc.hn",
      "blog.kg",
      "io.kg",
      "jp.kg",
      "tv.kg",
      "uk.kg",
      "us.kg",
      "de.ls",
      "at.md",
      "de.md",
      "jp.md",
      "to.md",
      "indie.porn",
      "vxl.sh",
      "ch.tc",
      "me.tc",
      "we.tc",
      "nyan.to",
      "at.vg",
      "blog.vu",
      "dev.vu",
      "me.vu",
      "v.ua",
      "*.vultrobjects.com",
      "wafflecell.com",
      "*.webhare.dev",
      "reserve-online.net",
      "reserve-online.com",
      "bookonline.app",
      "hotelwithflight.com",
      "wedeploy.io",
      "wedeploy.me",
      "wedeploy.sh",
      "remotewd.com",
      "pages.wiardweb.com",
      "wmflabs.org",
      "toolforge.org",
      "wmcloud.org",
      "panel.gg",
      "daemon.panel.gg",
      "messwithdns.com",
      "woltlab-demo.com",
      "myforum.community",
      "community-pro.de",
      "diskussionsbereich.de",
      "community-pro.net",
      "meinforum.net",
      "affinitylottery.org.uk",
      "raffleentry.org.uk",
      "weeklylottery.org.uk",
      "wpenginepowered.com",
      "js.wpenginepowered.com",
      "wixsite.com",
      "editorx.io",
      "half.host",
      "xnbay.com",
      "u2.xnbay.com",
      "u2-local.xnbay.com",
      "cistron.nl",
      "demon.nl",
      "xs4all.space",
      "yandexcloud.net",
      "storage.yandexcloud.net",
      "website.yandexcloud.net",
      "official.academy",
      "yolasite.com",
      "ybo.faith",
      "yombo.me",
      "homelink.one",
      "ybo.party",
      "ybo.review",
      "ybo.science",
      "ybo.trade",
      "ynh.fr",
      "nohost.me",
      "noho.st",
      "za.net",
      "za.org",
      "bss.design",
      "basicserver.io",
      "virtualserver.io",
      "enterprisecloud.nu"
    ];
  }
}), qk = A1({
  "node_modules/psl/index.js"(t) {
    var e = Q2(), a = {};
    a.rules = Nk().map(function(o) {
      return {
        rule: o,
        suffix: o.replace(/^(\*\.|\!)/, ""),
        punySuffix: -1,
        wildcard: o.charAt(0) === "*",
        exception: o.charAt(0) === "!"
      };
    }), a.endsWith = function(o, n) {
      return o.indexOf(n, o.length - n.length) !== -1;
    }, a.findRule = function(o) {
      var n = e.toASCII(o);
      return a.rules.reduce(function(r, s) {
        return s.punySuffix === -1 && (s.punySuffix = e.toASCII(s.suffix)), !a.endsWith(n, "." + s.punySuffix) && n !== s.punySuffix ? r : s;
      }, null);
    }, t.errorCodes = {
      DOMAIN_TOO_SHORT: "Domain name too short.",
      DOMAIN_TOO_LONG: "Domain name too long. It should be no more than 255 chars.",
      LABEL_STARTS_WITH_DASH: "Domain name label can not start with a dash.",
      LABEL_ENDS_WITH_DASH: "Domain name label can not end with a dash.",
      LABEL_TOO_LONG: "Domain name label should be at most 63 chars long.",
      LABEL_TOO_SHORT: "Domain name label should be at least 1 character long.",
      LABEL_INVALID_CHARS: "Domain name label can only contain alphanumeric characters or dashes."
    }, a.validate = function(o) {
      var n = e.toASCII(o);
      if (n.length < 1)
        return "DOMAIN_TOO_SHORT";
      if (n.length > 255)
        return "DOMAIN_TOO_LONG";
      for (var r = n.split("."), s, i = 0; i < r.length; ++i) {
        if (s = r[i], !s.length)
          return "LABEL_TOO_SHORT";
        if (s.length > 63)
          return "LABEL_TOO_LONG";
        if (s.charAt(0) === "-")
          return "LABEL_STARTS_WITH_DASH";
        if (s.charAt(s.length - 1) === "-")
          return "LABEL_ENDS_WITH_DASH";
        if (!/^[a-z0-9\-]+$/.test(s))
          return "LABEL_INVALID_CHARS";
      }
    }, t.parse = function(o) {
      if (typeof o != "string")
        throw new TypeError("Domain name must be a string.");
      var n = o.slice(0).toLowerCase();
      n.charAt(n.length - 1) === "." && (n = n.slice(0, n.length - 1));
      var r = a.validate(n);
      if (r)
        return {
          input: o,
          error: {
            message: t.errorCodes[r],
            code: r
          }
        };
      var s = {
        input: o,
        tld: null,
        sld: null,
        domain: null,
        subdomain: null,
        listed: !1
      }, i = n.split(".");
      if (i[i.length - 1] === "local")
        return s;
      var l = function() {
        return /xn--/.test(n) && (s.domain && (s.domain = e.toASCII(s.domain)), s.subdomain && (s.subdomain = e.toASCII(s.subdomain))), s;
      }, f = a.findRule(n);
      if (!f)
        return i.length < 2 ? s : (s.tld = i.pop(), s.sld = i.pop(), s.domain = [s.sld, s.tld].join("."), i.length && (s.subdomain = i.pop()), l());
      s.listed = !0;
      var u = f.suffix.split("."), d = i.slice(0, i.length - u.length);
      return f.exception && d.push(u.shift()), s.tld = u.join("."), !d.length || (f.wildcard && (u.unshift(d.pop()), s.tld = u.join(".")), !d.length) || (s.sld = d.pop(), s.domain = [s.sld, s.tld].join("."), d.length && (s.subdomain = d.join("."))), l();
    }, t.get = function(o) {
      return o && t.parse(o).domain || null;
    }, t.isValid = function(o) {
      var n = t.parse(o);
      return !!(n.domain && n.listed);
    };
  }
}), J2 = A1({
  "node_modules/tough-cookie/lib/pubsuffix-psl.js"(t) {
    var e = qk(), a = [
      "local",
      "example",
      "invalid",
      "localhost",
      "test"
    ], o = ["localhost", "invalid"];
    function n(r, s = {}) {
      const i = r.split("."), l = i[i.length - 1], f = !!s.allowSpecialUseDomain, u = !!s.ignoreError;
      if (f && a.includes(l)) {
        if (i.length > 1)
          return `${i[i.length - 2]}.${l}`;
        if (o.includes(l))
          return `${l}`;
      }
      if (!u && a.includes(l))
        throw new Error(
          `Cookie has domain set to the public suffix "${l}" which is a special use domain. To allow this, configure your CookieJar with {allowSpecialUseDomain:true, rejectPublicSuffixes: false}.`
        );
      return e.get(r);
    }
    t.getPublicSuffix = n;
  }
}), el = A1({
  "node_modules/tough-cookie/lib/store.js"(t) {
    var e = class {
      constructor() {
        this.synchronous = !1;
      }
      findCookie(a, o, n, r) {
        throw new Error("findCookie is not implemented");
      }
      findCookies(a, o, n, r) {
        throw new Error("findCookies is not implemented");
      }
      putCookie(a, o) {
        throw new Error("putCookie is not implemented");
      }
      updateCookie(a, o, n) {
        throw new Error("updateCookie is not implemented");
      }
      removeCookie(a, o, n, r) {
        throw new Error("removeCookie is not implemented");
      }
      removeCookies(a, o, n) {
        throw new Error("removeCookies is not implemented");
      }
      removeAllCookies(a) {
        throw new Error("removeAllCookies is not implemented");
      }
      getAllCookies(a) {
        throw new Error(
          "getAllCookies is not implemented (therefore jar cannot be serialized)"
        );
      }
    };
    t.Store = e;
  }
}), tl = A1({
  "node_modules/universalify/index.js"(t) {
    t.fromCallback = function(e) {
      return Object.defineProperty(function() {
        if (typeof arguments[arguments.length - 1] == "function") e.apply(this, arguments);
        else
          return new Promise((a, o) => {
            arguments[arguments.length] = (n, r) => {
              if (n) return o(n);
              a(r);
            }, arguments.length++, e.apply(this, arguments);
          });
      }, "name", { value: e.name });
    }, t.fromPromise = function(e) {
      return Object.defineProperty(function() {
        const a = arguments[arguments.length - 1];
        if (typeof a != "function") return e.apply(this, arguments);
        delete arguments[arguments.length - 1], arguments.length--, e.apply(this, arguments).then((o) => a(null, o), a);
      }, "name", { value: e.name });
    };
  }
}), al = A1({
  "node_modules/tough-cookie/lib/permuteDomain.js"(t) {
    var e = J2();
    function a(o, n) {
      const r = e.getPublicSuffix(o, {
        allowSpecialUseDomain: n
      });
      if (!r)
        return null;
      if (r == o)
        return [o];
      o.slice(-1) == "." && (o = o.slice(0, -1));
      const i = o.slice(0, -(r.length + 1)).split(".").reverse();
      let l = r;
      const f = [l];
      for (; i.length; )
        l = `${i.shift()}.${l}`, f.push(l);
      return f;
    }
    t.permuteDomain = a;
  }
}), ol = A1({
  "node_modules/tough-cookie/lib/pathMatch.js"(t) {
    function e(a, o) {
      return o === a || a.indexOf(o) === 0 && (o.substr(-1) === "/" || a.substr(o.length, 1) === "/");
    }
    t.pathMatch = e;
  }
}), nl = A1({
  "node_modules/tough-cookie/lib/utilHelper.js"(t) {
    function e() {
      try {
        return Ok("util");
      } catch {
        return null;
      }
    }
    function a() {
      return Symbol.for("nodejs.util.inspect.custom");
    }
    function o(n) {
      const s = (n.requireUtil || e)();
      return s ? s.inspect.custom : null;
    }
    t.getUtilInspect = function(r, s = {}) {
      const l = (s.requireUtil || e)();
      return function(u, d, k) {
        return l ? l.inspect(u, d, k) : r(u);
      };
    }, t.getCustomInspectSymbol = function(r = {}) {
      return (r.lookupCustomInspectSymbol || a)() || o(r);
    };
  }
}), Uk = A1({
  "node_modules/tough-cookie/lib/memstore.js"(t) {
    var { fromCallback: e } = tl(), a = el().Store, o = al().permuteDomain, n = ol().pathMatch, { getCustomInspectSymbol: r, getUtilInspect: s } = nl(), i = class extends a {
      constructor() {
        super(), this.synchronous = !0, this.idx = /* @__PURE__ */ Object.create(null);
        const d = r();
        d && (this[d] = this.inspect);
      }
      inspect() {
        return `{ idx: ${{ inspect: s(l) }.inspect(this.idx, !1, 2)} }`;
      }
      findCookie(d, k, y, b) {
        return !this.idx[d] || !this.idx[d][k] ? b(null, void 0) : b(null, this.idx[d][k][y] || null);
      }
      findCookies(d, k, y, b) {
        const M = [];
        if (typeof y == "function" && (b = y, y = !0), !d)
          return b(null, []);
        let c;
        k ? c = function(H) {
          Object.keys(H).forEach((w) => {
            if (n(k, w)) {
              const _ = H[w];
              for (const L in _)
                M.push(_[L]);
            }
          });
        } : c = function(H) {
          for (const w in H) {
            const _ = H[w];
            for (const L in _)
              M.push(_[L]);
          }
        };
        const p = o(d, y) || [d], h = this.idx;
        p.forEach((v) => {
          const H = h[v];
          H && c(H);
        }), b(null, M);
      }
      putCookie(d, k) {
        this.idx[d.domain] || (this.idx[d.domain] = /* @__PURE__ */ Object.create(null)), this.idx[d.domain][d.path] || (this.idx[d.domain][d.path] = /* @__PURE__ */ Object.create(null)), this.idx[d.domain][d.path][d.key] = d, k(null);
      }
      updateCookie(d, k, y) {
        this.putCookie(k, y);
      }
      removeCookie(d, k, y, b) {
        this.idx[d] && this.idx[d][k] && this.idx[d][k][y] && delete this.idx[d][k][y], b(null);
      }
      removeCookies(d, k, y) {
        return this.idx[d] && (k ? delete this.idx[d][k] : delete this.idx[d]), y(null);
      }
      removeAllCookies(d) {
        return this.idx = /* @__PURE__ */ Object.create(null), d(null);
      }
      getAllCookies(d) {
        const k = [], y = this.idx;
        Object.keys(y).forEach((M) => {
          Object.keys(y[M]).forEach((p) => {
            Object.keys(y[M][p]).forEach((v) => {
              v !== null && k.push(y[M][p][v]);
            });
          });
        }), k.sort((M, c) => (M.creationIndex || 0) - (c.creationIndex || 0)), d(null, k);
      }
    };
    [
      "findCookie",
      "findCookies",
      "putCookie",
      "updateCookie",
      "removeCookie",
      "removeCookies",
      "removeAllCookies",
      "getAllCookies"
    ].forEach((d) => {
      i.prototype[d] = e(
        i.prototype[d]
      );
    }), t.MemoryCookieStore = i;
    function l(d) {
      const k = Object.keys(d);
      if (k.length === 0)
        return "[Object: null prototype] {}";
      let y = `[Object: null prototype] {
`;
      return Object.keys(d).forEach((b, M) => {
        y += f(b, d[b]), M < k.length - 1 && (y += ","), y += `
`;
      }), y += "}", y;
    }
    function f(d, k) {
      let b = `  '${d}': [Object: null prototype] {
`;
      return Object.keys(k).forEach((M, c, p) => {
        b += u(M, k[M]), c < p.length - 1 && (b += ","), b += `
`;
      }), b += "  }", b;
    }
    function u(d, k) {
      const y = "    ";
      let b = `${y}'${d}': [Object: null prototype] {
`;
      return Object.keys(k).forEach((M, c, p) => {
        const h = k[M];
        b += `      ${M}: ${h.inspect()}`, c < p.length - 1 && (b += ","), b += `
`;
      }), b += `${y}}`, b;
    }
    t.inspectFallback = l;
  }
}), Yk = A1({
  "node_modules/tough-cookie/lib/validators.js"(t) {
    var e = Object.prototype.toString;
    function a(y) {
      return typeof y == "function";
    }
    function o(y) {
      return s(y) && y !== "";
    }
    function n(y) {
      return l(y, Date) && u(y.getTime());
    }
    function r(y) {
      return y === "" || y instanceof String && y.toString() === "";
    }
    function s(y) {
      return typeof y == "string" || y instanceof String;
    }
    function i(y) {
      return e.call(y) === "[object Object]";
    }
    function l(y, b) {
      try {
        return y instanceof b;
      } catch {
        return !1;
      }
    }
    function f(y) {
      return o(y) || i(y) && "hostname" in y && "pathname" in y && "protocol" in y || l(y, URL);
    }
    function u(y) {
      return typeof y == "number" && y % 1 === 0;
    }
    function d(y, b, M) {
      if (a(b) || (M = b, b = null), i(M) || (M = { Error: "Failed Check" }), !y)
        if (b)
          b(new k(M));
        else
          throw new k(M);
    }
    var k = class extends Error {
      constructor(...y) {
        super(...y);
      }
    };
    t.ParameterError = k, t.isFunction = a, t.isNonEmptyString = o, t.isDate = n, t.isEmptyString = r, t.isString = s, t.isObject = i, t.isUrlStringOrObject = f, t.validate = d;
  }
}), Wk = A1({
  "node_modules/tough-cookie/lib/version.js"(t, e) {
    e.exports = "4.1.4";
  }
}), Kk = A1({
  "node_modules/tough-cookie/lib/cookie.js"(t) {
    var e = Q2(), a = Rk(), o = J2(), n = el().Store, r = Uk().MemoryCookieStore, s = ol().pathMatch, i = Yk(), l = Wk(), { fromCallback: f } = tl(), { getCustomInspectSymbol: u } = nl(), d = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/, k = /[\x00-\x1F]/, y = [`
`, "\r", "\0"], b = /[\x20-\x3A\x3C-\x7E]+/, M = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/, c = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11
    }, p = 2147483647e3, h = 0, v = 'Invalid sameSiteContext option for getCookies(); expected one of "strict", "lax", or "none"';
    function H(P) {
      i.validate(i.isNonEmptyString(P), P);
      const V = String(P).toLowerCase();
      return V === "none" || V === "lax" || V === "strict" ? V : null;
    }
    var w = Object.freeze({
      SILENT: "silent",
      STRICT: "strict",
      DISABLED: "unsafe-disabled"
    }), _ = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-f\d]{1,4}:){7}(?:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,2}|:)|(?:[a-f\d]{1,4}:){4}(?:(?::[a-f\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,3}|:)|(?:[a-f\d]{1,4}:){3}(?:(?::[a-f\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,4}|:)|(?:[a-f\d]{1,4}:){2}(?:(?::[a-f\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,5}|:)|(?:[a-f\d]{1,4}:){1}(?:(?::[a-f\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,6}|:)|(?::(?:(?::[a-f\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,7}|:)))$)/, L = `
\\[?(?:
(?:[a-fA-F\\d]{1,4}:){7}(?:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,2}|:)|
(?:[a-fA-F\\d]{1,4}:){4}(?:(?::[a-fA-F\\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,3}|:)|
(?:[a-fA-F\\d]{1,4}:){3}(?:(?::[a-fA-F\\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){2}(?:(?::[a-fA-F\\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,5}|:)|
(?:[a-fA-F\\d]{1,4}:){1}(?:(?::[a-fA-F\\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,6}|:)|
(?::(?:(?::[a-fA-F\\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,7}|:))
)(?:%[0-9a-zA-Z]{1,})?\\]?
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), I = new RegExp(`^${L}$`);
    function F(P, V, E, S) {
      let R = 0;
      for (; R < P.length; ) {
        const ie = P.charCodeAt(R);
        if (ie <= 47 || ie >= 58)
          break;
        R++;
      }
      return R < V || R > E || !S && R != P.length ? null : parseInt(P.substr(0, R), 10);
    }
    function B(P) {
      const V = P.split(":"), E = [0, 0, 0];
      if (V.length !== 3)
        return null;
      for (let S = 0; S < 3; S++) {
        const R = S == 2, ie = F(V[S], 1, 2, R);
        if (ie === null)
          return null;
        E[S] = ie;
      }
      return E;
    }
    function K(P) {
      P = String(P).substr(0, 3).toLowerCase();
      const V = c[P];
      return V >= 0 ? V : null;
    }
    function ee(P) {
      if (!P)
        return;
      const V = P.split(M);
      if (!V)
        return;
      let E = null, S = null, R = null, ie = null, de = null, Ce = null;
      for (let He = 0; He < V.length; He++) {
        const X = V[He].trim();
        if (!X.length)
          continue;
        let ce;
        if (R === null && (ce = B(X), ce)) {
          E = ce[0], S = ce[1], R = ce[2];
          continue;
        }
        if (ie === null && (ce = F(X, 1, 2, !0), ce !== null)) {
          ie = ce;
          continue;
        }
        if (de === null && (ce = K(X), ce !== null)) {
          de = ce;
          continue;
        }
        Ce === null && (ce = F(X, 2, 4, !0), ce !== null && (Ce = ce, Ce >= 70 && Ce <= 99 ? Ce += 1900 : Ce >= 0 && Ce <= 69 && (Ce += 2e3)));
      }
      if (!(ie === null || de === null || Ce === null || R === null || ie < 1 || ie > 31 || Ce < 1601 || E > 23 || S > 59 || R > 59))
        return new Date(Date.UTC(Ce, de, ie, E, S, R));
    }
    function ve(P) {
      return i.validate(i.isDate(P), P), P.toUTCString();
    }
    function q(P) {
      return P == null ? null : (P = P.trim().replace(/^\./, ""), I.test(P) && (P = P.replace("[", "").replace("]", "")), e && /[^\u0001-\u007f]/.test(P) && (P = e.toASCII(P)), P.toLowerCase());
    }
    function O(P, V, E) {
      if (P == null || V == null)
        return null;
      if (E !== !1 && (P = q(P), V = q(V)), P == V)
        return !0;
      const S = P.lastIndexOf(V);
      return !(S <= 0 || P.length !== V.length + S || P.substr(S - 1, 1) !== "." || _.test(P));
    }
    function Y(P) {
      if (!P || P.substr(0, 1) !== "/")
        return "/";
      if (P === "/")
        return P;
      const V = P.lastIndexOf("/");
      return V === 0 ? "/" : P.slice(0, V);
    }
    function U(P) {
      if (i.isEmptyString(P)) return P;
      for (let V = 0; V < y.length; V++) {
        const E = P.indexOf(y[V]);
        E !== -1 && (P = P.substr(0, E));
      }
      return P;
    }
    function ne(P, V) {
      P = U(P), i.validate(i.isString(P), P);
      let E = P.indexOf("=");
      if (V)
        E === 0 && (P = P.substr(1), E = P.indexOf("="));
      else if (E <= 0)
        return;
      let S, R;
      if (E <= 0 ? (S = "", R = P.trim()) : (S = P.substr(0, E).trim(), R = P.substr(E + 1).trim()), k.test(S) || k.test(R))
        return;
      const ie = new W();
      return ie.key = S, ie.value = R, ie;
    }
    function te(P, V) {
      if ((!V || typeof V != "object") && (V = {}), i.isEmptyString(P) || !i.isString(P))
        return null;
      P = P.trim();
      const E = P.indexOf(";"), S = E === -1 ? P : P.substr(0, E), R = ne(S, !!V.loose);
      if (!R)
        return;
      if (E === -1)
        return R;
      const ie = P.slice(E + 1).trim();
      if (ie.length === 0)
        return R;
      const de = ie.split(";");
      for (; de.length; ) {
        const Ce = de.shift().trim();
        if (Ce.length === 0)
          continue;
        const He = Ce.indexOf("=");
        let X, ce;
        switch (He === -1 ? (X = Ce, ce = null) : (X = Ce.substr(0, He), ce = Ce.substr(He + 1)), X = X.trim().toLowerCase(), ce && (ce = ce.trim()), X) {
          case "expires":
            if (ce) {
              const Ze = ee(ce);
              Ze && (R.expires = Ze);
            }
            break;
          case "max-age":
            if (ce && /^-?[0-9]+$/.test(ce)) {
              const Ze = parseInt(ce, 10);
              R.setMaxAge(Ze);
            }
            break;
          case "domain":
            if (ce) {
              const Ze = ce.trim().replace(/^\./, "");
              Ze && (R.domain = Ze.toLowerCase());
            }
            break;
          case "path":
            R.path = ce && ce[0] === "/" ? ce : null;
            break;
          case "secure":
            R.secure = !0;
            break;
          case "httponly":
            R.httpOnly = !0;
            break;
          case "samesite":
            switch (ce ? ce.toLowerCase() : "") {
              case "strict":
                R.sameSite = "strict";
                break;
              case "lax":
                R.sameSite = "lax";
                break;
              case "none":
                R.sameSite = "none";
                break;
              default:
                R.sameSite = void 0;
                break;
            }
            break;
          default:
            R.extensions = R.extensions || [], R.extensions.push(Ce);
            break;
        }
      }
      return R;
    }
    function G(P) {
      return i.validate(i.isObject(P), P), !P.key.startsWith("__Secure-") || P.secure;
    }
    function T(P) {
      return i.validate(i.isObject(P)), !P.key.startsWith("__Host-") || P.secure && P.hostOnly && P.path != null && P.path === "/";
    }
    function Z(P) {
      let V;
      try {
        V = JSON.parse(P);
      } catch (E) {
        return E;
      }
      return V;
    }
    function D(P) {
      if (!P || i.isEmptyString(P))
        return null;
      let V;
      if (typeof P == "string") {
        if (V = Z(P), V instanceof Error)
          return null;
      } else
        V = P;
      const E = new W();
      for (let S = 0; S < W.serializableProperties.length; S++) {
        const R = W.serializableProperties[S];
        V[R] === void 0 || V[R] === $[R] || (R === "expires" || R === "creation" || R === "lastAccessed" ? V[R] === null ? E[R] = null : E[R] = V[R] == "Infinity" ? "Infinity" : new Date(V[R]) : E[R] = V[R]);
      }
      return E;
    }
    function x(P, V) {
      i.validate(i.isObject(P), P), i.validate(i.isObject(V), V);
      let E = 0;
      const S = P.path ? P.path.length : 0;
      if (E = (V.path ? V.path.length : 0) - S, E !== 0)
        return E;
      const ie = P.creation ? P.creation.getTime() : p, de = V.creation ? V.creation.getTime() : p;
      return E = ie - de, E !== 0 || (E = P.creationIndex - V.creationIndex), E;
    }
    function A(P) {
      if (i.validate(i.isString(P)), P === "/")
        return ["/"];
      const V = [P];
      for (; P.length > 1; ) {
        const E = P.lastIndexOf("/");
        if (E === 0)
          break;
        P = P.substr(0, E), V.push(P);
      }
      return V.push("/"), V;
    }
    function N(P) {
      if (P instanceof Object)
        return P;
      try {
        P = decodeURI(P);
      } catch {
      }
      return a(P);
    }
    var $ = {
      // the order in which the RFC has them:
      key: "",
      value: "",
      expires: "Infinity",
      maxAge: null,
      domain: null,
      path: null,
      secure: !1,
      httpOnly: !1,
      extensions: null,
      // set by the CookieJar:
      hostOnly: null,
      pathIsDefault: null,
      creation: null,
      lastAccessed: null,
      sameSite: void 0
    }, W = class on {
      constructor(V = {}) {
        const E = u();
        E && (this[E] = this.inspect), Object.assign(this, $, V), this.creation = this.creation || /* @__PURE__ */ new Date(), Object.defineProperty(this, "creationIndex", {
          configurable: !1,
          enumerable: !1,
          // important for assert.deepEqual checks
          writable: !0,
          value: ++on.cookiesCreated
        });
      }
      inspect() {
        const V = Date.now(), E = this.hostOnly != null ? this.hostOnly : "?", S = this.creation ? `${V - this.creation.getTime()}ms` : "?", R = this.lastAccessed ? `${V - this.lastAccessed.getTime()}ms` : "?";
        return `Cookie="${this.toString()}; hostOnly=${E}; aAge=${R}; cAge=${S}"`;
      }
      toJSON() {
        const V = {};
        for (const E of on.serializableProperties)
          this[E] !== $[E] && (E === "expires" || E === "creation" || E === "lastAccessed" ? this[E] === null ? V[E] = null : V[E] = this[E] == "Infinity" ? "Infinity" : this[E].toISOString() : E === "maxAge" ? this[E] !== null && (V[E] = this[E] == 1 / 0 || this[E] == -1 / 0 ? this[E].toString() : this[E]) : this[E] !== $[E] && (V[E] = this[E]));
        return V;
      }
      clone() {
        return D(this.toJSON());
      }
      validate() {
        if (!d.test(this.value) || this.expires != 1 / 0 && !(this.expires instanceof Date) && !ee(this.expires) || this.maxAge != null && this.maxAge <= 0 || this.path != null && !b.test(this.path))
          return !1;
        const V = this.cdomain();
        return !(V && (V.match(/\.$/) || o.getPublicSuffix(V) == null));
      }
      setExpires(V) {
        V instanceof Date ? this.expires = V : this.expires = ee(V) || "Infinity";
      }
      setMaxAge(V) {
        V === 1 / 0 || V === -1 / 0 ? this.maxAge = V.toString() : this.maxAge = V;
      }
      cookieString() {
        let V = this.value;
        return V == null && (V = ""), this.key === "" ? V : `${this.key}=${V}`;
      }
      // gives Set-Cookie header format
      toString() {
        let V = this.cookieString();
        if (this.expires != 1 / 0 && (this.expires instanceof Date ? V += `; Expires=${ve(this.expires)}` : V += `; Expires=${this.expires}`), this.maxAge != null && this.maxAge != 1 / 0 && (V += `; Max-Age=${this.maxAge}`), this.domain && !this.hostOnly && (V += `; Domain=${this.domain}`), this.path && (V += `; Path=${this.path}`), this.secure && (V += "; Secure"), this.httpOnly && (V += "; HttpOnly"), this.sameSite && this.sameSite !== "none") {
          const E = on.sameSiteCanonical[this.sameSite.toLowerCase()];
          V += `; SameSite=${E || this.sameSite}`;
        }
        return this.extensions && this.extensions.forEach((E) => {
          V += `; ${E}`;
        }), V;
      }
      // TTL() partially replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
      // elsewhere)
      // S5.3 says to give the "latest representable date" for which we use Infinity
      // For "expired" we use 0
      TTL(V) {
        if (this.maxAge != null)
          return this.maxAge <= 0 ? 0 : this.maxAge * 1e3;
        let E = this.expires;
        return E != 1 / 0 ? (E instanceof Date || (E = ee(E) || 1 / 0), E == 1 / 0 ? 1 / 0 : E.getTime() - (V || Date.now())) : 1 / 0;
      }
      // expiryTime() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
      // elsewhere)
      expiryTime(V) {
        if (this.maxAge != null) {
          const E = V || this.creation || /* @__PURE__ */ new Date(), S = this.maxAge <= 0 ? -1 / 0 : this.maxAge * 1e3;
          return E.getTime() + S;
        }
        return this.expires == 1 / 0 ? 1 / 0 : this.expires.getTime();
      }
      // expiryDate() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
      // elsewhere), except it returns a Date
      expiryDate(V) {
        const E = this.expiryTime(V);
        return E == 1 / 0 ? new Date(p) : E == -1 / 0 ? new Date(h) : new Date(E);
      }
      // This replaces the "persistent-flag" parts of S5.3 step 3
      isPersistent() {
        return this.maxAge != null || this.expires != 1 / 0;
      }
      // Mostly S5.1.2 and S5.2.3:
      canonicalizedDomain() {
        return this.domain == null ? null : q(this.domain);
      }
      cdomain() {
        return this.canonicalizedDomain();
      }
    };
    W.cookiesCreated = 0, W.parse = te, W.fromJSON = D, W.serializableProperties = Object.keys($), W.sameSiteLevel = {
      strict: 3,
      lax: 2,
      none: 1
    }, W.sameSiteCanonical = {
      strict: "Strict",
      lax: "Lax"
    };
    function fe(P) {
      if (P != null) {
        const V = P.toLowerCase();
        switch (V) {
          case w.STRICT:
          case w.SILENT:
          case w.DISABLED:
            return V;
        }
      }
      return w.SILENT;
    }
    var Le = class nn {
      constructor(V, E = { rejectPublicSuffixes: !0 }) {
        typeof E == "boolean" && (E = { rejectPublicSuffixes: E }), i.validate(i.isObject(E), E), this.rejectPublicSuffixes = E.rejectPublicSuffixes, this.enableLooseMode = !!E.looseMode, this.allowSpecialUseDomain = typeof E.allowSpecialUseDomain == "boolean" ? E.allowSpecialUseDomain : !0, this.store = V || new r(), this.prefixSecurity = fe(E.prefixSecurity), this._cloneSync = z("clone"), this._importCookiesSync = z("_importCookies"), this.getCookiesSync = z("getCookies"), this.getCookieStringSync = z("getCookieString"), this.getSetCookieStringsSync = z("getSetCookieStrings"), this.removeAllCookiesSync = z("removeAllCookies"), this.setCookieSync = z("setCookie"), this.serializeSync = z("serialize");
      }
      setCookie(V, E, S, R) {
        i.validate(i.isUrlStringOrObject(E), R, S);
        let ie;
        if (i.isFunction(E))
          return R = E, R(new Error("No URL was specified"));
        const de = N(E);
        if (i.isFunction(S) && (R = S, S = {}), i.validate(i.isFunction(R), R), !i.isNonEmptyString(V) && !i.isObject(V) && V instanceof String && V.length == 0)
          return R(null);
        const Ce = q(de.hostname), He = S.loose || this.enableLooseMode;
        let X = null;
        if (S.sameSiteContext && (X = H(S.sameSiteContext), !X))
          return R(new Error(v));
        if (typeof V == "string" || V instanceof String) {
          if (V = W.parse(V, { loose: He }), !V)
            return ie = new Error("Cookie failed to parse"), R(S.ignoreError ? null : ie);
        } else if (!(V instanceof W))
          return ie = new Error(
            "First argument to setCookie must be a Cookie object or string"
          ), R(S.ignoreError ? null : ie);
        const ce = S.now || /* @__PURE__ */ new Date();
        if (this.rejectPublicSuffixes && V.domain && o.getPublicSuffix(V.cdomain(), {
          allowSpecialUseDomain: this.allowSpecialUseDomain,
          ignoreError: S.ignoreError
        }) == null && !I.test(V.domain))
          return ie = new Error("Cookie has domain set to a public suffix"), R(S.ignoreError ? null : ie);
        if (V.domain) {
          if (!O(Ce, V.cdomain(), !1))
            return ie = new Error(
              `Cookie not in this host's domain. Cookie:${V.cdomain()} Request:${Ce}`
            ), R(S.ignoreError ? null : ie);
          V.hostOnly == null && (V.hostOnly = !1);
        } else
          V.hostOnly = !0, V.domain = Ce;
        if ((!V.path || V.path[0] !== "/") && (V.path = Y(de.pathname), V.pathIsDefault = !0), S.http === !1 && V.httpOnly)
          return ie = new Error("Cookie is HttpOnly and this isn't an HTTP API"), R(S.ignoreError ? null : ie);
        if (V.sameSite !== "none" && V.sameSite !== void 0 && X && X === "none")
          return ie = new Error(
            "Cookie is SameSite but this is a cross-origin request"
          ), R(S.ignoreError ? null : ie);
        const je = this.prefixSecurity === w.SILENT;
        if (!(this.prefixSecurity === w.DISABLED)) {
          let ze = !1, Pe;
          if (G(V) ? T(V) || (ze = !0, Pe = "Cookie has __Host prefix but either Secure or HostOnly attribute is not set or Path is not '/'") : (ze = !0, Pe = "Cookie has __Secure prefix but Secure attribute is not set"), ze)
            return R(
              S.ignoreError || je ? null : new Error(Pe)
            );
        }
        const r1 = this.store;
        r1.updateCookie || (r1.updateCookie = function(ze, Pe, E1) {
          this.putCookie(Pe, E1);
        });
        function xe(ze, Pe) {
          if (ze)
            return R(ze);
          const E1 = function(rt) {
            if (rt)
              return R(rt);
            R(null, V);
          };
          if (Pe) {
            if (S.http === !1 && Pe.httpOnly)
              return ze = new Error("old Cookie is HttpOnly and this isn't an HTTP API"), R(S.ignoreError ? null : ze);
            V.creation = Pe.creation, V.creationIndex = Pe.creationIndex, V.lastAccessed = ce, r1.updateCookie(Pe, V, E1);
          } else
            V.creation = V.lastAccessed = ce, r1.putCookie(V, E1);
        }
        r1.findCookie(V.domain, V.path, V.key, xe);
      }
      // RFC6365 S5.4
      getCookies(V, E, S) {
        i.validate(i.isUrlStringOrObject(V), S, V);
        const R = N(V);
        i.isFunction(E) && (S = E, E = {}), i.validate(i.isObject(E), S, E), i.validate(i.isFunction(S), S);
        const ie = q(R.hostname), de = R.pathname || "/";
        let Ce = E.secure;
        Ce == null && R.protocol && (R.protocol == "https:" || R.protocol == "wss:") && (Ce = !0);
        let He = 0;
        if (E.sameSiteContext) {
          const ze = H(E.sameSiteContext);
          if (He = W.sameSiteLevel[ze], !He)
            return S(new Error(v));
        }
        let X = E.http;
        X == null && (X = !0);
        const ce = E.now || Date.now(), je = E.expire !== !1, Ze = !!E.allPaths, r1 = this.store;
        function xe(ze) {
          if (ze.hostOnly) {
            if (ze.domain != ie)
              return !1;
          } else if (!O(ie, ze.domain, !1))
            return !1;
          return !Ze && !s(de, ze.path) || ze.secure && !Ce || ze.httpOnly && !X || He && W.sameSiteLevel[ze.sameSite || "none"] > He ? !1 : je && ze.expiryTime() <= ce ? (r1.removeCookie(ze.domain, ze.path, ze.key, () => {
          }), !1) : !0;
        }
        r1.findCookies(
          ie,
          Ze ? null : de,
          this.allowSpecialUseDomain,
          (ze, Pe) => {
            if (ze)
              return S(ze);
            Pe = Pe.filter(xe), E.sort !== !1 && (Pe = Pe.sort(x));
            const E1 = /* @__PURE__ */ new Date();
            for (const rt of Pe)
              rt.lastAccessed = E1;
            S(null, Pe);
          }
        );
      }
      getCookieString(...V) {
        const E = V.pop();
        i.validate(i.isFunction(E), E);
        const S = function(R, ie) {
          R ? E(R) : E(
            null,
            ie.sort(x).map((de) => de.cookieString()).join("; ")
          );
        };
        V.push(S), this.getCookies.apply(this, V);
      }
      getSetCookieStrings(...V) {
        const E = V.pop();
        i.validate(i.isFunction(E), E);
        const S = function(R, ie) {
          R ? E(R) : E(
            null,
            ie.map((de) => de.toString())
          );
        };
        V.push(S), this.getCookies.apply(this, V);
      }
      serialize(V) {
        i.validate(i.isFunction(V), V);
        let E = this.store.constructor.name;
        i.isObject(E) && (E = null);
        const S = {
          // The version of tough-cookie that serialized this jar. Generally a good
          // practice since future versions can make data import decisions based on
          // known past behavior. When/if this matters, use `semver`.
          version: `tough-cookie@${l}`,
          // add the store type, to make humans happy:
          storeType: E,
          // CookieJar configuration:
          rejectPublicSuffixes: !!this.rejectPublicSuffixes,
          enableLooseMode: !!this.enableLooseMode,
          allowSpecialUseDomain: !!this.allowSpecialUseDomain,
          prefixSecurity: fe(this.prefixSecurity),
          // this gets filled from getAllCookies:
          cookies: []
        };
        if (!(this.store.getAllCookies && typeof this.store.getAllCookies == "function"))
          return V(
            new Error(
              "store does not support getAllCookies and cannot be serialized"
            )
          );
        this.store.getAllCookies((R, ie) => R ? V(R) : (S.cookies = ie.map((de) => (de = de instanceof W ? de.toJSON() : de, delete de.creationIndex, de)), V(null, S)));
      }
      toJSON() {
        return this.serializeSync();
      }
      // use the class method CookieJar.deserialize instead of calling this directly
      _importCookies(V, E) {
        let S = V.cookies;
        if (!S || !Array.isArray(S))
          return E(new Error("serialized jar has no cookies array"));
        S = S.slice();
        const R = (ie) => {
          if (ie)
            return E(ie);
          if (!S.length)
            return E(ie, this);
          let de;
          try {
            de = D(S.shift());
          } catch (Ce) {
            return E(Ce);
          }
          if (de === null)
            return R(null);
          this.store.putCookie(de, R);
        };
        R();
      }
      clone(V, E) {
        arguments.length === 1 && (E = V, V = null), this.serialize((S, R) => {
          if (S)
            return E(S);
          nn.deserialize(R, V, E);
        });
      }
      cloneSync(V) {
        if (arguments.length === 0)
          return this._cloneSync();
        if (!V.synchronous)
          throw new Error(
            "CookieJar clone destination store is not synchronous; use async API instead."
          );
        return this._cloneSync(V);
      }
      removeAllCookies(V) {
        i.validate(i.isFunction(V), V);
        const E = this.store;
        if (typeof E.removeAllCookies == "function" && E.removeAllCookies !== n.prototype.removeAllCookies)
          return E.removeAllCookies(V);
        E.getAllCookies((S, R) => {
          if (S)
            return V(S);
          if (R.length === 0)
            return V(null);
          let ie = 0;
          const de = [];
          function Ce(He) {
            if (He && de.push(He), ie++, ie === R.length)
              return V(de.length ? de[0] : null);
          }
          R.forEach((He) => {
            E.removeCookie(
              He.domain,
              He.path,
              He.key,
              Ce
            );
          });
        });
      }
      static deserialize(V, E, S) {
        arguments.length !== 3 && (S = E, E = null), i.validate(i.isFunction(S), S);
        let R;
        if (typeof V == "string") {
          if (R = Z(V), R instanceof Error)
            return S(R);
        } else
          R = V;
        const ie = new nn(E, {
          rejectPublicSuffixes: R.rejectPublicSuffixes,
          looseMode: R.enableLooseMode,
          allowSpecialUseDomain: R.allowSpecialUseDomain,
          prefixSecurity: R.prefixSecurity
        });
        ie._importCookies(R, (de) => {
          if (de)
            return S(de);
          S(null, ie);
        });
      }
      static deserializeSync(V, E) {
        const S = typeof V == "string" ? JSON.parse(V) : V, R = new nn(E, {
          rejectPublicSuffixes: S.rejectPublicSuffixes,
          looseMode: S.enableLooseMode
        });
        if (!R.store.synchronous)
          throw new Error(
            "CookieJar store is not synchronous; use async API instead."
          );
        return R._importCookiesSync(S), R;
      }
    };
    Le.fromJSON = Le.deserializeSync, [
      "_importCookies",
      "clone",
      "getCookies",
      "getCookieString",
      "getSetCookieStrings",
      "removeAllCookies",
      "serialize",
      "setCookie"
    ].forEach((P) => {
      Le.prototype[P] = f(Le.prototype[P]);
    }), Le.deserialize = f(Le.deserialize);
    function z(P) {
      return function(...V) {
        if (!this.store.synchronous)
          throw new Error(
            "CookieJar store is not synchronous; use async API instead."
          );
        let E, S;
        if (this[P](...V, (R, ie) => {
          E = R, S = ie;
        }), E)
          throw E;
        return S;
      };
    }
    t.version = l, t.CookieJar = Le, t.Cookie = W, t.Store = n, t.MemoryCookieStore = r, t.parseDate = ee, t.formatDate = ve, t.parse = te, t.fromJSON = D, t.domainMatch = O, t.defaultPath = Y, t.pathMatch = s, t.getPublicSuffix = o.getPublicSuffix, t.cookieCompare = x, t.permuteDomain = al().permuteDomain, t.permutePath = A, t.canonicalDomain = q, t.PrefixSecurityEnum = w, t.ParameterError = i.ParameterError;
  }
}), Gk = Bk(Kk()), Xk = Gk.default;
/*! Bundled license information:

tough-cookie/lib/pubsuffix-psl.js:
  (*!
   * Copyright (c) 2018, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)

tough-cookie/lib/store.js:
  (*!
   * Copyright (c) 2015, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)

tough-cookie/lib/permuteDomain.js:
  (*!
   * Copyright (c) 2015, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)

tough-cookie/lib/pathMatch.js:
  (*!
   * Copyright (c) 2015, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)

tough-cookie/lib/memstore.js:
  (*!
   * Copyright (c) 2015, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)

tough-cookie/lib/cookie.js:
  (*!
   * Copyright (c) 2015-2020, Salesforce.com, Inc.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are met:
   *
   * 1. Redistributions of source code must retain the above copyright notice,
   * this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above copyright notice,
   * this list of conditions and the following disclaimer in the documentation
   * and/or other materials provided with the distribution.
   *
   * 3. Neither the name of Salesforce.com nor the names of its contributors may
   * be used to endorse or promote products derived from this software without
   * specific prior written permission.
   *
   * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
   * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
   * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
   * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
   * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
   * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
   * POSSIBILITY OF SUCH DAMAGE.
   *)
*/
const { Cookie: Qk, CookieJar: Jk, Store: eC, MemoryCookieStore: tC, domainMatch: aC, pathMatch: oC } = Xk;
class nC extends eC {
  storage;
  storageKey;
  constructor() {
    super(), l0(
      typeof localStorage < "u",
      "Failed to create a WebStorageCookieStore: `localStorage` is not available in this environment. This is likely an issue with MSW. Please report it on GitHub: https://github.com/mswjs/msw/issues"
    ), this.synchronous = !0, this.storage = localStorage, this.storageKey = "__msw-cookie-store__";
  }
  findCookie(e, a, o, n) {
    try {
      const r = this.getStore(), s = this.filterCookiesFromList(r, { domain: e, path: a, key: o });
      n(null, s[0] || null);
    } catch (r) {
      r instanceof Error && n(r, null);
    }
  }
  findCookies(e, a, o, n) {
    if (!e) {
      n(null, []);
      return;
    }
    try {
      const r = this.getStore(), s = this.filterCookiesFromList(r, {
        domain: e,
        path: a
      });
      n(null, s);
    } catch (r) {
      r instanceof Error && n(r, []);
    }
  }
  putCookie(e, a) {
    try {
      if (e.maxAge === 0)
        return;
      const o = this.getStore();
      o.push(e), this.updateStore(o);
    } catch (o) {
      o instanceof Error && a(o);
    }
  }
  updateCookie(e, a, o) {
    if (a.maxAge === 0) {
      this.removeCookie(
        a.domain || "",
        a.path || "",
        a.key,
        o
      );
      return;
    }
    this.putCookie(a, o);
  }
  removeCookie(e, a, o, n) {
    try {
      const r = this.getStore(), s = this.deleteCookiesFromList(r, { domain: e, path: a, key: o });
      this.updateStore(s), n(null);
    } catch (r) {
      r instanceof Error && n(r);
    }
  }
  removeCookies(e, a, o) {
    try {
      const n = this.getStore(), r = this.deleteCookiesFromList(n, { domain: e, path: a });
      this.updateStore(r), o(null);
    } catch (n) {
      n instanceof Error && o(n);
    }
  }
  getAllCookies(e) {
    try {
      e(null, this.getStore());
    } catch (a) {
      a instanceof Error && e(a, []);
    }
  }
  getStore() {
    try {
      const e = this.storage.getItem(this.storageKey);
      if (e == null)
        return [];
      const a = JSON.parse(e), o = [];
      for (const n of a) {
        const r = Qk.fromJSON(n);
        r != null && o.push(r);
      }
      return o;
    } catch {
      return [];
    }
  }
  updateStore(e) {
    this.storage.setItem(
      this.storageKey,
      JSON.stringify(e.map((a) => a.toJSON()))
    );
  }
  filterCookiesFromList(e, a) {
    const o = [];
    for (const n of e)
      a.domain && !aC(a.domain, n.domain || "") || a.path && !oC(a.path, n.path || "") || a.key && n.key !== a.key || o.push(n);
    return o;
  }
  deleteCookiesFromList(e, a) {
    const o = this.filterCookiesFromList(e, a);
    return e.filter((n) => !o.includes(n));
  }
}
const rC = q2() ? new tC() : new nC(), sC = new Jk(rC);
function rl(t) {
  const e = K2.parse(t), a = {};
  for (const o in e)
    typeof e[o] < "u" && (a[o] = e[o]);
  return a;
}
function as() {
  return rl(document.cookie);
}
function iC(t) {
  if (typeof document > "u" || typeof location > "u")
    return {};
  switch (t.credentials) {
    case "same-origin": {
      const e = new URL(t.url);
      return location.origin === e.origin ? as() : {};
    }
    case "include":
      return as();
    default:
      return {};
  }
}
function lC(t) {
  const e = t.headers.get("cookie"), a = e ? rl(e) : {}, o = iC(t);
  for (const s in o)
    t.headers.append(
      "cookie",
      K2.serialize(s, o[s])
    );
  const n = sC.getCookiesSync(t.url), r = Object.fromEntries(
    n.map((s) => [s.key, s.value])
  );
  for (const s of n)
    t.headers.append("cookie", s.toString());
  return {
    ...o,
    ...r,
    ...a
  };
}
var St = /* @__PURE__ */ ((t) => (t.HEAD = "HEAD", t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.PATCH = "PATCH", t.OPTIONS = "OPTIONS", t.DELETE = "DELETE", t))(St || {});
class uC extends mn {
  constructor(e, a, o, n) {
    super({
      info: {
        header: `${e} ${a}`,
        path: a,
        method: e
      },
      resolver: o,
      options: n
    }), this.checkRedundantQueryParameters();
  }
  checkRedundantQueryParameters() {
    const { method: e, path: a } = this.info;
    if (a instanceof RegExp || U2(a) === a)
      return;
    yk(a).forEach((r, s) => {
    }), Ar.warn(
      `Found a redundant usage of query parameters in the request handler URL for "${e} ${a}". Please match against a path instead and access query parameters using "new URL(request.url).searchParams" instead. Learn more: https://mswjs.io/docs/recipes/query-parameters`
    );
  }
  async parse(e) {
    const a = new URL(e.request.url), o = _k(
      a,
      this.info.path,
      e.resolutionContext?.baseUrl
    ), n = lC(e.request);
    return {
      match: o,
      cookies: n
    };
  }
  predicate(e) {
    const a = this.matchMethod(e.request.method), o = e.parsedResult.match.matches;
    return a && o;
  }
  matchMethod(e) {
    return this.info.method instanceof RegExp ? this.info.method.test(e) : Fb(this.info.method, e);
  }
  extendResolverArgs(e) {
    return {
      params: e.parsedResult.match?.params || {},
      cookies: e.parsedResult.cookies
    };
  }
  async log(e) {
    const a = Hk(e.request.url), o = await Zb(e.request), n = await Jb(e.response), r = Bb(n.status);
    console.groupCollapsed(
      Ar.formatMessage(
        `${Ib()} ${e.request.method} ${a} (%c${n.status} ${n.statusText}%c)`
      ),
      `color:${r}`,
      "color:inherit"
    ), console.log("Request", o), console.log("Handler:", this), console.log("Response", n), console.groupEnd();
  }
}
function Mt(t) {
  return (e, a, o = {}) => new uC(t, e, a, o);
}
const cC = {
  all: Mt(/.+/),
  head: Mt(St.HEAD),
  get: Mt(St.GET),
  post: Mt(St.POST),
  put: Mt(St.PUT),
  delete: Mt(St.DELETE),
  patch: Mt(St.PATCH),
  options: Mt(St.OPTIONS)
};
var dC = Object.create, sl = Object.defineProperty, mC = Object.getOwnPropertyDescriptor, il = Object.getOwnPropertyNames, pC = Object.getPrototypeOf, fC = Object.prototype.hasOwnProperty, hC = (t, e) => function() {
  return e || (0, t[il(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, vC = (t, e, a, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of il(e))
      !fC.call(t, n) && n !== a && sl(t, n, { get: () => e[n], enumerable: !(o = mC(e, n)) || o.enumerable });
  return t;
}, gC = (t, e, a) => (a = t != null ? dC(pC(t)) : {}, vC(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !t || !t.__esModule ? sl(a, "default", { value: t, enumerable: !0 }) : a,
  t
)), yC = hC({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(t, e) {
    var a = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function o(l) {
      return typeof l == "string" && !!l.trim();
    }
    function n(l, f) {
      var u = l.split(";").filter(o), d = u.shift(), k = r(d), y = k.name, b = k.value;
      f = f ? Object.assign({}, a, f) : a;
      try {
        b = f.decodeValues ? decodeURIComponent(b) : b;
      } catch (c) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + b + "'. Set options.decodeValues to false to disable this feature.",
          c
        );
      }
      var M = {
        name: y,
        value: b
      };
      return u.forEach(function(c) {
        var p = c.split("="), h = p.shift().trimLeft().toLowerCase(), v = p.join("=");
        h === "expires" ? M.expires = new Date(v) : h === "max-age" ? M.maxAge = parseInt(v, 10) : h === "secure" ? M.secure = !0 : h === "httponly" ? M.httpOnly = !0 : h === "samesite" ? M.sameSite = v : M[h] = v;
      }), M;
    }
    function r(l) {
      var f = "", u = "", d = l.split("=");
      return d.length > 1 ? (f = d.shift(), u = d.join("=")) : u = l, { name: f, value: u };
    }
    function s(l, f) {
      if (f = f ? Object.assign({}, a, f) : a, !l)
        return f.map ? {} : [];
      if (l.headers)
        if (typeof l.headers.getSetCookie == "function")
          l = l.headers.getSetCookie();
        else if (l.headers["set-cookie"])
          l = l.headers["set-cookie"];
        else {
          var u = l.headers[Object.keys(l.headers).find(function(k) {
            return k.toLowerCase() === "set-cookie";
          })];
          !u && l.headers.cookie && !f.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), l = u;
        }
      if (Array.isArray(l) || (l = [l]), f = f ? Object.assign({}, a, f) : a, f.map) {
        var d = {};
        return l.filter(o).reduce(function(k, y) {
          var b = n(y, f);
          return k[b.name] = b, k;
        }, d);
      } else
        return l.filter(o).map(function(k) {
          return n(k, f);
        });
    }
    function i(l) {
      if (Array.isArray(l))
        return l;
      if (typeof l != "string")
        return [];
      var f = [], u = 0, d, k, y, b, M;
      function c() {
        for (; u < l.length && /\s/.test(l.charAt(u)); )
          u += 1;
        return u < l.length;
      }
      function p() {
        return k = l.charAt(u), k !== "=" && k !== ";" && k !== ",";
      }
      for (; u < l.length; ) {
        for (d = u, M = !1; c(); )
          if (k = l.charAt(u), k === ",") {
            for (y = u, u += 1, c(), b = u; u < l.length && p(); )
              u += 1;
            u < l.length && l.charAt(u) === "=" ? (M = !0, u = b, f.push(l.substring(d, y)), d = u) : u = y + 1;
          } else
            u += 1;
        (!M || u >= l.length) && f.push(l.substring(d, l.length));
      }
      return f;
    }
    e.exports = s, e.exports.parse = s, e.exports.parseString = n, e.exports.splitCookiesString = i;
  }
}), bC = gC(yC()), kC = /[^a-z0-9\-#$%&'*+.^_`|~]/i;
function Na(t) {
  if (kC.test(t) || t.trim() === "")
    throw new TypeError("Invalid character in header field name");
  return t.trim().toLowerCase();
}
var os = [
  `
`,
  "\r",
  "	",
  " "
], CC = new RegExp(
  `(^[${os.join("")}]|$[${os.join("")}])`,
  "g"
);
function pr(t) {
  return t.replace(CC, "");
}
function qa(t) {
  if (typeof t != "string" || t.length === 0)
    return !1;
  for (let e = 0; e < t.length; e++) {
    const a = t.charCodeAt(e);
    if (a > 127 || !wC(a))
      return !1;
  }
  return !0;
}
function wC(t) {
  return ![
    127,
    32,
    "(",
    ")",
    "<",
    ">",
    "@",
    ",",
    ";",
    ":",
    "\\",
    '"',
    "/",
    "[",
    "]",
    "?",
    "=",
    "{",
    "}"
  ].includes(t);
}
function ns(t) {
  if (typeof t != "string" || t.trim() !== t)
    return !1;
  for (let e = 0; e < t.length; e++) {
    const a = t.charCodeAt(e);
    if (
      // NUL.
      a === 0 || // HTTP newline bytes.
      a === 10 || a === 13
    )
      return !1;
  }
  return !0;
}
var ma = Symbol("normalizedHeaders"), fr = Symbol("rawHeaderNames"), rs = ", ", ss, is, ls, _C = class ll {
  constructor(e) {
    this[ss] = {}, this[is] = /* @__PURE__ */ new Map(), this[ls] = "Headers", ["Headers", "HeadersPolyfill"].includes(e?.constructor.name) || e instanceof ll || typeof globalThis.Headers < "u" && e instanceof globalThis.Headers ? e.forEach((o, n) => {
      this.append(n, o);
    }, this) : Array.isArray(e) ? e.forEach(([a, o]) => {
      this.append(
        a,
        Array.isArray(o) ? o.join(rs) : o
      );
    }) : e && Object.getOwnPropertyNames(e).forEach((a) => {
      const o = e[a];
      this.append(
        a,
        Array.isArray(o) ? o.join(rs) : o
      );
    });
  }
  [(ss = ma, is = fr, ls = Symbol.toStringTag, Symbol.iterator)]() {
    return this.entries();
  }
  *keys() {
    for (const [e] of this.entries())
      yield e;
  }
  *values() {
    for (const [, e] of this.entries())
      yield e;
  }
  *entries() {
    let e = Object.keys(this[ma]).sort(
      (a, o) => a.localeCompare(o)
    );
    for (const a of e)
      if (a === "set-cookie")
        for (const o of this.getSetCookie())
          yield [a, o];
      else
        yield [a, this.get(a)];
  }
  /**
   * Returns a boolean stating whether a `Headers` object contains a certain header.
   */
  has(e) {
    if (!qa(e))
      throw new TypeError(`Invalid header name "${e}"`);
    return this[ma].hasOwnProperty(Na(e));
  }
  /**
   * Returns a `ByteString` sequence of all the values of a header with a given name.
   */
  get(e) {
    if (!qa(e))
      throw TypeError(`Invalid header name "${e}"`);
    return this[ma][Na(e)] ?? null;
  }
  /**
   * Sets a new value for an existing header inside a `Headers` object, or adds the header if it does not already exist.
   */
  set(e, a) {
    if (!qa(e) || !ns(a))
      return;
    const o = Na(e), n = pr(a);
    this[ma][o] = pr(n), this[fr].set(o, e);
  }
  /**
   * Appends a new value onto an existing header inside a `Headers` object, or adds the header if it does not already exist.
   */
  append(e, a) {
    if (!qa(e) || !ns(a))
      return;
    const o = Na(e), n = pr(a);
    let r = this.has(o) ? `${this.get(o)}, ${n}` : n;
    this.set(e, r);
  }
  /**
   * Deletes a header from the `Headers` object.
   */
  delete(e) {
    if (!qa(e) || !this.has(e))
      return;
    const a = Na(e);
    delete this[ma][a], this[fr].delete(a);
  }
  /**
   * Traverses the `Headers` object,
   * calling the given callback for each header.
   */
  forEach(e, a) {
    for (const [o, n] of this.entries())
      e.call(a, n, o, this);
  }
  /**
   * Returns an array containing the values
   * of all Set-Cookie headers associated
   * with a response
   */
  getSetCookie() {
    const e = this.get("set-cookie");
    return e === null ? [] : e === "" ? [""] : (0, bC.splitCookiesString)(e);
  }
};
const { message: HC } = I2, jC = Symbol("kSetCookie");
function qt(t = {}) {
  const e = t?.status || 200, a = t?.statusText || HC[e] || "", o = new Headers(t?.headers);
  return {
    ...t,
    headers: o,
    status: e,
    statusText: a
  };
}
function LC(t, e) {
  e.type && Object.defineProperty(t, "type", {
    value: e.type,
    enumerable: !0,
    writable: !1
  });
  const a = e.headers.get("set-cookie");
  if (a && (Object.defineProperty(t, jC, {
    value: a,
    enumerable: !1,
    writable: !1
  }), typeof document < "u")) {
    const o = _C.prototype.getSetCookie.call(
      e.headers
    );
    for (const n of o)
      document.cookie = n;
  }
  return t;
}
class ut extends Response {
  constructor(e, a) {
    const o = qt(a);
    super(e, o), LC(this, o);
  }
  /**
   * Create a `Response` with a `Content-Type: "text/plain"` body.
   * @example
   * HttpResponse.text('hello world')
   * HttpResponse.text('Error', { status: 500 })
   */
  static text(e, a) {
    const o = qt(a);
    return o.headers.has("Content-Type") || o.headers.set("Content-Type", "text/plain"), o.headers.has("Content-Length") || o.headers.set(
      "Content-Length",
      e ? new Blob([e]).size.toString() : "0"
    ), new ut(e, o);
  }
  /**
   * Create a `Response` with a `Content-Type: "application/json"` body.
   * @example
   * HttpResponse.json({ firstName: 'John' })
   * HttpResponse.json({ error: 'Not Authorized' }, { status: 401 })
   */
  static json(e, a) {
    const o = qt(a);
    o.headers.has("Content-Type") || o.headers.set("Content-Type", "application/json");
    const n = JSON.stringify(e);
    return o.headers.has("Content-Length") || o.headers.set(
      "Content-Length",
      n ? new Blob([n]).size.toString() : "0"
    ), new ut(
      n,
      o
    );
  }
  /**
   * Create a `Response` with a `Content-Type: "application/xml"` body.
   * @example
   * HttpResponse.xml(`<user name="John" />`)
   * HttpResponse.xml(`<article id="abc-123" />`, { status: 201 })
   */
  static xml(e, a) {
    const o = qt(a);
    return o.headers.has("Content-Type") || o.headers.set("Content-Type", "text/xml"), new ut(e, o);
  }
  /**
   * Create a `Response` with a `Content-Type: "text/html"` body.
   * @example
   * HttpResponse.html(`<p class="author">Jane Doe</p>`)
   * HttpResponse.html(`<main id="abc-123">Main text</main>`, { status: 201 })
   */
  static html(e, a) {
    const o = qt(a);
    return o.headers.has("Content-Type") || o.headers.set("Content-Type", "text/html"), new ut(e, o);
  }
  /**
   * Create a `Response` with an `ArrayBuffer` body.
   * @example
   * const buffer = new ArrayBuffer(3)
   * const view = new Uint8Array(buffer)
   * view.set([1, 2, 3])
   *
   * HttpResponse.arrayBuffer(buffer)
   */
  static arrayBuffer(e, a) {
    const o = qt(a);
    return o.headers.has("Content-Type") || o.headers.set("Content-Type", "application/octet-stream"), e && !o.headers.has("Content-Length") && o.headers.set("Content-Length", e.byteLength.toString()), new ut(e, o);
  }
  /**
   * Create a `Response` with a `FormData` body.
   * @example
   * const data = new FormData()
   * data.set('name', 'Alice')
   *
   * HttpResponse.formData(data)
   */
  static formData(e, a) {
    return new ut(e, qt(a));
  }
}
Db();
const I1 = {
  DIGITAL_STAMP: "DIGITAL_STAMP",
  UNFRANKED: "UNFRANKED",
  MAILBOX: "MAILBOX",
  PACKAGE: "PACKAGE",
  PALLET: "PALLET",
  SMALL_PACKAGE: "SMALL_PACKAGE"
}, X1 = {
  BPOST: "BPOST",
  CHEAP_CARGO: "CHEAP_CARGO",
  DHL_FOR_YOU: "DHL_FOR_YOU",
  DHL_EUROPLUS: "DHL_EUROPLUS",
  DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
  DPD: "DPD",
  GLS: "GLS",
  POSTNL: "POSTNL",
  UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
  UPS_STANDARD: "UPS_STANDARD"
}, rn = {
  EVENING_DELIVERY: "EVENING_DELIVERY",
  MORNING_DELIVERY: "MORNING_DELIVERY",
  STANDARD_DELIVERY: "STANDARD_DELIVERY"
}, us = {
  B2B: "B2B",
  B2C: "B2C"
}, Er = {
  /**
   * The server cannot or will not process the request due to an apparent client error
   * (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
   */
  BadRequest: 400,
  /**
   * Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
   * been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
   * requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
   * "unauthenticated",i.e. the user does not have the necessary credentials.
   */
  Unauthorized: 401
}, xC = (t) => ut.json(
  {
    type: "urn:problem:invalid-request-syntax",
    status: Er.BadRequest,
    title: "Bad Request",
    detail: "Request validation failed",
    instance: "urn:trace-id:bbe7361f-c9ff-4b3f-a0b8-0ecb0188166c",
    errors: t
  },
  {
    status: Er.BadRequest
  }
);
function $C(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var hr = { exports: {} }, cs = {}, vt = {}, Ut = {}, ds = {}, ms = {}, ps = {}, fs;
function pn() {
  return fs || (fs = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.regexpCode = t.getEsmExportName = t.getProperty = t.safeStringify = t.stringify = t.strConcat = t.addCodeArg = t.str = t._ = t.nil = t._Code = t.Name = t.IDENTIFIER = t._CodeOrName = void 0;
    class e {
    }
    t._CodeOrName = e, t.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
    class a extends e {
      constructor(h) {
        if (super(), !t.IDENTIFIER.test(h))
          throw new Error("CodeGen: name must be a valid identifier");
        this.str = h;
      }
      toString() {
        return this.str;
      }
      emptyStr() {
        return !1;
      }
      get names() {
        return { [this.str]: 1 };
      }
    }
    t.Name = a;
    class o extends e {
      constructor(h) {
        super(), this._items = typeof h == "string" ? [h] : h;
      }
      toString() {
        return this.str;
      }
      emptyStr() {
        if (this._items.length > 1)
          return !1;
        const h = this._items[0];
        return h === "" || h === '""';
      }
      get str() {
        var h;
        return (h = this._str) !== null && h !== void 0 ? h : this._str = this._items.reduce((v, H) => `${v}${H}`, "");
      }
      get names() {
        var h;
        return (h = this._names) !== null && h !== void 0 ? h : this._names = this._items.reduce((v, H) => (H instanceof a && (v[H.str] = (v[H.str] || 0) + 1), v), {});
      }
    }
    t._Code = o, t.nil = new o("");
    function n(p, ...h) {
      const v = [p[0]];
      let H = 0;
      for (; H < h.length; )
        i(v, h[H]), v.push(p[++H]);
      return new o(v);
    }
    t._ = n;
    const r = new o("+");
    function s(p, ...h) {
      const v = [y(p[0])];
      let H = 0;
      for (; H < h.length; )
        v.push(r), i(v, h[H]), v.push(r, y(p[++H]));
      return l(v), new o(v);
    }
    t.str = s;
    function i(p, h) {
      h instanceof o ? p.push(...h._items) : h instanceof a ? p.push(h) : p.push(d(h));
    }
    t.addCodeArg = i;
    function l(p) {
      let h = 1;
      for (; h < p.length - 1; ) {
        if (p[h] === r) {
          const v = f(p[h - 1], p[h + 1]);
          if (v !== void 0) {
            p.splice(h - 1, 3, v);
            continue;
          }
          p[h++] = "+";
        }
        h++;
      }
    }
    function f(p, h) {
      if (h === '""')
        return p;
      if (p === '""')
        return h;
      if (typeof p == "string")
        return h instanceof a || p[p.length - 1] !== '"' ? void 0 : typeof h != "string" ? `${p.slice(0, -1)}${h}"` : h[0] === '"' ? p.slice(0, -1) + h.slice(1) : void 0;
      if (typeof h == "string" && h[0] === '"' && !(p instanceof a))
        return `"${p}${h.slice(1)}`;
    }
    function u(p, h) {
      return h.emptyStr() ? p : p.emptyStr() ? h : s`${p}${h}`;
    }
    t.strConcat = u;
    function d(p) {
      return typeof p == "number" || typeof p == "boolean" || p === null ? p : y(Array.isArray(p) ? p.join(",") : p);
    }
    function k(p) {
      return new o(y(p));
    }
    t.stringify = k;
    function y(p) {
      return JSON.stringify(p).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }
    t.safeStringify = y;
    function b(p) {
      return typeof p == "string" && t.IDENTIFIER.test(p) ? new o(`.${p}`) : n`[${p}]`;
    }
    t.getProperty = b;
    function M(p) {
      if (typeof p == "string" && t.IDENTIFIER.test(p))
        return new o(`${p}`);
      throw new Error(`CodeGen: invalid export name: ${p}, use explicit $id name mapping`);
    }
    t.getEsmExportName = M;
    function c(p) {
      return new o(p.toString());
    }
    t.regexpCode = c;
  })(ps)), ps;
}
var hs = {}, vs;
function gs() {
  return vs || (vs = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ValueScope = t.ValueScopeName = t.Scope = t.varKinds = t.UsedValueState = void 0;
    const e = pn();
    class a extends Error {
      constructor(f) {
        super(`CodeGen: "code" for ${f} not defined`), this.value = f.value;
      }
    }
    var o;
    (function(l) {
      l[l.Started = 0] = "Started", l[l.Completed = 1] = "Completed";
    })(o || (t.UsedValueState = o = {})), t.varKinds = {
      const: new e.Name("const"),
      let: new e.Name("let"),
      var: new e.Name("var")
    };
    class n {
      constructor({ prefixes: f, parent: u } = {}) {
        this._names = {}, this._prefixes = f, this._parent = u;
      }
      toName(f) {
        return f instanceof e.Name ? f : this.name(f);
      }
      name(f) {
        return new e.Name(this._newName(f));
      }
      _newName(f) {
        const u = this._names[f] || this._nameGroup(f);
        return `${f}${u.index++}`;
      }
      _nameGroup(f) {
        var u, d;
        if (!((d = (u = this._parent) === null || u === void 0 ? void 0 : u._prefixes) === null || d === void 0) && d.has(f) || this._prefixes && !this._prefixes.has(f))
          throw new Error(`CodeGen: prefix "${f}" is not allowed in this scope`);
        return this._names[f] = { prefix: f, index: 0 };
      }
    }
    t.Scope = n;
    class r extends e.Name {
      constructor(f, u) {
        super(u), this.prefix = f;
      }
      setValue(f, { property: u, itemIndex: d }) {
        this.value = f, this.scopePath = (0, e._)`.${new e.Name(u)}[${d}]`;
      }
    }
    t.ValueScopeName = r;
    const s = (0, e._)`\n`;
    class i extends n {
      constructor(f) {
        super(f), this._values = {}, this._scope = f.scope, this.opts = { ...f, _n: f.lines ? s : e.nil };
      }
      get() {
        return this._scope;
      }
      name(f) {
        return new r(f, this._newName(f));
      }
      value(f, u) {
        var d;
        if (u.ref === void 0)
          throw new Error("CodeGen: ref must be passed in value");
        const k = this.toName(f), { prefix: y } = k, b = (d = u.key) !== null && d !== void 0 ? d : u.ref;
        let M = this._values[y];
        if (M) {
          const h = M.get(b);
          if (h)
            return h;
        } else
          M = this._values[y] = /* @__PURE__ */ new Map();
        M.set(b, k);
        const c = this._scope[y] || (this._scope[y] = []), p = c.length;
        return c[p] = u.ref, k.setValue(u, { property: y, itemIndex: p }), k;
      }
      getValue(f, u) {
        const d = this._values[f];
        if (d)
          return d.get(u);
      }
      scopeRefs(f, u = this._values) {
        return this._reduceValues(u, (d) => {
          if (d.scopePath === void 0)
            throw new Error(`CodeGen: name "${d}" has no value`);
          return (0, e._)`${f}${d.scopePath}`;
        });
      }
      scopeCode(f = this._values, u, d) {
        return this._reduceValues(f, (k) => {
          if (k.value === void 0)
            throw new Error(`CodeGen: name "${k}" has no value`);
          return k.value.code;
        }, u, d);
      }
      _reduceValues(f, u, d = {}, k) {
        let y = e.nil;
        for (const b in f) {
          const M = f[b];
          if (!M)
            continue;
          const c = d[b] = d[b] || /* @__PURE__ */ new Map();
          M.forEach((p) => {
            if (c.has(p))
              return;
            c.set(p, o.Started);
            let h = u(p);
            if (h) {
              const v = this.opts.es5 ? t.varKinds.var : t.varKinds.const;
              y = (0, e._)`${y}${v} ${p} = ${h};${this.opts._n}`;
            } else if (h = k?.(p))
              y = (0, e._)`${y}${h}${this.opts._n}`;
            else
              throw new a(p);
            c.set(p, o.Completed);
          });
        }
        return y;
      }
    }
    t.ValueScope = i;
  })(hs)), hs;
}
var ys;
function Fe() {
  return ys || (ys = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.or = t.and = t.not = t.CodeGen = t.operators = t.varKinds = t.ValueScopeName = t.ValueScope = t.Scope = t.Name = t.regexpCode = t.stringify = t.getProperty = t.nil = t.strConcat = t.str = t._ = void 0;
    const e = pn(), a = gs();
    var o = pn();
    Object.defineProperty(t, "_", { enumerable: !0, get: function() {
      return o._;
    } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
      return o.str;
    } }), Object.defineProperty(t, "strConcat", { enumerable: !0, get: function() {
      return o.strConcat;
    } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
      return o.nil;
    } }), Object.defineProperty(t, "getProperty", { enumerable: !0, get: function() {
      return o.getProperty;
    } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
      return o.stringify;
    } }), Object.defineProperty(t, "regexpCode", { enumerable: !0, get: function() {
      return o.regexpCode;
    } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
      return o.Name;
    } });
    var n = gs();
    Object.defineProperty(t, "Scope", { enumerable: !0, get: function() {
      return n.Scope;
    } }), Object.defineProperty(t, "ValueScope", { enumerable: !0, get: function() {
      return n.ValueScope;
    } }), Object.defineProperty(t, "ValueScopeName", { enumerable: !0, get: function() {
      return n.ValueScopeName;
    } }), Object.defineProperty(t, "varKinds", { enumerable: !0, get: function() {
      return n.varKinds;
    } }), t.operators = {
      GT: new e._Code(">"),
      GTE: new e._Code(">="),
      LT: new e._Code("<"),
      LTE: new e._Code("<="),
      EQ: new e._Code("==="),
      NEQ: new e._Code("!=="),
      NOT: new e._Code("!"),
      OR: new e._Code("||"),
      AND: new e._Code("&&"),
      ADD: new e._Code("+")
    };
    class r {
      optimizeNodes() {
        return this;
      }
      optimizeNames(x, A) {
        return this;
      }
    }
    class s extends r {
      constructor(x, A, N) {
        super(), this.varKind = x, this.name = A, this.rhs = N;
      }
      render({ es5: x, _n: A }) {
        const N = x ? a.varKinds.var : this.varKind, $ = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
        return `${N} ${this.name}${$};` + A;
      }
      optimizeNames(x, A) {
        if (x[this.name.str])
          return this.rhs && (this.rhs = q(this.rhs, x, A)), this;
      }
      get names() {
        return this.rhs instanceof e._CodeOrName ? this.rhs.names : {};
      }
    }
    class i extends r {
      constructor(x, A, N) {
        super(), this.lhs = x, this.rhs = A, this.sideEffects = N;
      }
      render({ _n: x }) {
        return `${this.lhs} = ${this.rhs};` + x;
      }
      optimizeNames(x, A) {
        if (!(this.lhs instanceof e.Name && !x[this.lhs.str] && !this.sideEffects))
          return this.rhs = q(this.rhs, x, A), this;
      }
      get names() {
        const x = this.lhs instanceof e.Name ? {} : { ...this.lhs.names };
        return ve(x, this.rhs);
      }
    }
    class l extends i {
      constructor(x, A, N, $) {
        super(x, N, $), this.op = A;
      }
      render({ _n: x }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + x;
      }
    }
    class f extends r {
      constructor(x) {
        super(), this.label = x, this.names = {};
      }
      render({ _n: x }) {
        return `${this.label}:` + x;
      }
    }
    class u extends r {
      constructor(x) {
        super(), this.label = x, this.names = {};
      }
      render({ _n: x }) {
        return `break${this.label ? ` ${this.label}` : ""};` + x;
      }
    }
    class d extends r {
      constructor(x) {
        super(), this.error = x;
      }
      render({ _n: x }) {
        return `throw ${this.error};` + x;
      }
      get names() {
        return this.error.names;
      }
    }
    class k extends r {
      constructor(x) {
        super(), this.code = x;
      }
      render({ _n: x }) {
        return `${this.code};` + x;
      }
      optimizeNodes() {
        return `${this.code}` ? this : void 0;
      }
      optimizeNames(x, A) {
        return this.code = q(this.code, x, A), this;
      }
      get names() {
        return this.code instanceof e._CodeOrName ? this.code.names : {};
      }
    }
    class y extends r {
      constructor(x = []) {
        super(), this.nodes = x;
      }
      render(x) {
        return this.nodes.reduce((A, N) => A + N.render(x), "");
      }
      optimizeNodes() {
        const { nodes: x } = this;
        let A = x.length;
        for (; A--; ) {
          const N = x[A].optimizeNodes();
          Array.isArray(N) ? x.splice(A, 1, ...N) : N ? x[A] = N : x.splice(A, 1);
        }
        return x.length > 0 ? this : void 0;
      }
      optimizeNames(x, A) {
        const { nodes: N } = this;
        let $ = N.length;
        for (; $--; ) {
          const W = N[$];
          W.optimizeNames(x, A) || (O(x, W.names), N.splice($, 1));
        }
        return N.length > 0 ? this : void 0;
      }
      get names() {
        return this.nodes.reduce((x, A) => ee(x, A.names), {});
      }
    }
    class b extends y {
      render(x) {
        return "{" + x._n + super.render(x) + "}" + x._n;
      }
    }
    class M extends y {
    }
    class c extends b {
    }
    c.kind = "else";
    class p extends b {
      constructor(x, A) {
        super(A), this.condition = x;
      }
      render(x) {
        let A = `if(${this.condition})` + super.render(x);
        return this.else && (A += "else " + this.else.render(x)), A;
      }
      optimizeNodes() {
        super.optimizeNodes();
        const x = this.condition;
        if (x === !0)
          return this.nodes;
        let A = this.else;
        if (A) {
          const N = A.optimizeNodes();
          A = this.else = Array.isArray(N) ? new c(N) : N;
        }
        if (A)
          return x === !1 ? A instanceof p ? A : A.nodes : this.nodes.length ? this : new p(Y(x), A instanceof p ? [A] : A.nodes);
        if (!(x === !1 || !this.nodes.length))
          return this;
      }
      optimizeNames(x, A) {
        var N;
        if (this.else = (N = this.else) === null || N === void 0 ? void 0 : N.optimizeNames(x, A), !!(super.optimizeNames(x, A) || this.else))
          return this.condition = q(this.condition, x, A), this;
      }
      get names() {
        const x = super.names;
        return ve(x, this.condition), this.else && ee(x, this.else.names), x;
      }
    }
    p.kind = "if";
    class h extends b {
    }
    h.kind = "for";
    class v extends h {
      constructor(x) {
        super(), this.iteration = x;
      }
      render(x) {
        return `for(${this.iteration})` + super.render(x);
      }
      optimizeNames(x, A) {
        if (super.optimizeNames(x, A))
          return this.iteration = q(this.iteration, x, A), this;
      }
      get names() {
        return ee(super.names, this.iteration.names);
      }
    }
    class H extends h {
      constructor(x, A, N, $) {
        super(), this.varKind = x, this.name = A, this.from = N, this.to = $;
      }
      render(x) {
        const A = x.es5 ? a.varKinds.var : this.varKind, { name: N, from: $, to: W } = this;
        return `for(${A} ${N}=${$}; ${N}<${W}; ${N}++)` + super.render(x);
      }
      get names() {
        const x = ve(super.names, this.from);
        return ve(x, this.to);
      }
    }
    class w extends h {
      constructor(x, A, N, $) {
        super(), this.loop = x, this.varKind = A, this.name = N, this.iterable = $;
      }
      render(x) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(x);
      }
      optimizeNames(x, A) {
        if (super.optimizeNames(x, A))
          return this.iterable = q(this.iterable, x, A), this;
      }
      get names() {
        return ee(super.names, this.iterable.names);
      }
    }
    class _ extends b {
      constructor(x, A, N) {
        super(), this.name = x, this.args = A, this.async = N;
      }
      render(x) {
        return `${this.async ? "async " : ""}function ${this.name}(${this.args})` + super.render(x);
      }
    }
    _.kind = "func";
    class L extends y {
      render(x) {
        return "return " + super.render(x);
      }
    }
    L.kind = "return";
    class I extends b {
      render(x) {
        let A = "try" + super.render(x);
        return this.catch && (A += this.catch.render(x)), this.finally && (A += this.finally.render(x)), A;
      }
      optimizeNodes() {
        var x, A;
        return super.optimizeNodes(), (x = this.catch) === null || x === void 0 || x.optimizeNodes(), (A = this.finally) === null || A === void 0 || A.optimizeNodes(), this;
      }
      optimizeNames(x, A) {
        var N, $;
        return super.optimizeNames(x, A), (N = this.catch) === null || N === void 0 || N.optimizeNames(x, A), ($ = this.finally) === null || $ === void 0 || $.optimizeNames(x, A), this;
      }
      get names() {
        const x = super.names;
        return this.catch && ee(x, this.catch.names), this.finally && ee(x, this.finally.names), x;
      }
    }
    class F extends b {
      constructor(x) {
        super(), this.error = x;
      }
      render(x) {
        return `catch(${this.error})` + super.render(x);
      }
    }
    F.kind = "catch";
    class B extends b {
      render(x) {
        return "finally" + super.render(x);
      }
    }
    B.kind = "finally";
    class K {
      constructor(x, A = {}) {
        this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = { ...A, _n: A.lines ? `
` : "" }, this._extScope = x, this._scope = new a.Scope({ parent: x }), this._nodes = [new M()];
      }
      toString() {
        return this._root.render(this.opts);
      }
      // returns unique name in the internal scope
      name(x) {
        return this._scope.name(x);
      }
      // reserves unique name in the external scope
      scopeName(x) {
        return this._extScope.name(x);
      }
      // reserves unique name in the external scope and assigns value to it
      scopeValue(x, A) {
        const N = this._extScope.value(x, A);
        return (this._values[N.prefix] || (this._values[N.prefix] = /* @__PURE__ */ new Set())).add(N), N;
      }
      getScopeValue(x, A) {
        return this._extScope.getValue(x, A);
      }
      // return code that assigns values in the external scope to the names that are used internally
      // (same names that were returned by gen.scopeName or gen.scopeValue)
      scopeRefs(x) {
        return this._extScope.scopeRefs(x, this._values);
      }
      scopeCode() {
        return this._extScope.scopeCode(this._values);
      }
      _def(x, A, N, $) {
        const W = this._scope.toName(A);
        return N !== void 0 && $ && (this._constants[W.str] = N), this._leafNode(new s(x, W, N)), W;
      }
      // `const` declaration (`var` in es5 mode)
      const(x, A, N) {
        return this._def(a.varKinds.const, x, A, N);
      }
      // `let` declaration with optional assignment (`var` in es5 mode)
      let(x, A, N) {
        return this._def(a.varKinds.let, x, A, N);
      }
      // `var` declaration with optional assignment
      var(x, A, N) {
        return this._def(a.varKinds.var, x, A, N);
      }
      // assignment code
      assign(x, A, N) {
        return this._leafNode(new i(x, A, N));
      }
      // `+=` code
      add(x, A) {
        return this._leafNode(new l(x, t.operators.ADD, A));
      }
      // appends passed SafeExpr to code or executes Block
      code(x) {
        return typeof x == "function" ? x() : x !== e.nil && this._leafNode(new k(x)), this;
      }
      // returns code for object literal for the passed argument list of key-value pairs
      object(...x) {
        const A = ["{"];
        for (const [N, $] of x)
          A.length > 1 && A.push(","), A.push(N), (N !== $ || this.opts.es5) && (A.push(":"), (0, e.addCodeArg)(A, $));
        return A.push("}"), new e._Code(A);
      }
      // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
      if(x, A, N) {
        if (this._blockNode(new p(x)), A && N)
          this.code(A).else().code(N).endIf();
        else if (A)
          this.code(A).endIf();
        else if (N)
          throw new Error('CodeGen: "else" body without "then" body');
        return this;
      }
      // `else if` clause - invalid without `if` or after `else` clauses
      elseIf(x) {
        return this._elseNode(new p(x));
      }
      // `else` clause - only valid after `if` or `else if` clauses
      else() {
        return this._elseNode(new c());
      }
      // end `if` statement (needed if gen.if was used only with condition)
      endIf() {
        return this._endBlockNode(p, c);
      }
      _for(x, A) {
        return this._blockNode(x), A && this.code(A).endFor(), this;
      }
      // a generic `for` clause (or statement if `forBody` is passed)
      for(x, A) {
        return this._for(new v(x), A);
      }
      // `for` statement for a range of values
      forRange(x, A, N, $, W = this.opts.es5 ? a.varKinds.var : a.varKinds.let) {
        const fe = this._scope.toName(x);
        return this._for(new H(W, fe, A, N), () => $(fe));
      }
      // `for-of` statement (in es5 mode replace with a normal for loop)
      forOf(x, A, N, $ = a.varKinds.const) {
        const W = this._scope.toName(x);
        if (this.opts.es5) {
          const fe = A instanceof e.Name ? A : this.var("_arr", A);
          return this.forRange("_i", 0, (0, e._)`${fe}.length`, (Le) => {
            this.var(W, (0, e._)`${fe}[${Le}]`), N(W);
          });
        }
        return this._for(new w("of", $, W, A), () => N(W));
      }
      // `for-in` statement.
      // With option `ownProperties` replaced with a `for-of` loop for object keys
      forIn(x, A, N, $ = this.opts.es5 ? a.varKinds.var : a.varKinds.const) {
        if (this.opts.ownProperties)
          return this.forOf(x, (0, e._)`Object.keys(${A})`, N);
        const W = this._scope.toName(x);
        return this._for(new w("in", $, W, A), () => N(W));
      }
      // end `for` loop
      endFor() {
        return this._endBlockNode(h);
      }
      // `label` statement
      label(x) {
        return this._leafNode(new f(x));
      }
      // `break` statement
      break(x) {
        return this._leafNode(new u(x));
      }
      // `return` statement
      return(x) {
        const A = new L();
        if (this._blockNode(A), this.code(x), A.nodes.length !== 1)
          throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(L);
      }
      // `try` statement
      try(x, A, N) {
        if (!A && !N)
          throw new Error('CodeGen: "try" without "catch" and "finally"');
        const $ = new I();
        if (this._blockNode($), this.code(x), A) {
          const W = this.name("e");
          this._currNode = $.catch = new F(W), A(W);
        }
        return N && (this._currNode = $.finally = new B(), this.code(N)), this._endBlockNode(F, B);
      }
      // `throw` statement
      throw(x) {
        return this._leafNode(new d(x));
      }
      // start self-balancing block
      block(x, A) {
        return this._blockStarts.push(this._nodes.length), x && this.code(x).endBlock(A), this;
      }
      // end the current self-balancing block
      endBlock(x) {
        const A = this._blockStarts.pop();
        if (A === void 0)
          throw new Error("CodeGen: not in self-balancing block");
        const N = this._nodes.length - A;
        if (N < 0 || x !== void 0 && N !== x)
          throw new Error(`CodeGen: wrong number of nodes: ${N} vs ${x} expected`);
        return this._nodes.length = A, this;
      }
      // `function` heading (or definition if funcBody is passed)
      func(x, A = e.nil, N, $) {
        return this._blockNode(new _(x, A, N)), $ && this.code($).endFunc(), this;
      }
      // end function definition
      endFunc() {
        return this._endBlockNode(_);
      }
      optimize(x = 1) {
        for (; x-- > 0; )
          this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
      }
      _leafNode(x) {
        return this._currNode.nodes.push(x), this;
      }
      _blockNode(x) {
        this._currNode.nodes.push(x), this._nodes.push(x);
      }
      _endBlockNode(x, A) {
        const N = this._currNode;
        if (N instanceof x || A && N instanceof A)
          return this._nodes.pop(), this;
        throw new Error(`CodeGen: not in block "${A ? `${x.kind}/${A.kind}` : x.kind}"`);
      }
      _elseNode(x) {
        const A = this._currNode;
        if (!(A instanceof p))
          throw new Error('CodeGen: "else" without "if"');
        return this._currNode = A.else = x, this;
      }
      get _root() {
        return this._nodes[0];
      }
      get _currNode() {
        const x = this._nodes;
        return x[x.length - 1];
      }
      set _currNode(x) {
        const A = this._nodes;
        A[A.length - 1] = x;
      }
    }
    t.CodeGen = K;
    function ee(D, x) {
      for (const A in x)
        D[A] = (D[A] || 0) + (x[A] || 0);
      return D;
    }
    function ve(D, x) {
      return x instanceof e._CodeOrName ? ee(D, x.names) : D;
    }
    function q(D, x, A) {
      if (D instanceof e.Name)
        return N(D);
      if (!$(D))
        return D;
      return new e._Code(D._items.reduce((W, fe) => (fe instanceof e.Name && (fe = N(fe)), fe instanceof e._Code ? W.push(...fe._items) : W.push(fe), W), []));
      function N(W) {
        const fe = A[W.str];
        return fe === void 0 || x[W.str] !== 1 ? W : (delete x[W.str], fe);
      }
      function $(W) {
        return W instanceof e._Code && W._items.some((fe) => fe instanceof e.Name && x[fe.str] === 1 && A[fe.str] !== void 0);
      }
    }
    function O(D, x) {
      for (const A in x)
        D[A] = (D[A] || 0) - (x[A] || 0);
    }
    function Y(D) {
      return typeof D == "boolean" || typeof D == "number" || D === null ? !D : (0, e._)`!${Z(D)}`;
    }
    t.not = Y;
    const U = T(t.operators.AND);
    function ne(...D) {
      return D.reduce(U);
    }
    t.and = ne;
    const te = T(t.operators.OR);
    function G(...D) {
      return D.reduce(te);
    }
    t.or = G;
    function T(D) {
      return (x, A) => x === e.nil ? A : A === e.nil ? x : (0, e._)`${Z(x)} ${D} ${Z(A)}`;
    }
    function Z(D) {
      return D instanceof e.Name ? D : (0, e._)`(${D})`;
    }
  })(ms)), ms;
}
var Te = {}, bs;
function We() {
  if (bs) return Te;
  bs = 1, Object.defineProperty(Te, "__esModule", { value: !0 }), Te.checkStrictMode = Te.getErrorPath = Te.Type = Te.useFunc = Te.setEvaluated = Te.evaluatedPropsToName = Te.mergeEvaluated = Te.eachItem = Te.unescapeJsonPointer = Te.escapeJsonPointer = Te.escapeFragment = Te.unescapeFragment = Te.schemaRefOrVal = Te.schemaHasRulesButRef = Te.schemaHasRules = Te.checkUnknownRules = Te.alwaysValidSchema = Te.toHash = void 0;
  const t = Fe(), e = pn();
  function a(w) {
    const _ = {};
    for (const L of w)
      _[L] = !0;
    return _;
  }
  Te.toHash = a;
  function o(w, _) {
    return typeof _ == "boolean" ? _ : Object.keys(_).length === 0 ? !0 : (n(w, _), !r(_, w.self.RULES.all));
  }
  Te.alwaysValidSchema = o;
  function n(w, _ = w.schema) {
    const { opts: L, self: I } = w;
    if (!L.strictSchema || typeof _ == "boolean")
      return;
    const F = I.RULES.keywords;
    for (const B in _)
      F[B] || H(w, `unknown keyword: "${B}"`);
  }
  Te.checkUnknownRules = n;
  function r(w, _) {
    if (typeof w == "boolean")
      return !w;
    for (const L in w)
      if (_[L])
        return !0;
    return !1;
  }
  Te.schemaHasRules = r;
  function s(w, _) {
    if (typeof w == "boolean")
      return !w;
    for (const L in w)
      if (L !== "$ref" && _.all[L])
        return !0;
    return !1;
  }
  Te.schemaHasRulesButRef = s;
  function i({ topSchemaRef: w, schemaPath: _ }, L, I, F) {
    if (!F) {
      if (typeof L == "number" || typeof L == "boolean")
        return L;
      if (typeof L == "string")
        return (0, t._)`${L}`;
    }
    return (0, t._)`${w}${_}${(0, t.getProperty)(I)}`;
  }
  Te.schemaRefOrVal = i;
  function l(w) {
    return d(decodeURIComponent(w));
  }
  Te.unescapeFragment = l;
  function f(w) {
    return encodeURIComponent(u(w));
  }
  Te.escapeFragment = f;
  function u(w) {
    return typeof w == "number" ? `${w}` : w.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  Te.escapeJsonPointer = u;
  function d(w) {
    return w.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  Te.unescapeJsonPointer = d;
  function k(w, _) {
    if (Array.isArray(w))
      for (const L of w)
        _(L);
    else
      _(w);
  }
  Te.eachItem = k;
  function y({ mergeNames: w, mergeToName: _, mergeValues: L, resultToName: I }) {
    return (F, B, K, ee) => {
      const ve = K === void 0 ? B : K instanceof t.Name ? (B instanceof t.Name ? w(F, B, K) : _(F, B, K), K) : B instanceof t.Name ? (_(F, K, B), B) : L(B, K);
      return ee === t.Name && !(ve instanceof t.Name) ? I(F, ve) : ve;
    };
  }
  Te.mergeEvaluated = {
    props: y({
      mergeNames: (w, _, L) => w.if((0, t._)`${L} !== true && ${_} !== undefined`, () => {
        w.if((0, t._)`${_} === true`, () => w.assign(L, !0), () => w.assign(L, (0, t._)`${L} || {}`).code((0, t._)`Object.assign(${L}, ${_})`));
      }),
      mergeToName: (w, _, L) => w.if((0, t._)`${L} !== true`, () => {
        _ === !0 ? w.assign(L, !0) : (w.assign(L, (0, t._)`${L} || {}`), M(w, L, _));
      }),
      mergeValues: (w, _) => w === !0 ? !0 : { ...w, ..._ },
      resultToName: b
    }),
    items: y({
      mergeNames: (w, _, L) => w.if((0, t._)`${L} !== true && ${_} !== undefined`, () => w.assign(L, (0, t._)`${_} === true ? true : ${L} > ${_} ? ${L} : ${_}`)),
      mergeToName: (w, _, L) => w.if((0, t._)`${L} !== true`, () => w.assign(L, _ === !0 ? !0 : (0, t._)`${L} > ${_} ? ${L} : ${_}`)),
      mergeValues: (w, _) => w === !0 ? !0 : Math.max(w, _),
      resultToName: (w, _) => w.var("items", _)
    })
  };
  function b(w, _) {
    if (_ === !0)
      return w.var("props", !0);
    const L = w.var("props", (0, t._)`{}`);
    return _ !== void 0 && M(w, L, _), L;
  }
  Te.evaluatedPropsToName = b;
  function M(w, _, L) {
    Object.keys(L).forEach((I) => w.assign((0, t._)`${_}${(0, t.getProperty)(I)}`, !0));
  }
  Te.setEvaluated = M;
  const c = {};
  function p(w, _) {
    return w.scopeValue("func", {
      ref: _,
      code: c[_.code] || (c[_.code] = new e._Code(_.code))
    });
  }
  Te.useFunc = p;
  var h;
  (function(w) {
    w[w.Num = 0] = "Num", w[w.Str = 1] = "Str";
  })(h || (Te.Type = h = {}));
  function v(w, _, L) {
    if (w instanceof t.Name) {
      const I = _ === h.Num;
      return L ? I ? (0, t._)`"[" + ${w} + "]"` : (0, t._)`"['" + ${w} + "']"` : I ? (0, t._)`"/" + ${w}` : (0, t._)`"/" + ${w}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
    }
    return L ? (0, t.getProperty)(w).toString() : "/" + u(w);
  }
  Te.getErrorPath = v;
  function H(w, _, L = w.opts.strictSchema) {
    if (L) {
      if (_ = `strict mode: ${_}`, L === !0)
        throw new Error(_);
      w.self.logger.warn(_);
    }
  }
  return Te.checkStrictMode = H, Te;
}
var ko = {}, ks;
function Zt() {
  if (ks) return ko;
  ks = 1, Object.defineProperty(ko, "__esModule", { value: !0 });
  const t = Fe(), e = {
    // validation function arguments
    data: new t.Name("data"),
    // data passed to validation function
    // args passed from referencing schema
    valCxt: new t.Name("valCxt"),
    // validation/data context - should not be used directly, it is destructured to the names below
    instancePath: new t.Name("instancePath"),
    parentData: new t.Name("parentData"),
    parentDataProperty: new t.Name("parentDataProperty"),
    rootData: new t.Name("rootData"),
    // root data - same as the data passed to the first/top validation function
    dynamicAnchors: new t.Name("dynamicAnchors"),
    // used to support recursiveRef and dynamicRef
    // function scoped variables
    vErrors: new t.Name("vErrors"),
    // null or array of validation errors
    errors: new t.Name("errors"),
    // counter of validation errors
    this: new t.Name("this"),
    // "globals"
    self: new t.Name("self"),
    scope: new t.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new t.Name("json"),
    jsonPos: new t.Name("jsonPos"),
    jsonLen: new t.Name("jsonLen"),
    jsonPart: new t.Name("jsonPart")
  };
  return ko.default = e, ko;
}
var Cs;
function xn() {
  return Cs || (Cs = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.extendErrors = t.resetErrorsCount = t.reportExtraError = t.reportError = t.keyword$DataError = t.keywordError = void 0;
    const e = Fe(), a = We(), o = Zt();
    t.keywordError = {
      message: ({ keyword: c }) => (0, e.str)`must pass "${c}" keyword validation`
    }, t.keyword$DataError = {
      message: ({ keyword: c, schemaType: p }) => p ? (0, e.str)`"${c}" keyword must be ${p} ($data)` : (0, e.str)`"${c}" keyword is invalid ($data)`
    };
    function n(c, p = t.keywordError, h, v) {
      const { it: H } = c, { gen: w, compositeRule: _, allErrors: L } = H, I = d(c, p, h);
      v ?? (_ || L) ? l(w, I) : f(H, (0, e._)`[${I}]`);
    }
    t.reportError = n;
    function r(c, p = t.keywordError, h) {
      const { it: v } = c, { gen: H, compositeRule: w, allErrors: _ } = v, L = d(c, p, h);
      l(H, L), w || _ || f(v, o.default.vErrors);
    }
    t.reportExtraError = r;
    function s(c, p) {
      c.assign(o.default.errors, p), c.if((0, e._)`${o.default.vErrors} !== null`, () => c.if(p, () => c.assign((0, e._)`${o.default.vErrors}.length`, p), () => c.assign(o.default.vErrors, null)));
    }
    t.resetErrorsCount = s;
    function i({ gen: c, keyword: p, schemaValue: h, data: v, errsCount: H, it: w }) {
      if (H === void 0)
        throw new Error("ajv implementation error");
      const _ = c.name("err");
      c.forRange("i", H, o.default.errors, (L) => {
        c.const(_, (0, e._)`${o.default.vErrors}[${L}]`), c.if((0, e._)`${_}.instancePath === undefined`, () => c.assign((0, e._)`${_}.instancePath`, (0, e.strConcat)(o.default.instancePath, w.errorPath))), c.assign((0, e._)`${_}.schemaPath`, (0, e.str)`${w.errSchemaPath}/${p}`), w.opts.verbose && (c.assign((0, e._)`${_}.schema`, h), c.assign((0, e._)`${_}.data`, v));
      });
    }
    t.extendErrors = i;
    function l(c, p) {
      const h = c.const("err", p);
      c.if((0, e._)`${o.default.vErrors} === null`, () => c.assign(o.default.vErrors, (0, e._)`[${h}]`), (0, e._)`${o.default.vErrors}.push(${h})`), c.code((0, e._)`${o.default.errors}++`);
    }
    function f(c, p) {
      const { gen: h, validateName: v, schemaEnv: H } = c;
      H.$async ? h.throw((0, e._)`new ${c.ValidationError}(${p})`) : (h.assign((0, e._)`${v}.errors`, p), h.return(!1));
    }
    const u = {
      keyword: new e.Name("keyword"),
      schemaPath: new e.Name("schemaPath"),
      // also used in JTD errors
      params: new e.Name("params"),
      propertyName: new e.Name("propertyName"),
      message: new e.Name("message"),
      schema: new e.Name("schema"),
      parentSchema: new e.Name("parentSchema")
    };
    function d(c, p, h) {
      const { createErrors: v } = c.it;
      return v === !1 ? (0, e._)`{}` : k(c, p, h);
    }
    function k(c, p, h = {}) {
      const { gen: v, it: H } = c, w = [
        y(H, h),
        b(c, h)
      ];
      return M(c, p, w), v.object(...w);
    }
    function y({ errorPath: c }, { instancePath: p }) {
      const h = p ? (0, e.str)`${c}${(0, a.getErrorPath)(p, a.Type.Str)}` : c;
      return [o.default.instancePath, (0, e.strConcat)(o.default.instancePath, h)];
    }
    function b({ keyword: c, it: { errSchemaPath: p } }, { schemaPath: h, parentSchema: v }) {
      let H = v ? p : (0, e.str)`${p}/${c}`;
      return h && (H = (0, e.str)`${H}${(0, a.getErrorPath)(h, a.Type.Str)}`), [u.schemaPath, H];
    }
    function M(c, { params: p, message: h }, v) {
      const { keyword: H, data: w, schemaValue: _, it: L } = c, { opts: I, propertyName: F, topSchemaRef: B, schemaPath: K } = L;
      v.push([u.keyword, H], [u.params, typeof p == "function" ? p(c) : p || (0, e._)`{}`]), I.messages && v.push([u.message, typeof h == "function" ? h(c) : h]), I.verbose && v.push([u.schema, _], [u.parentSchema, (0, e._)`${B}${K}`], [o.default.data, w]), F && v.push([u.propertyName, F]);
    }
  })(ds)), ds;
}
var ws;
function MC() {
  if (ws) return Ut;
  ws = 1, Object.defineProperty(Ut, "__esModule", { value: !0 }), Ut.boolOrEmptySchema = Ut.topBoolOrEmptySchema = void 0;
  const t = xn(), e = Fe(), a = Zt(), o = {
    message: "boolean schema is false"
  };
  function n(i) {
    const { gen: l, schema: f, validateName: u } = i;
    f === !1 ? s(i, !1) : typeof f == "object" && f.$async === !0 ? l.return(a.default.data) : (l.assign((0, e._)`${u}.errors`, null), l.return(!0));
  }
  Ut.topBoolOrEmptySchema = n;
  function r(i, l) {
    const { gen: f, schema: u } = i;
    u === !1 ? (f.var(l, !1), s(i)) : f.var(l, !0);
  }
  Ut.boolOrEmptySchema = r;
  function s(i, l) {
    const { gen: f, data: u } = i, d = {
      gen: f,
      keyword: "false schema",
      data: u,
      schema: !1,
      schemaCode: !1,
      schemaValue: !1,
      params: {},
      it: i
    };
    (0, t.reportError)(d, o, void 0, l);
  }
  return Ut;
}
var _1 = {}, Yt = {}, _s;
function ul() {
  if (_s) return Yt;
  _s = 1, Object.defineProperty(Yt, "__esModule", { value: !0 }), Yt.getRules = Yt.isJSONType = void 0;
  const t = ["string", "number", "integer", "boolean", "null", "object", "array"], e = new Set(t);
  function a(n) {
    return typeof n == "string" && e.has(n);
  }
  Yt.isJSONType = a;
  function o() {
    const n = {
      number: { type: "number", rules: [] },
      string: { type: "string", rules: [] },
      array: { type: "array", rules: [] },
      object: { type: "object", rules: [] }
    };
    return {
      types: { ...n, integer: !0, boolean: !0, null: !0 },
      rules: [{ rules: [] }, n.number, n.string, n.array, n.object],
      post: { rules: [] },
      all: {},
      keywords: {}
    };
  }
  return Yt.getRules = o, Yt;
}
var gt = {}, Hs;
function cl() {
  if (Hs) return gt;
  Hs = 1, Object.defineProperty(gt, "__esModule", { value: !0 }), gt.shouldUseRule = gt.shouldUseGroup = gt.schemaHasRulesForType = void 0;
  function t({ schema: o, self: n }, r) {
    const s = n.RULES.types[r];
    return s && s !== !0 && e(o, s);
  }
  gt.schemaHasRulesForType = t;
  function e(o, n) {
    return n.rules.some((r) => a(o, r));
  }
  gt.shouldUseGroup = e;
  function a(o, n) {
    var r;
    return o[n.keyword] !== void 0 || ((r = n.definition.implements) === null || r === void 0 ? void 0 : r.some((s) => o[s] !== void 0));
  }
  return gt.shouldUseRule = a, gt;
}
var js;
function fn() {
  if (js) return _1;
  js = 1, Object.defineProperty(_1, "__esModule", { value: !0 }), _1.reportTypeError = _1.checkDataTypes = _1.checkDataType = _1.coerceAndCheckDataType = _1.getJSONTypes = _1.getSchemaTypes = _1.DataType = void 0;
  const t = ul(), e = cl(), a = xn(), o = Fe(), n = We();
  var r;
  (function(h) {
    h[h.Correct = 0] = "Correct", h[h.Wrong = 1] = "Wrong";
  })(r || (_1.DataType = r = {}));
  function s(h) {
    const v = i(h.type);
    if (v.includes("null")) {
      if (h.nullable === !1)
        throw new Error("type: null contradicts nullable: false");
    } else {
      if (!v.length && h.nullable !== void 0)
        throw new Error('"nullable" cannot be used without "type"');
      h.nullable === !0 && v.push("null");
    }
    return v;
  }
  _1.getSchemaTypes = s;
  function i(h) {
    const v = Array.isArray(h) ? h : h ? [h] : [];
    if (v.every(t.isJSONType))
      return v;
    throw new Error("type must be JSONType or JSONType[]: " + v.join(","));
  }
  _1.getJSONTypes = i;
  function l(h, v) {
    const { gen: H, data: w, opts: _ } = h, L = u(v, _.coerceTypes), I = v.length > 0 && !(L.length === 0 && v.length === 1 && (0, e.schemaHasRulesForType)(h, v[0]));
    if (I) {
      const F = b(v, w, _.strictNumbers, r.Wrong);
      H.if(F, () => {
        L.length ? d(h, v, L) : c(h);
      });
    }
    return I;
  }
  _1.coerceAndCheckDataType = l;
  const f = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
  function u(h, v) {
    return v ? h.filter((H) => f.has(H) || v === "array" && H === "array") : [];
  }
  function d(h, v, H) {
    const { gen: w, data: _, opts: L } = h, I = w.let("dataType", (0, o._)`typeof ${_}`), F = w.let("coerced", (0, o._)`undefined`);
    L.coerceTypes === "array" && w.if((0, o._)`${I} == 'object' && Array.isArray(${_}) && ${_}.length == 1`, () => w.assign(_, (0, o._)`${_}[0]`).assign(I, (0, o._)`typeof ${_}`).if(b(v, _, L.strictNumbers), () => w.assign(F, _))), w.if((0, o._)`${F} !== undefined`);
    for (const K of H)
      (f.has(K) || K === "array" && L.coerceTypes === "array") && B(K);
    w.else(), c(h), w.endIf(), w.if((0, o._)`${F} !== undefined`, () => {
      w.assign(_, F), k(h, F);
    });
    function B(K) {
      switch (K) {
        case "string":
          w.elseIf((0, o._)`${I} == "number" || ${I} == "boolean"`).assign(F, (0, o._)`"" + ${_}`).elseIf((0, o._)`${_} === null`).assign(F, (0, o._)`""`);
          return;
        case "number":
          w.elseIf((0, o._)`${I} == "boolean" || ${_} === null
              || (${I} == "string" && ${_} && ${_} == +${_})`).assign(F, (0, o._)`+${_}`);
          return;
        case "integer":
          w.elseIf((0, o._)`${I} === "boolean" || ${_} === null
              || (${I} === "string" && ${_} && ${_} == +${_} && !(${_} % 1))`).assign(F, (0, o._)`+${_}`);
          return;
        case "boolean":
          w.elseIf((0, o._)`${_} === "false" || ${_} === 0 || ${_} === null`).assign(F, !1).elseIf((0, o._)`${_} === "true" || ${_} === 1`).assign(F, !0);
          return;
        case "null":
          w.elseIf((0, o._)`${_} === "" || ${_} === 0 || ${_} === false`), w.assign(F, null);
          return;
        case "array":
          w.elseIf((0, o._)`${I} === "string" || ${I} === "number"
              || ${I} === "boolean" || ${_} === null`).assign(F, (0, o._)`[${_}]`);
      }
    }
  }
  function k({ gen: h, parentData: v, parentDataProperty: H }, w) {
    h.if((0, o._)`${v} !== undefined`, () => h.assign((0, o._)`${v}[${H}]`, w));
  }
  function y(h, v, H, w = r.Correct) {
    const _ = w === r.Correct ? o.operators.EQ : o.operators.NEQ;
    let L;
    switch (h) {
      case "null":
        return (0, o._)`${v} ${_} null`;
      case "array":
        L = (0, o._)`Array.isArray(${v})`;
        break;
      case "object":
        L = (0, o._)`${v} && typeof ${v} == "object" && !Array.isArray(${v})`;
        break;
      case "integer":
        L = I((0, o._)`!(${v} % 1) && !isNaN(${v})`);
        break;
      case "number":
        L = I();
        break;
      default:
        return (0, o._)`typeof ${v} ${_} ${h}`;
    }
    return w === r.Correct ? L : (0, o.not)(L);
    function I(F = o.nil) {
      return (0, o.and)((0, o._)`typeof ${v} == "number"`, F, H ? (0, o._)`isFinite(${v})` : o.nil);
    }
  }
  _1.checkDataType = y;
  function b(h, v, H, w) {
    if (h.length === 1)
      return y(h[0], v, H, w);
    let _;
    const L = (0, n.toHash)(h);
    if (L.array && L.object) {
      const I = (0, o._)`typeof ${v} != "object"`;
      _ = L.null ? I : (0, o._)`!${v} || ${I}`, delete L.null, delete L.array, delete L.object;
    } else
      _ = o.nil;
    L.number && delete L.integer;
    for (const I in L)
      _ = (0, o.and)(_, y(I, v, H, w));
    return _;
  }
  _1.checkDataTypes = b;
  const M = {
    message: ({ schema: h }) => `must be ${h}`,
    params: ({ schema: h, schemaValue: v }) => typeof h == "string" ? (0, o._)`{type: ${h}}` : (0, o._)`{type: ${v}}`
  };
  function c(h) {
    const v = p(h);
    (0, a.reportError)(v, M);
  }
  _1.reportTypeError = c;
  function p(h) {
    const { gen: v, data: H, schema: w } = h, _ = (0, n.schemaRefOrVal)(h, w, "type");
    return {
      gen: v,
      keyword: "type",
      data: H,
      schema: w.type,
      schemaCode: _,
      schemaValue: _,
      parentSchema: w,
      params: {},
      it: h
    };
  }
  return _1;
}
var Ua = {}, Ls;
function VC() {
  if (Ls) return Ua;
  Ls = 1, Object.defineProperty(Ua, "__esModule", { value: !0 }), Ua.assignDefaults = void 0;
  const t = Fe(), e = We();
  function a(n, r) {
    const { properties: s, items: i } = n.schema;
    if (r === "object" && s)
      for (const l in s)
        o(n, l, s[l].default);
    else r === "array" && Array.isArray(i) && i.forEach((l, f) => o(n, f, l.default));
  }
  Ua.assignDefaults = a;
  function o(n, r, s) {
    const { gen: i, compositeRule: l, data: f, opts: u } = n;
    if (s === void 0)
      return;
    const d = (0, t._)`${f}${(0, t.getProperty)(r)}`;
    if (l) {
      (0, e.checkStrictMode)(n, `default is ignored for: ${d}`);
      return;
    }
    let k = (0, t._)`${d} === undefined`;
    u.useDefaults === "empty" && (k = (0, t._)`${k} || ${d} === null || ${d} === ""`), i.if(k, (0, t._)`${d} = ${(0, t.stringify)(s)}`);
  }
  return Ua;
}
var W1 = {}, Xe = {}, xs;
function nt() {
  if (xs) return Xe;
  xs = 1, Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.validateUnion = Xe.validateArray = Xe.usePattern = Xe.callValidateCode = Xe.schemaProperties = Xe.allSchemaProperties = Xe.noPropertyInData = Xe.propertyInData = Xe.isOwnProperty = Xe.hasPropFunc = Xe.reportMissingProp = Xe.checkMissingProp = Xe.checkReportMissingProp = void 0;
  const t = Fe(), e = We(), a = Zt(), o = We();
  function n(h, v) {
    const { gen: H, data: w, it: _ } = h;
    H.if(u(H, w, v, _.opts.ownProperties), () => {
      h.setParams({ missingProperty: (0, t._)`${v}` }, !0), h.error();
    });
  }
  Xe.checkReportMissingProp = n;
  function r({ gen: h, data: v, it: { opts: H } }, w, _) {
    return (0, t.or)(...w.map((L) => (0, t.and)(u(h, v, L, H.ownProperties), (0, t._)`${_} = ${L}`)));
  }
  Xe.checkMissingProp = r;
  function s(h, v) {
    h.setParams({ missingProperty: v }, !0), h.error();
  }
  Xe.reportMissingProp = s;
  function i(h) {
    return h.scopeValue("func", {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      ref: Object.prototype.hasOwnProperty,
      code: (0, t._)`Object.prototype.hasOwnProperty`
    });
  }
  Xe.hasPropFunc = i;
  function l(h, v, H) {
    return (0, t._)`${i(h)}.call(${v}, ${H})`;
  }
  Xe.isOwnProperty = l;
  function f(h, v, H, w) {
    const _ = (0, t._)`${v}${(0, t.getProperty)(H)} !== undefined`;
    return w ? (0, t._)`${_} && ${l(h, v, H)}` : _;
  }
  Xe.propertyInData = f;
  function u(h, v, H, w) {
    const _ = (0, t._)`${v}${(0, t.getProperty)(H)} === undefined`;
    return w ? (0, t.or)(_, (0, t.not)(l(h, v, H))) : _;
  }
  Xe.noPropertyInData = u;
  function d(h) {
    return h ? Object.keys(h).filter((v) => v !== "__proto__") : [];
  }
  Xe.allSchemaProperties = d;
  function k(h, v) {
    return d(v).filter((H) => !(0, e.alwaysValidSchema)(h, v[H]));
  }
  Xe.schemaProperties = k;
  function y({ schemaCode: h, data: v, it: { gen: H, topSchemaRef: w, schemaPath: _, errorPath: L }, it: I }, F, B, K) {
    const ee = K ? (0, t._)`${h}, ${v}, ${w}${_}` : v, ve = [
      [a.default.instancePath, (0, t.strConcat)(a.default.instancePath, L)],
      [a.default.parentData, I.parentData],
      [a.default.parentDataProperty, I.parentDataProperty],
      [a.default.rootData, a.default.rootData]
    ];
    I.opts.dynamicRef && ve.push([a.default.dynamicAnchors, a.default.dynamicAnchors]);
    const q = (0, t._)`${ee}, ${H.object(...ve)}`;
    return B !== t.nil ? (0, t._)`${F}.call(${B}, ${q})` : (0, t._)`${F}(${q})`;
  }
  Xe.callValidateCode = y;
  const b = (0, t._)`new RegExp`;
  function M({ gen: h, it: { opts: v } }, H) {
    const w = v.unicodeRegExp ? "u" : "", { regExp: _ } = v.code, L = _(H, w);
    return h.scopeValue("pattern", {
      key: L.toString(),
      ref: L,
      code: (0, t._)`${_.code === "new RegExp" ? b : (0, o.useFunc)(h, _)}(${H}, ${w})`
    });
  }
  Xe.usePattern = M;
  function c(h) {
    const { gen: v, data: H, keyword: w, it: _ } = h, L = v.name("valid");
    if (_.allErrors) {
      const F = v.let("valid", !0);
      return I(() => v.assign(F, !1)), F;
    }
    return v.var(L, !0), I(() => v.break()), L;
    function I(F) {
      const B = v.const("len", (0, t._)`${H}.length`);
      v.forRange("i", 0, B, (K) => {
        h.subschema({
          keyword: w,
          dataProp: K,
          dataPropType: e.Type.Num
        }, L), v.if((0, t.not)(L), F);
      });
    }
  }
  Xe.validateArray = c;
  function p(h) {
    const { gen: v, schema: H, keyword: w, it: _ } = h;
    if (!Array.isArray(H))
      throw new Error("ajv implementation error");
    if (H.some((F) => (0, e.alwaysValidSchema)(_, F)) && !_.opts.unevaluated)
      return;
    const L = v.let("valid", !1), I = v.name("_valid");
    v.block(() => H.forEach((F, B) => {
      const K = h.subschema({
        keyword: w,
        schemaProp: B,
        compositeRule: !0
      }, I);
      v.assign(L, (0, t._)`${L} || ${I}`), h.mergeValidEvaluated(K, I) || v.if((0, t.not)(L));
    })), h.result(L, () => h.reset(), () => h.error(!0));
  }
  return Xe.validateUnion = p, Xe;
}
var $s;
function SC() {
  if ($s) return W1;
  $s = 1, Object.defineProperty(W1, "__esModule", { value: !0 }), W1.validateKeywordUsage = W1.validSchemaType = W1.funcKeywordCode = W1.macroKeywordCode = void 0;
  const t = Fe(), e = Zt(), a = nt(), o = xn();
  function n(k, y) {
    const { gen: b, keyword: M, schema: c, parentSchema: p, it: h } = k, v = y.macro.call(h.self, c, p, h), H = f(b, M, v);
    h.opts.validateSchema !== !1 && h.self.validateSchema(v, !0);
    const w = b.name("valid");
    k.subschema({
      schema: v,
      schemaPath: t.nil,
      errSchemaPath: `${h.errSchemaPath}/${M}`,
      topSchemaRef: H,
      compositeRule: !0
    }, w), k.pass(w, () => k.error(!0));
  }
  W1.macroKeywordCode = n;
  function r(k, y) {
    var b;
    const { gen: M, keyword: c, schema: p, parentSchema: h, $data: v, it: H } = k;
    l(H, y);
    const w = !v && y.compile ? y.compile.call(H.self, p, h, H) : y.validate, _ = f(M, c, w), L = M.let("valid");
    k.block$data(L, I), k.ok((b = y.valid) !== null && b !== void 0 ? b : L);
    function I() {
      if (y.errors === !1)
        K(), y.modifying && s(k), ee(() => k.error());
      else {
        const ve = y.async ? F() : B();
        y.modifying && s(k), ee(() => i(k, ve));
      }
    }
    function F() {
      const ve = M.let("ruleErrs", null);
      return M.try(() => K((0, t._)`await `), (q) => M.assign(L, !1).if((0, t._)`${q} instanceof ${H.ValidationError}`, () => M.assign(ve, (0, t._)`${q}.errors`), () => M.throw(q))), ve;
    }
    function B() {
      const ve = (0, t._)`${_}.errors`;
      return M.assign(ve, null), K(t.nil), ve;
    }
    function K(ve = y.async ? (0, t._)`await ` : t.nil) {
      const q = H.opts.passContext ? e.default.this : e.default.self, O = !("compile" in y && !v || y.schema === !1);
      M.assign(L, (0, t._)`${ve}${(0, a.callValidateCode)(k, _, q, O)}`, y.modifying);
    }
    function ee(ve) {
      var q;
      M.if((0, t.not)((q = y.valid) !== null && q !== void 0 ? q : L), ve);
    }
  }
  W1.funcKeywordCode = r;
  function s(k) {
    const { gen: y, data: b, it: M } = k;
    y.if(M.parentData, () => y.assign(b, (0, t._)`${M.parentData}[${M.parentDataProperty}]`));
  }
  function i(k, y) {
    const { gen: b } = k;
    b.if((0, t._)`Array.isArray(${y})`, () => {
      b.assign(e.default.vErrors, (0, t._)`${e.default.vErrors} === null ? ${y} : ${e.default.vErrors}.concat(${y})`).assign(e.default.errors, (0, t._)`${e.default.vErrors}.length`), (0, o.extendErrors)(k);
    }, () => k.error());
  }
  function l({ schemaEnv: k }, y) {
    if (y.async && !k.$async)
      throw new Error("async keyword in sync schema");
  }
  function f(k, y, b) {
    if (b === void 0)
      throw new Error(`keyword "${y}" failed to compile`);
    return k.scopeValue("keyword", typeof b == "function" ? { ref: b } : { ref: b, code: (0, t.stringify)(b) });
  }
  function u(k, y, b = !1) {
    return !y.length || y.some((M) => M === "array" ? Array.isArray(k) : M === "object" ? k && typeof k == "object" && !Array.isArray(k) : typeof k == M || b && typeof k > "u");
  }
  W1.validSchemaType = u;
  function d({ schema: k, opts: y, self: b, errSchemaPath: M }, c, p) {
    if (Array.isArray(c.keyword) ? !c.keyword.includes(p) : c.keyword !== p)
      throw new Error("ajv implementation error");
    const h = c.dependencies;
    if (h?.some((v) => !Object.prototype.hasOwnProperty.call(k, v)))
      throw new Error(`parent schema must have dependencies of ${p}: ${h.join(",")}`);
    if (c.validateSchema && !c.validateSchema(k[p])) {
      const v = `keyword "${p}" value is invalid at path "${M}": ` + b.errorsText(c.validateSchema.errors);
      if (y.validateSchema === "log")
        b.logger.error(v);
      else
        throw new Error(v);
    }
  }
  return W1.validateKeywordUsage = d, W1;
}
var yt = {}, Ms;
function AC() {
  if (Ms) return yt;
  Ms = 1, Object.defineProperty(yt, "__esModule", { value: !0 }), yt.extendSubschemaMode = yt.extendSubschemaData = yt.getSubschema = void 0;
  const t = Fe(), e = We();
  function a(r, { keyword: s, schemaProp: i, schema: l, schemaPath: f, errSchemaPath: u, topSchemaRef: d }) {
    if (s !== void 0 && l !== void 0)
      throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (s !== void 0) {
      const k = r.schema[s];
      return i === void 0 ? {
        schema: k,
        schemaPath: (0, t._)`${r.schemaPath}${(0, t.getProperty)(s)}`,
        errSchemaPath: `${r.errSchemaPath}/${s}`
      } : {
        schema: k[i],
        schemaPath: (0, t._)`${r.schemaPath}${(0, t.getProperty)(s)}${(0, t.getProperty)(i)}`,
        errSchemaPath: `${r.errSchemaPath}/${s}/${(0, e.escapeFragment)(i)}`
      };
    }
    if (l !== void 0) {
      if (f === void 0 || u === void 0 || d === void 0)
        throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
      return {
        schema: l,
        schemaPath: f,
        topSchemaRef: d,
        errSchemaPath: u
      };
    }
    throw new Error('either "keyword" or "schema" must be passed');
  }
  yt.getSubschema = a;
  function o(r, s, { dataProp: i, dataPropType: l, data: f, dataTypes: u, propertyName: d }) {
    if (f !== void 0 && i !== void 0)
      throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: k } = s;
    if (i !== void 0) {
      const { errorPath: b, dataPathArr: M, opts: c } = s, p = k.let("data", (0, t._)`${s.data}${(0, t.getProperty)(i)}`, !0);
      y(p), r.errorPath = (0, t.str)`${b}${(0, e.getErrorPath)(i, l, c.jsPropertySyntax)}`, r.parentDataProperty = (0, t._)`${i}`, r.dataPathArr = [...M, r.parentDataProperty];
    }
    if (f !== void 0) {
      const b = f instanceof t.Name ? f : k.let("data", f, !0);
      y(b), d !== void 0 && (r.propertyName = d);
    }
    u && (r.dataTypes = u);
    function y(b) {
      r.data = b, r.dataLevel = s.dataLevel + 1, r.dataTypes = [], s.definedProperties = /* @__PURE__ */ new Set(), r.parentData = s.data, r.dataNames = [...s.dataNames, b];
    }
  }
  yt.extendSubschemaData = o;
  function n(r, { jtdDiscriminator: s, jtdMetadata: i, compositeRule: l, createErrors: f, allErrors: u }) {
    l !== void 0 && (r.compositeRule = l), f !== void 0 && (r.createErrors = f), u !== void 0 && (r.allErrors = u), r.jtdDiscriminator = s, r.jtdMetadata = i;
  }
  return yt.extendSubschemaMode = n, yt;
}
var P1 = {}, Vs, Ss;
function dl() {
  return Ss || (Ss = 1, Vs = function t(e, a) {
    if (e === a) return !0;
    if (e && a && typeof e == "object" && typeof a == "object") {
      if (e.constructor !== a.constructor) return !1;
      var o, n, r;
      if (Array.isArray(e)) {
        if (o = e.length, o != a.length) return !1;
        for (n = o; n-- !== 0; )
          if (!t(e[n], a[n])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === a.source && e.flags === a.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === a.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === a.toString();
      if (r = Object.keys(e), o = r.length, o !== Object.keys(a).length) return !1;
      for (n = o; n-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, r[n])) return !1;
      for (n = o; n-- !== 0; ) {
        var s = r[n];
        if (!t(e[s], a[s])) return !1;
      }
      return !0;
    }
    return e !== e && a !== a;
  }), Vs;
}
var vr = { exports: {} }, As;
function EC() {
  if (As) return vr.exports;
  As = 1;
  var t = vr.exports = function(o, n, r) {
    typeof n == "function" && (r = n, n = {}), r = n.cb || r;
    var s = typeof r == "function" ? r : r.pre || function() {
    }, i = r.post || function() {
    };
    e(n, s, i, o, "", o);
  };
  t.keywords = {
    additionalItems: !0,
    items: !0,
    contains: !0,
    additionalProperties: !0,
    propertyNames: !0,
    not: !0,
    if: !0,
    then: !0,
    else: !0
  }, t.arrayKeywords = {
    items: !0,
    allOf: !0,
    anyOf: !0,
    oneOf: !0
  }, t.propsKeywords = {
    $defs: !0,
    definitions: !0,
    properties: !0,
    patternProperties: !0,
    dependencies: !0
  }, t.skipKeywords = {
    default: !0,
    enum: !0,
    const: !0,
    required: !0,
    maximum: !0,
    minimum: !0,
    exclusiveMaximum: !0,
    exclusiveMinimum: !0,
    multipleOf: !0,
    maxLength: !0,
    minLength: !0,
    pattern: !0,
    format: !0,
    maxItems: !0,
    minItems: !0,
    uniqueItems: !0,
    maxProperties: !0,
    minProperties: !0
  };
  function e(o, n, r, s, i, l, f, u, d, k) {
    if (s && typeof s == "object" && !Array.isArray(s)) {
      n(s, i, l, f, u, d, k);
      for (var y in s) {
        var b = s[y];
        if (Array.isArray(b)) {
          if (y in t.arrayKeywords)
            for (var M = 0; M < b.length; M++)
              e(o, n, r, b[M], i + "/" + y + "/" + M, l, i, y, s, M);
        } else if (y in t.propsKeywords) {
          if (b && typeof b == "object")
            for (var c in b)
              e(o, n, r, b[c], i + "/" + y + "/" + a(c), l, i, y, s, c);
        } else (y in t.keywords || o.allKeys && !(y in t.skipKeywords)) && e(o, n, r, b, i + "/" + y, l, i, y, s);
      }
      r(s, i, l, f, u, d, k);
    }
  }
  function a(o) {
    return o.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  return vr.exports;
}
var Es;
function $n() {
  if (Es) return P1;
  Es = 1, Object.defineProperty(P1, "__esModule", { value: !0 }), P1.getSchemaRefs = P1.resolveUrl = P1.normalizeId = P1._getFullPath = P1.getFullPath = P1.inlineRef = void 0;
  const t = We(), e = dl(), a = EC(), o = /* @__PURE__ */ new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
  ]);
  function n(M, c = !0) {
    return typeof M == "boolean" ? !0 : c === !0 ? !s(M) : c ? i(M) <= c : !1;
  }
  P1.inlineRef = n;
  const r = /* @__PURE__ */ new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
  ]);
  function s(M) {
    for (const c in M) {
      if (r.has(c))
        return !0;
      const p = M[c];
      if (Array.isArray(p) && p.some(s) || typeof p == "object" && s(p))
        return !0;
    }
    return !1;
  }
  function i(M) {
    let c = 0;
    for (const p in M)
      if (p === "$ref" || (c++, !o.has(p) && (typeof M[p] == "object" && (0, t.eachItem)(M[p], (h) => c += i(h)), c === 1 / 0)))
        return 1 / 0;
    return c;
  }
  function l(M, c = "", p) {
    p !== !1 && (c = d(c));
    const h = M.parse(c);
    return f(M, h);
  }
  P1.getFullPath = l;
  function f(M, c) {
    return M.serialize(c).split("#")[0] + "#";
  }
  P1._getFullPath = f;
  const u = /#\/?$/;
  function d(M) {
    return M ? M.replace(u, "") : "";
  }
  P1.normalizeId = d;
  function k(M, c, p) {
    return p = d(p), M.resolve(c, p);
  }
  P1.resolveUrl = k;
  const y = /^[a-z_][-a-z0-9._]*$/i;
  function b(M, c) {
    if (typeof M == "boolean")
      return {};
    const { schemaId: p, uriResolver: h } = this.opts, v = d(M[p] || c), H = { "": v }, w = l(h, v, !1), _ = {}, L = /* @__PURE__ */ new Set();
    return a(M, { allKeys: !0 }, (B, K, ee, ve) => {
      if (ve === void 0)
        return;
      const q = w + K;
      let O = H[ve];
      typeof B[p] == "string" && (O = Y.call(this, B[p])), U.call(this, B.$anchor), U.call(this, B.$dynamicAnchor), H[K] = O;
      function Y(ne) {
        const te = this.opts.uriResolver.resolve;
        if (ne = d(O ? te(O, ne) : ne), L.has(ne))
          throw F(ne);
        L.add(ne);
        let G = this.refs[ne];
        return typeof G == "string" && (G = this.refs[G]), typeof G == "object" ? I(B, G.schema, ne) : ne !== d(q) && (ne[0] === "#" ? (I(B, _[ne], ne), _[ne] = B) : this.refs[ne] = q), ne;
      }
      function U(ne) {
        if (typeof ne == "string") {
          if (!y.test(ne))
            throw new Error(`invalid anchor "${ne}"`);
          Y.call(this, `#${ne}`);
        }
      }
    }), _;
    function I(B, K, ee) {
      if (K !== void 0 && !e(B, K))
        throw F(ee);
    }
    function F(B) {
      return new Error(`reference "${B}" resolves to more than one schema`);
    }
  }
  return P1.getSchemaRefs = b, P1;
}
var Ds;
function Mn() {
  if (Ds) return vt;
  Ds = 1, Object.defineProperty(vt, "__esModule", { value: !0 }), vt.getData = vt.KeywordCxt = vt.validateFunctionCode = void 0;
  const t = MC(), e = fn(), a = cl(), o = fn(), n = VC(), r = SC(), s = AC(), i = Fe(), l = Zt(), f = $n(), u = We(), d = xn();
  function k(z) {
    if (w(z) && (L(z), H(z))) {
      c(z);
      return;
    }
    y(z, () => (0, t.topBoolOrEmptySchema)(z));
  }
  vt.validateFunctionCode = k;
  function y({ gen: z, validateName: P, schema: V, schemaEnv: E, opts: S }, R) {
    S.code.es5 ? z.func(P, (0, i._)`${l.default.data}, ${l.default.valCxt}`, E.$async, () => {
      z.code((0, i._)`"use strict"; ${h(V, S)}`), M(z, S), z.code(R);
    }) : z.func(P, (0, i._)`${l.default.data}, ${b(S)}`, E.$async, () => z.code(h(V, S)).code(R));
  }
  function b(z) {
    return (0, i._)`{${l.default.instancePath}="", ${l.default.parentData}, ${l.default.parentDataProperty}, ${l.default.rootData}=${l.default.data}${z.dynamicRef ? (0, i._)`, ${l.default.dynamicAnchors}={}` : i.nil}}={}`;
  }
  function M(z, P) {
    z.if(l.default.valCxt, () => {
      z.var(l.default.instancePath, (0, i._)`${l.default.valCxt}.${l.default.instancePath}`), z.var(l.default.parentData, (0, i._)`${l.default.valCxt}.${l.default.parentData}`), z.var(l.default.parentDataProperty, (0, i._)`${l.default.valCxt}.${l.default.parentDataProperty}`), z.var(l.default.rootData, (0, i._)`${l.default.valCxt}.${l.default.rootData}`), P.dynamicRef && z.var(l.default.dynamicAnchors, (0, i._)`${l.default.valCxt}.${l.default.dynamicAnchors}`);
    }, () => {
      z.var(l.default.instancePath, (0, i._)`""`), z.var(l.default.parentData, (0, i._)`undefined`), z.var(l.default.parentDataProperty, (0, i._)`undefined`), z.var(l.default.rootData, l.default.data), P.dynamicRef && z.var(l.default.dynamicAnchors, (0, i._)`{}`);
    });
  }
  function c(z) {
    const { schema: P, opts: V, gen: E } = z;
    y(z, () => {
      V.$comment && P.$comment && ve(z), B(z), E.let(l.default.vErrors, null), E.let(l.default.errors, 0), V.unevaluated && p(z), I(z), q(z);
    });
  }
  function p(z) {
    const { gen: P, validateName: V } = z;
    z.evaluated = P.const("evaluated", (0, i._)`${V}.evaluated`), P.if((0, i._)`${z.evaluated}.dynamicProps`, () => P.assign((0, i._)`${z.evaluated}.props`, (0, i._)`undefined`)), P.if((0, i._)`${z.evaluated}.dynamicItems`, () => P.assign((0, i._)`${z.evaluated}.items`, (0, i._)`undefined`));
  }
  function h(z, P) {
    const V = typeof z == "object" && z[P.schemaId];
    return V && (P.code.source || P.code.process) ? (0, i._)`/*# sourceURL=${V} */` : i.nil;
  }
  function v(z, P) {
    if (w(z) && (L(z), H(z))) {
      _(z, P);
      return;
    }
    (0, t.boolOrEmptySchema)(z, P);
  }
  function H({ schema: z, self: P }) {
    if (typeof z == "boolean")
      return !z;
    for (const V in z)
      if (P.RULES.all[V])
        return !0;
    return !1;
  }
  function w(z) {
    return typeof z.schema != "boolean";
  }
  function _(z, P) {
    const { schema: V, gen: E, opts: S } = z;
    S.$comment && V.$comment && ve(z), K(z), ee(z);
    const R = E.const("_errs", l.default.errors);
    I(z, R), E.var(P, (0, i._)`${R} === ${l.default.errors}`);
  }
  function L(z) {
    (0, u.checkUnknownRules)(z), F(z);
  }
  function I(z, P) {
    if (z.opts.jtd)
      return Y(z, [], !1, P);
    const V = (0, e.getSchemaTypes)(z.schema), E = (0, e.coerceAndCheckDataType)(z, V);
    Y(z, V, !E, P);
  }
  function F(z) {
    const { schema: P, errSchemaPath: V, opts: E, self: S } = z;
    P.$ref && E.ignoreKeywordsWithRef && (0, u.schemaHasRulesButRef)(P, S.RULES) && S.logger.warn(`$ref: keywords ignored in schema at path "${V}"`);
  }
  function B(z) {
    const { schema: P, opts: V } = z;
    P.default !== void 0 && V.useDefaults && V.strictSchema && (0, u.checkStrictMode)(z, "default is ignored in the schema root");
  }
  function K(z) {
    const P = z.schema[z.opts.schemaId];
    P && (z.baseId = (0, f.resolveUrl)(z.opts.uriResolver, z.baseId, P));
  }
  function ee(z) {
    if (z.schema.$async && !z.schemaEnv.$async)
      throw new Error("async schema in sync schema");
  }
  function ve({ gen: z, schemaEnv: P, schema: V, errSchemaPath: E, opts: S }) {
    const R = V.$comment;
    if (S.$comment === !0)
      z.code((0, i._)`${l.default.self}.logger.log(${R})`);
    else if (typeof S.$comment == "function") {
      const ie = (0, i.str)`${E}/$comment`, de = z.scopeValue("root", { ref: P.root });
      z.code((0, i._)`${l.default.self}.opts.$comment(${R}, ${ie}, ${de}.schema)`);
    }
  }
  function q(z) {
    const { gen: P, schemaEnv: V, validateName: E, ValidationError: S, opts: R } = z;
    V.$async ? P.if((0, i._)`${l.default.errors} === 0`, () => P.return(l.default.data), () => P.throw((0, i._)`new ${S}(${l.default.vErrors})`)) : (P.assign((0, i._)`${E}.errors`, l.default.vErrors), R.unevaluated && O(z), P.return((0, i._)`${l.default.errors} === 0`));
  }
  function O({ gen: z, evaluated: P, props: V, items: E }) {
    V instanceof i.Name && z.assign((0, i._)`${P}.props`, V), E instanceof i.Name && z.assign((0, i._)`${P}.items`, E);
  }
  function Y(z, P, V, E) {
    const { gen: S, schema: R, data: ie, allErrors: de, opts: Ce, self: He } = z, { RULES: X } = He;
    if (R.$ref && (Ce.ignoreKeywordsWithRef || !(0, u.schemaHasRulesButRef)(R, X))) {
      S.block(() => $(z, "$ref", X.all.$ref.definition));
      return;
    }
    Ce.jtd || ne(z, P), S.block(() => {
      for (const je of X.rules)
        ce(je);
      ce(X.post);
    });
    function ce(je) {
      (0, a.shouldUseGroup)(R, je) && (je.type ? (S.if((0, o.checkDataType)(je.type, ie, Ce.strictNumbers)), U(z, je), P.length === 1 && P[0] === je.type && V && (S.else(), (0, o.reportTypeError)(z)), S.endIf()) : U(z, je), de || S.if((0, i._)`${l.default.errors} === ${E || 0}`));
    }
  }
  function U(z, P) {
    const { gen: V, schema: E, opts: { useDefaults: S } } = z;
    S && (0, n.assignDefaults)(z, P.type), V.block(() => {
      for (const R of P.rules)
        (0, a.shouldUseRule)(E, R) && $(z, R.keyword, R.definition, P.type);
    });
  }
  function ne(z, P) {
    z.schemaEnv.meta || !z.opts.strictTypes || (te(z, P), z.opts.allowUnionTypes || G(z, P), T(z, z.dataTypes));
  }
  function te(z, P) {
    if (P.length) {
      if (!z.dataTypes.length) {
        z.dataTypes = P;
        return;
      }
      P.forEach((V) => {
        D(z.dataTypes, V) || A(z, `type "${V}" not allowed by context "${z.dataTypes.join(",")}"`);
      }), x(z, P);
    }
  }
  function G(z, P) {
    P.length > 1 && !(P.length === 2 && P.includes("null")) && A(z, "use allowUnionTypes to allow union type keyword");
  }
  function T(z, P) {
    const V = z.self.RULES.all;
    for (const E in V) {
      const S = V[E];
      if (typeof S == "object" && (0, a.shouldUseRule)(z.schema, S)) {
        const { type: R } = S.definition;
        R.length && !R.some((ie) => Z(P, ie)) && A(z, `missing type "${R.join(",")}" for keyword "${E}"`);
      }
    }
  }
  function Z(z, P) {
    return z.includes(P) || P === "number" && z.includes("integer");
  }
  function D(z, P) {
    return z.includes(P) || P === "integer" && z.includes("number");
  }
  function x(z, P) {
    const V = [];
    for (const E of z.dataTypes)
      D(P, E) ? V.push(E) : P.includes("integer") && E === "number" && V.push("integer");
    z.dataTypes = V;
  }
  function A(z, P) {
    const V = z.schemaEnv.baseId + z.errSchemaPath;
    P += ` at "${V}" (strictTypes)`, (0, u.checkStrictMode)(z, P, z.opts.strictTypes);
  }
  class N {
    constructor(P, V, E) {
      if ((0, r.validateKeywordUsage)(P, V, E), this.gen = P.gen, this.allErrors = P.allErrors, this.keyword = E, this.data = P.data, this.schema = P.schema[E], this.$data = V.$data && P.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, u.schemaRefOrVal)(P, this.schema, E, this.$data), this.schemaType = V.schemaType, this.parentSchema = P.schema, this.params = {}, this.it = P, this.def = V, this.$data)
        this.schemaCode = P.gen.const("vSchema", Le(this.$data, P));
      else if (this.schemaCode = this.schemaValue, !(0, r.validSchemaType)(this.schema, V.schemaType, V.allowUndefined))
        throw new Error(`${E} value must be ${JSON.stringify(V.schemaType)}`);
      ("code" in V ? V.trackErrors : V.errors !== !1) && (this.errsCount = P.gen.const("_errs", l.default.errors));
    }
    result(P, V, E) {
      this.failResult((0, i.not)(P), V, E);
    }
    failResult(P, V, E) {
      this.gen.if(P), E ? E() : this.error(), V ? (this.gen.else(), V(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
    }
    pass(P, V) {
      this.failResult((0, i.not)(P), void 0, V);
    }
    fail(P) {
      if (P === void 0) {
        this.error(), this.allErrors || this.gen.if(!1);
        return;
      }
      this.gen.if(P), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
    }
    fail$data(P) {
      if (!this.$data)
        return this.fail(P);
      const { schemaCode: V } = this;
      this.fail((0, i._)`${V} !== undefined && (${(0, i.or)(this.invalid$data(), P)})`);
    }
    error(P, V, E) {
      if (V) {
        this.setParams(V), this._error(P, E), this.setParams({});
        return;
      }
      this._error(P, E);
    }
    _error(P, V) {
      (P ? d.reportExtraError : d.reportError)(this, this.def.error, V);
    }
    $dataError() {
      (0, d.reportError)(this, this.def.$dataError || d.keyword$DataError);
    }
    reset() {
      if (this.errsCount === void 0)
        throw new Error('add "trackErrors" to keyword definition');
      (0, d.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(P) {
      this.allErrors || this.gen.if(P);
    }
    setParams(P, V) {
      V ? Object.assign(this.params, P) : this.params = P;
    }
    block$data(P, V, E = i.nil) {
      this.gen.block(() => {
        this.check$data(P, E), V();
      });
    }
    check$data(P = i.nil, V = i.nil) {
      if (!this.$data)
        return;
      const { gen: E, schemaCode: S, schemaType: R, def: ie } = this;
      E.if((0, i.or)((0, i._)`${S} === undefined`, V)), P !== i.nil && E.assign(P, !0), (R.length || ie.validateSchema) && (E.elseIf(this.invalid$data()), this.$dataError(), P !== i.nil && E.assign(P, !1)), E.else();
    }
    invalid$data() {
      const { gen: P, schemaCode: V, schemaType: E, def: S, it: R } = this;
      return (0, i.or)(ie(), de());
      function ie() {
        if (E.length) {
          if (!(V instanceof i.Name))
            throw new Error("ajv implementation error");
          const Ce = Array.isArray(E) ? E : [E];
          return (0, i._)`${(0, o.checkDataTypes)(Ce, V, R.opts.strictNumbers, o.DataType.Wrong)}`;
        }
        return i.nil;
      }
      function de() {
        if (S.validateSchema) {
          const Ce = P.scopeValue("validate$data", { ref: S.validateSchema });
          return (0, i._)`!${Ce}(${V})`;
        }
        return i.nil;
      }
    }
    subschema(P, V) {
      const E = (0, s.getSubschema)(this.it, P);
      (0, s.extendSubschemaData)(E, this.it, P), (0, s.extendSubschemaMode)(E, P);
      const S = { ...this.it, ...E, items: void 0, props: void 0 };
      return v(S, V), S;
    }
    mergeEvaluated(P, V) {
      const { it: E, gen: S } = this;
      E.opts.unevaluated && (E.props !== !0 && P.props !== void 0 && (E.props = u.mergeEvaluated.props(S, P.props, E.props, V)), E.items !== !0 && P.items !== void 0 && (E.items = u.mergeEvaluated.items(S, P.items, E.items, V)));
    }
    mergeValidEvaluated(P, V) {
      const { it: E, gen: S } = this;
      if (E.opts.unevaluated && (E.props !== !0 || E.items !== !0))
        return S.if(V, () => this.mergeEvaluated(P, i.Name)), !0;
    }
  }
  vt.KeywordCxt = N;
  function $(z, P, V, E) {
    const S = new N(z, V, P);
    "code" in V ? V.code(S, E) : S.$data && V.validate ? (0, r.funcKeywordCode)(S, V) : "macro" in V ? (0, r.macroKeywordCode)(S, V) : (V.compile || V.validate) && (0, r.funcKeywordCode)(S, V);
  }
  const W = /^\/(?:[^~]|~0|~1)*$/, fe = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
  function Le(z, { dataLevel: P, dataNames: V, dataPathArr: E }) {
    let S, R;
    if (z === "")
      return l.default.rootData;
    if (z[0] === "/") {
      if (!W.test(z))
        throw new Error(`Invalid JSON-pointer: ${z}`);
      S = z, R = l.default.rootData;
    } else {
      const He = fe.exec(z);
      if (!He)
        throw new Error(`Invalid JSON-pointer: ${z}`);
      const X = +He[1];
      if (S = He[2], S === "#") {
        if (X >= P)
          throw new Error(Ce("property/index", X));
        return E[P - X];
      }
      if (X > P)
        throw new Error(Ce("data", X));
      if (R = V[P - X], !S)
        return R;
    }
    let ie = R;
    const de = S.split("/");
    for (const He of de)
      He && (R = (0, i._)`${R}${(0, i.getProperty)((0, u.unescapeJsonPointer)(He))}`, ie = (0, i._)`${ie} && ${R}`);
    return ie;
    function Ce(He, X) {
      return `Cannot access ${He} ${X} levels up, current level is ${P}`;
    }
  }
  return vt.getData = Le, vt;
}
var Co = {}, Ps;
function c0() {
  if (Ps) return Co;
  Ps = 1, Object.defineProperty(Co, "__esModule", { value: !0 });
  class t extends Error {
    constructor(a) {
      super("validation failed"), this.errors = a, this.ajv = this.validation = !0;
    }
  }
  return Co.default = t, Co;
}
var wo = {}, zs;
function Vn() {
  if (zs) return wo;
  zs = 1, Object.defineProperty(wo, "__esModule", { value: !0 });
  const t = $n();
  class e extends Error {
    constructor(o, n, r, s) {
      super(s || `can't resolve reference ${r} from id ${n}`), this.missingRef = (0, t.resolveUrl)(o, n, r), this.missingSchema = (0, t.normalizeId)((0, t.getFullPath)(o, this.missingRef));
    }
  }
  return wo.default = e, wo;
}
var B1 = {}, Ts;
function d0() {
  if (Ts) return B1;
  Ts = 1, Object.defineProperty(B1, "__esModule", { value: !0 }), B1.resolveSchema = B1.getCompilingSchema = B1.resolveRef = B1.compileSchema = B1.SchemaEnv = void 0;
  const t = Fe(), e = c0(), a = Zt(), o = $n(), n = We(), r = Mn();
  class s {
    constructor(p) {
      var h;
      this.refs = {}, this.dynamicAnchors = {};
      let v;
      typeof p.schema == "object" && (v = p.schema), this.schema = p.schema, this.schemaId = p.schemaId, this.root = p.root || this, this.baseId = (h = p.baseId) !== null && h !== void 0 ? h : (0, o.normalizeId)(v?.[p.schemaId || "$id"]), this.schemaPath = p.schemaPath, this.localRefs = p.localRefs, this.meta = p.meta, this.$async = v?.$async, this.refs = {};
    }
  }
  B1.SchemaEnv = s;
  function i(c) {
    const p = u.call(this, c);
    if (p)
      return p;
    const h = (0, o.getFullPath)(this.opts.uriResolver, c.root.baseId), { es5: v, lines: H } = this.opts.code, { ownProperties: w } = this.opts, _ = new t.CodeGen(this.scope, { es5: v, lines: H, ownProperties: w });
    let L;
    c.$async && (L = _.scopeValue("Error", {
      ref: e.default,
      code: (0, t._)`require("ajv/dist/runtime/validation_error").default`
    }));
    const I = _.scopeName("validate");
    c.validateName = I;
    const F = {
      gen: _,
      allErrors: this.opts.allErrors,
      data: a.default.data,
      parentData: a.default.parentData,
      parentDataProperty: a.default.parentDataProperty,
      dataNames: [a.default.data],
      dataPathArr: [t.nil],
      // TODO can its length be used as dataLevel if nil is removed?
      dataLevel: 0,
      dataTypes: [],
      definedProperties: /* @__PURE__ */ new Set(),
      topSchemaRef: _.scopeValue("schema", this.opts.code.source === !0 ? { ref: c.schema, code: (0, t.stringify)(c.schema) } : { ref: c.schema }),
      validateName: I,
      ValidationError: L,
      schema: c.schema,
      schemaEnv: c,
      rootId: h,
      baseId: c.baseId || h,
      schemaPath: t.nil,
      errSchemaPath: c.schemaPath || (this.opts.jtd ? "" : "#"),
      errorPath: (0, t._)`""`,
      opts: this.opts,
      self: this
    };
    let B;
    try {
      this._compilations.add(c), (0, r.validateFunctionCode)(F), _.optimize(this.opts.code.optimize);
      const K = _.toString();
      B = `${_.scopeRefs(a.default.scope)}return ${K}`, this.opts.code.process && (B = this.opts.code.process(B, c));
      const ee = new Function(`${a.default.self}`, `${a.default.scope}`, B)(this, this.scope.get());
      if (this.scope.value(I, { ref: ee }), ee.errors = null, ee.schema = c.schema, ee.schemaEnv = c, c.$async && (ee.$async = !0), this.opts.code.source === !0 && (ee.source = { validateName: I, validateCode: K, scopeValues: _._values }), this.opts.unevaluated) {
        const { props: ve, items: q } = F;
        ee.evaluated = {
          props: ve instanceof t.Name ? void 0 : ve,
          items: q instanceof t.Name ? void 0 : q,
          dynamicProps: ve instanceof t.Name,
          dynamicItems: q instanceof t.Name
        }, ee.source && (ee.source.evaluated = (0, t.stringify)(ee.evaluated));
      }
      return c.validate = ee, c;
    } catch (K) {
      throw delete c.validate, delete c.validateName, B && this.logger.error("Error compiling schema, function code:", B), K;
    } finally {
      this._compilations.delete(c);
    }
  }
  B1.compileSchema = i;
  function l(c, p, h) {
    var v;
    h = (0, o.resolveUrl)(this.opts.uriResolver, p, h);
    const H = c.refs[h];
    if (H)
      return H;
    let w = k.call(this, c, h);
    if (w === void 0) {
      const _ = (v = c.localRefs) === null || v === void 0 ? void 0 : v[h], { schemaId: L } = this.opts;
      _ && (w = new s({ schema: _, schemaId: L, root: c, baseId: p }));
    }
    if (w !== void 0)
      return c.refs[h] = f.call(this, w);
  }
  B1.resolveRef = l;
  function f(c) {
    return (0, o.inlineRef)(c.schema, this.opts.inlineRefs) ? c.schema : c.validate ? c : i.call(this, c);
  }
  function u(c) {
    for (const p of this._compilations)
      if (d(p, c))
        return p;
  }
  B1.getCompilingSchema = u;
  function d(c, p) {
    return c.schema === p.schema && c.root === p.root && c.baseId === p.baseId;
  }
  function k(c, p) {
    let h;
    for (; typeof (h = this.refs[p]) == "string"; )
      p = h;
    return h || this.schemas[p] || y.call(this, c, p);
  }
  function y(c, p) {
    const h = this.opts.uriResolver.parse(p), v = (0, o._getFullPath)(this.opts.uriResolver, h);
    let H = (0, o.getFullPath)(this.opts.uriResolver, c.baseId, void 0);
    if (Object.keys(c.schema).length > 0 && v === H)
      return M.call(this, h, c);
    const w = (0, o.normalizeId)(v), _ = this.refs[w] || this.schemas[w];
    if (typeof _ == "string") {
      const L = y.call(this, c, _);
      return typeof L?.schema != "object" ? void 0 : M.call(this, h, L);
    }
    if (typeof _?.schema == "object") {
      if (_.validate || i.call(this, _), w === (0, o.normalizeId)(p)) {
        const { schema: L } = _, { schemaId: I } = this.opts, F = L[I];
        return F && (H = (0, o.resolveUrl)(this.opts.uriResolver, H, F)), new s({ schema: L, schemaId: I, root: c, baseId: H });
      }
      return M.call(this, h, _);
    }
  }
  B1.resolveSchema = y;
  const b = /* @__PURE__ */ new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
  ]);
  function M(c, { baseId: p, schema: h, root: v }) {
    var H;
    if (((H = c.fragment) === null || H === void 0 ? void 0 : H[0]) !== "/")
      return;
    for (const L of c.fragment.slice(1).split("/")) {
      if (typeof h == "boolean")
        return;
      const I = h[(0, n.unescapeFragment)(L)];
      if (I === void 0)
        return;
      h = I;
      const F = typeof h == "object" && h[this.opts.schemaId];
      !b.has(L) && F && (p = (0, o.resolveUrl)(this.opts.uriResolver, p, F));
    }
    let w;
    if (typeof h != "boolean" && h.$ref && !(0, n.schemaHasRulesButRef)(h, this.RULES)) {
      const L = (0, o.resolveUrl)(this.opts.uriResolver, p, h.$ref);
      w = y.call(this, v, L);
    }
    const { schemaId: _ } = this.opts;
    if (w = w || new s({ schema: h, schemaId: _, root: v, baseId: p }), w.schema !== w.root.schema)
      return w;
  }
  return B1;
}
const DC = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", PC = "Meta-schema for $data reference (JSON AnySchema extension proposal)", zC = "object", TC = ["$data"], OC = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, FC = !1, BC = {
  $id: DC,
  description: PC,
  type: zC,
  required: TC,
  properties: OC,
  additionalProperties: FC
};
var _o = {}, Ya = { exports: {} }, Os, Fs;
function IC() {
  return Fs || (Fs = 1, Os = {
    HEX: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
      7: 7,
      8: 8,
      9: 9,
      a: 10,
      A: 10,
      b: 11,
      B: 11,
      c: 12,
      C: 12,
      d: 13,
      D: 13,
      e: 14,
      E: 14,
      f: 15,
      F: 15
    }
  }), Os;
}
var gr, Bs;
function ZC() {
  if (Bs) return gr;
  Bs = 1;
  const { HEX: t } = IC();
  function e(b) {
    if (s(b, ".") < 3)
      return { host: b, isIPV4: !1 };
    const M = b.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [], [c] = M;
    return c ? { host: r(c, "."), isIPV4: !0 } : { host: b, isIPV4: !1 };
  }
  function a(b, M = !1) {
    let c = "", p = !0;
    for (const h of b) {
      if (t[h] === void 0) return;
      h !== "0" && p === !0 && (p = !1), p || (c += h);
    }
    return M && c.length === 0 && (c = "0"), c;
  }
  function o(b) {
    let M = 0;
    const c = { error: !1, address: "", zone: "" }, p = [], h = [];
    let v = !1, H = !1, w = !1;
    function _() {
      if (h.length) {
        if (v === !1) {
          const L = a(h);
          if (L !== void 0)
            p.push(L);
          else
            return c.error = !0, !1;
        }
        h.length = 0;
      }
      return !0;
    }
    for (let L = 0; L < b.length; L++) {
      const I = b[L];
      if (!(I === "[" || I === "]"))
        if (I === ":") {
          if (H === !0 && (w = !0), !_())
            break;
          if (M++, p.push(":"), M > 7) {
            c.error = !0;
            break;
          }
          L - 1 >= 0 && b[L - 1] === ":" && (H = !0);
          continue;
        } else if (I === "%") {
          if (!_())
            break;
          v = !0;
        } else {
          h.push(I);
          continue;
        }
    }
    return h.length && (v ? c.zone = h.join("") : w ? p.push(h.join("")) : p.push(a(h))), c.address = p.join(""), c;
  }
  function n(b, M = {}) {
    if (s(b, ":") < 2)
      return { host: b, isIPV6: !1 };
    const c = o(b);
    if (c.error)
      return { host: b, isIPV6: !1 };
    {
      let p = c.address, h = c.address;
      return c.zone && (p += "%" + c.zone, h += "%25" + c.zone), { host: p, escapedHost: h, isIPV6: !0 };
    }
  }
  function r(b, M) {
    let c = "", p = !0;
    const h = b.length;
    for (let v = 0; v < h; v++) {
      const H = b[v];
      H === "0" && p ? (v + 1 <= h && b[v + 1] === M || v + 1 === h) && (c += H, p = !1) : (H === M ? p = !0 : p = !1, c += H);
    }
    return c;
  }
  function s(b, M) {
    let c = 0;
    for (let p = 0; p < b.length; p++)
      b[p] === M && c++;
    return c;
  }
  const i = /^\.\.?\//u, l = /^\/\.(?:\/|$)/u, f = /^\/\.\.(?:\/|$)/u, u = /^\/?(?:.|\n)*?(?=\/|$)/u;
  function d(b) {
    const M = [];
    for (; b.length; )
      if (b.match(i))
        b = b.replace(i, "");
      else if (b.match(l))
        b = b.replace(l, "/");
      else if (b.match(f))
        b = b.replace(f, "/"), M.pop();
      else if (b === "." || b === "..")
        b = "";
      else {
        const c = b.match(u);
        if (c) {
          const p = c[0];
          b = b.slice(p.length), M.push(p);
        } else
          throw new Error("Unexpected dot segment condition");
      }
    return M.join("");
  }
  function k(b, M) {
    const c = M !== !0 ? escape : unescape;
    return b.scheme !== void 0 && (b.scheme = c(b.scheme)), b.userinfo !== void 0 && (b.userinfo = c(b.userinfo)), b.host !== void 0 && (b.host = c(b.host)), b.path !== void 0 && (b.path = c(b.path)), b.query !== void 0 && (b.query = c(b.query)), b.fragment !== void 0 && (b.fragment = c(b.fragment)), b;
  }
  function y(b, M) {
    const c = [];
    if (b.userinfo !== void 0 && (c.push(b.userinfo), c.push("@")), b.host !== void 0) {
      let p = unescape(b.host);
      const h = e(p);
      if (h.isIPV4)
        p = h.host;
      else {
        const v = n(h.host, {});
        v.isIPV6 === !0 ? p = `[${v.escapedHost}]` : p = b.host;
      }
      c.push(p);
    }
    return (typeof b.port == "number" || typeof b.port == "string") && (c.push(":"), c.push(String(b.port))), c.length ? c.join("") : void 0;
  }
  return gr = {
    recomposeAuthority: y,
    normalizeComponentEncoding: k,
    removeDotSegments: d,
    normalizeIPv4: e,
    normalizeIPv6: n,
    stringArrayToHexStripped: a
  }, gr;
}
var yr, Is;
function RC() {
  if (Is) return yr;
  Is = 1;
  const t = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu, e = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
  function a(c) {
    return typeof c.secure == "boolean" ? c.secure : String(c.scheme).toLowerCase() === "wss";
  }
  function o(c) {
    return c.host || (c.error = c.error || "HTTP URIs must have a host."), c;
  }
  function n(c) {
    const p = String(c.scheme).toLowerCase() === "https";
    return (c.port === (p ? 443 : 80) || c.port === "") && (c.port = void 0), c.path || (c.path = "/"), c;
  }
  function r(c) {
    return c.secure = a(c), c.resourceName = (c.path || "/") + (c.query ? "?" + c.query : ""), c.path = void 0, c.query = void 0, c;
  }
  function s(c) {
    if ((c.port === (a(c) ? 443 : 80) || c.port === "") && (c.port = void 0), typeof c.secure == "boolean" && (c.scheme = c.secure ? "wss" : "ws", c.secure = void 0), c.resourceName) {
      const [p, h] = c.resourceName.split("?");
      c.path = p && p !== "/" ? p : void 0, c.query = h, c.resourceName = void 0;
    }
    return c.fragment = void 0, c;
  }
  function i(c, p) {
    if (!c.path)
      return c.error = "URN can not be parsed", c;
    const h = c.path.match(e);
    if (h) {
      const v = p.scheme || c.scheme || "urn";
      c.nid = h[1].toLowerCase(), c.nss = h[2];
      const H = `${v}:${p.nid || c.nid}`, w = M[H];
      c.path = void 0, w && (c = w.parse(c, p));
    } else
      c.error = c.error || "URN can not be parsed.";
    return c;
  }
  function l(c, p) {
    const h = p.scheme || c.scheme || "urn", v = c.nid.toLowerCase(), H = `${h}:${p.nid || v}`, w = M[H];
    w && (c = w.serialize(c, p));
    const _ = c, L = c.nss;
    return _.path = `${v || p.nid}:${L}`, p.skipEscape = !0, _;
  }
  function f(c, p) {
    const h = c;
    return h.uuid = h.nss, h.nss = void 0, !p.tolerant && (!h.uuid || !t.test(h.uuid)) && (h.error = h.error || "UUID is not valid."), h;
  }
  function u(c) {
    const p = c;
    return p.nss = (c.uuid || "").toLowerCase(), p;
  }
  const d = {
    scheme: "http",
    domainHost: !0,
    parse: o,
    serialize: n
  }, k = {
    scheme: "https",
    domainHost: d.domainHost,
    parse: o,
    serialize: n
  }, y = {
    scheme: "ws",
    domainHost: !0,
    parse: r,
    serialize: s
  }, b = {
    scheme: "wss",
    domainHost: y.domainHost,
    parse: y.parse,
    serialize: y.serialize
  }, M = {
    http: d,
    https: k,
    ws: y,
    wss: b,
    urn: {
      scheme: "urn",
      parse: i,
      serialize: l,
      skipNormalize: !0
    },
    "urn:uuid": {
      scheme: "urn:uuid",
      parse: f,
      serialize: u,
      skipNormalize: !0
    }
  };
  return yr = M, yr;
}
var Zs;
function NC() {
  if (Zs) return Ya.exports;
  Zs = 1;
  const { normalizeIPv6: t, normalizeIPv4: e, removeDotSegments: a, recomposeAuthority: o, normalizeComponentEncoding: n } = ZC(), r = RC();
  function s(c, p) {
    return typeof c == "string" ? c = u(b(c, p), p) : typeof c == "object" && (c = b(u(c, p), p)), c;
  }
  function i(c, p, h) {
    const v = Object.assign({ scheme: "null" }, h), H = l(b(c, v), b(p, v), v, !0);
    return u(H, { ...v, skipEscape: !0 });
  }
  function l(c, p, h, v) {
    const H = {};
    return v || (c = b(u(c, h), h), p = b(u(p, h), h)), h = h || {}, !h.tolerant && p.scheme ? (H.scheme = p.scheme, H.userinfo = p.userinfo, H.host = p.host, H.port = p.port, H.path = a(p.path || ""), H.query = p.query) : (p.userinfo !== void 0 || p.host !== void 0 || p.port !== void 0 ? (H.userinfo = p.userinfo, H.host = p.host, H.port = p.port, H.path = a(p.path || ""), H.query = p.query) : (p.path ? (p.path.charAt(0) === "/" ? H.path = a(p.path) : ((c.userinfo !== void 0 || c.host !== void 0 || c.port !== void 0) && !c.path ? H.path = "/" + p.path : c.path ? H.path = c.path.slice(0, c.path.lastIndexOf("/") + 1) + p.path : H.path = p.path, H.path = a(H.path)), H.query = p.query) : (H.path = c.path, p.query !== void 0 ? H.query = p.query : H.query = c.query), H.userinfo = c.userinfo, H.host = c.host, H.port = c.port), H.scheme = c.scheme), H.fragment = p.fragment, H;
  }
  function f(c, p, h) {
    return typeof c == "string" ? (c = unescape(c), c = u(n(b(c, h), !0), { ...h, skipEscape: !0 })) : typeof c == "object" && (c = u(n(c, !0), { ...h, skipEscape: !0 })), typeof p == "string" ? (p = unescape(p), p = u(n(b(p, h), !0), { ...h, skipEscape: !0 })) : typeof p == "object" && (p = u(n(p, !0), { ...h, skipEscape: !0 })), c.toLowerCase() === p.toLowerCase();
  }
  function u(c, p) {
    const h = {
      host: c.host,
      scheme: c.scheme,
      userinfo: c.userinfo,
      port: c.port,
      path: c.path,
      query: c.query,
      nid: c.nid,
      nss: c.nss,
      uuid: c.uuid,
      fragment: c.fragment,
      reference: c.reference,
      resourceName: c.resourceName,
      secure: c.secure,
      error: ""
    }, v = Object.assign({}, p), H = [], w = r[(v.scheme || h.scheme || "").toLowerCase()];
    w && w.serialize && w.serialize(h, v), h.path !== void 0 && (v.skipEscape ? h.path = unescape(h.path) : (h.path = escape(h.path), h.scheme !== void 0 && (h.path = h.path.split("%3A").join(":")))), v.reference !== "suffix" && h.scheme && (H.push(h.scheme), H.push(":"));
    const _ = o(h, v);
    if (_ !== void 0 && (v.reference !== "suffix" && H.push("//"), H.push(_), h.path && h.path.charAt(0) !== "/" && H.push("/")), h.path !== void 0) {
      let L = h.path;
      !v.absolutePath && (!w || !w.absolutePath) && (L = a(L)), _ === void 0 && (L = L.replace(/^\/\//u, "/%2F")), H.push(L);
    }
    return h.query !== void 0 && (H.push("?"), H.push(h.query)), h.fragment !== void 0 && (H.push("#"), H.push(h.fragment)), H.join("");
  }
  const d = Array.from({ length: 127 }, (c, p) => /[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(p)));
  function k(c) {
    let p = 0;
    for (let h = 0, v = c.length; h < v; ++h)
      if (p = c.charCodeAt(h), p > 126 || d[p])
        return !0;
    return !1;
  }
  const y = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
  function b(c, p) {
    const h = Object.assign({}, p), v = {
      scheme: void 0,
      userinfo: void 0,
      host: "",
      port: void 0,
      path: "",
      query: void 0,
      fragment: void 0
    }, H = c.indexOf("%") !== -1;
    let w = !1;
    h.reference === "suffix" && (c = (h.scheme ? h.scheme + ":" : "") + "//" + c);
    const _ = c.match(y);
    if (_) {
      if (v.scheme = _[1], v.userinfo = _[3], v.host = _[4], v.port = parseInt(_[5], 10), v.path = _[6] || "", v.query = _[7], v.fragment = _[8], isNaN(v.port) && (v.port = _[5]), v.host) {
        const I = e(v.host);
        if (I.isIPV4 === !1) {
          const F = t(I.host, { isIPV4: !1 });
          v.host = F.host.toLowerCase(), w = F.isIPV6;
        } else
          v.host = I.host, w = !0;
      }
      v.scheme === void 0 && v.userinfo === void 0 && v.host === void 0 && v.port === void 0 && !v.path && v.query === void 0 ? v.reference = "same-document" : v.scheme === void 0 ? v.reference = "relative" : v.fragment === void 0 ? v.reference = "absolute" : v.reference = "uri", h.reference && h.reference !== "suffix" && h.reference !== v.reference && (v.error = v.error || "URI is not a " + h.reference + " reference.");
      const L = r[(h.scheme || v.scheme || "").toLowerCase()];
      if (!h.unicodeSupport && (!L || !L.unicodeSupport) && v.host && (h.domainHost || L && L.domainHost) && w === !1 && k(v.host))
        try {
          v.host = URL.domainToASCII(v.host.toLowerCase());
        } catch (I) {
          v.error = v.error || "Host's domain name can not be converted to ASCII: " + I;
        }
      (!L || L && !L.skipNormalize) && (H && v.scheme !== void 0 && (v.scheme = unescape(v.scheme)), H && v.userinfo !== void 0 && (v.userinfo = unescape(v.userinfo)), H && v.host !== void 0 && (v.host = unescape(v.host)), v.path !== void 0 && v.path.length && (v.path = escape(unescape(v.path))), v.fragment !== void 0 && v.fragment.length && (v.fragment = encodeURI(decodeURIComponent(v.fragment)))), L && L.parse && L.parse(v, h);
    } else
      v.error = v.error || "URI can not be parsed.";
    return v;
  }
  const M = {
    SCHEMES: r,
    normalize: s,
    resolve: i,
    resolveComponents: l,
    equal: f,
    serialize: u,
    parse: b
  };
  return Ya.exports = M, Ya.exports.default = M, Ya.exports.fastUri = M, Ya.exports;
}
var Rs;
function qC() {
  if (Rs) return _o;
  Rs = 1, Object.defineProperty(_o, "__esModule", { value: !0 });
  const t = NC();
  return t.code = 'require("ajv/dist/runtime/uri").default', _o.default = t, _o;
}
var Ns;
function UC() {
  return Ns || (Ns = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0;
    var e = Mn();
    Object.defineProperty(t, "KeywordCxt", { enumerable: !0, get: function() {
      return e.KeywordCxt;
    } });
    var a = Fe();
    Object.defineProperty(t, "_", { enumerable: !0, get: function() {
      return a._;
    } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
      return a.str;
    } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
      return a.stringify;
    } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
      return a.nil;
    } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
      return a.Name;
    } }), Object.defineProperty(t, "CodeGen", { enumerable: !0, get: function() {
      return a.CodeGen;
    } });
    const o = c0(), n = Vn(), r = ul(), s = d0(), i = Fe(), l = $n(), f = fn(), u = We(), d = BC, k = qC(), y = (G, T) => new RegExp(G, T);
    y.code = "new RegExp";
    const b = ["removeAdditional", "useDefaults", "coerceTypes"], M = /* @__PURE__ */ new Set([
      "validate",
      "serialize",
      "parse",
      "wrapper",
      "root",
      "schema",
      "keyword",
      "pattern",
      "formats",
      "validate$data",
      "func",
      "obj",
      "Error"
    ]), c = {
      errorDataPath: "",
      format: "`validateFormats: false` can be used instead.",
      nullable: '"nullable" keyword is supported by default.',
      jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
      extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
      missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
      processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
      sourceCode: "Use option `code: {source: true}`",
      strictDefaults: "It is default now, see option `strict`.",
      strictKeywords: "It is default now, see option `strict`.",
      uniqueItems: '"uniqueItems" keyword is always validated.',
      unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
      cache: "Map is used as cache, schema object as key.",
      serialize: "Map is used as cache, schema object as key.",
      ajvErrors: "It is default now."
    }, p = {
      ignoreKeywordsWithRef: "",
      jsPropertySyntax: "",
      unicode: '"minLength"/"maxLength" account for unicode characters by default.'
    }, h = 200;
    function v(G) {
      var T, Z, D, x, A, N, $, W, fe, Le, z, P, V, E, S, R, ie, de, Ce, He, X, ce, je, Ze, r1;
      const xe = G.strict, ze = (T = G.code) === null || T === void 0 ? void 0 : T.optimize, Pe = ze === !0 || ze === void 0 ? 1 : ze || 0, E1 = (D = (Z = G.code) === null || Z === void 0 ? void 0 : Z.regExp) !== null && D !== void 0 ? D : y, rt = (x = G.uriResolver) !== null && x !== void 0 ? x : k.default;
      return {
        strictSchema: (N = (A = G.strictSchema) !== null && A !== void 0 ? A : xe) !== null && N !== void 0 ? N : !0,
        strictNumbers: (W = ($ = G.strictNumbers) !== null && $ !== void 0 ? $ : xe) !== null && W !== void 0 ? W : !0,
        strictTypes: (Le = (fe = G.strictTypes) !== null && fe !== void 0 ? fe : xe) !== null && Le !== void 0 ? Le : "log",
        strictTuples: (P = (z = G.strictTuples) !== null && z !== void 0 ? z : xe) !== null && P !== void 0 ? P : "log",
        strictRequired: (E = (V = G.strictRequired) !== null && V !== void 0 ? V : xe) !== null && E !== void 0 ? E : !1,
        code: G.code ? { ...G.code, optimize: Pe, regExp: E1 } : { optimize: Pe, regExp: E1 },
        loopRequired: (S = G.loopRequired) !== null && S !== void 0 ? S : h,
        loopEnum: (R = G.loopEnum) !== null && R !== void 0 ? R : h,
        meta: (ie = G.meta) !== null && ie !== void 0 ? ie : !0,
        messages: (de = G.messages) !== null && de !== void 0 ? de : !0,
        inlineRefs: (Ce = G.inlineRefs) !== null && Ce !== void 0 ? Ce : !0,
        schemaId: (He = G.schemaId) !== null && He !== void 0 ? He : "$id",
        addUsedSchema: (X = G.addUsedSchema) !== null && X !== void 0 ? X : !0,
        validateSchema: (ce = G.validateSchema) !== null && ce !== void 0 ? ce : !0,
        validateFormats: (je = G.validateFormats) !== null && je !== void 0 ? je : !0,
        unicodeRegExp: (Ze = G.unicodeRegExp) !== null && Ze !== void 0 ? Ze : !0,
        int32range: (r1 = G.int32range) !== null && r1 !== void 0 ? r1 : !0,
        uriResolver: rt
      };
    }
    class H {
      constructor(T = {}) {
        this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), T = this.opts = { ...T, ...v(T) };
        const { es5: Z, lines: D } = this.opts.code;
        this.scope = new i.ValueScope({ scope: {}, prefixes: M, es5: Z, lines: D }), this.logger = ee(T.logger);
        const x = T.validateFormats;
        T.validateFormats = !1, this.RULES = (0, r.getRules)(), w.call(this, c, T, "NOT SUPPORTED"), w.call(this, p, T, "DEPRECATED", "warn"), this._metaOpts = B.call(this), T.formats && I.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), T.keywords && F.call(this, T.keywords), typeof T.meta == "object" && this.addMetaSchema(T.meta), L.call(this), T.validateFormats = x;
      }
      _addVocabularies() {
        this.addKeyword("$async");
      }
      _addDefaultMetaSchema() {
        const { $data: T, meta: Z, schemaId: D } = this.opts;
        let x = d;
        D === "id" && (x = { ...d }, x.id = x.$id, delete x.$id), Z && T && this.addMetaSchema(x, x[D], !1);
      }
      defaultMeta() {
        const { meta: T, schemaId: Z } = this.opts;
        return this.opts.defaultMeta = typeof T == "object" ? T[Z] || T : void 0;
      }
      validate(T, Z) {
        let D;
        if (typeof T == "string") {
          if (D = this.getSchema(T), !D)
            throw new Error(`no schema with key or ref "${T}"`);
        } else
          D = this.compile(T);
        const x = D(Z);
        return "$async" in D || (this.errors = D.errors), x;
      }
      compile(T, Z) {
        const D = this._addSchema(T, Z);
        return D.validate || this._compileSchemaEnv(D);
      }
      compileAsync(T, Z) {
        if (typeof this.opts.loadSchema != "function")
          throw new Error("options.loadSchema should be a function");
        const { loadSchema: D } = this.opts;
        return x.call(this, T, Z);
        async function x(Le, z) {
          await A.call(this, Le.$schema);
          const P = this._addSchema(Le, z);
          return P.validate || N.call(this, P);
        }
        async function A(Le) {
          Le && !this.getSchema(Le) && await x.call(this, { $ref: Le }, !0);
        }
        async function N(Le) {
          try {
            return this._compileSchemaEnv(Le);
          } catch (z) {
            if (!(z instanceof n.default))
              throw z;
            return $.call(this, z), await W.call(this, z.missingSchema), N.call(this, Le);
          }
        }
        function $({ missingSchema: Le, missingRef: z }) {
          if (this.refs[Le])
            throw new Error(`AnySchema ${Le} is loaded but ${z} cannot be resolved`);
        }
        async function W(Le) {
          const z = await fe.call(this, Le);
          this.refs[Le] || await A.call(this, z.$schema), this.refs[Le] || this.addSchema(z, Le, Z);
        }
        async function fe(Le) {
          const z = this._loading[Le];
          if (z)
            return z;
          try {
            return await (this._loading[Le] = D(Le));
          } finally {
            delete this._loading[Le];
          }
        }
      }
      // Adds schema to the instance
      addSchema(T, Z, D, x = this.opts.validateSchema) {
        if (Array.isArray(T)) {
          for (const N of T)
            this.addSchema(N, void 0, D, x);
          return this;
        }
        let A;
        if (typeof T == "object") {
          const { schemaId: N } = this.opts;
          if (A = T[N], A !== void 0 && typeof A != "string")
            throw new Error(`schema ${N} must be string`);
        }
        return Z = (0, l.normalizeId)(Z || A), this._checkUnique(Z), this.schemas[Z] = this._addSchema(T, D, Z, x, !0), this;
      }
      // Add schema that will be used to validate other schemas
      // options in META_IGNORE_OPTIONS are alway set to false
      addMetaSchema(T, Z, D = this.opts.validateSchema) {
        return this.addSchema(T, Z, !0, D), this;
      }
      //  Validate schema against its meta-schema
      validateSchema(T, Z) {
        if (typeof T == "boolean")
          return !0;
        let D;
        if (D = T.$schema, D !== void 0 && typeof D != "string")
          throw new Error("$schema must be a string");
        if (D = D || this.opts.defaultMeta || this.defaultMeta(), !D)
          return this.logger.warn("meta-schema not available"), this.errors = null, !0;
        const x = this.validate(D, T);
        if (!x && Z) {
          const A = "schema is invalid: " + this.errorsText();
          if (this.opts.validateSchema === "log")
            this.logger.error(A);
          else
            throw new Error(A);
        }
        return x;
      }
      // Get compiled schema by `key` or `ref`.
      // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
      getSchema(T) {
        let Z;
        for (; typeof (Z = _.call(this, T)) == "string"; )
          T = Z;
        if (Z === void 0) {
          const { schemaId: D } = this.opts, x = new s.SchemaEnv({ schema: {}, schemaId: D });
          if (Z = s.resolveSchema.call(this, x, T), !Z)
            return;
          this.refs[T] = Z;
        }
        return Z.validate || this._compileSchemaEnv(Z);
      }
      // Remove cached schema(s).
      // If no parameter is passed all schemas but meta-schemas are removed.
      // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
      // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
      removeSchema(T) {
        if (T instanceof RegExp)
          return this._removeAllSchemas(this.schemas, T), this._removeAllSchemas(this.refs, T), this;
        switch (typeof T) {
          case "undefined":
            return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
          case "string": {
            const Z = _.call(this, T);
            return typeof Z == "object" && this._cache.delete(Z.schema), delete this.schemas[T], delete this.refs[T], this;
          }
          case "object": {
            const Z = T;
            this._cache.delete(Z);
            let D = T[this.opts.schemaId];
            return D && (D = (0, l.normalizeId)(D), delete this.schemas[D], delete this.refs[D]), this;
          }
          default:
            throw new Error("ajv.removeSchema: invalid parameter");
        }
      }
      // add "vocabulary" - a collection of keywords
      addVocabulary(T) {
        for (const Z of T)
          this.addKeyword(Z);
        return this;
      }
      addKeyword(T, Z) {
        let D;
        if (typeof T == "string")
          D = T, typeof Z == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), Z.keyword = D);
        else if (typeof T == "object" && Z === void 0) {
          if (Z = T, D = Z.keyword, Array.isArray(D) && !D.length)
            throw new Error("addKeywords: keyword must be string or non-empty array");
        } else
          throw new Error("invalid addKeywords parameters");
        if (q.call(this, D, Z), !Z)
          return (0, u.eachItem)(D, (A) => O.call(this, A)), this;
        U.call(this, Z);
        const x = {
          ...Z,
          type: (0, f.getJSONTypes)(Z.type),
          schemaType: (0, f.getJSONTypes)(Z.schemaType)
        };
        return (0, u.eachItem)(D, x.type.length === 0 ? (A) => O.call(this, A, x) : (A) => x.type.forEach((N) => O.call(this, A, x, N))), this;
      }
      getKeyword(T) {
        const Z = this.RULES.all[T];
        return typeof Z == "object" ? Z.definition : !!Z;
      }
      // Remove keyword
      removeKeyword(T) {
        const { RULES: Z } = this;
        delete Z.keywords[T], delete Z.all[T];
        for (const D of Z.rules) {
          const x = D.rules.findIndex((A) => A.keyword === T);
          x >= 0 && D.rules.splice(x, 1);
        }
        return this;
      }
      // Add format
      addFormat(T, Z) {
        return typeof Z == "string" && (Z = new RegExp(Z)), this.formats[T] = Z, this;
      }
      errorsText(T = this.errors, { separator: Z = ", ", dataVar: D = "data" } = {}) {
        return !T || T.length === 0 ? "No errors" : T.map((x) => `${D}${x.instancePath} ${x.message}`).reduce((x, A) => x + Z + A);
      }
      $dataMetaSchema(T, Z) {
        const D = this.RULES.all;
        T = JSON.parse(JSON.stringify(T));
        for (const x of Z) {
          const A = x.split("/").slice(1);
          let N = T;
          for (const $ of A)
            N = N[$];
          for (const $ in D) {
            const W = D[$];
            if (typeof W != "object")
              continue;
            const { $data: fe } = W.definition, Le = N[$];
            fe && Le && (N[$] = te(Le));
          }
        }
        return T;
      }
      _removeAllSchemas(T, Z) {
        for (const D in T) {
          const x = T[D];
          (!Z || Z.test(D)) && (typeof x == "string" ? delete T[D] : x && !x.meta && (this._cache.delete(x.schema), delete T[D]));
        }
      }
      _addSchema(T, Z, D, x = this.opts.validateSchema, A = this.opts.addUsedSchema) {
        let N;
        const { schemaId: $ } = this.opts;
        if (typeof T == "object")
          N = T[$];
        else {
          if (this.opts.jtd)
            throw new Error("schema must be object");
          if (typeof T != "boolean")
            throw new Error("schema must be object or boolean");
        }
        let W = this._cache.get(T);
        if (W !== void 0)
          return W;
        D = (0, l.normalizeId)(N || D);
        const fe = l.getSchemaRefs.call(this, T, D);
        return W = new s.SchemaEnv({ schema: T, schemaId: $, meta: Z, baseId: D, localRefs: fe }), this._cache.set(W.schema, W), A && !D.startsWith("#") && (D && this._checkUnique(D), this.refs[D] = W), x && this.validateSchema(T, !0), W;
      }
      _checkUnique(T) {
        if (this.schemas[T] || this.refs[T])
          throw new Error(`schema with key or id "${T}" already exists`);
      }
      _compileSchemaEnv(T) {
        if (T.meta ? this._compileMetaSchema(T) : s.compileSchema.call(this, T), !T.validate)
          throw new Error("ajv implementation error");
        return T.validate;
      }
      _compileMetaSchema(T) {
        const Z = this.opts;
        this.opts = this._metaOpts;
        try {
          s.compileSchema.call(this, T);
        } finally {
          this.opts = Z;
        }
      }
    }
    H.ValidationError = o.default, H.MissingRefError = n.default, t.default = H;
    function w(G, T, Z, D = "error") {
      for (const x in G) {
        const A = x;
        A in T && this.logger[D](`${Z}: option ${x}. ${G[A]}`);
      }
    }
    function _(G) {
      return G = (0, l.normalizeId)(G), this.schemas[G] || this.refs[G];
    }
    function L() {
      const G = this.opts.schemas;
      if (G)
        if (Array.isArray(G))
          this.addSchema(G);
        else
          for (const T in G)
            this.addSchema(G[T], T);
    }
    function I() {
      for (const G in this.opts.formats) {
        const T = this.opts.formats[G];
        T && this.addFormat(G, T);
      }
    }
    function F(G) {
      if (Array.isArray(G)) {
        this.addVocabulary(G);
        return;
      }
      this.logger.warn("keywords option as map is deprecated, pass array");
      for (const T in G) {
        const Z = G[T];
        Z.keyword || (Z.keyword = T), this.addKeyword(Z);
      }
    }
    function B() {
      const G = { ...this.opts };
      for (const T of b)
        delete G[T];
      return G;
    }
    const K = { log() {
    }, warn() {
    }, error() {
    } };
    function ee(G) {
      if (G === !1)
        return K;
      if (G === void 0)
        return console;
      if (G.log && G.warn && G.error)
        return G;
      throw new Error("logger must implement log, warn and error methods");
    }
    const ve = /^[a-z_$][a-z0-9_$:-]*$/i;
    function q(G, T) {
      const { RULES: Z } = this;
      if ((0, u.eachItem)(G, (D) => {
        if (Z.keywords[D])
          throw new Error(`Keyword ${D} is already defined`);
        if (!ve.test(D))
          throw new Error(`Keyword ${D} has invalid name`);
      }), !!T && T.$data && !("code" in T || "validate" in T))
        throw new Error('$data keyword must have "code" or "validate" function');
    }
    function O(G, T, Z) {
      var D;
      const x = T?.post;
      if (Z && x)
        throw new Error('keyword with "post" flag cannot have "type"');
      const { RULES: A } = this;
      let N = x ? A.post : A.rules.find(({ type: W }) => W === Z);
      if (N || (N = { type: Z, rules: [] }, A.rules.push(N)), A.keywords[G] = !0, !T)
        return;
      const $ = {
        keyword: G,
        definition: {
          ...T,
          type: (0, f.getJSONTypes)(T.type),
          schemaType: (0, f.getJSONTypes)(T.schemaType)
        }
      };
      T.before ? Y.call(this, N, $, T.before) : N.rules.push($), A.all[G] = $, (D = T.implements) === null || D === void 0 || D.forEach((W) => this.addKeyword(W));
    }
    function Y(G, T, Z) {
      const D = G.rules.findIndex((x) => x.keyword === Z);
      D >= 0 ? G.rules.splice(D, 0, T) : (G.rules.push(T), this.logger.warn(`rule ${Z} is not defined`));
    }
    function U(G) {
      let { metaSchema: T } = G;
      T !== void 0 && (G.$data && this.opts.$data && (T = te(T)), G.validateSchema = this.compile(T, !0));
    }
    const ne = {
      $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
    };
    function te(G) {
      return { anyOf: [G, ne] };
    }
  })(cs)), cs;
}
var Ho = {}, jo = {}, Lo = {}, qs;
function YC() {
  if (qs) return Lo;
  qs = 1, Object.defineProperty(Lo, "__esModule", { value: !0 });
  const t = {
    keyword: "id",
    code() {
      throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
  };
  return Lo.default = t, Lo;
}
var Vt = {}, Us;
function WC() {
  if (Us) return Vt;
  Us = 1, Object.defineProperty(Vt, "__esModule", { value: !0 }), Vt.callRef = Vt.getValidate = void 0;
  const t = Vn(), e = nt(), a = Fe(), o = Zt(), n = d0(), r = We(), s = {
    keyword: "$ref",
    schemaType: "string",
    code(f) {
      const { gen: u, schema: d, it: k } = f, { baseId: y, schemaEnv: b, validateName: M, opts: c, self: p } = k, { root: h } = b;
      if ((d === "#" || d === "#/") && y === h.baseId)
        return H();
      const v = n.resolveRef.call(p, h, y, d);
      if (v === void 0)
        throw new t.default(k.opts.uriResolver, y, d);
      if (v instanceof n.SchemaEnv)
        return w(v);
      return _(v);
      function H() {
        if (b === h)
          return l(f, M, b, b.$async);
        const L = u.scopeValue("root", { ref: h });
        return l(f, (0, a._)`${L}.validate`, h, h.$async);
      }
      function w(L) {
        const I = i(f, L);
        l(f, I, L, L.$async);
      }
      function _(L) {
        const I = u.scopeValue("schema", c.code.source === !0 ? { ref: L, code: (0, a.stringify)(L) } : { ref: L }), F = u.name("valid"), B = f.subschema({
          schema: L,
          dataTypes: [],
          schemaPath: a.nil,
          topSchemaRef: I,
          errSchemaPath: d
        }, F);
        f.mergeEvaluated(B), f.ok(F);
      }
    }
  };
  function i(f, u) {
    const { gen: d } = f;
    return u.validate ? d.scopeValue("validate", { ref: u.validate }) : (0, a._)`${d.scopeValue("wrapper", { ref: u })}.validate`;
  }
  Vt.getValidate = i;
  function l(f, u, d, k) {
    const { gen: y, it: b } = f, { allErrors: M, schemaEnv: c, opts: p } = b, h = p.passContext ? o.default.this : a.nil;
    k ? v() : H();
    function v() {
      if (!c.$async)
        throw new Error("async schema referenced by sync schema");
      const L = y.let("valid");
      y.try(() => {
        y.code((0, a._)`await ${(0, e.callValidateCode)(f, u, h)}`), _(u), M || y.assign(L, !0);
      }, (I) => {
        y.if((0, a._)`!(${I} instanceof ${b.ValidationError})`, () => y.throw(I)), w(I), M || y.assign(L, !1);
      }), f.ok(L);
    }
    function H() {
      f.result((0, e.callValidateCode)(f, u, h), () => _(u), () => w(u));
    }
    function w(L) {
      const I = (0, a._)`${L}.errors`;
      y.assign(o.default.vErrors, (0, a._)`${o.default.vErrors} === null ? ${I} : ${o.default.vErrors}.concat(${I})`), y.assign(o.default.errors, (0, a._)`${o.default.vErrors}.length`);
    }
    function _(L) {
      var I;
      if (!b.opts.unevaluated)
        return;
      const F = (I = d?.validate) === null || I === void 0 ? void 0 : I.evaluated;
      if (b.props !== !0)
        if (F && !F.dynamicProps)
          F.props !== void 0 && (b.props = r.mergeEvaluated.props(y, F.props, b.props));
        else {
          const B = y.var("props", (0, a._)`${L}.evaluated.props`);
          b.props = r.mergeEvaluated.props(y, B, b.props, a.Name);
        }
      if (b.items !== !0)
        if (F && !F.dynamicItems)
          F.items !== void 0 && (b.items = r.mergeEvaluated.items(y, F.items, b.items));
        else {
          const B = y.var("items", (0, a._)`${L}.evaluated.items`);
          b.items = r.mergeEvaluated.items(y, B, b.items, a.Name);
        }
    }
  }
  return Vt.callRef = l, Vt.default = s, Vt;
}
var Ys;
function KC() {
  if (Ys) return jo;
  Ys = 1, Object.defineProperty(jo, "__esModule", { value: !0 });
  const t = YC(), e = WC(), a = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    { keyword: "$comment" },
    "definitions",
    t.default,
    e.default
  ];
  return jo.default = a, jo;
}
var xo = {}, $o = {}, Ws;
function GC() {
  if (Ws) return $o;
  Ws = 1, Object.defineProperty($o, "__esModule", { value: !0 });
  const t = Fe(), e = t.operators, a = {
    maximum: { okStr: "<=", ok: e.LTE, fail: e.GT },
    minimum: { okStr: ">=", ok: e.GTE, fail: e.LT },
    exclusiveMaximum: { okStr: "<", ok: e.LT, fail: e.GTE },
    exclusiveMinimum: { okStr: ">", ok: e.GT, fail: e.LTE }
  }, o = {
    message: ({ keyword: r, schemaCode: s }) => (0, t.str)`must be ${a[r].okStr} ${s}`,
    params: ({ keyword: r, schemaCode: s }) => (0, t._)`{comparison: ${a[r].okStr}, limit: ${s}}`
  }, n = {
    keyword: Object.keys(a),
    type: "number",
    schemaType: "number",
    $data: !0,
    error: o,
    code(r) {
      const { keyword: s, data: i, schemaCode: l } = r;
      r.fail$data((0, t._)`${i} ${a[s].fail} ${l} || isNaN(${i})`);
    }
  };
  return $o.default = n, $o;
}
var Mo = {}, Ks;
function XC() {
  if (Ks) return Mo;
  Ks = 1, Object.defineProperty(Mo, "__esModule", { value: !0 });
  const t = Fe(), e = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: !0,
    error: {
      message: ({ schemaCode: a }) => (0, t.str)`must be multiple of ${a}`,
      params: ({ schemaCode: a }) => (0, t._)`{multipleOf: ${a}}`
    },
    code(a) {
      const { gen: o, data: n, schemaCode: r, it: s } = a, i = s.opts.multipleOfPrecision, l = o.let("res"), f = i ? (0, t._)`Math.abs(Math.round(${l}) - ${l}) > 1e-${i}` : (0, t._)`${l} !== parseInt(${l})`;
      a.fail$data((0, t._)`(${r} === 0 || (${l} = ${n}/${r}, ${f}))`);
    }
  };
  return Mo.default = e, Mo;
}
var Vo = {}, So = {}, Gs;
function QC() {
  if (Gs) return So;
  Gs = 1, Object.defineProperty(So, "__esModule", { value: !0 });
  function t(e) {
    const a = e.length;
    let o = 0, n = 0, r;
    for (; n < a; )
      o++, r = e.charCodeAt(n++), r >= 55296 && r <= 56319 && n < a && (r = e.charCodeAt(n), (r & 64512) === 56320 && n++);
    return o;
  }
  return So.default = t, t.code = 'require("ajv/dist/runtime/ucs2length").default', So;
}
var Xs;
function JC() {
  if (Xs) return Vo;
  Xs = 1, Object.defineProperty(Vo, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = QC(), o = {
    keyword: ["maxLength", "minLength"],
    type: "string",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: n, schemaCode: r }) {
        const s = n === "maxLength" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${s} than ${r} characters`;
      },
      params: ({ schemaCode: n }) => (0, t._)`{limit: ${n}}`
    },
    code(n) {
      const { keyword: r, data: s, schemaCode: i, it: l } = n, f = r === "maxLength" ? t.operators.GT : t.operators.LT, u = l.opts.unicode === !1 ? (0, t._)`${s}.length` : (0, t._)`${(0, e.useFunc)(n.gen, a.default)}(${s})`;
      n.fail$data((0, t._)`${u} ${f} ${i}`);
    }
  };
  return Vo.default = o, Vo;
}
var Ao = {}, Qs;
function ew() {
  if (Qs) return Ao;
  Qs = 1, Object.defineProperty(Ao, "__esModule", { value: !0 });
  const t = nt(), e = Fe(), a = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: !0,
    error: {
      message: ({ schemaCode: o }) => (0, e.str)`must match pattern "${o}"`,
      params: ({ schemaCode: o }) => (0, e._)`{pattern: ${o}}`
    },
    code(o) {
      const { data: n, $data: r, schema: s, schemaCode: i, it: l } = o, f = l.opts.unicodeRegExp ? "u" : "", u = r ? (0, e._)`(new RegExp(${i}, ${f}))` : (0, t.usePattern)(o, s);
      o.fail$data((0, e._)`!${u}.test(${n})`);
    }
  };
  return Ao.default = a, Ao;
}
var Eo = {}, Js;
function tw() {
  if (Js) return Eo;
  Js = 1, Object.defineProperty(Eo, "__esModule", { value: !0 });
  const t = Fe(), e = {
    keyword: ["maxProperties", "minProperties"],
    type: "object",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: a, schemaCode: o }) {
        const n = a === "maxProperties" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${n} than ${o} properties`;
      },
      params: ({ schemaCode: a }) => (0, t._)`{limit: ${a}}`
    },
    code(a) {
      const { keyword: o, data: n, schemaCode: r } = a, s = o === "maxProperties" ? t.operators.GT : t.operators.LT;
      a.fail$data((0, t._)`Object.keys(${n}).length ${s} ${r}`);
    }
  };
  return Eo.default = e, Eo;
}
var Do = {}, ei;
function aw() {
  if (ei) return Do;
  ei = 1, Object.defineProperty(Do, "__esModule", { value: !0 });
  const t = nt(), e = Fe(), a = We(), o = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: !0,
    error: {
      message: ({ params: { missingProperty: n } }) => (0, e.str)`must have required property '${n}'`,
      params: ({ params: { missingProperty: n } }) => (0, e._)`{missingProperty: ${n}}`
    },
    code(n) {
      const { gen: r, schema: s, schemaCode: i, data: l, $data: f, it: u } = n, { opts: d } = u;
      if (!f && s.length === 0)
        return;
      const k = s.length >= d.loopRequired;
      if (u.allErrors ? y() : b(), d.strictRequired) {
        const p = n.parentSchema.properties, { definedProperties: h } = n.it;
        for (const v of s)
          if (p?.[v] === void 0 && !h.has(v)) {
            const H = u.schemaEnv.baseId + u.errSchemaPath, w = `required property "${v}" is not defined at "${H}" (strictRequired)`;
            (0, a.checkStrictMode)(u, w, u.opts.strictRequired);
          }
      }
      function y() {
        if (k || f)
          n.block$data(e.nil, M);
        else
          for (const p of s)
            (0, t.checkReportMissingProp)(n, p);
      }
      function b() {
        const p = r.let("missing");
        if (k || f) {
          const h = r.let("valid", !0);
          n.block$data(h, () => c(p, h)), n.ok(h);
        } else
          r.if((0, t.checkMissingProp)(n, s, p)), (0, t.reportMissingProp)(n, p), r.else();
      }
      function M() {
        r.forOf("prop", i, (p) => {
          n.setParams({ missingProperty: p }), r.if((0, t.noPropertyInData)(r, l, p, d.ownProperties), () => n.error());
        });
      }
      function c(p, h) {
        n.setParams({ missingProperty: p }), r.forOf(p, i, () => {
          r.assign(h, (0, t.propertyInData)(r, l, p, d.ownProperties)), r.if((0, e.not)(h), () => {
            n.error(), r.break();
          });
        }, e.nil);
      }
    }
  };
  return Do.default = o, Do;
}
var Po = {}, ti;
function ow() {
  if (ti) return Po;
  ti = 1, Object.defineProperty(Po, "__esModule", { value: !0 });
  const t = Fe(), e = {
    keyword: ["maxItems", "minItems"],
    type: "array",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: a, schemaCode: o }) {
        const n = a === "maxItems" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${n} than ${o} items`;
      },
      params: ({ schemaCode: a }) => (0, t._)`{limit: ${a}}`
    },
    code(a) {
      const { keyword: o, data: n, schemaCode: r } = a, s = o === "maxItems" ? t.operators.GT : t.operators.LT;
      a.fail$data((0, t._)`${n}.length ${s} ${r}`);
    }
  };
  return Po.default = e, Po;
}
var zo = {}, To = {}, ai;
function m0() {
  if (ai) return To;
  ai = 1, Object.defineProperty(To, "__esModule", { value: !0 });
  const t = dl();
  return t.code = 'require("ajv/dist/runtime/equal").default', To.default = t, To;
}
var oi;
function nw() {
  if (oi) return zo;
  oi = 1, Object.defineProperty(zo, "__esModule", { value: !0 });
  const t = fn(), e = Fe(), a = We(), o = m0(), n = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: !0,
    error: {
      message: ({ params: { i: r, j: s } }) => (0, e.str)`must NOT have duplicate items (items ## ${s} and ${r} are identical)`,
      params: ({ params: { i: r, j: s } }) => (0, e._)`{i: ${r}, j: ${s}}`
    },
    code(r) {
      const { gen: s, data: i, $data: l, schema: f, parentSchema: u, schemaCode: d, it: k } = r;
      if (!l && !f)
        return;
      const y = s.let("valid"), b = u.items ? (0, t.getSchemaTypes)(u.items) : [];
      r.block$data(y, M, (0, e._)`${d} === false`), r.ok(y);
      function M() {
        const v = s.let("i", (0, e._)`${i}.length`), H = s.let("j");
        r.setParams({ i: v, j: H }), s.assign(y, !0), s.if((0, e._)`${v} > 1`, () => (c() ? p : h)(v, H));
      }
      function c() {
        return b.length > 0 && !b.some((v) => v === "object" || v === "array");
      }
      function p(v, H) {
        const w = s.name("item"), _ = (0, t.checkDataTypes)(b, w, k.opts.strictNumbers, t.DataType.Wrong), L = s.const("indices", (0, e._)`{}`);
        s.for((0, e._)`;${v}--;`, () => {
          s.let(w, (0, e._)`${i}[${v}]`), s.if(_, (0, e._)`continue`), b.length > 1 && s.if((0, e._)`typeof ${w} == "string"`, (0, e._)`${w} += "_"`), s.if((0, e._)`typeof ${L}[${w}] == "number"`, () => {
            s.assign(H, (0, e._)`${L}[${w}]`), r.error(), s.assign(y, !1).break();
          }).code((0, e._)`${L}[${w}] = ${v}`);
        });
      }
      function h(v, H) {
        const w = (0, a.useFunc)(s, o.default), _ = s.name("outer");
        s.label(_).for((0, e._)`;${v}--;`, () => s.for((0, e._)`${H} = ${v}; ${H}--;`, () => s.if((0, e._)`${w}(${i}[${v}], ${i}[${H}])`, () => {
          r.error(), s.assign(y, !1).break(_);
        })));
      }
    }
  };
  return zo.default = n, zo;
}
var Oo = {}, ni;
function rw() {
  if (ni) return Oo;
  ni = 1, Object.defineProperty(Oo, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = m0(), o = {
    keyword: "const",
    $data: !0,
    error: {
      message: "must be equal to constant",
      params: ({ schemaCode: n }) => (0, t._)`{allowedValue: ${n}}`
    },
    code(n) {
      const { gen: r, data: s, $data: i, schemaCode: l, schema: f } = n;
      i || f && typeof f == "object" ? n.fail$data((0, t._)`!${(0, e.useFunc)(r, a.default)}(${s}, ${l})`) : n.fail((0, t._)`${f} !== ${s}`);
    }
  };
  return Oo.default = o, Oo;
}
var Fo = {}, ri;
function sw() {
  if (ri) return Fo;
  ri = 1, Object.defineProperty(Fo, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = m0(), o = {
    keyword: "enum",
    schemaType: "array",
    $data: !0,
    error: {
      message: "must be equal to one of the allowed values",
      params: ({ schemaCode: n }) => (0, t._)`{allowedValues: ${n}}`
    },
    code(n) {
      const { gen: r, data: s, $data: i, schema: l, schemaCode: f, it: u } = n;
      if (!i && l.length === 0)
        throw new Error("enum must have non-empty array");
      const d = l.length >= u.opts.loopEnum;
      let k;
      const y = () => k ?? (k = (0, e.useFunc)(r, a.default));
      let b;
      if (d || i)
        b = r.let("valid"), n.block$data(b, M);
      else {
        if (!Array.isArray(l))
          throw new Error("ajv implementation error");
        const p = r.const("vSchema", f);
        b = (0, t.or)(...l.map((h, v) => c(p, v)));
      }
      n.pass(b);
      function M() {
        r.assign(b, !1), r.forOf("v", f, (p) => r.if((0, t._)`${y()}(${s}, ${p})`, () => r.assign(b, !0).break()));
      }
      function c(p, h) {
        const v = l[h];
        return typeof v == "object" && v !== null ? (0, t._)`${y()}(${s}, ${p}[${h}])` : (0, t._)`${s} === ${v}`;
      }
    }
  };
  return Fo.default = o, Fo;
}
var si;
function iw() {
  if (si) return xo;
  si = 1, Object.defineProperty(xo, "__esModule", { value: !0 });
  const t = GC(), e = XC(), a = JC(), o = ew(), n = tw(), r = aw(), s = ow(), i = nw(), l = rw(), f = sw(), u = [
    // number
    t.default,
    e.default,
    // string
    a.default,
    o.default,
    // object
    n.default,
    r.default,
    // array
    s.default,
    i.default,
    // any
    { keyword: "type", schemaType: ["string", "array"] },
    { keyword: "nullable", schemaType: "boolean" },
    l.default,
    f.default
  ];
  return xo.default = u, xo;
}
var Bo = {}, pa = {}, ii;
function ml() {
  if (ii) return pa;
  ii = 1, Object.defineProperty(pa, "__esModule", { value: !0 }), pa.validateAdditionalItems = void 0;
  const t = Fe(), e = We(), a = {
    keyword: "additionalItems",
    type: "array",
    schemaType: ["boolean", "object"],
    before: "uniqueItems",
    error: {
      message: ({ params: { len: n } }) => (0, t.str)`must NOT have more than ${n} items`,
      params: ({ params: { len: n } }) => (0, t._)`{limit: ${n}}`
    },
    code(n) {
      const { parentSchema: r, it: s } = n, { items: i } = r;
      if (!Array.isArray(i)) {
        (0, e.checkStrictMode)(s, '"additionalItems" is ignored when "items" is not an array of schemas');
        return;
      }
      o(n, i);
    }
  };
  function o(n, r) {
    const { gen: s, schema: i, data: l, keyword: f, it: u } = n;
    u.items = !0;
    const d = s.const("len", (0, t._)`${l}.length`);
    if (i === !1)
      n.setParams({ len: r.length }), n.pass((0, t._)`${d} <= ${r.length}`);
    else if (typeof i == "object" && !(0, e.alwaysValidSchema)(u, i)) {
      const y = s.var("valid", (0, t._)`${d} <= ${r.length}`);
      s.if((0, t.not)(y), () => k(y)), n.ok(y);
    }
    function k(y) {
      s.forRange("i", r.length, d, (b) => {
        n.subschema({ keyword: f, dataProp: b, dataPropType: e.Type.Num }, y), u.allErrors || s.if((0, t.not)(y), () => s.break());
      });
    }
  }
  return pa.validateAdditionalItems = o, pa.default = a, pa;
}
var Io = {}, fa = {}, li;
function pl() {
  if (li) return fa;
  li = 1, Object.defineProperty(fa, "__esModule", { value: !0 }), fa.validateTuple = void 0;
  const t = Fe(), e = We(), a = nt(), o = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "array", "boolean"],
    before: "uniqueItems",
    code(r) {
      const { schema: s, it: i } = r;
      if (Array.isArray(s))
        return n(r, "additionalItems", s);
      i.items = !0, !(0, e.alwaysValidSchema)(i, s) && r.ok((0, a.validateArray)(r));
    }
  };
  function n(r, s, i = r.schema) {
    const { gen: l, parentSchema: f, data: u, keyword: d, it: k } = r;
    M(f), k.opts.unevaluated && i.length && k.items !== !0 && (k.items = e.mergeEvaluated.items(l, i.length, k.items));
    const y = l.name("valid"), b = l.const("len", (0, t._)`${u}.length`);
    i.forEach((c, p) => {
      (0, e.alwaysValidSchema)(k, c) || (l.if((0, t._)`${b} > ${p}`, () => r.subschema({
        keyword: d,
        schemaProp: p,
        dataProp: p
      }, y)), r.ok(y));
    });
    function M(c) {
      const { opts: p, errSchemaPath: h } = k, v = i.length, H = v === c.minItems && (v === c.maxItems || c[s] === !1);
      if (p.strictTuples && !H) {
        const w = `"${d}" is ${v}-tuple, but minItems or maxItems/${s} are not specified or different at path "${h}"`;
        (0, e.checkStrictMode)(k, w, p.strictTuples);
      }
    }
  }
  return fa.validateTuple = n, fa.default = o, fa;
}
var ui;
function lw() {
  if (ui) return Io;
  ui = 1, Object.defineProperty(Io, "__esModule", { value: !0 });
  const t = pl(), e = {
    keyword: "prefixItems",
    type: "array",
    schemaType: ["array"],
    before: "uniqueItems",
    code: (a) => (0, t.validateTuple)(a, "items")
  };
  return Io.default = e, Io;
}
var Zo = {}, ci;
function uw() {
  if (ci) return Zo;
  ci = 1, Object.defineProperty(Zo, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = nt(), o = ml(), n = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    error: {
      message: ({ params: { len: r } }) => (0, t.str)`must NOT have more than ${r} items`,
      params: ({ params: { len: r } }) => (0, t._)`{limit: ${r}}`
    },
    code(r) {
      const { schema: s, parentSchema: i, it: l } = r, { prefixItems: f } = i;
      l.items = !0, !(0, e.alwaysValidSchema)(l, s) && (f ? (0, o.validateAdditionalItems)(r, f) : r.ok((0, a.validateArray)(r)));
    }
  };
  return Zo.default = n, Zo;
}
var Ro = {}, di;
function cw() {
  if (di) return Ro;
  di = 1, Object.defineProperty(Ro, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = {
    keyword: "contains",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    trackErrors: !0,
    error: {
      message: ({ params: { min: o, max: n } }) => n === void 0 ? (0, t.str)`must contain at least ${o} valid item(s)` : (0, t.str)`must contain at least ${o} and no more than ${n} valid item(s)`,
      params: ({ params: { min: o, max: n } }) => n === void 0 ? (0, t._)`{minContains: ${o}}` : (0, t._)`{minContains: ${o}, maxContains: ${n}}`
    },
    code(o) {
      const { gen: n, schema: r, parentSchema: s, data: i, it: l } = o;
      let f, u;
      const { minContains: d, maxContains: k } = s;
      l.opts.next ? (f = d === void 0 ? 1 : d, u = k) : f = 1;
      const y = n.const("len", (0, t._)`${i}.length`);
      if (o.setParams({ min: f, max: u }), u === void 0 && f === 0) {
        (0, e.checkStrictMode)(l, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
        return;
      }
      if (u !== void 0 && f > u) {
        (0, e.checkStrictMode)(l, '"minContains" > "maxContains" is always invalid'), o.fail();
        return;
      }
      if ((0, e.alwaysValidSchema)(l, r)) {
        let h = (0, t._)`${y} >= ${f}`;
        u !== void 0 && (h = (0, t._)`${h} && ${y} <= ${u}`), o.pass(h);
        return;
      }
      l.items = !0;
      const b = n.name("valid");
      u === void 0 && f === 1 ? c(b, () => n.if(b, () => n.break())) : f === 0 ? (n.let(b, !0), u !== void 0 && n.if((0, t._)`${i}.length > 0`, M)) : (n.let(b, !1), M()), o.result(b, () => o.reset());
      function M() {
        const h = n.name("_valid"), v = n.let("count", 0);
        c(h, () => n.if(h, () => p(v)));
      }
      function c(h, v) {
        n.forRange("i", 0, y, (H) => {
          o.subschema({
            keyword: "contains",
            dataProp: H,
            dataPropType: e.Type.Num,
            compositeRule: !0
          }, h), v();
        });
      }
      function p(h) {
        n.code((0, t._)`${h}++`), u === void 0 ? n.if((0, t._)`${h} >= ${f}`, () => n.assign(b, !0).break()) : (n.if((0, t._)`${h} > ${u}`, () => n.assign(b, !1).break()), f === 1 ? n.assign(b, !0) : n.if((0, t._)`${h} >= ${f}`, () => n.assign(b, !0)));
      }
    }
  };
  return Ro.default = a, Ro;
}
var mi = {}, pi;
function dw() {
  return pi || (pi = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.validateSchemaDeps = t.validatePropertyDeps = t.error = void 0;
    const e = Fe(), a = We(), o = nt();
    t.error = {
      message: ({ params: { property: l, depsCount: f, deps: u } }) => {
        const d = f === 1 ? "property" : "properties";
        return (0, e.str)`must have ${d} ${u} when property ${l} is present`;
      },
      params: ({ params: { property: l, depsCount: f, deps: u, missingProperty: d } }) => (0, e._)`{property: ${l},
    missingProperty: ${d},
    depsCount: ${f},
    deps: ${u}}`
      // TODO change to reference
    };
    const n = {
      keyword: "dependencies",
      type: "object",
      schemaType: "object",
      error: t.error,
      code(l) {
        const [f, u] = r(l);
        s(l, f), i(l, u);
      }
    };
    function r({ schema: l }) {
      const f = {}, u = {};
      for (const d in l) {
        if (d === "__proto__")
          continue;
        const k = Array.isArray(l[d]) ? f : u;
        k[d] = l[d];
      }
      return [f, u];
    }
    function s(l, f = l.schema) {
      const { gen: u, data: d, it: k } = l;
      if (Object.keys(f).length === 0)
        return;
      const y = u.let("missing");
      for (const b in f) {
        const M = f[b];
        if (M.length === 0)
          continue;
        const c = (0, o.propertyInData)(u, d, b, k.opts.ownProperties);
        l.setParams({
          property: b,
          depsCount: M.length,
          deps: M.join(", ")
        }), k.allErrors ? u.if(c, () => {
          for (const p of M)
            (0, o.checkReportMissingProp)(l, p);
        }) : (u.if((0, e._)`${c} && (${(0, o.checkMissingProp)(l, M, y)})`), (0, o.reportMissingProp)(l, y), u.else());
      }
    }
    t.validatePropertyDeps = s;
    function i(l, f = l.schema) {
      const { gen: u, data: d, keyword: k, it: y } = l, b = u.name("valid");
      for (const M in f)
        (0, a.alwaysValidSchema)(y, f[M]) || (u.if(
          (0, o.propertyInData)(u, d, M, y.opts.ownProperties),
          () => {
            const c = l.subschema({ keyword: k, schemaProp: M }, b);
            l.mergeValidEvaluated(c, b);
          },
          () => u.var(b, !0)
          // TODO var
        ), l.ok(b));
    }
    t.validateSchemaDeps = i, t.default = n;
  })(mi)), mi;
}
var No = {}, fi;
function mw() {
  if (fi) return No;
  fi = 1, Object.defineProperty(No, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = {
    keyword: "propertyNames",
    type: "object",
    schemaType: ["object", "boolean"],
    error: {
      message: "property name must be valid",
      params: ({ params: o }) => (0, t._)`{propertyName: ${o.propertyName}}`
    },
    code(o) {
      const { gen: n, schema: r, data: s, it: i } = o;
      if ((0, e.alwaysValidSchema)(i, r))
        return;
      const l = n.name("valid");
      n.forIn("key", s, (f) => {
        o.setParams({ propertyName: f }), o.subschema({
          keyword: "propertyNames",
          data: f,
          dataTypes: ["string"],
          propertyName: f,
          compositeRule: !0
        }, l), n.if((0, t.not)(l), () => {
          o.error(!0), i.allErrors || n.break();
        });
      }), o.ok(l);
    }
  };
  return No.default = a, No;
}
var qo = {}, hi;
function fl() {
  if (hi) return qo;
  hi = 1, Object.defineProperty(qo, "__esModule", { value: !0 });
  const t = nt(), e = Fe(), a = Zt(), o = We(), n = {
    keyword: "additionalProperties",
    type: ["object"],
    schemaType: ["boolean", "object"],
    allowUndefined: !0,
    trackErrors: !0,
    error: {
      message: "must NOT have additional properties",
      params: ({ params: r }) => (0, e._)`{additionalProperty: ${r.additionalProperty}}`
    },
    code(r) {
      const { gen: s, schema: i, parentSchema: l, data: f, errsCount: u, it: d } = r;
      if (!u)
        throw new Error("ajv implementation error");
      const { allErrors: k, opts: y } = d;
      if (d.props = !0, y.removeAdditional !== "all" && (0, o.alwaysValidSchema)(d, i))
        return;
      const b = (0, t.allSchemaProperties)(l.properties), M = (0, t.allSchemaProperties)(l.patternProperties);
      c(), r.ok((0, e._)`${u} === ${a.default.errors}`);
      function c() {
        s.forIn("key", f, (w) => {
          !b.length && !M.length ? v(w) : s.if(p(w), () => v(w));
        });
      }
      function p(w) {
        let _;
        if (b.length > 8) {
          const L = (0, o.schemaRefOrVal)(d, l.properties, "properties");
          _ = (0, t.isOwnProperty)(s, L, w);
        } else b.length ? _ = (0, e.or)(...b.map((L) => (0, e._)`${w} === ${L}`)) : _ = e.nil;
        return M.length && (_ = (0, e.or)(_, ...M.map((L) => (0, e._)`${(0, t.usePattern)(r, L)}.test(${w})`))), (0, e.not)(_);
      }
      function h(w) {
        s.code((0, e._)`delete ${f}[${w}]`);
      }
      function v(w) {
        if (y.removeAdditional === "all" || y.removeAdditional && i === !1) {
          h(w);
          return;
        }
        if (i === !1) {
          r.setParams({ additionalProperty: w }), r.error(), k || s.break();
          return;
        }
        if (typeof i == "object" && !(0, o.alwaysValidSchema)(d, i)) {
          const _ = s.name("valid");
          y.removeAdditional === "failing" ? (H(w, _, !1), s.if((0, e.not)(_), () => {
            r.reset(), h(w);
          })) : (H(w, _), k || s.if((0, e.not)(_), () => s.break()));
        }
      }
      function H(w, _, L) {
        const I = {
          keyword: "additionalProperties",
          dataProp: w,
          dataPropType: o.Type.Str
        };
        L === !1 && Object.assign(I, {
          compositeRule: !0,
          createErrors: !1,
          allErrors: !1
        }), r.subschema(I, _);
      }
    }
  };
  return qo.default = n, qo;
}
var Uo = {}, vi;
function pw() {
  if (vi) return Uo;
  vi = 1, Object.defineProperty(Uo, "__esModule", { value: !0 });
  const t = Mn(), e = nt(), a = We(), o = fl(), n = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code(r) {
      const { gen: s, schema: i, parentSchema: l, data: f, it: u } = r;
      u.opts.removeAdditional === "all" && l.additionalProperties === void 0 && o.default.code(new t.KeywordCxt(u, o.default, "additionalProperties"));
      const d = (0, e.allSchemaProperties)(i);
      for (const c of d)
        u.definedProperties.add(c);
      u.opts.unevaluated && d.length && u.props !== !0 && (u.props = a.mergeEvaluated.props(s, (0, a.toHash)(d), u.props));
      const k = d.filter((c) => !(0, a.alwaysValidSchema)(u, i[c]));
      if (k.length === 0)
        return;
      const y = s.name("valid");
      for (const c of k)
        b(c) ? M(c) : (s.if((0, e.propertyInData)(s, f, c, u.opts.ownProperties)), M(c), u.allErrors || s.else().var(y, !0), s.endIf()), r.it.definedProperties.add(c), r.ok(y);
      function b(c) {
        return u.opts.useDefaults && !u.compositeRule && i[c].default !== void 0;
      }
      function M(c) {
        r.subschema({
          keyword: "properties",
          schemaProp: c,
          dataProp: c
        }, y);
      }
    }
  };
  return Uo.default = n, Uo;
}
var Yo = {}, gi;
function fw() {
  if (gi) return Yo;
  gi = 1, Object.defineProperty(Yo, "__esModule", { value: !0 });
  const t = nt(), e = Fe(), a = We(), o = We(), n = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code(r) {
      const { gen: s, schema: i, data: l, parentSchema: f, it: u } = r, { opts: d } = u, k = (0, t.allSchemaProperties)(i), y = k.filter((H) => (0, a.alwaysValidSchema)(u, i[H]));
      if (k.length === 0 || y.length === k.length && (!u.opts.unevaluated || u.props === !0))
        return;
      const b = d.strictSchema && !d.allowMatchingProperties && f.properties, M = s.name("valid");
      u.props !== !0 && !(u.props instanceof e.Name) && (u.props = (0, o.evaluatedPropsToName)(s, u.props));
      const { props: c } = u;
      p();
      function p() {
        for (const H of k)
          b && h(H), u.allErrors ? v(H) : (s.var(M, !0), v(H), s.if(M));
      }
      function h(H) {
        for (const w in b)
          new RegExp(H).test(w) && (0, a.checkStrictMode)(u, `property ${w} matches pattern ${H} (use allowMatchingProperties)`);
      }
      function v(H) {
        s.forIn("key", l, (w) => {
          s.if((0, e._)`${(0, t.usePattern)(r, H)}.test(${w})`, () => {
            const _ = y.includes(H);
            _ || r.subschema({
              keyword: "patternProperties",
              schemaProp: H,
              dataProp: w,
              dataPropType: o.Type.Str
            }, M), u.opts.unevaluated && c !== !0 ? s.assign((0, e._)`${c}[${w}]`, !0) : !_ && !u.allErrors && s.if((0, e.not)(M), () => s.break());
          });
        });
      }
    }
  };
  return Yo.default = n, Yo;
}
var Wo = {}, yi;
function hw() {
  if (yi) return Wo;
  yi = 1, Object.defineProperty(Wo, "__esModule", { value: !0 });
  const t = We(), e = {
    keyword: "not",
    schemaType: ["object", "boolean"],
    trackErrors: !0,
    code(a) {
      const { gen: o, schema: n, it: r } = a;
      if ((0, t.alwaysValidSchema)(r, n)) {
        a.fail();
        return;
      }
      const s = o.name("valid");
      a.subschema({
        keyword: "not",
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }, s), a.failResult(s, () => a.reset(), () => a.error());
    },
    error: { message: "must NOT be valid" }
  };
  return Wo.default = e, Wo;
}
var Ko = {}, bi;
function vw() {
  if (bi) return Ko;
  bi = 1, Object.defineProperty(Ko, "__esModule", { value: !0 });
  const t = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: !0,
    code: nt().validateUnion,
    error: { message: "must match a schema in anyOf" }
  };
  return Ko.default = t, Ko;
}
var Go = {}, ki;
function gw() {
  if (ki) return Go;
  ki = 1, Object.defineProperty(Go, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: !0,
    error: {
      message: "must match exactly one schema in oneOf",
      params: ({ params: o }) => (0, t._)`{passingSchemas: ${o.passing}}`
    },
    code(o) {
      const { gen: n, schema: r, parentSchema: s, it: i } = o;
      if (!Array.isArray(r))
        throw new Error("ajv implementation error");
      if (i.opts.discriminator && s.discriminator)
        return;
      const l = r, f = n.let("valid", !1), u = n.let("passing", null), d = n.name("_valid");
      o.setParams({ passing: u }), n.block(k), o.result(f, () => o.reset(), () => o.error(!0));
      function k() {
        l.forEach((y, b) => {
          let M;
          (0, e.alwaysValidSchema)(i, y) ? n.var(d, !0) : M = o.subschema({
            keyword: "oneOf",
            schemaProp: b,
            compositeRule: !0
          }, d), b > 0 && n.if((0, t._)`${d} && ${f}`).assign(f, !1).assign(u, (0, t._)`[${u}, ${b}]`).else(), n.if(d, () => {
            n.assign(f, !0), n.assign(u, b), M && o.mergeEvaluated(M, t.Name);
          });
        });
      }
    }
  };
  return Go.default = a, Go;
}
var Xo = {}, Ci;
function yw() {
  if (Ci) return Xo;
  Ci = 1, Object.defineProperty(Xo, "__esModule", { value: !0 });
  const t = We(), e = {
    keyword: "allOf",
    schemaType: "array",
    code(a) {
      const { gen: o, schema: n, it: r } = a;
      if (!Array.isArray(n))
        throw new Error("ajv implementation error");
      const s = o.name("valid");
      n.forEach((i, l) => {
        if ((0, t.alwaysValidSchema)(r, i))
          return;
        const f = a.subschema({ keyword: "allOf", schemaProp: l }, s);
        a.ok(s), a.mergeEvaluated(f);
      });
    }
  };
  return Xo.default = e, Xo;
}
var Qo = {}, wi;
function bw() {
  if (wi) return Qo;
  wi = 1, Object.defineProperty(Qo, "__esModule", { value: !0 });
  const t = Fe(), e = We(), a = {
    keyword: "if",
    schemaType: ["object", "boolean"],
    trackErrors: !0,
    error: {
      message: ({ params: n }) => (0, t.str)`must match "${n.ifClause}" schema`,
      params: ({ params: n }) => (0, t._)`{failingKeyword: ${n.ifClause}}`
    },
    code(n) {
      const { gen: r, parentSchema: s, it: i } = n;
      s.then === void 0 && s.else === void 0 && (0, e.checkStrictMode)(i, '"if" without "then" and "else" is ignored');
      const l = o(i, "then"), f = o(i, "else");
      if (!l && !f)
        return;
      const u = r.let("valid", !0), d = r.name("_valid");
      if (k(), n.reset(), l && f) {
        const b = r.let("ifClause");
        n.setParams({ ifClause: b }), r.if(d, y("then", b), y("else", b));
      } else l ? r.if(d, y("then")) : r.if((0, t.not)(d), y("else"));
      n.pass(u, () => n.error(!0));
      function k() {
        const b = n.subschema({
          keyword: "if",
          compositeRule: !0,
          createErrors: !1,
          allErrors: !1
        }, d);
        n.mergeEvaluated(b);
      }
      function y(b, M) {
        return () => {
          const c = n.subschema({ keyword: b }, d);
          r.assign(u, d), n.mergeValidEvaluated(c, u), M ? r.assign(M, (0, t._)`${b}`) : n.setParams({ ifClause: b });
        };
      }
    }
  };
  function o(n, r) {
    const s = n.schema[r];
    return s !== void 0 && !(0, e.alwaysValidSchema)(n, s);
  }
  return Qo.default = a, Qo;
}
var Jo = {}, _i;
function kw() {
  if (_i) return Jo;
  _i = 1, Object.defineProperty(Jo, "__esModule", { value: !0 });
  const t = We(), e = {
    keyword: ["then", "else"],
    schemaType: ["object", "boolean"],
    code({ keyword: a, parentSchema: o, it: n }) {
      o.if === void 0 && (0, t.checkStrictMode)(n, `"${a}" without "if" is ignored`);
    }
  };
  return Jo.default = e, Jo;
}
var Hi;
function Cw() {
  if (Hi) return Bo;
  Hi = 1, Object.defineProperty(Bo, "__esModule", { value: !0 });
  const t = ml(), e = lw(), a = pl(), o = uw(), n = cw(), r = dw(), s = mw(), i = fl(), l = pw(), f = fw(), u = hw(), d = vw(), k = gw(), y = yw(), b = bw(), M = kw();
  function c(p = !1) {
    const h = [
      // any
      u.default,
      d.default,
      k.default,
      y.default,
      b.default,
      M.default,
      // object
      s.default,
      i.default,
      r.default,
      l.default,
      f.default
    ];
    return p ? h.push(e.default, o.default) : h.push(t.default, a.default), h.push(n.default), h;
  }
  return Bo.default = c, Bo;
}
var en = {}, tn = {}, ji;
function ww() {
  if (ji) return tn;
  ji = 1, Object.defineProperty(tn, "__esModule", { value: !0 });
  const t = Fe(), e = {
    keyword: "format",
    type: ["number", "string"],
    schemaType: "string",
    $data: !0,
    error: {
      message: ({ schemaCode: a }) => (0, t.str)`must match format "${a}"`,
      params: ({ schemaCode: a }) => (0, t._)`{format: ${a}}`
    },
    code(a, o) {
      const { gen: n, data: r, $data: s, schema: i, schemaCode: l, it: f } = a, { opts: u, errSchemaPath: d, schemaEnv: k, self: y } = f;
      if (!u.validateFormats)
        return;
      s ? b() : M();
      function b() {
        const c = n.scopeValue("formats", {
          ref: y.formats,
          code: u.code.formats
        }), p = n.const("fDef", (0, t._)`${c}[${l}]`), h = n.let("fType"), v = n.let("format");
        n.if((0, t._)`typeof ${p} == "object" && !(${p} instanceof RegExp)`, () => n.assign(h, (0, t._)`${p}.type || "string"`).assign(v, (0, t._)`${p}.validate`), () => n.assign(h, (0, t._)`"string"`).assign(v, p)), a.fail$data((0, t.or)(H(), w()));
        function H() {
          return u.strictSchema === !1 ? t.nil : (0, t._)`${l} && !${v}`;
        }
        function w() {
          const _ = k.$async ? (0, t._)`(${p}.async ? await ${v}(${r}) : ${v}(${r}))` : (0, t._)`${v}(${r})`, L = (0, t._)`(typeof ${v} == "function" ? ${_} : ${v}.test(${r}))`;
          return (0, t._)`${v} && ${v} !== true && ${h} === ${o} && !${L}`;
        }
      }
      function M() {
        const c = y.formats[i];
        if (!c) {
          H();
          return;
        }
        if (c === !0)
          return;
        const [p, h, v] = w(c);
        p === o && a.pass(_());
        function H() {
          if (u.strictSchema === !1) {
            y.logger.warn(L());
            return;
          }
          throw new Error(L());
          function L() {
            return `unknown format "${i}" ignored in schema at path "${d}"`;
          }
        }
        function w(L) {
          const I = L instanceof RegExp ? (0, t.regexpCode)(L) : u.code.formats ? (0, t._)`${u.code.formats}${(0, t.getProperty)(i)}` : void 0, F = n.scopeValue("formats", { key: i, ref: L, code: I });
          return typeof L == "object" && !(L instanceof RegExp) ? [L.type || "string", L.validate, (0, t._)`${F}.validate`] : ["string", L, F];
        }
        function _() {
          if (typeof c == "object" && !(c instanceof RegExp) && c.async) {
            if (!k.$async)
              throw new Error("async format in sync schema");
            return (0, t._)`await ${v}(${r})`;
          }
          return typeof h == "function" ? (0, t._)`${v}(${r})` : (0, t._)`${v}.test(${r})`;
        }
      }
    }
  };
  return tn.default = e, tn;
}
var Li;
function _w() {
  if (Li) return en;
  Li = 1, Object.defineProperty(en, "__esModule", { value: !0 });
  const t = [ww().default];
  return en.default = t, en;
}
var ha = {}, xi;
function Hw() {
  return xi || (xi = 1, Object.defineProperty(ha, "__esModule", { value: !0 }), ha.contentVocabulary = ha.metadataVocabulary = void 0, ha.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
  ], ha.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
  ]), ha;
}
var $i;
function jw() {
  if ($i) return Ho;
  $i = 1, Object.defineProperty(Ho, "__esModule", { value: !0 });
  const t = KC(), e = iw(), a = Cw(), o = _w(), n = Hw(), r = [
    t.default,
    e.default,
    (0, a.default)(),
    o.default,
    n.metadataVocabulary,
    n.contentVocabulary
  ];
  return Ho.default = r, Ho;
}
var an = {}, Wa = {}, Mi;
function Lw() {
  if (Mi) return Wa;
  Mi = 1, Object.defineProperty(Wa, "__esModule", { value: !0 }), Wa.DiscrError = void 0;
  var t;
  return (function(e) {
    e.Tag = "tag", e.Mapping = "mapping";
  })(t || (Wa.DiscrError = t = {})), Wa;
}
var Vi;
function xw() {
  if (Vi) return an;
  Vi = 1, Object.defineProperty(an, "__esModule", { value: !0 });
  const t = Fe(), e = Lw(), a = d0(), o = Vn(), n = We(), r = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: {
      message: ({ params: { discrError: s, tagName: i } }) => s === e.DiscrError.Tag ? `tag "${i}" must be string` : `value of tag "${i}" must be in oneOf`,
      params: ({ params: { discrError: s, tag: i, tagName: l } }) => (0, t._)`{error: ${s}, tag: ${l}, tagValue: ${i}}`
    },
    code(s) {
      const { gen: i, data: l, schema: f, parentSchema: u, it: d } = s, { oneOf: k } = u;
      if (!d.opts.discriminator)
        throw new Error("discriminator: requires discriminator option");
      const y = f.propertyName;
      if (typeof y != "string")
        throw new Error("discriminator: requires propertyName");
      if (f.mapping)
        throw new Error("discriminator: mapping is not supported");
      if (!k)
        throw new Error("discriminator: requires oneOf keyword");
      const b = i.let("valid", !1), M = i.const("tag", (0, t._)`${l}${(0, t.getProperty)(y)}`);
      i.if((0, t._)`typeof ${M} == "string"`, () => c(), () => s.error(!1, { discrError: e.DiscrError.Tag, tag: M, tagName: y })), s.ok(b);
      function c() {
        const v = h();
        i.if(!1);
        for (const H in v)
          i.elseIf((0, t._)`${M} === ${H}`), i.assign(b, p(v[H]));
        i.else(), s.error(!1, { discrError: e.DiscrError.Mapping, tag: M, tagName: y }), i.endIf();
      }
      function p(v) {
        const H = i.name("valid"), w = s.subschema({ keyword: "oneOf", schemaProp: v }, H);
        return s.mergeEvaluated(w, t.Name), H;
      }
      function h() {
        var v;
        const H = {}, w = L(u);
        let _ = !0;
        for (let B = 0; B < k.length; B++) {
          let K = k[B];
          if (K?.$ref && !(0, n.schemaHasRulesButRef)(K, d.self.RULES)) {
            const ve = K.$ref;
            if (K = a.resolveRef.call(d.self, d.schemaEnv.root, d.baseId, ve), K instanceof a.SchemaEnv && (K = K.schema), K === void 0)
              throw new o.default(d.opts.uriResolver, d.baseId, ve);
          }
          const ee = (v = K?.properties) === null || v === void 0 ? void 0 : v[y];
          if (typeof ee != "object")
            throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${y}"`);
          _ = _ && (w || L(K)), I(ee, B);
        }
        if (!_)
          throw new Error(`discriminator: "${y}" must be required`);
        return H;
        function L({ required: B }) {
          return Array.isArray(B) && B.includes(y);
        }
        function I(B, K) {
          if (B.const)
            F(B.const, K);
          else if (B.enum)
            for (const ee of B.enum)
              F(ee, K);
          else
            throw new Error(`discriminator: "properties/${y}" must have "const" or "enum"`);
        }
        function F(B, K) {
          if (typeof B != "string" || B in H)
            throw new Error(`discriminator: "${y}" values must be unique strings`);
          H[B] = K;
        }
      }
    }
  };
  return an.default = r, an;
}
const $w = "http://json-schema.org/draft-07/schema#", Mw = "http://json-schema.org/draft-07/schema#", Vw = "Core schema meta-schema", Sw = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } }, Aw = ["object", "boolean"], Ew = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: !0, readOnly: { type: "boolean", default: !1 }, examples: { type: "array", items: !0 }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, Dw = {
  $schema: $w,
  $id: Mw,
  title: Vw,
  definitions: Sw,
  type: Aw,
  properties: Ew,
  default: !0
};
var Si;
function Pw() {
  return Si || (Si = 1, (function(t, e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MissingRefError = e.ValidationError = e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = e.Ajv = void 0;
    const a = UC(), o = jw(), n = xw(), r = Dw, s = ["/properties"], i = "http://json-schema.org/draft-07/schema";
    class l extends a.default {
      _addVocabularies() {
        super._addVocabularies(), o.default.forEach((b) => this.addVocabulary(b)), this.opts.discriminator && this.addKeyword(n.default);
      }
      _addDefaultMetaSchema() {
        if (super._addDefaultMetaSchema(), !this.opts.meta)
          return;
        const b = this.opts.$data ? this.$dataMetaSchema(r, s) : r;
        this.addMetaSchema(b, i, !1), this.refs["http://json-schema.org/schema"] = i;
      }
      defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(i) ? i : void 0);
      }
    }
    e.Ajv = l, t.exports = e = l, t.exports.Ajv = l, Object.defineProperty(e, "__esModule", { value: !0 }), e.default = l;
    var f = Mn();
    Object.defineProperty(e, "KeywordCxt", { enumerable: !0, get: function() {
      return f.KeywordCxt;
    } });
    var u = Fe();
    Object.defineProperty(e, "_", { enumerable: !0, get: function() {
      return u._;
    } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
      return u.str;
    } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
      return u.stringify;
    } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
      return u.nil;
    } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
      return u.Name;
    } }), Object.defineProperty(e, "CodeGen", { enumerable: !0, get: function() {
      return u.CodeGen;
    } });
    var d = c0();
    Object.defineProperty(e, "ValidationError", { enumerable: !0, get: function() {
      return d.default;
    } });
    var k = Vn();
    Object.defineProperty(e, "MissingRefError", { enumerable: !0, get: function() {
      return k.default;
    } });
  })(hr, hr.exports)), hr.exports;
}
var zw = Pw();
const Tw = /* @__PURE__ */ $C(zw), hl = new Tw({ allErrors: !0 });
hl.addFormat("uuid", /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
hl.addFormat("date-time", /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/);
function Ow(t) {
  return async (e) => {
    const { request: a } = e;
    return a.headers.has("Authorization") ? t(e) : new ut(null, {
      status: Er.Unauthorized,
      statusText: "Unauthorized"
    });
  };
}
const j1 = {
  insurance: "insurance",
  oversizedPackage: "oversizedPackage",
  requiresCashOnDelivery: "requiresCashOnDelivery",
  recipientOnlyDelivery: "recipientOnlyDelivery",
  requiresAgeVerification: "requiresAgeVerification",
  requiresReceiptCode: "requiresReceiptCode",
  requiresSignature: "requiresSignature",
  returnOnFirstFailedDelivery: "returnOnFirstFailedDelivery",
  scheduledCollection: "scheduledCollection"
}, Fw = () => ({
  length: {
    min: {
      value: 1,
      unit: "cm"
    },
    max: {
      value: 175,
      unit: "cm"
    },
    calculation: ""
  },
  width: {
    min: {
      value: 1,
      unit: "cm"
    },
    max: {
      value: 78,
      unit: "cm"
    },
    calculation: ""
  },
  height: {
    min: {
      value: 1,
      unit: "cm"
    },
    max: {
      value: 58,
      unit: "cm"
    },
    calculation: ""
  },
  weight: {
    min: {
      value: 1,
      unit: "g"
    },
    max: {
      value: 3e4,
      unit: "g"
    },
    calculation: ""
  },
  volume: {
    min: {
      value: 1,
      unit: "g"
    },
    max: {
      value: 10,
      unit: "g"
    },
    calculation: "(length * width * height) / 1000"
  },
  girth: {
    min: {
      value: 1,
      unit: "cm"
    },
    max: {
      value: 300,
      unit: "cm"
    },
    calculation: "length + (2 * width) + (2 * height)"
  },
  volumetric_weight: {
    min: {
      value: 1,
      unit: "g"
    },
    max: {
      value: 30,
      unit: "g"
    },
    calculation: "(length * width * height) / 6000"
  },
  lwh_sum: {
    min: {
      value: 1,
      unit: "cm"
    },
    max: {
      value: 300,
      unit: "cm"
    },
    calculation: "(length + width + height)"
  }
}), Dr = {
  [j1.oversizedPackage]: {},
  [j1.recipientOnlyDelivery]: {},
  [j1.requiresSignature]: {},
  [j1.requiresAgeVerification]: {
    requires: [j1.recipientOnlyDelivery, j1.requiresSignature]
  },
  [j1.requiresReceiptCode]: {},
  [j1.returnOnFirstFailedDelivery]: {},
  [j1.insurance]: {
    insuredAmount: {
      default: {
        amount: 0,
        currency: "EUR"
      },
      max: {
        amount: 52e3,
        currency: "EUR"
      },
      min: {
        amount: 0,
        currency: "EUR"
      }
    }
  },
  [j1.requiresCashOnDelivery]: {}
}, Bw = (t) => {
  const e = {};
  for (const [a, o] of Object.entries(t)) {
    const n = a, r = {
      ...o,
      isRequired: o.isRequired ?? !1,
      isSelectedByDefault: o.isSelectedByDefault ?? !1,
      requires: o.requires ?? [],
      excludes: o.excludes ?? []
    };
    e[n] = r;
  }
  return e;
}, Iw = (t) => {
  const e = {};
  for (const [a, o] of Object.entries(t)) {
    const n = a;
    n === j1.scheduledCollection ? e[n] = {
      ...o,
      isRequired: !0,
      isSelectedByDefault: !0
    } : e[n] = o;
  }
  return e;
}, it = (t) => {
  const {
    carrier: e = X1.POSTNL,
    packageTypes: a = [
      I1.DIGITAL_STAMP,
      I1.UNFRANKED,
      I1.MAILBOX,
      I1.PACKAGE,
      I1.PALLET,
      I1.SMALL_PACKAGE
    ],
    options: o = Dr,
    collo: n = {
      max: 1
    },
    deliveryTypes: r = [rn.STANDARD_DELIVERY],
    transactionTypes: s = [us.B2B, us.B2C]
  } = t;
  return {
    carrier: e,
    packageTypes: a,
    options: Iw(Bw(o)),
    physicalProperties: Fw(),
    collo: n,
    deliveryTypes: r,
    transactionTypes: s
  };
}, Zw = (t) => cC.post(
  `${t}/shipments/capabilities`,
  Ow(async ({ request: e }) => {
    const a = await e.json(), o = [];
    return a.recipient?.countryCode || o.push({
      detail: "Required",
      pointer: "/body/recipient/countryCode"
    }), o.length ? xC(o) : ut.json(
      {
        results: [
          it({
            carrier: X1.BPOST
          }),
          it({
            carrier: X1.CHEAP_CARGO,
            packageTypes: [I1.PALLET],
            options: {}
          }),
          it({
            carrier: X1.DHL_EUROPLUS
          }),
          it({
            carrier: X1.DHL_FOR_YOU,
            options: {
              [j1.requiresSignature]: {
                excludes: [j1.recipientOnlyDelivery]
              },
              [j1.requiresReceiptCode]: {
                excludes: [j1.requiresSignature]
              }
            }
          }),
          it({
            carrier: X1.DHL_PARCEL_CONNECT
          }),
          it({
            carrier: X1.DPD,
            options: {
              ...Dr,
              [j1.insurance]: {
                insuredAmount: {
                  default: {
                    amount: 52e3,
                    currency: "EUR"
                  },
                  max: {
                    amount: 52e3,
                    currency: "EUR"
                  },
                  min: {
                    amount: 52e3,
                    currency: "EUR"
                  }
                }
              }
            }
          }),
          it({
            carrier: X1.GLS
          }),
          it({
            carrier: X1.POSTNL,
            collo: {
              max: 10
            },
            deliveryTypes: [
              rn.MORNING_DELIVERY,
              rn.STANDARD_DELIVERY,
              rn.EVENING_DELIVERY
            ]
          }),
          // Entire `UPS` network has `COLLECT` shipment option. Only set for `UPS_EXPRESS_SAVER` so we can test multiple scenarios.
          it({
            carrier: X1.UPS_EXPRESS_SAVER,
            options: {
              ...Dr,
              [j1.scheduledCollection]: {}
            }
          }),
          it({
            carrier: X1.UPS_STANDARD
          })
        ]
      },
      { status: 200 }
    );
  })
), Rw = "https://api.myparcel.nl";
Zw(Rw);
const Pr = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Nw = () => {
}, qw = (t) => t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && // uppercase letter
(t.charCodeAt(2) > 122 || t.charCodeAt(2) < 97), Sn = Object.assign, ft = Array.isArray, ia = (t) => typeof t == "function", Ot = (t) => typeof t == "string", Uw = (t) => typeof t == "symbol", Jt = (t) => t !== null && typeof t == "object";
let Ai;
const An = () => Ai || (Ai = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function p0(t) {
  if (ft(t)) {
    const e = {};
    for (let a = 0; a < t.length; a++) {
      const o = t[a], n = Ot(o) ? Gw(o) : p0(o);
      if (n)
        for (const r in n)
          e[r] = n[r];
    }
    return e;
  } else if (Ot(t) || Jt(t))
    return t;
}
const Yw = /;(?![^(]*\))/g, Ww = /:([^]+)/, Kw = /\/\*[^]*?\*\//g;
function Gw(t) {
  const e = {};
  return t.replace(Kw, "").split(Yw).forEach((a) => {
    if (a) {
      const o = a.split(Ww);
      o.length > 1 && (e[o[0].trim()] = o[1].trim());
    }
  }), e;
}
function f0(t) {
  let e = "";
  if (Ot(t))
    e = t;
  else if (ft(t))
    for (let a = 0; a < t.length; a++) {
      const o = f0(t[a]);
      o && (e += o + " ");
    }
  else if (Jt(t))
    for (const a in t)
      t[a] && (e += a + " ");
  return e.trim();
}
Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((t) => t !== "arguments" && t !== "caller").map((t) => Symbol[t]).filter(Uw)
);
function vl(t) {
  return zr(t) ? vl(t.__v_raw) : !!(t && t.__v_isReactive);
}
function zr(t) {
  return !!(t && t.__v_isReadonly);
}
function br(t) {
  return !!(t && t.__v_isShallow);
}
function Tr(t) {
  return t ? !!t.__v_raw : !1;
}
function ea(t) {
  const e = t && t.__v_raw;
  return e ? ea(e) : t;
}
function h0(t) {
  return t ? t.__v_isRef === !0 : !1;
}
/**
* @vue/runtime-core v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const ta = [];
function Xw(t) {
  ta.push(t);
}
function Qw() {
  ta.pop();
}
let kr = !1;
function oo(t, ...e) {
  if (kr) return;
  kr = !0;
  const a = ta.length ? ta[ta.length - 1].component : null, o = a && a.appContext.config.warnHandler, n = Jw();
  if (o)
    v0(
      o,
      a,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        t + e.map((r) => {
          var s, i;
          return (i = (s = r.toString) == null ? void 0 : s.call(r)) != null ? i : JSON.stringify(r);
        }).join(""),
        a && a.proxy,
        n.map(
          ({ vnode: r }) => `at <${Vl(a, r.type)}>`
        ).join(`
`),
        n
      ]
    );
  else {
    const r = [`[Vue warn]: ${t}`, ...e];
    n.length && r.push(`
`, ...e_(n)), console.warn(...r);
  }
  kr = !1;
}
function Jw() {
  let t = ta[ta.length - 1];
  if (!t)
    return [];
  const e = [];
  for (; t; ) {
    const a = e[0];
    a && a.vnode === t ? a.recurseCount++ : e.push({
      vnode: t,
      recurseCount: 0
    });
    const o = t.component && t.component.parent;
    t = o && o.vnode;
  }
  return e;
}
function e_(t) {
  const e = [];
  return t.forEach((a, o) => {
    e.push(...o === 0 ? [] : [`
`], ...t_(a));
  }), e;
}
function t_({ vnode: t, recurseCount: e }) {
  const a = e > 0 ? `... (${e} recursive calls)` : "", o = t.component ? t.component.parent == null : !1, n = ` at <${Vl(
    t.component,
    t.type,
    o
  )}`, r = ">" + a;
  return t.props ? [n, ...a_(t.props), r] : [n + r];
}
function a_(t) {
  const e = [], a = Object.keys(t);
  return a.slice(0, 3).forEach((o) => {
    e.push(...gl(o, t[o]));
  }), a.length > 3 && e.push(" ..."), e;
}
function gl(t, e, a) {
  return Ot(e) ? (e = JSON.stringify(e), a ? e : [`${t}=${e}`]) : typeof e == "number" || typeof e == "boolean" || e == null ? a ? e : [`${t}=${e}`] : h0(e) ? (e = gl(t, ea(e.value), !0), a ? e : [`${t}=Ref<`, e, ">"]) : ia(e) ? [`${t}=fn${e.name ? `<${e.name}>` : ""}`] : (e = ea(e), a ? e : [`${t}=`, e]);
}
const yl = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function v0(t, e, a, o) {
  try {
    return o ? t(...o) : t();
  } catch (n) {
    bl(n, e, a);
  }
}
function bl(t, e, a, o = !0) {
  const n = e ? e.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: s } = e && e.appContext.config || Pr;
  if (e) {
    let i = e.parent;
    const l = e.proxy, f = process.env.NODE_ENV !== "production" ? yl[a] : `https://vuejs.org/error-reference/#runtime-${a}`;
    for (; i; ) {
      const u = i.ec;
      if (u) {
        for (let d = 0; d < u.length; d++)
          if (u[d](t, l, f) === !1)
            return;
      }
      i = i.parent;
    }
    if (r) {
      v0(r, null, 10, [
        t,
        l,
        f
      ]);
      return;
    }
  }
  o_(t, a, n, o, s);
}
function o_(t, e, a, o = !0, n = !1) {
  if (process.env.NODE_ENV !== "production") {
    const r = yl[e];
    if (a && Xw(a), oo(`Unhandled error${r ? ` during execution of ${r}` : ""}`), a && Qw(), o)
      throw t;
    console.error(t);
  } else {
    if (n)
      throw t;
    console.error(t);
  }
}
const N1 = [];
let bt = -1;
const wa = [];
let At = null, ya = 0;
const n_ = /* @__PURE__ */ Promise.resolve();
let Or = null;
const r_ = 100;
function s_(t) {
  let e = bt + 1, a = N1.length;
  for (; e < a; ) {
    const o = e + a >>> 1, n = N1[o], r = no(n);
    r < t || r === t && n.flags & 2 ? e = o + 1 : a = o;
  }
  return e;
}
function i_(t) {
  if (!(t.flags & 1)) {
    const e = no(t), a = N1[N1.length - 1];
    !a || // fast path when the job id is larger than the tail
    !(t.flags & 2) && e >= no(a) ? N1.push(t) : N1.splice(s_(e), 0, t), t.flags |= 1, kl();
  }
}
function kl() {
  Or || (Or = n_.then(Cl));
}
function l_(t) {
  ft(t) ? wa.push(...t) : At && t.id === -1 ? At.splice(ya + 1, 0, t) : t.flags & 1 || (wa.push(t), t.flags |= 1), kl();
}
function u_(t) {
  if (wa.length) {
    const e = [...new Set(wa)].sort(
      (a, o) => no(a) - no(o)
    );
    if (wa.length = 0, At) {
      At.push(...e);
      return;
    }
    for (At = e, process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()), ya = 0; ya < At.length; ya++) {
      const a = At[ya];
      process.env.NODE_ENV !== "production" && wl(t, a) || (a.flags & 4 && (a.flags &= -2), a.flags & 8 || a(), a.flags &= -2);
    }
    At = null, ya = 0;
  }
}
const no = (t) => t.id == null ? t.flags & 2 ? -1 : 1 / 0 : t.id;
function Cl(t) {
  process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map());
  const e = process.env.NODE_ENV !== "production" ? (a) => wl(t, a) : Nw;
  try {
    for (bt = 0; bt < N1.length; bt++) {
      const a = N1[bt];
      if (a && !(a.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && e(a))
          continue;
        a.flags & 4 && (a.flags &= -2), v0(
          a,
          a.i,
          a.i ? 15 : 14
        ), a.flags & 4 || (a.flags &= -2);
      }
    }
  } finally {
    for (; bt < N1.length; bt++) {
      const a = N1[bt];
      a && (a.flags &= -2);
    }
    bt = -1, N1.length = 0, u_(t), Or = null, (N1.length || wa.length) && Cl(t);
  }
}
function wl(t, e) {
  const a = t.get(e) || 0;
  if (a > r_) {
    const o = e.i, n = o && Ml(o.type);
    return bl(
      `Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return t.set(e, a + 1), !1;
}
const Cr = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (An().__VUE_HMR_RUNTIME__ = {
  createRecord: wr(c_),
  rerender: wr(d_),
  reload: wr(m_)
});
const hn = /* @__PURE__ */ new Map();
function c_(t, e) {
  return hn.has(t) ? !1 : (hn.set(t, {
    initialDef: vn(e),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function vn(t) {
  return Sl(t) ? t.__vccOpts : t;
}
function d_(t, e) {
  const a = hn.get(t);
  a && (a.initialDef.render = e, [...a.instances].forEach((o) => {
    e && (o.render = e, vn(o.type).render = e), o.renderCache = [], o.job.flags & 8 || o.update();
  }));
}
function m_(t, e) {
  const a = hn.get(t);
  if (!a) return;
  e = vn(e), Ei(a.initialDef, e);
  const o = [...a.instances];
  for (let n = 0; n < o.length; n++) {
    const r = o[n], s = vn(r.type);
    let i = Cr.get(s);
    i || (s !== a.initialDef && Ei(s, e), Cr.set(s, i = /* @__PURE__ */ new Set())), i.add(r), r.appContext.propsCache.delete(r.type), r.appContext.emitsCache.delete(r.type), r.appContext.optionsCache.delete(r.type), r.ceReload ? (i.add(r), r.ceReload(e.styles), i.delete(r)) : r.parent ? i_(() => {
      r.parent.update(), i.delete(r);
    }) : r.appContext.reload ? r.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), r.root.ce && r !== r.root && r.root.ce._removeChildStyle(s);
  }
  l_(() => {
    Cr.clear();
  });
}
function Ei(t, e) {
  Sn(t, e);
  for (const a in t)
    a !== "__file" && !(a in e) && delete t[a];
}
function wr(t) {
  return (e, a) => {
    try {
      return t(e, a);
    } catch (o) {
      console.error(o), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let gn = null, p_ = null;
const f_ = (t) => t.__isTeleport;
function _l(t, e) {
  t.shapeFlag & 6 && t.component ? (t.transition = e, _l(t.component.subTree, e)) : t.shapeFlag & 128 ? (t.ssContent.transition = e.clone(t.ssContent), t.ssFallback.transition = e.clone(t.ssFallback)) : t.transition = e;
}
An().requestIdleCallback;
An().cancelIdleCallback;
const h_ = Symbol.for("v-ndc");
process.env.NODE_ENV;
const v_ = {}, Hl = (t) => Object.getPrototypeOf(t) === v_, g_ = (t) => t.__isSuspense, jl = Symbol.for("v-fgt"), y_ = Symbol.for("v-txt"), b_ = Symbol.for("v-cmt");
function k_(t) {
  return t ? t.__v_isVNode === !0 : !1;
}
const C_ = (...t) => xl(
  ...t
), Ll = ({ key: t }) => t ?? null, sn = ({
  ref: t,
  ref_key: e,
  ref_for: a
}) => (typeof t == "number" && (t = "" + t), t != null ? Ot(t) || h0(t) || ia(t) ? { i: gn, r: t, k: e, f: !!a } : t : null);
function w_(t, e = null, a = null, o = 0, n = null, r = t === jl ? 0 : 1, s = !1, i = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t,
    props: e,
    key: e && Ll(e),
    ref: e && sn(e),
    scopeId: p_,
    slotScopeIds: null,
    children: a,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: o,
    dynamicProps: n,
    dynamicChildren: null,
    appContext: null,
    ctx: gn
  };
  return i ? (g0(l, a), r & 128 && t.normalize(l)) : a && (l.shapeFlag |= Ot(a) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && oo("VNode created with invalid key (NaN). VNode type:", l.type), l;
}
const __ = process.env.NODE_ENV !== "production" ? C_ : xl;
function xl(t, e = null, a = null, o = 0, n = null, r = !1) {
  if ((!t || t === h_) && (process.env.NODE_ENV !== "production" && !t && oo(`Invalid vnode type when creating vnode: ${t}.`), t = b_), k_(t)) {
    const i = yn(
      t,
      e,
      !0
      /* mergeRef: true */
    );
    return a && g0(i, a), i.patchFlag = -2, i;
  }
  if (Sl(t) && (t = t.__vccOpts), e) {
    e = H_(e);
    let { class: i, style: l } = e;
    i && !Ot(i) && (e.class = f0(i)), Jt(l) && (Tr(l) && !ft(l) && (l = Sn({}, l)), e.style = p0(l));
  }
  const s = Ot(t) ? 1 : g_(t) ? 128 : f_(t) ? 64 : Jt(t) ? 4 : ia(t) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && s & 4 && Tr(t) && (t = ea(t), oo(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    t
  )), w_(
    t,
    e,
    a,
    o,
    n,
    s,
    r,
    !0
  );
}
function H_(t) {
  return t ? Tr(t) || Hl(t) ? Sn({}, t) : t : null;
}
function yn(t, e, a = !1, o = !1) {
  const { props: n, ref: r, patchFlag: s, children: i, transition: l } = t, f = e ? L_(n || {}, e) : n, u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t.type,
    props: f,
    key: f && Ll(f),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      a && r ? ft(r) ? r.concat(sn(e)) : [r, sn(e)] : sn(e)
    ) : r,
    scopeId: t.scopeId,
    slotScopeIds: t.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && s === -1 && ft(i) ? i.map($l) : i,
    target: t.target,
    targetStart: t.targetStart,
    targetAnchor: t.targetAnchor,
    staticCount: t.staticCount,
    shapeFlag: t.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && t.type !== jl ? s === -1 ? 16 : s | 16 : s,
    dynamicProps: t.dynamicProps,
    dynamicChildren: t.dynamicChildren,
    appContext: t.appContext,
    dirs: t.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: t.component,
    suspense: t.suspense,
    ssContent: t.ssContent && yn(t.ssContent),
    ssFallback: t.ssFallback && yn(t.ssFallback),
    placeholder: t.placeholder,
    el: t.el,
    anchor: t.anchor,
    ctx: t.ctx,
    ce: t.ce
  };
  return l && o && _l(
    u,
    l.clone(u)
  ), u;
}
function $l(t) {
  const e = yn(t);
  return ft(t.children) && (e.children = t.children.map($l)), e;
}
function j_(t = " ", e = 0) {
  return __(y_, null, t, e);
}
function g0(t, e) {
  let a = 0;
  const { shapeFlag: o } = t;
  if (e == null)
    e = null;
  else if (ft(e))
    a = 16;
  else if (typeof e == "object")
    if (o & 65) {
      const n = e.default;
      n && (n._c && (n._d = !1), g0(t, n()), n._c && (n._d = !0));
      return;
    } else
      a = 32, !e._ && !Hl(e) && (e._ctx = gn);
  else ia(e) ? (e = { default: e, _ctx: gn }, a = 32) : (e = String(e), o & 64 ? (a = 16, e = [j_(e)]) : a = 8);
  t.children = e, t.shapeFlag |= a;
}
function L_(...t) {
  const e = {};
  for (let a = 0; a < t.length; a++) {
    const o = t[a];
    for (const n in o)
      if (n === "class")
        e.class !== o.class && (e.class = f0([e.class, o.class]));
      else if (n === "style")
        e.style = p0([e.style, o.style]);
      else if (qw(n)) {
        const r = e[n], s = o[n];
        s && r !== s && !(ft(r) && r.includes(s)) && (e[n] = r ? [].concat(r, s) : s);
      } else n !== "" && (e[n] = o[n]);
  }
  return e;
}
{
  const t = An(), e = (a, o) => {
    let n;
    return (n = t[a]) || (n = t[a] = []), n.push(o), (r) => {
      n.length > 1 ? n.forEach((s) => s(r)) : n[0](r);
    };
  };
  e(
    "__VUE_INSTANCE_SETTERS__",
    (a) => a
  ), e(
    "__VUE_SSR_SETTERS__",
    (a) => a
  );
}
process.env.NODE_ENV;
const x_ = /(?:^|[-_])(\w)/g, $_ = (t) => t.replace(x_, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Ml(t, e = !0) {
  return ia(t) ? t.displayName || t.name : t.name || e && t.__name;
}
function Vl(t, e, a = !1) {
  let o = Ml(e);
  if (!o && e.__file) {
    const n = e.__file.match(/([^/\\]+)\.\w+$/);
    n && (o = n[1]);
  }
  if (!o && t && t.parent) {
    const n = (r) => {
      for (const s in r)
        if (r[s] === e)
          return s;
    };
    o = n(
      t.components || t.parent.type.components
    ) || n(t.appContext.components);
  }
  return o ? $_(o) : a ? "App" : "Anonymous";
}
function Sl(t) {
  return ia(t) && "__vccOpts" in t;
}
function M_() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const t = { style: "color:#3ba776" }, e = { style: "color:#1677ff" }, a = { style: "color:#f5222d" }, o = { style: "color:#eb2f96" }, n = {
    __vue_custom_formatter: !0,
    header(d) {
      if (!Jt(d))
        return null;
      if (d.__isVue)
        return ["div", t, "VueInstance"];
      if (h0(d)) {
        const k = d.value;
        return [
          "div",
          {},
          ["span", t, u(d)],
          "<",
          i(k),
          ">"
        ];
      } else {
        if (vl(d))
          return [
            "div",
            {},
            ["span", t, br(d) ? "ShallowReactive" : "Reactive"],
            "<",
            i(d),
            `>${zr(d) ? " (readonly)" : ""}`
          ];
        if (zr(d))
          return [
            "div",
            {},
            ["span", t, br(d) ? "ShallowReadonly" : "Readonly"],
            "<",
            i(d),
            ">"
          ];
      }
      return null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...r(d.$)
        ];
    }
  };
  function r(d) {
    const k = [];
    d.type.props && d.props && k.push(s("props", ea(d.props))), d.setupState !== Pr && k.push(s("setup", d.setupState)), d.data !== Pr && k.push(s("data", ea(d.data)));
    const y = l(d, "computed");
    y && k.push(s("computed", y));
    const b = l(d, "inject");
    return b && k.push(s("injected", b)), k.push([
      "div",
      {},
      [
        "span",
        {
          style: o.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), k;
  }
  function s(d, k) {
    return k = Sn({}, k), Object.keys(k).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(k).map((y) => [
          "div",
          {},
          ["span", o, y + ": "],
          i(k[y], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function i(d, k = !0) {
    return typeof d == "number" ? ["span", e, d] : typeof d == "string" ? ["span", a, JSON.stringify(d)] : typeof d == "boolean" ? ["span", o, d] : Jt(d) ? ["object", { object: k ? ea(d) : d }] : ["span", a, String(d)];
  }
  function l(d, k) {
    const y = d.type;
    if (ia(y))
      return;
    const b = {};
    for (const M in d.ctx)
      f(y, M, k) && (b[M] = d.ctx[M]);
    return b;
  }
  function f(d, k, y) {
    const b = d[y];
    if (ft(b) && b.includes(k) || Jt(b) && k in b || d.extends && f(d.extends, k, y) || d.mixins && d.mixins.some((M) => f(M, k, y)))
      return !0;
  }
  function u(d) {
    return br(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(n) : window.devtoolsFormatters = [n];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function V_() {
  M_();
}
process.env.NODE_ENV !== "production" && V_();
const y$ = /* @__PURE__ */ J({
  __name: "PackageTypeIcon",
  props: {
    packageTypeId: {}
  },
  setup(t) {
    const e = t, a = kn(), o = () => {
      switch (e.packageTypeId) {
        case ua.Package:
        case I1.PACKAGE:
          return Mv;
        case ua.Mailbox:
        case I1.MAILBOX:
          return vg;
        case ua.DigitalStamp:
        case I1.DIGITAL_STAMP:
          return mg;
        case ua.Letter:
        case I1.UNFRANKED:
          return Av;
        case ua.Pallet:
        case I1.PALLET:
          return rg;
        case ua.PackageSmall:
        case I1.SMALL_PACKAGE:
          return ug;
        default:
          return Pv;
      }
    };
    return Ue(
      () => e.packageTypeId,
      () => {
        a.value = o();
      },
      {
        immediate: !0
      }
    ), (n, r) => (m(), he(j(za), {
      size: j(ka).Medium
    }, {
      default: ue(() => [
        (m(), he(S1(a.value)))
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), S_ = ["aria-label"], A_ = ["tabindex", "aria-label", "disabled"], E_ = ["tabindex", "aria-hidden", "aria-current", "aria-label", "onClick", "onKeyup"], D_ = ["aria-label", "tabindex", "disabled"], b$ = /* @__PURE__ */ J({
  __name: "Pagination",
  props: {
    page: {},
    size: {},
    results: {},
    pageText: {},
    previousText: {},
    nextText: {},
    title: {}
  },
  emits: ["page"],
  setup(t, { emit: e }) {
    const a = t, o = me(), n = me(), r = e, s = Q(() => a.page > 1), i = Q(() => a.page < o.value), l = (u) => u === "-", f = (u) => {
      u !== "-" && r("page", u);
    };
    return Nl(() => {
      o.value = Math.ceil(a.results / a.size), o.value < 9 ? n.value = Array.from({ length: o.value }, (u, d) => d + 1) : a.page < 5 ? n.value = [1, 2, 3, 4, 5, 6, "-", o.value] : a.page > o.value - 4 ? n.value = [
        1,
        "-",
        o.value - 5,
        o.value - 4,
        o.value - 3,
        o.value - 2,
        o.value - 1,
        o.value
      ] : n.value = [1, "-", a.page - 1, a.page, a.page + 1, "-", o.value];
    }), (u, d) => o.value ? (m(), C("nav", {
      key: 0,
      "aria-label": u.title,
      class: "flex font-body"
    }, [
      g("div", {
        role: "button",
        class: le(["bg-white border px-3 py-1.5 rounded-l-lg", {
          "text-secondary cursor-pointer hover:bg-gray-200": s.value,
          "text-gray-800 cursor-not-allowed": u.page <= 1
        }]),
        tabindex: s.value ? 0 : -1,
        "aria-label": u.previousText,
        disabled: s.value ? void 0 : !0,
        onClick: d[0] || (d[0] = (k) => s.value ? f(u.page - 1) : void 0),
        onKeyup: d[1] || (d[1] = Ae($e((k) => f(u.page - 1), ["exact"]), ["enter"]))
      }, [
        ye(Oe, { class: "-scale-x-100" }, {
          default: ue(() => [
            g("title", null, _e(u.previousText), 1),
            ye(_0)
          ]),
          _: 1
        })
      ], 42, A_),
      (m(!0), C(ge, null, De(n.value, (k) => (m(), C("div", {
        key: k,
        tabindex: l(k) ? -1 : 0,
        "aria-hidden": l(k) ? !0 : void 0,
        "aria-current": k === u.page ? "page" : void 0,
        role: "button",
        "aria-label": `${u.pageText} ${k}`,
        class: le(["border-r border-y min-w-[30px] px-1 py-1.5 text-center", {
          "bg-primary-200 text-white active": k === u.page,
          "text-secondary": k !== u.page,
          "cursor-text": l(k),
          "cursor-pointer hover:bg-gray-200": !l(k) && k !== u.page
        }]),
        onClick: (y) => f(k),
        onKeyup: Ae($e((y) => f(k), ["exact"]), ["enter"])
      }, _e(k), 43, E_))), 128)),
      g("div", {
        class: le(["bg-white border-r border-y px-3 py-1.5 rounded-r-lg", {
          "text-secondary cursor-pointer hover:bg-gray-200": i.value,
          "text-gray-800 cursor-not-allowed": u.page >= o.value
        }]),
        role: "button",
        "aria-label": u.nextText,
        tabindex: i.value ? 0 : -1,
        disabled: i.value ? void 0 : !0,
        onClick: d[2] || (d[2] = (k) => i.value ? f(u.page + 1) : void 0),
        onKeyup: d[3] || (d[3] = Ae($e((k) => f(u.page + 1), ["exact"]), ["enter"]))
      }, [
        ye(Oe, null, {
          default: ue(() => [
            g("title", null, _e(u.nextText), 1),
            ye(_0)
          ]),
          _: 1
        })
      ], 42, D_)
    ], 8, S_)) : ae("", !0);
  }
}), k$ = /* @__PURE__ */ J({
  __name: "LoadMore",
  props: {
    label: {}
  },
  emits: ["loadMore"],
  setup(t) {
    const { t: e } = Sa({
      messages: {
        en: {
          loadMore: "Load more",
          loadMoreWithLabel: "Load more {label}"
        },
        fr: {
          loadMore: "Charger plus",
          loadMoreWithLabel: "Charger plus {label}"
        },
        nl: {
          loadMore: "Laad meer",
          loadMoreWithLabel: "Laad meer {label}"
        }
      }
    });
    return (a, o) => (m(), he(j(b1), {
      variant: "secondary-outline",
      size: "medium",
      class: "block mx-auto mt-2",
      onClick: o[0] || (o[0] = (n) => a.$emit("loadMore", n))
    }, {
      default: ue(() => [
        qe(_e(a.label ? j(e)("loadMoreWithLabel", { label: a.label }) : j(e)("loadMore")), 1)
      ]),
      _: 1
    }));
  }
}), P_ = {
  class: "relative",
  role: "tooltip"
}, z_ = 16, Di = 352, C$ = /* @__PURE__ */ J({
  __name: "PopOver",
  props: {
    alignment: { default: "right" }
  },
  setup(t) {
    const e = t, a = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), [o, n] = ht(), r = me(null), s = me(null);
    let i = null;
    const l = () => {
      a || (i && clearTimeout(i), n(!0));
    }, f = () => {
      a || (i = setTimeout(() => {
        o.value && n(!1);
      }, 200));
    };
    h1(() => {
      document.body.addEventListener("click", u);
    }), ql(() => {
      document.body.removeEventListener("click", u);
    });
    const u = (y) => {
      a && (y.target === r.value || y.target === s.value || r.value?.contains(y.target) || s.value?.contains(y.target) || n(!1));
    }, d = () => {
      if (a)
        return o.value ? n(!1) : n(!0);
    }, { floatingStyles: k } = Aa(r, s, {
      placement: e.alignment,
      whileElementsMounted: Da,
      middleware: [
        Br(8),
        Ea(),
        Cn(),
        wn({
          padding: z_,
          /*
           * availableWidth and availableHeight can be negative when the popover is at the edge of the screen.
           * Make sure the popover is kept within the screen bounds.
           */
          apply({ availableWidth: y, availableHeight: b, elements: M }) {
            if (Number.isNaN(y) || Number.isNaN(b) || y < 0 || b < 0)
              return;
            const c = y > Di ? Di : y;
            Object.assign(M.floating.style, {
              maxWidth: `${c}px`,
              maxHeight: `${b}px`
            });
          }
        })
      ]
    });
    return (y, b) => (m(), C("div", P_, [
      g("div", {
        ref_key: "reference",
        ref: r,
        class: "flex items-center w-max",
        "data-test": "popover-reference",
        onMouseenter: l,
        onMouseleave: f,
        onClick: d
      }, [
        oe(y.$slots, "icon", {}, () => [
          ye(j(za), { class: "text-secondary" }, {
            default: ue(() => [
              ye(j(jv))
            ]),
            _: 1
          })
        ])
      ], 544),
      g("div", {
        ref_key: "floating",
        ref: s,
        style: w1([j(k)]),
        class: le([{ "invisible pointer-events-none": !j(o) }, "absolute bg-white border border-secondary p-6 rounded-regular shadow-md w-max z-10"]),
        onMouseenter: l,
        onMouseleave: f
      }, [
        oe(y.$slots, "default")
      ], 38)
    ]));
  }
}), Al = /* @__PURE__ */ J({
  __name: "Skeleton",
  setup(t) {
    const e = F1();
    return (a, o) => (m(), C("div", {
      role: "status",
      "aria-live": "off",
      "aria-busy": "true",
      class: le(j(g1)("animate-pulse transform-gpu rounded-full bg-gray-200", j(e).class))
    }, null, 2));
  }
}), T_ = { class: "text-gray-900" }, w$ = /* @__PURE__ */ J({
  __name: "SkeletonField",
  props: {
    type: {},
    name: {},
    label: {},
    hideLabel: { type: Boolean },
    sublabel: {},
    note: {},
    skeletonStyle: {},
    preserveLabelGap: { type: Boolean }
  },
  setup(t) {
    const e = t, a = Q(() => {
      switch (e.type) {
        case "text":
        case "checkbox":
        case "radio":
          return "h-6";
        case "input":
          return "h-[42px]";
        default:
          return "h-6";
      }
    });
    return (o, n) => (m(), he(iv, {
      class: "w-full",
      "hide-label": o.hideLabel,
      "preserve-label-gap": o.preserveLabelGap
    }, f1({
      default: ue(() => [
        ye(Al, {
          class: le([a.value, o.skeletonStyle, "w-full"])
        }, null, 8, ["class"])
      ]),
      _: 2
    }, [
      o.hideLabel ? void 0 : {
        name: "label",
        fn: ue(() => [
          ye(fv, { id: o.name }, f1({
            default: ue(() => [
              qe(_e(o.label) + " ", 1)
            ]),
            _: 2
          }, [
            o.sublabel ? {
              name: "sublabel",
              fn: ue(() => [
                g("span", T_, _e(o.sublabel), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["id"])
        ]),
        key: "0"
      }
    ]), 1032, ["hide-label", "preserve-label-gap"]));
  }
}), _$ = /* @__PURE__ */ J({
  __name: "SkeletonRectangle",
  props: {
    height: { default: void 0 },
    width: { default: "w-full" }
  },
  setup(t) {
    const e = F1();
    return (a, o) => (m(), he(Al, {
      class: le([j(g1)(a.width, a.height, j(e).class)])
    }, null, 8, ["class"]));
  }
}), H$ = /* @__PURE__ */ J({
  __name: "Body",
  props: {
    borderless: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("div", {
      role: "rowgroup",
      class: le(["col-span-full grid grid-cols-subgrid", {
        "divide-solid divide-y": !e.borderless
      }])
    }, [
      oe(e.$slots, "default")
    ], 2));
  }
}), El = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Cell",
  setup(t) {
    return (e, a) => (m(), C("div", {
      class: le(["break-words", j(g1)("p-2.5 w-full rounded-b", e.$attrs.class)]),
      role: "cell"
    }, [
      oe(e.$slots, "default")
    ], 2));
  }
}), O_ = /* @__PURE__ */ J({
  __name: "Sort",
  props: {
    order: {}
  },
  setup(t) {
    return (e, a) => (m(), he(Oe, {
      class: "align-middle inline-block overflow-visible",
      viewbox: "0 0 8 12",
      width: "8",
      height: "12"
    }, {
      default: ue(() => [
        ye(j(r4), {
          class: le({ "text-icon-sort": e.order === j(Kt).Asc })
        }, null, 8, ["class"]),
        ye(j(t4), {
          class: le({ "text-icon-sort": e.order === j(Kt).Desc })
        }, null, 8, ["class"])
      ]),
      _: 1
    }));
  }
}), F_ = ["aria-sort"], B_ = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "ColumnHeader",
  props: {
    withSorting: { type: Boolean },
    sort: {},
    sortOrder: {}
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const a = t, o = e, n = {
      [Kt.Asc]: "ascending",
      [Kt.Desc]: "descending"
    }, r = (i) => i ? n[i] : "none", s = Q(() => a.sort ? a.sort === "ascending" ? Kt.Asc : a.sort === "descending" ? Kt.Desc : void 0 : a.sortOrder === null ? void 0 : a.sortOrder);
    return (i, l) => (m(), C("div", {
      class: le(
        j(g1)("lg:text-base p-2.5 text-black text-sm w-full whitespace-nowrap", i.$attrs.class, {
          "cursor-pointer": i.withSorting
        })
      ),
      role: "columnheader",
      "aria-sort": i.sort ? i.sort : r(i.sortOrder),
      onClick: l[0] || (l[0] = (f) => o("click", f))
    }, [
      oe(i.$slots, "default"),
      i.withSorting ? (m(), he(O_, {
        key: 0,
        class: "ml-1.5",
        order: s.value
      }, null, 8, ["order"])) : ae("", !0)
    ], 10, F_));
  }
}), I_ = {
  key: 0,
  class: "font-normal text-black"
}, Z_ = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Header",
  props: {
    hasTabs: { type: Boolean },
    useTableSorting: {},
    columns: {}
  },
  setup(t) {
    const e = t, a = F1(), { t: o } = Sa(), n = (l) => l.sortable ? l.sortKey : l.name, r = (l) => l.reduce((f, u) => (u.sortable && (f[u.sortKey] = u.defaultSortOrder ?? null), f), {}), { sortByColumn: s, sorters: i } = e.useTableSorting && e.columns ? Jl(
      e.useTableSorting.name,
      r(e.columns),
      e.useTableSorting.sortOptions
    ) : {
      sortByColumn: void 0,
      sorters: me({})
    };
    return (l, f) => (m(), C("div", {
      class: le(
        j(g1)(
          "col-span-full grid grid-cols-subgrid bg-gray-100 border-b grid-flow-col h-11 rounded-tr-lg w-full rounded-tl-lg",
          {
            "rounded-tl-none": l.hasTabs
          },
          j(a).class
        )
      ),
      role: "rowgroup"
    }, [
      l.columns ? (m(!0), C(ge, { key: 0 }, De(l.columns, (u) => (m(), he(B_, {
        key: n(u),
        class: le(u.colSpan ? `col-span-${u.colSpan}` : ""),
        "sort-order": u.sortable ? j(i)[u.sortKey] : null,
        onClick: (d) => u.sortable && j(s) ? j(s)(u.sortKey) : () => {
        },
        "with-sorting": u.sortable && !!l.useTableSorting
      }, {
        default: ue(() => [
          oe(l.$slots, `header:${n(u)}`, Re({ ref_for: !0 }, u), () => [
            u.header ? (m(), C("span", I_, _e(j(o)(u.header.translationKey)), 1)) : ae("", !0)
          ])
        ]),
        _: 2
      }, 1032, ["class", "sort-order", "onClick", "with-sorting"]))), 128)) : ae("", !0),
      oe(l.$slots, "default")
    ], 2));
  }
}), R_ = ["aria-rowindex"], bn = /* @__PURE__ */ J({
  __name: "Row",
  props: {
    index: {},
    border: { type: Boolean },
    highlight: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("div", {
      class: le(["col-span-full grid grid-cols-subgrid", {
        "border-b border-gray-400 last:border-b-0": e.border,
        "animate-blink": e.highlight
      }]),
      role: "row",
      "aria-rowindex": e.index
    }, [
      oe(e.$slots, "default")
    ], 10, R_));
  }
}), j$ = /* @__PURE__ */ J({
  __name: "ColoredRow",
  props: {
    color: {},
    index: {},
    highlight: { type: Boolean }
  },
  setup(t) {
    const e = {
      Yellow: "yellow",
      Red: "red",
      Gray: "gray",
      Green: "green"
    }, a = t, o = Q(() => a.color === e.Gray), n = Q(() => a.color === e.Green), r = Q(() => a.color === e.Red), s = Q(() => a.color === e.Yellow);
    return (i, l) => (m(), he(bn, {
      index: i.index,
      class: le({
        "border-l-[5px] border-x-transparent ": i.highlight,
        "bg-green-100! border-x-green!": n.value,
        "bg-gray-100! border-x-gray!": o.value,
        "bg-red-100! border-x-red!": r.value,
        "bg-yellow-100! border-x-yellow!": s.value
      })
    }, {
      default: ue(() => [
        oe(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["index", "class"]));
  }
}), N_ = ["name", "aria-expanded", "aria-controls"], q_ = /* @__PURE__ */ J({
  __name: "RowToggle",
  props: {
    name: {},
    expanded: { type: Boolean },
    openLabel: {},
    closeLabel: {}
  },
  emits: ["click"],
  setup(t) {
    return (e, a) => (m(), C("button", {
      name: `row-toggle-${e.name}`,
      type: "button",
      class: "cursor-pointer flex items-center text-left w-min",
      "aria-expanded": e.expanded ? "true" : "false",
      "aria-controls": `row-toggle-control-${e.name}`,
      onClick: a[0] || (a[0] = (o) => e.$emit("click"))
    }, [
      ye(ra, {
        "is-open": e.expanded,
        "aria-label": e.expanded ? e.closeLabel : e.openLabel
      }, null, 8, ["is-open", "aria-label"])
    ], 8, N_));
  }
}), U_ = /* @__PURE__ */ J({
  __name: "TabCount",
  props: {
    isActive: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("span", {
      class: le([
        "bg-gray-200 rounded-full w-6 h-6 flex items-center justify-center text-sm ml-2 border border-gray-300",
        { "text-primary opacity-100": e.isActive }
      ])
    }, [
      oe(e.$slots, "default")
    ], 2));
  }
}), Y_ = ["aria-selected"], L$ = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Tab",
  props: {
    isActive: { type: Boolean },
    withCount: { type: Boolean },
    amount: {}
  },
  setup(t) {
    const e = F1(), a = Q(() => {
      const { class: o, ...n } = e;
      return n;
    });
    return (o, n) => (m(), C("button", Re({
      type: "button",
      role: "tab"
    }, a.value, {
      "aria-selected": o.isActive,
      class: j(g1)(
        {
          "bg-white border-x text-primary font-semibold": o.isActive,
          "bg-gray-100 text-black-light": !o.isActive
        },
        "flex items-center border-y first:border-l first:rounded-l-md last:border-r last:rounded-r-md lg:border-b-0 lg:first:rounded-bl-none lg:last:rounded-br-none px-4 h-10 text-sm",
        j(e).class
      )
    }), [
      oe(o.$slots, "default"),
      o.withCount && o.isActive ? (m(), he(U_, {
        key: 0,
        "is-active": o.isActive
      }, {
        default: ue(() => [
          qe(_e(o.amount), 1)
        ]),
        _: 1
      }, 8, ["is-active"])) : ae("", !0)
    ], 16, Y_));
  }
}), W_ = ["aria-rowcount"], x$ = /* @__PURE__ */ J({
  inheritAttrs: !1,
  __name: "Table",
  props: {
    hasTabs: { type: Boolean },
    useTableSorting: {},
    columns: {},
    rowCount: {}
  },
  setup(t) {
    const e = (n) => n.sortable ? n.sortKey : n.name, a = F1(), o = Q(() => {
      const { class: n, ...r } = a;
      return r;
    });
    return (n, r) => (m(), C("div", Re(o.value, {
      class: j(g1)(
        "border rounded-lg w-full grid",
        {
          "rounded-tl-none!": n.hasTabs
        },
        n.$attrs.class
      ),
      "aria-rowcount": n.rowCount,
      role: "table"
    }), [
      n.columns?.length ? (m(), he(Z_, {
        key: 0,
        "has-tabs": n.hasTabs,
        "use-table-sorting": n.useTableSorting,
        columns: n.columns
      }, f1({ _: 2 }, [
        De(n.columns, (s) => ({
          name: `header:${e(s)}`,
          fn: ue((i) => [
            oe(n.$slots, `header:${e(s)}`, v1(V1(i)))
          ])
        }))
      ]), 1032, ["has-tabs", "use-table-sorting", "columns"])) : ae("", !0),
      oe(n.$slots, "default"),
      oe(n.$slots, "empty")
    ], 16, W_));
  }
}), K_ = {}, G_ = { class: "flex" };
function X_(t, e) {
  return m(), C("div", G_, [
    oe(t.$slots, "default")
  ]);
}
const $$ = /* @__PURE__ */ se(K_, [["render", X_]]), M$ = /* @__PURE__ */ J({
  __name: "RowExpandable",
  props: {
    openLabel: {},
    closeLabel: {}
  },
  setup(t) {
    const [e, a] = ht(), o = ro();
    return (n, r) => (m(), C(ge, null, [
      ye(bn, {
        class: le(n.$attrs.class)
      }, {
        default: ue(() => [
          oe(n.$slots, "default"),
          ye(El, null, {
            default: ue(() => [
              ye(q_, {
                name: j(o),
                "open-label": n.openLabel,
                "close-label": n.closeLabel,
                expanded: j(e),
                onClick: j(a)
              }, null, 8, ["name", "open-label", "close-label", "expanded", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 3
      }, 8, ["class"]),
      Ne(ye(bn, {
        class: le(n.$attrs.class),
        id: `row-toggle-control-${j(o)}`
      }, {
        default: ue(() => [
          oe(n.$slots, "expandable-content")
        ]),
        _: 3
      }, 8, ["class", "id"]), [
        [L1, j(e)]
      ])
    ], 64));
  }
}), Q_ = { key: 0 }, V$ = /* @__PURE__ */ J({
  __name: "EmptyBody",
  props: {
    message: { default: void 0 },
    button: { default: void 0 },
    columnCount: {}
  },
  setup(t) {
    return (e, a) => (m(), he(j(bn), null, {
      default: ue(() => [
        ye(j(El), {
          "aria-colspan": e.columnCount,
          class: "col-span-full my-2 text-center text-gray-900 flex align-center justify-center flex-col gap-2"
        }, {
          default: ue(() => [
            e.message ? (m(), C("span", Q_, _e(e.message), 1)) : ae("", !0),
            e.button ? (m(), he(j(b1), {
              key: 1,
              class: "mx-auto flex gap-2 items-center text-black text-sm",
              variant: "gray",
              onClick: e.button.click
            }, {
              default: ue(() => [
                e.button.icon ? (m(), he(j(za), { key: 0 }, {
                  default: ue(() => [
                    (m(), he(S1(e.button.icon)))
                  ]),
                  _: 1
                })) : ae("", !0),
                qe(" " + _e(e.button.label), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : ae("", !0)
          ]),
          _: 1
        }, 8, ["aria-colspan"])
      ]),
      _: 1
    }));
  }
}), J_ = {}, eH = { class: "overflow-x-auto px-4" }, tH = { class: "flex gap-4" };
function aH(t, e) {
  return m(), C("nav", eH, [
    g("ul", tH, [
      oe(t.$slots, "default")
    ])
  ]);
}
const S$ = /* @__PURE__ */ se(J_, [["render", aH]]), A$ = /* @__PURE__ */ J({
  __name: "TabLink",
  props: {
    active: { type: Boolean }
  },
  setup(t) {
    return (e, a) => (m(), C("li", {
      class: le(["border-b-2 cursor-pointer min-w-max", {
        "border-secondary": e.active,
        "border-white hover:border-gray": !e.active
      }])
    }, [
      g("div", {
        class: le(["block pb-[10px]", { "text-secondary": e.active }])
      }, [
        oe(e.$slots, "default")
      ], 2)
    ], 2));
  }
}), oH = /* @__PURE__ */ J({
  __name: "StatusIcon",
  props: {
    status: {}
  },
  setup(t) {
    const e = t, a = kn();
    function o(n) {
      switch (n) {
        case Ba.Registered:
          return Oa(Lu);
        case Ba.HandedToCarrier:
          return Oa(fu);
        case Ba.Sorting:
          return Oa(Vu);
        case Ba.Distribution:
          return Oa(_u);
        case Ba.Delivered:
          return Oa(Z7);
      }
    }
    return Ue(
      () => e.status,
      (n) => {
        a.value = o(n);
      },
      { immediate: !0 }
    ), (n, r) => (m(), he(j(Oe), {
      size: j(et).Medium
    }, {
      default: ue(() => [
        (m(), he(S1(a.value)))
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), nH = { class: "flex gap-4" }, rH = { class: "flex items-center justify-center" }, sH = /* @__PURE__ */ J({
  __name: "Header",
  props: {
    item: {}
  },
  setup(t) {
    return (e, a) => (m(), C("div", nH, [
      g("div", rH, [
        ye(oH, {
          status: e.item.status,
          class: le({ "text-primary": !e.item.disabled, "text-gray-400": e.item.disabled })
        }, null, 8, ["status", "class"])
      ]),
      g("div", {
        class: le(["font-bold py-2", { "text-primary": !e.item.disabled, "text-gray-800": e.item.disabled }])
      }, _e(e.item.description), 3)
    ]));
  }
}), iH = { class: "flex gap-4" }, lH = { class: "flex w-6" }, uH = { class: "flex flex-1 items-center justify-center relative" }, cH = { class: "flex flex-1 flex-col py-2" }, dH = {
  "data-test": "tnt-time",
  class: "text-slate-500 text-sm"
}, mH = /* @__PURE__ */ J({
  __name: "InBetweenStatus",
  props: {
    item: {},
    nextIsDisabled: { type: Boolean }
  },
  setup(t) {
    const e = t, a = Q(() => J1(e.item.date).format("D MMMM HH:mm"));
    return (o, n) => (m(), C("div", iH, [
      g("div", lH, [
        g("div", uH, [
          g("div", {
            "data-test": "tnt-top-line",
            class: le(["absolute border-l h-1/2 top-0 w-0", o.nextIsDisabled ? "border-gray-300" : "border-primary"])
          }, null, 2),
          n[0] || (n[0] = g("div", {
            "data-test": "tnt-bottom-line",
            class: "absolute border-l h-1/2 top-1/2 w-0 border-primary"
          }, null, -1)),
          n[1] || (n[1] = g("div", {
            "data-test": "tnt-middle-circle",
            class: "h-2 relative rounded-full w-2 z-10 bg-primary"
          }, null, -1))
        ])
      ]),
      g("div", cH, [
        g("p", dH, _e(a.value), 1),
        g("p", null, _e(o.item.description), 1)
      ])
    ]));
  }
}), pH = { class: "flex flex-col pl-1" }, E$ = /* @__PURE__ */ J({
  __name: "TrackAndTraceTimeline",
  props: {
    items: {}
  },
  setup(t) {
    const e = t, a = Q(() => [...e.items].reverse());
    return (o, n) => (m(), C("div", pH, [
      (m(!0), C(ge, null, De(a.value, (r, s) => (m(), C(ge, null, [
        r.type === "header" ? (m(), he(sH, {
          key: `${r.type}-${r.status}`,
          item: r
        }, null, 8, ["item"])) : ae("", !0),
        r.type === "item" ? (m(), he(mH, {
          key: `${r.type}-${r.status}-${s}`,
          item: r,
          "next-is-disabled": a.value[s - 1]?.disabled
        }, null, 8, ["item", "next-is-disabled"])) : ae("", !0)
      ], 64))), 256))
    ]));
  }
}), fH = { class: "flex gap-4" }, hH = { class: "flex w-6" }, vH = { class: "flex flex-1 items-center justify-center relative" }, gH = {
  key: 0,
  "data-test": "tnt-top-line",
  class: "absolute border-l h-1/2 top-0 w-0 border-primary"
}, yH = {
  key: 1,
  "data-test": "tnt-bottom-line",
  class: "absolute border-l h-1/2 top-1/2 w-0 border-primary"
}, bH = { class: "flex flex-1 flex-col py-2" }, kH = {
  "data-test": "tnt-time",
  class: "text-slate-500 text-sm"
}, CH = /* @__PURE__ */ J({
  __name: "TrackAndTraceListItem",
  props: {
    item: {},
    hasNext: { type: Boolean },
    hasPrevious: { type: Boolean }
  },
  setup(t) {
    const e = t, a = Q(() => J1(e.item.date).format("D MMMM HH:mm"));
    return (o, n) => (m(), C("div", fH, [
      g("div", hH, [
        g("div", vH, [
          o.hasPrevious ? (m(), C("div", gH)) : ae("", !0),
          o.hasNext ? (m(), C("div", yH)) : ae("", !0),
          n[0] || (n[0] = g("div", {
            "data-test": "tnt-middle-circle",
            class: "h-2 relative rounded-full w-2 z-10 bg-primary"
          }, null, -1))
        ])
      ]),
      g("div", bH, [
        g("p", kH, _e(a.value), 1),
        g("p", null, _e(o.item.description), 1)
      ])
    ]));
  }
}), wH = { class: "flex flex-col pl-1" }, D$ = /* @__PURE__ */ J({
  __name: "TrackAndTraceList",
  props: {
    items: {}
  },
  setup(t) {
    const e = t, a = Q(() => Ul.date.sortByDate(e.items, "date", { order: Kt.Desc }));
    return (o, n) => (m(), C("div", wH, [
      (m(!0), C(ge, null, De(a.value, (r, s) => (m(), he(CH, {
        key: `${r.type}-${r.status}-${s}`,
        item: r,
        "has-previous": s !== 0,
        "has-next": s !== a.value.length - 1
      }, null, 8, ["item", "has-previous", "has-next"]))), 128))
    ]));
  }
});
export {
  VH as AccordionGroup,
  Mx as AccordionItem,
  Hr as ActionButton,
  Ri as ActionButtonWrapper,
  gL as AdminUser24,
  ZL as Amazon,
  pL as ArrowDown,
  mL as ArrowRight,
  fL as ArrowUp,
  GH as AssignToPerson,
  ej as Attachment24,
  r$ as Backdrop,
  Vx as Badge,
  D1 as BadgeVariant,
  jj as Barcode,
  Lu as Barcode24,
  yj as Bars,
  Sx as BaseImage,
  fj as Basket,
  tx as Bell,
  ax as Bell24,
  vo as Bol,
  qj as Box,
  Uj as Box24,
  Nj as BoxOpen,
  Gn as Bpost,
  Xn as Brt,
  b1 as Button,
  Ka as ButtonSizes,
  O9 as ButtonType,
  k1 as ButtonVariant,
  Ax as ButtonWithSpinner,
  uj as Cancel,
  Ni as Card,
  Ex as CardBody,
  Dx as CardRow,
  Px as CarrierLogo,
  _u as CarrierTruck,
  Vj as CarrierTruck48,
  EH as Chat24,
  Qn as Cheapcargo,
  Ir as Check,
  fx as Check24,
  mx as Check48,
  z6 as CheckRounded,
  px as CheckRounded24,
  Pd as Checkbox,
  Eu as CheckboxCheck,
  Fd as CheckboxGroup,
  Lt as CheckboxGroupAlignment,
  L5 as ChevronDown,
  V5 as ChevronDown24,
  ra as ChevronIcon,
  Bj as ChevronLeft,
  _0 as ChevronRight,
  Fj as ChevronRight24,
  w5 as ChevronUp,
  T5 as ChevronUp24,
  wj as Chrome,
  nj as Clear,
  zx as ClipboardText,
  Lj as Close,
  NH as Cog24,
  s$ as CollapseMenuButton,
  Rx as ColorInput,
  oj as Comments48,
  SH as Compress,
  Ku as Copy,
  fd as CountBadge,
  Oi as Cross,
  FH as Crosshairs24,
  Nx as CurrencyInput,
  UH as Dashboard,
  qx as DatePicker,
  sv as DatePickerRange,
  zH as Desktop,
  Y1 as Dhl,
  oL as DhlActive,
  eL as DhlRounded,
  rx as DigitalStamp,
  hj as Directdebitauthorization,
  gj as Distributed88,
  i$ as DividerMenuItem,
  kj as Doublechatbubble,
  Yn as Dpd,
  Gj as DpdActive,
  Kj as DpdRounded,
  Tx as Dropdown,
  ZH as Droppedoff88,
  EL as Ecommerceplatformbol,
  PL as Ecommerceplatformbolmedium,
  VL as Ecommerceplatformdefault,
  DL as Ecommerceplatformshopify,
  AL as Ecommerceplatformshopifymedium,
  SL as Ecommerceplatformwoocommerce,
  zL as Ecommerceplatformwoocommercemedium,
  e5 as Edit,
  $j as Envelope24,
  w0 as Error,
  IL as Etsy,
  p6 as EuroSign,
  ix as EuroSign24,
  FL as Exact,
  RL as ExactDe,
  OH as Expand,
  cx as ExternalLink,
  _6 as ExternalLink24,
  Ox as ExternalLinkAnchor,
  Rt as ExternalLinkVariant,
  l$ as ExternalMenuItem,
  Zj as EyeHide,
  Rj as EyeShow,
  Ij as EyeShow24,
  KL as Facebook,
  WL as FacebookSocial,
  YL as FacebookSolid,
  Hj as Feedback,
  rL as File,
  uL as FileAlt,
  Fx as FileBar,
  iL as FileCsv,
  dL as FileDownload,
  nL as FileDownload24,
  z4 as FileDownload48,
  cL as FileMov,
  sL as FilePackingSlip,
  lL as FilePdf,
  vj as FileSheet,
  Bx as FileUpload,
  L4 as FileUpload48,
  lt as FileUploadVariant,
  Ix as FilledFileCard,
  cj as Filter,
  jy as FilterBar,
  Fa as FlagBe,
  Un as FlagDe,
  Nn as FlagEs,
  PH as FlagFinish24,
  Zn as FlagFr,
  ho as FlagGb,
  Zx as FlagIcon,
  qn as FlagIt,
  Rn as FlagNl,
  iv as FormRow,
  Dj as Fulfilment24,
  JH as Fulfilment48,
  Z7 as Gift,
  Wn as Gls,
  lx as Hamburger,
  ux as Hamburger24,
  fu as HandGivingPackage,
  kd as Heading,
  Nt as HeadingLevel,
  XH as Home,
  Oe as IconBase,
  et as IconSize,
  $x as IconType,
  D9 as IconViewBox,
  rj as ImageEmpty,
  Ux as ImageUpload,
  pu as Info,
  n$ as InfoCard,
  H0 as Instabox,
  hx as Instagram,
  vx as InstagramSocial,
  gx as InstagramSolid,
  pj as Insurance,
  u$ as InternalMenuItem,
  fv as Label,
  mr as LabelPosition,
  aj as Laptop48,
  jx as Linkedin,
  Hx as LinkedinSocial,
  Lx as LinkedinSolid,
  k$ as LoadMore,
  lj as LocationPin,
  sx as MailboxParcel,
  RH as MapMarkerAlt,
  wL as Megaphone,
  _L as MegaphoneLoud,
  g$ as MenuButton,
  c$ as MenuItemType,
  w3 as Minus,
  Yj as Minus24,
  mj as MobilePhone,
  P7 as More16,
  HL as More24,
  P2 as MultiSelect,
  Xx as MultiSelectWithBadges,
  Qx as MultiSelectWithBadgesOutside,
  XL as MyParcel,
  QL as MyParcelBe,
  GL as MyParcelPrimary,
  Tu as Myparcel24,
  TH as Note,
  T2 as Notification,
  vv as NumberInput,
  Yx as NumberInputStepper,
  nx as PackageSmall,
  y$ as PackageTypeIcon,
  Sj as Packaging,
  IH as Packaging24,
  bj as PackingSlip,
  b$ as Pagination,
  ox as Pallet,
  _j as PaperPlane,
  d$ as ParentMenuItemCollapsed,
  p$ as ParentMenuItemExpanded,
  Wx as PasswordInput,
  JL as Phone24,
  ex as Phone48,
  Pj as Picklist,
  Ii as Plus,
  xx as Plus24,
  C$ as PopOver,
  Zi as Popup,
  Jn as Postnl,
  tL as PostnlActive,
  aL as PostnlBusinessActive,
  Xj as PostnlBusinessRounded,
  Qj as PostnlRounded,
  xL as Question,
  jL as Question24,
  LL as QuestionCircle,
  $L as QuestionCircle24,
  ML as QuestionCircle48,
  Hg as RadioGroup,
  vL as Redo,
  hL as Redo24,
  Mj as Refresh,
  Aj as RefreshPlus,
  AH as Reminder,
  KH as Reply,
  ku as Search24,
  Kx as SearchInput,
  Gx as SearchSuggestTextInput,
  Vg as Select,
  Jx as SelectAutocomplete,
  DH as Settings,
  dj as Settings24,
  qH as Shipment,
  Vu as ShipmentSorting,
  ij as ShipmentUnknown,
  WH as Shirt24,
  Cj as ShoppingCart,
  m$ as SideMenuCollapsed,
  f$ as SideMenuExpanded,
  v8 as SideMenuHide,
  k8 as SideMenuShow,
  h$ as SidePanel,
  v$ as SidePanelContainer,
  Ej as Signin,
  Al as Skeleton,
  w$ as SkeletonField,
  _$ as SkeletonRectangle,
  r4 as SortAsc,
  t4 as SortDesc,
  tj as Sorted,
  X9 as Spinner,
  UL as Star,
  NL as Star24,
  qL as StarSolid,
  TL as Subscription,
  OL as Subscription48,
  YH as Support,
  xj as Support24,
  e$ as Switch,
  S$ as TabGroup,
  A$ as TabLink,
  x$ as Table,
  H$ as TableBody,
  El as TableCell,
  j$ as TableColoredRow,
  B_ as TableColumnHeader,
  O_ as TableColumnHeaderSort,
  V$ as TableEmptyBody,
  Z_ as TableHeader,
  bn as TableRow,
  M$ as TableRowExpandable,
  q_ as TableRowToggle,
  L$ as TableTab,
  $$ as TableTabs,
  L0 as Target,
  t$ as TextArea,
  mo as TextInput,
  Cg as TextInputWithButton,
  a$ as TextInputWithInfo,
  BH as ThSolid,
  dx as TiktokSocial,
  o$ as TimeInput,
  n7 as Times,
  Fi as Times24,
  s0 as Toast,
  D$ as TrackAndTraceList,
  E$ as TrackAndTraceTimeline,
  _7 as Trash,
  kL as Trash24,
  Bi as TrashBig,
  Kn as Trunkrs,
  Tj as Twitter,
  Oj as TwitterSocial,
  zj as TwitterSolid,
  QH as UnassignFromPerson,
  sj as Unstamped,
  _x as Upload,
  wx as Upload24,
  jt as Ups,
  Wj as UpsActive,
  Jj as UpsRounded,
  yL as User,
  bL as User24,
  Cx as Whatsapp,
  yx as Whatsapp24,
  kx as Whatsapp48,
  bx as WhatsappSolid,
  BL as Wix,
  CL as YoutubeSocial,
  Jy as useSidePanel
};
